
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire233b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire233b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Ivrw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aPfka"));

});
parcelRegister("aPfka", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $7e1a8de1463f8dc5$export$ffb0004e005737fa, (v) => $7e1a8de1463f8dc5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $7e1a8de1463f8dc5$export$34b9dba7ce09269b, (v) => $7e1a8de1463f8dc5$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $7e1a8de1463f8dc5$export$25062201e9e25d76, (v) => $7e1a8de1463f8dc5$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7e1a8de1463f8dc5$export$ffb0004e005737fa;
var $7e1a8de1463f8dc5$export$34b9dba7ce09269b;
var $7e1a8de1463f8dc5$export$25062201e9e25d76;
'use strict';

var $aqdBs = parcelRequire("aqdBs");
var $7e1a8de1463f8dc5$var$k = Symbol.for("react.element"), $7e1a8de1463f8dc5$var$l = Symbol.for("react.fragment"), $7e1a8de1463f8dc5$var$m = Object.prototype.hasOwnProperty, $7e1a8de1463f8dc5$var$n = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7e1a8de1463f8dc5$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7e1a8de1463f8dc5$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7e1a8de1463f8dc5$var$m.call(a, b) && !$7e1a8de1463f8dc5$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7e1a8de1463f8dc5$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7e1a8de1463f8dc5$var$n.current
    };
}
$7e1a8de1463f8dc5$export$ffb0004e005737fa = $7e1a8de1463f8dc5$var$l;
$7e1a8de1463f8dc5$export$34b9dba7ce09269b = $7e1a8de1463f8dc5$var$q;
$7e1a8de1463f8dc5$export$25062201e9e25d76 = $7e1a8de1463f8dc5$var$q;

});
parcelRegister("aqdBs", function(module, exports) {
'use strict';

module.exports = (parcelRequire("WCsmQ"));

});
parcelRegister("WCsmQ", function(module, exports) {

$parcel$export(module.exports, "Children", () => $0b033f8fda7971e0$export$dca3b0875bd9a954, (v) => $0b033f8fda7971e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $0b033f8fda7971e0$export$16fa2f45be04daa8, (v) => $0b033f8fda7971e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $0b033f8fda7971e0$export$ffb0004e005737fa, (v) => $0b033f8fda7971e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $0b033f8fda7971e0$export$e2c29f18771995cb, (v) => $0b033f8fda7971e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $0b033f8fda7971e0$export$221d75b3f55bb0bd, (v) => $0b033f8fda7971e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $0b033f8fda7971e0$export$5f8d39834fd61797, (v) => $0b033f8fda7971e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0b033f8fda7971e0$export$74bf444e3cd11ea5, (v) => $0b033f8fda7971e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b033f8fda7971e0$export$ae55be85d98224ed, (v) => $0b033f8fda7971e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $0b033f8fda7971e0$export$3ba232387fd5d6dd, (v) => $0b033f8fda7971e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $0b033f8fda7971e0$export$e530037191fcd5d7, (v) => $0b033f8fda7971e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $0b033f8fda7971e0$export$fd42f52fd3ae1109, (v) => $0b033f8fda7971e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $0b033f8fda7971e0$export$c8a8987d4410bf2d, (v) => $0b033f8fda7971e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $0b033f8fda7971e0$export$d38cd72104c1f0e9, (v) => $0b033f8fda7971e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $0b033f8fda7971e0$export$7d1e3a5e95ceca43, (v) => $0b033f8fda7971e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $0b033f8fda7971e0$export$257a8862b851cb5b, (v) => $0b033f8fda7971e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $0b033f8fda7971e0$export$a8257692ac88316c, (v) => $0b033f8fda7971e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $0b033f8fda7971e0$export$488013bae63b21da, (v) => $0b033f8fda7971e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $0b033f8fda7971e0$export$7c73462e0d25e514, (v) => $0b033f8fda7971e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $0b033f8fda7971e0$export$7568632d0d33d16d, (v) => $0b033f8fda7971e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $0b033f8fda7971e0$export$88948ce120ea2619, (v) => $0b033f8fda7971e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $0b033f8fda7971e0$export$35808ee640e87ca7, (v) => $0b033f8fda7971e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $0b033f8fda7971e0$export$fae74005e78b1a27, (v) => $0b033f8fda7971e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e, (v) => $0b033f8fda7971e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $0b033f8fda7971e0$export$6a7bc4e911dc01cf, (v) => $0b033f8fda7971e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $0b033f8fda7971e0$export$6d9c69b0de29b591, (v) => $0b033f8fda7971e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $0b033f8fda7971e0$export$f680877a34711e37, (v) => $0b033f8fda7971e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $0b033f8fda7971e0$export$d5a552a76deda3c2, (v) => $0b033f8fda7971e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $0b033f8fda7971e0$export$aaabe4eda9ed9969, (v) => $0b033f8fda7971e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $0b033f8fda7971e0$export$e5c5a5f917a5871c, (v) => $0b033f8fda7971e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $0b033f8fda7971e0$export$1538c33de8887b59, (v) => $0b033f8fda7971e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $0b033f8fda7971e0$export$13e3392192263954, (v) => $0b033f8fda7971e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $0b033f8fda7971e0$export$b8f5890fc79d6aca, (v) => $0b033f8fda7971e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $0b033f8fda7971e0$export$60241385465d0a34, (v) => $0b033f8fda7971e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $0b033f8fda7971e0$export$306c0aa65ff9ec16, (v) => $0b033f8fda7971e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $0b033f8fda7971e0$export$7b286972b8d8ccbf, (v) => $0b033f8fda7971e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $0b033f8fda7971e0$export$83d89fbfd8236492, (v) => $0b033f8fda7971e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b033f8fda7971e0$export$dca3b0875bd9a954;
var $0b033f8fda7971e0$export$16fa2f45be04daa8;
var $0b033f8fda7971e0$export$ffb0004e005737fa;
var $0b033f8fda7971e0$export$e2c29f18771995cb;
var $0b033f8fda7971e0$export$221d75b3f55bb0bd;
var $0b033f8fda7971e0$export$5f8d39834fd61797;
var $0b033f8fda7971e0$export$74bf444e3cd11ea5;
var $0b033f8fda7971e0$export$ae55be85d98224ed;
var $0b033f8fda7971e0$export$3ba232387fd5d6dd;
var $0b033f8fda7971e0$export$e530037191fcd5d7;
var $0b033f8fda7971e0$export$fd42f52fd3ae1109;
var $0b033f8fda7971e0$export$c8a8987d4410bf2d;
var $0b033f8fda7971e0$export$d38cd72104c1f0e9;
var $0b033f8fda7971e0$export$7d1e3a5e95ceca43;
var $0b033f8fda7971e0$export$257a8862b851cb5b;
var $0b033f8fda7971e0$export$a8257692ac88316c;
var $0b033f8fda7971e0$export$488013bae63b21da;
var $0b033f8fda7971e0$export$7c73462e0d25e514;
var $0b033f8fda7971e0$export$7568632d0d33d16d;
var $0b033f8fda7971e0$export$88948ce120ea2619;
var $0b033f8fda7971e0$export$35808ee640e87ca7;
var $0b033f8fda7971e0$export$fae74005e78b1a27;
var $0b033f8fda7971e0$export$dc8fbce3eb94dc1e;
var $0b033f8fda7971e0$export$6a7bc4e911dc01cf;
var $0b033f8fda7971e0$export$6d9c69b0de29b591;
var $0b033f8fda7971e0$export$f680877a34711e37;
var $0b033f8fda7971e0$export$d5a552a76deda3c2;
var $0b033f8fda7971e0$export$aaabe4eda9ed9969;
var $0b033f8fda7971e0$export$e5c5a5f917a5871c;
var $0b033f8fda7971e0$export$1538c33de8887b59;
var $0b033f8fda7971e0$export$13e3392192263954;
var $0b033f8fda7971e0$export$b8f5890fc79d6aca;
var $0b033f8fda7971e0$export$60241385465d0a34;
var $0b033f8fda7971e0$export$306c0aa65ff9ec16;
var $0b033f8fda7971e0$export$7b286972b8d8ccbf;
var $0b033f8fda7971e0$export$83d89fbfd8236492;
'use strict';
var $0b033f8fda7971e0$var$l = Symbol.for("react.element"), $0b033f8fda7971e0$var$n = Symbol.for("react.portal"), $0b033f8fda7971e0$var$p = Symbol.for("react.fragment"), $0b033f8fda7971e0$var$q = Symbol.for("react.strict_mode"), $0b033f8fda7971e0$var$r = Symbol.for("react.profiler"), $0b033f8fda7971e0$var$t = Symbol.for("react.provider"), $0b033f8fda7971e0$var$u = Symbol.for("react.context"), $0b033f8fda7971e0$var$v = Symbol.for("react.forward_ref"), $0b033f8fda7971e0$var$w = Symbol.for("react.suspense"), $0b033f8fda7971e0$var$x = Symbol.for("react.memo"), $0b033f8fda7971e0$var$y = Symbol.for("react.lazy"), $0b033f8fda7971e0$var$z = Symbol.iterator;
function $0b033f8fda7971e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b033f8fda7971e0$var$z && a[$0b033f8fda7971e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b033f8fda7971e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b033f8fda7971e0$var$C = Object.assign, $0b033f8fda7971e0$var$D = {};
function $0b033f8fda7971e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
$0b033f8fda7971e0$var$E.prototype.isReactComponent = {};
$0b033f8fda7971e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b033f8fda7971e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b033f8fda7971e0$var$F() {}
$0b033f8fda7971e0$var$F.prototype = $0b033f8fda7971e0$var$E.prototype;
function $0b033f8fda7971e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b033f8fda7971e0$var$D;
    this.updater = e || $0b033f8fda7971e0$var$B;
}
var $0b033f8fda7971e0$var$H = $0b033f8fda7971e0$var$G.prototype = new $0b033f8fda7971e0$var$F;
$0b033f8fda7971e0$var$H.constructor = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$var$C($0b033f8fda7971e0$var$H, $0b033f8fda7971e0$var$E.prototype);
$0b033f8fda7971e0$var$H.isPureReactComponent = !0;
var $0b033f8fda7971e0$var$I = Array.isArray, $0b033f8fda7971e0$var$J = Object.prototype.hasOwnProperty, $0b033f8fda7971e0$var$K = {
    current: null
}, $0b033f8fda7971e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b033f8fda7971e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b033f8fda7971e0$var$J.call(b, d) && !$0b033f8fda7971e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b033f8fda7971e0$var$K.current
    };
}
function $0b033f8fda7971e0$var$N(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b033f8fda7971e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b033f8fda7971e0$var$l;
}
function $0b033f8fda7971e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b033f8fda7971e0$var$P = /\/+/g;
function $0b033f8fda7971e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b033f8fda7971e0$var$escape("" + a.key) : b.toString(36);
}
function $0b033f8fda7971e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b033f8fda7971e0$var$l:
                case $0b033f8fda7971e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b033f8fda7971e0$var$Q(h, 0) : d, $0b033f8fda7971e0$var$I(c) ? (e = "", null != a && (e = a.replace($0b033f8fda7971e0$var$P, "$&/") + "/"), $0b033f8fda7971e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b033f8fda7971e0$var$O(c) && (c = $0b033f8fda7971e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b033f8fda7971e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b033f8fda7971e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b033f8fda7971e0$var$Q(k, g);
        h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    }
    else if (f = $0b033f8fda7971e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b033f8fda7971e0$var$Q(k, g++), h += $0b033f8fda7971e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b033f8fda7971e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b033f8fda7971e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b033f8fda7971e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b033f8fda7971e0$var$U = {
    current: null
}, $0b033f8fda7971e0$var$V = {
    transition: null
}, $0b033f8fda7971e0$var$W = {
    ReactCurrentDispatcher: $0b033f8fda7971e0$var$U,
    ReactCurrentBatchConfig: $0b033f8fda7971e0$var$V,
    ReactCurrentOwner: $0b033f8fda7971e0$var$K
};
function $0b033f8fda7971e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b033f8fda7971e0$export$dca3b0875bd9a954 = {
    map: $0b033f8fda7971e0$var$S,
    forEach: function(a, b, e) {
        $0b033f8fda7971e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b033f8fda7971e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b033f8fda7971e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b033f8fda7971e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b033f8fda7971e0$export$16fa2f45be04daa8 = $0b033f8fda7971e0$var$E;
$0b033f8fda7971e0$export$ffb0004e005737fa = $0b033f8fda7971e0$var$p;
$0b033f8fda7971e0$export$e2c29f18771995cb = $0b033f8fda7971e0$var$r;
$0b033f8fda7971e0$export$221d75b3f55bb0bd = $0b033f8fda7971e0$var$G;
$0b033f8fda7971e0$export$5f8d39834fd61797 = $0b033f8fda7971e0$var$q;
$0b033f8fda7971e0$export$74bf444e3cd11ea5 = $0b033f8fda7971e0$var$w;
$0b033f8fda7971e0$export$ae55be85d98224ed = $0b033f8fda7971e0$var$W;
$0b033f8fda7971e0$export$3ba232387fd5d6dd = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b033f8fda7971e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b033f8fda7971e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b033f8fda7971e0$var$J.call(b, f) && !$0b033f8fda7971e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b033f8fda7971e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b033f8fda7971e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b033f8fda7971e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b033f8fda7971e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b033f8fda7971e0$export$c8a8987d4410bf2d = $0b033f8fda7971e0$var$M;
$0b033f8fda7971e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b033f8fda7971e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b033f8fda7971e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b033f8fda7971e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$v,
        render: a
    };
};
$0b033f8fda7971e0$export$a8257692ac88316c = $0b033f8fda7971e0$var$O;
$0b033f8fda7971e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b033f8fda7971e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b033f8fda7971e0$var$T
    };
};
$0b033f8fda7971e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b033f8fda7971e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b033f8fda7971e0$export$7568632d0d33d16d = function(a) {
    var b = $0b033f8fda7971e0$var$V.transition;
    $0b033f8fda7971e0$var$V.transition = {};
    try {
        a();
    } finally{
        $0b033f8fda7971e0$var$V.transition = b;
    }
};
$0b033f8fda7971e0$export$88948ce120ea2619 = $0b033f8fda7971e0$var$X;
$0b033f8fda7971e0$export$35808ee640e87ca7 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useCallback(a, b);
};
$0b033f8fda7971e0$export$fae74005e78b1a27 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useContext(a);
};
$0b033f8fda7971e0$export$dc8fbce3eb94dc1e = function() {};
$0b033f8fda7971e0$export$6a7bc4e911dc01cf = function(a) {
    return $0b033f8fda7971e0$var$U.current.useDeferredValue(a);
};
$0b033f8fda7971e0$export$6d9c69b0de29b591 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useEffect(a, b);
};
$0b033f8fda7971e0$export$f680877a34711e37 = function() {
    return $0b033f8fda7971e0$var$U.current.useId();
};
$0b033f8fda7971e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useImperativeHandle(a, b, e);
};
$0b033f8fda7971e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useInsertionEffect(a, b);
};
$0b033f8fda7971e0$export$e5c5a5f917a5871c = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useLayoutEffect(a, b);
};
$0b033f8fda7971e0$export$1538c33de8887b59 = function(a, b) {
    return $0b033f8fda7971e0$var$U.current.useMemo(a, b);
};
$0b033f8fda7971e0$export$13e3392192263954 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useReducer(a, b, e);
};
$0b033f8fda7971e0$export$b8f5890fc79d6aca = function(a) {
    return $0b033f8fda7971e0$var$U.current.useRef(a);
};
$0b033f8fda7971e0$export$60241385465d0a34 = function(a) {
    return $0b033f8fda7971e0$var$U.current.useState(a);
};
$0b033f8fda7971e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b033f8fda7971e0$var$U.current.useSyncExternalStore(a, b, e);
};
$0b033f8fda7971e0$export$7b286972b8d8ccbf = function() {
    return $0b033f8fda7971e0$var$U.current.useTransition();
};
$0b033f8fda7971e0$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("jVlfX", function(module, exports) {
'use strict';
function $e813d4480671d45c$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e813d4480671d45c$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e813d4480671d45c$var$checkDCE();

module.exports = (parcelRequire("l8cRS"));

});
parcelRegister("l8cRS", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $f62453a6e3b4559e$export$ae55be85d98224ed, (v) => $f62453a6e3b4559e$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $f62453a6e3b4559e$export$d39a5bbd09211389, (v) => $f62453a6e3b4559e$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $f62453a6e3b4559e$export$882461b6382ed46c, (v) => $f62453a6e3b4559e$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $f62453a6e3b4559e$export$466bfc07425424d5, (v) => $f62453a6e3b4559e$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $f62453a6e3b4559e$export$cd75ccfd720a3cd4, (v) => $f62453a6e3b4559e$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $f62453a6e3b4559e$export$fa8d919ba61d84db, (v) => $f62453a6e3b4559e$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $f62453a6e3b4559e$export$757ceba2d55c277e, (v) => $f62453a6e3b4559e$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $f62453a6e3b4559e$export$b3890eb0ae9dca99, (v) => $f62453a6e3b4559e$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $f62453a6e3b4559e$export$502457920280e6be, (v) => $f62453a6e3b4559e$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $f62453a6e3b4559e$export$c78a37762a8d58e1, (v) => $f62453a6e3b4559e$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $f62453a6e3b4559e$export$dc54d992c10e8a18, (v) => $f62453a6e3b4559e$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $f62453a6e3b4559e$export$83d89fbfd8236492, (v) => $f62453a6e3b4559e$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f62453a6e3b4559e$export$ae55be85d98224ed;
var $f62453a6e3b4559e$export$d39a5bbd09211389;
var $f62453a6e3b4559e$export$882461b6382ed46c;
var $f62453a6e3b4559e$export$466bfc07425424d5;
var $f62453a6e3b4559e$export$cd75ccfd720a3cd4;
var $f62453a6e3b4559e$export$fa8d919ba61d84db;
var $f62453a6e3b4559e$export$757ceba2d55c277e;
var $f62453a6e3b4559e$export$b3890eb0ae9dca99;
var $f62453a6e3b4559e$export$502457920280e6be;
var $f62453a6e3b4559e$export$c78a37762a8d58e1;
var $f62453a6e3b4559e$export$dc54d992c10e8a18;
var $f62453a6e3b4559e$export$83d89fbfd8236492;
'use strict';

var $aqdBs = parcelRequire("aqdBs");

var $7zDBh = parcelRequire("7zDBh");
function $f62453a6e3b4559e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $f62453a6e3b4559e$var$da = new Set, $f62453a6e3b4559e$var$ea = {};
function $f62453a6e3b4559e$var$fa(a, b) {
    $f62453a6e3b4559e$var$ha(a, b);
    $f62453a6e3b4559e$var$ha(a + "Capture", b);
}
function $f62453a6e3b4559e$var$ha(a, b) {
    $f62453a6e3b4559e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$da.add(b[a]);
}
var $f62453a6e3b4559e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f62453a6e3b4559e$var$ja = Object.prototype.hasOwnProperty, $f62453a6e3b4559e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $f62453a6e3b4559e$var$la = {}, $f62453a6e3b4559e$var$ma = {};
function $f62453a6e3b4559e$var$oa(a) {
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$ma, a)) return !0;
    if ($f62453a6e3b4559e$var$ja.call($f62453a6e3b4559e$var$la, a)) return !1;
    if ($f62453a6e3b4559e$var$ka.test(a)) return $f62453a6e3b4559e$var$ma[a] = !0;
    $f62453a6e3b4559e$var$la[a] = !0;
    return !1;
}
function $f62453a6e3b4559e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $f62453a6e3b4559e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $f62453a6e3b4559e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $f62453a6e3b4559e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $f62453a6e3b4559e$var$ra = /[\-:]([a-z])/g;
function $f62453a6e3b4559e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($f62453a6e3b4559e$var$ra, $f62453a6e3b4559e$var$sa);
    $f62453a6e3b4559e$var$z[b] = new $f62453a6e3b4559e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$f62453a6e3b4559e$var$z.xlinkHref = new $f62453a6e3b4559e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $f62453a6e3b4559e$var$z[a] = new $f62453a6e3b4559e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $f62453a6e3b4559e$var$ta(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$z.hasOwnProperty(b) ? $f62453a6e3b4559e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $f62453a6e3b4559e$var$qa(b, c, e, d) && (c = null), d || null === e ? $f62453a6e3b4559e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $f62453a6e3b4559e$var$ua = $aqdBs.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $f62453a6e3b4559e$var$va = Symbol.for("react.element"), $f62453a6e3b4559e$var$wa = Symbol.for("react.portal"), $f62453a6e3b4559e$var$ya = Symbol.for("react.fragment"), $f62453a6e3b4559e$var$za = Symbol.for("react.strict_mode"), $f62453a6e3b4559e$var$Aa = Symbol.for("react.profiler"), $f62453a6e3b4559e$var$Ba = Symbol.for("react.provider"), $f62453a6e3b4559e$var$Ca = Symbol.for("react.context"), $f62453a6e3b4559e$var$Da = Symbol.for("react.forward_ref"), $f62453a6e3b4559e$var$Ea = Symbol.for("react.suspense"), $f62453a6e3b4559e$var$Fa = Symbol.for("react.suspense_list"), $f62453a6e3b4559e$var$Ga = Symbol.for("react.memo"), $f62453a6e3b4559e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $f62453a6e3b4559e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $f62453a6e3b4559e$var$Ja = Symbol.iterator;
function $f62453a6e3b4559e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f62453a6e3b4559e$var$Ja && a[$f62453a6e3b4559e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f62453a6e3b4559e$var$A = Object.assign, $f62453a6e3b4559e$var$La;
function $f62453a6e3b4559e$var$Ma(a) {
    if (void 0 === $f62453a6e3b4559e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $f62453a6e3b4559e$var$La = b && b[1] || "";
    }
    return "\n" + $f62453a6e3b4559e$var$La + a;
}
var $f62453a6e3b4559e$var$Na = !1;
function $f62453a6e3b4559e$var$Oa(a, b) {
    if (!a || $f62453a6e3b4559e$var$Na) return "";
    $f62453a6e3b4559e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $f62453a6e3b4559e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $f62453a6e3b4559e$var$Ma(a) : "";
}
function $f62453a6e3b4559e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $f62453a6e3b4559e$var$Ma(a.type);
        case 16:
            return $f62453a6e3b4559e$var$Ma("Lazy");
        case 13:
            return $f62453a6e3b4559e$var$Ma("Suspense");
        case 19:
            return $f62453a6e3b4559e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !1), a;
        case 11:
            return a = $f62453a6e3b4559e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $f62453a6e3b4559e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $f62453a6e3b4559e$var$ya:
            return "Fragment";
        case $f62453a6e3b4559e$var$wa:
            return "Portal";
        case $f62453a6e3b4559e$var$Aa:
            return "Profiler";
        case $f62453a6e3b4559e$var$za:
            return "StrictMode";
        case $f62453a6e3b4559e$var$Ea:
            return "Suspense";
        case $f62453a6e3b4559e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $f62453a6e3b4559e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $f62453a6e3b4559e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $f62453a6e3b4559e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $f62453a6e3b4559e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $f62453a6e3b4559e$var$Qa(a.type) || "Memo";
        case $f62453a6e3b4559e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $f62453a6e3b4559e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $f62453a6e3b4559e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $f62453a6e3b4559e$var$Qa(b);
        case 8:
            return b === $f62453a6e3b4559e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $f62453a6e3b4559e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $f62453a6e3b4559e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $f62453a6e3b4559e$var$Ua(a) {
    var b = $f62453a6e3b4559e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $f62453a6e3b4559e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $f62453a6e3b4559e$var$Ua(a));
}
function $f62453a6e3b4559e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $f62453a6e3b4559e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $f62453a6e3b4559e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $f62453a6e3b4559e$var$Ya(a, b) {
    var c = b.checked;
    return $f62453a6e3b4559e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $f62453a6e3b4559e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $f62453a6e3b4559e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $f62453a6e3b4559e$var$ab(a, b) {
    b = b.checked;
    null != b && $f62453a6e3b4559e$var$ta(a, "checked", b, !1);
}
function $f62453a6e3b4559e$var$bb(a, b) {
    $f62453a6e3b4559e$var$ab(a, b);
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $f62453a6e3b4559e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $f62453a6e3b4559e$var$cb(a, b.type, $f62453a6e3b4559e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $f62453a6e3b4559e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $f62453a6e3b4559e$var$cb(a, b, c) {
    if ("number" !== b || $f62453a6e3b4559e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $f62453a6e3b4559e$var$eb = Array.isArray;
function $f62453a6e3b4559e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $f62453a6e3b4559e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $f62453a6e3b4559e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($f62453a6e3b4559e$var$p(91));
    return $f62453a6e3b4559e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $f62453a6e3b4559e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($f62453a6e3b4559e$var$p(92));
            if ($f62453a6e3b4559e$var$eb(c)) {
                if (1 < c.length) throw Error($f62453a6e3b4559e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $f62453a6e3b4559e$var$Sa(c)
    };
}
function $f62453a6e3b4559e$var$ib(a, b) {
    var c = $f62453a6e3b4559e$var$Sa(b.value), d = $f62453a6e3b4559e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $f62453a6e3b4559e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $f62453a6e3b4559e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $f62453a6e3b4559e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $f62453a6e3b4559e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $f62453a6e3b4559e$var$mb, $f62453a6e3b4559e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $f62453a6e3b4559e$var$mb = $f62453a6e3b4559e$var$mb || document.createElement("div");
        $f62453a6e3b4559e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $f62453a6e3b4559e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $f62453a6e3b4559e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $f62453a6e3b4559e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $f62453a6e3b4559e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($f62453a6e3b4559e$var$pb).forEach(function(a) {
    $f62453a6e3b4559e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $f62453a6e3b4559e$var$pb[b] = $f62453a6e3b4559e$var$pb[a];
    });
});
function $f62453a6e3b4559e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $f62453a6e3b4559e$var$pb.hasOwnProperty(a) && $f62453a6e3b4559e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $f62453a6e3b4559e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $f62453a6e3b4559e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $f62453a6e3b4559e$var$tb = $f62453a6e3b4559e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $f62453a6e3b4559e$var$ub(a, b) {
    if (b) {
        if ($f62453a6e3b4559e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($f62453a6e3b4559e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($f62453a6e3b4559e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($f62453a6e3b4559e$var$p(62));
    }
}
function $f62453a6e3b4559e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f62453a6e3b4559e$var$wb = null;
function $f62453a6e3b4559e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $f62453a6e3b4559e$var$yb = null, $f62453a6e3b4559e$var$zb = null, $f62453a6e3b4559e$var$Ab = null;
function $f62453a6e3b4559e$var$Bb(a) {
    if (a = $f62453a6e3b4559e$var$Cb(a)) {
        if ("function" !== typeof $f62453a6e3b4559e$var$yb) throw Error($f62453a6e3b4559e$var$p(280));
        var b = a.stateNode;
        b && (b = $f62453a6e3b4559e$var$Db(b), $f62453a6e3b4559e$var$yb(a.stateNode, a.type, b));
    }
}
function $f62453a6e3b4559e$var$Eb(a) {
    $f62453a6e3b4559e$var$zb ? $f62453a6e3b4559e$var$Ab ? $f62453a6e3b4559e$var$Ab.push(a) : $f62453a6e3b4559e$var$Ab = [
        a
    ] : $f62453a6e3b4559e$var$zb = a;
}
function $f62453a6e3b4559e$var$Fb() {
    if ($f62453a6e3b4559e$var$zb) {
        var a = $f62453a6e3b4559e$var$zb, b = $f62453a6e3b4559e$var$Ab;
        $f62453a6e3b4559e$var$Ab = $f62453a6e3b4559e$var$zb = null;
        $f62453a6e3b4559e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$f62453a6e3b4559e$var$Bb(b[a]);
    }
}
function $f62453a6e3b4559e$var$Gb(a, b) {
    return a(b);
}
function $f62453a6e3b4559e$var$Hb() {}
var $f62453a6e3b4559e$var$Ib = !1;
function $f62453a6e3b4559e$var$Jb(a, b, c) {
    if ($f62453a6e3b4559e$var$Ib) return a(b, c);
    $f62453a6e3b4559e$var$Ib = !0;
    try {
        return $f62453a6e3b4559e$var$Gb(a, b, c);
    } finally{
        if ($f62453a6e3b4559e$var$Ib = !1, null !== $f62453a6e3b4559e$var$zb || null !== $f62453a6e3b4559e$var$Ab) $f62453a6e3b4559e$var$Hb(), $f62453a6e3b4559e$var$Fb();
    }
}
function $f62453a6e3b4559e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $f62453a6e3b4559e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($f62453a6e3b4559e$var$p(231, b, typeof c));
    return c;
}
var $f62453a6e3b4559e$var$Lb = !1;
if ($f62453a6e3b4559e$var$ia) try {
    var $f62453a6e3b4559e$var$Mb = {};
    Object.defineProperty($f62453a6e3b4559e$var$Mb, "passive", {
        get: function() {
            $f62453a6e3b4559e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
    window.removeEventListener("test", $f62453a6e3b4559e$var$Mb, $f62453a6e3b4559e$var$Mb);
} catch (a) {
    $f62453a6e3b4559e$var$Lb = !1;
}
function $f62453a6e3b4559e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $f62453a6e3b4559e$var$Ob = !1, $f62453a6e3b4559e$var$Pb = null, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, $f62453a6e3b4559e$var$Sb = {
    onError: function(a) {
        $f62453a6e3b4559e$var$Ob = !0;
        $f62453a6e3b4559e$var$Pb = a;
    }
};
function $f62453a6e3b4559e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Ob = !1;
    $f62453a6e3b4559e$var$Pb = null;
    $f62453a6e3b4559e$var$Nb.apply($f62453a6e3b4559e$var$Sb, arguments);
}
function $f62453a6e3b4559e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $f62453a6e3b4559e$var$Tb.apply(this, arguments);
    if ($f62453a6e3b4559e$var$Ob) {
        if ($f62453a6e3b4559e$var$Ob) {
            var l = $f62453a6e3b4559e$var$Pb;
            $f62453a6e3b4559e$var$Ob = !1;
            $f62453a6e3b4559e$var$Pb = null;
        } else throw Error($f62453a6e3b4559e$var$p(198));
        $f62453a6e3b4559e$var$Qb || ($f62453a6e3b4559e$var$Qb = !0, $f62453a6e3b4559e$var$Rb = l);
    }
}
function $f62453a6e3b4559e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $f62453a6e3b4559e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $f62453a6e3b4559e$var$Xb(a) {
    if ($f62453a6e3b4559e$var$Vb(a) !== a) throw Error($f62453a6e3b4559e$var$p(188));
}
function $f62453a6e3b4559e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $f62453a6e3b4559e$var$Vb(a);
        if (null === b) throw Error($f62453a6e3b4559e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $f62453a6e3b4559e$var$Xb(e), a;
                if (f === d) return $f62453a6e3b4559e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($f62453a6e3b4559e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($f62453a6e3b4559e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($f62453a6e3b4559e$var$p(190));
    }
    if (3 !== c.tag) throw Error($f62453a6e3b4559e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $f62453a6e3b4559e$var$Zb(a) {
    a = $f62453a6e3b4559e$var$Yb(a);
    return null !== a ? $f62453a6e3b4559e$var$$b(a) : null;
}
function $f62453a6e3b4559e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $f62453a6e3b4559e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$ac = $7zDBh.unstable_scheduleCallback, $f62453a6e3b4559e$var$bc = $7zDBh.unstable_cancelCallback, $f62453a6e3b4559e$var$cc = $7zDBh.unstable_shouldYield, $f62453a6e3b4559e$var$dc = $7zDBh.unstable_requestPaint, $f62453a6e3b4559e$var$B = $7zDBh.unstable_now, $f62453a6e3b4559e$var$ec = $7zDBh.unstable_getCurrentPriorityLevel, $f62453a6e3b4559e$var$fc = $7zDBh.unstable_ImmediatePriority, $f62453a6e3b4559e$var$gc = $7zDBh.unstable_UserBlockingPriority, $f62453a6e3b4559e$var$hc = $7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$ic = $7zDBh.unstable_LowPriority, $f62453a6e3b4559e$var$jc = $7zDBh.unstable_IdlePriority, $f62453a6e3b4559e$var$kc = null, $f62453a6e3b4559e$var$lc = null;
function $f62453a6e3b4559e$var$mc(a) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberRoot) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberRoot($f62453a6e3b4559e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $f62453a6e3b4559e$var$oc = Math.clz32 ? Math.clz32 : $f62453a6e3b4559e$var$nc, $f62453a6e3b4559e$var$pc = Math.log, $f62453a6e3b4559e$var$qc = Math.LN2;
function $f62453a6e3b4559e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($f62453a6e3b4559e$var$pc(a) / $f62453a6e3b4559e$var$qc | 0) | 0;
}
var $f62453a6e3b4559e$var$rc = 64, $f62453a6e3b4559e$var$sc = 4194304;
function $f62453a6e3b4559e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $f62453a6e3b4559e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $f62453a6e3b4559e$var$tc(h) : (f &= g, 0 !== f && (d = $f62453a6e3b4559e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $f62453a6e3b4559e$var$tc(g) : 0 !== f && (d = $f62453a6e3b4559e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $f62453a6e3b4559e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $f62453a6e3b4559e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f62453a6e3b4559e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $f62453a6e3b4559e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $f62453a6e3b4559e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $f62453a6e3b4559e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $f62453a6e3b4559e$var$yc() {
    var a = $f62453a6e3b4559e$var$rc;
    $f62453a6e3b4559e$var$rc <<= 1;
    0 === ($f62453a6e3b4559e$var$rc & 4194240) && ($f62453a6e3b4559e$var$rc = 64);
    return a;
}
function $f62453a6e3b4559e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $f62453a6e3b4559e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $f62453a6e3b4559e$var$oc(b);
    a[b] = c;
}
function $f62453a6e3b4559e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $f62453a6e3b4559e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $f62453a6e3b4559e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $f62453a6e3b4559e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $f62453a6e3b4559e$var$C = 0;
function $f62453a6e3b4559e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $f62453a6e3b4559e$var$Ec, $f62453a6e3b4559e$var$Fc, $f62453a6e3b4559e$var$Gc, $f62453a6e3b4559e$var$Hc, $f62453a6e3b4559e$var$Ic, $f62453a6e3b4559e$var$Jc = !1, $f62453a6e3b4559e$var$Kc = [], $f62453a6e3b4559e$var$Lc = null, $f62453a6e3b4559e$var$Mc = null, $f62453a6e3b4559e$var$Nc = null, $f62453a6e3b4559e$var$Oc = new Map, $f62453a6e3b4559e$var$Pc = new Map, $f62453a6e3b4559e$var$Qc = [], $f62453a6e3b4559e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $f62453a6e3b4559e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $f62453a6e3b4559e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $f62453a6e3b4559e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $f62453a6e3b4559e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $f62453a6e3b4559e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f62453a6e3b4559e$var$Pc.delete(b.pointerId);
    }
}
function $f62453a6e3b4559e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $f62453a6e3b4559e$var$Cb(b), null !== b && $f62453a6e3b4559e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $f62453a6e3b4559e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $f62453a6e3b4559e$var$Lc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $f62453a6e3b4559e$var$Mc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $f62453a6e3b4559e$var$Nc = $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $f62453a6e3b4559e$var$Oc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $f62453a6e3b4559e$var$Pc.set(f, $f62453a6e3b4559e$var$Tc($f62453a6e3b4559e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $f62453a6e3b4559e$var$Vc(a) {
    var b = $f62453a6e3b4559e$var$Wc(a.target);
    if (null !== b) {
        var c = $f62453a6e3b4559e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $f62453a6e3b4559e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $f62453a6e3b4559e$var$Ic(a.priority, function() {
                        $f62453a6e3b4559e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $f62453a6e3b4559e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $f62453a6e3b4559e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $f62453a6e3b4559e$var$wb = d;
            c.target.dispatchEvent(d);
            $f62453a6e3b4559e$var$wb = null;
        } else return b = $f62453a6e3b4559e$var$Cb(c), null !== b && $f62453a6e3b4559e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $f62453a6e3b4559e$var$Zc(a, b, c) {
    $f62453a6e3b4559e$var$Xc(a) && c.delete(b);
}
function $f62453a6e3b4559e$var$$c() {
    $f62453a6e3b4559e$var$Jc = !1;
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Lc) && ($f62453a6e3b4559e$var$Lc = null);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Mc) && ($f62453a6e3b4559e$var$Mc = null);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$Xc($f62453a6e3b4559e$var$Nc) && ($f62453a6e3b4559e$var$Nc = null);
    $f62453a6e3b4559e$var$Oc.forEach($f62453a6e3b4559e$var$Zc);
    $f62453a6e3b4559e$var$Pc.forEach($f62453a6e3b4559e$var$Zc);
}
function $f62453a6e3b4559e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $f62453a6e3b4559e$var$Jc || ($f62453a6e3b4559e$var$Jc = !0, $7zDBh.unstable_scheduleCallback($7zDBh.unstable_NormalPriority, $f62453a6e3b4559e$var$$c)));
}
function $f62453a6e3b4559e$var$bd(a) {
    function b(b) {
        return $f62453a6e3b4559e$var$ad(b, a);
    }
    if (0 < $f62453a6e3b4559e$var$Kc.length) {
        $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Kc[0], a);
        for(var c = 1; c < $f62453a6e3b4559e$var$Kc.length; c++){
            var d = $f62453a6e3b4559e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $f62453a6e3b4559e$var$Lc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Lc, a);
    null !== $f62453a6e3b4559e$var$Mc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Mc, a);
    null !== $f62453a6e3b4559e$var$Nc && $f62453a6e3b4559e$var$ad($f62453a6e3b4559e$var$Nc, a);
    $f62453a6e3b4559e$var$Oc.forEach(b);
    $f62453a6e3b4559e$var$Pc.forEach(b);
    for(c = 0; c < $f62453a6e3b4559e$var$Qc.length; c++)d = $f62453a6e3b4559e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $f62453a6e3b4559e$var$Qc.length && (c = $f62453a6e3b4559e$var$Qc[0], null === c.blockedOn);)$f62453a6e3b4559e$var$Vc(c), null === c.blockedOn && $f62453a6e3b4559e$var$Qc.shift();
}
var $f62453a6e3b4559e$var$cd = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$dd = !0;
function $f62453a6e3b4559e$var$ed(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$gd(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$C, f = $f62453a6e3b4559e$var$cd.transition;
    $f62453a6e3b4559e$var$cd.transition = null;
    try {
        $f62453a6e3b4559e$var$C = 4, $f62453a6e3b4559e$var$fd(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$C = e, $f62453a6e3b4559e$var$cd.transition = f;
    }
}
function $f62453a6e3b4559e$var$fd(a, b, c, d) {
    if ($f62453a6e3b4559e$var$dd) {
        var e = $f62453a6e3b4559e$var$Yc(a, b, c, d);
        if (null === e) $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c), $f62453a6e3b4559e$var$Sc(a, d);
        else if ($f62453a6e3b4559e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($f62453a6e3b4559e$var$Sc(a, d), b & 4 && -1 < $f62453a6e3b4559e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $f62453a6e3b4559e$var$Cb(e);
                null !== f && $f62453a6e3b4559e$var$Ec(f);
                f = $f62453a6e3b4559e$var$Yc(a, b, c, d);
                null === f && $f62453a6e3b4559e$var$hd(a, b, d, $f62453a6e3b4559e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $f62453a6e3b4559e$var$hd(a, b, d, null, c);
    }
}
var $f62453a6e3b4559e$var$id = null;
function $f62453a6e3b4559e$var$Yc(a, b, c, d) {
    $f62453a6e3b4559e$var$id = null;
    a = $f62453a6e3b4559e$var$xb(d);
    a = $f62453a6e3b4559e$var$Wc(a);
    if (null !== a) {
        if (b = $f62453a6e3b4559e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $f62453a6e3b4559e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $f62453a6e3b4559e$var$id = a;
    return null;
}
function $f62453a6e3b4559e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($f62453a6e3b4559e$var$ec()){
                case $f62453a6e3b4559e$var$fc:
                    return 1;
                case $f62453a6e3b4559e$var$gc:
                    return 4;
                case $f62453a6e3b4559e$var$hc:
                case $f62453a6e3b4559e$var$ic:
                    return 16;
                case $f62453a6e3b4559e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ld = null, $f62453a6e3b4559e$var$md = null;
function $f62453a6e3b4559e$var$nd() {
    if ($f62453a6e3b4559e$var$md) return $f62453a6e3b4559e$var$md;
    var a, b = $f62453a6e3b4559e$var$ld, c = b.length, d, e = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $f62453a6e3b4559e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $f62453a6e3b4559e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $f62453a6e3b4559e$var$pd() {
    return !0;
}
function $f62453a6e3b4559e$var$qd() {
    return !1;
}
function $f62453a6e3b4559e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $f62453a6e3b4559e$var$pd : $f62453a6e3b4559e$var$qd;
        this.isPropagationStopped = $f62453a6e3b4559e$var$qd;
        return this;
    }
    $f62453a6e3b4559e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $f62453a6e3b4559e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $f62453a6e3b4559e$var$pd);
        },
        persist: function() {},
        isPersistent: $f62453a6e3b4559e$var$pd
    });
    return b;
}
var $f62453a6e3b4559e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f62453a6e3b4559e$var$td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$sd), $f62453a6e3b4559e$var$ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    view: 0,
    detail: 0
}), $f62453a6e3b4559e$var$vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$ud), $f62453a6e3b4559e$var$wd, $f62453a6e3b4559e$var$xd, $f62453a6e3b4559e$var$yd, $f62453a6e3b4559e$var$Ad = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $f62453a6e3b4559e$var$yd && ($f62453a6e3b4559e$var$yd && "mousemove" === a.type ? ($f62453a6e3b4559e$var$wd = a.screenX - $f62453a6e3b4559e$var$yd.screenX, $f62453a6e3b4559e$var$xd = a.screenY - $f62453a6e3b4559e$var$yd.screenY) : $f62453a6e3b4559e$var$xd = $f62453a6e3b4559e$var$wd = 0, $f62453a6e3b4559e$var$yd = a);
        return $f62453a6e3b4559e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $f62453a6e3b4559e$var$xd;
    }
}), $f62453a6e3b4559e$var$Bd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ad), $f62453a6e3b4559e$var$Cd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    dataTransfer: 0
}), $f62453a6e3b4559e$var$Dd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Cd), $f62453a6e3b4559e$var$Ed = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    relatedTarget: 0
}), $f62453a6e3b4559e$var$Fd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ed), $f62453a6e3b4559e$var$Gd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Hd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Gd), $f62453a6e3b4559e$var$Id = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $f62453a6e3b4559e$var$Jd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Id), $f62453a6e3b4559e$var$Kd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    data: 0
}), $f62453a6e3b4559e$var$Ld = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Kd), $f62453a6e3b4559e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f62453a6e3b4559e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f62453a6e3b4559e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f62453a6e3b4559e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $f62453a6e3b4559e$var$Od[a]) ? !!b[a] : !1;
}
function $f62453a6e3b4559e$var$zd() {
    return $f62453a6e3b4559e$var$Pd;
}
var $f62453a6e3b4559e$var$Qd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $f62453a6e3b4559e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $f62453a6e3b4559e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $f62453a6e3b4559e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f62453a6e3b4559e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $f62453a6e3b4559e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $f62453a6e3b4559e$var$Rd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Qd), $f62453a6e3b4559e$var$Sd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f62453a6e3b4559e$var$Td = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Sd), $f62453a6e3b4559e$var$Ud = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f62453a6e3b4559e$var$zd
}), $f62453a6e3b4559e$var$Vd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Ud), $f62453a6e3b4559e$var$Wd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f62453a6e3b4559e$var$Xd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Wd), $f62453a6e3b4559e$var$Yd = $f62453a6e3b4559e$var$A({}, $f62453a6e3b4559e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f62453a6e3b4559e$var$Zd = $f62453a6e3b4559e$var$rd($f62453a6e3b4559e$var$Yd), $f62453a6e3b4559e$var$$d = [
    9,
    13,
    27,
    32
], $f62453a6e3b4559e$var$ae = $f62453a6e3b4559e$var$ia && "CompositionEvent" in window, $f62453a6e3b4559e$var$be = null;
$f62453a6e3b4559e$var$ia && "documentMode" in document && ($f62453a6e3b4559e$var$be = document.documentMode);
var $f62453a6e3b4559e$var$ce = $f62453a6e3b4559e$var$ia && "TextEvent" in window && !$f62453a6e3b4559e$var$be, $f62453a6e3b4559e$var$de = $f62453a6e3b4559e$var$ia && (!$f62453a6e3b4559e$var$ae || $f62453a6e3b4559e$var$be && 8 < $f62453a6e3b4559e$var$be && 11 >= $f62453a6e3b4559e$var$be), $f62453a6e3b4559e$var$ee = String.fromCharCode(32), $f62453a6e3b4559e$var$fe = !1;
function $f62453a6e3b4559e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $f62453a6e3b4559e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $f62453a6e3b4559e$var$ie = !1;
function $f62453a6e3b4559e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $f62453a6e3b4559e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $f62453a6e3b4559e$var$fe = !0;
            return $f62453a6e3b4559e$var$ee;
        case "textInput":
            return a = b.data, a === $f62453a6e3b4559e$var$ee && $f62453a6e3b4559e$var$fe ? null : a;
        default:
            return null;
    }
}
function $f62453a6e3b4559e$var$ke(a, b) {
    if ($f62453a6e3b4559e$var$ie) return "compositionend" === a || !$f62453a6e3b4559e$var$ae && $f62453a6e3b4559e$var$ge(a, b) ? (a = $f62453a6e3b4559e$var$nd(), $f62453a6e3b4559e$var$md = $f62453a6e3b4559e$var$ld = $f62453a6e3b4559e$var$kd = null, $f62453a6e3b4559e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $f62453a6e3b4559e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f62453a6e3b4559e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$f62453a6e3b4559e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $f62453a6e3b4559e$var$ne(a, b, c, d) {
    $f62453a6e3b4559e$var$Eb(d);
    b = $f62453a6e3b4559e$var$oe(b, "onChange");
    0 < b.length && (c = new $f62453a6e3b4559e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $f62453a6e3b4559e$var$pe = null, $f62453a6e3b4559e$var$qe = null;
function $f62453a6e3b4559e$var$re(a) {
    $f62453a6e3b4559e$var$se(a, 0);
}
function $f62453a6e3b4559e$var$te(a) {
    var b = $f62453a6e3b4559e$var$ue(a);
    if ($f62453a6e3b4559e$var$Wa(b)) return a;
}
function $f62453a6e3b4559e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $f62453a6e3b4559e$var$we = !1;
if ($f62453a6e3b4559e$var$ia) {
    var $f62453a6e3b4559e$var$xe;
    if ($f62453a6e3b4559e$var$ia) {
        var $f62453a6e3b4559e$var$ye = "oninput" in document;
        if (!$f62453a6e3b4559e$var$ye) {
            var $f62453a6e3b4559e$var$ze = document.createElement("div");
            $f62453a6e3b4559e$var$ze.setAttribute("oninput", "return;");
            $f62453a6e3b4559e$var$ye = "function" === typeof $f62453a6e3b4559e$var$ze.oninput;
        }
        $f62453a6e3b4559e$var$xe = $f62453a6e3b4559e$var$ye;
    } else $f62453a6e3b4559e$var$xe = !1;
    $f62453a6e3b4559e$var$we = $f62453a6e3b4559e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $f62453a6e3b4559e$var$Ae() {
    $f62453a6e3b4559e$var$pe && ($f62453a6e3b4559e$var$pe.detachEvent("onpropertychange", $f62453a6e3b4559e$var$Be), $f62453a6e3b4559e$var$qe = $f62453a6e3b4559e$var$pe = null);
}
function $f62453a6e3b4559e$var$Be(a) {
    if ("value" === a.propertyName && $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe)) {
        var b = [];
        $f62453a6e3b4559e$var$ne(b, $f62453a6e3b4559e$var$qe, a, $f62453a6e3b4559e$var$xb(a));
        $f62453a6e3b4559e$var$Jb($f62453a6e3b4559e$var$re, b);
    }
}
function $f62453a6e3b4559e$var$Ce(a, b, c) {
    "focusin" === a ? ($f62453a6e3b4559e$var$Ae(), $f62453a6e3b4559e$var$pe = b, $f62453a6e3b4559e$var$qe = c, $f62453a6e3b4559e$var$pe.attachEvent("onpropertychange", $f62453a6e3b4559e$var$Be)) : "focusout" === a && $f62453a6e3b4559e$var$Ae();
}
function $f62453a6e3b4559e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $f62453a6e3b4559e$var$te($f62453a6e3b4559e$var$qe);
}
function $f62453a6e3b4559e$var$Ee(a, b) {
    if ("click" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $f62453a6e3b4559e$var$te(b);
}
function $f62453a6e3b4559e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f62453a6e3b4559e$var$He = "function" === typeof Object.is ? Object.is : $f62453a6e3b4559e$var$Ge;
function $f62453a6e3b4559e$var$Ie(a, b) {
    if ($f62453a6e3b4559e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$f62453a6e3b4559e$var$ja.call(b, e) || !$f62453a6e3b4559e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $f62453a6e3b4559e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $f62453a6e3b4559e$var$Ke(a, b) {
    var c = $f62453a6e3b4559e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $f62453a6e3b4559e$var$Je(c);
    }
}
function $f62453a6e3b4559e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $f62453a6e3b4559e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $f62453a6e3b4559e$var$Me() {
    for(var a = window, b = $f62453a6e3b4559e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $f62453a6e3b4559e$var$Xa(a.document);
    }
    return b;
}
function $f62453a6e3b4559e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $f62453a6e3b4559e$var$Oe(a) {
    var b = $f62453a6e3b4559e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $f62453a6e3b4559e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $f62453a6e3b4559e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $f62453a6e3b4559e$var$Ke(c, f);
                var g = $f62453a6e3b4559e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $f62453a6e3b4559e$var$Pe = $f62453a6e3b4559e$var$ia && "documentMode" in document && 11 >= document.documentMode, $f62453a6e3b4559e$var$Qe = null, $f62453a6e3b4559e$var$Re = null, $f62453a6e3b4559e$var$Se = null, $f62453a6e3b4559e$var$Te = !1;
function $f62453a6e3b4559e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $f62453a6e3b4559e$var$Te || null == $f62453a6e3b4559e$var$Qe || $f62453a6e3b4559e$var$Qe !== $f62453a6e3b4559e$var$Xa(d) || (d = $f62453a6e3b4559e$var$Qe, "selectionStart" in d && $f62453a6e3b4559e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $f62453a6e3b4559e$var$Se && $f62453a6e3b4559e$var$Ie($f62453a6e3b4559e$var$Se, d) || ($f62453a6e3b4559e$var$Se = d, d = $f62453a6e3b4559e$var$oe($f62453a6e3b4559e$var$Re, "onSelect"), 0 < d.length && (b = new $f62453a6e3b4559e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $f62453a6e3b4559e$var$Qe)));
}
function $f62453a6e3b4559e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $f62453a6e3b4559e$var$We = {
    animationend: $f62453a6e3b4559e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $f62453a6e3b4559e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $f62453a6e3b4559e$var$Ve("Animation", "AnimationStart"),
    transitionend: $f62453a6e3b4559e$var$Ve("Transition", "TransitionEnd")
}, $f62453a6e3b4559e$var$Xe = {}, $f62453a6e3b4559e$var$Ye = {};
$f62453a6e3b4559e$var$ia && ($f62453a6e3b4559e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $f62453a6e3b4559e$var$We.animationend.animation, delete $f62453a6e3b4559e$var$We.animationiteration.animation, delete $f62453a6e3b4559e$var$We.animationstart.animation), "TransitionEvent" in window || delete $f62453a6e3b4559e$var$We.transitionend.transition);
function $f62453a6e3b4559e$var$Ze(a) {
    if ($f62453a6e3b4559e$var$Xe[a]) return $f62453a6e3b4559e$var$Xe[a];
    if (!$f62453a6e3b4559e$var$We[a]) return a;
    var b = $f62453a6e3b4559e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $f62453a6e3b4559e$var$Ye) return $f62453a6e3b4559e$var$Xe[a] = b[c];
    return a;
}
var $f62453a6e3b4559e$var$$e = $f62453a6e3b4559e$var$Ze("animationend"), $f62453a6e3b4559e$var$af = $f62453a6e3b4559e$var$Ze("animationiteration"), $f62453a6e3b4559e$var$bf = $f62453a6e3b4559e$var$Ze("animationstart"), $f62453a6e3b4559e$var$cf = $f62453a6e3b4559e$var$Ze("transitionend"), $f62453a6e3b4559e$var$df = new Map, $f62453a6e3b4559e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $f62453a6e3b4559e$var$ff(a, b) {
    $f62453a6e3b4559e$var$df.set(a, b);
    $f62453a6e3b4559e$var$fa(b, [
        a
    ]);
}
for(var $f62453a6e3b4559e$var$gf = 0; $f62453a6e3b4559e$var$gf < $f62453a6e3b4559e$var$ef.length; $f62453a6e3b4559e$var$gf++){
    var $f62453a6e3b4559e$var$hf = $f62453a6e3b4559e$var$ef[$f62453a6e3b4559e$var$gf], $f62453a6e3b4559e$var$jf = $f62453a6e3b4559e$var$hf.toLowerCase(), $f62453a6e3b4559e$var$kf = $f62453a6e3b4559e$var$hf[0].toUpperCase() + $f62453a6e3b4559e$var$hf.slice(1);
    $f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$jf, "on" + $f62453a6e3b4559e$var$kf);
}
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$$e, "onAnimationEnd");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$af, "onAnimationIteration");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$bf, "onAnimationStart");
$f62453a6e3b4559e$var$ff("dblclick", "onDoubleClick");
$f62453a6e3b4559e$var$ff("focusin", "onFocus");
$f62453a6e3b4559e$var$ff("focusout", "onBlur");
$f62453a6e3b4559e$var$ff($f62453a6e3b4559e$var$cf, "onTransitionEnd");
$f62453a6e3b4559e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f62453a6e3b4559e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f62453a6e3b4559e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f62453a6e3b4559e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f62453a6e3b4559e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f62453a6e3b4559e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f62453a6e3b4559e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f62453a6e3b4559e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($f62453a6e3b4559e$var$lf));
function $f62453a6e3b4559e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $f62453a6e3b4559e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $f62453a6e3b4559e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $f62453a6e3b4559e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($f62453a6e3b4559e$var$Qb) throw a = $f62453a6e3b4559e$var$Rb, $f62453a6e3b4559e$var$Qb = !1, $f62453a6e3b4559e$var$Rb = null, a;
}
function $f62453a6e3b4559e$var$D(a, b) {
    var c = b[$f62453a6e3b4559e$var$of];
    void 0 === c && (c = b[$f62453a6e3b4559e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($f62453a6e3b4559e$var$pf(b, a, 2, !1), c.add(d));
}
function $f62453a6e3b4559e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $f62453a6e3b4559e$var$pf(c, a, d, b);
}
var $f62453a6e3b4559e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $f62453a6e3b4559e$var$sf(a) {
    if (!a[$f62453a6e3b4559e$var$rf]) {
        a[$f62453a6e3b4559e$var$rf] = !0;
        $f62453a6e3b4559e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($f62453a6e3b4559e$var$mf.has(b) || $f62453a6e3b4559e$var$qf(b, !1, a), $f62453a6e3b4559e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$f62453a6e3b4559e$var$rf] || (b[$f62453a6e3b4559e$var$rf] = !0, $f62453a6e3b4559e$var$qf("selectionchange", !1, b));
    }
}
function $f62453a6e3b4559e$var$pf(a, b, c, d) {
    switch($f62453a6e3b4559e$var$jd(b)){
        case 1:
            var e = $f62453a6e3b4559e$var$ed;
            break;
        case 4:
            e = $f62453a6e3b4559e$var$gd;
            break;
        default:
            e = $f62453a6e3b4559e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$f62453a6e3b4559e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $f62453a6e3b4559e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $f62453a6e3b4559e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $f62453a6e3b4559e$var$Jb(function() {
        var d = f, e = $f62453a6e3b4559e$var$xb(c), g = [];
        a: {
            var h = $f62453a6e3b4559e$var$df.get(a);
            if (void 0 !== h) {
                var k = $f62453a6e3b4559e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $f62453a6e3b4559e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $f62453a6e3b4559e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $f62453a6e3b4559e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $f62453a6e3b4559e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $f62453a6e3b4559e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $f62453a6e3b4559e$var$Vd;
                        break;
                    case $f62453a6e3b4559e$var$$e:
                    case $f62453a6e3b4559e$var$af:
                    case $f62453a6e3b4559e$var$bf:
                        k = $f62453a6e3b4559e$var$Hd;
                        break;
                    case $f62453a6e3b4559e$var$cf:
                        k = $f62453a6e3b4559e$var$Xd;
                        break;
                    case "scroll":
                        k = $f62453a6e3b4559e$var$vd;
                        break;
                    case "wheel":
                        k = $f62453a6e3b4559e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $f62453a6e3b4559e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $f62453a6e3b4559e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $f62453a6e3b4559e$var$Kb(w, x), null != F && t.push($f62453a6e3b4559e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $f62453a6e3b4559e$var$wb && (n = c.relatedTarget || c.fromElement) && ($f62453a6e3b4559e$var$Wc(n) || n[$f62453a6e3b4559e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $f62453a6e3b4559e$var$Wc(n) : null, null !== n && (J = $f62453a6e3b4559e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $f62453a6e3b4559e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $f62453a6e3b4559e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $f62453a6e3b4559e$var$ue(k);
                        u = null == n ? h : $f62453a6e3b4559e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $f62453a6e3b4559e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $f62453a6e3b4559e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $f62453a6e3b4559e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $f62453a6e3b4559e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $f62453a6e3b4559e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $f62453a6e3b4559e$var$vf(t);
                                x = $f62453a6e3b4559e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $f62453a6e3b4559e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $f62453a6e3b4559e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $f62453a6e3b4559e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $f62453a6e3b4559e$var$ve;
                else if ($f62453a6e3b4559e$var$me(h)) {
                    if ($f62453a6e3b4559e$var$we) na = $f62453a6e3b4559e$var$Fe;
                    else {
                        na = $f62453a6e3b4559e$var$De;
                        var xa = $f62453a6e3b4559e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $f62453a6e3b4559e$var$Ee);
                if (na && (na = na(a, d))) {
                    $f62453a6e3b4559e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $f62453a6e3b4559e$var$cb(h, "number", h.value);
            }
            xa = d ? $f62453a6e3b4559e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($f62453a6e3b4559e$var$me(xa) || "true" === xa.contentEditable) $f62453a6e3b4559e$var$Qe = xa, $f62453a6e3b4559e$var$Re = d, $f62453a6e3b4559e$var$Se = null;
                    break;
                case "focusout":
                    $f62453a6e3b4559e$var$Se = $f62453a6e3b4559e$var$Re = $f62453a6e3b4559e$var$Qe = null;
                    break;
                case "mousedown":
                    $f62453a6e3b4559e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f62453a6e3b4559e$var$Te = !1;
                    $f62453a6e3b4559e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($f62453a6e3b4559e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $f62453a6e3b4559e$var$Ue(g, c, e);
            }
            var $a;
            if ($f62453a6e3b4559e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $f62453a6e3b4559e$var$ie ? $f62453a6e3b4559e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($f62453a6e3b4559e$var$de && "ko" !== c.locale && ($f62453a6e3b4559e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $f62453a6e3b4559e$var$ie && ($a = $f62453a6e3b4559e$var$nd()) : ($f62453a6e3b4559e$var$kd = e, $f62453a6e3b4559e$var$ld = "value" in $f62453a6e3b4559e$var$kd ? $f62453a6e3b4559e$var$kd.value : $f62453a6e3b4559e$var$kd.textContent, $f62453a6e3b4559e$var$ie = !0)), xa = $f62453a6e3b4559e$var$oe(d, ba), 0 < xa.length && (ba = new $f62453a6e3b4559e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $f62453a6e3b4559e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $f62453a6e3b4559e$var$ce ? $f62453a6e3b4559e$var$je(a, c) : $f62453a6e3b4559e$var$ke(a, c)) d = $f62453a6e3b4559e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $f62453a6e3b4559e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $f62453a6e3b4559e$var$se(g, b);
    });
}
function $f62453a6e3b4559e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $f62453a6e3b4559e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $f62453a6e3b4559e$var$Kb(a, c), null != f && d.unshift($f62453a6e3b4559e$var$tf(a, f, e)), f = $f62453a6e3b4559e$var$Kb(a, b), null != f && d.push($f62453a6e3b4559e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $f62453a6e3b4559e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $f62453a6e3b4559e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.unshift($f62453a6e3b4559e$var$tf(c, k, h))) : e || (k = $f62453a6e3b4559e$var$Kb(c, f), null != k && g.push($f62453a6e3b4559e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $f62453a6e3b4559e$var$xf = /\r\n?/g, $f62453a6e3b4559e$var$yf = /\u0000|\uFFFD/g;
function $f62453a6e3b4559e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($f62453a6e3b4559e$var$xf, "\n").replace($f62453a6e3b4559e$var$yf, "");
}
function $f62453a6e3b4559e$var$Af(a, b, c) {
    b = $f62453a6e3b4559e$var$zf(b);
    if ($f62453a6e3b4559e$var$zf(a) !== b && c) throw Error($f62453a6e3b4559e$var$p(425));
}
function $f62453a6e3b4559e$var$Bf() {}
var $f62453a6e3b4559e$var$Cf = null, $f62453a6e3b4559e$var$Df = null;
function $f62453a6e3b4559e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $f62453a6e3b4559e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $f62453a6e3b4559e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $f62453a6e3b4559e$var$Hf = "function" === typeof Promise ? Promise : void 0, $f62453a6e3b4559e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f62453a6e3b4559e$var$Hf ? function(a) {
    return $f62453a6e3b4559e$var$Hf.resolve(null).then(a).catch($f62453a6e3b4559e$var$If);
} : $f62453a6e3b4559e$var$Ff;
function $f62453a6e3b4559e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $f62453a6e3b4559e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $f62453a6e3b4559e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $f62453a6e3b4559e$var$bd(b);
}
function $f62453a6e3b4559e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $f62453a6e3b4559e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Nf = Math.random().toString(36).slice(2), $f62453a6e3b4559e$var$Of = "__reactFiber$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Pf = "__reactProps$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$uf = "__reactContainer$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$of = "__reactEvents$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Qf = "__reactListeners$" + $f62453a6e3b4559e$var$Nf, $f62453a6e3b4559e$var$Rf = "__reactHandles$" + $f62453a6e3b4559e$var$Nf;
function $f62453a6e3b4559e$var$Wc(a) {
    var b = a[$f62453a6e3b4559e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$f62453a6e3b4559e$var$uf] || c[$f62453a6e3b4559e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $f62453a6e3b4559e$var$Mf(a); null !== a;){
                if (c = a[$f62453a6e3b4559e$var$Of]) return c;
                a = $f62453a6e3b4559e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $f62453a6e3b4559e$var$Cb(a) {
    a = a[$f62453a6e3b4559e$var$Of] || a[$f62453a6e3b4559e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $f62453a6e3b4559e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($f62453a6e3b4559e$var$p(33));
}
function $f62453a6e3b4559e$var$Db(a) {
    return a[$f62453a6e3b4559e$var$Pf] || null;
}
var $f62453a6e3b4559e$var$Sf = [], $f62453a6e3b4559e$var$Tf = -1;
function $f62453a6e3b4559e$var$Uf(a) {
    return {
        current: a
    };
}
function $f62453a6e3b4559e$var$E(a) {
    0 > $f62453a6e3b4559e$var$Tf || (a.current = $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf], $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = null, $f62453a6e3b4559e$var$Tf--);
}
function $f62453a6e3b4559e$var$G(a, b) {
    $f62453a6e3b4559e$var$Tf++;
    $f62453a6e3b4559e$var$Sf[$f62453a6e3b4559e$var$Tf] = a.current;
    a.current = b;
}
var $f62453a6e3b4559e$var$Vf = {}, $f62453a6e3b4559e$var$H = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$Vf), $f62453a6e3b4559e$var$Wf = $f62453a6e3b4559e$var$Uf(!1), $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$Vf;
function $f62453a6e3b4559e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $f62453a6e3b4559e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $f62453a6e3b4559e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f62453a6e3b4559e$var$$f() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
}
function $f62453a6e3b4559e$var$ag(a, b, c) {
    if ($f62453a6e3b4559e$var$H.current !== $f62453a6e3b4559e$var$Vf) throw Error($f62453a6e3b4559e$var$p(168));
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
function $f62453a6e3b4559e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($f62453a6e3b4559e$var$p(108, $f62453a6e3b4559e$var$Ra(a) || "Unknown", e));
    return $f62453a6e3b4559e$var$A({}, c, d);
}
function $f62453a6e3b4559e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $f62453a6e3b4559e$var$Vf;
    $f62453a6e3b4559e$var$Xf = $f62453a6e3b4559e$var$H.current;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, $f62453a6e3b4559e$var$Wf.current);
    return !0;
}
function $f62453a6e3b4559e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($f62453a6e3b4559e$var$p(169));
    c ? (a = $f62453a6e3b4559e$var$bg(a, b, $f62453a6e3b4559e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$H, a)) : $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wf, c);
}
var $f62453a6e3b4559e$var$eg = null, $f62453a6e3b4559e$var$fg = !1, $f62453a6e3b4559e$var$gg = !1;
function $f62453a6e3b4559e$var$hg(a) {
    null === $f62453a6e3b4559e$var$eg ? $f62453a6e3b4559e$var$eg = [
        a
    ] : $f62453a6e3b4559e$var$eg.push(a);
}
function $f62453a6e3b4559e$var$ig(a) {
    $f62453a6e3b4559e$var$fg = !0;
    $f62453a6e3b4559e$var$hg(a);
}
function $f62453a6e3b4559e$var$jg() {
    if (!$f62453a6e3b4559e$var$gg && null !== $f62453a6e3b4559e$var$eg) {
        $f62453a6e3b4559e$var$gg = !0;
        var a = 0, b = $f62453a6e3b4559e$var$C;
        try {
            var c = $f62453a6e3b4559e$var$eg;
            for($f62453a6e3b4559e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $f62453a6e3b4559e$var$eg = null;
            $f62453a6e3b4559e$var$fg = !1;
        } catch (e) {
            throw null !== $f62453a6e3b4559e$var$eg && ($f62453a6e3b4559e$var$eg = $f62453a6e3b4559e$var$eg.slice(a + 1)), $f62453a6e3b4559e$var$ac($f62453a6e3b4559e$var$fc, $f62453a6e3b4559e$var$jg), e;
        } finally{
            $f62453a6e3b4559e$var$C = b, $f62453a6e3b4559e$var$gg = !1;
        }
    }
    return null;
}
var $f62453a6e3b4559e$var$kg = [], $f62453a6e3b4559e$var$lg = 0, $f62453a6e3b4559e$var$mg = null, $f62453a6e3b4559e$var$ng = 0, $f62453a6e3b4559e$var$og = [], $f62453a6e3b4559e$var$pg = 0, $f62453a6e3b4559e$var$qg = null, $f62453a6e3b4559e$var$rg = 1, $f62453a6e3b4559e$var$sg = "";
function $f62453a6e3b4559e$var$tg(a, b) {
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$ng;
    $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg++] = $f62453a6e3b4559e$var$mg;
    $f62453a6e3b4559e$var$mg = a;
    $f62453a6e3b4559e$var$ng = b;
}
function $f62453a6e3b4559e$var$ug(a, b, c) {
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg;
    $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg;
    $f62453a6e3b4559e$var$qg = a;
    var d = $f62453a6e3b4559e$var$rg;
    a = $f62453a6e3b4559e$var$sg;
    var e = 32 - $f62453a6e3b4559e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $f62453a6e3b4559e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $f62453a6e3b4559e$var$rg = 1 << 32 - $f62453a6e3b4559e$var$oc(b) + e | c << e | d;
        $f62453a6e3b4559e$var$sg = f + a;
    } else $f62453a6e3b4559e$var$rg = 1 << f | c << e | d, $f62453a6e3b4559e$var$sg = a;
}
function $f62453a6e3b4559e$var$vg(a) {
    null !== a.return && ($f62453a6e3b4559e$var$tg(a, 1), $f62453a6e3b4559e$var$ug(a, 1, 0));
}
function $f62453a6e3b4559e$var$wg(a) {
    for(; a === $f62453a6e3b4559e$var$mg;)$f62453a6e3b4559e$var$mg = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null, $f62453a6e3b4559e$var$ng = $f62453a6e3b4559e$var$kg[--$f62453a6e3b4559e$var$lg], $f62453a6e3b4559e$var$kg[$f62453a6e3b4559e$var$lg] = null;
    for(; a === $f62453a6e3b4559e$var$qg;)$f62453a6e3b4559e$var$qg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$sg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null, $f62453a6e3b4559e$var$rg = $f62453a6e3b4559e$var$og[--$f62453a6e3b4559e$var$pg], $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg] = null;
}
var $f62453a6e3b4559e$var$xg = null, $f62453a6e3b4559e$var$yg = null, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$zg = null;
function $f62453a6e3b4559e$var$Ag(a, b) {
    var c = $f62453a6e3b4559e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $f62453a6e3b4559e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $f62453a6e3b4559e$var$qg ? {
                id: $f62453a6e3b4559e$var$rg,
                overflow: $f62453a6e3b4559e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $f62453a6e3b4559e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $f62453a6e3b4559e$var$xg = a, $f62453a6e3b4559e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $f62453a6e3b4559e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $f62453a6e3b4559e$var$Eg(a) {
    if ($f62453a6e3b4559e$var$I) {
        var b = $f62453a6e3b4559e$var$yg;
        if (b) {
            var c = b;
            if (!$f62453a6e3b4559e$var$Cg(a, b)) {
                if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
                b = $f62453a6e3b4559e$var$Lf(c.nextSibling);
                var d = $f62453a6e3b4559e$var$xg;
                b && $f62453a6e3b4559e$var$Cg(a, b) ? $f62453a6e3b4559e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $f62453a6e3b4559e$var$I = !1, $f62453a6e3b4559e$var$xg = a);
            }
        } else {
            if ($f62453a6e3b4559e$var$Dg(a)) throw Error($f62453a6e3b4559e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $f62453a6e3b4559e$var$I = !1;
            $f62453a6e3b4559e$var$xg = a;
        }
    }
}
function $f62453a6e3b4559e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $f62453a6e3b4559e$var$xg = a;
}
function $f62453a6e3b4559e$var$Gg(a) {
    if (a !== $f62453a6e3b4559e$var$xg) return !1;
    if (!$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$Fg(a), $f62453a6e3b4559e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$f62453a6e3b4559e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $f62453a6e3b4559e$var$yg)) {
        if ($f62453a6e3b4559e$var$Dg(a)) throw $f62453a6e3b4559e$var$Hg(), Error($f62453a6e3b4559e$var$p(418));
        for(; b;)$f62453a6e3b4559e$var$Ag(a, b), b = $f62453a6e3b4559e$var$Lf(b.nextSibling);
    }
    $f62453a6e3b4559e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($f62453a6e3b4559e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $f62453a6e3b4559e$var$yg = null;
        }
    } else $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg ? $f62453a6e3b4559e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $f62453a6e3b4559e$var$Hg() {
    for(var a = $f62453a6e3b4559e$var$yg; a;)a = $f62453a6e3b4559e$var$Lf(a.nextSibling);
}
function $f62453a6e3b4559e$var$Ig() {
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$xg = null;
    $f62453a6e3b4559e$var$I = !1;
}
function $f62453a6e3b4559e$var$Jg(a) {
    null === $f62453a6e3b4559e$var$zg ? $f62453a6e3b4559e$var$zg = [
        a
    ] : $f62453a6e3b4559e$var$zg.push(a);
}
var $f62453a6e3b4559e$var$Kg = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig;
function $f62453a6e3b4559e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($f62453a6e3b4559e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($f62453a6e3b4559e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($f62453a6e3b4559e$var$p(284));
        if (!c._owner) throw Error($f62453a6e3b4559e$var$p(290, a));
    }
    return a;
}
function $f62453a6e3b4559e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($f62453a6e3b4559e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $f62453a6e3b4559e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $f62453a6e3b4559e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $f62453a6e3b4559e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $f62453a6e3b4559e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $f62453a6e3b4559e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $f62453a6e3b4559e$var$Lg(a, b, c), d.return = a, d;
        d = $f62453a6e3b4559e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $f62453a6e3b4559e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $f62453a6e3b4559e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $f62453a6e3b4559e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $f62453a6e3b4559e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c = $f62453a6e3b4559e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $f62453a6e3b4559e$var$Lg(a, null, b), c.return = a, c;
                case $f62453a6e3b4559e$var$wa:
                    return b = $f62453a6e3b4559e$var$Sg(b, a.mode, c), b.return = a, b;
                case $f62453a6e3b4559e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($f62453a6e3b4559e$var$eb(b) || $f62453a6e3b4559e$var$Ka(b)) return b = $f62453a6e3b4559e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $f62453a6e3b4559e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $f62453a6e3b4559e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($f62453a6e3b4559e$var$eb(c) || $f62453a6e3b4559e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $f62453a6e3b4559e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $f62453a6e3b4559e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $f62453a6e3b4559e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($f62453a6e3b4559e$var$eb(d) || $f62453a6e3b4559e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $f62453a6e3b4559e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $f62453a6e3b4559e$var$Ka(h);
        if ("function" !== typeof l) throw Error($f62453a6e3b4559e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($f62453a6e3b4559e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $f62453a6e3b4559e$var$I && $f62453a6e3b4559e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $f62453a6e3b4559e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $f62453a6e3b4559e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $f62453a6e3b4559e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $f62453a6e3b4559e$var$Ha && $f62453a6e3b4559e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $f62453a6e3b4559e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $f62453a6e3b4559e$var$ya ? (d = $f62453a6e3b4559e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $f62453a6e3b4559e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $f62453a6e3b4559e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $f62453a6e3b4559e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $f62453a6e3b4559e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($f62453a6e3b4559e$var$eb(f)) return n(a, d, f, h);
            if ($f62453a6e3b4559e$var$Ka(f)) return t(a, d, f, h);
            $f62453a6e3b4559e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $f62453a6e3b4559e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $f62453a6e3b4559e$var$Ug = $f62453a6e3b4559e$var$Og(!0), $f62453a6e3b4559e$var$Vg = $f62453a6e3b4559e$var$Og(!1), $f62453a6e3b4559e$var$Wg = $f62453a6e3b4559e$var$Uf(null), $f62453a6e3b4559e$var$Xg = null, $f62453a6e3b4559e$var$Yg = null, $f62453a6e3b4559e$var$Zg = null;
function $f62453a6e3b4559e$var$$g() {
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Xg = null;
}
function $f62453a6e3b4559e$var$ah(a) {
    var b = $f62453a6e3b4559e$var$Wg.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wg);
    a._currentValue = b;
}
function $f62453a6e3b4559e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $f62453a6e3b4559e$var$ch(a, b) {
    $f62453a6e3b4559e$var$Xg = a;
    $f62453a6e3b4559e$var$Zg = $f62453a6e3b4559e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($f62453a6e3b4559e$var$dh = !0), a.firstContext = null);
}
function $f62453a6e3b4559e$var$eh(a) {
    var b = a._currentValue;
    if ($f62453a6e3b4559e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $f62453a6e3b4559e$var$Yg) {
            if (null === $f62453a6e3b4559e$var$Xg) throw Error($f62453a6e3b4559e$var$p(308));
            $f62453a6e3b4559e$var$Yg = a;
            $f62453a6e3b4559e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $f62453a6e3b4559e$var$Yg = $f62453a6e3b4559e$var$Yg.next = a;
    }
    return b;
}
var $f62453a6e3b4559e$var$fh = null;
function $f62453a6e3b4559e$var$gh(a) {
    null === $f62453a6e3b4559e$var$fh ? $f62453a6e3b4559e$var$fh = [
        a
    ] : $f62453a6e3b4559e$var$fh.push(a);
}
function $f62453a6e3b4559e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $f62453a6e3b4559e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $f62453a6e3b4559e$var$ih(a, d);
}
function $f62453a6e3b4559e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $f62453a6e3b4559e$var$jh = !1;
function $f62453a6e3b4559e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $f62453a6e3b4559e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $f62453a6e3b4559e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f62453a6e3b4559e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($f62453a6e3b4559e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $f62453a6e3b4559e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $f62453a6e3b4559e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $f62453a6e3b4559e$var$ih(a, c);
}
function $f62453a6e3b4559e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
function $f62453a6e3b4559e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $f62453a6e3b4559e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $f62453a6e3b4559e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $f62453a6e3b4559e$var$A({}, q, r);
                            break a;
                        case 2:
                            $f62453a6e3b4559e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $f62453a6e3b4559e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $f62453a6e3b4559e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($f62453a6e3b4559e$var$p(191, e));
            e.call(d);
        }
    }
}
var $f62453a6e3b4559e$var$th = {}, $f62453a6e3b4559e$var$uh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$vh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th), $f62453a6e3b4559e$var$wh = $f62453a6e3b4559e$var$Uf($f62453a6e3b4559e$var$th);
function $f62453a6e3b4559e$var$xh(a) {
    if (a === $f62453a6e3b4559e$var$th) throw Error($f62453a6e3b4559e$var$p(174));
    return a;
}
function $f62453a6e3b4559e$var$yh(a, b) {
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$wh, b);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, $f62453a6e3b4559e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $f62453a6e3b4559e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $f62453a6e3b4559e$var$lb(b, a);
    }
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, b);
}
function $f62453a6e3b4559e$var$zh() {
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh);
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$wh);
}
function $f62453a6e3b4559e$var$Ah(a) {
    $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
    var b = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
    var c = $f62453a6e3b4559e$var$lb(b, a.type);
    b !== c && ($f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$vh, a), $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$uh, c));
}
function $f62453a6e3b4559e$var$Bh(a) {
    $f62453a6e3b4559e$var$vh.current === a && ($f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$uh), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$vh));
}
var $f62453a6e3b4559e$var$L = $f62453a6e3b4559e$var$Uf(0);
function $f62453a6e3b4559e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $f62453a6e3b4559e$var$Dh = [];
function $f62453a6e3b4559e$var$Eh() {
    for(var a = 0; a < $f62453a6e3b4559e$var$Dh.length; a++)$f62453a6e3b4559e$var$Dh[a]._workInProgressVersionPrimary = null;
    $f62453a6e3b4559e$var$Dh.length = 0;
}
var $f62453a6e3b4559e$var$Fh = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$Gh = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$Hh = 0, $f62453a6e3b4559e$var$M = null, $f62453a6e3b4559e$var$N = null, $f62453a6e3b4559e$var$O = null, $f62453a6e3b4559e$var$Ih = !1, $f62453a6e3b4559e$var$Jh = !1, $f62453a6e3b4559e$var$Kh = 0, $f62453a6e3b4559e$var$Lh = 0;
function $f62453a6e3b4559e$var$P() {
    throw Error($f62453a6e3b4559e$var$p(321));
}
function $f62453a6e3b4559e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$f62453a6e3b4559e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $f62453a6e3b4559e$var$Nh(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$Hh = f;
    $f62453a6e3b4559e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $f62453a6e3b4559e$var$Fh.current = null === a || null === a.memoizedState ? $f62453a6e3b4559e$var$Oh : $f62453a6e3b4559e$var$Ph;
    a = c(d, e);
    if ($f62453a6e3b4559e$var$Jh) {
        f = 0;
        do {
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            if (25 <= f) throw Error($f62453a6e3b4559e$var$p(301));
            f += 1;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = null;
            b.updateQueue = null;
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Qh;
            a = c(d, e);
        }while ($f62453a6e3b4559e$var$Jh);
    }
    $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
    b = null !== $f62453a6e3b4559e$var$N && null !== $f62453a6e3b4559e$var$N.next;
    $f62453a6e3b4559e$var$Hh = 0;
    $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
    $f62453a6e3b4559e$var$Ih = !1;
    if (b) throw Error($f62453a6e3b4559e$var$p(300));
    return a;
}
function $f62453a6e3b4559e$var$Sh() {
    var a = 0 !== $f62453a6e3b4559e$var$Kh;
    $f62453a6e3b4559e$var$Kh = 0;
    return a;
}
function $f62453a6e3b4559e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Uh() {
    if (null === $f62453a6e3b4559e$var$N) {
        var a = $f62453a6e3b4559e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $f62453a6e3b4559e$var$N.next;
    var b = null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState : $f62453a6e3b4559e$var$O.next;
    if (null !== b) $f62453a6e3b4559e$var$O = b, $f62453a6e3b4559e$var$N = a;
    else {
        if (null === a) throw Error($f62453a6e3b4559e$var$p(310));
        $f62453a6e3b4559e$var$N = a;
        a = {
            memoizedState: $f62453a6e3b4559e$var$N.memoizedState,
            baseState: $f62453a6e3b4559e$var$N.baseState,
            baseQueue: $f62453a6e3b4559e$var$N.baseQueue,
            queue: $f62453a6e3b4559e$var$N.queue,
            next: null
        };
        null === $f62453a6e3b4559e$var$O ? $f62453a6e3b4559e$var$M.memoizedState = $f62453a6e3b4559e$var$O = a : $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$O.next = a;
    }
    return $f62453a6e3b4559e$var$O;
}
function $f62453a6e3b4559e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $f62453a6e3b4559e$var$Wh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $f62453a6e3b4559e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($f62453a6e3b4559e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $f62453a6e3b4559e$var$M.lanes |= m;
                $f62453a6e3b4559e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $f62453a6e3b4559e$var$He(d, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $f62453a6e3b4559e$var$M.lanes |= f, $f62453a6e3b4559e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $f62453a6e3b4559e$var$Xh(a) {
    var b = $f62453a6e3b4559e$var$Uh(), c = b.queue;
    if (null === c) throw Error($f62453a6e3b4559e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $f62453a6e3b4559e$var$He(f, b.memoizedState) || ($f62453a6e3b4559e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $f62453a6e3b4559e$var$Yh() {}
function $f62453a6e3b4559e$var$Zh(a, b) {
    var c = $f62453a6e3b4559e$var$M, d = $f62453a6e3b4559e$var$Uh(), e = b(), f = !$f62453a6e3b4559e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $f62453a6e3b4559e$var$dh = !0);
    d = d.queue;
    $f62453a6e3b4559e$var$$h($f62453a6e3b4559e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $f62453a6e3b4559e$var$O && $f62453a6e3b4559e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
        0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(c, b, e);
    }
    return e;
}
function $f62453a6e3b4559e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $f62453a6e3b4559e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
}
function $f62453a6e3b4559e$var$ai(a, b, c) {
    return c(function() {
        $f62453a6e3b4559e$var$ei(b) && $f62453a6e3b4559e$var$fi(a);
    });
}
function $f62453a6e3b4559e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$f62453a6e3b4559e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $f62453a6e3b4559e$var$fi(a) {
    var b = $f62453a6e3b4559e$var$ih(a, 1);
    null !== b && $f62453a6e3b4559e$var$gi(b, a, 1, -1);
}
function $f62453a6e3b4559e$var$hi(a) {
    var b = $f62453a6e3b4559e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f62453a6e3b4559e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $f62453a6e3b4559e$var$ii.bind(null, $f62453a6e3b4559e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $f62453a6e3b4559e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $f62453a6e3b4559e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $f62453a6e3b4559e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $f62453a6e3b4559e$var$ji() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$ki(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Th();
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $f62453a6e3b4559e$var$li(a, b, c, d) {
    var e = $f62453a6e3b4559e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $f62453a6e3b4559e$var$N) {
        var g = $f62453a6e3b4559e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $f62453a6e3b4559e$var$Mh(d, g.deps)) {
            e.memoizedState = $f62453a6e3b4559e$var$bi(b, c, f, d);
            return;
        }
    }
    $f62453a6e3b4559e$var$M.flags |= a;
    e.memoizedState = $f62453a6e3b4559e$var$bi(1 | b, c, f, d);
}
function $f62453a6e3b4559e$var$mi(a, b) {
    return $f62453a6e3b4559e$var$ki(8390656, 8, a, b);
}
function $f62453a6e3b4559e$var$$h(a, b) {
    return $f62453a6e3b4559e$var$li(2048, 8, a, b);
}
function $f62453a6e3b4559e$var$ni(a, b) {
    return $f62453a6e3b4559e$var$li(4, 2, a, b);
}
function $f62453a6e3b4559e$var$oi(a, b) {
    return $f62453a6e3b4559e$var$li(4, 4, a, b);
}
function $f62453a6e3b4559e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $f62453a6e3b4559e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $f62453a6e3b4559e$var$li(4, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
}
function $f62453a6e3b4559e$var$ri() {}
function $f62453a6e3b4559e$var$si(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ti(a, b) {
    var c = $f62453a6e3b4559e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $f62453a6e3b4559e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $f62453a6e3b4559e$var$ui(a, b, c) {
    if (0 === ($f62453a6e3b4559e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $f62453a6e3b4559e$var$dh = !0), a.memoizedState = c;
    $f62453a6e3b4559e$var$He(c, b) || (c = $f62453a6e3b4559e$var$yc(), $f62453a6e3b4559e$var$M.lanes |= c, $f62453a6e3b4559e$var$rh |= c, a.baseState = !0);
    return b;
}
function $f62453a6e3b4559e$var$vi(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    $f62453a6e3b4559e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $f62453a6e3b4559e$var$Gh.transition;
    $f62453a6e3b4559e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$Gh.transition = d;
    }
}
function $f62453a6e3b4559e$var$wi() {
    return $f62453a6e3b4559e$var$Uh().memoizedState;
}
function $f62453a6e3b4559e$var$xi(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, c);
    else if (c = $f62453a6e3b4559e$var$hh(a, b, c, d), null !== c) {
        var e = $f62453a6e3b4559e$var$R();
        $f62453a6e3b4559e$var$gi(c, a, d, e);
        $f62453a6e3b4559e$var$Bi(c, b, d);
    }
}
function $f62453a6e3b4559e$var$ii(a, b, c) {
    var d = $f62453a6e3b4559e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f62453a6e3b4559e$var$zi(a)) $f62453a6e3b4559e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($f62453a6e3b4559e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $f62453a6e3b4559e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $f62453a6e3b4559e$var$hh(a, b, e, d);
        null !== c && (e = $f62453a6e3b4559e$var$R(), $f62453a6e3b4559e$var$gi(c, a, d, e), $f62453a6e3b4559e$var$Bi(c, b, d));
    }
}
function $f62453a6e3b4559e$var$zi(a) {
    var b = a.alternate;
    return a === $f62453a6e3b4559e$var$M || null !== b && b === $f62453a6e3b4559e$var$M;
}
function $f62453a6e3b4559e$var$Ai(a, b) {
    $f62453a6e3b4559e$var$Jh = $f62453a6e3b4559e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $f62453a6e3b4559e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $f62453a6e3b4559e$var$Cc(a, c);
    }
}
var $f62453a6e3b4559e$var$Rh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$P,
    useContext: $f62453a6e3b4559e$var$P,
    useEffect: $f62453a6e3b4559e$var$P,
    useImperativeHandle: $f62453a6e3b4559e$var$P,
    useInsertionEffect: $f62453a6e3b4559e$var$P,
    useLayoutEffect: $f62453a6e3b4559e$var$P,
    useMemo: $f62453a6e3b4559e$var$P,
    useReducer: $f62453a6e3b4559e$var$P,
    useRef: $f62453a6e3b4559e$var$P,
    useState: $f62453a6e3b4559e$var$P,
    useDebugValue: $f62453a6e3b4559e$var$P,
    useDeferredValue: $f62453a6e3b4559e$var$P,
    useTransition: $f62453a6e3b4559e$var$P,
    useMutableSource: $f62453a6e3b4559e$var$P,
    useSyncExternalStore: $f62453a6e3b4559e$var$P,
    useId: $f62453a6e3b4559e$var$P,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Oh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: function(a, b) {
        $f62453a6e3b4559e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $f62453a6e3b4559e$var$ki(4194308, 4, $f62453a6e3b4559e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $f62453a6e3b4559e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $f62453a6e3b4559e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $f62453a6e3b4559e$var$xi.bind(null, $f62453a6e3b4559e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $f62453a6e3b4559e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $f62453a6e3b4559e$var$hi,
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        return $f62453a6e3b4559e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$hi(!1), b = a[0];
        a = $f62453a6e3b4559e$var$vi.bind(null, a[1]);
        $f62453a6e3b4559e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $f62453a6e3b4559e$var$M, e = $f62453a6e3b4559e$var$Th();
        if ($f62453a6e3b4559e$var$I) {
            if (void 0 === c) throw Error($f62453a6e3b4559e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $f62453a6e3b4559e$var$Q) throw Error($f62453a6e3b4559e$var$p(349));
            0 !== ($f62453a6e3b4559e$var$Hh & 30) || $f62453a6e3b4559e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $f62453a6e3b4559e$var$mi($f62453a6e3b4559e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $f62453a6e3b4559e$var$bi(9, $f62453a6e3b4559e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $f62453a6e3b4559e$var$Th(), b = $f62453a6e3b4559e$var$Q.identifierPrefix;
        if ($f62453a6e3b4559e$var$I) {
            var c = $f62453a6e3b4559e$var$sg;
            var d = $f62453a6e3b4559e$var$rg;
            c = (d & ~(1 << 32 - $f62453a6e3b4559e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $f62453a6e3b4559e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $f62453a6e3b4559e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Ph = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Wh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Wh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
}, $f62453a6e3b4559e$var$Qh = {
    readContext: $f62453a6e3b4559e$var$eh,
    useCallback: $f62453a6e3b4559e$var$si,
    useContext: $f62453a6e3b4559e$var$eh,
    useEffect: $f62453a6e3b4559e$var$$h,
    useImperativeHandle: $f62453a6e3b4559e$var$qi,
    useInsertionEffect: $f62453a6e3b4559e$var$ni,
    useLayoutEffect: $f62453a6e3b4559e$var$oi,
    useMemo: $f62453a6e3b4559e$var$ti,
    useReducer: $f62453a6e3b4559e$var$Xh,
    useRef: $f62453a6e3b4559e$var$ji,
    useState: function() {
        return $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh);
    },
    useDebugValue: $f62453a6e3b4559e$var$ri,
    useDeferredValue: function(a) {
        var b = $f62453a6e3b4559e$var$Uh();
        return null === $f62453a6e3b4559e$var$N ? b.memoizedState = a : $f62453a6e3b4559e$var$ui(b, $f62453a6e3b4559e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $f62453a6e3b4559e$var$Xh($f62453a6e3b4559e$var$Vh)[0], b = $f62453a6e3b4559e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $f62453a6e3b4559e$var$Yh,
    useSyncExternalStore: $f62453a6e3b4559e$var$Zh,
    useId: $f62453a6e3b4559e$var$wi,
    unstable_isNewReconciler: !1
};
function $f62453a6e3b4559e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $f62453a6e3b4559e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $f62453a6e3b4559e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $f62453a6e3b4559e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $f62453a6e3b4559e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $f62453a6e3b4559e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $f62453a6e3b4559e$var$R(), e = $f62453a6e3b4559e$var$yi(a), f = $f62453a6e3b4559e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $f62453a6e3b4559e$var$nh(a, f, e);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, e, d), $f62453a6e3b4559e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $f62453a6e3b4559e$var$R(), d = $f62453a6e3b4559e$var$yi(a), e = $f62453a6e3b4559e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $f62453a6e3b4559e$var$nh(a, e, d);
        null !== b && ($f62453a6e3b4559e$var$gi(b, a, d, c), $f62453a6e3b4559e$var$oh(b, a, d));
    }
};
function $f62453a6e3b4559e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$f62453a6e3b4559e$var$Ie(c, d) || !$f62453a6e3b4559e$var$Ie(e, f) : !0;
}
function $f62453a6e3b4559e$var$Gi(a, b, c) {
    var d = !1, e = $f62453a6e3b4559e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $f62453a6e3b4559e$var$eh(f) : (e = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $f62453a6e3b4559e$var$Yf(a, e) : $f62453a6e3b4559e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $f62453a6e3b4559e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $f62453a6e3b4559e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $f62453a6e3b4559e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $f62453a6e3b4559e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $f62453a6e3b4559e$var$eh(f) : (f = $f62453a6e3b4559e$var$Zf(b) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, e.context = $f62453a6e3b4559e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($f62453a6e3b4559e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $f62453a6e3b4559e$var$Ei.enqueueReplaceState(e, e.state, null), $f62453a6e3b4559e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $f62453a6e3b4559e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $f62453a6e3b4559e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $f62453a6e3b4559e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $f62453a6e3b4559e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $f62453a6e3b4559e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $f62453a6e3b4559e$var$Ni(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $f62453a6e3b4559e$var$Oi || ($f62453a6e3b4559e$var$Oi = !0, $f62453a6e3b4559e$var$Pi = d);
        $f62453a6e3b4559e$var$Li(a, b);
    };
    return c;
}
function $f62453a6e3b4559e$var$Qi(a, b, c) {
    c = $f62453a6e3b4559e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $f62453a6e3b4559e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $f62453a6e3b4559e$var$Li(a, b);
        "function" !== typeof d && (null === $f62453a6e3b4559e$var$Ri ? $f62453a6e3b4559e$var$Ri = new Set([
            this
        ]) : $f62453a6e3b4559e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $f62453a6e3b4559e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $f62453a6e3b4559e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $f62453a6e3b4559e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $f62453a6e3b4559e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $f62453a6e3b4559e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $f62453a6e3b4559e$var$mh(-1, 1), b.tag = 2, $f62453a6e3b4559e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $f62453a6e3b4559e$var$Wi = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$dh = !1;
function $f62453a6e3b4559e$var$Xi(a, b, c, d) {
    b.child = null === a ? $f62453a6e3b4559e$var$Vg(b, null, c, d) : $f62453a6e3b4559e$var$Ug(b, a.child, c, d);
}
function $f62453a6e3b4559e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $f62453a6e3b4559e$var$ch(b, e);
    d = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    c = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && c && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, d, e);
    return b.child;
}
function $f62453a6e3b4559e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$f62453a6e3b4559e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $f62453a6e3b4559e$var$bj(a, b, f, d, e);
        a = $f62453a6e3b4559e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $f62453a6e3b4559e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $f62453a6e3b4559e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $f62453a6e3b4559e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $f62453a6e3b4559e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($f62453a6e3b4559e$var$Ie(f, d) && a.ref === b.ref) {
            if ($f62453a6e3b4559e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($f62453a6e3b4559e$var$dh = !0);
            else return b.lanes = a.lanes, $f62453a6e3b4559e$var$Zi(a, b, e);
        }
    }
    return $f62453a6e3b4559e$var$cj(a, b, c, d, e);
}
function $f62453a6e3b4559e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj);
            $f62453a6e3b4559e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$ej, $f62453a6e3b4559e$var$fj), $f62453a6e3b4559e$var$fj |= d;
    $f62453a6e3b4559e$var$Xi(a, b, e, c);
    return b.child;
}
function $f62453a6e3b4559e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $f62453a6e3b4559e$var$cj(a, b, c, d, e) {
    var f = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current;
    f = $f62453a6e3b4559e$var$Yf(b, f);
    $f62453a6e3b4559e$var$ch(b, e);
    c = $f62453a6e3b4559e$var$Nh(a, b, c, d, f, e);
    d = $f62453a6e3b4559e$var$Sh();
    if (null !== a && !$f62453a6e3b4559e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $f62453a6e3b4559e$var$Zi(a, b, e);
    $f62453a6e3b4559e$var$I && d && $f62453a6e3b4559e$var$vg(b);
    b.flags |= 1;
    $f62453a6e3b4559e$var$Xi(a, b, c, e);
    return b.child;
}
function $f62453a6e3b4559e$var$hj(a, b, c, d, e) {
    if ($f62453a6e3b4559e$var$Zf(c)) {
        var f = !0;
        $f62453a6e3b4559e$var$cg(b);
    } else f = !1;
    $f62453a6e3b4559e$var$ch(b, e);
    if (null === b.stateNode) $f62453a6e3b4559e$var$ij(a, b), $f62453a6e3b4559e$var$Gi(b, c, d), $f62453a6e3b4559e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $f62453a6e3b4559e$var$eh(l) : (l = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, l = $f62453a6e3b4559e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $f62453a6e3b4559e$var$Hi(b, g, d, l);
        $f62453a6e3b4559e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof m && ($f62453a6e3b4559e$var$Di(b, c, m, d), k = b.memoizedState), (h = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $f62453a6e3b4559e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $f62453a6e3b4559e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $f62453a6e3b4559e$var$eh(k) : (k = $f62453a6e3b4559e$var$Zf(c) ? $f62453a6e3b4559e$var$Xf : $f62453a6e3b4559e$var$H.current, k = $f62453a6e3b4559e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $f62453a6e3b4559e$var$Hi(b, g, d, k);
        $f62453a6e3b4559e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $f62453a6e3b4559e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $f62453a6e3b4559e$var$Wf.current || $f62453a6e3b4559e$var$jh ? ("function" === typeof y && ($f62453a6e3b4559e$var$Di(b, c, y, d), n = b.memoizedState), (l = $f62453a6e3b4559e$var$jh || $f62453a6e3b4559e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $f62453a6e3b4559e$var$jj(a, b, c, d, f, e);
}
function $f62453a6e3b4559e$var$jj(a, b, c, d, e, f) {
    $f62453a6e3b4559e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $f62453a6e3b4559e$var$dg(b, c, !1), $f62453a6e3b4559e$var$Zi(a, b, f);
    d = b.stateNode;
    $f62453a6e3b4559e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $f62453a6e3b4559e$var$Ug(b, a.child, null, f), b.child = $f62453a6e3b4559e$var$Ug(b, null, h, f)) : $f62453a6e3b4559e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $f62453a6e3b4559e$var$dg(b, c, !0);
    return b.child;
}
function $f62453a6e3b4559e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $f62453a6e3b4559e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $f62453a6e3b4559e$var$ag(a, b.context, !1);
    $f62453a6e3b4559e$var$yh(a, b.containerInfo);
}
function $f62453a6e3b4559e$var$lj(a, b, c, d, e) {
    $f62453a6e3b4559e$var$Ig();
    $f62453a6e3b4559e$var$Jg(e);
    b.flags |= 256;
    $f62453a6e3b4559e$var$Xi(a, b, c, d);
    return b.child;
}
var $f62453a6e3b4559e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $f62453a6e3b4559e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $f62453a6e3b4559e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $f62453a6e3b4559e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, e & 1);
    if (null === a) {
        $f62453a6e3b4559e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $f62453a6e3b4559e$var$pj(g, d, 0, null), a = $f62453a6e3b4559e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $f62453a6e3b4559e$var$nj(c), b.memoizedState = $f62453a6e3b4559e$var$mj, a) : $f62453a6e3b4559e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $f62453a6e3b4559e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $f62453a6e3b4559e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $f62453a6e3b4559e$var$Pg(h, f) : (f = $f62453a6e3b4559e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $f62453a6e3b4559e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $f62453a6e3b4559e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $f62453a6e3b4559e$var$qj(a, b) {
    b = $f62453a6e3b4559e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $f62453a6e3b4559e$var$sj(a, b, c, d) {
    null !== d && $f62453a6e3b4559e$var$Jg(d);
    $f62453a6e3b4559e$var$Ug(b, a.child, null, c);
    a = $f62453a6e3b4559e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $f62453a6e3b4559e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(422))), $f62453a6e3b4559e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $f62453a6e3b4559e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $f62453a6e3b4559e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $f62453a6e3b4559e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $f62453a6e3b4559e$var$nj(g);
        b.memoizedState = $f62453a6e3b4559e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $f62453a6e3b4559e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($f62453a6e3b4559e$var$p(419));
        d = $f62453a6e3b4559e$var$Ki(f, d, void 0);
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($f62453a6e3b4559e$var$dh || h) {
        d = $f62453a6e3b4559e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $f62453a6e3b4559e$var$ih(a, e), $f62453a6e3b4559e$var$gi(d, a, e, -1));
        }
        $f62453a6e3b4559e$var$tj();
        d = $f62453a6e3b4559e$var$Ki(Error($f62453a6e3b4559e$var$p(421)));
        return $f62453a6e3b4559e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $f62453a6e3b4559e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(e.nextSibling);
    $f62453a6e3b4559e$var$xg = b;
    $f62453a6e3b4559e$var$I = !0;
    $f62453a6e3b4559e$var$zg = null;
    null !== a && ($f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$rg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$sg, $f62453a6e3b4559e$var$og[$f62453a6e3b4559e$var$pg++] = $f62453a6e3b4559e$var$qg, $f62453a6e3b4559e$var$rg = a.id, $f62453a6e3b4559e$var$sg = a.overflow, $f62453a6e3b4559e$var$qg = b);
    b = $f62453a6e3b4559e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $f62453a6e3b4559e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $f62453a6e3b4559e$var$bh(a.return, b, c);
}
function $f62453a6e3b4559e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $f62453a6e3b4559e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $f62453a6e3b4559e$var$Xi(a, b, d.children, c);
    d = $f62453a6e3b4559e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $f62453a6e3b4559e$var$vj(a, c, b);
            else if (19 === a.tag) $f62453a6e3b4559e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $f62453a6e3b4559e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $f62453a6e3b4559e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $f62453a6e3b4559e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $f62453a6e3b4559e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $f62453a6e3b4559e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $f62453a6e3b4559e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $f62453a6e3b4559e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($f62453a6e3b4559e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $f62453a6e3b4559e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $f62453a6e3b4559e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $f62453a6e3b4559e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $f62453a6e3b4559e$var$kj(b);
            $f62453a6e3b4559e$var$Ig();
            break;
        case 5:
            $f62453a6e3b4559e$var$Ah(b);
            break;
        case 1:
            $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$cg(b);
            break;
        case 4:
            $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $f62453a6e3b4559e$var$oj(a, b, c);
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
                a = $f62453a6e3b4559e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $f62453a6e3b4559e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $f62453a6e3b4559e$var$dj(a, b, c);
    }
    return $f62453a6e3b4559e$var$Zi(a, b, c);
}
var $f62453a6e3b4559e$var$zj, $f62453a6e3b4559e$var$Aj, $f62453a6e3b4559e$var$Bj, $f62453a6e3b4559e$var$Cj;
$f62453a6e3b4559e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$f62453a6e3b4559e$var$Aj = function() {};
$f62453a6e3b4559e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $f62453a6e3b4559e$var$Ya(a, e);
                d = $f62453a6e3b4559e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $f62453a6e3b4559e$var$A({}, e, {
                    value: void 0
                });
                d = $f62453a6e3b4559e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $f62453a6e3b4559e$var$gb(a, e);
                d = $f62453a6e3b4559e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
        }
        $f62453a6e3b4559e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($f62453a6e3b4559e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $f62453a6e3b4559e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$f62453a6e3b4559e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $f62453a6e3b4559e$var$Dj(a, b) {
    if (!$f62453a6e3b4559e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $f62453a6e3b4559e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $f62453a6e3b4559e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f62453a6e3b4559e$var$S(b), null;
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $f62453a6e3b4559e$var$zh();
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
            $f62453a6e3b4559e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $f62453a6e3b4559e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null));
            $f62453a6e3b4559e$var$Aj(a, b);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 5:
            $f62453a6e3b4559e$var$Bh(b);
            var e = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $f62453a6e3b4559e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                    $f62453a6e3b4559e$var$S(b);
                    return null;
                }
                a = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    d[$f62453a6e3b4559e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $f62453a6e3b4559e$var$D("cancel", d);
                            $f62453a6e3b4559e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], d);
                            break;
                        case "source":
                            $f62453a6e3b4559e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $f62453a6e3b4559e$var$D("error", d);
                            $f62453a6e3b4559e$var$D("load", d);
                            break;
                        case "details":
                            $f62453a6e3b4559e$var$D("toggle", d);
                            break;
                        case "input":
                            $f62453a6e3b4559e$var$Za(d, f);
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $f62453a6e3b4559e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$hb(d, f), $f62453a6e3b4559e$var$D("invalid", d);
                    }
                    $f62453a6e3b4559e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $f62453a6e3b4559e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $f62453a6e3b4559e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$Va(d);
                            $f62453a6e3b4559e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $f62453a6e3b4559e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $f62453a6e3b4559e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$f62453a6e3b4559e$var$Of] = b;
                    a[$f62453a6e3b4559e$var$Pf] = d;
                    $f62453a6e3b4559e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $f62453a6e3b4559e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $f62453a6e3b4559e$var$D("cancel", a);
                                $f62453a6e3b4559e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $f62453a6e3b4559e$var$lf.length; e++)$f62453a6e3b4559e$var$D($f62453a6e3b4559e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $f62453a6e3b4559e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $f62453a6e3b4559e$var$D("error", a);
                                $f62453a6e3b4559e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $f62453a6e3b4559e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $f62453a6e3b4559e$var$Za(a, d);
                                e = $f62453a6e3b4559e$var$Ya(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $f62453a6e3b4559e$var$A({}, d, {
                                    value: void 0
                                });
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$hb(a, d);
                                e = $f62453a6e3b4559e$var$gb(a, d);
                                $f62453a6e3b4559e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $f62453a6e3b4559e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $f62453a6e3b4559e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $f62453a6e3b4559e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $f62453a6e3b4559e$var$ob(a, k) : "number" === typeof k && $f62453a6e3b4559e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($f62453a6e3b4559e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $f62453a6e3b4559e$var$D("scroll", a) : null != k && $f62453a6e3b4559e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $f62453a6e3b4559e$var$Va(a);
                                $f62453a6e3b4559e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $f62453a6e3b4559e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $f62453a6e3b4559e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $f62453a6e3b4559e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $f62453a6e3b4559e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $f62453a6e3b4559e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($f62453a6e3b4559e$var$p(166));
                c = $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$wh.current);
                $f62453a6e3b4559e$var$xh($f62453a6e3b4559e$var$uh.current);
                if ($f62453a6e3b4559e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$f62453a6e3b4559e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $f62453a6e3b4559e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $f62453a6e3b4559e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$f62453a6e3b4559e$var$Of] = b, b.stateNode = d;
            }
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($f62453a6e3b4559e$var$I && null !== $f62453a6e3b4559e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $f62453a6e3b4559e$var$Hg(), $f62453a6e3b4559e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $f62453a6e3b4559e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($f62453a6e3b4559e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($f62453a6e3b4559e$var$p(317));
                        f[$f62453a6e3b4559e$var$Of] = b;
                    } else $f62453a6e3b4559e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $f62453a6e3b4559e$var$S(b);
                    f = !1;
                } else null !== $f62453a6e3b4559e$var$zg && ($f62453a6e3b4559e$var$Fj($f62453a6e3b4559e$var$zg), $f62453a6e3b4559e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($f62453a6e3b4559e$var$L.current & 1) ? 0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 3) : $f62453a6e3b4559e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$Aj(a, b), null === a && $f62453a6e3b4559e$var$sf(b.stateNode.containerInfo), $f62453a6e3b4559e$var$S(b), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), $f62453a6e3b4559e$var$S(b), null;
        case 17:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), $f62453a6e3b4559e$var$S(b), null;
        case 19:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            f = b.memoizedState;
            if (null === f) return $f62453a6e3b4559e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $f62453a6e3b4559e$var$Dj(f, !1);
                else {
                    if (0 !== $f62453a6e3b4559e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $f62453a6e3b4559e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $f62453a6e3b4559e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, $f62453a6e3b4559e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $f62453a6e3b4559e$var$B() > $f62453a6e3b4559e$var$Gj && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $f62453a6e3b4559e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $f62453a6e3b4559e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$f62453a6e3b4559e$var$I) return $f62453a6e3b4559e$var$S(b), null;
                    } else 2 * $f62453a6e3b4559e$var$B() - f.renderingStartTime > $f62453a6e3b4559e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $f62453a6e3b4559e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $f62453a6e3b4559e$var$B(), b.sibling = null, c = $f62453a6e3b4559e$var$L.current, $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$L, d ? c & 1 | 2 : c & 1), b;
            $f62453a6e3b4559e$var$S(b);
            return null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($f62453a6e3b4559e$var$fj & 1073741824) && ($f62453a6e3b4559e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $f62453a6e3b4559e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
}
function $f62453a6e3b4559e$var$Ij(a, b) {
    $f62453a6e3b4559e$var$wg(b);
    switch(b.tag){
        case 1:
            return $f62453a6e3b4559e$var$Zf(b.type) && $f62453a6e3b4559e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $f62453a6e3b4559e$var$zh(), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf), $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H), $f62453a6e3b4559e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $f62453a6e3b4559e$var$Bh(b), null;
        case 13:
            $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($f62453a6e3b4559e$var$p(340));
                $f62453a6e3b4559e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L), null;
        case 4:
            return $f62453a6e3b4559e$var$zh(), null;
        case 10:
            return $f62453a6e3b4559e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $f62453a6e3b4559e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $f62453a6e3b4559e$var$Jj = !1, $f62453a6e3b4559e$var$U = !1, $f62453a6e3b4559e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $f62453a6e3b4559e$var$V = null;
function $f62453a6e3b4559e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $f62453a6e3b4559e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $f62453a6e3b4559e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $f62453a6e3b4559e$var$W(a, b, d);
    }
}
var $f62453a6e3b4559e$var$Nj = !1;
function $f62453a6e3b4559e$var$Oj(a, b) {
    $f62453a6e3b4559e$var$Cf = $f62453a6e3b4559e$var$dd;
    a = $f62453a6e3b4559e$var$Me();
    if ($f62453a6e3b4559e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $f62453a6e3b4559e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $f62453a6e3b4559e$var$dd = !1;
    for($f62453a6e3b4559e$var$V = b; null !== $f62453a6e3b4559e$var$V;)if (b = $f62453a6e3b4559e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $f62453a6e3b4559e$var$V = a;
    else for(; null !== $f62453a6e3b4559e$var$V;){
        b = $f62453a6e3b4559e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $f62453a6e3b4559e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(163));
            }
        } catch (F) {
            $f62453a6e3b4559e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $f62453a6e3b4559e$var$V = a;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
    n = $f62453a6e3b4559e$var$Nj;
    $f62453a6e3b4559e$var$Nj = !1;
    return n;
}
function $f62453a6e3b4559e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $f62453a6e3b4559e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $f62453a6e3b4559e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $f62453a6e3b4559e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $f62453a6e3b4559e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $f62453a6e3b4559e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$f62453a6e3b4559e$var$Of], delete b[$f62453a6e3b4559e$var$Pf], delete b[$f62453a6e3b4559e$var$of], delete b[$f62453a6e3b4559e$var$Qf], delete b[$f62453a6e3b4559e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $f62453a6e3b4559e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $f62453a6e3b4559e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $f62453a6e3b4559e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $f62453a6e3b4559e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $f62453a6e3b4559e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Vj(a, b, c), a = a.sibling;
}
function $f62453a6e3b4559e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling; null !== a;)$f62453a6e3b4559e$var$Wj(a, b, c), a = a.sibling;
}
var $f62453a6e3b4559e$var$X = null, $f62453a6e3b4559e$var$Xj = !1;
function $f62453a6e3b4559e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$f62453a6e3b4559e$var$Zj(a, b, c), c = c.sibling;
}
function $f62453a6e3b4559e$var$Zj(a, b, c) {
    if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onCommitFiberUnmount) try {
        $f62453a6e3b4559e$var$lc.onCommitFiberUnmount($f62453a6e3b4559e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Lj(c, b);
        case 6:
            var d = $f62453a6e3b4559e$var$X, e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $f62453a6e3b4559e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $f62453a6e3b4559e$var$X && ($f62453a6e3b4559e$var$Xj ? (a = $f62453a6e3b4559e$var$X, c = c.stateNode, 8 === a.nodeType ? $f62453a6e3b4559e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $f62453a6e3b4559e$var$Kf(a, c), $f62453a6e3b4559e$var$bd(a)) : $f62453a6e3b4559e$var$Kf($f62453a6e3b4559e$var$X, c.stateNode));
            break;
        case 4:
            d = $f62453a6e3b4559e$var$X;
            e = $f62453a6e3b4559e$var$Xj;
            $f62453a6e3b4559e$var$X = c.stateNode.containerInfo;
            $f62453a6e3b4559e$var$Xj = !0;
            $f62453a6e3b4559e$var$Yj(a, b, c);
            $f62453a6e3b4559e$var$X = d;
            $f62453a6e3b4559e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$f62453a6e3b4559e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $f62453a6e3b4559e$var$Mj(c, b, g) : 0 !== (f & 4) && $f62453a6e3b4559e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$f62453a6e3b4559e$var$U && ($f62453a6e3b4559e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $f62453a6e3b4559e$var$W(c, b, h);
            }
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 21:
            $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($f62453a6e3b4559e$var$U = (d = $f62453a6e3b4559e$var$U) || null !== c.memoizedState, $f62453a6e3b4559e$var$Yj(a, b, c), $f62453a6e3b4559e$var$U = d) : $f62453a6e3b4559e$var$Yj(a, b, c);
            break;
        default:
            $f62453a6e3b4559e$var$Yj(a, b, c);
    }
}
function $f62453a6e3b4559e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $f62453a6e3b4559e$var$Kj);
        b.forEach(function(b) {
            var d = $f62453a6e3b4559e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $f62453a6e3b4559e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $f62453a6e3b4559e$var$X = h.stateNode;
                        $f62453a6e3b4559e$var$Xj = !1;
                        break a;
                    case 3:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                    case 4:
                        $f62453a6e3b4559e$var$X = h.stateNode.containerInfo;
                        $f62453a6e3b4559e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $f62453a6e3b4559e$var$X) throw Error($f62453a6e3b4559e$var$p(160));
            $f62453a6e3b4559e$var$Zj(f, g, e);
            $f62453a6e3b4559e$var$X = null;
            $f62453a6e3b4559e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $f62453a6e3b4559e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$f62453a6e3b4559e$var$dk(b, a), b = b.sibling;
}
function $f62453a6e3b4559e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                try {
                    $f62453a6e3b4559e$var$Pj(3, a, a.return), $f62453a6e3b4559e$var$Qj(3, a);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
                try {
                    $f62453a6e3b4559e$var$Pj(5, a, a.return);
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            break;
        case 5:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 512 && null !== c && $f62453a6e3b4559e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $f62453a6e3b4559e$var$ob(e, "");
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $f62453a6e3b4559e$var$ab(e, f);
                    $f62453a6e3b4559e$var$vb(h, g);
                    var l = $f62453a6e3b4559e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $f62453a6e3b4559e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $f62453a6e3b4559e$var$nb(e, q) : "children" === m ? $f62453a6e3b4559e$var$ob(e, q) : $f62453a6e3b4559e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $f62453a6e3b4559e$var$bb(e, f);
                            break;
                        case "textarea":
                            $f62453a6e3b4559e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $f62453a6e3b4559e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$f62453a6e3b4559e$var$Pf] = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($f62453a6e3b4559e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $f62453a6e3b4559e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $f62453a6e3b4559e$var$bd(b.containerInfo);
            } catch (t) {
                $f62453a6e3b4559e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            break;
        case 13:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($f62453a6e3b4559e$var$fk = $f62453a6e3b4559e$var$B()));
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($f62453a6e3b4559e$var$U = (l = $f62453a6e3b4559e$var$U) || m, $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$U = l) : $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($f62453a6e3b4559e$var$V = a, m = a.child; null !== m;){
                    for(q = $f62453a6e3b4559e$var$V = m; null !== $f62453a6e3b4559e$var$V;){
                        r = $f62453a6e3b4559e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $f62453a6e3b4559e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $f62453a6e3b4559e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $f62453a6e3b4559e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $f62453a6e3b4559e$var$V = y) : $f62453a6e3b4559e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $f62453a6e3b4559e$var$rb("display", g));
                            } catch (t) {
                                $f62453a6e3b4559e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $f62453a6e3b4559e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $f62453a6e3b4559e$var$ck(b, a);
            $f62453a6e3b4559e$var$ek(a);
            d & 4 && $f62453a6e3b4559e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $f62453a6e3b4559e$var$ck(b, a), $f62453a6e3b4559e$var$ek(a);
    }
}
function $f62453a6e3b4559e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($f62453a6e3b4559e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($f62453a6e3b4559e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($f62453a6e3b4559e$var$ob(e, ""), d.flags &= -33);
                    var f = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $f62453a6e3b4559e$var$Uj(a);
                    $f62453a6e3b4559e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(161));
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $f62453a6e3b4559e$var$hk(a, b, c) {
    $f62453a6e3b4559e$var$V = a;
    $f62453a6e3b4559e$var$ik(a, b, c);
}
function $f62453a6e3b4559e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $f62453a6e3b4559e$var$V;){
        var e = $f62453a6e3b4559e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $f62453a6e3b4559e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $f62453a6e3b4559e$var$U;
                h = $f62453a6e3b4559e$var$Jj;
                var l = $f62453a6e3b4559e$var$U;
                $f62453a6e3b4559e$var$Jj = g;
                if (($f62453a6e3b4559e$var$U = k) && !l) for($f62453a6e3b4559e$var$V = e; null !== $f62453a6e3b4559e$var$V;)g = $f62453a6e3b4559e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $f62453a6e3b4559e$var$jk(e) : null !== k ? (k.return = g, $f62453a6e3b4559e$var$V = k) : $f62453a6e3b4559e$var$jk(e);
                for(; null !== f;)$f62453a6e3b4559e$var$V = f, $f62453a6e3b4559e$var$ik(f, b, c), f = f.sibling;
                $f62453a6e3b4559e$var$V = e;
                $f62453a6e3b4559e$var$Jj = h;
                $f62453a6e3b4559e$var$U = l;
            }
            $f62453a6e3b4559e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $f62453a6e3b4559e$var$V = f) : $f62453a6e3b4559e$var$kk(a, b, c);
    }
}
function $f62453a6e3b4559e$var$kk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $f62453a6e3b4559e$var$U || $f62453a6e3b4559e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$f62453a6e3b4559e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $f62453a6e3b4559e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $f62453a6e3b4559e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $f62453a6e3b4559e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $f62453a6e3b4559e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($f62453a6e3b4559e$var$p(163));
                }
                $f62453a6e3b4559e$var$U || b.flags & 512 && $f62453a6e3b4559e$var$Rj(b);
            } catch (r) {
                $f62453a6e3b4559e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$gk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $f62453a6e3b4559e$var$V = c;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
function $f62453a6e3b4559e$var$jk(a) {
    for(; null !== $f62453a6e3b4559e$var$V;){
        var b = $f62453a6e3b4559e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $f62453a6e3b4559e$var$Qj(4, b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $f62453a6e3b4559e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $f62453a6e3b4559e$var$Rj(b);
                    } catch (k) {
                        $f62453a6e3b4559e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $f62453a6e3b4559e$var$W(b, b.return, k);
        }
        if (b === a) {
            $f62453a6e3b4559e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $f62453a6e3b4559e$var$V = h;
            break;
        }
        $f62453a6e3b4559e$var$V = b.return;
    }
}
var $f62453a6e3b4559e$var$lk = Math.ceil, $f62453a6e3b4559e$var$mk = $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher, $f62453a6e3b4559e$var$nk = $f62453a6e3b4559e$var$ua.ReactCurrentOwner, $f62453a6e3b4559e$var$ok = $f62453a6e3b4559e$var$ua.ReactCurrentBatchConfig, $f62453a6e3b4559e$var$K = 0, $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Y = null, $f62453a6e3b4559e$var$Z = 0, $f62453a6e3b4559e$var$fj = 0, $f62453a6e3b4559e$var$ej = $f62453a6e3b4559e$var$Uf(0), $f62453a6e3b4559e$var$T = 0, $f62453a6e3b4559e$var$pk = null, $f62453a6e3b4559e$var$rh = 0, $f62453a6e3b4559e$var$qk = 0, $f62453a6e3b4559e$var$rk = 0, $f62453a6e3b4559e$var$sk = null, $f62453a6e3b4559e$var$tk = null, $f62453a6e3b4559e$var$fk = 0, $f62453a6e3b4559e$var$Gj = Infinity, $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Oi = !1, $f62453a6e3b4559e$var$Pi = null, $f62453a6e3b4559e$var$Ri = null, $f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = null, $f62453a6e3b4559e$var$xk = 0, $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, $f62453a6e3b4559e$var$Ak = -1, $f62453a6e3b4559e$var$Bk = 0;
function $f62453a6e3b4559e$var$R() {
    return 0 !== ($f62453a6e3b4559e$var$K & 6) ? $f62453a6e3b4559e$var$B() : -1 !== $f62453a6e3b4559e$var$Ak ? $f62453a6e3b4559e$var$Ak : $f62453a6e3b4559e$var$Ak = $f62453a6e3b4559e$var$B();
}
function $f62453a6e3b4559e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($f62453a6e3b4559e$var$K & 2) && 0 !== $f62453a6e3b4559e$var$Z) return $f62453a6e3b4559e$var$Z & -$f62453a6e3b4559e$var$Z;
    if (null !== $f62453a6e3b4559e$var$Kg.transition) return 0 === $f62453a6e3b4559e$var$Bk && ($f62453a6e3b4559e$var$Bk = $f62453a6e3b4559e$var$yc()), $f62453a6e3b4559e$var$Bk;
    a = $f62453a6e3b4559e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $f62453a6e3b4559e$var$jd(a.type);
    return a;
}
function $f62453a6e3b4559e$var$gi(a, b, c, d) {
    if (50 < $f62453a6e3b4559e$var$yk) throw $f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = null, Error($f62453a6e3b4559e$var$p(185));
    $f62453a6e3b4559e$var$Ac(a, c, d);
    if (0 === ($f62453a6e3b4559e$var$K & 2) || a !== $f62453a6e3b4559e$var$Q) a === $f62453a6e3b4559e$var$Q && (0 === ($f62453a6e3b4559e$var$K & 2) && ($f62453a6e3b4559e$var$qk |= c), 4 === $f62453a6e3b4559e$var$T && $f62453a6e3b4559e$var$Ck(a, $f62453a6e3b4559e$var$Z)), $f62453a6e3b4559e$var$Dk(a, d), 1 === c && 0 === $f62453a6e3b4559e$var$K && 0 === (b.mode & 1) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
}
function $f62453a6e3b4559e$var$Dk(a, b) {
    var c = a.callbackNode;
    $f62453a6e3b4559e$var$wc(a, b);
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) null !== c && $f62453a6e3b4559e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $f62453a6e3b4559e$var$bc(c);
        if (1 === b) 0 === a.tag ? $f62453a6e3b4559e$var$ig($f62453a6e3b4559e$var$Ek.bind(null, a)) : $f62453a6e3b4559e$var$hg($f62453a6e3b4559e$var$Ek.bind(null, a)), $f62453a6e3b4559e$var$Jf(function() {
            0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
        }), c = null;
        else {
            switch($f62453a6e3b4559e$var$Dc(d)){
                case 1:
                    c = $f62453a6e3b4559e$var$fc;
                    break;
                case 4:
                    c = $f62453a6e3b4559e$var$gc;
                    break;
                case 16:
                    c = $f62453a6e3b4559e$var$hc;
                    break;
                case 536870912:
                    c = $f62453a6e3b4559e$var$jc;
                    break;
                default:
                    c = $f62453a6e3b4559e$var$hc;
            }
            c = $f62453a6e3b4559e$var$Fk(c, $f62453a6e3b4559e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $f62453a6e3b4559e$var$Gk(a, b) {
    $f62453a6e3b4559e$var$Ak = -1;
    $f62453a6e3b4559e$var$Bk = 0;
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    var c = a.callbackNode;
    if ($f62453a6e3b4559e$var$Hk() && a.callbackNode !== c) return null;
    var d = $f62453a6e3b4559e$var$uc(a, a === $f62453a6e3b4559e$var$Q ? $f62453a6e3b4559e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $f62453a6e3b4559e$var$Ik(a, d);
    else {
        b = d;
        var e = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 2;
        var f = $f62453a6e3b4559e$var$Jk();
        if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$Kk(a, b);
        for(;;)try {
            $f62453a6e3b4559e$var$Lk();
            break;
        } catch (h) {
            $f62453a6e3b4559e$var$Mk(a, h);
        }
        $f62453a6e3b4559e$var$$g();
        $f62453a6e3b4559e$var$mk.current = f;
        $f62453a6e3b4559e$var$K = e;
        null !== $f62453a6e3b4559e$var$Y ? b = 0 : ($f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0, b = $f62453a6e3b4559e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $f62453a6e3b4559e$var$xc(a), 0 !== e && (d = e, b = $f62453a6e3b4559e$var$Nk(a, e)));
        if (1 === b) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
        if (6 === b) $f62453a6e3b4559e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$f62453a6e3b4559e$var$Ok(e) && (b = $f62453a6e3b4559e$var$Ik(a, d), 2 === b && (f = $f62453a6e3b4559e$var$xc(a), 0 !== f && (d = f, b = $f62453a6e3b4559e$var$Nk(a, f))), 1 === b)) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, d), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($f62453a6e3b4559e$var$p(345));
                case 2:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 3:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $f62453a6e3b4559e$var$fk + 500 - $f62453a6e3b4559e$var$B(), 10 < b)) {
                        if (0 !== $f62453a6e3b4559e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $f62453a6e3b4559e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), b);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 4:
                    $f62453a6e3b4559e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $f62453a6e3b4559e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $f62453a6e3b4559e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $f62453a6e3b4559e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $f62453a6e3b4559e$var$Ff($f62453a6e3b4559e$var$Pk.bind(null, a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk), d);
                        break;
                    }
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                case 5:
                    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
                    break;
                default:
                    throw Error($f62453a6e3b4559e$var$p(329));
            }
        }
    }
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return a.callbackNode === c ? $f62453a6e3b4559e$var$Gk.bind(null, a) : null;
}
function $f62453a6e3b4559e$var$Nk(a, b) {
    var c = $f62453a6e3b4559e$var$sk;
    a.current.memoizedState.isDehydrated && ($f62453a6e3b4559e$var$Kk(a, b).flags |= 256);
    a = $f62453a6e3b4559e$var$Ik(a, b);
    2 !== a && (b = $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$tk = c, null !== b && $f62453a6e3b4559e$var$Fj(b));
    return a;
}
function $f62453a6e3b4559e$var$Fj(a) {
    null === $f62453a6e3b4559e$var$tk ? $f62453a6e3b4559e$var$tk = a : $f62453a6e3b4559e$var$tk.push.apply($f62453a6e3b4559e$var$tk, a);
}
function $f62453a6e3b4559e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$f62453a6e3b4559e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $f62453a6e3b4559e$var$Ck(a, b) {
    b &= ~$f62453a6e3b4559e$var$rk;
    b &= ~$f62453a6e3b4559e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $f62453a6e3b4559e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $f62453a6e3b4559e$var$Ek(a) {
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$uc(a, 0);
    if (0 === (b & 1)) return $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), null;
    var c = $f62453a6e3b4559e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $f62453a6e3b4559e$var$xc(a);
        0 !== d && (b = d, c = $f62453a6e3b4559e$var$Nk(a, d));
    }
    if (1 === c) throw c = $f62453a6e3b4559e$var$pk, $f62453a6e3b4559e$var$Kk(a, 0), $f62453a6e3b4559e$var$Ck(a, b), $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B()), c;
    if (6 === c) throw Error($f62453a6e3b4559e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $f62453a6e3b4559e$var$Pk(a, $f62453a6e3b4559e$var$tk, $f62453a6e3b4559e$var$uk);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    return null;
}
function $f62453a6e3b4559e$var$Qk(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $f62453a6e3b4559e$var$K = c, 0 === $f62453a6e3b4559e$var$K && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$fg && $f62453a6e3b4559e$var$jg());
    }
}
function $f62453a6e3b4559e$var$Rk(a) {
    null !== $f62453a6e3b4559e$var$wk && 0 === $f62453a6e3b4559e$var$wk.tag && 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$Hk();
    var b = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 1;
    var c = $f62453a6e3b4559e$var$ok.transition, d = $f62453a6e3b4559e$var$C;
    try {
        if ($f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, a) return a();
    } finally{
        $f62453a6e3b4559e$var$C = d, $f62453a6e3b4559e$var$ok.transition = c, $f62453a6e3b4559e$var$K = b, 0 === ($f62453a6e3b4559e$var$K & 6) && $f62453a6e3b4559e$var$jg();
    }
}
function $f62453a6e3b4559e$var$Hj() {
    $f62453a6e3b4559e$var$fj = $f62453a6e3b4559e$var$ej.current;
    $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$ej);
}
function $f62453a6e3b4559e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $f62453a6e3b4559e$var$Gf(c));
    if (null !== $f62453a6e3b4559e$var$Y) for(c = $f62453a6e3b4559e$var$Y.return; null !== c;){
        var d = c;
        $f62453a6e3b4559e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f62453a6e3b4559e$var$$f();
                break;
            case 3:
                $f62453a6e3b4559e$var$zh();
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$Wf);
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$H);
                $f62453a6e3b4559e$var$Eh();
                break;
            case 5:
                $f62453a6e3b4559e$var$Bh(d);
                break;
            case 4:
                $f62453a6e3b4559e$var$zh();
                break;
            case 13:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 19:
                $f62453a6e3b4559e$var$E($f62453a6e3b4559e$var$L);
                break;
            case 10:
                $f62453a6e3b4559e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $f62453a6e3b4559e$var$Hj();
        }
        c = c.return;
    }
    $f62453a6e3b4559e$var$Q = a;
    $f62453a6e3b4559e$var$Y = a = $f62453a6e3b4559e$var$Pg(a.current, null);
    $f62453a6e3b4559e$var$Z = $f62453a6e3b4559e$var$fj = b;
    $f62453a6e3b4559e$var$T = 0;
    $f62453a6e3b4559e$var$pk = null;
    $f62453a6e3b4559e$var$rk = $f62453a6e3b4559e$var$qk = $f62453a6e3b4559e$var$rh = 0;
    $f62453a6e3b4559e$var$tk = $f62453a6e3b4559e$var$sk = null;
    if (null !== $f62453a6e3b4559e$var$fh) {
        for(b = 0; b < $f62453a6e3b4559e$var$fh.length; b++)if (c = $f62453a6e3b4559e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $f62453a6e3b4559e$var$fh = null;
    }
    return a;
}
function $f62453a6e3b4559e$var$Mk(a, b) {
    do {
        var c = $f62453a6e3b4559e$var$Y;
        try {
            $f62453a6e3b4559e$var$$g();
            $f62453a6e3b4559e$var$Fh.current = $f62453a6e3b4559e$var$Rh;
            if ($f62453a6e3b4559e$var$Ih) {
                for(var d = $f62453a6e3b4559e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $f62453a6e3b4559e$var$Ih = !1;
            }
            $f62453a6e3b4559e$var$Hh = 0;
            $f62453a6e3b4559e$var$O = $f62453a6e3b4559e$var$N = $f62453a6e3b4559e$var$M = null;
            $f62453a6e3b4559e$var$Jh = !1;
            $f62453a6e3b4559e$var$Kh = 0;
            $f62453a6e3b4559e$var$nk.current = null;
            if (null === c || null === c.return) {
                $f62453a6e3b4559e$var$T = 1;
                $f62453a6e3b4559e$var$pk = b;
                $f62453a6e3b4559e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $f62453a6e3b4559e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $f62453a6e3b4559e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $f62453a6e3b4559e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $f62453a6e3b4559e$var$Si(f, l, b);
                            $f62453a6e3b4559e$var$tj();
                            break a;
                        }
                        k = Error($f62453a6e3b4559e$var$p(426));
                    }
                } else if ($f62453a6e3b4559e$var$I && h.mode & 1) {
                    var J = $f62453a6e3b4559e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $f62453a6e3b4559e$var$Vi(J, g, h, f, b);
                        $f62453a6e3b4559e$var$Jg($f62453a6e3b4559e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $f62453a6e3b4559e$var$Ji(k, h);
                4 !== $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 2);
                null === $f62453a6e3b4559e$var$sk ? $f62453a6e3b4559e$var$sk = [
                    f
                ] : $f62453a6e3b4559e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $f62453a6e3b4559e$var$Ni(f, k, b);
                            $f62453a6e3b4559e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $f62453a6e3b4559e$var$Qi(f, h, b);
                                $f62453a6e3b4559e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $f62453a6e3b4559e$var$Sk(c);
        } catch (na) {
            b = na;
            $f62453a6e3b4559e$var$Y === c && null !== c && ($f62453a6e3b4559e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $f62453a6e3b4559e$var$Jk() {
    var a = $f62453a6e3b4559e$var$mk.current;
    $f62453a6e3b4559e$var$mk.current = $f62453a6e3b4559e$var$Rh;
    return null === a ? $f62453a6e3b4559e$var$Rh : a;
}
function $f62453a6e3b4559e$var$tj() {
    if (0 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T || 2 === $f62453a6e3b4559e$var$T) $f62453a6e3b4559e$var$T = 4;
    null === $f62453a6e3b4559e$var$Q || 0 === ($f62453a6e3b4559e$var$rh & 268435455) && 0 === ($f62453a6e3b4559e$var$qk & 268435455) || $f62453a6e3b4559e$var$Ck($f62453a6e3b4559e$var$Q, $f62453a6e3b4559e$var$Z);
}
function $f62453a6e3b4559e$var$Ik(a, b) {
    var c = $f62453a6e3b4559e$var$K;
    $f62453a6e3b4559e$var$K |= 2;
    var d = $f62453a6e3b4559e$var$Jk();
    if ($f62453a6e3b4559e$var$Q !== a || $f62453a6e3b4559e$var$Z !== b) $f62453a6e3b4559e$var$uk = null, $f62453a6e3b4559e$var$Kk(a, b);
    for(;;)try {
        $f62453a6e3b4559e$var$Tk();
        break;
    } catch (e) {
        $f62453a6e3b4559e$var$Mk(a, e);
    }
    $f62453a6e3b4559e$var$$g();
    $f62453a6e3b4559e$var$K = c;
    $f62453a6e3b4559e$var$mk.current = d;
    if (null !== $f62453a6e3b4559e$var$Y) throw Error($f62453a6e3b4559e$var$p(261));
    $f62453a6e3b4559e$var$Q = null;
    $f62453a6e3b4559e$var$Z = 0;
    return $f62453a6e3b4559e$var$T;
}
function $f62453a6e3b4559e$var$Tk() {
    for(; null !== $f62453a6e3b4559e$var$Y;)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Lk() {
    for(; null !== $f62453a6e3b4559e$var$Y && !$f62453a6e3b4559e$var$cc();)$f62453a6e3b4559e$var$Uk($f62453a6e3b4559e$var$Y);
}
function $f62453a6e3b4559e$var$Uk(a) {
    var b = $f62453a6e3b4559e$var$Vk(a.alternate, a, $f62453a6e3b4559e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $f62453a6e3b4559e$var$Sk(a) : $f62453a6e3b4559e$var$Y = b;
    $f62453a6e3b4559e$var$nk.current = null;
}
function $f62453a6e3b4559e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $f62453a6e3b4559e$var$Ej(c, b, $f62453a6e3b4559e$var$fj), null !== c) {
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
        } else {
            c = $f62453a6e3b4559e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $f62453a6e3b4559e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $f62453a6e3b4559e$var$T = 6;
                $f62453a6e3b4559e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $f62453a6e3b4559e$var$Y = b;
            return;
        }
        $f62453a6e3b4559e$var$Y = b = a;
    }while (null !== b);
    0 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$T = 5);
}
function $f62453a6e3b4559e$var$Pk(a, b, c) {
    var d = $f62453a6e3b4559e$var$C, e = $f62453a6e3b4559e$var$ok.transition;
    try {
        $f62453a6e3b4559e$var$ok.transition = null, $f62453a6e3b4559e$var$C = 1, $f62453a6e3b4559e$var$Wk(a, b, c, d);
    } finally{
        $f62453a6e3b4559e$var$ok.transition = e, $f62453a6e3b4559e$var$C = d;
    }
    return null;
}
function $f62453a6e3b4559e$var$Wk(a, b, c, d) {
    do $f62453a6e3b4559e$var$Hk();
    while (null !== $f62453a6e3b4559e$var$wk);
    if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($f62453a6e3b4559e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $f62453a6e3b4559e$var$Bc(a, f);
    a === $f62453a6e3b4559e$var$Q && ($f62453a6e3b4559e$var$Y = $f62453a6e3b4559e$var$Q = null, $f62453a6e3b4559e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $f62453a6e3b4559e$var$vk || ($f62453a6e3b4559e$var$vk = !0, $f62453a6e3b4559e$var$Fk($f62453a6e3b4559e$var$hc, function() {
        $f62453a6e3b4559e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $f62453a6e3b4559e$var$ok.transition;
        $f62453a6e3b4559e$var$ok.transition = null;
        var g = $f62453a6e3b4559e$var$C;
        $f62453a6e3b4559e$var$C = 1;
        var h = $f62453a6e3b4559e$var$K;
        $f62453a6e3b4559e$var$K |= 4;
        $f62453a6e3b4559e$var$nk.current = null;
        $f62453a6e3b4559e$var$Oj(a, c);
        $f62453a6e3b4559e$var$dk(c, a);
        $f62453a6e3b4559e$var$Oe($f62453a6e3b4559e$var$Df);
        $f62453a6e3b4559e$var$dd = !!$f62453a6e3b4559e$var$Cf;
        $f62453a6e3b4559e$var$Df = $f62453a6e3b4559e$var$Cf = null;
        a.current = c;
        $f62453a6e3b4559e$var$hk(c, a, e);
        $f62453a6e3b4559e$var$dc();
        $f62453a6e3b4559e$var$K = h;
        $f62453a6e3b4559e$var$C = g;
        $f62453a6e3b4559e$var$ok.transition = f;
    } else a.current = c;
    $f62453a6e3b4559e$var$vk && ($f62453a6e3b4559e$var$vk = !1, $f62453a6e3b4559e$var$wk = a, $f62453a6e3b4559e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($f62453a6e3b4559e$var$Ri = null);
    $f62453a6e3b4559e$var$mc(c.stateNode, d);
    $f62453a6e3b4559e$var$Dk(a, $f62453a6e3b4559e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($f62453a6e3b4559e$var$Oi) throw $f62453a6e3b4559e$var$Oi = !1, a = $f62453a6e3b4559e$var$Pi, $f62453a6e3b4559e$var$Pi = null, a;
    0 !== ($f62453a6e3b4559e$var$xk & 1) && 0 !== a.tag && $f62453a6e3b4559e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $f62453a6e3b4559e$var$zk ? $f62453a6e3b4559e$var$yk++ : ($f62453a6e3b4559e$var$yk = 0, $f62453a6e3b4559e$var$zk = a) : $f62453a6e3b4559e$var$yk = 0;
    $f62453a6e3b4559e$var$jg();
    return null;
}
function $f62453a6e3b4559e$var$Hk() {
    if (null !== $f62453a6e3b4559e$var$wk) {
        var a = $f62453a6e3b4559e$var$Dc($f62453a6e3b4559e$var$xk), b = $f62453a6e3b4559e$var$ok.transition, c = $f62453a6e3b4559e$var$C;
        try {
            $f62453a6e3b4559e$var$ok.transition = null;
            $f62453a6e3b4559e$var$C = 16 > a ? 16 : a;
            if (null === $f62453a6e3b4559e$var$wk) var d = !1;
            else {
                a = $f62453a6e3b4559e$var$wk;
                $f62453a6e3b4559e$var$wk = null;
                $f62453a6e3b4559e$var$xk = 0;
                if (0 !== ($f62453a6e3b4559e$var$K & 6)) throw Error($f62453a6e3b4559e$var$p(331));
                var e = $f62453a6e3b4559e$var$K;
                $f62453a6e3b4559e$var$K |= 4;
                for($f62453a6e3b4559e$var$V = a.current; null !== $f62453a6e3b4559e$var$V;){
                    var f = $f62453a6e3b4559e$var$V, g = f.child;
                    if (0 !== ($f62453a6e3b4559e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($f62453a6e3b4559e$var$V = l; null !== $f62453a6e3b4559e$var$V;){
                                    var m = $f62453a6e3b4559e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $f62453a6e3b4559e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $f62453a6e3b4559e$var$V = q;
                                    else for(; null !== $f62453a6e3b4559e$var$V;){
                                        m = $f62453a6e3b4559e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $f62453a6e3b4559e$var$Sj(m);
                                        if (m === l) {
                                            $f62453a6e3b4559e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $f62453a6e3b4559e$var$V = r;
                                            break;
                                        }
                                        $f62453a6e3b4559e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $f62453a6e3b4559e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $f62453a6e3b4559e$var$V = g;
                    else b: for(; null !== $f62453a6e3b4559e$var$V;){
                        f = $f62453a6e3b4559e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $f62453a6e3b4559e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $f62453a6e3b4559e$var$V = x;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($f62453a6e3b4559e$var$V = w; null !== $f62453a6e3b4559e$var$V;){
                    g = $f62453a6e3b4559e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $f62453a6e3b4559e$var$V = u;
                    else b: for(g = w; null !== $f62453a6e3b4559e$var$V;){
                        h = $f62453a6e3b4559e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $f62453a6e3b4559e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $f62453a6e3b4559e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $f62453a6e3b4559e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $f62453a6e3b4559e$var$V = F;
                            break b;
                        }
                        $f62453a6e3b4559e$var$V = h.return;
                    }
                }
                $f62453a6e3b4559e$var$K = e;
                $f62453a6e3b4559e$var$jg();
                if ($f62453a6e3b4559e$var$lc && "function" === typeof $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot) try {
                    $f62453a6e3b4559e$var$lc.onPostCommitFiberRoot($f62453a6e3b4559e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $f62453a6e3b4559e$var$C = c, $f62453a6e3b4559e$var$ok.transition = b;
        }
    }
    return !1;
}
function $f62453a6e3b4559e$var$Xk(a, b, c) {
    b = $f62453a6e3b4559e$var$Ji(c, b);
    b = $f62453a6e3b4559e$var$Ni(a, b, 1);
    a = $f62453a6e3b4559e$var$nh(a, b, 1);
    b = $f62453a6e3b4559e$var$R();
    null !== a && ($f62453a6e3b4559e$var$Ac(a, 1, b), $f62453a6e3b4559e$var$Dk(a, b));
}
function $f62453a6e3b4559e$var$W(a, b, c) {
    if (3 === a.tag) $f62453a6e3b4559e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $f62453a6e3b4559e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $f62453a6e3b4559e$var$Ri || !$f62453a6e3b4559e$var$Ri.has(d))) {
                a = $f62453a6e3b4559e$var$Ji(c, a);
                a = $f62453a6e3b4559e$var$Qi(b, a, 1);
                b = $f62453a6e3b4559e$var$nh(b, a, 1);
                a = $f62453a6e3b4559e$var$R();
                null !== b && ($f62453a6e3b4559e$var$Ac(b, 1, a), $f62453a6e3b4559e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $f62453a6e3b4559e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $f62453a6e3b4559e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $f62453a6e3b4559e$var$Q === a && ($f62453a6e3b4559e$var$Z & c) === c && (4 === $f62453a6e3b4559e$var$T || 3 === $f62453a6e3b4559e$var$T && ($f62453a6e3b4559e$var$Z & 130023424) === $f62453a6e3b4559e$var$Z && 500 > $f62453a6e3b4559e$var$B() - $f62453a6e3b4559e$var$fk ? $f62453a6e3b4559e$var$Kk(a, 0) : $f62453a6e3b4559e$var$rk |= c);
    $f62453a6e3b4559e$var$Dk(a, b);
}
function $f62453a6e3b4559e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $f62453a6e3b4559e$var$sc, $f62453a6e3b4559e$var$sc <<= 1, 0 === ($f62453a6e3b4559e$var$sc & 130023424) && ($f62453a6e3b4559e$var$sc = 4194304)));
    var c = $f62453a6e3b4559e$var$R();
    a = $f62453a6e3b4559e$var$ih(a, b);
    null !== a && ($f62453a6e3b4559e$var$Ac(a, b, c), $f62453a6e3b4559e$var$Dk(a, c));
}
function $f62453a6e3b4559e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $f62453a6e3b4559e$var$Yk(a, c);
}
function $f62453a6e3b4559e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($f62453a6e3b4559e$var$p(314));
    }
    null !== d && d.delete(b);
    $f62453a6e3b4559e$var$Yk(a, c);
}
var $f62453a6e3b4559e$var$Vk;
$f62453a6e3b4559e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $f62453a6e3b4559e$var$Wf.current) $f62453a6e3b4559e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$yj(a, b, c);
            $f62453a6e3b4559e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $f62453a6e3b4559e$var$dh = !1, $f62453a6e3b4559e$var$I && 0 !== (b.flags & 1048576) && $f62453a6e3b4559e$var$ug(b, $f62453a6e3b4559e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $f62453a6e3b4559e$var$ij(a, b);
            a = b.pendingProps;
            var e = $f62453a6e3b4559e$var$Yf(b, $f62453a6e3b4559e$var$H.current);
            $f62453a6e3b4559e$var$ch(b, c);
            e = $f62453a6e3b4559e$var$Nh(null, b, d, a, e, c);
            var f = $f62453a6e3b4559e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $f62453a6e3b4559e$var$Zf(d) ? (f = !0, $f62453a6e3b4559e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $f62453a6e3b4559e$var$kh(b), e.updater = $f62453a6e3b4559e$var$Ei, b.stateNode = e, e._reactInternals = b, $f62453a6e3b4559e$var$Ii(b, d, a, c), b = $f62453a6e3b4559e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $f62453a6e3b4559e$var$I && f && $f62453a6e3b4559e$var$vg(b), $f62453a6e3b4559e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $f62453a6e3b4559e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $f62453a6e3b4559e$var$Zk(d);
                a = $f62453a6e3b4559e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $f62453a6e3b4559e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $f62453a6e3b4559e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $f62453a6e3b4559e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $f62453a6e3b4559e$var$$i(null, b, d, $f62453a6e3b4559e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($f62453a6e3b4559e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $f62453a6e3b4559e$var$kj(b);
                if (null === a) throw Error($f62453a6e3b4559e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $f62453a6e3b4559e$var$lh(a, b);
                $f62453a6e3b4559e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(423)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $f62453a6e3b4559e$var$Ji(Error($f62453a6e3b4559e$var$p(424)), b);
                        b = $f62453a6e3b4559e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($f62453a6e3b4559e$var$yg = $f62453a6e3b4559e$var$Lf(b.stateNode.containerInfo.firstChild), $f62453a6e3b4559e$var$xg = b, $f62453a6e3b4559e$var$I = !0, $f62453a6e3b4559e$var$zg = null, c = $f62453a6e3b4559e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $f62453a6e3b4559e$var$Ig();
                    if (d === e) {
                        b = $f62453a6e3b4559e$var$Zi(a, b, c);
                        break a;
                    }
                    $f62453a6e3b4559e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $f62453a6e3b4559e$var$Ah(b), null === a && $f62453a6e3b4559e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $f62453a6e3b4559e$var$Ef(d, e) ? g = null : null !== f && $f62453a6e3b4559e$var$Ef(d, f) && (b.flags |= 32), $f62453a6e3b4559e$var$gj(a, b), $f62453a6e3b4559e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $f62453a6e3b4559e$var$Eg(b), null;
        case 13:
            return $f62453a6e3b4559e$var$oj(a, b, c);
        case 4:
            return $f62453a6e3b4559e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $f62453a6e3b4559e$var$Ug(b, null, d, c) : $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$Yi(a, b, d, e, c);
        case 7:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $f62453a6e3b4559e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $f62453a6e3b4559e$var$G($f62453a6e3b4559e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($f62453a6e3b4559e$var$He(f.value, g)) {
                        if (f.children === e.children && !$f62453a6e3b4559e$var$Wf.current) {
                            b = $f62453a6e3b4559e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $f62453a6e3b4559e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $f62453a6e3b4559e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($f62453a6e3b4559e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $f62453a6e3b4559e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $f62453a6e3b4559e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $f62453a6e3b4559e$var$ch(b, c), e = $f62453a6e3b4559e$var$eh(e), d = d(e), b.flags |= 1, $f62453a6e3b4559e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $f62453a6e3b4559e$var$Ci(d, b.pendingProps), e = $f62453a6e3b4559e$var$Ci(d.type, e), $f62453a6e3b4559e$var$$i(a, b, d, e, c);
        case 15:
            return $f62453a6e3b4559e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $f62453a6e3b4559e$var$Ci(d, e), $f62453a6e3b4559e$var$ij(a, b), b.tag = 1, $f62453a6e3b4559e$var$Zf(d) ? (a = !0, $f62453a6e3b4559e$var$cg(b)) : a = !1, $f62453a6e3b4559e$var$ch(b, c), $f62453a6e3b4559e$var$Gi(b, d, e), $f62453a6e3b4559e$var$Ii(b, d, e, c), $f62453a6e3b4559e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $f62453a6e3b4559e$var$xj(a, b, c);
        case 22:
            return $f62453a6e3b4559e$var$dj(a, b, c);
    }
    throw Error($f62453a6e3b4559e$var$p(156, b.tag));
};
function $f62453a6e3b4559e$var$Fk(a, b) {
    return $f62453a6e3b4559e$var$ac(a, b);
}
function $f62453a6e3b4559e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f62453a6e3b4559e$var$Bg(a, b, c, d) {
    return new $f62453a6e3b4559e$var$$k(a, b, c, d);
}
function $f62453a6e3b4559e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $f62453a6e3b4559e$var$Zk(a) {
    if ("function" === typeof a) return $f62453a6e3b4559e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $f62453a6e3b4559e$var$Da) return 11;
        if (a === $f62453a6e3b4559e$var$Ga) return 14;
    }
    return 2;
}
function $f62453a6e3b4559e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $f62453a6e3b4559e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $f62453a6e3b4559e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $f62453a6e3b4559e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $f62453a6e3b4559e$var$ya:
            return $f62453a6e3b4559e$var$Tg(c.children, e, f, b);
        case $f62453a6e3b4559e$var$za:
            g = 8;
            e |= 8;
            break;
        case $f62453a6e3b4559e$var$Aa:
            return a = $f62453a6e3b4559e$var$Bg(12, c, b, e | 2), a.elementType = $f62453a6e3b4559e$var$Aa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ea:
            return a = $f62453a6e3b4559e$var$Bg(13, c, b, e), a.elementType = $f62453a6e3b4559e$var$Ea, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Fa:
            return a = $f62453a6e3b4559e$var$Bg(19, c, b, e), a.elementType = $f62453a6e3b4559e$var$Fa, a.lanes = f, a;
        case $f62453a6e3b4559e$var$Ia:
            return $f62453a6e3b4559e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $f62453a6e3b4559e$var$Ba:
                    g = 10;
                    break a;
                case $f62453a6e3b4559e$var$Ca:
                    g = 9;
                    break a;
                case $f62453a6e3b4559e$var$Da:
                    g = 11;
                    break a;
                case $f62453a6e3b4559e$var$Ga:
                    g = 14;
                    break a;
                case $f62453a6e3b4559e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($f62453a6e3b4559e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $f62453a6e3b4559e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $f62453a6e3b4559e$var$Tg(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$pj(a, b, c, d) {
    a = $f62453a6e3b4559e$var$Bg(22, a, d, b);
    a.elementType = $f62453a6e3b4559e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $f62453a6e3b4559e$var$Qg(a, b, c) {
    a = $f62453a6e3b4559e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $f62453a6e3b4559e$var$Sg(a, b, c) {
    b = $f62453a6e3b4559e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $f62453a6e3b4559e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $f62453a6e3b4559e$var$zc(0);
    this.expirationTimes = $f62453a6e3b4559e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f62453a6e3b4559e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $f62453a6e3b4559e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $f62453a6e3b4559e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $f62453a6e3b4559e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $f62453a6e3b4559e$var$kh(f);
    return a;
}
function $f62453a6e3b4559e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $f62453a6e3b4559e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $f62453a6e3b4559e$var$dl(a) {
    if (!a) return $f62453a6e3b4559e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($f62453a6e3b4559e$var$Vb(a) !== a || 1 !== a.tag) throw Error($f62453a6e3b4559e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($f62453a6e3b4559e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($f62453a6e3b4559e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($f62453a6e3b4559e$var$Zf(c)) return $f62453a6e3b4559e$var$bg(a, c, b);
    }
    return b;
}
function $f62453a6e3b4559e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $f62453a6e3b4559e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $f62453a6e3b4559e$var$dl(null);
    c = a.current;
    d = $f62453a6e3b4559e$var$R();
    e = $f62453a6e3b4559e$var$yi(c);
    f = $f62453a6e3b4559e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $f62453a6e3b4559e$var$nh(c, f, e);
    a.current.lanes = e;
    $f62453a6e3b4559e$var$Ac(a, e, d);
    $f62453a6e3b4559e$var$Dk(a, d);
    return a;
}
function $f62453a6e3b4559e$var$fl(a, b, c, d) {
    var e = b.current, f = $f62453a6e3b4559e$var$R(), g = $f62453a6e3b4559e$var$yi(e);
    c = $f62453a6e3b4559e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $f62453a6e3b4559e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $f62453a6e3b4559e$var$nh(e, b, g);
    null !== a && ($f62453a6e3b4559e$var$gi(a, e, g, f), $f62453a6e3b4559e$var$oh(a, e, g));
    return g;
}
function $f62453a6e3b4559e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $f62453a6e3b4559e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $f62453a6e3b4559e$var$il(a, b) {
    $f62453a6e3b4559e$var$hl(a, b);
    (a = a.alternate) && $f62453a6e3b4559e$var$hl(a, b);
}
function $f62453a6e3b4559e$var$jl() {
    return null;
}
var $f62453a6e3b4559e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $f62453a6e3b4559e$var$ll(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.render = $f62453a6e3b4559e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($f62453a6e3b4559e$var$p(409));
    $f62453a6e3b4559e$var$fl(a, b, null, null);
};
$f62453a6e3b4559e$var$ml.prototype.unmount = $f62453a6e3b4559e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $f62453a6e3b4559e$var$Rk(function() {
            $f62453a6e3b4559e$var$fl(null, a, null, null);
        });
        b[$f62453a6e3b4559e$var$uf] = null;
    }
};
function $f62453a6e3b4559e$var$ml(a) {
    this._internalRoot = a;
}
$f62453a6e3b4559e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $f62453a6e3b4559e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $f62453a6e3b4559e$var$Qc.length && 0 !== b && b < $f62453a6e3b4559e$var$Qc[c].priority; c++);
        $f62453a6e3b4559e$var$Qc.splice(c, 0, a);
        0 === c && $f62453a6e3b4559e$var$Vc(a);
    }
};
function $f62453a6e3b4559e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $f62453a6e3b4559e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $f62453a6e3b4559e$var$pl() {}
function $f62453a6e3b4559e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                f.call(a);
            };
        }
        var g = $f62453a6e3b4559e$var$el(b, d, a, 0, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
        a._reactRootContainer = g;
        a[$f62453a6e3b4559e$var$uf] = g.current;
        $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $f62453a6e3b4559e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $f62453a6e3b4559e$var$gl(k);
            h.call(a);
        };
    }
    var k = $f62453a6e3b4559e$var$bl(a, 0, !1, null, null, !1, !1, "", $f62453a6e3b4559e$var$pl);
    a._reactRootContainer = k;
    a[$f62453a6e3b4559e$var$uf] = k.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$fl(b, k, c, d);
    });
    return k;
}
function $f62453a6e3b4559e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $f62453a6e3b4559e$var$gl(g);
                h.call(a);
            };
        }
        $f62453a6e3b4559e$var$fl(b, g, a, e);
    } else g = $f62453a6e3b4559e$var$ql(c, b, a, e, d);
    return $f62453a6e3b4559e$var$gl(g);
}
$f62453a6e3b4559e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $f62453a6e3b4559e$var$tc(b.pendingLanes);
                0 !== c && ($f62453a6e3b4559e$var$Cc(b, c | 1), $f62453a6e3b4559e$var$Dk(b, $f62453a6e3b4559e$var$B()), 0 === ($f62453a6e3b4559e$var$K & 6) && ($f62453a6e3b4559e$var$Gj = $f62453a6e3b4559e$var$B() + 500, $f62453a6e3b4559e$var$jg()));
            }
            break;
        case 13:
            $f62453a6e3b4559e$var$Rk(function() {
                var b = $f62453a6e3b4559e$var$ih(a, 1);
                if (null !== b) {
                    var c = $f62453a6e3b4559e$var$R();
                    $f62453a6e3b4559e$var$gi(b, a, 1, c);
                }
            }), $f62453a6e3b4559e$var$il(a, 1);
    }
};
$f62453a6e3b4559e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(b, a, 134217728, c);
        }
        $f62453a6e3b4559e$var$il(a, 134217728);
    }
};
$f62453a6e3b4559e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $f62453a6e3b4559e$var$yi(a), c = $f62453a6e3b4559e$var$ih(a, b);
        if (null !== c) {
            var d = $f62453a6e3b4559e$var$R();
            $f62453a6e3b4559e$var$gi(c, a, b, d);
        }
        $f62453a6e3b4559e$var$il(a, b);
    }
};
$f62453a6e3b4559e$var$Hc = function() {
    return $f62453a6e3b4559e$var$C;
};
$f62453a6e3b4559e$var$Ic = function(a, b) {
    var c = $f62453a6e3b4559e$var$C;
    try {
        return $f62453a6e3b4559e$var$C = a, b();
    } finally{
        $f62453a6e3b4559e$var$C = c;
    }
};
$f62453a6e3b4559e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $f62453a6e3b4559e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $f62453a6e3b4559e$var$Db(d);
                        if (!e) throw Error($f62453a6e3b4559e$var$p(90));
                        $f62453a6e3b4559e$var$Wa(d);
                        $f62453a6e3b4559e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $f62453a6e3b4559e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $f62453a6e3b4559e$var$fb(a, !!c.multiple, b, !1);
    }
};
$f62453a6e3b4559e$var$Gb = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$var$Hb = $f62453a6e3b4559e$var$Rk;
var $f62453a6e3b4559e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $f62453a6e3b4559e$var$Cb,
        $f62453a6e3b4559e$var$ue,
        $f62453a6e3b4559e$var$Db,
        $f62453a6e3b4559e$var$Eb,
        $f62453a6e3b4559e$var$Fb,
        $f62453a6e3b4559e$var$Qk
    ]
}, $f62453a6e3b4559e$var$tl = {
    findFiberByHostInstance: $f62453a6e3b4559e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $f62453a6e3b4559e$var$ul = {
    bundleType: $f62453a6e3b4559e$var$tl.bundleType,
    version: $f62453a6e3b4559e$var$tl.version,
    rendererPackageName: $f62453a6e3b4559e$var$tl.rendererPackageName,
    rendererConfig: $f62453a6e3b4559e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $f62453a6e3b4559e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $f62453a6e3b4559e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $f62453a6e3b4559e$var$tl.findFiberByHostInstance || $f62453a6e3b4559e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f62453a6e3b4559e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f62453a6e3b4559e$var$vl.isDisabled && $f62453a6e3b4559e$var$vl.supportsFiber) try {
        $f62453a6e3b4559e$var$kc = $f62453a6e3b4559e$var$vl.inject($f62453a6e3b4559e$var$ul), $f62453a6e3b4559e$var$lc = $f62453a6e3b4559e$var$vl;
    } catch (a) {}
}
$f62453a6e3b4559e$export$ae55be85d98224ed = $f62453a6e3b4559e$var$sl;
$f62453a6e3b4559e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$f62453a6e3b4559e$var$nl(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$cl(a, b, null, c);
};
$f62453a6e3b4559e$export$882461b6382ed46c = function(a, b) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(299));
    var c = !1, d = "", e = $f62453a6e3b4559e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $f62453a6e3b4559e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $f62453a6e3b4559e$var$ll(b);
};
$f62453a6e3b4559e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($f62453a6e3b4559e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($f62453a6e3b4559e$var$p(268, a));
    }
    a = $f62453a6e3b4559e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$f62453a6e3b4559e$export$cd75ccfd720a3cd4 = function(a) {
    return $f62453a6e3b4559e$var$Rk(a);
};
$f62453a6e3b4559e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !0, c);
};
$f62453a6e3b4559e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$nl(a)) throw Error($f62453a6e3b4559e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $f62453a6e3b4559e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $f62453a6e3b4559e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$f62453a6e3b4559e$var$uf] = b.current;
    $f62453a6e3b4559e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $f62453a6e3b4559e$var$ml(b);
};
$f62453a6e3b4559e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$f62453a6e3b4559e$var$ol(b)) throw Error($f62453a6e3b4559e$var$p(200));
    return $f62453a6e3b4559e$var$rl(null, a, b, !1, c);
};
$f62453a6e3b4559e$export$502457920280e6be = function(a) {
    if (!$f62453a6e3b4559e$var$ol(a)) throw Error($f62453a6e3b4559e$var$p(40));
    return a._reactRootContainer ? ($f62453a6e3b4559e$var$Rk(function() {
        $f62453a6e3b4559e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$f62453a6e3b4559e$var$uf] = null;
        });
    }), !0) : !1;
};
$f62453a6e3b4559e$export$c78a37762a8d58e1 = $f62453a6e3b4559e$var$Qk;
$f62453a6e3b4559e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$f62453a6e3b4559e$var$ol(c)) throw Error($f62453a6e3b4559e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($f62453a6e3b4559e$var$p(38));
    return $f62453a6e3b4559e$var$rl(a, b, c, !1, d);
};
$f62453a6e3b4559e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7zDBh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1uxJf"));

});
parcelRegister("1uxJf", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $1162c1a406d3f6f8$export$c4744153514ff05d, (v) => $1162c1a406d3f6f8$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7, (v) => $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $1162c1a406d3f6f8$export$e26fe2ed2fa76875, (v) => $1162c1a406d3f6f8$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $1162c1a406d3f6f8$export$502329bbf4b505b1, (v) => $1162c1a406d3f6f8$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $1162c1a406d3f6f8$export$6e3807111c4874c4, (v) => $1162c1a406d3f6f8$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $1162c1a406d3f6f8$export$c27134553091fb3a, (v) => $1162c1a406d3f6f8$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2, (v) => $1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $1162c1a406d3f6f8$export$b00a404bbd5edef2, (v) => $1162c1a406d3f6f8$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $1162c1a406d3f6f8$export$8352ce38b91d0c62, (v) => $1162c1a406d3f6f8$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $1162c1a406d3f6f8$export$d66a1c1c77bd778b, (v) => $1162c1a406d3f6f8$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $1162c1a406d3f6f8$export$d3dfb8e4810cb555, (v) => $1162c1a406d3f6f8$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $1162c1a406d3f6f8$export$839f9183b0465a69, (v) => $1162c1a406d3f6f8$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $1162c1a406d3f6f8$export$72fdf0e06517287b, (v) => $1162c1a406d3f6f8$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $1162c1a406d3f6f8$export$4b844e58a3e414b4, (v) => $1162c1a406d3f6f8$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $1162c1a406d3f6f8$export$816d2913ae6b83b1, (v) => $1162c1a406d3f6f8$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $1162c1a406d3f6f8$export$61bcfe829111a1d0, (v) => $1162c1a406d3f6f8$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f, (v) => $1162c1a406d3f6f8$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $1162c1a406d3f6f8$export$b5836b71941fa3ed, (v) => $1162c1a406d3f6f8$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $1162c1a406d3f6f8$export$cf845f2c119da08a, (v) => $1162c1a406d3f6f8$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1162c1a406d3f6f8$export$c4744153514ff05d;
var $1162c1a406d3f6f8$export$3e506c1ccc9cc1a7;
var $1162c1a406d3f6f8$export$e26fe2ed2fa76875;
var $1162c1a406d3f6f8$export$502329bbf4b505b1;
var $1162c1a406d3f6f8$export$6e3807111c4874c4;
var $1162c1a406d3f6f8$export$c27134553091fb3a;
var $1162c1a406d3f6f8$export$33ee1acdc04fd2a2;
var $1162c1a406d3f6f8$export$b00a404bbd5edef2;
var $1162c1a406d3f6f8$export$8352ce38b91d0c62;
var $1162c1a406d3f6f8$export$d66a1c1c77bd778b;
var $1162c1a406d3f6f8$export$d3dfb8e4810cb555;
var $1162c1a406d3f6f8$export$839f9183b0465a69;
var $1162c1a406d3f6f8$export$72fdf0e06517287b;
var $1162c1a406d3f6f8$export$4b844e58a3e414b4;
var $1162c1a406d3f6f8$export$816d2913ae6b83b1;
var $1162c1a406d3f6f8$export$61bcfe829111a1d0;
var $1162c1a406d3f6f8$export$7ee8c9beb337bc3f;
var $1162c1a406d3f6f8$export$b5836b71941fa3ed;
var $1162c1a406d3f6f8$export$cf845f2c119da08a;
'use strict';
function $1162c1a406d3f6f8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1162c1a406d3f6f8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1162c1a406d3f6f8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1162c1a406d3f6f8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1162c1a406d3f6f8$var$g(C, c)) n < e && 0 > $1162c1a406d3f6f8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1162c1a406d3f6f8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1162c1a406d3f6f8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1162c1a406d3f6f8$var$l = performance;
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$l.now();
    };
} else {
    var $1162c1a406d3f6f8$var$p = Date, $1162c1a406d3f6f8$var$q = $1162c1a406d3f6f8$var$p.now();
    $1162c1a406d3f6f8$export$c4744153514ff05d = function() {
        return $1162c1a406d3f6f8$var$p.now() - $1162c1a406d3f6f8$var$q;
    };
}
var $1162c1a406d3f6f8$var$r = [], $1162c1a406d3f6f8$var$t = [], $1162c1a406d3f6f8$var$u = 1, $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = 3, $1162c1a406d3f6f8$var$z = !1, $1162c1a406d3f6f8$var$A = !1, $1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$D = "function" === typeof setTimeout ? setTimeout : null, $1162c1a406d3f6f8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1162c1a406d3f6f8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1162c1a406d3f6f8$var$G(a) {
    for(var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t); null !== b;){
        if (null === b.callback) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t);
        else if (b.startTime <= a) $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$t), b.sortIndex = b.expirationTime, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, b);
        else break;
        b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
    }
}
function $1162c1a406d3f6f8$var$H(a) {
    $1162c1a406d3f6f8$var$B = !1;
    $1162c1a406d3f6f8$var$G(a);
    if (!$1162c1a406d3f6f8$var$A) {
        if (null !== $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r)) $1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J);
        else {
            var b = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== b && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, b.startTime - a);
        }
    }
}
function $1162c1a406d3f6f8$var$J(a, b) {
    $1162c1a406d3f6f8$var$A = !1;
    $1162c1a406d3f6f8$var$B && ($1162c1a406d3f6f8$var$B = !1, $1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1);
    $1162c1a406d3f6f8$var$z = !0;
    var c = $1162c1a406d3f6f8$var$y;
    try {
        $1162c1a406d3f6f8$var$G(b);
        for($1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r); null !== $1162c1a406d3f6f8$var$v && (!($1162c1a406d3f6f8$var$v.expirationTime > b) || a && !$1162c1a406d3f6f8$var$M());){
            var d = $1162c1a406d3f6f8$var$v.callback;
            if ("function" === typeof d) {
                $1162c1a406d3f6f8$var$v.callback = null;
                $1162c1a406d3f6f8$var$y = $1162c1a406d3f6f8$var$v.priorityLevel;
                var e = d($1162c1a406d3f6f8$var$v.expirationTime <= b);
                b = $1162c1a406d3f6f8$export$c4744153514ff05d();
                "function" === typeof e ? $1162c1a406d3f6f8$var$v.callback = e : $1162c1a406d3f6f8$var$v === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
                $1162c1a406d3f6f8$var$G(b);
            } else $1162c1a406d3f6f8$var$k($1162c1a406d3f6f8$var$r);
            $1162c1a406d3f6f8$var$v = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
        }
        if (null !== $1162c1a406d3f6f8$var$v) var w = !0;
        else {
            var m = $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t);
            null !== m && $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1162c1a406d3f6f8$var$v = null, $1162c1a406d3f6f8$var$y = c, $1162c1a406d3f6f8$var$z = !1;
    }
}
var $1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null, $1162c1a406d3f6f8$var$L = -1, $1162c1a406d3f6f8$var$P = 5, $1162c1a406d3f6f8$var$Q = -1;
function $1162c1a406d3f6f8$var$M() {
    return $1162c1a406d3f6f8$export$c4744153514ff05d() - $1162c1a406d3f6f8$var$Q < $1162c1a406d3f6f8$var$P ? !1 : !0;
}
function $1162c1a406d3f6f8$var$R() {
    if (null !== $1162c1a406d3f6f8$var$O) {
        var a = $1162c1a406d3f6f8$export$c4744153514ff05d();
        $1162c1a406d3f6f8$var$Q = a;
        var b = !0;
        try {
            b = $1162c1a406d3f6f8$var$O(!0, a);
        } finally{
            b ? $1162c1a406d3f6f8$var$S() : ($1162c1a406d3f6f8$var$N = !1, $1162c1a406d3f6f8$var$O = null);
        }
    } else $1162c1a406d3f6f8$var$N = !1;
}
var $1162c1a406d3f6f8$var$S;
if ("function" === typeof $1162c1a406d3f6f8$var$F) $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$F($1162c1a406d3f6f8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1162c1a406d3f6f8$var$T = new MessageChannel, $1162c1a406d3f6f8$var$U = $1162c1a406d3f6f8$var$T.port2;
    $1162c1a406d3f6f8$var$T.port1.onmessage = $1162c1a406d3f6f8$var$R;
    $1162c1a406d3f6f8$var$S = function() {
        $1162c1a406d3f6f8$var$U.postMessage(null);
    };
} else $1162c1a406d3f6f8$var$S = function() {
    $1162c1a406d3f6f8$var$D($1162c1a406d3f6f8$var$R, 0);
};
function $1162c1a406d3f6f8$var$I(a) {
    $1162c1a406d3f6f8$var$O = a;
    $1162c1a406d3f6f8$var$N || ($1162c1a406d3f6f8$var$N = !0, $1162c1a406d3f6f8$var$S());
}
function $1162c1a406d3f6f8$var$K(a, b) {
    $1162c1a406d3f6f8$var$L = $1162c1a406d3f6f8$var$D(function() {
        a($1162c1a406d3f6f8$export$c4744153514ff05d());
    }, b);
}
$1162c1a406d3f6f8$export$3e506c1ccc9cc1a7 = 5;
$1162c1a406d3f6f8$export$e26fe2ed2fa76875 = 1;
$1162c1a406d3f6f8$export$502329bbf4b505b1 = 4;
$1162c1a406d3f6f8$export$6e3807111c4874c4 = 3;
$1162c1a406d3f6f8$export$c27134553091fb3a = null;
$1162c1a406d3f6f8$export$33ee1acdc04fd2a2 = 2;
$1162c1a406d3f6f8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1162c1a406d3f6f8$export$8352ce38b91d0c62 = function() {
    $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J));
};
$1162c1a406d3f6f8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1162c1a406d3f6f8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1162c1a406d3f6f8$export$d3dfb8e4810cb555 = function() {
    return $1162c1a406d3f6f8$var$y;
};
$1162c1a406d3f6f8$export$839f9183b0465a69 = function() {
    return $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r);
};
$1162c1a406d3f6f8$export$72fdf0e06517287b = function(a) {
    switch($1162c1a406d3f6f8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1162c1a406d3f6f8$var$y;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = b;
    try {
        return a();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$4b844e58a3e414b4 = function() {};
$1162c1a406d3f6f8$export$816d2913ae6b83b1 = function() {};
$1162c1a406d3f6f8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1162c1a406d3f6f8$var$y;
    $1162c1a406d3f6f8$var$y = a;
    try {
        return b();
    } finally{
        $1162c1a406d3f6f8$var$y = c;
    }
};
$1162c1a406d3f6f8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1162c1a406d3f6f8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1162c1a406d3f6f8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$t, a), null === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$r) && a === $1162c1a406d3f6f8$var$h($1162c1a406d3f6f8$var$t) && ($1162c1a406d3f6f8$var$B ? ($1162c1a406d3f6f8$var$E($1162c1a406d3f6f8$var$L), $1162c1a406d3f6f8$var$L = -1) : $1162c1a406d3f6f8$var$B = !0, $1162c1a406d3f6f8$var$K($1162c1a406d3f6f8$var$H, c - d))) : (a.sortIndex = e, $1162c1a406d3f6f8$var$f($1162c1a406d3f6f8$var$r, a), $1162c1a406d3f6f8$var$A || $1162c1a406d3f6f8$var$z || ($1162c1a406d3f6f8$var$A = !0, $1162c1a406d3f6f8$var$I($1162c1a406d3f6f8$var$J)));
    return a;
};
$1162c1a406d3f6f8$export$b5836b71941fa3ed = $1162c1a406d3f6f8$var$M;
$1162c1a406d3f6f8$export$cf845f2c119da08a = function(a) {
    var b = $1162c1a406d3f6f8$var$y;
    return function() {
        var c = $1162c1a406d3f6f8$var$y;
        $1162c1a406d3f6f8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1162c1a406d3f6f8$var$y = c;
        }
    };
};

});




parcelRegister("28b3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d4e73d0b254ee4$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $hiIj0 = parcelRequire("hiIj0");

var $gL7Ec = parcelRequire("gL7Ec");
var $18d4e73d0b254ee4$var$CheckCircleOutlined = function CheckCircleOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $hiIj0.default)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5OSAzNTNoLTQ2LjljLTEwLjIgMC0xOS45IDQuOS0yNS45IDEzLjNMNDY5IDU4NC4zbC03MS4yLTk4LjhjLTYtOC4zLTE1LjYtMTMuMy0yNS45LTEzLjNIMzI1Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjQuNiAxNzIuOGEzMS44IDMxLjggMCAwMDUxLjcgMGwyMTAuNi0yOTJjMy45LTUuMy4xLTEyLjctNi40LTEyLjd6IiAvPjxwYXRoIGQ9Ik01MTIgNjRDMjY0LjYgNjQgNjQgMjY0LjYgNjQgNTEyczIwMC42IDQ0OCA0NDggNDQ4IDQ0OC0yMDAuNiA0NDgtNDQ4Uzc1OS40IDY0IDUxMiA2NHptMCA4MjBjLTIwNS40IDAtMzcyLTE2Ni42LTM3Mi0zNzJzMTY2LjYtMzcyIDM3Mi0zNzIgMzcyIDE2Ni42IDM3MiAzNzItMTY2LjYgMzcyLTM3MiAzNzJ6IiAvPjwvc3ZnPg==) */ var $18d4e73d0b254ee4$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($18d4e73d0b254ee4$var$CheckCircleOutlined);
var $18d4e73d0b254ee4$export$2e2bcd8739ae039 = $18d4e73d0b254ee4$var$RefIcon;

});
parcelRegister("13KW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7a8efbbb30e1$export$2e2bcd8739ae039);
function $0c5a7a8efbbb30e1$export$2e2bcd8739ae039() {
    return $0c5a7a8efbbb30e1$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0c5a7a8efbbb30e1$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hiIj0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9867c45c20e3cca$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $c9867c45c20e3cca$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
var $c9867c45c20e3cca$export$2e2bcd8739ae039 = $c9867c45c20e3cca$var$CheckCircleOutlined;

});

parcelRegister("gL7Ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $c336f7c20823638d$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $kelIR = parcelRequire("kelIR");

var $br1G4 = parcelRequire("br1G4");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("epPW7");
var $8mnLo = parcelRequire("8mnLo");

var $jOmuk = parcelRequire("jOmuk");

var $2aU1p = parcelRequire("2aU1p");

var $gS5RN = parcelRequire("gS5RN");

var $gDFZV = parcelRequire("gDFZV");
'use client';
var $c336f7c20823638d$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $gS5RN.setTwoToneColor)((0, $8mnLo.blue).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $c336f7c20823638d$var$Icon = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $aX4Fp.default)(props, $c336f7c20823638d$var$_excluded);
    var _React$useContext = $aqdBs.useContext((0, $jOmuk.default)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? 'anticon' : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(rootClassName, prefixCls, (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === 'loading'), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $gDFZV.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $kelIR.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $aqdBs.createElement("span", (0, $13KW1.default)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $aqdBs.createElement((0, $2aU1p.default), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$c336f7c20823638d$var$Icon.displayName = 'AntdIcon';
$c336f7c20823638d$var$Icon.getTwoToneColor = (0, $gS5RN.getTwoToneColor);
$c336f7c20823638d$var$Icon.setTwoToneColor = (0, $gS5RN.setTwoToneColor);
var $c336f7c20823638d$export$2e2bcd8739ae039 = $c336f7c20823638d$var$Icon;

});
parcelRegister("kelIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $eba5f7190e6b3ada$export$2e2bcd8739ae039);

var $741lX = parcelRequire("741lX");

var $81r24 = parcelRequire("81r24");

var $eBUQ0 = parcelRequire("eBUQ0");

var $7w8t2 = parcelRequire("7w8t2");
function $eba5f7190e6b3ada$export$2e2bcd8739ae039(r, e) {
    return (0, $741lX.default)(r) || (0, $81r24.default)(r, e) || (0, $eBUQ0.default)(r, e) || (0, $7w8t2.default)();
}

});
parcelRegister("741lX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5249f4d53a7a32a3$export$2e2bcd8739ae039);
function $5249f4d53a7a32a3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("81r24", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7362c7eeb7f90e$export$2e2bcd8739ae039);
function $5d7362c7eeb7f90e$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("eBUQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa309c2b788f395a$export$2e2bcd8739ae039);

var $fgmJk = parcelRequire("fgmJk");
function $aa309c2b788f395a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fgmJk.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fgmJk.default)(r, a) : void 0;
    }
}

});
parcelRegister("fgmJk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c9fb587462033e$export$2e2bcd8739ae039);
function $b1c9fb587462033e$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("7w8t2", function(module, exports) {

$parcel$export(module.exports, "default", () => $579216fc2949f25e$export$2e2bcd8739ae039);
function $579216fc2949f25e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("br1G4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8533846fb865ff34$export$2e2bcd8739ae039);

var $4ZPfB = parcelRequire("4ZPfB");
function $8533846fb865ff34$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZPfB.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZPfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a349d38689b4999$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $20caE = parcelRequire("20caE");
function $3a349d38689b4999$export$2e2bcd8739ae039(t) {
    var i = (0, $20caE.default)(t, "string");
    return "symbol" == (0, $7IgoF.default)(i) ? i : i + "";
}

});
parcelRegister("7IgoF", function(module, exports) {

$parcel$export(module.exports, "default", () => $59d95c89d706156e$export$2e2bcd8739ae039);
function $59d95c89d706156e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $59d95c89d706156e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $59d95c89d706156e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("20caE", function(module, exports) {

$parcel$export(module.exports, "default", () => $175505b912c4d2fc$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");
function $175505b912c4d2fc$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7IgoF.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7IgoF.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("aX4Fp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9308cd4f54bbe2$export$2e2bcd8739ae039);

var $bcoHM = parcelRequire("bcoHM");
function $7f9308cd4f54bbe2$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $bcoHM.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("bcoHM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8273faa0add5e98d$export$2e2bcd8739ae039);
function $8273faa0add5e98d$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("bqPQ9", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("epPW7", function(module, exports) {
$parcel$export(module.exports, "blue", () => (parcelRequire("8mnLo")).blue);
$parcel$export(module.exports, "gold", () => (parcelRequire("8mnLo")).gold);
$parcel$export(module.exports, "presetPalettes", () => (parcelRequire("8mnLo")).presetPalettes);
$parcel$export(module.exports, "presetPrimaryColors", () => (parcelRequire("8mnLo")).presetPrimaryColors);

$parcel$export(module.exports, "generate", () => (parcelRequire("7oyKr")).default);

var $7oyKr = parcelRequire("7oyKr");
parcelRequire("8mnLo");

});
parcelRegister("7oyKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5625ba8aa38945f9$export$2e2bcd8739ae039);
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
var $5625ba8aa38945f9$var$hueStep = 2; // 色相阶梯
var $5625ba8aa38945f9$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $5625ba8aa38945f9$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $5625ba8aa38945f9$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $5625ba8aa38945f9$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $5625ba8aa38945f9$var$lightColorCount = 5; // 浅色数量，主色上
var $5625ba8aa38945f9$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $5625ba8aa38945f9$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $5625ba8aa38945f9$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $5625ba8aa38945f9$var$hueStep * i : Math.round(hsv.h) + $5625ba8aa38945f9$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $5625ba8aa38945f9$var$hueStep * i : Math.round(hsv.h) - $5625ba8aa38945f9$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $5625ba8aa38945f9$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $5625ba8aa38945f9$var$saturationStep * i;
    else if (i === $5625ba8aa38945f9$var$darkColorCount) saturation = hsv.s + $5625ba8aa38945f9$var$saturationStep;
    else saturation = hsv.s + $5625ba8aa38945f9$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $5625ba8aa38945f9$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $5625ba8aa38945f9$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $5625ba8aa38945f9$var$brightnessStep1 * i;
    else value = hsv.v - $5625ba8aa38945f9$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $5625ba8aa38945f9$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = new (0, $bkcIW.FastColor)(color);
    var hsv = pColor.toHsv();
    for(var i = $5625ba8aa38945f9$var$lightColorCount; i > 0; i -= 1){
        var c = new (0, $bkcIW.FastColor)({
            h: $5625ba8aa38945f9$var$getHue(hsv, i, true),
            s: $5625ba8aa38945f9$var$getSaturation(hsv, i, true),
            v: $5625ba8aa38945f9$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(var _i = 1; _i <= $5625ba8aa38945f9$var$darkColorCount; _i += 1){
        var _c = new (0, $bkcIW.FastColor)({
            h: $5625ba8aa38945f9$var$getHue(hsv, _i),
            s: $5625ba8aa38945f9$var$getSaturation(hsv, _i),
            v: $5625ba8aa38945f9$var$getValue(hsv, _i)
        });
        patterns.push(_c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return $5625ba8aa38945f9$var$darkColorMap.map(function(_ref) {
        var index = _ref.index, amount = _ref.amount;
        return new (0, $bkcIW.FastColor)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString();
    });
    return patterns.map(function(c) {
        return c.toHexString();
    });
}

});
parcelRegister("jtvBX", function(module, exports) {
$parcel$export(module.exports, "FastColor", () => (parcelRequire("bkcIW")).FastColor);
parcelRequire("bkcIW");
parcelRequire("9hQ0L");

});
parcelRegister("bkcIW", function(module, exports) {

$parcel$export(module.exports, "FastColor", () => $83eb6eaaa8bec4e0$export$2c4f38d6c0ecc25a);

var $br1G4 = parcelRequire("br1G4");
const $83eb6eaaa8bec4e0$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $83eb6eaaa8bec4e0$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $83eb6eaaa8bec4e0$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $83eb6eaaa8bec4e0$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $83eb6eaaa8bec4e0$export$2c4f38d6c0ecc25a {
    constructor(input){
        /**
     * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
     */ (0, $br1G4.default)(this, "isValid", true);
        /**
     * Red, R in RGB
     */ (0, $br1G4.default)(this, "r", 0);
        /**
     * Green, G in RGB
     */ (0, $br1G4.default)(this, "g", 0);
        /**
     * Blue, B in RGB
     */ (0, $br1G4.default)(this, "b", 0);
        /**
     * Alpha/Opacity, A in RGBA/HSLA
     */ (0, $br1G4.default)(this, "a", 1);
        // HSV privates
        (0, $br1G4.default)(this, "_h", void 0);
        (0, $br1G4.default)(this, "_s", void 0);
        (0, $br1G4.default)(this, "_l", void 0);
        (0, $br1G4.default)(this, "_v", void 0);
        // intermediate variables to calculate HSL/HSV
        (0, $br1G4.default)(this, "_max", void 0);
        (0, $br1G4.default)(this, "_min", void 0);
        (0, $br1G4.default)(this, "_brightness", void 0);
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
        } else if (input instanceof $83eb6eaaa8bec4e0$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = $83eb6eaaa8bec4e0$var$limitRange(input.r);
            this.g = $83eb6eaaa8bec4e0$var$limitRange(input.g);
            this.b = $83eb6eaaa8bec4e0$var$limitRange(input.b);
            this.a = typeof input.a === 'number' ? $83eb6eaaa8bec4e0$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $83eb6eaaa8bec4e0$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $83eb6eaaa8bec4e0$var$round(calc('r')),
            g: $83eb6eaaa8bec4e0$var$round(calc('g')),
            b: $83eb6eaaa8bec4e0$var$round(calc('b')),
            a: $83eb6eaaa8bec4e0$var$round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $83eb6eaaa8bec4e0$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = $83eb6eaaa8bec4e0$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $83eb6eaaa8bec4e0$var$round(this.getSaturation() * 100);
        const l = $83eb6eaaa8bec4e0$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $83eb6eaaa8bec4e0$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: h, s: s, l: l, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = $83eb6eaaa8bec4e0$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $83eb6eaaa8bec4e0$var$round((r + lightnessModification) * 255);
        this.g = $83eb6eaaa8bec4e0$var$round((g + lightnessModification) * 255);
        this.b = $83eb6eaaa8bec4e0$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: h, s: s, v: v, a: a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = $83eb6eaaa8bec4e0$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $83eb6eaaa8bec4e0$var$round(v * (1.0 - s) * 255);
        const q = $83eb6eaaa8bec4e0$var$round(v * (1.0 - s * ff) * 255);
        const t = $83eb6eaaa8bec4e0$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $83eb6eaaa8bec4e0$var$splitColorStr(trimStr, $83eb6eaaa8bec4e0$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $83eb6eaaa8bec4e0$var$splitColorStr(trimStr, $83eb6eaaa8bec4e0$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $83eb6eaaa8bec4e0$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? $83eb6eaaa8bec4e0$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}

});

parcelRegister("9hQ0L", function(module, exports) {

});



parcelRegister("8mnLo", function(module, exports) {

$parcel$export(module.exports, "presetPrimaryColors", () => $6162cfbcf15bb2aa$export$3968a3afc810b5f5);
$parcel$export(module.exports, "gold", () => $6162cfbcf15bb2aa$export$c24201f7fe3571d8);
$parcel$export(module.exports, "blue", () => $6162cfbcf15bb2aa$export$2aa0182783e7e9de);
$parcel$export(module.exports, "presetPalettes", () => $6162cfbcf15bb2aa$export$36ad6df0f83f284d);
// Generated by script. Do NOT modify!
var $6162cfbcf15bb2aa$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $6162cfbcf15bb2aa$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$6162cfbcf15bb2aa$export$a90204d1394caf30.primary = $6162cfbcf15bb2aa$export$a90204d1394caf30[5];
var $6162cfbcf15bb2aa$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$6162cfbcf15bb2aa$export$e63a1643b2f79b16.primary = $6162cfbcf15bb2aa$export$e63a1643b2f79b16[5];
var $6162cfbcf15bb2aa$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$6162cfbcf15bb2aa$export$ad766f34ace1cafd.primary = $6162cfbcf15bb2aa$export$ad766f34ace1cafd[5];
var $6162cfbcf15bb2aa$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$6162cfbcf15bb2aa$export$c24201f7fe3571d8.primary = $6162cfbcf15bb2aa$export$c24201f7fe3571d8[5];
var $6162cfbcf15bb2aa$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$6162cfbcf15bb2aa$export$594c5a8758200c32.primary = $6162cfbcf15bb2aa$export$594c5a8758200c32[5];
var $6162cfbcf15bb2aa$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$6162cfbcf15bb2aa$export$221d31baf2636aad.primary = $6162cfbcf15bb2aa$export$221d31baf2636aad[5];
var $6162cfbcf15bb2aa$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$6162cfbcf15bb2aa$export$955a2ebd2fb142ae.primary = $6162cfbcf15bb2aa$export$955a2ebd2fb142ae[5];
var $6162cfbcf15bb2aa$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$6162cfbcf15bb2aa$export$7474046f446842ee.primary = $6162cfbcf15bb2aa$export$7474046f446842ee[5];
var $6162cfbcf15bb2aa$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$6162cfbcf15bb2aa$export$2aa0182783e7e9de.primary = $6162cfbcf15bb2aa$export$2aa0182783e7e9de[5];
var $6162cfbcf15bb2aa$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$6162cfbcf15bb2aa$export$4138d3aeddcbf415.primary = $6162cfbcf15bb2aa$export$4138d3aeddcbf415[5];
var $6162cfbcf15bb2aa$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$6162cfbcf15bb2aa$export$e13cce2a2d16a9d4.primary = $6162cfbcf15bb2aa$export$e13cce2a2d16a9d4[5];
var $6162cfbcf15bb2aa$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$6162cfbcf15bb2aa$export$2a9ca2e383622e18.primary = $6162cfbcf15bb2aa$export$2a9ca2e383622e18[5];
var $6162cfbcf15bb2aa$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$6162cfbcf15bb2aa$export$e4c89085febbc618.primary = $6162cfbcf15bb2aa$export$e4c89085febbc618[5];
var $6162cfbcf15bb2aa$export$3e2c219d3ab79d01 = $6162cfbcf15bb2aa$export$e4c89085febbc618;
var $6162cfbcf15bb2aa$export$36ad6df0f83f284d = {
    red: $6162cfbcf15bb2aa$export$a90204d1394caf30,
    volcano: $6162cfbcf15bb2aa$export$e63a1643b2f79b16,
    orange: $6162cfbcf15bb2aa$export$ad766f34ace1cafd,
    gold: $6162cfbcf15bb2aa$export$c24201f7fe3571d8,
    yellow: $6162cfbcf15bb2aa$export$594c5a8758200c32,
    lime: $6162cfbcf15bb2aa$export$221d31baf2636aad,
    green: $6162cfbcf15bb2aa$export$955a2ebd2fb142ae,
    cyan: $6162cfbcf15bb2aa$export$7474046f446842ee,
    blue: $6162cfbcf15bb2aa$export$2aa0182783e7e9de,
    geekblue: $6162cfbcf15bb2aa$export$4138d3aeddcbf415,
    purple: $6162cfbcf15bb2aa$export$e13cce2a2d16a9d4,
    magenta: $6162cfbcf15bb2aa$export$2a9ca2e383622e18,
    grey: $6162cfbcf15bb2aa$export$e4c89085febbc618
};
var $6162cfbcf15bb2aa$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$6162cfbcf15bb2aa$export$e984d34fc144caa1.primary = $6162cfbcf15bb2aa$export$e984d34fc144caa1[5];
var $6162cfbcf15bb2aa$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$6162cfbcf15bb2aa$export$360e10f78e17a865.primary = $6162cfbcf15bb2aa$export$360e10f78e17a865[5];
var $6162cfbcf15bb2aa$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$6162cfbcf15bb2aa$export$d5a12c698b31fa45.primary = $6162cfbcf15bb2aa$export$d5a12c698b31fa45[5];
var $6162cfbcf15bb2aa$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$6162cfbcf15bb2aa$export$2330427fb6a6af6f.primary = $6162cfbcf15bb2aa$export$2330427fb6a6af6f[5];
var $6162cfbcf15bb2aa$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$6162cfbcf15bb2aa$export$67d203119f0ecec.primary = $6162cfbcf15bb2aa$export$67d203119f0ecec[5];
var $6162cfbcf15bb2aa$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$6162cfbcf15bb2aa$export$51ed2a10d86576ed.primary = $6162cfbcf15bb2aa$export$51ed2a10d86576ed[5];
var $6162cfbcf15bb2aa$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$6162cfbcf15bb2aa$export$76a3d804058f9b5f.primary = $6162cfbcf15bb2aa$export$76a3d804058f9b5f[5];
var $6162cfbcf15bb2aa$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$6162cfbcf15bb2aa$export$dee6c7c6683c0d88.primary = $6162cfbcf15bb2aa$export$dee6c7c6683c0d88[5];
var $6162cfbcf15bb2aa$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$6162cfbcf15bb2aa$export$10e0fd027e632624.primary = $6162cfbcf15bb2aa$export$10e0fd027e632624[5];
var $6162cfbcf15bb2aa$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$6162cfbcf15bb2aa$export$abdd57ab473bba66.primary = $6162cfbcf15bb2aa$export$abdd57ab473bba66[5];
var $6162cfbcf15bb2aa$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$6162cfbcf15bb2aa$export$7a65e68792738764.primary = $6162cfbcf15bb2aa$export$7a65e68792738764[5];
var $6162cfbcf15bb2aa$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$6162cfbcf15bb2aa$export$d260a9321db4ab86.primary = $6162cfbcf15bb2aa$export$d260a9321db4ab86[5];
var $6162cfbcf15bb2aa$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$6162cfbcf15bb2aa$export$515283ba400ffa6c.primary = $6162cfbcf15bb2aa$export$515283ba400ffa6c[5];
var $6162cfbcf15bb2aa$export$24617255e4daf647 = {
    red: $6162cfbcf15bb2aa$export$e984d34fc144caa1,
    volcano: $6162cfbcf15bb2aa$export$360e10f78e17a865,
    orange: $6162cfbcf15bb2aa$export$d5a12c698b31fa45,
    gold: $6162cfbcf15bb2aa$export$2330427fb6a6af6f,
    yellow: $6162cfbcf15bb2aa$export$67d203119f0ecec,
    lime: $6162cfbcf15bb2aa$export$51ed2a10d86576ed,
    green: $6162cfbcf15bb2aa$export$76a3d804058f9b5f,
    cyan: $6162cfbcf15bb2aa$export$dee6c7c6683c0d88,
    blue: $6162cfbcf15bb2aa$export$10e0fd027e632624,
    geekblue: $6162cfbcf15bb2aa$export$abdd57ab473bba66,
    purple: $6162cfbcf15bb2aa$export$7a65e68792738764,
    magenta: $6162cfbcf15bb2aa$export$d260a9321db4ab86,
    grey: $6162cfbcf15bb2aa$export$515283ba400ffa6c
};

});


parcelRegister("jOmuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6c42188665902d5$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $e6c42188665902d5$var$IconContext = /*#__PURE__*/ (0, $aqdBs.createContext)({});
var $e6c42188665902d5$export$2e2bcd8739ae039 = $e6c42188665902d5$var$IconContext;

});

parcelRegister("2aU1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $1957f8b439b9e8fa$export$2e2bcd8739ae039);

var $aX4Fp = parcelRequire("aX4Fp");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");

var $gDFZV = parcelRequire("gDFZV");
var $1957f8b439b9e8fa$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $1957f8b439b9e8fa$var$twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function $1957f8b439b9e8fa$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $1957f8b439b9e8fa$var$twoToneColorPalette.primaryColor = primaryColor;
    $1957f8b439b9e8fa$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $gDFZV.getSecondaryColor)(primaryColor);
    $1957f8b439b9e8fa$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $1957f8b439b9e8fa$var$getTwoToneColors() {
    return (0, $4f2X8.default)({}, $1957f8b439b9e8fa$var$twoToneColorPalette);
}
var $1957f8b439b9e8fa$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $aX4Fp.default)(props, $1957f8b439b9e8fa$var$_excluded);
    var svgRef = $aqdBs.useRef();
    var colors = $1957f8b439b9e8fa$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $gDFZV.getSecondaryColor)(primaryColor)
    };
    (0, $gDFZV.useInsertStyles)(svgRef);
    (0, $gDFZV.warning)((0, $gDFZV.isIconDefinition)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $gDFZV.isIconDefinition)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === 'function') target = (0, $4f2X8.default)((0, $4f2X8.default)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $gDFZV.generate)(target.icon, "svg-".concat(target.name), (0, $4f2X8.default)((0, $4f2X8.default)({
        className: className,
        onClick: onClick,
        style: style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true'
    }, restProps), {}, {
        ref: svgRef
    }));
};
$1957f8b439b9e8fa$var$IconBase.displayName = 'IconReact';
$1957f8b439b9e8fa$var$IconBase.getTwoToneColors = $1957f8b439b9e8fa$var$getTwoToneColors;
$1957f8b439b9e8fa$var$IconBase.setTwoToneColors = $1957f8b439b9e8fa$var$setTwoToneColors;
var $1957f8b439b9e8fa$export$2e2bcd8739ae039 = $1957f8b439b9e8fa$var$IconBase;

});
parcelRegister("4f2X8", function(module, exports) {

$parcel$export(module.exports, "default", () => $316ada816e730279$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");
function $316ada816e730279$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $316ada816e730279$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $316ada816e730279$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $br1G4.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $316ada816e730279$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("gDFZV", function(module, exports) {

$parcel$export(module.exports, "warning", () => $c1d0ddc0869b4c55$export$491112666e282270);
$parcel$export(module.exports, "isIconDefinition", () => $c1d0ddc0869b4c55$export$ab652842c37578f4);
$parcel$export(module.exports, "generate", () => $c1d0ddc0869b4c55$export$80d376111cc09ad7);
$parcel$export(module.exports, "getSecondaryColor", () => $c1d0ddc0869b4c55$export$b71c93f469694483);
$parcel$export(module.exports, "normalizeTwoToneColors", () => $c1d0ddc0869b4c55$export$b5b464c3d8433a9b);
$parcel$export(module.exports, "useInsertStyles", () => $c1d0ddc0869b4c55$export$938b1f86b61613d0);

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");
parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");

var $98AgF = parcelRequire("98AgF");

var $f1XSo = parcelRequire("f1XSo");

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $jOmuk = parcelRequire("jOmuk");
function $c1d0ddc0869b4c55$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $c1d0ddc0869b4c55$export$491112666e282270(valid, message) {
    (0, $i7X5i.default)(valid, "[@ant-design/icons] ".concat(message));
}
function $c1d0ddc0869b4c55$export$ab652842c37578f4(target) {
    return (0, $7IgoF.default)(target) === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && ((0, $7IgoF.default)(target.icon) === 'object' || typeof target.icon === 'function');
}
function $c1d0ddc0869b4c55$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$c1d0ddc0869b4c55$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $c1d0ddc0869b4c55$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(node.tag, (0, $4f2X8.default)({
        key: key
    }, $c1d0ddc0869b4c55$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $c1d0ddc0869b4c55$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(node.tag, (0, $4f2X8.default)((0, $4f2X8.default)({
        key: key
    }, $c1d0ddc0869b4c55$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $c1d0ddc0869b4c55$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $c1d0ddc0869b4c55$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $7oyKr.default)(primaryColor)[0];
}
function $c1d0ddc0869b4c55$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $c1d0ddc0869b4c55$export$960a899a9cccb2d5 = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
var $c1d0ddc0869b4c55$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $c1d0ddc0869b4c55$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $aqdBs.useContext)((0, $jOmuk.default)), csp = _useContext.csp, prefixCls = _useContext.prefixCls, layer = _useContext.layer;
    var mergedStyleStr = $c1d0ddc0869b4c55$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = "@layer ".concat(layer, " {\n").concat(mergedStyleStr, "\n}");
    (0, $aqdBs.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $f1XSo.getShadowRoot)(ele);
        (0, $98AgF.updateCSS)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};

});
parcelRegister("98AgF", function(module, exports) {

$parcel$export(module.exports, "removeCSS", () => $6a70fe6d6ca51c76$export$2232e336aecaa80a);
$parcel$export(module.exports, "updateCSS", () => $6a70fe6d6ca51c76$export$4d99a2890bb989f0);

var $4f2X8 = parcelRequire("4f2X8");

var $8Vh6n = parcelRequire("8Vh6n");

var $i3X5I = parcelRequire("i3X5I");
var $6a70fe6d6ca51c76$var$APPEND_ORDER = 'data-rc-order';
var $6a70fe6d6ca51c76$var$APPEND_PRIORITY = 'data-rc-priority';
var $6a70fe6d6ca51c76$var$MARK_KEY = "rc-util-key";
var $6a70fe6d6ca51c76$var$containerCache = new Map();
function $6a70fe6d6ca51c76$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith('data-') ? mark : "data-".concat(mark);
    return $6a70fe6d6ca51c76$var$MARK_KEY;
}
function $6a70fe6d6ca51c76$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector('head');
    return head || document.body;
}
function $6a70fe6d6ca51c76$var$getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function $6a70fe6d6ca51c76$var$findStyles(container) {
    return Array.from(($6a70fe6d6ca51c76$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === 'STYLE';
    });
}
function $6a70fe6d6ca51c76$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $8Vh6n.default)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $6a70fe6d6ca51c76$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === 'prependQueue';
    var styleNode = document.createElement('style');
    styleNode.setAttribute($6a70fe6d6ca51c76$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($6a70fe6d6ca51c76$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $6a70fe6d6ca51c76$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $6a70fe6d6ca51c76$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute($6a70fe6d6ca51c76$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($6a70fe6d6ca51c76$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $6a70fe6d6ca51c76$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $6a70fe6d6ca51c76$var$getContainer(option);
    return (option.styles || $6a70fe6d6ca51c76$var$findStyles(container)).find(function(node) {
        return node.getAttribute($6a70fe6d6ca51c76$var$getMark(option)) === key;
    });
}
function $6a70fe6d6ca51c76$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $6a70fe6d6ca51c76$var$findExistNode(key, option);
    if (existNode) {
        var container = $6a70fe6d6ca51c76$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $6a70fe6d6ca51c76$var$syncRealContainer(container, option) {
    var cachedRealContainer = $6a70fe6d6ca51c76$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $i3X5I.default)(document, cachedRealContainer)) {
        var placeholderStyle = $6a70fe6d6ca51c76$export$1ab5838465dbd10a('', option);
        var parentNode = placeholderStyle.parentNode;
        $6a70fe6d6ca51c76$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $6a70fe6d6ca51c76$export$f80df667f2f5a272() {
    $6a70fe6d6ca51c76$var$containerCache.clear();
}
function $6a70fe6d6ca51c76$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $6a70fe6d6ca51c76$var$getContainer(originOption);
    var styles = $6a70fe6d6ca51c76$var$findStyles(container);
    var option = (0, $4f2X8.default)((0, $4f2X8.default)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $6a70fe6d6ca51c76$var$syncRealContainer(container, option);
    var existNode = $6a70fe6d6ca51c76$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $6a70fe6d6ca51c76$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($6a70fe6d6ca51c76$var$getMark(option), key);
    return newNode;
}

});
parcelRegister("8Vh6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f0e9adda5dfd4a$export$2e2bcd8739ae039);
function $67f0e9adda5dfd4a$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

});

parcelRegister("i3X5I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d26658131c4fe65e$export$2e2bcd8739ae039);
function $d26658131c4fe65e$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

});


parcelRegister("f1XSo", function(module, exports) {

$parcel$export(module.exports, "getShadowRoot", () => $af1565320bfafe96$export$70e8259662bb498b);
function $af1565320bfafe96$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $af1565320bfafe96$export$cca82218ea4431a(ele) {
    return $af1565320bfafe96$var$getRoot(ele) instanceof ShadowRoot;
}
function $af1565320bfafe96$export$70e8259662bb498b(ele) {
    return $af1565320bfafe96$export$cca82218ea4431a(ele) ? $af1565320bfafe96$var$getRoot(ele) : null;
}

});

parcelRegister("i7X5i", function(module, exports) {

$parcel$export(module.exports, "warning", () => $d326b666b39c12ce$export$491112666e282270);
$parcel$export(module.exports, "resetWarned", () => $d326b666b39c12ce$export$60eef1277fe463e4);
$parcel$export(module.exports, "noteOnce", () => $d326b666b39c12ce$export$89ff31684837bbbf);
$parcel$export(module.exports, "default", () => $d326b666b39c12ce$export$2e2bcd8739ae039);
/* eslint-disable no-console */ var $d326b666b39c12ce$var$warned = {};
var $d326b666b39c12ce$var$preWarningFns = [];
var $d326b666b39c12ce$export$61616f168f0e5a05 = function preMessage(fn) {
    $d326b666b39c12ce$var$preWarningFns.push(fn);
};
function $d326b666b39c12ce$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $d326b666b39c12ce$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $d326b666b39c12ce$export$60eef1277fe463e4() {
    $d326b666b39c12ce$var$warned = {};
}
function $d326b666b39c12ce$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$d326b666b39c12ce$var$warned[message]) {
        method(false, message);
        $d326b666b39c12ce$var$warned[message] = true;
    }
}
function $d326b666b39c12ce$export$82934adf09101657(valid, message) {
    $d326b666b39c12ce$export$848feb93d8f32b9b($d326b666b39c12ce$export$491112666e282270, valid, message);
}
function $d326b666b39c12ce$export$89ff31684837bbbf(valid, message) {
    $d326b666b39c12ce$export$848feb93d8f32b9b($d326b666b39c12ce$export$a92e4c44d367d0af, valid, message);
}
$d326b666b39c12ce$export$82934adf09101657.preMessage = $d326b666b39c12ce$export$61616f168f0e5a05;
$d326b666b39c12ce$export$82934adf09101657.resetWarned = $d326b666b39c12ce$export$60eef1277fe463e4;
$d326b666b39c12ce$export$82934adf09101657.noteOnce = $d326b666b39c12ce$export$89ff31684837bbbf;
var $d326b666b39c12ce$export$2e2bcd8739ae039 = $d326b666b39c12ce$export$82934adf09101657;

});



parcelRegister("gS5RN", function(module, exports) {

$parcel$export(module.exports, "setTwoToneColor", () => $c4863d7df36379ea$export$8a145f34580ff02b);
$parcel$export(module.exports, "getTwoToneColor", () => $c4863d7df36379ea$export$abc7c554784cb4a7);

var $kelIR = parcelRequire("kelIR");

var $2aU1p = parcelRequire("2aU1p");

var $gDFZV = parcelRequire("gDFZV");
function $c4863d7df36379ea$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $gDFZV.normalizeTwoToneColors)(twoToneColor), _normalizeTwoToneColo2 = (0, $kelIR.default)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $2aU1p.default).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $c4863d7df36379ea$export$abc7c554784cb4a7() {
    var colors = (0, $2aU1p.default).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

});



parcelRegister("gtz9i", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfea9e9e2b12d7a9$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $63J19 = parcelRequire("63J19");

var $gL7Ec = parcelRequire("gL7Ec");
var $bfea9e9e2b12d7a9$var$ExclamationOutlined = function ExclamationOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $63J19.default)
    }));
};
/**![exclamation](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ0OCA4MDRhNjQgNjQgMCAxMDEyOCAwIDY0IDY0IDAgMTAtMTI4IDB6bTMyLTE2OGg2NGM0LjQgMCA4LTMuNiA4LThWMTY0YzAtNC40LTMuNi04LTgtOGgtNjRjLTQuNCAwLTggMy42LTggOHY0NjRjMCA0LjQgMy42IDggOCA4eiIgLz48L3N2Zz4=) */ var $bfea9e9e2b12d7a9$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($bfea9e9e2b12d7a9$var$ExclamationOutlined);
var $bfea9e9e2b12d7a9$export$2e2bcd8739ae039 = $bfea9e9e2b12d7a9$var$RefIcon;

});
parcelRegister("63J19", function(module, exports) {

$parcel$export(module.exports, "default", () => $4695f1728964f4c9$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $4695f1728964f4c9$var$ExclamationOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M448 804a64 64 0 10128 0 64 64 0 10-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation",
    "theme": "outlined"
};
var $4695f1728964f4c9$export$2e2bcd8739ae039 = $4695f1728964f4c9$var$ExclamationOutlined;

});


parcelRegister("5BZxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41602561df97ca9b$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $3bxkm = parcelRequire("3bxkm");

var $gL7Ec = parcelRequire("gL7Ec");
var $41602561df97ca9b$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $3bxkm.default)
    }));
};
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ var $41602561df97ca9b$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($41602561df97ca9b$var$LoadingOutlined);
var $41602561df97ca9b$export$2e2bcd8739ae039 = $41602561df97ca9b$var$RefIcon;

});
parcelRegister("3bxkm", function(module, exports) {

$parcel$export(module.exports, "default", () => $251c4049929a9a92$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $251c4049929a9a92$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $251c4049929a9a92$export$2e2bcd8739ae039 = $251c4049929a9a92$var$LoadingOutlined;

});


parcelRegister("71P5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e0407f62d706b2$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $a6PfL = parcelRequire("a6PfL");

var $gL7Ec = parcelRequire("gL7Ec");
var $51e0407f62d706b2$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $a6PfL.default)
    }));
};
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ var $51e0407f62d706b2$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($51e0407f62d706b2$var$PlusOutlined);
var $51e0407f62d706b2$export$2e2bcd8739ae039 = $51e0407f62d706b2$var$RefIcon;

});
parcelRegister("a6PfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $75c238bb41dead94$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $75c238bb41dead94$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $75c238bb41dead94$export$2e2bcd8739ae039 = $75c238bb41dead94$var$PlusOutlined;

});


parcelRegister("ffbQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19172905155f631$export$2e2bcd8739ae039);

var $9kz5l = parcelRequire("9kz5l");

"use client";
var $b19172905155f631$export$2e2bcd8739ae039 = (0, $9kz5l.default);

});
parcelRegister("9kz5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb1327b4bf682a3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");

var $kBwE8 = parcelRequire("kBwE8");


var $9lFfv = parcelRequire("9lFfv");

var $kjlvF = parcelRequire("kjlvF");

var $bpKJo = parcelRequire("bpKJo");

var $3m1Z3 = parcelRequire("3m1Z3");

var $O3SCq = parcelRequire("O3SCq");

var $jZLp3 = parcelRequire("jZLp3");

var $1TaA8 = parcelRequire("1TaA8");

var $3Apmx = parcelRequire("3Apmx");

var $apxIS = parcelRequire("apxIS");

var $hd4WI = parcelRequire("hd4WI");

var $l2MUR = parcelRequire("l2MUR");
"use client";
var $6cb1327b4bf682a3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6cb1327b4bf682a3$var$getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $6cb1327b4bf682a3$var$ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const $6cb1327b4bf682a3$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef((props, ref)=>{
    var _a, _b;
    const { loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: shape = 'default', size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition = 'start', ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames: customClassNames, style: customStyle = {}, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus } = props, rest = $6cb1327b4bf682a3$var$__rest(props, [
        "loading",
        "prefixCls",
        "color",
        "variant",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "iconPosition",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style",
        "autoInsertSpace",
        "autoFocus"
    ]);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button: button } = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $kjlvF.ConfigContext));
    const [mergedColor, mergedVariant] = (0, $aqdBs.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $6cb1327b4bf682a3$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if ((button === null || button === void 0 ? void 0 : button.color) && (button === null || button === void 0 ? void 0 : button.variant)) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        type,
        color,
        variant,
        danger,
        button === null || button === void 0 ? void 0 : button.variant,
        button === null || button === void 0 ? void 0 : button.color
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $kjlvF.useComponentConfig)('button');
    const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : contextAutoInsertSpace) !== null && _a !== void 0 ? _a : true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $hd4WI.default)(prefixCls);
    const disabled = (0, $aqdBs.useContext)((0, $bpKJo.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $aqdBs.useContext)((0, $jZLp3.GroupSizeContext));
    const loadingOrDelay = (0, $aqdBs.useMemo)(()=>$6cb1327b4bf682a3$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $aqdBs.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $aqdBs.useState)(false);
    const buttonRef = (0, $aqdBs.useRef)(null);
    const mergedRef = (0, $kBwE8.useComposeRef)(ref, buttonRef);
    const needInserted = (0, $aqdBs.Children).count(children) === 1 && !icon && !(0, $1TaA8.isUnBorderedButtonVariant)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $aqdBs.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $aqdBs.useLayoutEffect)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $aqdBs.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, $1TaA8.isTwoCNChar)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, $aqdBs.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useCallback((e)=>{
        var _a;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        (_a = props.onClick) === null || _a === void 0 || _a.call(props, 'href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $O3SCq.useCompactItemContext)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, $3m1Z3.default)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? (_b = sizeClassNameMap[sizeFullName]) !== null && _b !== void 0 ? _b : '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const linkButtonRestProps = (0, $1iwLi.default)(rest, [
        'navigate'
    ]);
    // ========================= Render =========================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $1TaA8.isUnBorderedButtonVariant)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: iconPosition === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName);
    const fullStyle = Object.assign(Object.assign({}, contextStyle), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, contextClassNames.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), contextStyles.icon || {});
    const iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $apxIS.default), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : loading && typeof loading === 'object' && loading.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $apxIS.default), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, loading.icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $3Apmx.default), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current
    });
    const kids = children || children === 0 ? (0, $1TaA8.spaceChildren)(children, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }), iconNode, kids, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $l2MUR.default), {
        prefixCls: prefixCls
    }));
    if (!(0, $1TaA8.isUnBorderedButtonVariant)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9lFfv.default), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
});
const $6cb1327b4bf682a3$var$Button = $6cb1327b4bf682a3$var$InternalCompoundedButton;
$6cb1327b4bf682a3$var$Button.Group = (0, $jZLp3.default);
$6cb1327b4bf682a3$var$Button.__ANT_BUTTON = true;
var $6cb1327b4bf682a3$export$2e2bcd8739ae039 = $6cb1327b4bf682a3$var$Button;

});
parcelRegister("1iwLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f20e2b5a4b6a717$export$2e2bcd8739ae039);
function $0f20e2b5a4b6a717$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}

});

parcelRegister("kBwE8", function(module, exports) {

$parcel$export(module.exports, "fillRef", () => $f00096373667dbb1$export$f17fd18fa51dcb5b);
$parcel$export(module.exports, "composeRef", () => $f00096373667dbb1$export$ab452c34e8e05029);
$parcel$export(module.exports, "useComposeRef", () => $f00096373667dbb1$export$1d1c999670a1285d);
$parcel$export(module.exports, "supportRef", () => $f00096373667dbb1$export$c1cec34af06bcf7);
$parcel$export(module.exports, "supportNodeRef", () => $f00096373667dbb1$export$b51ae67c7882a242);
$parcel$export(module.exports, "getNodeRef", () => $f00096373667dbb1$export$7465e5c0bf44f19a);

var $7IgoF = parcelRequire("7IgoF");

var $aqdBs = parcelRequire("aqdBs");

var $e4gx5 = parcelRequire("e4gx5");

var $9nP3o = parcelRequire("9nP3o");

var $2JmHQ = parcelRequire("2JmHQ");
var $f00096373667dbb1$var$ReactMajorVersion = Number((0, $aqdBs.version).split('.')[0]);
var $f00096373667dbb1$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $7IgoF.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $f00096373667dbb1$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $f00096373667dbb1$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $f00096373667dbb1$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $9nP3o.default)(function() {
        return $f00096373667dbb1$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $f00096373667dbb1$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($f00096373667dbb1$var$isReactElement(nodeOrComponent) && $f00096373667dbb1$var$ReactMajorVersion >= 19) return true;
    var type = (0, $e4gx5.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $e4gx5.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $e4gx5.ForwardRef)) return false;
    return true;
};
function $f00096373667dbb1$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $aqdBs.isValidElement)(node) && !(0, $2JmHQ.default)(node);
}
var $f00096373667dbb1$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $f00096373667dbb1$var$isReactElement(node) && $f00096373667dbb1$export$c1cec34af06bcf7(node);
};
var $f00096373667dbb1$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $f00096373667dbb1$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

});
parcelRegister("e4gx5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("f00Nn"));

});
parcelRegister("f00Nn", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aeb779073e6ae545$export$a7c73072b1a182ae, (v) => $aeb779073e6ae545$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aeb779073e6ae545$export$9f27bc3417b4524d, (v) => $aeb779073e6ae545$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aeb779073e6ae545$export$db77ccec0bb4ccac, (v) => $aeb779073e6ae545$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aeb779073e6ae545$export$8392c0c9d3dcbd35, (v) => $aeb779073e6ae545$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aeb779073e6ae545$export$ffb0004e005737fa, (v) => $aeb779073e6ae545$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aeb779073e6ae545$export$b624eff549462981, (v) => $aeb779073e6ae545$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aeb779073e6ae545$export$7897aa7841a5380c, (v) => $aeb779073e6ae545$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aeb779073e6ae545$export$602eac185826482c, (v) => $aeb779073e6ae545$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aeb779073e6ae545$export$e2c29f18771995cb, (v) => $aeb779073e6ae545$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aeb779073e6ae545$export$5f8d39834fd61797, (v) => $aeb779073e6ae545$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aeb779073e6ae545$export$74bf444e3cd11ea5, (v) => $aeb779073e6ae545$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aeb779073e6ae545$export$998bcd577473dd93, (v) => $aeb779073e6ae545$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aeb779073e6ae545$export$92387174baf9b227, (v) => $aeb779073e6ae545$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aeb779073e6ae545$export$ec112efeb987d9c6, (v) => $aeb779073e6ae545$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aeb779073e6ae545$export$b706b080d889d2c9, (v) => $aeb779073e6ae545$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aeb779073e6ae545$export$5be5a87408f70ddc, (v) => $aeb779073e6ae545$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aeb779073e6ae545$export$45a5e7f76e0caa8d, (v) => $aeb779073e6ae545$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aeb779073e6ae545$export$455c2e768291efa6, (v) => $aeb779073e6ae545$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aeb779073e6ae545$export$9522e17588c12572, (v) => $aeb779073e6ae545$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aeb779073e6ae545$export$2110ac352bb060b9, (v) => $aeb779073e6ae545$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aeb779073e6ae545$export$56885ab8b9c456ab, (v) => $aeb779073e6ae545$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aeb779073e6ae545$export$d927fcb6adf8f9de, (v) => $aeb779073e6ae545$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aeb779073e6ae545$export$b82d16f27459e05a, (v) => $aeb779073e6ae545$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aeb779073e6ae545$export$522c17b4f5e123e8, (v) => $aeb779073e6ae545$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aeb779073e6ae545$export$1aabd8a0274ecfd6, (v) => $aeb779073e6ae545$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aeb779073e6ae545$export$3d6c20d97e46b957, (v) => $aeb779073e6ae545$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aeb779073e6ae545$export$9b621391a187a31a, (v) => $aeb779073e6ae545$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aeb779073e6ae545$export$f5bbd400c2f4426f, (v) => $aeb779073e6ae545$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aeb779073e6ae545$export$a7c73072b1a182ae;
var $aeb779073e6ae545$export$9f27bc3417b4524d;
var $aeb779073e6ae545$export$db77ccec0bb4ccac;
var $aeb779073e6ae545$export$8392c0c9d3dcbd35;
var $aeb779073e6ae545$export$ffb0004e005737fa;
var $aeb779073e6ae545$export$b624eff549462981;
var $aeb779073e6ae545$export$7897aa7841a5380c;
var $aeb779073e6ae545$export$602eac185826482c;
var $aeb779073e6ae545$export$e2c29f18771995cb;
var $aeb779073e6ae545$export$5f8d39834fd61797;
var $aeb779073e6ae545$export$74bf444e3cd11ea5;
var $aeb779073e6ae545$export$998bcd577473dd93;
var $aeb779073e6ae545$export$92387174baf9b227;
var $aeb779073e6ae545$export$ec112efeb987d9c6;
var $aeb779073e6ae545$export$b706b080d889d2c9;
var $aeb779073e6ae545$export$5be5a87408f70ddc;
var $aeb779073e6ae545$export$45a5e7f76e0caa8d;
var $aeb779073e6ae545$export$455c2e768291efa6;
var $aeb779073e6ae545$export$9522e17588c12572;
var $aeb779073e6ae545$export$2110ac352bb060b9;
var $aeb779073e6ae545$export$56885ab8b9c456ab;
var $aeb779073e6ae545$export$d927fcb6adf8f9de;
var $aeb779073e6ae545$export$b82d16f27459e05a;
var $aeb779073e6ae545$export$522c17b4f5e123e8;
var $aeb779073e6ae545$export$1aabd8a0274ecfd6;
var $aeb779073e6ae545$export$3d6c20d97e46b957;
var $aeb779073e6ae545$export$9b621391a187a31a;
var $aeb779073e6ae545$export$f5bbd400c2f4426f;
'use strict';
var $aeb779073e6ae545$var$b = Symbol.for("react.element"), $aeb779073e6ae545$var$c = Symbol.for("react.portal"), $aeb779073e6ae545$var$d = Symbol.for("react.fragment"), $aeb779073e6ae545$var$e = Symbol.for("react.strict_mode"), $aeb779073e6ae545$var$f = Symbol.for("react.profiler"), $aeb779073e6ae545$var$g = Symbol.for("react.provider"), $aeb779073e6ae545$var$h = Symbol.for("react.context"), $aeb779073e6ae545$var$k = Symbol.for("react.server_context"), $aeb779073e6ae545$var$l = Symbol.for("react.forward_ref"), $aeb779073e6ae545$var$m = Symbol.for("react.suspense"), $aeb779073e6ae545$var$n = Symbol.for("react.suspense_list"), $aeb779073e6ae545$var$p = Symbol.for("react.memo"), $aeb779073e6ae545$var$q = Symbol.for("react.lazy"), $aeb779073e6ae545$var$t = Symbol.for("react.offscreen"), $aeb779073e6ae545$var$u;
$aeb779073e6ae545$var$u = Symbol.for("react.module.reference");
function $aeb779073e6ae545$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aeb779073e6ae545$var$b:
                switch(a = a.type, a){
                    case $aeb779073e6ae545$var$d:
                    case $aeb779073e6ae545$var$f:
                    case $aeb779073e6ae545$var$e:
                    case $aeb779073e6ae545$var$m:
                    case $aeb779073e6ae545$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aeb779073e6ae545$var$k:
                            case $aeb779073e6ae545$var$h:
                            case $aeb779073e6ae545$var$l:
                            case $aeb779073e6ae545$var$q:
                            case $aeb779073e6ae545$var$p:
                            case $aeb779073e6ae545$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aeb779073e6ae545$var$c:
                return r;
        }
    }
}
$aeb779073e6ae545$export$a7c73072b1a182ae = $aeb779073e6ae545$var$h;
$aeb779073e6ae545$export$9f27bc3417b4524d = $aeb779073e6ae545$var$g;
$aeb779073e6ae545$export$db77ccec0bb4ccac = $aeb779073e6ae545$var$b;
$aeb779073e6ae545$export$8392c0c9d3dcbd35 = $aeb779073e6ae545$var$l;
$aeb779073e6ae545$export$ffb0004e005737fa = $aeb779073e6ae545$var$d;
$aeb779073e6ae545$export$b624eff549462981 = $aeb779073e6ae545$var$q;
$aeb779073e6ae545$export$7897aa7841a5380c = $aeb779073e6ae545$var$p;
$aeb779073e6ae545$export$602eac185826482c = $aeb779073e6ae545$var$c;
$aeb779073e6ae545$export$e2c29f18771995cb = $aeb779073e6ae545$var$f;
$aeb779073e6ae545$export$5f8d39834fd61797 = $aeb779073e6ae545$var$e;
$aeb779073e6ae545$export$74bf444e3cd11ea5 = $aeb779073e6ae545$var$m;
$aeb779073e6ae545$export$998bcd577473dd93 = $aeb779073e6ae545$var$n;
$aeb779073e6ae545$export$92387174baf9b227 = function() {
    return !1;
};
$aeb779073e6ae545$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aeb779073e6ae545$export$b706b080d889d2c9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$h;
};
$aeb779073e6ae545$export$5be5a87408f70ddc = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$g;
};
$aeb779073e6ae545$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aeb779073e6ae545$var$b;
};
$aeb779073e6ae545$export$455c2e768291efa6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$l;
};
$aeb779073e6ae545$export$9522e17588c12572 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$d;
};
$aeb779073e6ae545$export$2110ac352bb060b9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$q;
};
$aeb779073e6ae545$export$56885ab8b9c456ab = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$p;
};
$aeb779073e6ae545$export$d927fcb6adf8f9de = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$c;
};
$aeb779073e6ae545$export$b82d16f27459e05a = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$f;
};
$aeb779073e6ae545$export$522c17b4f5e123e8 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$e;
};
$aeb779073e6ae545$export$1aabd8a0274ecfd6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$m;
};
$aeb779073e6ae545$export$3d6c20d97e46b957 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$n;
};
$aeb779073e6ae545$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aeb779073e6ae545$var$d || a === $aeb779073e6ae545$var$f || a === $aeb779073e6ae545$var$e || a === $aeb779073e6ae545$var$m || a === $aeb779073e6ae545$var$n || a === $aeb779073e6ae545$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aeb779073e6ae545$var$q || a.$$typeof === $aeb779073e6ae545$var$p || a.$$typeof === $aeb779073e6ae545$var$g || a.$$typeof === $aeb779073e6ae545$var$h || a.$$typeof === $aeb779073e6ae545$var$l || a.$$typeof === $aeb779073e6ae545$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aeb779073e6ae545$export$f5bbd400c2f4426f = $aeb779073e6ae545$var$v;

});


parcelRegister("9nP3o", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4ddd41af4b16b6$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $6d4ddd41af4b16b6$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $aqdBs.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

});

parcelRegister("2JmHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd165b0bbda3540$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");
var $1fd165b0bbda3540$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $1fd165b0bbda3540$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $1fd165b0bbda3540$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $1fd165b0bbda3540$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $7IgoF.default)(object) === 'object' && // React Element type
    (object.$$typeof === $1fd165b0bbda3540$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $1fd165b0bbda3540$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $1fd165b0bbda3540$var$REACT_FRAGMENT_TYPE);
}

});


parcelRegister("9lFfv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce61268f48142e5$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $djRIe = parcelRequire("djRIe");

var $kBwE8 = parcelRequire("kBwE8");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $iOHOh = parcelRequire("iOHOh");

var $eCcq8 = parcelRequire("eCcq8");

var $fNzK2 = parcelRequire("fNzK2");
const $6ce61268f48142e5$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
    const containerRef = (0, $aqdBs.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const [, hashId] = (0, $eCcq8.default)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $fNzK2.default)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $djRIe.default)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $kBwE8.supportRef)(children) ? (0, $kBwE8.composeRef)((0, $kBwE8.getNodeRef)(children), containerRef) : containerRef;
    return (0, $iOHOh.cloneElement)(children, {
        ref: ref
    });
};
var $6ce61268f48142e5$export$2e2bcd8739ae039 = $6ce61268f48142e5$var$Wave;

});
parcelRegister("djRIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b26b6e3ca8a8b55$export$2e2bcd8739ae039);
var $9b26b6e3ca8a8b55$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};

});

parcelRegister("ky6DR", function(module, exports) {

$parcel$export(module.exports, "globalConfig", () => $ef5c228e1913d0f0$export$f9cd1e43211d8a4a);
$parcel$export(module.exports, "default", () => $ef5c228e1913d0f0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ConfigContext", () => (parcelRequire("kjlvF")).ConfigContext);
$parcel$export(module.exports, "defaultPrefixCls", () => (parcelRequire("kjlvF")).defaultPrefixCls);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("g14b3");
var $4wnj3 = parcelRequire("4wnj3");
var $6M602 = parcelRequire("6M602");

var $jOmuk = parcelRequire("jOmuk");

var $9nP3o = parcelRequire("9nP3o");

var $acNyW = parcelRequire("acNyW");

var $dkjPS = parcelRequire("dkjPS");

var $79Tx6 = parcelRequire("79Tx6");

var $3zIQU = parcelRequire("3zIQU");

var $eJWTa = parcelRequire("eJWTa");

var $iPGr2 = parcelRequire("iPGr2");

var $dWyN5 = parcelRequire("dWyN5");
var $j22ew = parcelRequire("j22ew");

var $l15Kx = parcelRequire("l15Kx");

var $kjlvF = parcelRequire("kjlvF");

var $3CGdL = parcelRequire("3CGdL");

var $bpKJo = parcelRequire("bpKJo");

var $9ddCs = parcelRequire("9ddCs");

var $c6v8s = parcelRequire("c6v8s");

var $b4Uzj = parcelRequire("b4Uzj");

var $bA3rc = parcelRequire("bA3rc");

var $fo0uV = parcelRequire("fo0uV");

var $6bM5M = parcelRequire("6bM5M");
"use client";
var $ef5c228e1913d0f0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $ef5c228e1913d0f0$var$existThemeConfig = false;
const $ef5c228e1913d0f0$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $ef5c228e1913d0f0$export$e7f14a745e5c386a = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const $ef5c228e1913d0f0$var$PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let $ef5c228e1913d0f0$var$globalPrefixCls;
let $ef5c228e1913d0f0$var$globalIconPrefixCls;
let $ef5c228e1913d0f0$var$globalTheme;
let $ef5c228e1913d0f0$var$globalHolderRender;
function $ef5c228e1913d0f0$var$getGlobalPrefixCls() {
    return $ef5c228e1913d0f0$var$globalPrefixCls || (0, $kjlvF.defaultPrefixCls);
}
function $ef5c228e1913d0f0$var$getGlobalIconPrefixCls() {
    return $ef5c228e1913d0f0$var$globalIconPrefixCls || (0, $kjlvF.defaultIconPrefixCls);
}
function $ef5c228e1913d0f0$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith('Color'));
}
const $ef5c228e1913d0f0$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $ef5c228e1913d0f0$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $ef5c228e1913d0f0$var$globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) $ef5c228e1913d0f0$var$globalHolderRender = holderRender;
    if (theme) {
        if ($ef5c228e1913d0f0$var$isLegacyTheme(theme)) (0, $3CGdL.registerTheme)($ef5c228e1913d0f0$var$getGlobalPrefixCls(), theme);
        else $ef5c228e1913d0f0$var$globalTheme = theme;
    }
};
const $ef5c228e1913d0f0$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$ef5c228e1913d0f0$var$getGlobalPrefixCls()}-${suffixCls}` : $ef5c228e1913d0f0$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $ef5c228e1913d0f0$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($ef5c228e1913d0f0$var$globalPrefixCls) return $ef5c228e1913d0f0$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $ef5c228e1913d0f0$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$ef5c228e1913d0f0$var$globalTheme,
        holderRender: $ef5c228e1913d0f0$var$globalHolderRender
    });
const $ef5c228e1913d0f0$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $aqdBs.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $kjlvF.defaultIconPrefixCls);
    const csp = customCsp || parentContext.csp;
    (0, $6bM5M.default)(iconPrefixCls, csp);
    const mergedTheme = (0, $c6v8s.default)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $ef5c228e1913d0f0$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $9nP3o.default)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $aqdBs.useContext((0, $6M602.default));
    const memoIconContextValue = $aqdBs.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $bA3rc.default), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $aqdBs.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $acNyW.merge)(((_a = (0, $iPGr2.default).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $79Tx6.default).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $3zIQU.default), {
        locale: locale,
        _ANT_MARK__: (0, $3zIQU.ANT_MARK)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $jOmuk.default).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $fo0uV.SizeContextProvider), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $aqdBs.createElement((0, $b4Uzj.default), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $aqdBs.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $ef5c228e1913d0f0$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $4wnj3.default)(algorithm) : (0, $dWyN5.default);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = Object.assign({}, componentToken);
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, $4wnj3.default)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $l15Kx.default)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $j22ew.DesignTokenContext).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $dkjPS.WarningContext).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $aqdBs.createElement((0, $bpKJo.DisabledContextProvider), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $aqdBs.createElement((0, $kjlvF.ConfigContext).Provider, {
        value: memoedConfig
    }, childNode);
};
const $ef5c228e1913d0f0$var$ConfigProvider = (props)=>{
    const context = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const antLocale = $aqdBs.useContext((0, $eJWTa.default));
    return /*#__PURE__*/ $aqdBs.createElement($ef5c228e1913d0f0$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$ef5c228e1913d0f0$var$ConfigProvider.ConfigContext = (0, $kjlvF.ConfigContext);
$ef5c228e1913d0f0$var$ConfigProvider.SizeContext = (0, $fo0uV.default);
$ef5c228e1913d0f0$var$ConfigProvider.config = $ef5c228e1913d0f0$var$setGlobalConfig;
$ef5c228e1913d0f0$var$ConfigProvider.useConfig = (0, $9ddCs.default);
Object.defineProperty($ef5c228e1913d0f0$var$ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, $fo0uV.default;
    }
});
var $ef5c228e1913d0f0$export$2e2bcd8739ae039 = $ef5c228e1913d0f0$var$ConfigProvider;

});
parcelRegister("g14b3", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("4wnj3")).default);
$parcel$export(module.exports, "useStyleRegister", () => (parcelRequire("f4yOi")).default);
$parcel$export(module.exports, "useCSSVarRegister", () => (parcelRequire("7n0Ot")).default);
$parcel$export(module.exports, "useCacheToken", () => (parcelRequire("5tHf5")).default);
$parcel$export(module.exports, "StyleContext", () => (parcelRequire("6M602")).default);
$parcel$export(module.exports, "Keyframes", () => (parcelRequire("Zo2YC")).default);
$parcel$export(module.exports, "getComputedToken", () => (parcelRequire("5tHf5")).getComputedToken);
$parcel$export(module.exports, "token2CSSVar", () => (parcelRequire("dD82S")).token2CSSVar);
$parcel$export(module.exports, "unit", () => (parcelRequire("aWTY1")).unit);

var $fMIZT = parcelRequire("fMIZT");

var $5tHf5 = parcelRequire("5tHf5");

var $7n0Ot = parcelRequire("7n0Ot");

var $f4yOi = parcelRequire("f4yOi");

var $Zo2YC = parcelRequire("Zo2YC");
parcelRequire("azUMR");
var $hJpEj = parcelRequire("hJpEj");
var $icw2m = parcelRequire("icw2m");
var $9v582 = parcelRequire("9v582");
var $gy1C5 = parcelRequire("gy1C5");

var $6M602 = parcelRequire("6M602");
parcelRequire("7icds");
var $4wnj3 = parcelRequire("4wnj3");

var $4mVYk = parcelRequire("4mVYk");

var $4i6U4 = parcelRequire("4i6U4");

var $aWTY1 = parcelRequire("aWTY1");

var $dD82S = parcelRequire("dD82S");
var $ba8ffadf65919803$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $aWTY1.supportWhere)() && (0, $aWTY1.supportLogicProps)();
    }
};

});
parcelRegister("fMIZT", function(module, exports) {

var $kelIR = parcelRequire("kelIR");

var $br1G4 = parcelRequire("br1G4");

var $5tHf5 = parcelRequire("5tHf5");

var $7n0Ot = parcelRequire("7n0Ot");

var $f4yOi = parcelRequire("f4yOi");

var $aWTY1 = parcelRequire("aWTY1");

var $gXcV4 = parcelRequire("gXcV4");
var $b7de3e34bcf0614d$var$_ExtractStyleFns;
var $b7de3e34bcf0614d$var$ExtractStyleFns = ($b7de3e34bcf0614d$var$_ExtractStyleFns = {}, (0, $br1G4.default)($b7de3e34bcf0614d$var$_ExtractStyleFns, (0, $f4yOi.STYLE_PREFIX), (0, $f4yOi.extract)), (0, $br1G4.default)($b7de3e34bcf0614d$var$_ExtractStyleFns, (0, $5tHf5.TOKEN_PREFIX), (0, $5tHf5.extract)), (0, $br1G4.default)($b7de3e34bcf0614d$var$_ExtractStyleFns, (0, $7n0Ot.CSS_VAR_PREFIX), (0, $7n0Ot.extract)), $b7de3e34bcf0614d$var$_ExtractStyleFns);
function $b7de3e34bcf0614d$var$isNotNull(value) {
    return value !== null;
}
function $b7de3e34bcf0614d$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === 'boolean' ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        'style',
        'token',
        'cssVar'
    ] : _ref$types;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === 'string' ? [
        types
    ] : types).join('|'), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = '';
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        var _key$split = key.split('%'), _key$split2 = (0, $kelIR.default)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $b7de3e34bcf0614d$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $kelIR.default)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($b7de3e34bcf0614d$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $kelIR.default)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $kelIR.default)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $kelIR.default)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $aWTY1.toStyleStr)(".".concat((0, $gXcV4.ATTR_CACHE_MAP), "{content:\"").concat((0, $gXcV4.serialize)(cachePathMap), "\";}"), undefined, undefined, (0, $br1G4.default)({}, (0, $gXcV4.ATTR_CACHE_MAP), (0, $gXcV4.ATTR_CACHE_MAP)), plain);
    return styleText;
}

});
parcelRegister("5tHf5", function(module, exports) {

$parcel$export(module.exports, "getComputedToken", () => $3fd13438752fdb6a$export$18602cb46ae80b62);
$parcel$export(module.exports, "TOKEN_PREFIX", () => $3fd13438752fdb6a$export$270fba097347f4fa);
$parcel$export(module.exports, "default", () => $3fd13438752fdb6a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $3fd13438752fdb6a$export$f9380c9a627682d3);

var $kelIR = parcelRequire("kelIR");

var $dMbbs = parcelRequire("dMbbs");

var $4f2X8 = parcelRequire("4f2X8");

var $3ieOL = parcelRequire("3ieOL");

var $98AgF = parcelRequire("98AgF");

var $aqdBs = parcelRequire("aqdBs");

var $6M602 = parcelRequire("6M602");

var $aWTY1 = parcelRequire("aWTY1");

var $dD82S = parcelRequire("dD82S");

var $gPQnm = parcelRequire("gPQnm");
var $3fd13438752fdb6a$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $3fd13438752fdb6a$var$hashPrefix = 'css';
var $3fd13438752fdb6a$var$tokenKeys = new Map();
function $3fd13438752fdb6a$var$recordCleanToken(tokenKey) {
    $3fd13438752fdb6a$var$tokenKeys.set(tokenKey, ($3fd13438752fdb6a$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $3fd13438752fdb6a$var$removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        var styles = document.querySelectorAll("style[".concat((0, $6M602.ATTR_TOKEN), "=\"").concat(key, "\"]"));
        styles.forEach(function(style) {
            if (style[0, $6M602.CSS_IN_JS_INSTANCE] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $3fd13438752fdb6a$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $3fd13438752fdb6a$var$cleanTokenStyle(tokenKey, instanceId) {
    $3fd13438752fdb6a$var$tokenKeys.set(tokenKey, ($3fd13438752fdb6a$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($3fd13438752fdb6a$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $3fd13438752fdb6a$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $3fd13438752fdb6a$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $3fd13438752fdb6a$var$removeStyleTags(key, instanceId);
        $3fd13438752fdb6a$var$tokenKeys.delete(key);
    });
}
var $3fd13438752fdb6a$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $4f2X8.default)((0, $4f2X8.default)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $3fd13438752fdb6a$export$270fba097347f4fa = 'token';
function $3fd13438752fdb6a$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $aqdBs.useContext)((0, $6M602.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? '' : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $3fd13438752fdb6a$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $aWTY1.memoResult)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $dMbbs.default)(tokens)));
    }, tokens);
    var tokenStr = (0, $aWTY1.flattenToken)(mergedToken);
    var overrideTokenStr = (0, $aWTY1.flattenToken)(override);
    var cssVarStr = cssVar ? (0, $aWTY1.flattenToken)(cssVar) : '';
    var cachedToken = (0, $gPQnm.default)($3fd13438752fdb6a$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $3fd13438752fdb6a$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $4f2X8.default)({}, mergedDerivativeToken);
        var cssVarsStr = '';
        if (!!cssVar) {
            var _transformToken = (0, $dD82S.transformToken)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $kelIR.default)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $aWTY1.token2key)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $aWTY1.token2key)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $3fd13438752fdb6a$var$recordCleanToken(themeKey);
        var hashId = "".concat($3fd13438752fdb6a$var$hashPrefix, "-").concat((0, $3ieOL.default)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ''
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $3fd13438752fdb6a$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $kelIR.default)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $98AgF.updateCSS)(cssVarsStr, (0, $3ieOL.default)("css-variables-".concat(token._themeKey)), {
                mark: (0, $6M602.ATTR_MARK),
                prepend: 'queue',
                attachTo: container,
                priority: -999
            });
            style[0, $6M602.CSS_IN_JS_INSTANCE] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $6M602.ATTR_TOKEN), token._themeKey);
        }
    });
    return cachedToken;
}
var $3fd13438752fdb6a$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $kelIR.default)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $aWTY1.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};

});
parcelRegister("dMbbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0786ef1aa30ac1d$export$2e2bcd8739ae039);

var $d0w7F = parcelRequire("d0w7F");

var $k1M0z = parcelRequire("k1M0z");

var $eBUQ0 = parcelRequire("eBUQ0");

var $ghbrn = parcelRequire("ghbrn");
function $a0786ef1aa30ac1d$export$2e2bcd8739ae039(r) {
    return (0, $d0w7F.default)(r) || (0, $k1M0z.default)(r) || (0, $eBUQ0.default)(r) || (0, $ghbrn.default)();
}

});
parcelRegister("d0w7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $978431554dd3a0b2$export$2e2bcd8739ae039);

var $fgmJk = parcelRequire("fgmJk");
function $978431554dd3a0b2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fgmJk.default)(r);
}

});

parcelRegister("k1M0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94924114e35edc5$export$2e2bcd8739ae039);
function $e94924114e35edc5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("ghbrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd971bbbc0ef96e0$export$2e2bcd8739ae039);
function $bd971bbbc0ef96e0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3ieOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $265e8c0f7074eb72$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $265e8c0f7074eb72$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $265e8c0f7074eb72$export$2e2bcd8739ae039 = $265e8c0f7074eb72$var$murmur2;

});

parcelRegister("6M602", function(module, exports) {

$parcel$export(module.exports, "ATTR_TOKEN", () => $4eebe1260f69a923$export$5d99297dcd5476ac);
$parcel$export(module.exports, "ATTR_MARK", () => $4eebe1260f69a923$export$89ce1123b3c0bd9e);
$parcel$export(module.exports, "CSS_IN_JS_INSTANCE", () => $4eebe1260f69a923$export$4c16a0c02134a7dc);
$parcel$export(module.exports, "default", () => $4eebe1260f69a923$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $9nP3o = parcelRequire("9nP3o");

var $aTirs = parcelRequire("aTirs");

var $aqdBs = parcelRequire("aqdBs");

var $3m6cr = parcelRequire("3m6cr");
var $4eebe1260f69a923$var$_excluded = [
    "children"
];
var $4eebe1260f69a923$export$5d99297dcd5476ac = 'data-token-hash';
var $4eebe1260f69a923$export$89ce1123b3c0bd9e = 'data-css-hash';
var $4eebe1260f69a923$export$36f8a6c9fa24262a = 'data-cache-path';
var $4eebe1260f69a923$export$4c16a0c02134a7dc = '__cssinjs_instance__';
function $4eebe1260f69a923$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($4eebe1260f69a923$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$4eebe1260f69a923$export$4c16a0c02134a7dc] = style[$4eebe1260f69a923$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$4eebe1260f69a923$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($4eebe1260f69a923$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($4eebe1260f69a923$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$4eebe1260f69a923$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $3m6cr.default)(cssinjsInstanceId);
}
var $4eebe1260f69a923$var$StyleContext = /*#__PURE__*/ $aqdBs.createContext({
    hashPriority: 'low',
    cache: $4eebe1260f69a923$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $4eebe1260f69a923$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $aX4Fp.default)(props, $4eebe1260f69a923$var$_excluded);
    var parentContext = $aqdBs.useContext($4eebe1260f69a923$var$StyleContext);
    var context = (0, $9nP3o.default)(function() {
        var mergedContext = (0, $4f2X8.default)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $4eebe1260f69a923$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $aTirs.default)(prev[0], next[0], true) || !(0, $aTirs.default)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $aqdBs.createElement($4eebe1260f69a923$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $4eebe1260f69a923$export$2e2bcd8739ae039 = $4eebe1260f69a923$var$StyleContext;

});
parcelRegister("aTirs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edd589af78193d3$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $i7X5i = parcelRequire("i7X5i");
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $7edd589af78193d3$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $i7X5i.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $7IgoF.default)(a) === 'object' && (0, $7IgoF.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $7edd589af78193d3$export$2e2bcd8739ae039 = $7edd589af78193d3$var$isEqual;

});

parcelRegister("3m6cr", function(module, exports) {

$parcel$export(module.exports, "pathKey", () => $27183c4f4b177cab$export$1d14e1d8187b9aad);
$parcel$export(module.exports, "default", () => $27183c4f4b177cab$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");
// [times, realValue]
var $27183c4f4b177cab$var$SPLIT = '%';
function $27183c4f4b177cab$export$1d14e1d8187b9aad(keys) {
    return keys.join($27183c4f4b177cab$var$SPLIT);
}
var $27183c4f4b177cab$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $dYVVZ.default)(this, Entity);
        (0, $br1G4.default)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $br1G4.default)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $hevvH.default)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($27183c4f4b177cab$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($27183c4f4b177cab$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $27183c4f4b177cab$export$2e2bcd8739ae039 = $27183c4f4b177cab$var$Entity;

});
parcelRegister("dYVVZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ddd187a2b42f6c$export$2e2bcd8739ae039);
function $a2ddd187a2b42f6c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hevvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8bc2fc06a4886a9$export$2e2bcd8739ae039);

var $4ZPfB = parcelRequire("4ZPfB");
function $c8bc2fc06a4886a9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZPfB.default)(o.key), o);
    }
}
function $c8bc2fc06a4886a9$export$2e2bcd8739ae039(e, r, t) {
    return r && $c8bc2fc06a4886a9$var$_defineProperties(e.prototype, r), t && $c8bc2fc06a4886a9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});



parcelRegister("aWTY1", function(module, exports) {

$parcel$export(module.exports, "memoResult", () => $7f8abc15bf3e7d35$export$6aabcc1951563d93);
$parcel$export(module.exports, "flattenToken", () => $7f8abc15bf3e7d35$export$597374558a261efc);
$parcel$export(module.exports, "token2key", () => $7f8abc15bf3e7d35$export$6c82d0ebe8f2ea2c);
$parcel$export(module.exports, "supportWhere", () => $7f8abc15bf3e7d35$export$f51d3b8ac4ac9ed1);
$parcel$export(module.exports, "supportLogicProps", () => $7f8abc15bf3e7d35$export$64a912f57d5de48e);
$parcel$export(module.exports, "isClientSide", () => $7f8abc15bf3e7d35$export$9542afab8c2a5f48);
$parcel$export(module.exports, "unit", () => $7f8abc15bf3e7d35$export$523c0b569236b342);
$parcel$export(module.exports, "toStyleStr", () => $7f8abc15bf3e7d35$export$71c98ec84f0481d3);

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");

var $3ieOL = parcelRequire("3ieOL");

var $8Vh6n = parcelRequire("8Vh6n");

var $98AgF = parcelRequire("98AgF");

var $6M602 = parcelRequire("6M602");
parcelRequire("7icds");
var $bN1ji = parcelRequire("bN1ji");
// Create a cache for memo concat
var $7f8abc15bf3e7d35$var$resultCache = new WeakMap();
var $7f8abc15bf3e7d35$var$RESULT_VALUE = {};
function $7f8abc15bf3e7d35$export$6aabcc1951563d93(callback, deps) {
    var current = $7f8abc15bf3e7d35$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($7f8abc15bf3e7d35$var$RESULT_VALUE)) current.set($7f8abc15bf3e7d35$var$RESULT_VALUE, callback());
    return current.get($7f8abc15bf3e7d35$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $7f8abc15bf3e7d35$var$flattenTokenCache = new WeakMap();
function $7f8abc15bf3e7d35$export$597374558a261efc(token) {
    var str = $7f8abc15bf3e7d35$var$flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $bN1ji.default)) str += value.id;
            else if (value && (0, $7IgoF.default)(value) === 'object') str += $7f8abc15bf3e7d35$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $3ieOL.default)(str);
        // Put in cache
        $7f8abc15bf3e7d35$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $7f8abc15bf3e7d35$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $3ieOL.default)("".concat(salt, "_").concat($7f8abc15bf3e7d35$export$597374558a261efc(token)));
}
var $7f8abc15bf3e7d35$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, '');
// Magic `content` for detect selector support
var $7f8abc15bf3e7d35$var$checkContent = '_bAmBoO_';
function $7f8abc15bf3e7d35$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $8Vh6n.default)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $98AgF.updateCSS)(styleStr, $7f8abc15bf3e7d35$var$randomSelectorKey);
        var _ele = document.createElement('div');
        _ele.style.position = 'fixed';
        _ele.style.left = '0';
        _ele.style.top = '0';
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($7f8abc15bf3e7d35$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $98AgF.removeCSS)($7f8abc15bf3e7d35$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $7f8abc15bf3e7d35$var$canLayer = undefined;
function $7f8abc15bf3e7d35$export$ac8d3fd9840e20dd() {
    if ($7f8abc15bf3e7d35$var$canLayer === undefined) $7f8abc15bf3e7d35$var$canLayer = $7f8abc15bf3e7d35$var$supportSelector("@layer ".concat($7f8abc15bf3e7d35$var$randomSelectorKey, " { .").concat($7f8abc15bf3e7d35$var$randomSelectorKey, " { content: \"").concat($7f8abc15bf3e7d35$var$checkContent, "\"!important; } }"), function(ele) {
        ele.className = $7f8abc15bf3e7d35$var$randomSelectorKey;
    });
    return $7f8abc15bf3e7d35$var$canLayer;
}
var $7f8abc15bf3e7d35$var$canWhere = undefined;
function $7f8abc15bf3e7d35$export$f51d3b8ac4ac9ed1() {
    if ($7f8abc15bf3e7d35$var$canWhere === undefined) $7f8abc15bf3e7d35$var$canWhere = $7f8abc15bf3e7d35$var$supportSelector(":where(.".concat($7f8abc15bf3e7d35$var$randomSelectorKey, ") { content: \"").concat($7f8abc15bf3e7d35$var$checkContent, "\"!important; }"), function(ele) {
        ele.className = $7f8abc15bf3e7d35$var$randomSelectorKey;
    });
    return $7f8abc15bf3e7d35$var$canWhere;
}
var $7f8abc15bf3e7d35$var$canLogic = undefined;
function $7f8abc15bf3e7d35$export$64a912f57d5de48e() {
    if ($7f8abc15bf3e7d35$var$canLogic === undefined) $7f8abc15bf3e7d35$var$canLogic = $7f8abc15bf3e7d35$var$supportSelector(".".concat($7f8abc15bf3e7d35$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $7f8abc15bf3e7d35$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === '93px';
    });
    return $7f8abc15bf3e7d35$var$canLogic;
}
var $7f8abc15bf3e7d35$export$9542afab8c2a5f48 = (0, $8Vh6n.default)();
function $7f8abc15bf3e7d35$export$523c0b569236b342(num) {
    if (typeof num === 'number') return "".concat(num, "px");
    return num;
}
function $7f8abc15bf3e7d35$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var _objectSpread2;
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $4f2X8.default)((0, $4f2X8.default)({}, customizeAttrs), {}, (_objectSpread2 = {}, (0, $br1G4.default)(_objectSpread2, (0, $6M602.ATTR_TOKEN), tokenKey), (0, $br1G4.default)(_objectSpread2, (0, $6M602.ATTR_MARK), styleId), _objectSpread2));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, "=\"").concat(val, "\"") : null;
    }).filter(function(v) {
        return v;
    }).join(' ');
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}

});
parcelRegister("7icds", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => (parcelRequire("4wnj3")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("bN1ji")).default);

var $gCATB = parcelRequire("gCATB");

var $4wnj3 = parcelRequire("4wnj3");

var $bN1ji = parcelRequire("bN1ji");

var $6vdVL = parcelRequire("6vdVL");

});
parcelRegister("gCATB", function(module, exports) {

var $9yX6X = parcelRequire("9yX6X");

var $dxxNX = parcelRequire("dxxNX");
var $c19cd0aebf8cf2bb$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $9yX6X.default) : (0, $dxxNX.default);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $c19cd0aebf8cf2bb$export$2e2bcd8739ae039 = $c19cd0aebf8cf2bb$var$genCalc;

});
parcelRegister("9yX6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6524454cd11412$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $g5xqv = parcelRequire("g5xqv");
var $6f6524454cd11412$var$CALC_UNIT = 'CALC_UNIT';
var $6f6524454cd11412$var$regexp = new RegExp($6f6524454cd11412$var$CALC_UNIT, 'g');
function $6f6524454cd11412$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($6f6524454cd11412$var$CALC_UNIT);
    return value;
}
var $6f6524454cd11412$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9nc35.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $lriWM.default)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $dYVVZ.default)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "result", '');
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "unitlessCssVar", void 0);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "lowPriority", void 0);
        var numType = (0, $7IgoF.default)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $6f6524454cd11412$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $hevvH.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($6f6524454cd11412$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($6f6524454cd11412$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($6f6524454cd11412$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $g5xqv.default));

});
parcelRegister("1FDZu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1378a41df7b126e7$export$2e2bcd8739ae039);
function $1378a41df7b126e7$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("9nc35", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2f9bb22a4295f6$export$2e2bcd8739ae039);

var $3AEpF = parcelRequire("3AEpF");
function $6d2f9bb22a4295f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $3AEpF.default)(t, e);
}

});
parcelRegister("3AEpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d4150d28646c20$export$2e2bcd8739ae039);
function $29d4150d28646c20$export$2e2bcd8739ae039(t, e) {
    return $29d4150d28646c20$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $29d4150d28646c20$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("lriWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9bad117e8f031bf$export$2e2bcd8739ae039);

var $9g5l6 = parcelRequire("9g5l6");

var $fo3td = parcelRequire("fo3td");

var $g1108 = parcelRequire("g1108");
function $f9bad117e8f031bf$export$2e2bcd8739ae039(t) {
    var r = (0, $fo3td.default)();
    return function() {
        var e, o = (0, $9g5l6.default)(t);
        if (r) {
            var s = (0, $9g5l6.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $g1108.default)(this, e);
    };
}

});
parcelRegister("9g5l6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bd9bff74cf8c465$export$2e2bcd8739ae039);
function $6bd9bff74cf8c465$export$2e2bcd8739ae039(t) {
    return $6bd9bff74cf8c465$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $6bd9bff74cf8c465$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fo3td", function(module, exports) {

$parcel$export(module.exports, "default", () => $b33bca00e6b00890$export$2e2bcd8739ae039);
function $b33bca00e6b00890$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b33bca00e6b00890$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("g1108", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8d842a64496dff$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $1FDZu = parcelRequire("1FDZu");
function $ba8d842a64496dff$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7IgoF.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $1FDZu.default)(t);
}

});


parcelRegister("g5xqv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb670ac6f9ad3942$export$2e2bcd8739ae039);

var $hevvH = parcelRequire("hevvH");

var $dYVVZ = parcelRequire("dYVVZ");
var $bb670ac6f9ad3942$var$AbstractCalculator = /*#__PURE__*/ (0, $hevvH.default)(function AbstractCalculator() {
    (0, $dYVVZ.default)(this, AbstractCalculator);
});
var $bb670ac6f9ad3942$export$2e2bcd8739ae039 = $bb670ac6f9ad3942$var$AbstractCalculator;

});


parcelRegister("dxxNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8945c1435a156$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $g5xqv = parcelRequire("g5xqv");
var $9db8945c1435a156$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9nc35.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, $lriWM.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $dYVVZ.default)(this, NumCalculator);
        _this = _super.call(this);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $hevvH.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $g5xqv.default));

});


parcelRegister("4wnj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ac3abfa4c6cfd2$export$2e2bcd8739ae039);

var $6vdVL = parcelRequire("6vdVL");

var $bN1ji = parcelRequire("bN1ji");
var $34ac3abfa4c6cfd2$var$cacheThemes = new (0, $6vdVL.default)();
function $34ac3abfa4c6cfd2$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$34ac3abfa4c6cfd2$var$cacheThemes.has(derivativeArr)) $34ac3abfa4c6cfd2$var$cacheThemes.set(derivativeArr, new (0, $bN1ji.default)(derivativeArr));
    // Get theme from cache and return
    return $34ac3abfa4c6cfd2$var$cacheThemes.get(derivativeArr);
}

});
parcelRegister("6vdVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bc071a7a18a6ca1$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");
function $4bc071a7a18a6ca1$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $4bc071a7a18a6ca1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $dYVVZ.default)(this, ThemeCache);
        (0, $br1G4.default)(this, "cache", void 0);
        (0, $br1G4.default)(this, "keys", void 0);
        (0, $br1G4.default)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $hevvH.default)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $kelIR.default)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $kelIR.default)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$4bc071a7a18a6ca1$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $br1G4.default)($4bc071a7a18a6ca1$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $br1G4.default)($4bc071a7a18a6ca1$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);

});

parcelRegister("bN1ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $8955498247aacde6$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");

var $i7X5i = parcelRequire("i7X5i");
var $8955498247aacde6$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $8955498247aacde6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $dYVVZ.default)(this, Theme);
        (0, $br1G4.default)(this, "derivatives", void 0);
        (0, $br1G4.default)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $8955498247aacde6$var$uuid;
        if (derivatives.length === 0) (0, $i7X5i.warning)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        $8955498247aacde6$var$uuid += 1;
    }
    (0, $hevvH.default)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();

});




parcelRegister("dD82S", function(module, exports) {

$parcel$export(module.exports, "token2CSSVar", () => $9ec5288cad4e8f5a$export$309b3b095f0c7662);
$parcel$export(module.exports, "transformToken", () => $9ec5288cad4e8f5a$export$67858afe85bce49f);

var $kelIR = parcelRequire("kelIR");
var $9ec5288cad4e8f5a$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "--".concat(prefix ? "".concat(prefix, "-") : '').concat(token).replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
var $9ec5288cad4e8f5a$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return '';
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : '', "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $kelIR.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(''), "}");
};
var $9ec5288cad4e8f5a$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $kelIR.default)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $9ec5288cad4e8f5a$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === 'number' && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $9ec5288cad4e8f5a$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};

});

parcelRegister("gPQnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41a097d1f4d5c6a$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $3m6cr = parcelRequire("3m6cr");

var $6M602 = parcelRequire("6M602");

var $1kDB3 = parcelRequire("1kDB3");

var $hy6Qk = parcelRequire("hy6Qk");

var $4WJRX = parcelRequire("4WJRX");
function $c41a097d1f4d5c6a$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $aqdBs.useContext((0, $6M602.default)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $dMbbs.default)(keyPath));
    var fullPathStr = (0, $3m6cr.pathKey)(fullPath);
    var register = (0, $hy6Qk.default)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $4WJRX.default)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $kelIR.default)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $aqdBs.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $1kDB3.default)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $kelIR.default)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $kelIR.default)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}

});
parcelRegister("1kDB3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f865fc3f0ff9f18$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $iEJaB = parcelRequire("iEJaB");

var $aqdBs = parcelRequire("aqdBs");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $0f865fc3f0ff9f18$var$fullClone = (0, $4f2X8.default)({}, $aqdBs);
var $0f865fc3f0ff9f18$var$useInsertionEffect = $0f865fc3f0ff9f18$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $0f865fc3f0ff9f18$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $aqdBs.useMemo(renderEffect, deps);
    (0, $iEJaB.default)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $0f865fc3f0ff9f18$var$useCompatibleInsertionEffect = $0f865fc3f0ff9f18$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $0f865fc3f0ff9f18$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $0f865fc3f0ff9f18$var$useInsertionEffectPolyfill;
var $0f865fc3f0ff9f18$export$2e2bcd8739ae039 = $0f865fc3f0ff9f18$var$useCompatibleInsertionEffect;

});
parcelRegister("iEJaB", function(module, exports) {

$parcel$export(module.exports, "useLayoutUpdateEffect", () => $d94f003ccd0dfb3e$export$9283e56bae2f7b0f);
$parcel$export(module.exports, "default", () => $d94f003ccd0dfb3e$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $8Vh6n = parcelRequire("8Vh6n");
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $d94f003ccd0dfb3e$var$useInternalLayoutEffect = (0, $8Vh6n.default)() ? $aqdBs.useLayoutEffect : $aqdBs.useEffect;
var $d94f003ccd0dfb3e$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $aqdBs.useRef(true);
    $d94f003ccd0dfb3e$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $d94f003ccd0dfb3e$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $d94f003ccd0dfb3e$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $d94f003ccd0dfb3e$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $d94f003ccd0dfb3e$export$2e2bcd8739ae039 = $d94f003ccd0dfb3e$var$useLayoutEffect;

});


parcelRegister("hy6Qk", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc6aeb7f45cd37dd$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");
parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");
var $cc6aeb7f45cd37dd$var$fullClone = (0, $4f2X8.default)({}, $aqdBs);
var $cc6aeb7f45cd37dd$var$useInsertionEffect = $cc6aeb7f45cd37dd$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $cc6aeb7f45cd37dd$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $aqdBs.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $cc6aeb7f45cd37dd$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $cc6aeb7f45cd37dd$var$useEffectCleanupRegister = typeof $cc6aeb7f45cd37dd$var$useInsertionEffect !== 'undefined' ? $cc6aeb7f45cd37dd$var$useCleanupRegister : $cc6aeb7f45cd37dd$var$useRun;
var $cc6aeb7f45cd37dd$export$2e2bcd8739ae039 = $cc6aeb7f45cd37dd$var$useEffectCleanupRegister;

});

parcelRegister("4WJRX", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a028e538f73d3b$export$2e2bcd8739ae039);
function $39a028e538f73d3b$var$useProdHMR() {
    return false;
}
var $39a028e538f73d3b$var$webpackHMR = false;
function $39a028e538f73d3b$var$useDevHMR() {
    return $39a028e538f73d3b$var$webpackHMR;
}
var $39a028e538f73d3b$export$2e2bcd8739ae039 = $39a028e538f73d3b$var$useProdHMR;
var $39a028e538f73d3b$var$win, $39a028e538f73d3b$var$originWebpackHotUpdate;

});



parcelRegister("7n0Ot", function(module, exports) {

$parcel$export(module.exports, "CSS_VAR_PREFIX", () => $55db4fd9e0b318c6$export$d96c342855c5e1fc);
$parcel$export(module.exports, "extract", () => $55db4fd9e0b318c6$export$f9380c9a627682d3);
$parcel$export(module.exports, "default", () => $55db4fd9e0b318c6$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $dMbbs = parcelRequire("dMbbs");

var $98AgF = parcelRequire("98AgF");

var $aqdBs = parcelRequire("aqdBs");

var $6M602 = parcelRequire("6M602");

var $aWTY1 = parcelRequire("aWTY1");

var $dD82S = parcelRequire("dD82S");

var $gPQnm = parcelRequire("gPQnm");

var $f4yOi = parcelRequire("f4yOi");
var $55db4fd9e0b318c6$export$d96c342855c5e1fc = 'cssVar';
var $55db4fd9e0b318c6$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? '' : _config$scope;
    var _useContext = (0, $aqdBs.useContext)((0, $6M602.default)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $dMbbs.default)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $gPQnm.default)($55db4fd9e0b318c6$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $dD82S.transformToken)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $kelIR.default)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $f4yOi.uniqueHash)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $kelIR.default)(_ref, 3), styleId = _ref2[2];
        if (0, $aWTY1.isClientSide) (0, $98AgF.removeCSS)(styleId, {
            mark: (0, $6M602.ATTR_MARK)
        });
    }, function(_ref3) {
        var _ref4 = (0, $kelIR.default)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $98AgF.updateCSS)(cssVarsStr, styleId, {
            mark: (0, $6M602.ATTR_MARK),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, $6M602.CSS_IN_JS_INSTANCE] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $6M602.ATTR_TOKEN), key);
    });
    return cache;
};
var $55db4fd9e0b318c6$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $kelIR.default)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    var styleText = (0, $aWTY1.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $55db4fd9e0b318c6$export$2e2bcd8739ae039 = $55db4fd9e0b318c6$var$useCSSVarRegister;

});
parcelRegister("f4yOi", function(module, exports) {

$parcel$export(module.exports, "uniqueHash", () => $af923b574378f959$export$412618713057f6ca);
$parcel$export(module.exports, "STYLE_PREFIX", () => $af923b574378f959$export$1e6d9f0d06c7ec14);
$parcel$export(module.exports, "default", () => $af923b574378f959$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extract", () => $af923b574378f959$export$f9380c9a627682d3);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $dMbbs = parcelRequire("dMbbs");

var $7IgoF = parcelRequire("7IgoF");

var $3ieOL = parcelRequire("3ieOL");

var $98AgF = parcelRequire("98AgF");

var $aqdBs = parcelRequire("aqdBs");

var $bHUcK = parcelRequire("bHUcK");

var $1azUd = parcelRequire("1azUd");
var $6PNh5 = parcelRequire("6PNh5");
parcelRequire("azUMR");

var $6M602 = parcelRequire("6M602");

var $aWTY1 = parcelRequire("aWTY1");

var $gXcV4 = parcelRequire("gXcV4");

var $gPQnm = parcelRequire("gPQnm");
var $af923b574378f959$var$SKIP_CHECK = '_skip_check_';
var $af923b574378f959$var$MULTI_VALUE = '_multi_value_';
function $af923b574378f959$export$8756898546458274(styleStr) {
    var serialized = (0, $6PNh5.serialize)((0, $1azUd.compile)(styleStr), (0, $6PNh5.stringify));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function $af923b574378f959$var$isCompoundCSSProperty(value) {
    return (0, $7IgoF.default)(value) === 'object' && value && ($af923b574378f959$var$SKIP_CHECK in value || $af923b574378f959$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $af923b574378f959$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === 'low' ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(',').map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || '';
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || '';
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $dMbbs.default)(fullPath.slice(1))).join(' ');
    });
    return keys.join(',');
}
var $af923b574378f959$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = '';
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $kelIR.default)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $7IgoF.default)(value) === 'object' && value && (key !== 'animationName' || !value._keyframe) && !$af923b574378f959$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = $af923b574378f959$var$injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $af923b574378f959$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $dMbbs.default)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $kelIR.default)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $4f2X8.default)((0, $4f2X8.default)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $bHUcK.default)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $7IgoF.default)(value) === 'object' && value !== null && value !== void 0 && value[$af923b574378f959$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $af923b574378f959$export$412618713057f6ca(path, styleStr) {
    return (0, $3ieOL.default)("".concat(path.join('%')).concat(styleStr));
}
function $af923b574378f959$var$Empty() {
    return null;
}
var $af923b574378f959$export$1e6d9f0d06c7ec14 = 'style';
function $af923b574378f959$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $aqdBs.useContext((0, $6M602.default)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push.apply(fullPath, (0, $dMbbs.default)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $aWTY1.isClientSide);
    var _useGlobalCache = (0, $gPQnm.default)($af923b574378f959$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, $gXcV4.existPath)(cachePath)) {
            var _getStyleAndHash = (0, $gXcV4.getStyleAndHash)(cachePath), _getStyleAndHash2 = (0, $kelIR.default)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $af923b574378f959$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $kelIR.default)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $af923b574378f959$export$8756898546458274(parsedStyle);
        var styleId = $af923b574378f959$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $kelIR.default)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $aWTY1.isClientSide)) (0, $98AgF.removeCSS)(styleId, {
            mark: (0, $6M602.ATTR_MARK)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $kelIR.default)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $gXcV4.CSS_FILE_STYLE)) {
            var mergedCSSConfig = {
                mark: (0, $6M602.ATTR_MARK),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $98AgF.updateCSS)($af923b574378f959$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $4f2X8.default)((0, $4f2X8.default)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $98AgF.updateCSS)(styleStr, styleId, mergedCSSConfig);
            style[0, $6M602.CSS_IN_JS_INSTANCE] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $6M602.ATTR_TOKEN), tokenKey);
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $98AgF.updateCSS)($af923b574378f959$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $kelIR.default)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $aqdBs.createElement($af923b574378f959$var$Empty, null);
        else {
            var _ref6;
            styleNode = /*#__PURE__*/ $aqdBs.createElement("style", (0, $13KW1.default)({}, (_ref6 = {}, (0, $br1G4.default)(_ref6, (0, $6M602.ATTR_TOKEN), cachedTokenKey), (0, $br1G4.default)(_ref6, (0, $6M602.ATTR_MARK), cachedStyleId), _ref6), {
                dangerouslySetInnerHTML: {
                    __html: cachedStyleStr
                }
            }));
        }
        return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, styleNode, node);
    };
}
var $af923b574378f959$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $kelIR.default)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $aWTY1.toStyleStr)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $af923b574378f959$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $aWTY1.toStyleStr)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};

});
parcelRegister("bHUcK", function(module, exports) {

$parcel$export(module.exports, "default", () => $885f4eee88e48c11$export$2e2bcd8739ae039);
var $885f4eee88e48c11$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $885f4eee88e48c11$export$2e2bcd8739ae039 = $885f4eee88e48c11$var$unitlessKeys;

});

parcelRegister("1azUd", function(module, exports) {

$parcel$export(module.exports, "compile", () => $0da293b81cdc2df3$export$ef7acd7185315e22);

var $1NBT5 = parcelRequire("1NBT5");

var $e9xbD = parcelRequire("e9xbD");

var $MyHGq = parcelRequire("MyHGq");
function $0da293b81cdc2df3$export$ef7acd7185315e22(value) {
    return (0, $MyHGq.dealloc)($0da293b81cdc2df3$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $MyHGq.alloc)(value), 0, [
        0
    ], value));
}
function $0da293b81cdc2df3$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $MyHGq.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $e9xbD.charat)(characters, length - 1) == 58) {
                if ((0, $e9xbD.indexof)(characters += (0, $e9xbD.replace)((0, $MyHGq.delimit)(character), '&', '&\f'), '&\f', (0, $e9xbD.abs)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $MyHGq.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $MyHGq.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $MyHGq.escaping)((0, $MyHGq.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $MyHGq.peek)()){
                case 42:
                case 47:
                    (0, $e9xbD.append)($0da293b81cdc2df3$export$4a34f930e789283c((0, $MyHGq.commenter)((0, $MyHGq.next)(), (0, $MyHGq.caret)()), root, parent, declarations), declarations);
                    if (((0, $MyHGq.token)(previous || 1) == 5 || (0, $MyHGq.token)((0, $MyHGq.peek)() || 1) == 5) && (0, $e9xbD.strlen)(characters) && (0, $e9xbD.substr)(characters, -1, void 0) !== ' ') characters += ' ';
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $e9xbD.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $e9xbD.replace)(characters, /\f/g, '');
                    if (property > 0 && ((0, $e9xbD.strlen)(characters) - length || variable === 0 && previous === 47)) (0, $e9xbD.append)(property > 32 ? $0da293b81cdc2df3$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1, declarations) : $0da293b81cdc2df3$export$f8483753829ec8f3((0, $e9xbD.replace)(characters, ' ', '') + ';', rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $e9xbD.append)(reference = $0da293b81cdc2df3$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $0da293b81cdc2df3$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else {
                            switch(atrule){
                                // c(ontainer)
                                case 99:
                                    if ((0, $e9xbD.charat)(characters, 3) === 110) break;
                                // l(ayer)
                                case 108:
                                    if ((0, $e9xbD.charat)(characters, 2) === 97) break;
                                default:
                                    offset = 0;
                                // d(ocument) m(edia) s(upports)
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (offset) $0da293b81cdc2df3$export$98e6a39c04603d36(value, reference, reference, rule && (0, $e9xbD.append)($0da293b81cdc2df3$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                            else $0da293b81cdc2df3$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                ''
                            ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $e9xbD.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $MyHGq.prev)() == 125) continue;
            }
            switch(characters += (0, $e9xbD.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $e9xbD.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $MyHGq.peek)() === 45) characters += (0, $MyHGq.delimit)((0, $MyHGq.next)());
                    atrule = (0, $MyHGq.peek)(), offset = length = (0, $e9xbD.strlen)(type = characters += (0, $MyHGq.identifier)((0, $MyHGq.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $e9xbD.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $0da293b81cdc2df3$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $e9xbD.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $e9xbD.substr)(value, post + 1, post = (0, $e9xbD.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $e9xbD.trim)(j > 0 ? rule[x] + ' ' + y : (0, $e9xbD.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $MyHGq.node)(value, root, parent, offset === 0 ? (0, $1NBT5.RULESET) : type, props, children, length, siblings);
}
function $0da293b81cdc2df3$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $MyHGq.node)(value, root, parent, (0, $1NBT5.COMMENT), (0, $e9xbD.from)((0, $MyHGq.char)()), (0, $e9xbD.substr)(value, 2, -2), 0, siblings);
}
function $0da293b81cdc2df3$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $MyHGq.node)(value, root, parent, (0, $1NBT5.DECLARATION), (0, $e9xbD.substr)(value, 0, length), (0, $e9xbD.substr)(value, length + 1, -1), length, siblings);
}

});
parcelRegister("1NBT5", function(module, exports) {

$parcel$export(module.exports, "COMMENT", () => $14f7c1b46e1d219f$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $14f7c1b46e1d219f$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $14f7c1b46e1d219f$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $14f7c1b46e1d219f$export$a763edbf796b780a);
$parcel$export(module.exports, "NAMESPACE", () => $14f7c1b46e1d219f$export$6aad947bda0f3f46);
$parcel$export(module.exports, "KEYFRAMES", () => $14f7c1b46e1d219f$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $14f7c1b46e1d219f$export$d773506282b3cfe6);
var $14f7c1b46e1d219f$export$71ad59f2e432cfe8 = '-ms-';
var $14f7c1b46e1d219f$export$2c0f367103c8d01c = '-moz-';
var $14f7c1b46e1d219f$export$39dfd62a25e0fe93 = '-webkit-';
var $14f7c1b46e1d219f$export$a29989082612d0d9 = 'comm';
var $14f7c1b46e1d219f$export$aa3a2e812ca8570d = 'rule';
var $14f7c1b46e1d219f$export$527d108ccf083c2b = 'decl';
var $14f7c1b46e1d219f$export$d3d35020fa5b54f0 = '@page';
var $14f7c1b46e1d219f$export$500415a86c544f73 = '@media';
var $14f7c1b46e1d219f$export$a763edbf796b780a = '@import';
var $14f7c1b46e1d219f$export$2790aeb8b4e5c826 = '@charset';
var $14f7c1b46e1d219f$export$1cc683e23b84b133 = '@viewport';
var $14f7c1b46e1d219f$export$9447a5efea57e862 = '@supports';
var $14f7c1b46e1d219f$export$ef011b4e114b1fba = '@document';
var $14f7c1b46e1d219f$export$6aad947bda0f3f46 = '@namespace';
var $14f7c1b46e1d219f$export$b44a8529a35fcb60 = '@keyframes';
var $14f7c1b46e1d219f$export$2c16de31893252e6 = '@font-face';
var $14f7c1b46e1d219f$export$3d846dd52e150c6f = '@counter-style';
var $14f7c1b46e1d219f$export$22314bfbb57653fe = '@font-feature-values';
var $14f7c1b46e1d219f$export$d773506282b3cfe6 = '@layer';
var $14f7c1b46e1d219f$export$1c5a554c78c0cd12 = '@scope';

});

parcelRegister("e9xbD", function(module, exports) {

$parcel$export(module.exports, "abs", () => $a4dba62487c0087b$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $a4dba62487c0087b$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $a4dba62487c0087b$export$e6e34fd1f2686227);
$parcel$export(module.exports, "charat", () => $a4dba62487c0087b$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $a4dba62487c0087b$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "replace", () => $a4dba62487c0087b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $a4dba62487c0087b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $a4dba62487c0087b$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $a4dba62487c0087b$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $a4dba62487c0087b$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $a4dba62487c0087b$export$10d8903dec122b9d);
/**
 * @param {number}
 * @return {number}
 */ var $a4dba62487c0087b$export$2335f513bbd82c6d = Math.abs;
var $a4dba62487c0087b$export$6788812c4e6611e6 = String.fromCharCode;
var $a4dba62487c0087b$export$e6e34fd1f2686227 = Object.assign;
function $a4dba62487c0087b$export$d6af199866bfb566(value, length) {
    return $a4dba62487c0087b$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 0)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 1)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 2)) << 2 ^ $a4dba62487c0087b$export$a9db5e087081082d(value, 3) : 0;
}
function $a4dba62487c0087b$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $a4dba62487c0087b$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $a4dba62487c0087b$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $a4dba62487c0087b$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $a4dba62487c0087b$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $a4dba62487c0087b$export$36776f635604f274(value) {
    return value.length;
}
function $a4dba62487c0087b$export$f9084667e487ed46(value) {
    return value.length;
}
function $a4dba62487c0087b$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $a4dba62487c0087b$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}
function $a4dba62487c0087b$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$a4dba62487c0087b$export$4659b591c19bdf3d(value, pattern);
    });
}

});

parcelRegister("MyHGq", function(module, exports) {

$parcel$export(module.exports, "node", () => $091f67372881bac3$export$35059013cd4a06db);
$parcel$export(module.exports, "char", () => $091f67372881bac3$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $091f67372881bac3$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $091f67372881bac3$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $091f67372881bac3$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $091f67372881bac3$export$e88cb2efb12ae807);
$parcel$export(module.exports, "token", () => $091f67372881bac3$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $091f67372881bac3$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $091f67372881bac3$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $091f67372881bac3$export$410ac95b9ec204b8);
$parcel$export(module.exports, "whitespace", () => $091f67372881bac3$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $091f67372881bac3$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $091f67372881bac3$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $091f67372881bac3$export$4254d4e2b3745c4c);

var $e9xbD = parcelRequire("e9xbD");
var $091f67372881bac3$export$53f1d5ea8de3d7c = 1;
var $091f67372881bac3$export$4e0c71f277ca26b3 = 1;
var $091f67372881bac3$export$f24224f1c91d8156 = 0;
var $091f67372881bac3$export$5880b8b5730aff45 = 0;
var $091f67372881bac3$export$c0306caf338ac095 = 0;
var $091f67372881bac3$export$30a86d91af8ff6e6 = '';
function $091f67372881bac3$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $091f67372881bac3$export$53f1d5ea8de3d7c,
        column: $091f67372881bac3$export$4e0c71f277ca26b3,
        length: length,
        return: '',
        siblings: siblings
    };
}
function $091f67372881bac3$export$784d13d8ee351f07(root, props) {
    return (0, $e9xbD.assign)($091f67372881bac3$export$35059013cd4a06db('', null, null, '', null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $091f67372881bac3$export$590e8b2c435046d9(root) {
    while(root.root)root = $091f67372881bac3$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $e9xbD.append)(root, root.siblings);
}
function $091f67372881bac3$export$eba6f6f03b0a92e7() {
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$232faf9add678146() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 > 0 ? (0, $e9xbD.charat)($091f67372881bac3$export$30a86d91af8ff6e6, --$091f67372881bac3$export$5880b8b5730aff45) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3--, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c--;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$48cfd1e771a65c4f() {
    $091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$5880b8b5730aff45 < $091f67372881bac3$export$f24224f1c91d8156 ? (0, $e9xbD.charat)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45++) : 0;
    if ($091f67372881bac3$export$4e0c71f277ca26b3++, $091f67372881bac3$export$c0306caf338ac095 === 10) $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$53f1d5ea8de3d7c++;
    return $091f67372881bac3$export$c0306caf338ac095;
}
function $091f67372881bac3$export$4d3fb11e950abb9e() {
    return (0, $e9xbD.charat)($091f67372881bac3$export$30a86d91af8ff6e6, $091f67372881bac3$export$5880b8b5730aff45);
}
function $091f67372881bac3$export$e88cb2efb12ae807() {
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$58adb3bec8346d0f(begin, end) {
    return (0, $e9xbD.substr)($091f67372881bac3$export$30a86d91af8ff6e6, begin, end);
}
function $091f67372881bac3$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $091f67372881bac3$export$2de70f21292aac9e(value) {
    return $091f67372881bac3$export$53f1d5ea8de3d7c = $091f67372881bac3$export$4e0c71f277ca26b3 = 1, $091f67372881bac3$export$f24224f1c91d8156 = (0, $e9xbD.strlen)($091f67372881bac3$export$30a86d91af8ff6e6 = value), $091f67372881bac3$export$5880b8b5730aff45 = 0, [];
}
function $091f67372881bac3$export$45918ac1574455b1(value) {
    return $091f67372881bac3$export$30a86d91af8ff6e6 = '', value;
}
function $091f67372881bac3$export$410ac95b9ec204b8(type) {
    return (0, $e9xbD.trim)($091f67372881bac3$export$58adb3bec8346d0f($091f67372881bac3$export$5880b8b5730aff45 - 1, $091f67372881bac3$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $091f67372881bac3$export$660b2ee2d4fb4eff(value) {
    return $091f67372881bac3$export$45918ac1574455b1($091f67372881bac3$export$5f8c09e3ae6f64e1($091f67372881bac3$export$2de70f21292aac9e(value)));
}
function $091f67372881bac3$export$7af1228ff777d175(type) {
    while($091f67372881bac3$export$c0306caf338ac095 = $091f67372881bac3$export$4d3fb11e950abb9e())if ($091f67372881bac3$export$c0306caf338ac095 < 33) $091f67372881bac3$export$48cfd1e771a65c4f();
    else break;
    return $091f67372881bac3$export$9e1725a4cfeada27(type) > 2 || $091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $091f67372881bac3$export$5f8c09e3ae6f64e1(children) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$c0306caf338ac095)){
        case 0:
            (0, $e9xbD.append)($091f67372881bac3$export$c2ab62c7bf24634($091f67372881bac3$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $e9xbD.append)($091f67372881bac3$export$410ac95b9ec204b8($091f67372881bac3$export$c0306caf338ac095), children);
            break;
        default:
            (0, $e9xbD.append)((0, $e9xbD.from)($091f67372881bac3$export$c0306caf338ac095), children);
    }
    return children;
}
function $091f67372881bac3$export$955ba06d119e085e(index, count) {
    while(--count && $091f67372881bac3$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($091f67372881bac3$export$c0306caf338ac095 < 48 || $091f67372881bac3$export$c0306caf338ac095 > 102 || $091f67372881bac3$export$c0306caf338ac095 > 57 && $091f67372881bac3$export$c0306caf338ac095 < 65 || $091f67372881bac3$export$c0306caf338ac095 > 70 && $091f67372881bac3$export$c0306caf338ac095 < 97) break;
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$e88cb2efb12ae807() + (count < 6 && $091f67372881bac3$export$4d3fb11e950abb9e() == 32 && $091f67372881bac3$export$48cfd1e771a65c4f() == 32));
}
function $091f67372881bac3$export$c889f2fcc19dbf12(type) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())switch($091f67372881bac3$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $091f67372881bac3$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $091f67372881bac3$export$c889f2fcc19dbf12($091f67372881bac3$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $091f67372881bac3$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $091f67372881bac3$export$48cfd1e771a65c4f();
            break;
    }
    return $091f67372881bac3$export$5880b8b5730aff45;
}
function $091f67372881bac3$export$4254d4e2b3745c4c(type, index) {
    while($091f67372881bac3$export$48cfd1e771a65c4f())// //
    if (type + $091f67372881bac3$export$c0306caf338ac095 === 57) break;
    else if (type + $091f67372881bac3$export$c0306caf338ac095 === 84 && $091f67372881bac3$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45 - 1) + '*' + (0, $e9xbD.from)(type === 47 ? type : $091f67372881bac3$export$48cfd1e771a65c4f());
}
function $091f67372881bac3$export$c2ab62c7bf24634(index) {
    while(!$091f67372881bac3$export$9e1725a4cfeada27($091f67372881bac3$export$4d3fb11e950abb9e()))$091f67372881bac3$export$48cfd1e771a65c4f();
    return $091f67372881bac3$export$58adb3bec8346d0f(index, $091f67372881bac3$export$5880b8b5730aff45);
}

});


parcelRegister("6PNh5", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $4f9dba64a0f6480c$export$fac44ee5b035f737);

var $1NBT5 = parcelRequire("1NBT5");

var $e9xbD = parcelRequire("e9xbD");
function $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $4f9dba64a0f6480c$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $1NBT5.LAYER:
            if (element.children.length) break;
        case 0, $1NBT5.IMPORT:
        case 0, $1NBT5.NAMESPACE:
        case 0, $1NBT5.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $1NBT5.COMMENT:
            return '';
        case 0, $1NBT5.KEYFRAMES:
            return element.return = element.value + '{' + $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $1NBT5.RULESET:
            if (!(0, $e9xbD.strlen)(element.value = element.props.join(','))) return '';
    }
    return (0, $e9xbD.strlen)(children = $4f9dba64a0f6480c$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("azUMR", function(module, exports) {

var $8qfRQ = parcelRequire("8qfRQ");

var $8qIZK = parcelRequire("8qIZK");

var $icw2m = parcelRequire("icw2m");

var $hJpEj = parcelRequire("hJpEj");

var $gy1C5 = parcelRequire("gy1C5");

var $9v582 = parcelRequire("9v582");

});
parcelRegister("8qfRQ", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
var $621d0f5df6d24e39$var$linter = function linter(key, value, info) {
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $1KR79.lintWarning)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $621d0f5df6d24e39$export$2e2bcd8739ae039 = $621d0f5df6d24e39$var$linter;

});
parcelRegister("1KR79", function(module, exports) {

$parcel$export(module.exports, "lintWarning", () => $147349b81e49be63$export$e7b7955c4f1f8c03);

var $i7X5i = parcelRequire("i7X5i");
function $147349b81e49be63$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $i7X5i.default)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : '').concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(' | ')) : ''));
}

});


parcelRegister("8qIZK", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
var $6233a7810faf3fc9$var$linter = function linter(key, value, info) {
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, $1KR79.lintWarning)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $6233a7810faf3fc9$export$2e2bcd8739ae039 = $6233a7810faf3fc9$var$linter;

});

parcelRegister("icw2m", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
function $d40232e2f4fffc76$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $d40232e2f4fffc76$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, '');
}
var $d40232e2f4fffc76$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $d40232e2f4fffc76$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($d40232e2f4fffc76$var$isConcatSelector)) (0, $1KR79.lintWarning)("Concat ':not' selector not support in legacy browsers.", info);
};
var $d40232e2f4fffc76$export$2e2bcd8739ae039 = $d40232e2f4fffc76$var$linter;

});

parcelRegister("hJpEj", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
var $ce8a890846652a9e$var$linter = function linter(key, value, info) {
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, $1KR79.lintWarning)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                var valueArr = value.split(' ').map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $1KR79.lintWarning)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, $1KR79.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                var radiusGroups = value.split('/').map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(' ').map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $1KR79.lintWarning)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $ce8a890846652a9e$export$2e2bcd8739ae039 = $ce8a890846652a9e$var$linter;

});

parcelRegister("gy1C5", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
var $c0c112aba487ca4d$var$linter = function linter(key, value, info) {
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, $1KR79.lintWarning)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $c0c112aba487ca4d$export$2e2bcd8739ae039 = $c0c112aba487ca4d$var$linter;

});

parcelRegister("9v582", function(module, exports) {

var $1KR79 = parcelRequire("1KR79");
var $6eaafcc148e92bf7$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(',');
        return selectors.some(function(item) {
            return item.split('&').length > 2;
        });
    })) (0, $1KR79.lintWarning)('Should not use more than one `&` in a selector.', info);
};
var $6eaafcc148e92bf7$export$2e2bcd8739ae039 = $6eaafcc148e92bf7$var$linter;

});


parcelRegister("gXcV4", function(module, exports) {

$parcel$export(module.exports, "ATTR_CACHE_MAP", () => $c57c2d923541d0e8$export$1c054aa01963e47e);
$parcel$export(module.exports, "CSS_FILE_STYLE", () => $c57c2d923541d0e8$export$e0a2f8ff7fc63361);
$parcel$export(module.exports, "serialize", () => $c57c2d923541d0e8$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "existPath", () => $c57c2d923541d0e8$export$5aa0d776d676ab98);
$parcel$export(module.exports, "getStyleAndHash", () => $c57c2d923541d0e8$export$d3851dfd3659b2ce);

var $kelIR = parcelRequire("kelIR");

var $8Vh6n = parcelRequire("8Vh6n");

var $6M602 = parcelRequire("6M602");
var $c57c2d923541d0e8$export$1c054aa01963e47e = 'data-ant-cssinjs-cache-path';
var $c57c2d923541d0e8$export$e0a2f8ff7fc63361 = '_FILE_STYLE__';
function $c57c2d923541d0e8$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(';');
}
var $c57c2d923541d0e8$var$cachePathMap;
var $c57c2d923541d0e8$var$fromCSSFile = true;
function $c57c2d923541d0e8$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $c57c2d923541d0e8$var$cachePathMap = mockCache;
    $c57c2d923541d0e8$var$fromCSSFile = fromFile;
}
function $c57c2d923541d0e8$export$18298bb220d85216() {
    if (!$c57c2d923541d0e8$var$cachePathMap) {
        $c57c2d923541d0e8$var$cachePathMap = {};
        if ((0, $8Vh6n.default)()) {
            var div = document.createElement('div');
            div.className = $c57c2d923541d0e8$export$1c054aa01963e47e;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach(function(item) {
                var _item$split = item.split(':'), _item$split2 = (0, $kelIR.default)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $c57c2d923541d0e8$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($c57c2d923541d0e8$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $c57c2d923541d0e8$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $c57c2d923541d0e8$export$5aa0d776d676ab98(path) {
    $c57c2d923541d0e8$export$18298bb220d85216();
    return !!$c57c2d923541d0e8$var$cachePathMap[path];
}
function $c57c2d923541d0e8$export$d3851dfd3659b2ce(path) {
    var hash = $c57c2d923541d0e8$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $8Vh6n.default)()) {
        if ($c57c2d923541d0e8$var$fromCSSFile) styleStr = $c57c2d923541d0e8$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $6M602.ATTR_MARK), "=\"").concat($c57c2d923541d0e8$var$cachePathMap[path], "\"]"));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $c57c2d923541d0e8$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}

});




parcelRegister("Zo2YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b8859db1169b609$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");
var $0b8859db1169b609$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $dYVVZ.default)(this, Keyframe);
        (0, $br1G4.default)(this, "name", void 0);
        (0, $br1G4.default)(this, "style", void 0);
        (0, $br1G4.default)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $hevvH.default)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $0b8859db1169b609$export$2e2bcd8739ae039 = $0b8859db1169b609$var$Keyframe;

});

parcelRegister("4mVYk", function(module, exports) {

var $kelIR = parcelRequire("kelIR");
function $32e62f879c3c9907$var$splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes('(') || item.includes(')')) {
                var left = item.split('(').length - 1;
                var right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $32e62f879c3c9907$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $32e62f879c3c9907$var$keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: $32e62f879c3c9907$var$noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: $32e62f879c3c9907$var$noSplit([
        'borderTop'
    ]),
    borderBlockEnd: $32e62f879c3c9907$var$noSplit([
        'borderBottom'
    ]),
    borderInline: $32e62f879c3c9907$var$noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: $32e62f879c3c9907$var$noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: $32e62f879c3c9907$var$noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function $32e62f879c3c9907$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $32e62f879c3c9907$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $32e62f879c3c9907$var$keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                var _splitValues = $32e62f879c3c9907$var$splitValues(value), _splitValues2 = (0, $kelIR.default)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $32e62f879c3c9907$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $32e62f879c3c9907$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $32e62f879c3c9907$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $32e62f879c3c9907$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $32e62f879c3c9907$export$2e2bcd8739ae039 = $32e62f879c3c9907$var$transform;

});

parcelRegister("4i6U4", function(module, exports) {

var $kelIR = parcelRequire("kelIR");

var $4f2X8 = parcelRequire("4f2X8");

var $bHUcK = parcelRequire("bHUcK");
var $31fe32b6576a6059$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $31fe32b6576a6059$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $31fe32b6576a6059$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $31fe32b6576a6059$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $4f2X8.default)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $kelIR.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === 'string' && value.includes('px')) {
                var newValue = value.replace($31fe32b6576a6059$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $bHUcK.default)[key] && typeof value === 'number' && value !== 0) clone[key] = "".concat(value, "px").replace($31fe32b6576a6059$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                var newKey = key.replace($31fe32b6576a6059$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $31fe32b6576a6059$export$2e2bcd8739ae039 = $31fe32b6576a6059$var$transform;

});


parcelRegister("acNyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $76e17873d7e04c49$export$2e2bcd8739ae039);
$parcel$export(module.exports, "merge", () => $76e17873d7e04c49$export$4950aa0f605343fb);

var $7IgoF = parcelRequire("7IgoF");

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $gQWqK = parcelRequire("gQWqK");

var $fGBDZ = parcelRequire("fGBDZ");
function $76e17873d7e04c49$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $gQWqK.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $dMbbs.default)(entity);
    else clone = (0, $4f2X8.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $76e17873d7e04c49$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $76e17873d7e04c49$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $fGBDZ.default)(entity, paths.slice(0, -1))) return entity;
    return $76e17873d7e04c49$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $76e17873d7e04c49$var$isObject(obj) {
    return (0, $7IgoF.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $76e17873d7e04c49$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $76e17873d7e04c49$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $76e17873d7e04c49$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $76e17873d7e04c49$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $fGBDZ.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $76e17873d7e04c49$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $fGBDZ.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $76e17873d7e04c49$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $7IgoF.default)(originValue) !== 'object') // Init container if not exist
                    clone = $76e17873d7e04c49$export$2e2bcd8739ae039(clone, path, $76e17873d7e04c49$var$createEmpty(value));
                    $76e17873d7e04c49$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $dMbbs.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $76e17873d7e04c49$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

});
parcelRegister("gQWqK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c44ed3c122262b16$export$2e2bcd8739ae039);

var $741lX = parcelRequire("741lX");

var $k1M0z = parcelRequire("k1M0z");

var $eBUQ0 = parcelRequire("eBUQ0");

var $7w8t2 = parcelRequire("7w8t2");
function $c44ed3c122262b16$export$2e2bcd8739ae039(r) {
    return (0, $741lX.default)(r) || (0, $k1M0z.default)(r) || (0, $eBUQ0.default)(r) || (0, $7w8t2.default)();
}

});

parcelRegister("fGBDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6b7fa91572597da$export$2e2bcd8739ae039);
function $b6b7fa91572597da$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

});


parcelRegister("dkjPS", function(module, exports) {

$parcel$export(module.exports, "WarningContext", () => $9b3c8791dd2f4187$export$11b88c75b33aa1fd);
$parcel$export(module.exports, "devUseWarning", () => $9b3c8791dd2f4187$export$cf977aa92c751e61);

var $aqdBs = parcelRequire("aqdBs");

var $i7X5i = parcelRequire("i7X5i");
function $9b3c8791dd2f4187$export$8793edee2d425525() {}
let $9b3c8791dd2f4187$var$deprecatedWarnList = null;
function $9b3c8791dd2f4187$export$60eef1277fe463e4() {
    $9b3c8791dd2f4187$var$deprecatedWarnList = null;
    (0, $i7X5i.resetWarned)();
}
let $9b3c8791dd2f4187$var$warning = $9b3c8791dd2f4187$export$8793edee2d425525;
var $9b3c8791dd2f4187$var$valid, $9b3c8791dd2f4187$var$component, $9b3c8791dd2f4187$var$message;
const $9b3c8791dd2f4187$export$11b88c75b33aa1fd = /*#__PURE__*/ $aqdBs.createContext({});
const $9b3c8791dd2f4187$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $9b3c8791dd2f4187$export$8793edee2d425525;
    return noopWarning;
};
var $9b3c8791dd2f4187$export$2e2bcd8739ae039 = $9b3c8791dd2f4187$var$warning;

});

parcelRegister("79Tx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $5364735eaec019f3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$5364735eaec019f3$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $aqdBs.createContext)(undefined);

});

parcelRegister("3zIQU", function(module, exports) {

$parcel$export(module.exports, "ANT_MARK", () => $29a76eb83841da82$export$b2f162cd5c15ea3e);
$parcel$export(module.exports, "default", () => $29a76eb83841da82$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");


var $k3aBe = parcelRequire("k3aBe");

var $eJWTa = parcelRequire("eJWTa");

var $h1ynd = parcelRequire("h1ynd");
"use client";
const $29a76eb83841da82$export$b2f162cd5c15ea3e = 'internalMark';
const $29a76eb83841da82$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $aqdBs.useEffect(()=>{
        const clearLocale = (0, $k3aBe.changeConfirmLocale)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $aqdBs.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $eJWTa.default).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $29a76eb83841da82$export$2e2bcd8739ae039 = $29a76eb83841da82$var$LocaleProvider;

});
parcelRegister("k3aBe", function(module, exports) {

$parcel$export(module.exports, "changeConfirmLocale", () => $e98c4f47a0313abd$export$9485ecb9d81a550c);
$parcel$export(module.exports, "getConfirmLocale", () => $e98c4f47a0313abd$export$1b6004afda18cd51);

var $iPGr2 = parcelRequire("iPGr2");
let $e98c4f47a0313abd$var$runtimeLocale = Object.assign({}, (0, $iPGr2.default).Modal);
let $e98c4f47a0313abd$var$localeList = [];
const $e98c4f47a0313abd$var$generateLocale = ()=>$e98c4f47a0313abd$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $iPGr2.default).Modal);
function $e98c4f47a0313abd$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $e98c4f47a0313abd$var$localeList.push(cloneLocale);
        $e98c4f47a0313abd$var$runtimeLocale = $e98c4f47a0313abd$var$generateLocale();
        return ()=>{
            $e98c4f47a0313abd$var$localeList = $e98c4f47a0313abd$var$localeList.filter((locale)=>locale !== cloneLocale);
            $e98c4f47a0313abd$var$runtimeLocale = $e98c4f47a0313abd$var$generateLocale();
        };
    }
    $e98c4f47a0313abd$var$runtimeLocale = Object.assign({}, (0, $iPGr2.default).Modal);
}
function $e98c4f47a0313abd$export$1b6004afda18cd51() {
    return $e98c4f47a0313abd$var$runtimeLocale;
}

});
parcelRegister("iPGr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $db5de8263bd56201$export$2e2bcd8739ae039);

var $hodHE = parcelRequire("hodHE");

var $40u3G = parcelRequire("40u3G");

var $gYMIr = parcelRequire("gYMIr");

var $804N3 = parcelRequire("804N3");
const $db5de8263bd56201$var$typeTemplate = '${label} is not a valid ${type}';
const $db5de8263bd56201$var$localeValues = {
    locale: 'en',
    Pagination: $hodHE.default,
    DatePicker: $gYMIr.default,
    TimePicker: $804N3.default,
    Calendar: $40u3G.default,
    global: {
        placeholder: 'Please select',
        close: 'Close'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: $db5de8263bd56201$var$typeTemplate,
                method: $db5de8263bd56201$var$typeTemplate,
                array: $db5de8263bd56201$var$typeTemplate,
                object: $db5de8263bd56201$var$typeTemplate,
                number: $db5de8263bd56201$var$typeTemplate,
                date: $db5de8263bd56201$var$typeTemplate,
                boolean: $db5de8263bd56201$var$typeTemplate,
                integer: $db5de8263bd56201$var$typeTemplate,
                float: $db5de8263bd56201$var$typeTemplate,
                regexp: $db5de8263bd56201$var$typeTemplate,
                email: $db5de8263bd56201$var$typeTemplate,
                url: $db5de8263bd56201$var$typeTemplate,
                hex: $db5de8263bd56201$var$typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    Image: {
        preview: 'Preview'
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
var $db5de8263bd56201$export$2e2bcd8739ae039 = $db5de8263bd56201$var$localeValues;

});
parcelRegister("hodHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8f4ead0357a202$export$2e2bcd8739ae039);
var $ca8f4ead0357a202$var$locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
var $ca8f4ead0357a202$export$2e2bcd8739ae039 = $ca8f4ead0357a202$var$locale;

});

parcelRegister("40u3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eae7a78751d6e94$export$2e2bcd8739ae039);

var $gYMIr = parcelRequire("gYMIr");
var $2eae7a78751d6e94$export$2e2bcd8739ae039 = (0, $gYMIr.default);

});
parcelRegister("gYMIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c809e5724ff5d1$export$2e2bcd8739ae039);

var $6hsoi = parcelRequire("6hsoi");

var $804N3 = parcelRequire("804N3");
// Merge into a locale object
const $c5c809e5724ff5d1$var$locale = {
    lang: Object.assign({
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ]
    }, (0, $6hsoi.default)),
    timePickerLocale: Object.assign({}, (0, $804N3.default))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$c5c809e5724ff5d1$export$2e2bcd8739ae039 = $c5c809e5724ff5d1$var$locale;

});
parcelRegister("6hsoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $492a5a6ecd6e3de7$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $hxx3d = parcelRequire("hxx3d");
var $492a5a6ecd6e3de7$var$locale = (0, $4f2X8.default)((0, $4f2X8.default)({}, (0, $hxx3d.commonLocale)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    dateFormat: 'M/D/YYYY',
    dateTimeFormat: 'M/D/YYYY HH:mm:ss',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
var $492a5a6ecd6e3de7$export$2e2bcd8739ae039 = $492a5a6ecd6e3de7$var$locale;

});
parcelRegister("hxx3d", function(module, exports) {

$parcel$export(module.exports, "commonLocale", () => $cc4f27ecdea89cb5$export$bdd78c3fd9633c1e);
var $cc4f27ecdea89cb5$export$bdd78c3fd9633c1e = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};

});


parcelRegister("804N3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d320a11a7ccb3a9$export$2e2bcd8739ae039);
const $5d320a11a7ccb3a9$var$locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
var $5d320a11a7ccb3a9$export$2e2bcd8739ae039 = $5d320a11a7ccb3a9$var$locale;

});





parcelRegister("eJWTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb2f2ba12345082$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
const $abb2f2ba12345082$var$LocaleContext = /*#__PURE__*/ (0, $aqdBs.createContext)(undefined);
var $abb2f2ba12345082$export$2e2bcd8739ae039 = $abb2f2ba12345082$var$LocaleContext;

});

parcelRegister("h1ynd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64d318451170ab3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $eJWTa = parcelRequire("eJWTa");

var $iPGr2 = parcelRequire("iPGr2");
const $c64d318451170ab3$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $aqdBs.useContext((0, $eJWTa.default));
    const getLocale = $aqdBs.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $iPGr2.default)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $aqdBs.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $iPGr2.default).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $c64d318451170ab3$export$2e2bcd8739ae039 = $c64d318451170ab3$var$useLocale;

});


parcelRegister("dWyN5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a26baddea454258e$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $4wnj3 = parcelRequire("4wnj3");

var $j3WK9 = parcelRequire("j3WK9");
const $a26baddea454258e$var$defaultTheme = (0, $4wnj3.default)((0, $j3WK9.default));
var $a26baddea454258e$export$2e2bcd8739ae039 = $a26baddea454258e$var$defaultTheme;

});
parcelRegister("j3WK9", function(module, exports) {

$parcel$export(module.exports, "default", () => $de0bdd5e3613cf10$export$2e2bcd8739ae039);
parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");
var $8mnLo = parcelRequire("8mnLo");

var $l15Kx = parcelRequire("l15Kx");

var $inLzo = parcelRequire("inLzo");

var $kyxrH = parcelRequire("kyxrH");

var $DeCMq = parcelRequire("DeCMq");

var $hNSjw = parcelRequire("hNSjw");

var $4mV7g = parcelRequire("4mV7g");

var $aWY8V = parcelRequire("aWY8V");
function $de0bdd5e3613cf10$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $8mnLo.presetPrimaryColors).pink = (0, $8mnLo.presetPrimaryColors).magenta;
    (0, $8mnLo.presetPalettes).pink = (0, $8mnLo.presetPalettes).magenta;
    const colorPalettes = Object.keys((0, $l15Kx.defaultPresetColors)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $8mnLo.presetPrimaryColors)[colorKey] ? (0, $8mnLo.presetPalettes)[colorKey] : (0, $7oyKr.default)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $inLzo.default)(token, {
        generateColorPalettes: $aWY8V.generateColorPalettes,
        generateNeutralColorPalettes: $aWY8V.generateNeutralColorPalettes
    })), (0, $hNSjw.default)(token.fontSize)), (0, $4mV7g.default)(token)), (0, $DeCMq.default)(token)), (0, $kyxrH.default)(token));
}

});
parcelRegister("l15Kx", function(module, exports) {

$parcel$export(module.exports, "defaultPresetColors", () => $f4ce26b5722b7772$export$37e27b43af4d16eb);
$parcel$export(module.exports, "default", () => $f4ce26b5722b7772$export$2e2bcd8739ae039);
const $f4ce26b5722b7772$export$37e27b43af4d16eb = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const $f4ce26b5722b7772$var$seedToken = Object.assign(Object.assign({}, $f4ce26b5722b7772$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $f4ce26b5722b7772$export$2e2bcd8739ae039 = $f4ce26b5722b7772$var$seedToken;

});

parcelRegister("inLzo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d61f46602079f721$export$2e2bcd8739ae039);
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
function $d61f46602079f721$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $bkcIW.FastColor)(errorColors[1]).mix(new (0, $bkcIW.FastColor)(errorColors[3]), 50).toHexString();
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $bkcIW.FastColor)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    });
}

});

parcelRegister("kyxrH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef70ed437ba973e1$export$2e2bcd8739ae039);

var $fh4Dy = parcelRequire("fh4Dy");
function $ef70ed437ba973e1$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $fh4Dy.default)(borderRadius));
}

});
parcelRegister("fh4Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1ec0a5e9ad05234$export$2e2bcd8739ae039);
const $b1ec0a5e9ad05234$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $b1ec0a5e9ad05234$export$2e2bcd8739ae039 = $b1ec0a5e9ad05234$var$genRadius;

});


parcelRegister("DeCMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $075efcc049ed0150$export$2e2bcd8739ae039);
const $075efcc049ed0150$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $075efcc049ed0150$export$2e2bcd8739ae039 = $075efcc049ed0150$var$genControlHeight;

});

parcelRegister("hNSjw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf6124e11e7895ea$export$2e2bcd8739ae039);

var $cwoZg = parcelRequire("cwoZg");
const $cf6124e11e7895ea$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $cwoZg.default)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $cf6124e11e7895ea$export$2e2bcd8739ae039 = $cf6124e11e7895ea$var$genFontMapToken;

});
parcelRegister("cwoZg", function(module, exports) {

$parcel$export(module.exports, "getLineHeight", () => $91dbdb1ff694b119$export$56204a27a2958a55);
$parcel$export(module.exports, "default", () => $91dbdb1ff694b119$export$2e2bcd8739ae039);
function $91dbdb1ff694b119$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $91dbdb1ff694b119$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $91dbdb1ff694b119$export$56204a27a2958a55(size)
        }));
}

});


parcelRegister("4mV7g", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e5858d80736822$export$2e2bcd8739ae039);
function $32e5858d80736822$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}

});

parcelRegister("aWY8V", function(module, exports) {

$parcel$export(module.exports, "generateColorPalettes", () => $7f8df947f64519fb$export$da275153033f4ec1);
$parcel$export(module.exports, "generateNeutralColorPalettes", () => $7f8df947f64519fb$export$3e0cb0c1d9c1b691);
parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");

var $dECRO = parcelRequire("dECRO");
const $7f8df947f64519fb$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $7oyKr.default)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $7f8df947f64519fb$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $dECRO.getAlphaColor)(colorTextBase, 0.88),
        colorTextSecondary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.65),
        colorTextTertiary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.25),
        colorFill: (0, $dECRO.getAlphaColor)(colorTextBase, 0.15),
        colorFillSecondary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.06),
        colorFillTertiary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $dECRO.getAlphaColor)(colorTextBase, 0.02),
        colorBgSolid: (0, $dECRO.getAlphaColor)(colorTextBase, 1),
        colorBgSolidHover: (0, $dECRO.getAlphaColor)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $dECRO.getAlphaColor)(colorTextBase, 0.95),
        colorBgLayout: (0, $dECRO.getSolidColor)(colorBgBase, 4),
        colorBgContainer: (0, $dECRO.getSolidColor)(colorBgBase, 0),
        colorBgElevated: (0, $dECRO.getSolidColor)(colorBgBase, 0),
        colorBgSpotlight: (0, $dECRO.getAlphaColor)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, $dECRO.getSolidColor)(colorBgBase, 15),
        colorBorderSecondary: (0, $dECRO.getSolidColor)(colorBgBase, 6)
    };
};

});
parcelRegister("dECRO", function(module, exports) {

$parcel$export(module.exports, "getAlphaColor", () => $9f0d28edd26fa9c6$export$31f6399ba7ce6bea);
$parcel$export(module.exports, "getSolidColor", () => $9f0d28edd26fa9c6$export$7003a8a990e79359);
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
const $9f0d28edd26fa9c6$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $bkcIW.FastColor)(baseColor).setA(alpha).toRgbString();
const $9f0d28edd26fa9c6$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $bkcIW.FastColor)(baseColor);
    return instance.darken(brightness).toHexString();
};

});




parcelRegister("j22ew", function(module, exports) {

$parcel$export(module.exports, "defaultConfig", () => $ddafefb87b174e99$export$f84bd70098573c5c);
$parcel$export(module.exports, "DesignTokenContext", () => $ddafefb87b174e99$export$69b0ebb9efcddb30);

var $aqdBs = parcelRequire("aqdBs");

var $l15Kx = parcelRequire("l15Kx");

var $dWyN5 = parcelRequire("dWyN5");
const $ddafefb87b174e99$export$f84bd70098573c5c = {
    token: (0, $l15Kx.default),
    override: {
        override: (0, $l15Kx.default)
    },
    hashed: true
};
const $ddafefb87b174e99$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext($ddafefb87b174e99$export$f84bd70098573c5c);

});

parcelRegister("kjlvF", function(module, exports) {

$parcel$export(module.exports, "defaultPrefixCls", () => $ec9644641b2ba3a7$export$e4ec87ea71f29b41);
$parcel$export(module.exports, "defaultIconPrefixCls", () => $ec9644641b2ba3a7$export$eaca8ee5ed21b4e9);
$parcel$export(module.exports, "Variants", () => $ec9644641b2ba3a7$export$fa216ce2679a073b);
$parcel$export(module.exports, "ConfigContext", () => $ec9644641b2ba3a7$export$a92f85ab3e9ad68b);
$parcel$export(module.exports, "useComponentConfig", () => $ec9644641b2ba3a7$export$46f4bd6436a25a31);

var $aqdBs = parcelRequire("aqdBs");
const $ec9644641b2ba3a7$export$e4ec87ea71f29b41 = 'ant';
const $ec9644641b2ba3a7$export$eaca8ee5ed21b4e9 = 'anticon';
const $ec9644641b2ba3a7$export$fa216ce2679a073b = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const $ec9644641b2ba3a7$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$ec9644641b2ba3a7$export$e4ec87ea71f29b41}-${suffixCls}` : $ec9644641b2ba3a7$export$e4ec87ea71f29b41;
};
const $ec9644641b2ba3a7$export$a92f85ab3e9ad68b = /*#__PURE__*/ $aqdBs.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $ec9644641b2ba3a7$var$defaultGetPrefixCls,
    iconPrefixCls: $ec9644641b2ba3a7$export$eaca8ee5ed21b4e9
});
const { Consumer: $ec9644641b2ba3a7$export$cd5442f2b8da7663 } = $ec9644641b2ba3a7$export$a92f85ab3e9ad68b;
const $ec9644641b2ba3a7$var$EMPTY_OBJECT = {};
function $ec9644641b2ba3a7$export$46f4bd6436a25a31(propName) {
    const context = $aqdBs.useContext($ec9644641b2ba3a7$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer } = context;
    const propValue = context[propName];
    return Object.assign(Object.assign({
        classNames: $ec9644641b2ba3a7$var$EMPTY_OBJECT,
        styles: $ec9644641b2ba3a7$var$EMPTY_OBJECT
    }, propValue), {
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer
    });
}

});

parcelRegister("3CGdL", function(module, exports) {

$parcel$export(module.exports, "registerTheme", () => $2a35abe9937bf139$export$f9c59eed5de5ff80);
parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");

var $8Vh6n = parcelRequire("8Vh6n");

var $98AgF = parcelRequire("98AgF");

const $2a35abe9937bf139$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $2a35abe9937bf139$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $bkcIW.FastColor)(colorVal);
        const colorPalettes = (0, $7oyKr.default)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setA(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, 'primary');
        const primaryColor = new (0, $bkcIW.FastColor)(theme.primaryColor);
        const primaryColors = (0, $7oyKr.default)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables['primary-color-deprecated-l-35'] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables['primary-color-deprecated-l-20'] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables['primary-color-deprecated-t-20'] = formatColor(primaryColor, (c)=>c.tint(20));
        variables['primary-color-deprecated-t-50'] = formatColor(primaryColor, (c)=>c.tint(50));
        variables['primary-color-deprecated-f-12'] = formatColor(primaryColor, (c)=>c.setA(c.a * 0.12));
        const primaryActiveColor = new (0, $bkcIW.FastColor)(primaryColors[0]);
        variables['primary-color-active-deprecated-f-30'] = formatColor(primaryActiveColor, (c)=>c.setA(c.a * 0.3));
        variables['primary-color-active-deprecated-d-02'] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, 'success');
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, 'warning');
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, 'error');
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, 'info');
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join('\n')}
  }
  `.trim();
}
function $2a35abe9937bf139$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $2a35abe9937bf139$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $8Vh6n.default)()) (0, $98AgF.updateCSS)(style, `${$2a35abe9937bf139$var$dynamicStyleMark}-dynamic-theme`);
}

});

parcelRegister("bpKJo", function(module, exports) {

$parcel$export(module.exports, "DisabledContextProvider", () => $022501269efee3c2$export$6adb5f3b918b11bb);
$parcel$export(module.exports, "default", () => $022501269efee3c2$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
"use client";
const $022501269efee3c2$var$DisabledContext = /*#__PURE__*/ $aqdBs.createContext(false);
const $022501269efee3c2$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $aqdBs.useContext($022501269efee3c2$var$DisabledContext);
    return /*#__PURE__*/ $aqdBs.createElement($022501269efee3c2$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $022501269efee3c2$export$2e2bcd8739ae039 = $022501269efee3c2$var$DisabledContext;

});

parcelRegister("9ddCs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b4fe4719e43224e$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bpKJo = parcelRequire("bpKJo");

var $fo0uV = parcelRequire("fo0uV");
function $6b4fe4719e43224e$var$useConfig() {
    const componentDisabled = (0, $aqdBs.useContext)((0, $bpKJo.default));
    const componentSize = (0, $aqdBs.useContext)((0, $fo0uV.default));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $6b4fe4719e43224e$export$2e2bcd8739ae039 = $6b4fe4719e43224e$var$useConfig;

});
parcelRegister("fo0uV", function(module, exports) {

$parcel$export(module.exports, "SizeContextProvider", () => $b3397bbd87a9689c$export$dbc92d89fabc8ebe);
$parcel$export(module.exports, "default", () => $b3397bbd87a9689c$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
"use client";
const $b3397bbd87a9689c$var$SizeContext = /*#__PURE__*/ $aqdBs.createContext(undefined);
const $b3397bbd87a9689c$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $aqdBs.useContext($b3397bbd87a9689c$var$SizeContext);
    return /*#__PURE__*/ $aqdBs.createElement($b3397bbd87a9689c$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $b3397bbd87a9689c$export$2e2bcd8739ae039 = $b3397bbd87a9689c$var$SizeContext;

});


parcelRegister("c6v8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cfe326aff35024a$export$2e2bcd8739ae039);

var $9nP3o = parcelRequire("9nP3o");

var $aTirs = parcelRequire("aTirs");

var $dkjPS = parcelRequire("dkjPS");

var $j22ew = parcelRequire("j22ew");

var $dQECg = parcelRequire("dQECg");
function $8cfe326aff35024a$export$2e2bcd8739ae039(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $dkjPS.devUseWarning)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, (0, $j22ew.defaultConfig)), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : (0, $j22ew.defaultConfig).hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $dQECg.default)();
    return (0, $9nP3o.default)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === 'object' ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === 'object' ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === 'object' && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $aTirs.default)(prevTheme, nextTheme, true);
        }));
}

});
parcelRegister("dQECg", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14fa337fc2d8d3f$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
const $a14fa337fc2d8d3f$var$fullClone = Object.assign({}, $aqdBs);
const { useId: $a14fa337fc2d8d3f$var$useId } = $a14fa337fc2d8d3f$var$fullClone;
const $a14fa337fc2d8d3f$var$useEmptyId = ()=>'';
const $a14fa337fc2d8d3f$var$useThemeKey = typeof $a14fa337fc2d8d3f$var$useId === 'undefined' ? $a14fa337fc2d8d3f$var$useEmptyId : $a14fa337fc2d8d3f$var$useId;
var $a14fa337fc2d8d3f$export$2e2bcd8739ae039 = $a14fa337fc2d8d3f$var$useThemeKey;

});


parcelRegister("b4Uzj", function(module, exports) {

$parcel$export(module.exports, "default", () => $810bf2c917f6bb8c$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("6ufPd");
var $6w31h = parcelRequire("6w31h");

var $jygCN = parcelRequire("jygCN");
"use client";
const $810bf2c917f6bb8c$var$MotionCacheContext = /*#__PURE__*/ $aqdBs.createContext(true);
function $810bf2c917f6bb8c$export$2e2bcd8739ae039(props) {
    const parentMotion = $aqdBs.useContext($810bf2c917f6bb8c$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $jygCN.default)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $aqdBs.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $aqdBs.createElement($810bf2c917f6bb8c$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $aqdBs.createElement((0, $6w31h.default), {
        motion: motion
    }, children));
    return children;
}

});
parcelRegister("6ufPd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b91d1f076eb0e35$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Provider", () => (parcelRequire("6w31h")).default);
$parcel$export(module.exports, "CSSMotionList", () => (parcelRequire("eSxAB")).default);

var $2fpcT = parcelRequire("2fpcT");

var $eSxAB = parcelRequire("eSxAB");

var $6w31h = parcelRequire("6w31h");
var $4b91d1f076eb0e35$export$2e2bcd8739ae039 = (0, $2fpcT.default);

});
parcelRegister("2fpcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a30890980b8eb4a$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $7IgoF = parcelRequire("7IgoF");

var $bqPQ9 = parcelRequire("bqPQ9");

var $bTIJW = parcelRequire("bTIJW");

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");

var $6w31h = parcelRequire("6w31h");

var $6g8Ti = parcelRequire("6g8Ti");

var $1rpEZ = parcelRequire("1rpEZ");

var $eLs3p = parcelRequire("eLs3p");

var $8ipdf = parcelRequire("8ipdf");

var $cr9rC = parcelRequire("cr9rC");
function $1a30890980b8eb4a$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $7IgoF.default)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $aqdBs.useContext((0, $6w31h.Context)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $aqdBs.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $aqdBs.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $bTIJW.default)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $1rpEZ.default)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $kelIR.default)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $aqdBs.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $aqdBs.useCallback(function(node) {
            nodeRef.current = node;
            (0, $kBwE8.fillRef)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $4f2X8.default)((0, $4f2X8.default)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $8ipdf.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $4f2X8.default)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $4f2X8.default)((0, $4f2X8.default)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $4f2X8.default)((0, $4f2X8.default)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $8ipdf.STEP_PREPARE)) statusSuffix = 'prepare';
            else if ((0, $eLs3p.isActive)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $8ipdf.STEP_START)) statusSuffix = 'start';
            var motionCls = (0, $cr9rC.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $4f2X8.default)((0, $4f2X8.default)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))((0, $cr9rC.getTransitionName)(motionName, status), (0, $br1G4.default)((0, $br1G4.default)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $aqdBs.isValidElement(motionChildren) && (0, $kBwE8.supportRef)(motionChildren)) {
            var originNodeRef = (0, $kBwE8.getNodeRef)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $aqdBs.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $aqdBs.createElement((0, $6g8Ti.default), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $1a30890980b8eb4a$export$2e2bcd8739ae039 = $1a30890980b8eb4a$export$e265d52a86a9f199((0, $cr9rC.supportTransition));

});
parcelRegister("bTIJW", function(module, exports) {

$parcel$export(module.exports, "isDOM", () => $8a978936ed19c92b$export$41e30d8dd0ba7a50);
$parcel$export(module.exports, "getDOM", () => $8a978936ed19c92b$export$9aa546fdc20ae5b3);
$parcel$export(module.exports, "default", () => $8a978936ed19c92b$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");
function $8a978936ed19c92b$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $8a978936ed19c92b$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $7IgoF.default)(node) === 'object' && $8a978936ed19c92b$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($8a978936ed19c92b$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $8a978936ed19c92b$export$2e2bcd8739ae039(node) {
    var domNode = $8a978936ed19c92b$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($jVlfX))), node);
    }
    return null;
}

});

parcelRegister("6w31h", function(module, exports) {

$parcel$export(module.exports, "Context", () => $4be812e00ba64e45$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $4be812e00ba64e45$export$2e2bcd8739ae039);

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");
var $4be812e00ba64e45$var$_excluded = [
    "children"
];
var $4be812e00ba64e45$export$841858b892ce1f4c = /*#__PURE__*/ $aqdBs.createContext({});
function $4be812e00ba64e45$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $aX4Fp.default)(_ref, $4be812e00ba64e45$var$_excluded);
    return /*#__PURE__*/ $aqdBs.createElement($4be812e00ba64e45$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}

});

parcelRegister("6g8Ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $48eb22439beee009$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $aqdBs = parcelRequire("aqdBs");
var $48eb22439beee009$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $9nc35.default)(DomWrapper, _React$Component);
    var _super = (0, $lriWM.default)(DomWrapper);
    function DomWrapper() {
        (0, $dYVVZ.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $hevvH.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($aqdBs.Component);
var $48eb22439beee009$export$2e2bcd8739ae039 = $48eb22439beee009$var$DomWrapper;

});

parcelRegister("1rpEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cc379bb6d7ff8c$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $br1G4 = parcelRequire("br1G4");

var $kelIR = parcelRequire("kelIR");
parcelRequire("2UjQ5");
var $k91S5 = parcelRequire("k91S5");

var $7fRGY = parcelRequire("7fRGY");

var $hvpCg = parcelRequire("hvpCg");

var $aqdBs = parcelRequire("aqdBs");

var $8ipdf = parcelRequire("8ipdf");

var $coOUM = parcelRequire("coOUM");

var $vdufA = parcelRequire("vdufA");

var $eLs3p = parcelRequire("eLs3p");
function $10cc379bb6d7ff8c$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $7fRGY.default)(), _useState2 = (0, $kelIR.default)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $hvpCg.default)((0, $8ipdf.STATUS_NONE)), _useSyncState2 = (0, $kelIR.default)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $7fRGY.default)(null), _useState4 = (0, $kelIR.default)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $aqdBs.useRef)(false);
    var deadlineRef = (0, $aqdBs.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $aqdBs.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $8ipdf.STATUS_NONE));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $k91S5.default)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $8ipdf.STATUS_NONE)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $8ipdf.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $8ipdf.STATUS_ENTER) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $8ipdf.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $coOUM.default)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $kelIR.default)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $8ipdf.STATUS_APPEAR:
                return (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, (0, $8ipdf.STEP_PREPARE), onAppearPrepare), (0, $8ipdf.STEP_START), onAppearStart), (0, $8ipdf.STEP_ACTIVE), onAppearActive);
            case 0, $8ipdf.STATUS_ENTER:
                return (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, (0, $8ipdf.STEP_PREPARE), onEnterPrepare), (0, $8ipdf.STEP_START), onEnterStart), (0, $8ipdf.STEP_ACTIVE), onEnterActive);
            case 0, $8ipdf.STATUS_LEAVE:
                return (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, (0, $8ipdf.STEP_PREPARE), onLeavePrepare), (0, $8ipdf.STEP_START), onLeaveStart), (0, $8ipdf.STEP_ACTIVE), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $aqdBs.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $eLs3p.default)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $8ipdf.STEP_PREPARE)) {
            var onPrepare = eventHandlers[0, $8ipdf.STEP_PREPARE];
            if (!onPrepare) return 0, $eLs3p.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $8ipdf.STEP_ACTIVE) && currentStatus !== (0, $8ipdf.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $8ipdf.STEP_PREPARED)) updateMotionEndStatus();
        return 0, $eLs3p.DoStep;
    }), _useStepQueue2 = (0, $kelIR.default)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $eLs3p.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $aqdBs.useRef)(null);
    // Update with new status
    (0, $vdufA.default)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $8ipdf.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $8ipdf.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $8ipdf.STATUS_LEAVE);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $8ipdf.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $8ipdf.STATUS_NONE));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $aqdBs.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $8ipdf.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, $8ipdf.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, $8ipdf.STATUS_LEAVE) && !motionLeave) setStatus((0, $8ipdf.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $aqdBs.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $aqdBs.useRef(false);
    (0, $aqdBs.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $8ipdf.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $8ipdf.STEP_PREPARE] && step === (0, $8ipdf.STEP_START)) mergedStyle = (0, $4f2X8.default)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}

});
parcelRegister("2UjQ5", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => (parcelRequire("k91S5")).default);
$parcel$export(module.exports, "useMergedState", () => (parcelRequire("eAKDF")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("fGBDZ")).default);
$parcel$export(module.exports, "set", () => (parcelRequire("acNyW")).default);

var $k91S5 = parcelRequire("k91S5");

var $eAKDF = parcelRequire("eAKDF");

var $kBwE8 = parcelRequire("kBwE8");

var $fGBDZ = parcelRequire("fGBDZ");

var $acNyW = parcelRequire("acNyW");

var $i7X5i = parcelRequire("i7X5i");

});
parcelRegister("k91S5", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaa61984414f8688$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $eaa61984414f8688$export$2e2bcd8739ae039(callback) {
    var fnRef = $aqdBs.useRef();
    fnRef.current = callback;
    var memoFn = $aqdBs.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

});

parcelRegister("eAKDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9f89afd4c8e65cc$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $k91S5 = parcelRequire("k91S5");

var $iEJaB = parcelRequire("iEJaB");

var $7fRGY = parcelRequire("7fRGY");
/** We only think `undefined` is empty */ function $a9f89afd4c8e65cc$var$hasValue(value) {
    return value !== undefined;
}
function $a9f89afd4c8e65cc$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $7fRGY.default)(function() {
        if ($a9f89afd4c8e65cc$var$hasValue(value)) return value;
        else if ($a9f89afd4c8e65cc$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $kelIR.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $k91S5.default)(onChange);
    var _useState3 = (0, $7fRGY.default)([
        mergedValue
    ]), _useState4 = (0, $kelIR.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $iEJaB.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $iEJaB.useLayoutUpdateEffect)(function() {
        if (!$a9f89afd4c8e65cc$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $k91S5.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

});
parcelRegister("7fRGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $54839544bc297466$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");
function $54839544bc297466$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $aqdBs.useRef(false);
    var _React$useState = $aqdBs.useState(defaultValue), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $aqdBs.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

});



parcelRegister("hvpCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe933be7b1aa358$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $k91S5 = parcelRequire("k91S5");
function $cbe933be7b1aa358$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $aqdBs.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $kelIR.default)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $aqdBs.useRef(defaultValue);
    var getValue = (0, $k91S5.default)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $k91S5.default)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

});

parcelRegister("8ipdf", function(module, exports) {

$parcel$export(module.exports, "STATUS_NONE", () => $60a38fe6e6c1a79f$export$de71442bbf2143da);
$parcel$export(module.exports, "STATUS_APPEAR", () => $60a38fe6e6c1a79f$export$4fc3521687bcacd2);
$parcel$export(module.exports, "STATUS_ENTER", () => $60a38fe6e6c1a79f$export$5d6af549241fe2e8);
$parcel$export(module.exports, "STATUS_LEAVE", () => $60a38fe6e6c1a79f$export$59b1c493d29f68e4);
$parcel$export(module.exports, "STEP_NONE", () => $60a38fe6e6c1a79f$export$40b34dd77d5522bf);
$parcel$export(module.exports, "STEP_PREPARE", () => $60a38fe6e6c1a79f$export$1b792916a5fac4fc);
$parcel$export(module.exports, "STEP_START", () => $60a38fe6e6c1a79f$export$9563153dd25a3ce8);
$parcel$export(module.exports, "STEP_ACTIVE", () => $60a38fe6e6c1a79f$export$e205886172277ec6);
$parcel$export(module.exports, "STEP_ACTIVATED", () => $60a38fe6e6c1a79f$export$3a846c3d2fac10b8);
$parcel$export(module.exports, "STEP_PREPARED", () => $60a38fe6e6c1a79f$export$98351fa4e6b4f204);
var $60a38fe6e6c1a79f$export$de71442bbf2143da = 'none';
var $60a38fe6e6c1a79f$export$4fc3521687bcacd2 = 'appear';
var $60a38fe6e6c1a79f$export$5d6af549241fe2e8 = 'enter';
var $60a38fe6e6c1a79f$export$59b1c493d29f68e4 = 'leave';
var $60a38fe6e6c1a79f$export$40b34dd77d5522bf = 'none';
var $60a38fe6e6c1a79f$export$1b792916a5fac4fc = 'prepare';
var $60a38fe6e6c1a79f$export$9563153dd25a3ce8 = 'start';
var $60a38fe6e6c1a79f$export$e205886172277ec6 = 'active';
var $60a38fe6e6c1a79f$export$3a846c3d2fac10b8 = 'end';
var $60a38fe6e6c1a79f$export$98351fa4e6b4f204 = 'prepared';

});

parcelRegister("coOUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $906f3886f975edf1$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $cr9rC = parcelRequire("cr9rC");
var $906f3886f975edf1$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $aqdBs.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $cr9rC.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, $cr9rC.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $cr9rC.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, $cr9rC.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $aqdBs.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

});
parcelRegister("cr9rC", function(module, exports) {

$parcel$export(module.exports, "supportTransition", () => $90df551c6c37bbd4$export$d28133ed3ad06c8b);
$parcel$export(module.exports, "animationEndName", () => $90df551c6c37bbd4$export$760cc9769c51b738);
$parcel$export(module.exports, "transitionEndName", () => $90df551c6c37bbd4$export$44baea64b8602e3c);
$parcel$export(module.exports, "getTransitionName", () => $90df551c6c37bbd4$export$27c72201b1d09951);

var $7IgoF = parcelRequire("7IgoF");

var $8Vh6n = parcelRequire("8Vh6n");
// ================= Transition =================
// Event wrapper. Copy from react source code
function $90df551c6c37bbd4$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $90df551c6c37bbd4$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $90df551c6c37bbd4$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $90df551c6c37bbd4$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $90df551c6c37bbd4$var$vendorPrefixes = $90df551c6c37bbd4$export$6e8b350b1a8958a0((0, $8Vh6n.default)(), typeof window !== 'undefined' ? window : {});
var $90df551c6c37bbd4$var$style = {};
if ((0, $8Vh6n.default)()) {
    var $90df551c6c37bbd4$var$_document$createEleme = document.createElement('div');
    $90df551c6c37bbd4$var$style = $90df551c6c37bbd4$var$_document$createEleme.style;
}
var $90df551c6c37bbd4$var$prefixedEventNames = {};
function $90df551c6c37bbd4$export$a032e4f39350c1d8(eventName) {
    if ($90df551c6c37bbd4$var$prefixedEventNames[eventName]) return $90df551c6c37bbd4$var$prefixedEventNames[eventName];
    var prefixMap = $90df551c6c37bbd4$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $90df551c6c37bbd4$var$style) {
                $90df551c6c37bbd4$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $90df551c6c37bbd4$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $90df551c6c37bbd4$var$internalAnimationEndName = $90df551c6c37bbd4$export$a032e4f39350c1d8('animationend');
var $90df551c6c37bbd4$var$internalTransitionEndName = $90df551c6c37bbd4$export$a032e4f39350c1d8('transitionend');
var $90df551c6c37bbd4$export$d28133ed3ad06c8b = !!($90df551c6c37bbd4$var$internalAnimationEndName && $90df551c6c37bbd4$var$internalTransitionEndName);
var $90df551c6c37bbd4$export$760cc9769c51b738 = $90df551c6c37bbd4$var$internalAnimationEndName || 'animationend';
var $90df551c6c37bbd4$export$44baea64b8602e3c = $90df551c6c37bbd4$var$internalTransitionEndName || 'transitionend';
function $90df551c6c37bbd4$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $7IgoF.default)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}

});


parcelRegister("vdufA", function(module, exports) {

$parcel$export(module.exports, "default", () => $05dd5b9592a78354$export$2e2bcd8739ae039);

var $8Vh6n = parcelRequire("8Vh6n");

var $aqdBs = parcelRequire("aqdBs");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $05dd5b9592a78354$var$useIsomorphicLayoutEffect = (0, $8Vh6n.default)() ? (0, $aqdBs.useLayoutEffect) : (0, $aqdBs.useEffect);
var $05dd5b9592a78354$export$2e2bcd8739ae039 = $05dd5b9592a78354$var$useIsomorphicLayoutEffect;

});

parcelRegister("eLs3p", function(module, exports) {

$parcel$export(module.exports, "SkipStep", () => $abfb37659817622f$export$c2029bf6cfdbc28a);
$parcel$export(module.exports, "DoStep", () => $abfb37659817622f$export$dbee1e282e8c4830);
$parcel$export(module.exports, "isActive", () => $abfb37659817622f$export$39e04e72f972b885);
$parcel$export(module.exports, "default", () => $abfb37659817622f$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $7fRGY = parcelRequire("7fRGY");

var $aqdBs = parcelRequire("aqdBs");

var $8ipdf = parcelRequire("8ipdf");

var $vdufA = parcelRequire("vdufA");

var $dHoeA = parcelRequire("dHoeA");
var $abfb37659817622f$var$FULL_STEP_QUEUE = [
    (0, $8ipdf.STEP_PREPARE),
    (0, $8ipdf.STEP_START),
    (0, $8ipdf.STEP_ACTIVE),
    (0, $8ipdf.STEP_ACTIVATED)
];
var $abfb37659817622f$var$SIMPLE_STEP_QUEUE = [
    (0, $8ipdf.STEP_PREPARE),
    (0, $8ipdf.STEP_PREPARED)
];
var $abfb37659817622f$export$c2029bf6cfdbc28a = false;
var $abfb37659817622f$export$dbee1e282e8c4830 = true;
function $abfb37659817622f$export$39e04e72f972b885(step) {
    return step === (0, $8ipdf.STEP_ACTIVE) || step === (0, $8ipdf.STEP_ACTIVATED);
}
var $abfb37659817622f$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $7fRGY.default)((0, $8ipdf.STEP_NONE)), _useState2 = (0, $kelIR.default)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dHoeA.default)(), _useNextFrame2 = (0, $kelIR.default)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $8ipdf.STEP_PREPARE), true);
    }
    var STEP_QUEUE = prepareOnly ? $abfb37659817622f$var$SIMPLE_STEP_QUEUE : $abfb37659817622f$var$FULL_STEP_QUEUE;
    (0, $vdufA.default)(function() {
        if (step !== (0, $8ipdf.STEP_NONE) && step !== (0, $8ipdf.STEP_ACTIVATED)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $abfb37659817622f$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $aqdBs.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};

});
parcelRegister("dHoeA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f9216f08323bccc$export$2e2bcd8739ae039);

var $ebavw = parcelRequire("ebavw");

var $aqdBs = parcelRequire("aqdBs");
var $9f9216f08323bccc$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $aqdBs.useRef(null);
    function cancelNextFrame() {
        (0, $ebavw.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $ebavw.default)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $aqdBs.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

});
parcelRegister("ebavw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a52a3e4de5dbe974$export$2e2bcd8739ae039);
var $a52a3e4de5dbe974$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a52a3e4de5dbe974$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $a52a3e4de5dbe974$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a52a3e4de5dbe974$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a52a3e4de5dbe974$var$rafUUID = 0;
var $a52a3e4de5dbe974$var$rafIds = new Map();
function $a52a3e4de5dbe974$var$cleanup(id) {
    $a52a3e4de5dbe974$var$rafIds.delete(id);
}
var $a52a3e4de5dbe974$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a52a3e4de5dbe974$var$rafUUID += 1;
    var id = $a52a3e4de5dbe974$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a52a3e4de5dbe974$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a52a3e4de5dbe974$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a52a3e4de5dbe974$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a52a3e4de5dbe974$var$wrapperRaf.cancel = function(id) {
    var realId = $a52a3e4de5dbe974$var$rafIds.get(id);
    $a52a3e4de5dbe974$var$cleanup(id);
    return $a52a3e4de5dbe974$var$caf(realId);
};
var $a52a3e4de5dbe974$export$2e2bcd8739ae039 = $a52a3e4de5dbe974$var$wrapperRaf;

});





parcelRegister("eSxAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5029f73a0206b0$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $4f2X8 = parcelRequire("4f2X8");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $aqdBs = parcelRequire("aqdBs");

var $2fpcT = parcelRequire("2fpcT");

var $1wbQR = parcelRequire("1wbQR");

var $cr9rC = parcelRequire("cr9rC");
var $ad5029f73a0206b0$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ad5029f73a0206b0$var$_excluded2 = [
    "status"
];
var $ad5029f73a0206b0$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $ad5029f73a0206b0$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2fpcT.default);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $9nc35.default)(CSSMotionList, _React$Component);
        var _super = (0, $lriWM.default)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $dYVVZ.default)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $br1G4.default)((0, $1FDZu.default)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $br1G4.default)((0, $1FDZu.default)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $4f2X8.default)((0, $4f2X8.default)({}, entity), {}, {
                            status: (0, $1wbQR.STATUS_REMOVED)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $1wbQR.STATUS_REMOVED);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $hevvH.default)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $aX4Fp.default)(_this$props, $ad5029f73a0206b0$var$_excluded);
                    var Component = component || $aqdBs.Fragment;
                    var motionProps = {};
                    $ad5029f73a0206b0$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $aqdBs.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $aX4Fp.default)(_ref2, $ad5029f73a0206b0$var$_excluded2);
                        var visible = status === (0, $1wbQR.STATUS_ADD) || status === (0, $1wbQR.STATUS_KEEP);
                        return /*#__PURE__*/ $aqdBs.createElement(CSSMotion, (0, $13KW1.default)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $4f2X8.default)((0, $4f2X8.default)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $1wbQR.parseKeys)(keys);
                    var mixedKeyEntities = (0, $1wbQR.diffKeys)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $1wbQR.STATUS_REMOVED) && entity.status === (0, $1wbQR.STATUS_REMOVE)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($aqdBs.Component);
    (0, $br1G4.default)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $ad5029f73a0206b0$export$2e2bcd8739ae039 = $ad5029f73a0206b0$export$fcfc62c1d33d5e2e((0, $cr9rC.supportTransition));

});
parcelRegister("1wbQR", function(module, exports) {

$parcel$export(module.exports, "STATUS_ADD", () => $11b1f90fb38a085a$export$3904baa009bc026e);
$parcel$export(module.exports, "STATUS_KEEP", () => $11b1f90fb38a085a$export$851162f0adad2cbc);
$parcel$export(module.exports, "STATUS_REMOVE", () => $11b1f90fb38a085a$export$c8b3fb08b68cfc85);
$parcel$export(module.exports, "STATUS_REMOVED", () => $11b1f90fb38a085a$export$2ac1bd1808d2e43a);
$parcel$export(module.exports, "parseKeys", () => $11b1f90fb38a085a$export$84bd7bd42ccc0f72);
$parcel$export(module.exports, "diffKeys", () => $11b1f90fb38a085a$export$14527669107aa301);

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");
var $11b1f90fb38a085a$export$3904baa009bc026e = 'add';
var $11b1f90fb38a085a$export$851162f0adad2cbc = 'keep';
var $11b1f90fb38a085a$export$c8b3fb08b68cfc85 = 'remove';
var $11b1f90fb38a085a$export$2ac1bd1808d2e43a = 'removed';
function $11b1f90fb38a085a$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $7IgoF.default)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $4f2X8.default)((0, $4f2X8.default)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $11b1f90fb38a085a$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($11b1f90fb38a085a$export$c47fd798e598c85c);
}
function $11b1f90fb38a085a$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $11b1f90fb38a085a$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $11b1f90fb38a085a$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $4f2X8.default)((0, $4f2X8.default)({}, obj), {}, {
                            status: $11b1f90fb38a085a$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $4f2X8.default)((0, $4f2X8.default)({}, currentKeyObj), {}, {
                    status: $11b1f90fb38a085a$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $4f2X8.default)((0, $4f2X8.default)({}, keyObj), {}, {
            status: $11b1f90fb38a085a$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, obj), {}, {
            status: $11b1f90fb38a085a$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $11b1f90fb38a085a$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $11b1f90fb38a085a$export$851162f0adad2cbc;
        });
    });
    return list;
}

});



parcelRegister("jygCN", function(module, exports) {

$parcel$export(module.exports, "unitless", () => $e3be16a42e77c175$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "default", () => $e3be16a42e77c175$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("g14b3");
var $5tHf5 = parcelRequire("5tHf5");

var $lN6FX = parcelRequire("lN6FX");

var $dWyN5 = parcelRequire("dWyN5");
var $j22ew = parcelRequire("j22ew");

var $l15Kx = parcelRequire("l15Kx");

var $emEBF = parcelRequire("emEBF");
var $e3be16a42e77c175$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e3be16a42e77c175$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $e3be16a42e77c175$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $e3be16a42e77c175$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $e3be16a42e77c175$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $e3be16a42e77c175$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $emEBF.default)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme } = value, componentTokens = $e3be16a42e77c175$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $e3be16a42e77c175$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $e3be16a42e77c175$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $j22ew.DesignTokenContext));
    const salt = `${(0, $lN6FX.default)}-${hashed || ''}`;
    const mergedTheme = theme || (0, $dWyN5.default);
    const [token, hashId, realToken] = (0, $5tHf5.default)(mergedTheme, [
        (0, $l15Kx.default),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $e3be16a42e77c175$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $emEBF.default,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $e3be16a42e77c175$export$c6b9faa6b723d31a,
            ignore: $e3be16a42e77c175$export$738b109e247a462c,
            preserve: $e3be16a42e77c175$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar
    ];
}

});
parcelRegister("lN6FX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdd35a386f386e2c$export$2e2bcd8739ae039);

var $eEdAB = parcelRequire("eEdAB");
"use client";
var $fdd35a386f386e2c$export$2e2bcd8739ae039 = (0, $eEdAB.default);

});
parcelRegister("eEdAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa9f57b4499f3b25$export$2e2bcd8739ae039);
var $aa9f57b4499f3b25$export$2e2bcd8739ae039 = '5.26.1';

});


parcelRegister("emEBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7529e5c10ca009d$export$2e2bcd8739ae039);
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");

var $l15Kx = parcelRequire("l15Kx");

var $fF4Xy = parcelRequire("fF4Xy");
var $a7529e5c10ca009d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a7529e5c10ca009d$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $a7529e5c10ca009d$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $l15Kx.default)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $fF4Xy.default)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $fF4Xy.default)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $fF4Xy.default)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $fF4Xy.default)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $bkcIW.FastColor)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, $bkcIW.FastColor)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, $bkcIW.FastColor)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)'
    }), overrideTokens);
    return aliasToken;
}

});
parcelRegister("fF4Xy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b66e8831af27a49c$export$2e2bcd8739ae039);
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
function $b66e8831af27a49c$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $b66e8831af27a49c$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $bkcIW.FastColor)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $bkcIW.FastColor)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($b66e8831af27a49c$var$isStableColor(r) && $b66e8831af27a49c$var$isStableColor(g) && $b66e8831af27a49c$var$isStableColor(b)) return new (0, $bkcIW.FastColor)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $bkcIW.FastColor)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $b66e8831af27a49c$export$2e2bcd8739ae039 = $b66e8831af27a49c$var$getAlphaColor;

});




parcelRegister("bA3rc", function(module, exports) {

$parcel$export(module.exports, "default", () => $86e5b92b71a5f9b0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $dkjPS = parcelRequire("dkjPS");
"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $86e5b92b71a5f9b0$var$PropWarning = /*#__PURE__*/ $aqdBs.memo(({ dropdownMatchSelectWidth: dropdownMatchSelectWidth })=>{
    const warning = (0, $dkjPS.devUseWarning)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
var $86e5b92b71a5f9b0$export$2e2bcd8739ae039 = ()=>null;

});

parcelRegister("6bM5M", function(module, exports) {

$parcel$export(module.exports, "default", () => $4819134abe135262$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $f4yOi = parcelRequire("f4yOi");

var $5kUb2 = parcelRequire("5kUb2");

var $jygCN = parcelRequire("jygCN");
const $4819134abe135262$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $jygCN.default)();
    // Generate style for icons
    return (0, $f4yOi.default)({
        theme: theme,
        token: token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>[
            (0, $5kUb2.genIconStyle)(iconPrefixCls)
        ]);
};
var $4819134abe135262$export$2e2bcd8739ae039 = $4819134abe135262$var$useResetIconStyle;

});
parcelRegister("5kUb2", function(module, exports) {

$parcel$export(module.exports, "textEllipsis", () => $3e2a6592f1965e07$export$b2b65df0d0824629);
$parcel$export(module.exports, "resetComponent", () => $3e2a6592f1965e07$export$23997c3e44cc1c59);
$parcel$export(module.exports, "resetIcon", () => $3e2a6592f1965e07$export$171ccda7bc085e59);
$parcel$export(module.exports, "clearFix", () => $3e2a6592f1965e07$export$8c467e8859fdef13);
$parcel$export(module.exports, "genLinkStyle", () => $3e2a6592f1965e07$export$905d771977096614);
$parcel$export(module.exports, "genCommonStyle", () => $3e2a6592f1965e07$export$689382c111559cd9);
$parcel$export(module.exports, "genFocusOutline", () => $3e2a6592f1965e07$export$6539948f0a737e39);
$parcel$export(module.exports, "genFocusStyle", () => $3e2a6592f1965e07$export$a44db842bcb28231);
$parcel$export(module.exports, "genIconStyle", () => $3e2a6592f1965e07$export$f1a0b31dfb234e7e);
$parcel$export(module.exports, "operationUnit", () => $3e2a6592f1965e07$export$9a16e7694a707ab4);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
"use client";
const $3e2a6592f1965e07$export$b2b65df0d0824629 = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const $3e2a6592f1965e07$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const $3e2a6592f1965e07$export$171ccda7bc085e59 = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const $3e2a6592f1965e07$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const $3e2a6592f1965e07$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const $3e2a6592f1965e07$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
const $3e2a6592f1965e07$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $aWTY1.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset !== null && offset !== void 0 ? offset : 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const $3e2a6592f1965e07$export$a44db842bcb28231 = (token, offset)=>({
        '&:focus-visible': Object.assign({}, $3e2a6592f1965e07$export$6539948f0a737e39(token, offset))
    });
const $3e2a6592f1965e07$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, $3e2a6592f1965e07$export$171ccda7bc085e59()), {
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        })
    });
const $3e2a6592f1965e07$export$9a16e7694a707ab4 = (token)=>Object.assign(Object.assign({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none'
    }, $3e2a6592f1965e07$export$a44db842bcb28231(token)), {
        '&:focus, &:hover': {
            color: token.colorLinkHover
        },
        '&:active': {
            color: token.colorLinkActive
        }
    });

});



parcelRegister("iOHOh", function(module, exports) {

$parcel$export(module.exports, "isFragment", () => $db2ee14585eb0881$export$9522e17588c12572);
$parcel$export(module.exports, "cloneElement", () => $db2ee14585eb0881$export$e530037191fcd5d7);

var $aqdBs = parcelRequire("aqdBs");
function $db2ee14585eb0881$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment;
}
const $db2ee14585eb0881$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function $db2ee14585eb0881$export$e530037191fcd5d7(element, props) {
    return $db2ee14585eb0881$export$2dfe578f95754f6a(element, element, props);
}

});

parcelRegister("eCcq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3e3fc091389477$export$2e2bcd8739ae039);

var $4wPvn = parcelRequire("4wPvn");
const $aa3e3fc091389477$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
var $aa3e3fc091389477$export$2e2bcd8739ae039 = (0, $4wPvn.genComponentStyleHook)('Wave', (token)=>[
        $aa3e3fc091389477$var$genWaveStyle(token)
    ]);

});
parcelRegister("4wPvn", function(module, exports) {

$parcel$export(module.exports, "genStyleHooks", () => $34c21a68440fd358$export$51ec95de45185b42);
$parcel$export(module.exports, "genComponentStyleHook", () => $34c21a68440fd358$export$b8cc4ee2ee8cfbc8);
$parcel$export(module.exports, "genSubStyleComponent", () => $34c21a68440fd358$export$1537386bc155ea56);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("gS2oY");
var $6Tvtp = parcelRequire("6Tvtp");

var $kjlvF = parcelRequire("kjlvF");

var $5kUb2 = parcelRequire("5kUb2");

var $jygCN = parcelRequire("jygCN");
const { genStyleHooks: $34c21a68440fd358$export$51ec95de45185b42, genComponentStyleHook: $34c21a68440fd358$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $34c21a68440fd358$export$1537386bc155ea56 } = (0, $6Tvtp.default)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar] = (0, $jygCN.default)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
        return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: (token, config)=>{
        var _a;
        const linkStyle = (0, $5kUb2.genLinkStyle)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, $5kUb2.genIconStyle)((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : (0, $kjlvF.defaultIconPrefixCls))
        ];
    },
    getCommonStyle: (0, $5kUb2.genCommonStyle),
    getCompUnitless: ()=>(0, $jygCN.unitless)
});

});
parcelRegister("gS2oY", function(module, exports) {

$parcel$export(module.exports, "genStyleUtils", () => (parcelRequire("6Tvtp")).default);
$parcel$export(module.exports, "mergeToken", () => (parcelRequire("8Olk9")).merge);

var $6Tvtp = parcelRequire("6Tvtp");

var $jQupS = parcelRequire("jQupS");

var $8Olk9 = parcelRequire("8Olk9");

});
parcelRegister("6Tvtp", function(module, exports) {

$parcel$export(module.exports, "default", () => $50504b19a27b0611$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $kelIR = parcelRequire("kelIR");

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("g14b3");
var $dD82S = parcelRequire("dD82S");
var $7n0Ot = parcelRequire("7n0Ot");
var $f4yOi = parcelRequire("f4yOi");

var $jQupS = parcelRequire("jQupS");

var $h9OXK = parcelRequire("h9OXK");

var $607RK = parcelRequire("607RK");

var $cXfED = parcelRequire("cXfED");

var $l5cks = parcelRequire("l5cks");

var $8Olk9 = parcelRequire("8Olk9");

var $jZysg = parcelRequire("jZysg");

var $3DBGy = parcelRequire("3DBGy");
function $50504b19a27b0611$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $3DBGy.default) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, $4f2X8.default)((0, $4f2X8.default)({}, originCompUnitless), {}, (0, $br1G4.default)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $4f2X8.default)((0, $4f2X8.default)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useStyle = useStyle(prefixCls, rootCls), _useStyle2 = (0, $kelIR.default)(_useStyle, 2), hashId = _useStyle2[1];
            var _useCSSVar = useCSSVar(rootCls), _useCSSVar2 = (0, $kelIR.default)(_useCSSVar, 2), wrapCSSVar = _useCSSVar2[0], cssVarCls = _useCSSVar2[1];
            return [
                wrapCSSVar,
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, _options$injectStyle = options.injectStyle, injectStyle = _options$injectStyle === void 0 ? true : _options$injectStyle, prefixToken = options.prefixToken, ignore = options.ignore;
        var CSSVarRegister = function CSSVarRegister(_ref) {
            var rootCls = _ref.rootCls, _ref$cssVar = _ref.cssVar, cssVar = _ref$cssVar === void 0 ? {} : _ref$cssVar;
            var _useToken = useToken(), realToken = _useToken.realToken;
            (0, $7n0Ot.default)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, $cXfED.default)(component, realToken, getDefaultToken);
                var componentToken = (0, $607RK.default)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return null;
        };
        var useCSSVar = function useCSSVar(rootCls) {
            var _useToken2 = useToken(), cssVar = _useToken2.cssVar;
            return [
                function(node) {
                    return injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(CSSVarRegister, {
                        rootCls: rootCls,
                        cssVar: cssVar,
                        component: component
                    }), node) : node;
                },
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.key
            ];
        };
        return useCSSVar;
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $kelIR.default)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken3 = useToken(), theme = _useToken3.theme, realToken = _useToken3.realToken, hashId = _useToken3.hashId, token = _useToken3.token, cssVar = _useToken3.cssVar;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = cssVar ? 'css' : 'js';
            // Use unique memo to share the result across all instances
            var calc = (0, $jZysg.default)(function() {
                var unitlessCssVar = new Set();
                if (cssVar) Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $dD82S.token2CSSVar)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $dD82S.token2CSSVar)(key, (0, $h9OXK.default)(component, cssVar.prefix)));
                });
                return (0, $jQupS.default)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $l5cks.default)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, $f4yOi.default)((0, $4f2X8.default)((0, $4f2X8.default)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            var wrapSSR = (0, $f4yOi.default)((0, $4f2X8.default)((0, $4f2X8.default)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $8Olk9.default)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $cXfED.default)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $607RK.default)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (cssVar && defaultComponentToken && (0, $7IgoF.default)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $dD82S.token2CSSVar)(key, (0, $h9OXK.default)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $8Olk9.merge)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    // @ts-ignore
                    max: max,
                    // @ts-ignore
                    min: min
                }, cssVar ? defaultComponentToken : componentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return [
                wrapSSR,
                hashId
            ];
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $4f2X8.default)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref2) {
            var prefixCls = _ref2.prefixCls, _ref2$rootCls = _ref2.rootCls, rootCls = _ref2$rootCls === void 0 ? prefixCls : _ref2$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $50504b19a27b0611$export$2e2bcd8739ae039 = $50504b19a27b0611$var$genStyleUtils;

});
parcelRegister("jQupS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e72a77b1c0d4f6af$export$2e2bcd8739ae039);

var $dbzik = parcelRequire("dbzik");

var $ioxzw = parcelRequire("ioxzw");
var $e72a77b1c0d4f6af$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, $dbzik.default) : (0, $ioxzw.default);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $e72a77b1c0d4f6af$export$2e2bcd8739ae039 = $e72a77b1c0d4f6af$var$genCalc;

});
parcelRegister("dbzik", function(module, exports) {

$parcel$export(module.exports, "default", () => $9997ae3e664b3fc7$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $i6Kuf = parcelRequire("i6Kuf");
var $9997ae3e664b3fc7$var$CALC_UNIT = 'CALC_UNIT';
var $9997ae3e664b3fc7$var$regexp = new RegExp($9997ae3e664b3fc7$var$CALC_UNIT, 'g');
function $9997ae3e664b3fc7$var$unit(value) {
    if (typeof value === 'number') return "".concat(value).concat($9997ae3e664b3fc7$var$CALC_UNIT);
    return value;
}
var $9997ae3e664b3fc7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9nc35.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $lriWM.default)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $dYVVZ.default)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "result", '');
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "unitlessCssVar", void 0);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "lowPriority", void 0);
        var numType = (0, $7IgoF.default)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = $9997ae3e664b3fc7$var$unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, $hevvH.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat($9997ae3e664b3fc7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat($9997ae3e664b3fc7$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($9997ae3e664b3fc7$var$regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $i6Kuf.default));

});
parcelRegister("i6Kuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ecd8ddbe37fc3f$export$2e2bcd8739ae039);

var $hevvH = parcelRequire("hevvH");

var $dYVVZ = parcelRequire("dYVVZ");
var $d2ecd8ddbe37fc3f$var$AbstractCalculator = /*#__PURE__*/ (0, $hevvH.default)(function AbstractCalculator() {
    (0, $dYVVZ.default)(this, AbstractCalculator);
});
var $d2ecd8ddbe37fc3f$export$2e2bcd8739ae039 = $d2ecd8ddbe37fc3f$var$AbstractCalculator;

});


parcelRegister("ioxzw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64482971f8d6d45$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $i6Kuf = parcelRequire("i6Kuf");
var $d64482971f8d6d45$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $9nc35.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, $lriWM.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $dYVVZ.default)(this, NumCalculator);
        _this = _super.call(this);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, $hevvH.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $i6Kuf.default));
var $d64482971f8d6d45$export$2e2bcd8739ae039 = $d64482971f8d6d45$var$NumCalculator;

});


parcelRegister("h9OXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7dacf10a91f5382$export$2e2bcd8739ae039);
var $c7dacf10a91f5382$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
var $c7dacf10a91f5382$export$2e2bcd8739ae039 = $c7dacf10a91f5382$var$getCompVarPrefix;

});

parcelRegister("607RK", function(module, exports) {

$parcel$export(module.exports, "default", () => $45e8d8295729032b$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $4f2X8 = parcelRequire("4f2X8");
parcelRequire("2UjQ5");
function $45e8d8295729032b$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $4f2X8.default)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $kelIR.default)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $4f2X8.default)((0, $4f2X8.default)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $45e8d8295729032b$export$2e2bcd8739ae039 = $45e8d8295729032b$var$getComponentToken;

});

parcelRegister("cXfED", function(module, exports) {

$parcel$export(module.exports, "default", () => $96e7235c11a51146$export$2e2bcd8739ae039);

var $8Olk9 = parcelRequire("8Olk9");
function $96e7235c11a51146$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, $8Olk9.merge)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $96e7235c11a51146$export$2e2bcd8739ae039 = $96e7235c11a51146$var$getDefaultComponentToken;

});
parcelRegister("8Olk9", function(module, exports) {

$parcel$export(module.exports, "merge", () => $66a388bed9c3c653$export$4950aa0f605343fb);
$parcel$export(module.exports, "default", () => $66a388bed9c3c653$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");
var $66a388bed9c3c653$var$enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var $66a388bed9c3c653$var$recording = true;
function $66a388bed9c3c653$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$66a388bed9c3c653$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $66a388bed9c3c653$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $7IgoF.default)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $66a388bed9c3c653$var$recording = true;
    return ret;
}
var $66a388bed9c3c653$export$754a5e2d36c5fa7a = {};
var $66a388bed9c3c653$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $66a388bed9c3c653$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $66a388bed9c3c653$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $66a388bed9c3c653$var$noop;
    if ($66a388bed9c3c653$var$enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($66a388bed9c3c653$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $66a388bed9c3c653$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $4f2X8.default)((0, $4f2X8.default)({}, (_statistic$componentN = $66a388bed9c3c653$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $66a388bed9c3c653$export$2e2bcd8739ae039 = $66a388bed9c3c653$var$statisticToken;

});


parcelRegister("l5cks", function(module, exports) {

$parcel$export(module.exports, "default", () => $f593a0e621b51300$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
function $f593a0e621b51300$var$genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $aWTY1.unit)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $aWTY1.unit)(value);
            }).join(','), ")");
        }
    };
}
var $f593a0e621b51300$export$2e2bcd8739ae039 = $f593a0e621b51300$var$genMaxMin;

});

parcelRegister("jZysg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8de70d79264132a$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");

var $aqdBs = parcelRequire("aqdBs");
var $e8de70d79264132a$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $e8de70d79264132a$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $dYVVZ.default)(this, ArrayKeyMap);
        (0, $br1G4.default)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $br1G4.default)(this, "objectIDMap", new WeakMap());
        (0, $br1G4.default)(this, "nextID", 0);
        (0, $br1G4.default)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $br1G4.default)(this, "accessBeat", 0);
    }
    (0, $hevvH.default)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $7IgoF.default)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $7IgoF.default)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $e8de70d79264132a$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $e8de70d79264132a$var$uniqueMap = new $e8de70d79264132a$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $e8de70d79264132a$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(function() {
        var cachedValue = $e8de70d79264132a$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $e8de70d79264132a$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $e8de70d79264132a$export$2e2bcd8739ae039 = $e8de70d79264132a$var$useUniqueMemo;

});

parcelRegister("3DBGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a623f1e3571d29c$export$2e2bcd8739ae039);
/**
 * Provide a default hook since not everyone needs to config this.
 */ var $2a623f1e3571d29c$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $2a623f1e3571d29c$export$2e2bcd8739ae039 = $2a623f1e3571d29c$var$useDefaultCSP;

});





parcelRegister("fNzK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b807282909a3fac7$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $k91S5 = parcelRequire("k91S5");

var $ebavw = parcelRequire("ebavw");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $jygCN = parcelRequire("jygCN");

var $mpBQr = parcelRequire("mpBQr");

var $44xtJ = parcelRequire("44xtJ");
const $b807282909a3fac7$var$useWave = (nodeRef, className, component)=>{
    const { wave: wave } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const [, token, hashId] = (0, $jygCN.default)();
    const showWave = (0, $k91S5.default)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $mpBQr.TARGET_CLS)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $44xtJ.default))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $aqdBs.useRef(null);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $ebavw.default).cancel(rafId.current);
        rafId.current = (0, $ebavw.default)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $b807282909a3fac7$export$2e2bcd8739ae039 = $b807282909a3fac7$var$useWave;

});
parcelRegister("mpBQr", function(module, exports) {

$parcel$export(module.exports, "TARGET_CLS", () => $0435ebaea358c1f2$export$23466a5792b7a5d3);
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
const $0435ebaea358c1f2$export$23466a5792b7a5d3 = `${(0, $kjlvF.defaultPrefixCls)}-wave-target`;

});

parcelRegister("44xtJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7181450edc8329$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $ebavw = parcelRequire("ebavw");

var $kBwE8 = parcelRequire("kBwE8");

var $lxiZB = parcelRequire("lxiZB");

var $mpBQr = parcelRequire("mpBQr");

var $beitW = parcelRequire("beitW");
"use client";
function $2f7181450edc8329$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $2f7181450edc8329$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, registerUnmount: registerUnmount } = props;
    const divRef = $aqdBs.useRef(null);
    // ====================== Refs ======================
    const unmountRef = $aqdBs.useRef(null);
    $aqdBs.useEffect(()=>{
        unmountRef.current = registerUnmount();
    }, []);
    // ===================== Effect =====================
    const [color, setWaveColor] = $aqdBs.useState(null);
    const [borderRadius, setBorderRadius] = $aqdBs.useState([]);
    const [left, setLeft] = $aqdBs.useState(0);
    const [top, setTop] = $aqdBs.useState(0);
    const [width, setWidth] = $aqdBs.useState(0);
    const [height, setHeight] = $aqdBs.useState(0);
    const [enabled, setEnabled] = $aqdBs.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $beitW.getTargetWaveColor)(target));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $2f7181450edc8329$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $2f7181450edc8329$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$2f7181450edc8329$var$validateNum(parseFloat(radius))));
    }
    $aqdBs.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $ebavw.default)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $ebavw.default).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $mpBQr.TARGET_CLS)));
    return /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a, _b;
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (_b = unmountRef.current) === null || _b === void 0 || _b.call(unmountRef).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $aqdBs.createElement("div", {
            ref: (0, $kBwE8.composeRef)(divRef, ref),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const $2f7181450edc8329$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !((_a = target.querySelector('input')) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    const reactRender = (0, $lxiZB.unstableSetRender)();
    let unmountCallback = null;
    function registerUnmount() {
        return unmountCallback;
    }
    unmountCallback = reactRender(/*#__PURE__*/ $aqdBs.createElement($2f7181450edc8329$var$WaveEffect, Object.assign({}, info, {
        target: target,
        registerUnmount: registerUnmount
    })), holder);
};
var $2f7181450edc8329$export$2e2bcd8739ae039 = $2f7181450edc8329$var$showWaveEffect;

});
parcelRegister("lxiZB", function(module, exports) {

$parcel$export(module.exports, "unstableSetRender", () => $fadb6995340a8f90$export$4d4bf8843d204cca);
parcelRequire("aqdBs");
parcelRequire("jVlfX");

var $jypRW = parcelRequire("jypRW");

"use client";
const $fadb6995340a8f90$var$defaultReactRender = (node, container)=>{
    (0, $jypRW.render)(node, container);
    return ()=>{
        return (0, $jypRW.unmount)(container);
    };
};
let $fadb6995340a8f90$var$unstableRender = $fadb6995340a8f90$var$defaultReactRender;
function $fadb6995340a8f90$export$4d4bf8843d204cca(render) {
    if (render) $fadb6995340a8f90$var$unstableRender = render;
    return $fadb6995340a8f90$var$unstableRender;
}

});
parcelRegister("jypRW", function(module, exports) {

$parcel$export(module.exports, "render", () => $e3c542587303e1d7$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "unmount", () => $e3c542587303e1d7$export$121e2d597d222bad);

var $6jwft = parcelRequire("6jwft");

var $8F2Cm = parcelRequire("8F2Cm");

var $7IgoF = parcelRequire("7IgoF");

var $4f2X8 = parcelRequire("4f2X8");

var $jVlfX = parcelRequire("jVlfX");
// Let compiler not to search module usage
var $e3c542587303e1d7$var$fullClone = (0, $4f2X8.default)({}, $jVlfX);
var $e3c542587303e1d7$var$version = $e3c542587303e1d7$var$fullClone.version, $e3c542587303e1d7$var$reactRender = $e3c542587303e1d7$var$fullClone.render, $e3c542587303e1d7$var$unmountComponentAtNode = $e3c542587303e1d7$var$fullClone.unmountComponentAtNode;
var $e3c542587303e1d7$var$createRoot;
try {
    var $e3c542587303e1d7$var$mainVersion = Number(($e3c542587303e1d7$var$version || '').split('.')[0]);
    if ($e3c542587303e1d7$var$mainVersion >= 18) $e3c542587303e1d7$var$createRoot = $e3c542587303e1d7$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $e3c542587303e1d7$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $e3c542587303e1d7$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $7IgoF.default)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === 'object') __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $e3c542587303e1d7$var$MARK = '__rc_react_root__';
// ========================== Render ==========================
function $e3c542587303e1d7$var$modernRender(node, container) {
    $e3c542587303e1d7$var$toggleWarning(true);
    var root = container[$e3c542587303e1d7$var$MARK] || $e3c542587303e1d7$var$createRoot(container);
    $e3c542587303e1d7$var$toggleWarning(false);
    root.render(node);
    container[$e3c542587303e1d7$var$MARK] = root;
}
function $e3c542587303e1d7$var$legacyRender(node, container) {
    $e3c542587303e1d7$var$reactRender === null || $e3c542587303e1d7$var$reactRender === void 0 || $e3c542587303e1d7$var$reactRender(node, container);
}
function $e3c542587303e1d7$export$892c6608f54d7438(node, container) {}
function $e3c542587303e1d7$export$b3890eb0ae9dca99(node, container) {
    if ($e3c542587303e1d7$var$createRoot) {
        $e3c542587303e1d7$var$modernRender(node, container);
        return;
    }
    $e3c542587303e1d7$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $e3c542587303e1d7$var$modernUnmount(_x) {
    return $e3c542587303e1d7$var$_modernUnmount.apply(this, arguments);
}
function $e3c542587303e1d7$var$_modernUnmount() {
    $e3c542587303e1d7$var$_modernUnmount = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee(container) {
        return (0, $6jwft.default)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$e3c542587303e1d7$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$e3c542587303e1d7$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e3c542587303e1d7$var$_modernUnmount.apply(this, arguments);
}
function $e3c542587303e1d7$var$legacyUnmount(container) {
    $e3c542587303e1d7$var$unmountComponentAtNode(container);
}
function $e3c542587303e1d7$export$fd39fe14445b207a(container) {}
function $e3c542587303e1d7$export$121e2d597d222bad(_x2) {
    return $e3c542587303e1d7$var$_unmount.apply(this, arguments);
}
function $e3c542587303e1d7$var$_unmount() {
    $e3c542587303e1d7$var$_unmount = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee2(container) {
        return (0, $6jwft.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($e3c542587303e1d7$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $e3c542587303e1d7$var$modernUnmount(container));
                case 2:
                    $e3c542587303e1d7$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $e3c542587303e1d7$var$_unmount.apply(this, arguments);
}

});
parcelRegister("6jwft", function(module, exports) {

$parcel$export(module.exports, "default", () => $498d885283c5d9dd$export$2e2bcd8739ae039);

var $6ihNj = parcelRequire("6ihNj");

var $7gyZj = parcelRequire("7gyZj");

var $gavY0 = parcelRequire("gavY0");

var $iRBvC = parcelRequire("iRBvC");

var $9Elel = parcelRequire("9Elel");

var $1YGWL = parcelRequire("1YGWL");

var $1q4lt = parcelRequire("1q4lt");
function $498d885283c5d9dd$export$2e2bcd8739ae039() {
    "use strict";
    var r = (0, $7gyZj.default)(), e = r.m($498d885283c5d9dd$export$2e2bcd8739ae039), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, (0, $1q4lt.default)(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return ($498d885283c5d9dd$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new (0, $6ihNj.default)(r, e);
            },
            AsyncIterator: (0, $9Elel.default),
            async: function async(r, e, t, o, u) {
                return (n(e) ? (0, $iRBvC.default) : (0, $gavY0.default))(a(r), e, t, o, u);
            },
            keys: (0, $1YGWL.default),
            values: (0, $1q4lt.default)
        };
    })();
}

});
parcelRegister("6ihNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $49523a14f9cd04c6$export$2e2bcd8739ae039);
function $49523a14f9cd04c6$export$2e2bcd8739ae039(e, d) {
    this.v = e, this.k = d;
}

});

parcelRegister("7gyZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $54a52aeaba640a54$export$2e2bcd8739ae039);

var $VcRGX = parcelRequire("VcRGX");
function $54a52aeaba640a54$export$2e2bcd8739ae039() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return (0, $VcRGX.default)(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ((0, $VcRGX.default)(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, (0, $VcRGX.default)(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, (0, $VcRGX.default)(u, "constructor", GeneratorFunctionPrototype), (0, $VcRGX.default)(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", (0, $VcRGX.default)(GeneratorFunctionPrototype, o, "GeneratorFunction"), (0, $VcRGX.default)(u), (0, $VcRGX.default)(u, o, "Generator"), (0, $VcRGX.default)(u, n, function() {
        return this;
    }), (0, $VcRGX.default)(u, "toString", function() {
        return "[object Generator]";
    }), ($54a52aeaba640a54$export$2e2bcd8739ae039 = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}

});
parcelRegister("VcRGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $0abf4db4c63a839d$export$2e2bcd8739ae039);
function $0abf4db4c63a839d$export$2e2bcd8739ae039(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    $0abf4db4c63a839d$export$2e2bcd8739ae039 = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $0abf4db4c63a839d$export$2e2bcd8739ae039(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, $0abf4db4c63a839d$export$2e2bcd8739ae039(e, r, n, t);
}

});


parcelRegister("gavY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc5660754340a17c$export$2e2bcd8739ae039);

var $iRBvC = parcelRequire("iRBvC");
function $bc5660754340a17c$export$2e2bcd8739ae039(n, e, r, t, o) {
    var a = (0, $iRBvC.default)(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}

});
parcelRegister("iRBvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbba45b71bdb1908$export$2e2bcd8739ae039);

var $7gyZj = parcelRequire("7gyZj");

var $9Elel = parcelRequire("9Elel");
function $dbba45b71bdb1908$export$2e2bcd8739ae039(r, e, t, o, n) {
    return new (0, $9Elel.default)((0, $7gyZj.default)().w(r, e, t, o), n || Promise);
}

});
parcelRegister("9Elel", function(module, exports) {

$parcel$export(module.exports, "default", () => $706851689aa2d14a$export$2e2bcd8739ae039);

var $6ihNj = parcelRequire("6ihNj");

var $VcRGX = parcelRequire("VcRGX");
function $706851689aa2d14a$export$2e2bcd8739ae039(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof (0, $6ihNj.default) ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ((0, $VcRGX.default)($706851689aa2d14a$export$2e2bcd8739ae039.prototype), (0, $VcRGX.default)($706851689aa2d14a$export$2e2bcd8739ae039.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), (0, $VcRGX.default)(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}

});



parcelRegister("1YGWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $170cb567867986ba$export$2e2bcd8739ae039);
function $170cb567867986ba$export$2e2bcd8739ae039(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}

});

parcelRegister("1q4lt", function(module, exports) {

$parcel$export(module.exports, "default", () => $108b9707ddad0499$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");
function $108b9707ddad0499$export$2e2bcd8739ae039(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError((0, $7IgoF.default)(e) + " is not iterable");
}

});


parcelRegister("8F2Cm", function(module, exports) {

$parcel$export(module.exports, "default", () => $64e42edff45d4fc1$export$2e2bcd8739ae039);
function $64e42edff45d4fc1$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $64e42edff45d4fc1$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $64e42edff45d4fc1$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $64e42edff45d4fc1$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});



parcelRegister("beitW", function(module, exports) {

$parcel$export(module.exports, "getTargetWaveColor", () => $82cf56a39be6285d$export$651d8e9c80304fc8);
function $82cf56a39be6285d$export$9d61ea039e87eb91(color) {
    return color && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent';
}
function $82cf56a39be6285d$export$651d8e9c80304fc8(node) {
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    if ($82cf56a39be6285d$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($82cf56a39be6285d$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($82cf56a39be6285d$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}

});




parcelRegister("3m1Z3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2714f718edaf4c48$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $fo0uV = parcelRequire("fo0uV");
const $2714f718edaf4c48$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $fo0uV.default));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize !== null && customSize !== void 0 ? customSize : size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $2714f718edaf4c48$export$2e2bcd8739ae039 = $2714f718edaf4c48$var$useSize;

});

parcelRegister("O3SCq", function(module, exports) {

$parcel$export(module.exports, "useCompactItemContext", () => $0967ae1a5a122c91$export$cd8cf9d7bab8dd4);
$parcel$export(module.exports, "NoCompactStyle", () => $0967ae1a5a122c91$export$5f56e610a4afb685);
$parcel$export(module.exports, "default", () => $0967ae1a5a122c91$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $bZ6Ai = parcelRequire("bZ6Ai");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $3m1Z3 = parcelRequire("3m1Z3");

var $bJSwL = parcelRequire("bJSwL");
"use client";
var $0967ae1a5a122c91$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0967ae1a5a122c91$export$8d1c486ac0db0a7d = /*#__PURE__*/ $aqdBs.createContext(null);
const $0967ae1a5a122c91$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $aqdBs.useContext($0967ae1a5a122c91$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $aqdBs.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $0967ae1a5a122c91$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $aqdBs.createElement($0967ae1a5a122c91$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $0967ae1a5a122c91$var$CompactItem = (props)=>{
    const { children: children } = props, others = $0967ae1a5a122c91$var$__rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($0967ae1a5a122c91$export$8d1c486ac0db0a7d.Provider, {
        value: $aqdBs.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $0967ae1a5a122c91$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $0967ae1a5a122c91$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $3m1Z3.default)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $bJSwL.default)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === 'vertical'
    }, className, rootClassName);
    const compactItemContext = $aqdBs.useContext($0967ae1a5a122c91$export$8d1c486ac0db0a7d);
    const childNodes = (0, $bZ6Ai.default)(children);
    const nodes = $aqdBs.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $aqdBs.createElement($0967ae1a5a122c91$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $0967ae1a5a122c91$export$2e2bcd8739ae039 = $0967ae1a5a122c91$var$Compact;

});
parcelRegister("bZ6Ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $02406d6a65e21940$export$2e2bcd8739ae039);

var $2JmHQ = parcelRequire("2JmHQ");

var $aqdBs = parcelRequire("aqdBs");
function $02406d6a65e21940$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($02406d6a65e21940$export$2e2bcd8739ae039(child));
        else if ((0, $2JmHQ.default)(child) && child.props) ret = ret.concat($02406d6a65e21940$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

});

parcelRegister("bJSwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $88be31b70f451d30$export$2e2bcd8739ae039);

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $1ldrV = parcelRequire("1ldrV");
const $88be31b70f451d30$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const $88be31b70f451d30$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $88be31b70f451d30$export$9ca1be8807fe0675 = ()=>({});
var $88be31b70f451d30$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Space', (token)=>{
    const spaceToken = (0, $8Olk9.merge)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $88be31b70f451d30$var$genSpaceStyle(spaceToken),
        $88be31b70f451d30$var$genSpaceGapStyle(spaceToken),
        (0, $1ldrV.default)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});

});
parcelRegister("1ldrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fa22f64131ab815$export$2e2bcd8739ae039);
const $0fa22f64131ab815$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            }
        }
    };
};
var // ============================== Export ==============================
$0fa22f64131ab815$export$2e2bcd8739ae039 = $0fa22f64131ab815$var$genSpaceCompactStyle;

});



parcelRegister("jZLp3", function(module, exports) {

$parcel$export(module.exports, "GroupSizeContext", () => $e8e87c15e37004e0$export$ed0cc8bd1f617d6d);
$parcel$export(module.exports, "default", () => $e8e87c15e37004e0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $jygCN = parcelRequire("jygCN");
"use client";
var $e8e87c15e37004e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e8e87c15e37004e0$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $aqdBs.createContext(undefined);
const $e8e87c15e37004e0$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $e8e87c15e37004e0$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, $jygCN.default)();
    const sizeCls = $aqdBs.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ $aqdBs.createElement($e8e87c15e37004e0$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $e8e87c15e37004e0$export$2e2bcd8739ae039 = $e8e87c15e37004e0$var$ButtonGroup;

});

parcelRegister("1TaA8", function(module, exports) {

$parcel$export(module.exports, "isTwoCNChar", () => $160322ce4f71feac$export$c5dca2bf412dea0d);
$parcel$export(module.exports, "convertLegacyProps", () => $160322ce4f71feac$export$19bc9a290855952);
$parcel$export(module.exports, "isUnBorderedButtonVariant", () => $160322ce4f71feac$export$b120bc11c0d9c214);
$parcel$export(module.exports, "spaceChildren", () => $160322ce4f71feac$export$b6ee00a7e7908bc);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $iOHOh = parcelRequire("iOHOh");

var $gGv71 = parcelRequire("gGv71");
"use client";
const $160322ce4f71feac$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $160322ce4f71feac$export$c5dca2bf412dea0d = $160322ce4f71feac$var$rxTwoCNChar.test.bind($160322ce4f71feac$var$rxTwoCNChar);
function $160322ce4f71feac$export$19bc9a290855952(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type: type
    };
}
function $160322ce4f71feac$export$844ec244b1367d54(str) {
    return typeof str === 'string';
}
function $160322ce4f71feac$export$b120bc11c0d9c214(type) {
    return type === 'text' || type === 'link';
}
function $160322ce4f71feac$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && $160322ce4f71feac$export$844ec244b1367d54(child.type) && $160322ce4f71feac$export$c5dca2bf412dea0d(child.props.children)) return (0, $iOHOh.cloneElement)(child, {
        children: child.props.children.split('').join(SPACE)
    });
    if ($160322ce4f71feac$export$844ec244b1367d54(child)) return $160322ce4f71feac$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", null, child.split('').join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", null, child);
    if ((0, $iOHOh.isFragment)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", null, child);
    return child;
}
function $160322ce4f71feac$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Children.map(childList, (child)=>$160322ce4f71feac$var$splitCNCharsBySpace(child, needInserted));
}
const $160322ce4f71feac$var$_ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const $160322ce4f71feac$var$_ButtonShapes = [
    'default',
    'circle',
    'round'
];
const $160322ce4f71feac$var$_ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const $160322ce4f71feac$export$9870b52452f51da5 = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const $160322ce4f71feac$export$760f16d96e091fc5 = [
    'default',
    'primary',
    'danger'
].concat((0, $dMbbs.default)((0, $gGv71.PresetColors)));

});
parcelRegister("gGv71", function(module, exports) {

$parcel$export(module.exports, "PresetColors", () => $c258b3d906e0abcd$export$6d4fe3a00a1811ad);
const $c258b3d906e0abcd$export$6d4fe3a00a1811ad = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];

});


parcelRegister("3Apmx", function(module, exports) {

$parcel$export(module.exports, "default", () => $29c8685efa28beb0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $5BZxE = parcelRequire("5BZxE");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $apxIS = parcelRequire("apxIS");
"use client";
const $29c8685efa28beb0$var$InnerLoadingIcon = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $apxIS.default), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $5BZxE.default), {
        className: iconClassName
    }));
});
const $29c8685efa28beb0$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const $29c8685efa28beb0$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const $29c8685efa28beb0$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($29c8685efa28beb0$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $6ufPd.default), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $29c8685efa28beb0$var$getCollapsedWidth,
        onAppearActive: $29c8685efa28beb0$var$getRealWidth,
        onEnterStart: $29c8685efa28beb0$var$getCollapsedWidth,
        onEnterActive: $29c8685efa28beb0$var$getRealWidth,
        onLeaveStart: $29c8685efa28beb0$var$getRealWidth,
        onLeaveActive: $29c8685efa28beb0$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = Object.assign(Object.assign({}, style), motionStyle);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($29c8685efa28beb0$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $29c8685efa28beb0$export$2e2bcd8739ae039 = $29c8685efa28beb0$var$DefaultLoadingIcon;

});
parcelRegister("apxIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $794665da3fb04c44$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
"use client";
const $794665da3fb04c44$var$IconWrapper = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $794665da3fb04c44$export$2e2bcd8739ae039 = $794665da3fb04c44$var$IconWrapper;

});


parcelRegister("hd4WI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8777cbef437af7e$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $gGv71 = parcelRequire("gGv71");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $28A7s = parcelRequire("28A7s");

var $9nSnF = parcelRequire("9nSnF");
// ============================== Shared ==============================
const $c8777cbef437af7e$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, marginXS: marginXS, calc: calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: token.marginXS,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            background: 'transparent',
            border: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            color: token.colorText,
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $5kUb2.resetIcon)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, $5kUb2.genFocusStyle)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                },
                [`&${componentCls}-round`]: {
                    width: 'auto'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPosition
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(marginXS).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(marginXS).mul(-1).equal()
                    }
                }
            }
        }
    };
};
const $c8777cbef437af7e$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            '&:hover': hoverStyle,
            '&:active': activeStyle
        }
    });
// ============================== Shape ===============================
const $c8777cbef437af7e$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: '50%'
    });
const $c8777cbef437af7e$var$genRoundButtonStyle = (token)=>({
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    });
const $c8777cbef437af7e$var$genDisabledStyle = (token)=>({
        cursor: 'not-allowed',
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: 'none'
    });
const $c8777cbef437af7e$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: 'none'
        }, $c8777cbef437af7e$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            '&:disabled': {
                cursor: 'not-allowed',
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $c8777cbef437af7e$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $c8777cbef437af7e$var$genDisabledStyle(token))
    });
const $c8777cbef437af7e$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: 'not-allowed',
            color: token.colorTextDisabled
        }
    });
// ============================== Variant =============================
const $c8777cbef437af7e$var$genVariantButtonStyle = (token, hoverStyle, activeStyle, variant)=>{
    const isPureDisabled = variant && [
        'link',
        'text'
    ].includes(variant);
    const genDisabledButtonStyle = isPureDisabled ? $c8777cbef437af7e$var$genPureDisabledButtonStyle : $c8777cbef437af7e$var$genSolidDisabledButtonStyle;
    return Object.assign(Object.assign({}, genDisabledButtonStyle(token)), $c8777cbef437af7e$var$genHoverActiveButtonStyle(token.componentCls, hoverStyle, activeStyle));
};
const $c8777cbef437af7e$var$genSolidButtonStyle = (token, textColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-solid`]: Object.assign({
            color: textColor,
            background: background
        }, $c8777cbef437af7e$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $c8777cbef437af7e$var$genOutlinedDashedButtonStyle = (token, borderColor, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-outlined, &${token.componentCls}-variant-dashed`]: Object.assign({
            borderColor: borderColor,
            background: background
        }, $c8777cbef437af7e$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $c8777cbef437af7e$var$genDashedButtonStyle = (token)=>({
        [`&${token.componentCls}-variant-dashed`]: {
            borderStyle: 'dashed'
        }
    });
const $c8777cbef437af7e$var$genFilledButtonStyle = (token, background, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-filled`]: Object.assign({
            boxShadow: 'none',
            background: background
        }, $c8777cbef437af7e$var$genVariantButtonStyle(token, hoverStyle, activeStyle))
    });
const $c8777cbef437af7e$var$genTextLinkButtonStyle = (token, textColor, variant, hoverStyle, activeStyle)=>({
        [`&${token.componentCls}-variant-${variant}`]: Object.assign({
            color: textColor,
            boxShadow: 'none'
        }, $c8777cbef437af7e$var$genVariantButtonStyle(token, hoverStyle, activeStyle, variant))
    });
// =============================== Color ==============================
const $c8777cbef437af7e$var$genPresetColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return (0, $gGv71.PresetColors).reduce((prev, colorKey)=>{
        const darkColor = token[`${colorKey}6`];
        const lightColor = token[`${colorKey}1`];
        const hoverColor = token[`${colorKey}5`];
        const lightHoverColor = token[`${colorKey}2`];
        const lightBorderColor = token[`${colorKey}3`];
        const activeColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), {
            [`&${componentCls}-color-${colorKey}`]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
                color: darkColor,
                boxShadow: token[`${colorKey}ShadowColor`]
            }, $c8777cbef437af7e$var$genSolidButtonStyle(token, token.colorTextLightSolid, darkColor, {
                background: hoverColor
            }, {
                background: activeColor
            })), $c8777cbef437af7e$var$genOutlinedDashedButtonStyle(token, darkColor, token.colorBgContainer, {
                color: hoverColor,
                borderColor: hoverColor,
                background: token.colorBgContainer
            }, {
                color: activeColor,
                borderColor: activeColor,
                background: token.colorBgContainer
            })), $c8777cbef437af7e$var$genDashedButtonStyle(token)), $c8777cbef437af7e$var$genFilledButtonStyle(token, lightColor, {
                background: lightHoverColor
            }, {
                background: lightBorderColor
            })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, darkColor, 'link', {
                color: hoverColor
            }, {
                color: activeColor
            })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, darkColor, 'text', {
                color: hoverColor,
                background: lightColor
            }, {
                color: activeColor,
                background: lightBorderColor
            }))
        });
    }, {});
};
const $c8777cbef437af7e$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }, $c8777cbef437af7e$var$genSolidButtonStyle(token, token.solidTextColor, token.colorBgSolid, {
        color: token.solidTextColor,
        background: token.colorBgSolidHover
    }, {
        color: token.solidTextColor,
        background: token.colorBgSolidActive
    })), $c8777cbef437af7e$var$genDashedButtonStyle(token)), $c8777cbef437af7e$var$genFilledButtonStyle(token, token.colorFillTertiary, {
        background: token.colorFillSecondary
    }, {
        background: token.colorFill
    })), $c8777cbef437af7e$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.textTextColor, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
const $c8777cbef437af7e$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorPrimary,
        boxShadow: token.primaryShadow
    }, $c8777cbef437af7e$var$genOutlinedDashedButtonStyle(token, token.colorPrimary, token.colorBgContainer, {
        color: token.colorPrimaryTextHover,
        borderColor: token.colorPrimaryHover,
        background: token.colorBgContainer
    }, {
        color: token.colorPrimaryTextActive,
        borderColor: token.colorPrimaryActive,
        background: token.colorBgContainer
    })), $c8777cbef437af7e$var$genDashedButtonStyle(token)), $c8777cbef437af7e$var$genFilledButtonStyle(token, token.colorPrimaryBg, {
        background: token.colorPrimaryBgHover
    }, {
        background: token.colorPrimaryBorder
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'text', {
        color: token.colorPrimaryTextHover,
        background: token.colorPrimaryBg
    }, {
        color: token.colorPrimaryTextActive,
        background: token.colorPrimaryBorder
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorPrimaryText, 'link', {
        color: token.colorPrimaryTextHover,
        background: token.linkHoverBg
    }, {
        color: token.colorPrimaryTextActive
    })), $c8777cbef437af7e$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    }));
const $c8777cbef437af7e$var$genDangerousStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        color: token.colorError,
        boxShadow: token.dangerShadow
    }, $c8777cbef437af7e$var$genSolidButtonStyle(token, token.dangerColor, token.colorError, {
        background: token.colorErrorHover
    }, {
        background: token.colorErrorActive
    })), $c8777cbef437af7e$var$genOutlinedDashedButtonStyle(token, token.colorError, token.colorBgContainer, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorBorderHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    })), $c8777cbef437af7e$var$genDashedButtonStyle(token)), $c8777cbef437af7e$var$genFilledButtonStyle(token, token.colorErrorBg, {
        background: token.colorErrorBgFilledHover
    }, {
        background: token.colorErrorBgActive
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorError, 'text', {
        color: token.colorErrorHover,
        background: token.colorErrorBg
    }, {
        color: token.colorErrorHover,
        background: token.colorErrorBgActive
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorError, 'link', {
        color: token.colorErrorHover
    }, {
        color: token.colorErrorActive
    })), $c8777cbef437af7e$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
        color: token.colorErrorHover,
        borderColor: token.colorErrorHover
    }, {
        color: token.colorErrorActive,
        borderColor: token.colorErrorActive
    }));
const $c8777cbef437af7e$var$genLinkStyle = (token)=>Object.assign(Object.assign({}, $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover
    }, {
        color: token.colorLinkActive
    })), $c8777cbef437af7e$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorInfo, token.colorInfo, token.colorTextDisabled, token.colorBorder, {
        color: token.colorInfoHover,
        borderColor: token.colorInfoHover
    }, {
        color: token.colorInfoActive,
        borderColor: token.colorInfoActive
    }));
const $c8777cbef437af7e$var$genColorButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return Object.assign({
        [`${componentCls}-color-default`]: $c8777cbef437af7e$var$genDefaultButtonStyle(token),
        [`${componentCls}-color-primary`]: $c8777cbef437af7e$var$genPrimaryButtonStyle(token),
        [`${componentCls}-color-dangerous`]: $c8777cbef437af7e$var$genDangerousStyle(token),
        [`${componentCls}-color-link`]: $c8777cbef437af7e$var$genLinkStyle(token)
    }, $c8777cbef437af7e$var$genPresetColorStyle(token));
};
// =========== Compatible with versions earlier than 5.21.0 ===========
const $c8777cbef437af7e$var$genCompatibleButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign({}, $c8777cbef437af7e$var$genOutlinedDashedButtonStyle(token, token.defaultBorderColor, token.defaultBg, {
        color: token.defaultHoverColor,
        borderColor: token.defaultHoverBorderColor,
        background: token.defaultHoverBg
    }, {
        color: token.defaultActiveColor,
        borderColor: token.defaultActiveBorderColor,
        background: token.defaultActiveBg
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.textTextColor, 'text', {
        color: token.textTextHoverColor,
        background: token.textHoverBg
    }, {
        color: token.textTextActiveColor,
        background: token.colorBgTextActive
    })), $c8777cbef437af7e$var$genSolidButtonStyle(token, token.primaryColor, token.colorPrimary, {
        background: token.colorPrimaryHover,
        color: token.primaryColor
    }, {
        background: token.colorPrimaryActive,
        color: token.primaryColor
    })), $c8777cbef437af7e$var$genTextLinkButtonStyle(token, token.colorLink, 'link', {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    }));
// =============================== Size ===============================
const $c8777cbef437af7e$var$genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $aWTY1.unit)(buttonPaddingVertical)} ${(0, $aWTY1.unit)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $c8777cbef437af7e$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: $c8777cbef437af7e$var$genRoundButtonStyle(token)
        }
    ];
};
const $c8777cbef437af7e$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $8Olk9.merge)(token, {
        fontSize: token.contentFontSize
    });
    return $c8777cbef437af7e$var$genButtonStyle(baseToken, token.componentCls);
};
const $c8777cbef437af7e$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $8Olk9.merge)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $c8777cbef437af7e$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $c8777cbef437af7e$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $8Olk9.merge)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $c8777cbef437af7e$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $c8777cbef437af7e$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
var // ============================== Export ==============================
$c8777cbef437af7e$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Button', (token)=>{
    const buttonToken = (0, $9nSnF.prepareToken)(token);
    return [
        // Shared
        $c8777cbef437af7e$var$genSharedButtonStyle(buttonToken),
        // Size
        $c8777cbef437af7e$var$genSizeBaseButtonStyle(buttonToken),
        $c8777cbef437af7e$var$genSizeSmallButtonStyle(buttonToken),
        $c8777cbef437af7e$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $c8777cbef437af7e$var$genBlockButtonStyle(buttonToken),
        // Color
        $c8777cbef437af7e$var$genColorButtonStyle(buttonToken),
        // https://github.com/ant-design/ant-design/issues/50969
        $c8777cbef437af7e$var$genCompatibleButtonStyle(buttonToken),
        // Button Group
        (0, $28A7s.default)(buttonToken)
    ];
}, (0, $9nSnF.prepareComponentToken), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});

});
parcelRegister("28A7s", function(module, exports) {

$parcel$export(module.exports, "default", () => $18e858ae15c56c86$export$2e2bcd8739ae039);
const $18e858ae15c56c86$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $18e858ae15c56c86$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $18e858ae15c56c86$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $18e858ae15c56c86$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $18e858ae15c56c86$export$2e2bcd8739ae039 = $18e858ae15c56c86$var$genGroupStyle;

});

parcelRegister("9nSnF", function(module, exports) {

$parcel$export(module.exports, "prepareToken", () => $01c35cad071e04e0$export$362fb92a8f81bbf9);
$parcel$export(module.exports, "prepareComponentToken", () => $01c35cad071e04e0$export$9ca1be8807fe0675);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $flvmh = parcelRequire("flvmh");

var $67VPf = parcelRequire("67VPf");

var $cwoZg = parcelRequire("cwoZg");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $gGv71 = parcelRequire("gGv71");

var $fF4Xy = parcelRequire("fF4Xy");
const $01c35cad071e04e0$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize } = token;
    const buttonToken = (0, $8Olk9.merge)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $01c35cad071e04e0$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c, _d, _e, _f;
    const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
    const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
    const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
    const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0, $cwoZg.getLineHeight)(contentFontSize);
    const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, $cwoZg.getLineHeight)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, $cwoZg.getLineHeight)(contentFontSizeLG);
    const solidTextColor = (0, $67VPf.isBright)(new (0, $flvmh.AggregationColor)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, $gGv71.PresetColors).reduce((prev, colorKey)=>Object.assign(Object.assign({}, prev), {
            [`${colorKey}ShadowColor`]: `0 ${(0, $aWTY1.unit)(token.controlOutlineWidth)} 0 ${(0, $fF4Xy.default)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    return Object.assign(Object.assign({}, shadowColorTokens), {
        fontWeight: 400,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
    });
};

});
parcelRegister("flvmh", function(module, exports) {

$parcel$export(module.exports, "AggregationColor", () => $b2c1244a6071139d$export$e8cc8a2e87e145b4);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");
parcelRequire("arcxy");
var $gLmye = parcelRequire("gLmye");
const $b2c1244a6071139d$export$d0aa8b5e56c9af06 = (value, alpha)=>(value === null || value === void 0 ? void 0 : value.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6)) || '';
const $b2c1244a6071139d$export$6c90ef703dcfba25 = (value, alpha)=>value ? $b2c1244a6071139d$export$d0aa8b5e56c9af06(value, alpha) : '';
let $b2c1244a6071139d$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $dYVVZ.default)(this, AggregationColor);
        var _a;
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = (_a = color.colors) === null || _a === void 0 ? void 0 : _a.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $gLmye.Color)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $gLmye.Color)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $hevvH.default)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $b2c1244a6071139d$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();

});
parcelRegister("arcxy", function(module, exports) {

$parcel$export(module.exports, "Color", () => (parcelRequire("gLmye")).Color);
$parcel$export(module.exports, "ColorBlock", () => (parcelRequire("hSphY")).default);

var $3ZbL9 = parcelRequire("3ZbL9");

var $gLmye = parcelRequire("gLmye");

var $hSphY = parcelRequire("hSphY");
parcelRequire("22cMp");
var $7996273c267c570a$export$2e2bcd8739ae039 = (0, $3ZbL9.default);

});
parcelRegister("3ZbL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e7030cebe6e8f71$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $654qo = parcelRequire("654qo");

var $bqPQ9 = parcelRequire("bqPQ9");

var $gLmye = parcelRequire("gLmye");

var $hSphY = parcelRequire("hSphY");

var $20iYx = parcelRequire("20iYx");

var $frntj = parcelRequire("frntj");

var $9Fynw = parcelRequire("9Fynw");
var $2e7030cebe6e8f71$var$HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
var $2e7030cebe6e8f71$var$ColorPicker = /*#__PURE__*/ (0, $aqdBs.forwardRef)(function(props, ref) {
    var value = props.value, defaultValue = props.defaultValue, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $654qo.ColorPickerPrefixCls) : _props$prefixCls, onChange = props.onChange, onChangeComplete = props.onChangeComplete, className = props.className, style = props.style, panelRender = props.panelRender, _props$disabledAlpha = props.disabledAlpha, disabledAlpha = _props$disabledAlpha === void 0 ? false : _props$disabledAlpha, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, components = props.components;
    // ========================== Components ==========================
    var _useComponent = (0, $9Fynw.default)(components), _useComponent2 = (0, $kelIR.default)(_useComponent, 1), Slider = _useComponent2[0];
    // ============================ Color =============================
    var _useColorState = (0, $frntj.default)(defaultValue || (0, $654qo.defaultColor), value), _useColorState2 = (0, $kelIR.default)(_useColorState, 2), colorValue = _useColorState2[0], setColorValue = _useColorState2[1];
    var alphaColor = (0, $aqdBs.useMemo)(function() {
        return colorValue.setA(1).toRgbString();
    }, [
        colorValue
    ]);
    // ============================ Events ============================
    var handleChange = function handleChange(data, type) {
        if (!value) setColorValue(data);
        onChange === null || onChange === void 0 || onChange(data, type);
    };
    // Convert
    var getHueColor = function getHueColor(hue) {
        return new (0, $gLmye.Color)(colorValue.setHue(hue));
    };
    var getAlphaColor = function getAlphaColor(alpha) {
        return new (0, $gLmye.Color)(colorValue.setA(alpha / 100));
    };
    // Slider change
    var onHueChange = function onHueChange(hue) {
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    var onAlphaChange = function onAlphaChange(alpha) {
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    var onHueChangeComplete = function onHueChangeComplete(hue) {
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    var onAlphaChangeComplete = function onAlphaChangeComplete(alpha) {
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    var mergeCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-panel"), className, (0, $br1G4.default)({}, "".concat(prefixCls, "-panel-disabled"), disabled));
    var sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    var defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $20iYx.default), (0, $13KW1.default)({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-slider-container")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-slider-group"), (0, $br1G4.default)({}, "".concat(prefixCls, "-slider-group-disabled-alpha"), disabledAlpha))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(Slider, (0, $13KW1.default)({}, sharedSliderProps, {
        type: "hue",
        colors: $2e7030cebe6e8f71$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(Slider, (0, $13KW1.default)({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $hSphY.default), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
var $2e7030cebe6e8f71$export$2e2bcd8739ae039 = $2e7030cebe6e8f71$var$ColorPicker;

});
parcelRegister("654qo", function(module, exports) {

$parcel$export(module.exports, "ColorPickerPrefixCls", () => $46d6a45c7f82a549$export$90004e2badfbdf1f);
$parcel$export(module.exports, "generateColor", () => $46d6a45c7f82a549$export$c844f5d21427d1ab);
$parcel$export(module.exports, "defaultColor", () => $46d6a45c7f82a549$export$f705f0fde43a55a);
$parcel$export(module.exports, "calculateColor", () => $46d6a45c7f82a549$export$3a7095e9fd85a71d);
$parcel$export(module.exports, "calcOffset", () => $46d6a45c7f82a549$export$20165527867cbf14);

var $4f2X8 = parcelRequire("4f2X8");

var $gLmye = parcelRequire("gLmye");
var $46d6a45c7f82a549$export$90004e2badfbdf1f = 'rc-color-picker';
var $46d6a45c7f82a549$export$c844f5d21427d1ab = function generateColor(color) {
    if (color instanceof (0, $gLmye.Color)) return color;
    return new (0, $gLmye.Color)(color);
};
var $46d6a45c7f82a549$export$f705f0fde43a55a = $46d6a45c7f82a549$export$c844f5d21427d1ab('#1677ff');
var $46d6a45c7f82a549$export$3a7095e9fd85a71d = function calculateColor(props) {
    var offset = props.offset, targetRef = props.targetRef, containerRef = props.containerRef, color = props.color, type = props.type;
    var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
    var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
    var centerOffsetX = targetWidth / 2;
    var centerOffsetY = targetHeight / 2;
    var saturation = (offset.x + centerOffsetX) / width;
    var bright = 1 - (offset.y + centerOffsetY) / height;
    var hsb = color.toHsb();
    var alphaOffset = saturation;
    var hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return $46d6a45c7f82a549$export$c844f5d21427d1ab((0, $4f2X8.default)((0, $4f2X8.default)({}, hsb), {}, {
                h: hueOffset <= 0 ? 0 : hueOffset
            }));
        case 'alpha':
            return $46d6a45c7f82a549$export$c844f5d21427d1ab((0, $4f2X8.default)((0, $4f2X8.default)({}, hsb), {}, {
                a: alphaOffset <= 0 ? 0 : alphaOffset
            }));
    }
    return $46d6a45c7f82a549$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
var $46d6a45c7f82a549$export$20165527867cbf14 = function calcOffset(color, type) {
    var hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};

});
parcelRegister("gLmye", function(module, exports) {

$parcel$export(module.exports, "Color", () => $c342874bae1dba3a$export$892596cec99bc70e);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $7IgoF = parcelRequire("7IgoF");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
var $c342874bae1dba3a$var$_excluded = [
    "b"
], $c342874bae1dba3a$var$_excluded2 = [
    "v"
];
var $c342874bae1dba3a$export$8d6531175688484b = function getRoundNumber(value) {
    return Math.round(Number(value || 0));
};
var $c342874bae1dba3a$var$convertHsb2Hsv = function convertHsb2Hsv(color) {
    if (color instanceof (0, $bkcIW.FastColor)) return color;
    if (color && (0, $7IgoF.default)(color) === 'object' && 'h' in color && 'b' in color) {
        var _ref = color, b = _ref.b, resets = (0, $aX4Fp.default)(_ref, $c342874bae1dba3a$var$_excluded);
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, resets), {}, {
            v: b
        });
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
var $c342874bae1dba3a$export$892596cec99bc70e = /*#__PURE__*/ function(_FastColor) {
    (0, $9nc35.default)(Color, _FastColor);
    var _super = (0, $lriWM.default)(Color);
    function Color(color) {
        (0, $dYVVZ.default)(this, Color);
        return _super.call(this, $c342874bae1dba3a$var$convertHsb2Hsv(color));
    }
    (0, $hevvH.default)(Color, [
        {
            key: "toHsbString",
            value: function toHsbString() {
                var hsb = this.toHsb();
                var saturation = $c342874bae1dba3a$export$8d6531175688484b(hsb.s * 100);
                var lightness = $c342874bae1dba3a$export$8d6531175688484b(hsb.b * 100);
                var hue = $c342874bae1dba3a$export$8d6531175688484b(hsb.h);
                var alpha = hsb.a;
                var hsbString = "hsb(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
                var hsbaString = "hsba(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%, ").concat(alpha.toFixed(alpha === 0 ? 0 : 2), ")");
                return alpha === 1 ? hsbString : hsbaString;
            }
        },
        {
            key: "toHsb",
            value: function toHsb() {
                var _this$toHsv = this.toHsv(), v = _this$toHsv.v, resets = (0, $aX4Fp.default)(_this$toHsv, $c342874bae1dba3a$var$_excluded2);
                return (0, $4f2X8.default)((0, $4f2X8.default)({}, resets), {}, {
                    b: v,
                    a: this.a
                });
            }
        }
    ]);
    return Color;
}((0, $bkcIW.FastColor));

});


parcelRegister("hSphY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d03b18ad05058178$export$2e2bcd8739ae039);

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");
var $d03b18ad05058178$var$ColorBlock = function ColorBlock(_ref) {
    var color = _ref.color, prefixCls = _ref.prefixCls, className = _ref.className, style = _ref.style, onClick = _ref.onClick;
    var colorBlockCls = "".concat(prefixCls, "-color-block");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(colorBlockCls, "-inner"),
        style: {
            background: color
        }
    }));
};
var $d03b18ad05058178$export$2e2bcd8739ae039 = $d03b18ad05058178$var$ColorBlock;

});

parcelRegister("20iYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $175a4cfeba19d3bd$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $lWXj9 = parcelRequire("lWXj9");

var $654qo = parcelRequire("654qo");
parcelRequire("2UjQ5");
var $k91S5 = parcelRequire("k91S5");

var $9SODc = parcelRequire("9SODc");

var $e2Tjr = parcelRequire("e2Tjr");

var $1FhNX = parcelRequire("1FhNX");
var $175a4cfeba19d3bd$var$Picker = function Picker(_ref) {
    var color = _ref.color, onChange = _ref.onChange, prefixCls = _ref.prefixCls, onChangeComplete = _ref.onChangeComplete, disabled = _ref.disabled;
    var pickerRef = (0, $aqdBs.useRef)();
    var transformRef = (0, $aqdBs.useRef)();
    var colorRef = (0, $aqdBs.useRef)(color);
    var onDragChange = (0, $k91S5.default)(function(offsetValue) {
        var calcColor = (0, $654qo.calculateColor)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    var _useColorDrag = (0, $lWXj9.default)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: function calculate() {
            return (0, $654qo.calcOffset)(color);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            return onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(colorRef.current);
        },
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $kelIR.default)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        ref: pickerRef,
        className: "".concat(prefixCls, "-select"),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e2Tjr.default), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $1FhNX.default), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9SODc.default), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-saturation"),
        style: {
            backgroundColor: "hsl(".concat(color.toHsb().h, ",100%, 50%)"),
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
var $175a4cfeba19d3bd$export$2e2bcd8739ae039 = $175a4cfeba19d3bd$var$Picker;

});
parcelRegister("lWXj9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffad051497c0913b$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");
function $ffad051497c0913b$var$getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    var scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    var scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $ffad051497c0913b$var$useColorDrag(props) {
    var targetRef = props.targetRef, containerRef = props.containerRef, direction = props.direction, onDragChange = props.onDragChange, onDragChangeComplete = props.onDragChangeComplete, calculate = props.calculate, color = props.color, disabledDrag = props.disabledDrag;
    var _useState = (0, $aqdBs.useState)({
        x: 0,
        y: 0
    }), _useState2 = (0, $kelIR.default)(_useState, 2), offsetValue = _useState2[0], setOffsetValue = _useState2[1];
    var mouseMoveRef = (0, $aqdBs.useRef)(null);
    var mouseUpRef = (0, $aqdBs.useRef)(null);
    // Always get position from `color`
    (0, $aqdBs.useEffect)(function() {
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $aqdBs.useEffect)(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        };
    }, []);
    var updateOffset = function updateOffset(e) {
        var _getPosition = $ffad051497c0913b$var$getPosition(e), pageX = _getPosition.pageX, pageY = _getPosition.pageY;
        var _containerRef$current = containerRef.current.getBoundingClientRect(), rectX = _containerRef$current.x, rectY = _containerRef$current.y, width = _containerRef$current.width, height = _containerRef$current.height;
        var _targetRef$current$ge = targetRef.current.getBoundingClientRect(), targetWidth = _targetRef$current$ge.width, targetHeight = _targetRef$current$ge.height;
        var centerOffsetX = targetWidth / 2;
        var centerOffsetY = targetHeight / 2;
        var offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        var offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        var calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange === null || onDragChange === void 0 || onDragChange(calcOffset);
    };
    var onDragMove = function onDragMove(e) {
        e.preventDefault();
        updateOffset(e);
    };
    var onDragStop = function onDragStop(e) {
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete === null || onDragChangeComplete === void 0 || onDragChangeComplete();
    };
    var onDragStart = function onDragStart(e) {
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $ffad051497c0913b$export$2e2bcd8739ae039 = $ffad051497c0913b$var$useColorDrag;

});

parcelRegister("9SODc", function(module, exports) {

$parcel$export(module.exports, "default", () => $73206e7f26e87795$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");
var $73206e7f26e87795$var$Handler = function Handler(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'default' : _ref$size, color = _ref.color, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-handler"), (0, $br1G4.default)({}, "".concat(prefixCls, "-handler-sm"), size === 'small')),
        style: {
            backgroundColor: color
        }
    });
};
var $73206e7f26e87795$export$2e2bcd8739ae039 = $73206e7f26e87795$var$Handler;

});

parcelRegister("e2Tjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a39c288995e21733$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");
var $a39c288995e21733$var$Palette = function Palette(_ref) {
    var children = _ref.children, style = _ref.style, prefixCls = _ref.prefixCls;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-palette"),
        style: (0, $4f2X8.default)({
            position: 'relative'
        }, style)
    }, children);
};
var $a39c288995e21733$export$2e2bcd8739ae039 = $a39c288995e21733$var$Palette;

});

parcelRegister("1FhNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $13676e6cf742e179$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $13676e6cf742e179$var$Transform = /*#__PURE__*/ (0, $aqdBs.forwardRef)(function(props, ref) {
    var children = props.children, x = props.x, y = props.y;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: "".concat(x, "%"),
            top: "".concat(y, "%"),
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
var $13676e6cf742e179$export$2e2bcd8739ae039 = $13676e6cf742e179$var$Transform;

});


parcelRegister("frntj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3db95a3cd9e1ad8$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");
parcelRequire("2UjQ5");
var $eAKDF = parcelRequire("eAKDF");

var $aqdBs = parcelRequire("aqdBs");

var $654qo = parcelRequire("654qo");
var $b3db95a3cd9e1ad8$var$useColorState = function useColorState(defaultValue, value) {
    var _useMergedState = (0, $eAKDF.default)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var color = (0, $aqdBs.useMemo)(function() {
        return (0, $654qo.generateColor)(mergedValue);
    }, [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $b3db95a3cd9e1ad8$export$2e2bcd8739ae039 = $b3db95a3cd9e1ad8$var$useColorState;

});

parcelRegister("9Fynw", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a29c39c750fecb$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $l06h0 = parcelRequire("l06h0");
function $70a29c39c750fecb$export$2e2bcd8739ae039(components) {
    return $aqdBs.useMemo(function() {
        var _ref = components || {}, slider = _ref.slider;
        return [
            slider || (0, $l06h0.default)
        ];
    }, [
        components
    ]);
}

});
parcelRegister("l06h0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f49e76cdb2e62160$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $lWXj9 = parcelRequire("lWXj9");

var $e2Tjr = parcelRequire("e2Tjr");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("2UjQ5");
var $k91S5 = parcelRequire("k91S5");

var $gLmye = parcelRequire("gLmye");

var $654qo = parcelRequire("654qo");

var $4Nm7e = parcelRequire("4Nm7e");

var $9SODc = parcelRequire("9SODc");

var $1FhNX = parcelRequire("1FhNX");
var $f49e76cdb2e62160$var$Slider = function Slider(props) {
    var prefixCls = props.prefixCls, colors = props.colors, disabled = props.disabled, onChange = props.onChange, onChangeComplete = props.onChangeComplete, color = props.color, type = props.type;
    var sliderRef = (0, $aqdBs.useRef)();
    var transformRef = (0, $aqdBs.useRef)();
    var colorRef = (0, $aqdBs.useRef)(color);
    var getValue = function getValue(c) {
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    var onDragChange = (0, $k91S5.default)(function(offsetValue) {
        var calcColor = (0, $654qo.calculateColor)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    var _useColorDrag = (0, $lWXj9.default)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: function calculate() {
            return (0, $654qo.calcOffset)(color, type);
        },
        onDragChange: onDragChange,
        onDragChangeComplete: function onDragChangeComplete() {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    }), _useColorDrag2 = (0, $kelIR.default)(_useColorDrag, 2), offset = _useColorDrag2[0], dragStartHandle = _useColorDrag2[1];
    var handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(function() {
        if (type === 'hue') {
            var hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            var lightColor = new (0, $gLmye.Color)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    var gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(function() {
        return colors.map(function(info) {
            return "".concat(info.color, " ").concat(info.percent, "%");
        });
    }, [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        ref: sliderRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-slider"), "".concat(prefixCls, "-slider-").concat(type)),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $e2Tjr.default), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $1FhNX.default), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $9SODc.default), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $4Nm7e.default), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $f49e76cdb2e62160$export$2e2bcd8739ae039 = $f49e76cdb2e62160$var$Slider;

});
parcelRegister("4Nm7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dce4bb502ca1a8$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $gLmye = parcelRequire("gLmye");

var $654qo = parcelRequire("654qo");
var $37dce4bb502ca1a8$var$Gradient = function Gradient(_ref) {
    var colors = _ref.colors, children = _ref.children, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'to right' : _ref$direction, type = _ref.type, prefixCls = _ref.prefixCls;
    var gradientColors = (0, $aqdBs.useMemo)(function() {
        return colors.map(function(color, idx) {
            var result = (0, $654qo.generateColor)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, $gLmye.Color)(result.setA(1));
            return result.toRgbString();
        }).join(',');
    }, [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-gradient"),
        style: {
            position: 'absolute',
            inset: 0,
            background: "linear-gradient(".concat(direction, ", ").concat(gradientColors, ")")
        }
    }, children);
};
var $37dce4bb502ca1a8$export$2e2bcd8739ae039 = $37dce4bb502ca1a8$var$Gradient;

});




parcelRegister("22cMp", function(module, exports) {

});



parcelRegister("67VPf", function(module, exports) {

$parcel$export(module.exports, "isBright", () => $476040784581dfb0$export$6341b37cb79161da);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("arcxy");
var $gLmye = parcelRequire("gLmye");
var $hSphY = parcelRequire("hSphY");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eAKDF = parcelRequire("eAKDF");

var $kVnlc = parcelRequire("kVnlc");

var $h1ynd = parcelRequire("h1ynd");

var $jygCN = parcelRequire("jygCN");

var $4hrc8 = parcelRequire("4hrc8");
"use client";
const $476040784581dfb0$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $4hrc8.generateColor));
        return value;
    });
const $476040784581dfb0$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $gLmye.Color)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $476040784581dfb0$var$genCollapsePanelKey = (preset, index)=>{
    var _a;
    const mergedKey = (_a = preset.key) !== null && _a !== void 0 ? _a : index;
    return `panel-${mergedKey}`;
};
const $476040784581dfb0$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $h1ynd.default)('ColorPicker');
    const [, token] = (0, $jygCN.default)();
    const [presetsValue] = (0, $eAKDF.default)($476040784581dfb0$var$genPresetColor(presets), {
        value: $476040784581dfb0$var$genPresetColor(presets),
        postState: $476040784581dfb0$var$genPresetColor
    });
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $aqdBs.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($476040784581dfb0$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange === null || onChange === void 0 || onChange(colorValue);
    };
    const items = presetsValue.map((preset, index)=>{
        var _a;
        return {
            key: $476040784581dfb0$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset === null || preset === void 0 ? void 0 : preset.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset === null || preset === void 0 ? void 0 : preset.colors) && ((_a = preset.colors) === null || _a === void 0 ? void 0 : _a.length) > 0 ? preset.colors.map((presetColor, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $hSphY.default), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: (0, $4hrc8.generateColor)(presetColor).toRgbString(),
                    prefixCls: prefixCls,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toHexString() === (color === null || color === void 0 ? void 0 : color.toHexString()),
                        [`${colorPresetsPrefixCls}-color-bright`]: $476040784581dfb0$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $kVnlc.default), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $476040784581dfb0$export$2e2bcd8739ae039 = $476040784581dfb0$var$ColorPresets;

});
parcelRegister("kVnlc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb3c8a78ead891$export$2e2bcd8739ae039);

var $6krZI = parcelRequire("6krZI");
"use client";
var $f3bb3c8a78ead891$export$2e2bcd8739ae039 = (0, $6krZI.default);

});
parcelRegister("6krZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ba53716a429094$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $k3pyC = parcelRequire("k3pyC");

var $bqPQ9 = parcelRequire("bqPQ9");

var $4Qpou = parcelRequire("4Qpou");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $1iwLi = parcelRequire("1iwLi");

var $dLmcO = parcelRequire("dLmcO");

var $iOHOh = parcelRequire("iOHOh");


var $kjlvF = parcelRequire("kjlvF");

var $3m1Z3 = parcelRequire("3m1Z3");

var $b3BHG = parcelRequire("b3BHG");

var $iCnPK = parcelRequire("iCnPK");
"use client";
const $49ba53716a429094$var$Collapse = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle } = (0, $kjlvF.useComponentConfig)('collapse');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPosition: expandIconPosition = 'start', children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon } = props;
    const mergedSize = (0, $3m1Z3.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : ctx) !== null && _a !== void 0 ? _a : 'middle';
    });
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [wrapCSSVar, hashId, cssVarCls] = (0, $iCnPK.default)(prefixCls);
    // Align with logic position
    const mergedExpandIconPosition = $aqdBs.useMemo(()=>{
        if (expandIconPosition === 'left') return 'start';
        return expandIconPosition === 'right' ? 'end' : expandIconPosition;
    }, [
        expandIconPosition
    ]);
    const mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    const renderExpandIcon = $aqdBs.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $aqdBs.createElement((0, $k3pyC.default), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, $iOHOh.cloneElement)(icon, ()=>{
            var _a;
            return {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))((_a = icon === null || icon === void 0 ? void 0 : icon.props) === null || _a === void 0 ? void 0 : _a.className, `${prefixCls}-arrow`)
            };
        });
    }, [
        mergedExpandIcon,
        prefixCls
    ]);
    const collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-icon-position-${mergedExpandIconPosition}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const openMotion = Object.assign(Object.assign({}, (0, $dLmcO.default)(rootPrefixCls)), {
        motionAppear: false,
        leavedClassName: `${prefixCls}-content-hidden`
    });
    const items = $aqdBs.useMemo(()=>{
        if (children) return (0, $bZ6Ai.default)(children).map((child, index)=>{
            var _a, _b;
            const childProps = child.props;
            if (childProps === null || childProps === void 0 ? void 0 : childProps.disabled) {
                const key = (_a = child.key) !== null && _a !== void 0 ? _a : String(index);
                const mergedChildProps = Object.assign(Object.assign({}, (0, $1iwLi.default)(child.props, [
                    'disabled'
                ])), {
                    key: key,
                    collapsible: (_b = childProps.collapsible) !== null && _b !== void 0 ? _b : 'disabled'
                });
                return (0, $iOHOh.cloneElement)(child, mergedChildProps);
            }
            return child;
        });
        return null;
    }, [
        children
    ]);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    $aqdBs.createElement((0, $4Qpou.default), Object.assign({
        ref: ref,
        openMotion: openMotion
    }, (0, $1iwLi.default)(props, [
        'rootClassName'
    ]), {
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: Object.assign(Object.assign({}, contextStyle), style),
        // TODO: In the future, destroyInactivePanel in rc-collapse needs to be upgrade to destroyOnHidden
        destroyInactivePanel: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyInactivePanel
    }), items));
});
var $49ba53716a429094$export$2e2bcd8739ae039 = Object.assign($49ba53716a429094$var$Collapse, {
    Panel: (0, $b3BHG.default)
});

});
parcelRegister("k3pyC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e997e9a1d730acf7$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $8lMDc = parcelRequire("8lMDc");

var $gL7Ec = parcelRequire("gL7Ec");
var $e997e9a1d730acf7$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $8lMDc.default)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $e997e9a1d730acf7$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($e997e9a1d730acf7$var$RightOutlined);
var $e997e9a1d730acf7$export$2e2bcd8739ae039 = $e997e9a1d730acf7$var$RefIcon;

});
parcelRegister("8lMDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6146020f7d2d07a2$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $6146020f7d2d07a2$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $6146020f7d2d07a2$export$2e2bcd8739ae039 = $6146020f7d2d07a2$var$RightOutlined;

});


parcelRegister("4Qpou", function(module, exports) {

$parcel$export(module.exports, "default", () => $386fb7759571e14d$export$2e2bcd8739ae039);

var $9kLQm = parcelRequire("9kLQm");
var $386fb7759571e14d$export$2e2bcd8739ae039 = (0, $9kLQm.default);
/**
 * @deprecated use `items` instead, will be removed in `v4.0.0`
 */ var $386fb7759571e14d$export$2ddb90ad54e5f587 = (0, $9kLQm.default).Panel;

});
parcelRegister("9kLQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cbb1805bf32e3ee$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $7IgoF = parcelRequire("7IgoF");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eAKDF = parcelRequire("eAKDF");

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $jV4ZN = parcelRequire("jV4ZN");

var $3KWeh = parcelRequire("3KWeh");

var $bWa8g = parcelRequire("bWa8g");
function $6cbb1805bf32e3ee$var$getActiveKeysArray(activeKey) {
    var currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        var activeKeyType = (0, $7IgoF.default)(currentActiveKey);
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map(function(key) {
        return String(key);
    });
}
var $6cbb1805bf32e3ee$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-collapse' : _props$prefixCls, _props$destroyInactiv = props.destroyInactivePanel, destroyInactivePanel = _props$destroyInactiv === void 0 ? false : _props$destroyInactiv, style = props.style, accordion = props.accordion, className = props.className, children = props.children, collapsible = props.collapsible, openMotion = props.openMotion, expandIcon = props.expandIcon, rawActiveKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, _onChange = props.onChange, items = props.items;
    var collapseClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className);
    var _useMergedState = (0, $eAKDF.default)([], {
        value: rawActiveKey,
        onChange: function onChange(v) {
            return _onChange === null || _onChange === void 0 ? void 0 : _onChange(v);
        },
        defaultValue: defaultActiveKey,
        postState: $6cbb1805bf32e3ee$var$getActiveKeysArray
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), activeKey = _useMergedState2[0], setActiveKey = _useMergedState2[1];
    var onItemClick = function onItemClick(key) {
        return setActiveKey(function() {
            if (accordion) return activeKey[0] === key ? [] : [
                key
            ];
            var index = activeKey.indexOf(key);
            var isActive = index > -1;
            if (isActive) return activeKey.filter(function(item) {
                return item !== key;
            });
            return [].concat((0, $dMbbs.default)(activeKey), [
                key
            ]);
        });
    };
    // ======================== Children ========================
    (0, $i7X5i.default)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    var mergedChildren = (0, $jV4ZN.default)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyInactivePanel: destroyInactivePanel,
        onItemClick: onItemClick,
        activeKey: activeKey
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", (0, $13KW1.default)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, $bWa8g.default)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $6cbb1805bf32e3ee$export$2e2bcd8739ae039 = Object.assign($6cbb1805bf32e3ee$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $3KWeh.default)
});

});
parcelRegister("jV4ZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8073739c677a7e6$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $aqdBs = parcelRequire("aqdBs");

var $3KWeh = parcelRequire("3KWeh");
var $e8073739c677a7e6$var$_excluded = [
    "children",
    "label",
    "key",
    "collapsible",
    "onItemClick",
    "destroyInactivePanel"
];
var $e8073739c677a7e6$var$convertItemsToNodes = function convertItemsToNodes(items, props) {
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    return items.map(function(item, index) {
        var children = item.children, label = item.label, rawKey = item.key, rawCollapsible = item.collapsible, rawOnItemClick = item.onItemClick, rawDestroyInactivePanel = item.destroyInactivePanel, restProps = (0, $aX4Fp.default)(item, $e8073739c677a7e6$var$_excluded);
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        var key = String(rawKey !== null && rawKey !== void 0 ? rawKey : index);
        var mergeCollapsible = rawCollapsible !== null && rawCollapsible !== void 0 ? rawCollapsible : collapsible;
        var mergeDestroyInactivePanel = rawDestroyInactivePanel !== null && rawDestroyInactivePanel !== void 0 ? rawDestroyInactivePanel : destroyInactivePanel;
        var handleItemClick = function handleItemClick(value) {
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick === null || rawOnItemClick === void 0 || rawOnItemClick(value);
        };
        var isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $3KWeh.default), (0, $13KW1.default)({}, restProps, {
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyInactivePanel: mergeDestroyInactivePanel
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ var $e8073739c677a7e6$var$getNewChild = function getNewChild(child, index, props) {
    if (!child) return null;
    var prefixCls = props.prefixCls, accordion = props.accordion, collapsible = props.collapsible, destroyInactivePanel = props.destroyInactivePanel, onItemClick = props.onItemClick, activeKey = props.activeKey, openMotion = props.openMotion, expandIcon = props.expandIcon;
    var key = child.key || String(index);
    var _child$props = child.props, header = _child$props.header, headerClass = _child$props.headerClass, childDestroyInactivePanel = _child$props.destroyInactivePanel, childCollapsible = _child$props.collapsible, childOnItemClick = _child$props.onItemClick;
    var isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    var mergeCollapsible = childCollapsible !== null && childCollapsible !== void 0 ? childCollapsible : collapsible;
    var handleItemClick = function handleItemClick(value) {
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick === null || childOnItemClick === void 0 || childOnItemClick(value);
    };
    var childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyInactivePanel: childDestroyInactivePanel !== null && childDestroyInactivePanel !== void 0 ? childDestroyInactivePanel : destroyInactivePanel,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach(function(propName) {
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(child, childProps);
};
function $e8073739c677a7e6$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $e8073739c677a7e6$var$convertItemsToNodes(items, props);
    return (0, $bZ6Ai.default)(rawChildren).map(function(child, index) {
        return $e8073739c677a7e6$var$getNewChild(child, index, props);
    });
}
var $e8073739c677a7e6$export$2e2bcd8739ae039 = $e8073739c677a7e6$var$useItems;

});
parcelRegister("3KWeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc2d61b591c692e$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $dHI2t = parcelRequire("dHI2t");

var $aqdBs = parcelRequire("aqdBs");

var $cYiQm = parcelRequire("cYiQm");
var $2bc2d61b591c692e$var$_excluded = [
    "showArrow",
    "headerClass",
    "isActive",
    "onItemClick",
    "forceRender",
    "className",
    "classNames",
    "styles",
    "prefixCls",
    "collapsible",
    "accordion",
    "panelKey",
    "extra",
    "header",
    "expandIcon",
    "openMotion",
    "destroyInactivePanel",
    "children"
];
var $2bc2d61b591c692e$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
    var _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, headerClass = props.headerClass, isActive = props.isActive, onItemClick = props.onItemClick, forceRender = props.forceRender, className = props.className, _props$classNames = props.classNames, customizeClassNames = _props$classNames === void 0 ? {} : _props$classNames, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, prefixCls = props.prefixCls, collapsible = props.collapsible, accordion = props.accordion, panelKey = props.panelKey, extra = props.extra, header = props.header, expandIcon = props.expandIcon, openMotion = props.openMotion, destroyInactivePanel = props.destroyInactivePanel, children = props.children, resetProps = (0, $aX4Fp.default)(props, $2bc2d61b591c692e$var$_excluded);
    var disabled = collapsible === 'disabled';
    var ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    var collapsibleProps = (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({
        onClick: function onClick() {
            onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.keyCode === (0, $dHI2t.default).ENTER || e.which === (0, $dHI2t.default).ENTER) onItemClick === null || onItemClick === void 0 || onItemClick(panelKey);
        },
        role: accordion ? 'tab' : 'button'
    }, 'aria-expanded', isActive), 'aria-disabled', disabled), "tabIndex", disabled ? -1 : 0);
    // ======================== Icon ========================
    var iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("i", {
        className: "arrow"
    });
    var iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", (0, $13KW1.default)({
        className: "".concat(prefixCls, "-expand-icon")
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    var collapsePanelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-item"), (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-item-active"), isActive), "".concat(prefixCls, "-item-disabled"), disabled), className);
    var headerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(headerClass, "".concat(prefixCls, "-header"), (0, $br1G4.default)({}, "".concat(prefixCls, "-collapsible-").concat(collapsible), !!collapsible), customizeClassNames.header);
    // ======================== HeaderProps ========================
    var headerProps = (0, $4f2X8.default)({
        className: headerClassName,
        style: styles.header
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? {} : collapsibleProps);
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", (0, $13KW1.default)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", (0, $13KW1.default)({
        className: "".concat(prefixCls, "-header-text")
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-extra")
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $6ufPd.default), (0, $13KW1.default)({
        visible: isActive,
        leavedClassName: "".concat(prefixCls, "-content-hidden")
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyInactivePanel
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $cYiQm.default), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : void 0
        }, children);
    }));
});
var $2bc2d61b591c692e$export$2e2bcd8739ae039 = $2bc2d61b591c692e$var$CollapsePanel;

});
parcelRegister("dHI2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa173b8fbcd72e1$export$2e2bcd8739ae039);
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $9fa173b8fbcd72e1$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $9fa173b8fbcd72e1$var$KeyCode.F1 && keyCode <= $9fa173b8fbcd72e1$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $9fa173b8fbcd72e1$var$KeyCode.ALT:
            case $9fa173b8fbcd72e1$var$KeyCode.CAPS_LOCK:
            case $9fa173b8fbcd72e1$var$KeyCode.CONTEXT_MENU:
            case $9fa173b8fbcd72e1$var$KeyCode.CTRL:
            case $9fa173b8fbcd72e1$var$KeyCode.DOWN:
            case $9fa173b8fbcd72e1$var$KeyCode.END:
            case $9fa173b8fbcd72e1$var$KeyCode.ESC:
            case $9fa173b8fbcd72e1$var$KeyCode.HOME:
            case $9fa173b8fbcd72e1$var$KeyCode.INSERT:
            case $9fa173b8fbcd72e1$var$KeyCode.LEFT:
            case $9fa173b8fbcd72e1$var$KeyCode.MAC_FF_META:
            case $9fa173b8fbcd72e1$var$KeyCode.META:
            case $9fa173b8fbcd72e1$var$KeyCode.NUMLOCK:
            case $9fa173b8fbcd72e1$var$KeyCode.NUM_CENTER:
            case $9fa173b8fbcd72e1$var$KeyCode.PAGE_DOWN:
            case $9fa173b8fbcd72e1$var$KeyCode.PAGE_UP:
            case $9fa173b8fbcd72e1$var$KeyCode.PAUSE:
            case $9fa173b8fbcd72e1$var$KeyCode.PRINT_SCREEN:
            case $9fa173b8fbcd72e1$var$KeyCode.RIGHT:
            case $9fa173b8fbcd72e1$var$KeyCode.SHIFT:
            case $9fa173b8fbcd72e1$var$KeyCode.UP:
            case $9fa173b8fbcd72e1$var$KeyCode.WIN_KEY:
            case $9fa173b8fbcd72e1$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $9fa173b8fbcd72e1$var$KeyCode.ZERO && keyCode <= $9fa173b8fbcd72e1$var$KeyCode.NINE) return true;
        if (keyCode >= $9fa173b8fbcd72e1$var$KeyCode.NUM_ZERO && keyCode <= $9fa173b8fbcd72e1$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $9fa173b8fbcd72e1$var$KeyCode.A && keyCode <= $9fa173b8fbcd72e1$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $9fa173b8fbcd72e1$var$KeyCode.SPACE:
            case $9fa173b8fbcd72e1$var$KeyCode.QUESTION_MARK:
            case $9fa173b8fbcd72e1$var$KeyCode.NUM_PLUS:
            case $9fa173b8fbcd72e1$var$KeyCode.NUM_MINUS:
            case $9fa173b8fbcd72e1$var$KeyCode.NUM_PERIOD:
            case $9fa173b8fbcd72e1$var$KeyCode.NUM_DIVISION:
            case $9fa173b8fbcd72e1$var$KeyCode.SEMICOLON:
            case $9fa173b8fbcd72e1$var$KeyCode.DASH:
            case $9fa173b8fbcd72e1$var$KeyCode.EQUALS:
            case $9fa173b8fbcd72e1$var$KeyCode.COMMA:
            case $9fa173b8fbcd72e1$var$KeyCode.PERIOD:
            case $9fa173b8fbcd72e1$var$KeyCode.SLASH:
            case $9fa173b8fbcd72e1$var$KeyCode.APOSTROPHE:
            case $9fa173b8fbcd72e1$var$KeyCode.SINGLE_QUOTE:
            case $9fa173b8fbcd72e1$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $9fa173b8fbcd72e1$var$KeyCode.BACKSLASH:
            case $9fa173b8fbcd72e1$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $9fa173b8fbcd72e1$export$2e2bcd8739ae039 = $9fa173b8fbcd72e1$var$KeyCode;

});

parcelRegister("cYiQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719b48a661df0db$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $kelIR = parcelRequire("kelIR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");
var $9719b48a661df0db$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, forceRender = props.forceRender, className = props.className, style = props.style, children = props.children, isActive = props.isActive, role = props.role, customizeClassNames = props.classNames, styles = props.styles;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState(isActive || forceRender), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), rendered = _React$useState2[0], setRendered = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useEffect(function() {
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-content"), (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-content-active"), isActive), "".concat(prefixCls, "-content-inactive"), !isActive), className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-content-box"), customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames.body),
        style: styles === null || styles === void 0 ? void 0 : styles.body
    }, children));
});
$9719b48a661df0db$var$PanelContent.displayName = 'PanelContent';
var $9719b48a661df0db$export$2e2bcd8739ae039 = $9719b48a661df0db$var$PanelContent;

});



parcelRegister("bWa8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b0cf88b17d1d86f$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");
var $8b0cf88b17d1d86f$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $8b0cf88b17d1d86f$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $8b0cf88b17d1d86f$var$propList = "".concat($8b0cf88b17d1d86f$var$attributes, " ").concat($8b0cf88b17d1d86f$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $8b0cf88b17d1d86f$var$ariaPrefix = 'aria-';
var $8b0cf88b17d1d86f$var$dataPrefix = 'data-';
function $8b0cf88b17d1d86f$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $8b0cf88b17d1d86f$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $4f2X8.default)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === 'role' || $8b0cf88b17d1d86f$var$match(key, $8b0cf88b17d1d86f$var$ariaPrefix)) || // Data
        mergedConfig.data && $8b0cf88b17d1d86f$var$match(key, $8b0cf88b17d1d86f$var$dataPrefix) || // Attr
        mergedConfig.attr && $8b0cf88b17d1d86f$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}

});



parcelRegister("dLmcO", function(module, exports) {

$parcel$export(module.exports, "getTransitionName", () => $a050e3be4ff825e5$export$27c72201b1d09951);
$parcel$export(module.exports, "default", () => $a050e3be4ff825e5$export$2e2bcd8739ae039);
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
// ================== Collapse Motion ==================
const $a050e3be4ff825e5$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $a050e3be4ff825e5$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $a050e3be4ff825e5$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $a050e3be4ff825e5$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const $a050e3be4ff825e5$var$initCollapseMotion = (rootCls = (0, $kjlvF.defaultPrefixCls))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $a050e3be4ff825e5$var$getCollapsedHeight,
        onEnterStart: $a050e3be4ff825e5$var$getCollapsedHeight,
        onAppearActive: $a050e3be4ff825e5$var$getRealHeight,
        onEnterActive: $a050e3be4ff825e5$var$getRealHeight,
        onLeaveStart: $a050e3be4ff825e5$var$getCurrentHeight,
        onLeaveActive: $a050e3be4ff825e5$var$getCollapsedHeight,
        onAppearEnd: $a050e3be4ff825e5$var$skipOpacityTransition,
        onEnterEnd: $a050e3be4ff825e5$var$skipOpacityTransition,
        onLeaveEnd: $a050e3be4ff825e5$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $a050e3be4ff825e5$var$_SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const $a050e3be4ff825e5$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $a050e3be4ff825e5$export$2e2bcd8739ae039 = $a050e3be4ff825e5$var$initCollapseMotion;

});

parcelRegister("b3BHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0213d37e8f23286b$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $4Qpou = parcelRequire("4Qpou");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
"use client";
const $0213d37e8f23286b$var$CollapsePanel = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $aqdBs.createElement((0, $4Qpou.default).Panel, Object.assign({
        ref: ref
    }, props, {
        prefixCls: prefixCls,
        className: collapsePanelClassName
    }));
});
var $0213d37e8f23286b$export$2e2bcd8739ae039 = $0213d37e8f23286b$var$CollapsePanel;

});

parcelRegister("iCnPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8de4377b3b4fd4b$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $ZA9h0 = parcelRequire("ZA9h0");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $d8de4377b3b4fd4b$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, collapseHeaderPaddingSM: collapseHeaderPaddingSM, collapseHeaderPaddingLG: collapseHeaderPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $aWTY1.unit)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $aWTY1.unit)(collapsePanelBorderRadius)} ${(0, $aWTY1.unit)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $aWTY1.unit)(collapsePanelBorderRadius)} ${(0, $aWTY1.unit)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: Object.assign(Object.assign({
                    position: 'relative',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`
                }, (0, $5kUb2.genFocusStyle)(token)), {
                    [`> ${componentCls}-header-text`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        paddingInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $5kUb2.resetIcon)()), {
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    }),
                    // >>>>> Text
                    [`${componentCls}-header-text`]: {
                        marginInlineEnd: 'auto'
                    }
                }),
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-header-text`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-content`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-content-box`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-content > ${componentCls}-content-box`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    borderRadius: `0 0 ${(0, $aWTY1.unit)(collapsePanelBorderRadius)} ${(0, $aWTY1.unit)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Position ==========================
            [`&${componentCls}-icon-position-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            paddingInlineEnd: 0,
                            paddingInlineStart: marginSM
                        }
                    }
                }
            }
        })
    };
};
const $d8de4377b3b4fd4b$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $d8de4377b3b4fd4b$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-content > ${componentCls}-content-box`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $d8de4377b3b4fd4b$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-content`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-content-box`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $d8de4377b3b4fd4b$export$9ca1be8807fe0675 = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
var $d8de4377b3b4fd4b$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Collapse', (token)=>{
    const collapseToken = (0, $8Olk9.merge)(token, {
        collapseHeaderPaddingSM: `${(0, $aWTY1.unit)(token.paddingXS)} ${(0, $aWTY1.unit)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, $aWTY1.unit)(token.padding)} ${(0, $aWTY1.unit)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $d8de4377b3b4fd4b$export$5ca74f7be820a85(collapseToken),
        $d8de4377b3b4fd4b$var$genBorderlessStyle(collapseToken),
        $d8de4377b3b4fd4b$var$genGhostStyle(collapseToken),
        $d8de4377b3b4fd4b$var$genArrowStyle(collapseToken),
        (0, $ZA9h0.default)(collapseToken)
    ];
}, $d8de4377b3b4fd4b$export$9ca1be8807fe0675);

});
parcelRegister("ZA9h0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b91bcf8f9272960$export$2e2bcd8739ae039);
const $0b91bcf8f9272960$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $0b91bcf8f9272960$export$2e2bcd8739ae039 = $0b91bcf8f9272960$var$genCollapseMotion;

});




parcelRegister("4hrc8", function(module, exports) {

$parcel$export(module.exports, "generateColor", () => $31ddd84344deca0d$export$c844f5d21427d1ab);

var $dMbbs = parcelRequire("dMbbs");
parcelRequire("arcxy");
var $gLmye = parcelRequire("gLmye");

var $flvmh = parcelRequire("flvmh");
const $31ddd84344deca0d$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $flvmh.AggregationColor)) return color;
    return new (0, $flvmh.AggregationColor)(color);
};
const $31ddd84344deca0d$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $31ddd84344deca0d$export$3c8ae3c73ab0e52a = (color)=>$31ddd84344deca0d$export$8d6531175688484b(color.toHsb().a * 100);
const $31ddd84344deca0d$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $31ddd84344deca0d$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $31ddd84344deca0d$export$c844f5d21427d1ab(rgba);
};
const $31ddd84344deca0d$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $dMbbs.default)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $gLmye.Color)(startColor);
            const endRcColor = new (0, $gLmye.Color)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};

});




parcelRegister("l2MUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51fba9a0afaee8f$export$2e2bcd8739ae039);

var $46oWY = parcelRequire("46oWY");

var $6mI82 = parcelRequire("6mI82");

var $4wPvn = parcelRequire("4wPvn");

var $9nSnF = parcelRequire("9nSnF");
const $f51fba9a0afaee8f$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, colorPrimaryHover: colorPrimaryHover, lineWidth: lineWidth, calc: calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const selector = `${componentCls}-compact${vertical ? '-vertical' : ''}-item${componentCls}-primary:not([disabled])`;
        return {
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return Object.assign(Object.assign({}, getCompactBorderStyle()), getCompactBorderStyle(true));
};
var // ============================== Export ==============================
$f51fba9a0afaee8f$export$2e2bcd8739ae039 = (0, $4wPvn.genSubStyleComponent)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, $9nSnF.prepareToken)(token);
    return [
        // Space Compact
        (0, $46oWY.genCompactItemStyle)(buttonToken),
        (0, $6mI82.genCompactItemVerticalStyle)(buttonToken),
        $f51fba9a0afaee8f$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $9nSnF.prepareComponentToken));

});
parcelRegister("46oWY", function(module, exports) {

$parcel$export(module.exports, "genCompactItemStyle", () => $2fcb138949694568$export$b1208b23589b4b73);
// handle border collapse
function $2fcb138949694568$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $2fcb138949694568$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $2fcb138949694568$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $2fcb138949694568$var$compactItemBorder(token, compactCls, options)), $2fcb138949694568$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}

});

parcelRegister("6mI82", function(module, exports) {

$parcel$export(module.exports, "genCompactItemVerticalStyle", () => $4a27072a031f3f32$export$4dc87cb8ebf78ac6);
function $4a27072a031f3f32$var$compactItemVerticalBorder(token, parentCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 2
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function $4a27072a031f3f32$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $4a27072a031f3f32$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $4a27072a031f3f32$var$compactItemVerticalBorder(token, compactCls)), $4a27072a031f3f32$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}

});




parcelRegister("k643f", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea1782b41e21305d$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");


var $h1ynd = parcelRequire("h1ynd");

var $kGipf = parcelRequire("kGipf");

var $iV68x = parcelRequire("iV68x");

var $jURIP = parcelRequire("jURIP");

var $kjlvF = parcelRequire("kjlvF");
"use client";
var $ea1782b41e21305d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ea1782b41e21305d$var$defaultEmptyImg = /*#__PURE__*/ $aqdBs.createElement((0, $kGipf.default), null);
const $ea1782b41e21305d$var$simpleEmptyImg = /*#__PURE__*/ $aqdBs.createElement((0, $iV68x.default), null);
const $ea1782b41e21305d$var$Empty = (props)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image = $ea1782b41e21305d$var$defaultEmptyImg, description: description, children: children, imageStyle: imageStyle, style: style, classNames: emptyClassNames, styles: styles } = props, restProps = $ea1782b41e21305d$var$__rest(props, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style",
        "classNames",
        "styles"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $kjlvF.useComponentConfig)('empty');
    const prefixCls = getPrefixCls('empty', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $jURIP.default)(prefixCls);
    const [locale] = (0, $h1ynd.default)('Empty');
    const des = typeof description !== 'undefined' ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    const alt = typeof des === 'string' ? des : 'empty';
    let imageNode = null;
    if (typeof image === 'string') imageNode = /*#__PURE__*/ $aqdBs.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    var deprecatedName, newName;
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: image === $ea1782b41e21305d$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, className, rootClassName, contextClassNames.root, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.root),
        style: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.root), contextStyle), styles === null || styles === void 0 ? void 0 : styles.root), style)
    }, restProps), /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-image`, contextClassNames.image, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.image),
        style: Object.assign(Object.assign(Object.assign({}, imageStyle), contextStyles.image), styles === null || styles === void 0 ? void 0 : styles.image)
    }, imageNode), des && /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-description`, contextClassNames.description, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.description),
        style: Object.assign(Object.assign({}, contextStyles.description), styles === null || styles === void 0 ? void 0 : styles.description)
    }, des), children && /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-footer`, contextClassNames.footer, emptyClassNames === null || emptyClassNames === void 0 ? void 0 : emptyClassNames.footer),
        style: Object.assign(Object.assign({}, contextStyles.footer), styles === null || styles === void 0 ? void 0 : styles.footer)
    }, children)));
};
$ea1782b41e21305d$var$Empty.PRESENTED_IMAGE_DEFAULT = $ea1782b41e21305d$var$defaultEmptyImg;
$ea1782b41e21305d$var$Empty.PRESENTED_IMAGE_SIMPLE = $ea1782b41e21305d$var$simpleEmptyImg;
var $ea1782b41e21305d$export$2e2bcd8739ae039 = $ea1782b41e21305d$var$Empty;

});
parcelRegister("kGipf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0e601fda81c15df$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");

var $h1ynd = parcelRequire("h1ynd");

var $jygCN = parcelRequire("jygCN");
"use client";
const $f0e601fda81c15df$var$Empty = ()=>{
    const [, token] = (0, $jygCN.default)();
    const [locale] = (0, $h1ynd.default)('Empty');
    const bgColor = new (0, $bkcIW.FastColor)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $aqdBs.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $aqdBs.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $aqdBs.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $aqdBs.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $aqdBs.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $aqdBs.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $aqdBs.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $f0e601fda81c15df$export$2e2bcd8739ae039 = $f0e601fda81c15df$var$Empty;

});

parcelRegister("iV68x", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc624f8278ac89d3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");

var $jygCN = parcelRequire("jygCN");

var $h1ynd = parcelRequire("h1ynd");
"use client";
const $dc624f8278ac89d3$var$Simple = ()=>{
    const [, token] = (0, $jygCN.default)();
    const [locale] = (0, $h1ynd.default)('Empty');
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $aqdBs.useMemo)(()=>({
            borderColor: new (0, $bkcIW.FastColor)(colorFill).onBackground(colorBgContainer).toHexString(),
            shadowColor: new (0, $bkcIW.FastColor)(colorFillTertiary).onBackground(colorBgContainer).toHexString(),
            contentColor: new (0, $bkcIW.FastColor)(colorFillQuaternary).onBackground(colorBgContainer).toHexString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $aqdBs.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $aqdBs.createElement("title", null, (locale === null || locale === void 0 ? void 0 : locale.description) || 'Empty'), /*#__PURE__*/ $aqdBs.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $aqdBs.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $aqdBs.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $dc624f8278ac89d3$export$2e2bcd8739ae039 = $dc624f8278ac89d3$var$Simple;

});

parcelRegister("jURIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7fceb5a63295d9d$export$2e2bcd8739ae039);

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
// ============================== Shared ==============================
const $e7fceb5a63295d9d$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: 'center',
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: '100%'
                },
                svg: {
                    maxWidth: '100%',
                    height: '100%',
                    margin: 'auto'
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            '&-normal': {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            '&-small': {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$e7fceb5a63295d9d$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Empty', (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $8Olk9.merge)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $e7fceb5a63295d9d$var$genSharedEmptyStyle(emptyToken)
    ];
});

});


parcelRegister("kft9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebdbd32585779a25$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $1agFQ = parcelRequire("1agFQ");

var $gL7Ec = parcelRequire("gL7Ec");
var $ebdbd32585779a25$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $1agFQ.default)
    }));
};
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ var $ebdbd32585779a25$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($ebdbd32585779a25$var$LeftOutlined);
var $ebdbd32585779a25$export$2e2bcd8739ae039 = $ebdbd32585779a25$var$RefIcon;

});
parcelRegister("1agFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d93a8b98f62c9b7$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $0d93a8b98f62c9b7$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $0d93a8b98f62c9b7$export$2e2bcd8739ae039 = $0d93a8b98f62c9b7$var$LeftOutlined;

});


parcelRegister("1FrlO", function(module, exports) {

$parcel$export(module.exports, "default", () => $136ed61734bfb4ba$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SubMenu", () => (parcelRequire("aXEQC")).default);
$parcel$export(module.exports, "Item", () => (parcelRequire("8azox")).default);
$parcel$export(module.exports, "MenuItem", () => (parcelRequire("8azox")).default);
$parcel$export(module.exports, "ItemGroup", () => (parcelRequire("7YcE0")).default);
$parcel$export(module.exports, "Divider", () => (parcelRequire("aqdcb")).default);
$parcel$export(module.exports, "useFullPath", () => (parcelRequire("irLxp")).useFullPath);

var $iVxjX = parcelRequire("iVxjX");

var $8azox = parcelRequire("8azox");

var $aXEQC = parcelRequire("aXEQC");

var $7YcE0 = parcelRequire("7YcE0");

var $irLxp = parcelRequire("irLxp");

var $aqdcb = parcelRequire("aqdcb");
var $136ed61734bfb4ba$var$ExportMenu = (0, $iVxjX.default);
$136ed61734bfb4ba$var$ExportMenu.Item = (0, $8azox.default);
$136ed61734bfb4ba$var$ExportMenu.SubMenu = (0, $aXEQC.default);
$136ed61734bfb4ba$var$ExportMenu.ItemGroup = (0, $7YcE0.default);
$136ed61734bfb4ba$var$ExportMenu.Divider = (0, $aqdcb.default);
var $136ed61734bfb4ba$export$2e2bcd8739ae039 = $136ed61734bfb4ba$var$ExportMenu;

});
parcelRegister("iVxjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc7765b3d32a3fc7$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");

var $46nrX = parcelRequire("46nrX");

var $eAKDF = parcelRequire("eAKDF");

var $aTirs = parcelRequire("aTirs");
parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $5O0NX = parcelRequire("5O0NX");

var $eQzmH = parcelRequire("eQzmH");

var $irLxp = parcelRequire("irLxp");

var $xemlq = parcelRequire("xemlq");

var $Wow47 = parcelRequire("Wow47");

var $aTGbS = parcelRequire("aTGbS");

var $8UKDd = parcelRequire("8UKDd");

var $65gUz = parcelRequire("65gUz");

var $8azox = parcelRequire("8azox");

var $aXEQC = parcelRequire("aXEQC");

var $d6bJY = parcelRequire("d6bJY");

var $39XhA = parcelRequire("39XhA");
var $dc7765b3d32a3fc7$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem",
    "_internalComponents"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $dc7765b3d32a3fc7$var$EMPTY_LIST = [];
var $dc7765b3d32a3fc7$var$Menu = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var _childList$;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-menu' : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'vertical' : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? 'hover' : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? '...' : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, _internalComponents = _ref._internalComponents, restProps = (0, $aX4Fp.default)(_ref, $dc7765b3d32a3fc7$var$_excluded);
    var _React$useMemo = $aqdBs.useMemo(function() {
        return [
            (0, $d6bJY.parseItems)(children, items, $dc7765b3d32a3fc7$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $d6bJY.parseItems)(children, items, $dc7765b3d32a3fc7$var$EMPTY_LIST, {}, prefixCls)
        ];
    }, [
        children,
        items,
        _internalComponents
    ]), _React$useMemo2 = (0, $kelIR.default)(_React$useMemo, 2), childList = _React$useMemo2[0], measureChildList = _React$useMemo2[1];
    var _React$useState = $aqdBs.useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $aqdBs.useRef();
    var uuid = (0, $65gUz.default)(id);
    var isRtl = direction === 'rtl';
    // ========================= Open =========================
    var _useMergedState = (0, $eAKDF.default)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $dc7765b3d32a3fc7$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $jVlfX.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $aqdBs.useState(mergedOpenKeys), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $aqdBs.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo3 = $aqdBs.useMemo(function() {
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo4 = (0, $kelIR.default)(_React$useMemo3, 2), mergedMode = _React$useMemo4[0], mergedInlineCollapsed = _React$useMemo4[1];
    var isInlineMode = mergedMode === 'inline';
    var _React$useState5 = $aqdBs.useState(mergedMode), _React$useState6 = (0, $kelIR.default)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $aqdBs.useState(mergedInlineCollapsed), _React$useState8 = (0, $kelIR.default)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $aqdBs.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($dc7765b3d32a3fc7$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $aqdBs.useState(0), _React$useState10 = (0, $kelIR.default)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    $aqdBs.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $aqdBs.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $aTGbS.default)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $aqdBs.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $aqdBs.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $aqdBs.useEffect(function() {
        refreshOverflowKeys(allVisible ? $dc7765b3d32a3fc7$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $eAKDF.default)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $kelIR.default)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $8UKDd.default)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $8UKDd.default)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $aqdBs.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var keys = getKeys();
                var _refreshElements = (0, $Wow47.refreshElements)(keys, uuid), elements = _refreshElements.elements, key2element = _refreshElements.key2element, element2key = _refreshElements.element2key;
                var focusableElements = (0, $Wow47.getFocusableElements)(containerRef.current, elements);
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                var elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) {
                    var _elementToFocus$focus;
                    elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $eAKDF.default)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $dc7765b3d32a3fc7$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $kelIR.default)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $dMbbs.default)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $4f2X8.default)((0, $4f2X8.default)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys($dc7765b3d32a3fc7$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $8UKDd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $39XhA.warnItemProp)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $8UKDd.default)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $aTirs.default)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $Wow47.useAccessibility)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $aqdBs.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $aqdBs.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $aqdBs.createElement((0, $eQzmH.default), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $aqdBs.createElement((0, $46nrX.default), (0, $13KW1.default)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $8azox.default),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), "".concat(prefixCls, "-rtl"), isRtl), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $aqdBs.createElement((0, $aXEQC.default), {
                eventKey: (0, $aTGbS.OVERFLOW_KEY),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, $46nrX.default).INVALIDATE : (0, $46nrX.default).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $aqdBs.createElement((0, $xemlq.default).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $5O0NX.IdContext).Provider, {
        value: uuid
    }, /*#__PURE__*/ $aqdBs.createElement((0, $eQzmH.default), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $aqdBs.createElement((0, $irLxp.PathUserContext).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $aqdBs.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $aqdBs.createElement((0, $irLxp.PathRegisterContext).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $dc7765b3d32a3fc7$export$2e2bcd8739ae039 = $dc7765b3d32a3fc7$var$Menu;

});
parcelRegister("46nrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc9e9a2df9c62d2$export$2e2bcd8739ae039);

var $8QchD = parcelRequire("8QchD");
var $2fc9e9a2df9c62d2$export$2e2bcd8739ae039 = (0, $8QchD.default);

});
parcelRegister("8QchD", function(module, exports) {

$parcel$export(module.exports, "default", () => $66fcb5448691caa6$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $jeSJT = parcelRequire("jeSJT");

var $iEJaB = parcelRequire("iEJaB");

var $8dK06 = parcelRequire("8dK06");

var $3oPnI = parcelRequire("3oPnI");

var $6Lu7c = parcelRequire("6Lu7c");

var $9sraC = parcelRequire("9sraC");
var $66fcb5448691caa6$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $66fcb5448691caa6$var$RESPONSIVE = 'responsive';
var $66fcb5448691caa6$var$INVALIDATE = 'invalidate';
function $66fcb5448691caa6$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $66fcb5448691caa6$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-overflow' : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $aX4Fp.default)(props, $66fcb5448691caa6$var$_excluded);
    var fullySSR = ssr === 'full';
    var notifyEffectUpdate = (0, $3oPnI.useBatcher)();
    var _useEffectState = (0, $3oPnI.default)(notifyEffectUpdate, null), _useEffectState2 = (0, $kelIR.default)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $3oPnI.default)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $kelIR.default)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $3oPnI.default)(notifyEffectUpdate, 0), _useEffectState6 = (0, $kelIR.default)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $3oPnI.default)(notifyEffectUpdate, 0), _useEffectState8 = (0, $kelIR.default)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $3oPnI.default)(notifyEffectUpdate, 0), _useEffectState10 = (0, $kelIR.default)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $aqdBs.useState)(null), _useState2 = (0, $kelIR.default)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $aqdBs.useState)(null), _useState4 = (0, $kelIR.default)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $aqdBs.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $aqdBs.useState)(false), _useState6 = (0, $kelIR.default)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $66fcb5448691caa6$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $66fcb5448691caa6$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    var mergedData = (0, $aqdBs.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $aqdBs.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $aqdBs.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === 'function') return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $aqdBs.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $iEJaB.default)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $aqdBs.createElement((0, $9sraC.OverflowContext).Provider, {
            key: key,
            value: (0, $4f2X8.default)((0, $4f2X8.default)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $aqdBs.createElement((0, $8dK06.default), (0, $13KW1.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    var mergedRenderRest = renderRest || $66fcb5448691caa6$var$defaultRenderRest;
    var restNode = renderRawRest ? /*#__PURE__*/ $aqdBs.createElement((0, $9sraC.OverflowContext).Provider, {
        value: (0, $4f2X8.default)((0, $4f2X8.default)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $aqdBs.createElement((0, $8dK06.default), (0, $13KW1.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    var overflowNode = /*#__PURE__*/ $aqdBs.createElement(Component, (0, $13KW1.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $aqdBs.createElement((0, $8dK06.default), (0, $13KW1.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $aqdBs.createElement((0, $jeSJT.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
var $66fcb5448691caa6$var$ForwardOverflow = /*#__PURE__*/ $aqdBs.forwardRef($66fcb5448691caa6$var$Overflow);
$66fcb5448691caa6$var$ForwardOverflow.displayName = 'Overflow';
$66fcb5448691caa6$var$ForwardOverflow.Item = (0, $6Lu7c.default);
$66fcb5448691caa6$var$ForwardOverflow.RESPONSIVE = $66fcb5448691caa6$var$RESPONSIVE;
$66fcb5448691caa6$var$ForwardOverflow.INVALIDATE = $66fcb5448691caa6$var$INVALIDATE;
var // Convert to generic type
$66fcb5448691caa6$export$2e2bcd8739ae039 = $66fcb5448691caa6$var$ForwardOverflow;

});
parcelRegister("jeSJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e019c936567afc75$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $bZ6Ai = parcelRequire("bZ6Ai");
parcelRequire("i7X5i");

var $9Dt2Y = parcelRequire("9Dt2Y");

var $lrPcE = parcelRequire("lrPcE");

var $jEqjk = parcelRequire("jEqjk");
var $e019c936567afc75$var$INTERNAL_PREFIX_KEY = 'rc-observer-key';
function $e019c936567afc75$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === 'function' ? [
        children
    ] : (0, $bZ6Ai.default)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($e019c936567afc75$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $aqdBs.createElement((0, $9Dt2Y.default), (0, $13KW1.default)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $e019c936567afc75$var$RefResizeObserver = /*#__PURE__*/ $aqdBs.forwardRef($e019c936567afc75$var$ResizeObserver);
$e019c936567afc75$var$RefResizeObserver.Collection = (0, $lrPcE.Collection);
var $e019c936567afc75$export$2e2bcd8739ae039 = $e019c936567afc75$var$RefResizeObserver;

});
parcelRegister("9Dt2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $703e49ac61991172$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");

var $bTIJW = parcelRequire("bTIJW");

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");

var $lrPcE = parcelRequire("lrPcE");

var $jEqjk = parcelRequire("jEqjk");

var $2yZlt = parcelRequire("2yZlt");
function $703e49ac61991172$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $aqdBs.useRef(null);
    var wrapperRef = $aqdBs.useRef(null);
    var onCollectionResize = $aqdBs.useContext((0, $lrPcE.CollectionContext));
    // =========================== Children ===========================
    var isRenderProps = typeof children === 'function';
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $aqdBs.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $aqdBs.isValidElement(mergedChildren) && (0, $kBwE8.supportRef)(mergedChildren);
    var originRef = canRef ? (0, $kBwE8.getNodeRef)(mergedChildren) : null;
    var mergedRef = (0, $kBwE8.useComposeRef)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $bTIJW.default)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $7IgoF.default)(elementRef.current) === 'object' ? (0, $bTIJW.default)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $bTIJW.default)(wrapperRef.current);
    };
    $aqdBs.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $aqdBs.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $aqdBs.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $4f2X8.default)((0, $4f2X8.default)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $aqdBs.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $jEqjk.observe)(currentElement, onInternalResize);
        return function() {
            return (0, $jEqjk.unobserve)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $aqdBs.createElement((0, $2yZlt.default), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $aqdBs.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $703e49ac61991172$var$RefSingleObserver = /*#__PURE__*/ $aqdBs.forwardRef($703e49ac61991172$var$SingleObserver);
var $703e49ac61991172$export$2e2bcd8739ae039 = $703e49ac61991172$var$RefSingleObserver;

});
parcelRegister("lrPcE", function(module, exports) {

$parcel$export(module.exports, "CollectionContext", () => $f9d3d674e86ddd24$export$db36075d98ba73d3);
$parcel$export(module.exports, "Collection", () => $f9d3d674e86ddd24$export$fb8073518f34e6ec);

var $aqdBs = parcelRequire("aqdBs");
var $f9d3d674e86ddd24$export$db36075d98ba73d3 = /*#__PURE__*/ $aqdBs.createContext(null);
function $f9d3d674e86ddd24$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $aqdBs.useRef(0);
    var resizeInfosRef = $aqdBs.useRef([]);
    var onCollectionResize = $aqdBs.useContext($f9d3d674e86ddd24$export$db36075d98ba73d3);
    var onResize = $aqdBs.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($f9d3d674e86ddd24$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}

});

parcelRegister("jEqjk", function(module, exports) {

$parcel$export(module.exports, "observe", () => $e4e6297e9a7e3c6a$export$d1203567a167490e);
$parcel$export(module.exports, "unobserve", () => $e4e6297e9a7e3c6a$export$23a2283368c55ea2);

var $hsUmT = parcelRequire("hsUmT");
// =============================== Const ===============================
var $e4e6297e9a7e3c6a$var$elementListeners = new Map();
function $e4e6297e9a7e3c6a$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $e4e6297e9a7e3c6a$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $e4e6297e9a7e3c6a$var$resizeObserver = new (0, $hsUmT.default)($e4e6297e9a7e3c6a$var$onResize);
var $e4e6297e9a7e3c6a$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $e4e6297e9a7e3c6a$export$524f0fd3b47831a = null; // eslint-disable-line
function $e4e6297e9a7e3c6a$export$d1203567a167490e(element, callback) {
    if (!$e4e6297e9a7e3c6a$var$elementListeners.has(element)) {
        $e4e6297e9a7e3c6a$var$elementListeners.set(element, new Set());
        $e4e6297e9a7e3c6a$var$resizeObserver.observe(element);
    }
    $e4e6297e9a7e3c6a$var$elementListeners.get(element).add(callback);
}
function $e4e6297e9a7e3c6a$export$23a2283368c55ea2(element, callback) {
    if ($e4e6297e9a7e3c6a$var$elementListeners.has(element)) {
        $e4e6297e9a7e3c6a$var$elementListeners.get(element).delete(callback);
        if (!$e4e6297e9a7e3c6a$var$elementListeners.get(element).size) {
            $e4e6297e9a7e3c6a$var$resizeObserver.unobserve(element);
            $e4e6297e9a7e3c6a$var$elementListeners.delete(element);
        }
    }
}

});
parcelRegister("hsUmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb70c6bc39638066$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $cb70c6bc39638066$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $cb70c6bc39638066$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $cb70c6bc39638066$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $cb70c6bc39638066$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($cb70c6bc39638066$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $cb70c6bc39638066$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $cb70c6bc39638066$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $cb70c6bc39638066$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $cb70c6bc39638066$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $cb70c6bc39638066$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $cb70c6bc39638066$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $cb70c6bc39638066$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $cb70c6bc39638066$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $cb70c6bc39638066$var$throttle(this.refresh.bind(this), $cb70c6bc39638066$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$cb70c6bc39638066$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($cb70c6bc39638066$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$cb70c6bc39638066$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $cb70c6bc39638066$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $cb70c6bc39638066$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $cb70c6bc39638066$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $cb70c6bc39638066$var$global$1;
};
// Placeholder of an empty content rectangle.
var $cb70c6bc39638066$var$emptyRect = $cb70c6bc39638066$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $cb70c6bc39638066$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $cb70c6bc39638066$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $cb70c6bc39638066$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $cb70c6bc39638066$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $cb70c6bc39638066$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $cb70c6bc39638066$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $cb70c6bc39638066$var$emptyRect;
    var styles = $cb70c6bc39638066$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $cb70c6bc39638066$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $cb70c6bc39638066$var$toFloat(styles.width), height = $cb70c6bc39638066$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $cb70c6bc39638066$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $cb70c6bc39638066$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$cb70c6bc39638066$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $cb70c6bc39638066$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $cb70c6bc39638066$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $cb70c6bc39638066$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $cb70c6bc39638066$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $cb70c6bc39638066$var$isDocumentElement(target) {
    return target === $cb70c6bc39638066$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$getContentRect(target) {
    if (!$cb70c6bc39638066$var$isBrowser) return $cb70c6bc39638066$var$emptyRect;
    if ($cb70c6bc39638066$var$isSVGGraphicsElement(target)) return $cb70c6bc39638066$var$getSVGContentRect(target);
    return $cb70c6bc39638066$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $cb70c6bc39638066$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $cb70c6bc39638066$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $cb70c6bc39638066$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $cb70c6bc39638066$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $cb70c6bc39638066$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $cb70c6bc39638066$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $cb70c6bc39638066$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $cb70c6bc39638066$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $cb70c6bc39638066$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $cb70c6bc39638066$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $cb70c6bc39638066$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $cb70c6bc39638066$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $cb70c6bc39638066$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $cb70c6bc39638066$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $cb70c6bc39638066$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $cb70c6bc39638066$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $cb70c6bc39638066$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $cb70c6bc39638066$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $cb70c6bc39638066$var$ResizeObserverController.getInstance();
        var observer = new $cb70c6bc39638066$var$ResizeObserverSPI(callback, controller, this);
        $cb70c6bc39638066$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $cb70c6bc39638066$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $cb70c6bc39638066$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $cb70c6bc39638066$var$index = function() {
    // Export existing implementation if available.
    if (typeof $cb70c6bc39638066$var$global$1.ResizeObserver !== 'undefined') return $cb70c6bc39638066$var$global$1.ResizeObserver;
    return $cb70c6bc39638066$var$ResizeObserver;
}();
var $cb70c6bc39638066$export$2e2bcd8739ae039 = $cb70c6bc39638066$var$index;

});


parcelRegister("2yZlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dde57acd0017762$export$2e2bcd8739ae039);

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $aqdBs = parcelRequire("aqdBs");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1dde57acd0017762$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $9nc35.default)(DomWrapper, _React$Component);
    var _super = (0, $lriWM.default)(DomWrapper);
    function DomWrapper() {
        (0, $dYVVZ.default)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $hevvH.default)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($aqdBs.Component);

});



parcelRegister("8dK06", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc33860c1445b55$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $jeSJT = parcelRequire("jeSJT");
var $5fc33860c1445b55$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $5fc33860c1445b55$var$UNDEFINED = undefined;
function $5fc33860c1445b55$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, restProps = (0, $aX4Fp.default)(props, $5fc33860c1445b55$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $aqdBs.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $5fc33860c1445b55$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $5fc33860c1445b55$var$UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : $5fc33860c1445b55$var$UNDEFINED,
        order: responsive ? order : $5fc33860c1445b55$var$UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : $5fc33860c1445b55$var$UNDEFINED,
        position: mergedHidden ? 'absolute' : $5fc33860c1445b55$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    var itemNode = /*#__PURE__*/ $aqdBs.createElement(Component, (0, $13KW1.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(!invalidate && prefixCls, className),
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $aqdBs.createElement((0, $jeSJT.default), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $5fc33860c1445b55$var$Item = /*#__PURE__*/ $aqdBs.forwardRef($5fc33860c1445b55$var$InternalItem);
$5fc33860c1445b55$var$Item.displayName = 'Item';
var $5fc33860c1445b55$export$2e2bcd8739ae039 = $5fc33860c1445b55$var$Item;

});

parcelRegister("3oPnI", function(module, exports) {

$parcel$export(module.exports, "useBatcher", () => $279b7842dde5d77d$export$eedf51fe9d751c7a);
$parcel$export(module.exports, "default", () => $279b7842dde5d77d$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $k91S5 = parcelRequire("k91S5");

var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $b8rIh = parcelRequire("b8rIh");
function $279b7842dde5d77d$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $aqdBs.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $b8rIh.default)(function() {
                (0, $jVlfX.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $279b7842dde5d77d$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $aqdBs.useState(defaultValue), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $k91S5.default)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}

});
parcelRegister("b8rIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $81b5f051a28ebdd5$export$2e2bcd8739ae039);

var $ebavw = parcelRequire("ebavw");
function $81b5f051a28ebdd5$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === 'undefined') (0, $ebavw.default)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}

});


parcelRegister("6Lu7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ece7e15053b73ec$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $8dK06 = parcelRequire("8dK06");

var $9sraC = parcelRequire("9sraC");
var $4ece7e15053b73ec$var$_excluded = [
    "component"
], $4ece7e15053b73ec$var$_excluded2 = [
    "className"
], $4ece7e15053b73ec$var$_excluded3 = [
    "className"
];
var $4ece7e15053b73ec$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $aqdBs.useContext((0, $9sraC.OverflowContext));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _restProps = (0, $aX4Fp.default)(props, $4ece7e15053b73ec$var$_excluded);
        return /*#__PURE__*/ $aqdBs.createElement(Component, (0, $13KW1.default)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $aX4Fp.default)(context, $4ece7e15053b73ec$var$_excluded2);
    var className = props.className, restProps = (0, $aX4Fp.default)(props, $4ece7e15053b73ec$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $aqdBs.createElement((0, $9sraC.OverflowContext).Provider, {
        value: null
    }, /*#__PURE__*/ $aqdBs.createElement((0, $8dK06.default), (0, $13KW1.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(contextClassName, className)
    }, restContext, restProps)));
};
var $4ece7e15053b73ec$var$RawItem = /*#__PURE__*/ $aqdBs.forwardRef($4ece7e15053b73ec$var$InternalRawItem);
$4ece7e15053b73ec$var$RawItem.displayName = 'RawItem';
var $4ece7e15053b73ec$export$2e2bcd8739ae039 = $4ece7e15053b73ec$var$RawItem;

});
parcelRegister("9sraC", function(module, exports) {

$parcel$export(module.exports, "OverflowContext", () => $6e2bce0367a3b4e6$export$79f16dd643143c25);

var $aqdBs = parcelRequire("aqdBs");
var $6e2bce0367a3b4e6$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(null);

});




parcelRegister("5O0NX", function(module, exports) {

$parcel$export(module.exports, "IdContext", () => $43a23f0d17e71ef5$export$26537912ea160acd);
$parcel$export(module.exports, "getMenuId", () => $43a23f0d17e71ef5$export$80c871fe8d6b896);
$parcel$export(module.exports, "useMenuId", () => $43a23f0d17e71ef5$export$a276eb4e9be640f8);

var $aqdBs = parcelRequire("aqdBs");
var $43a23f0d17e71ef5$export$26537912ea160acd = /*#__PURE__*/ $aqdBs.createContext(null);
function $43a23f0d17e71ef5$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $43a23f0d17e71ef5$export$a276eb4e9be640f8(eventKey) {
    var id = $aqdBs.useContext($43a23f0d17e71ef5$export$26537912ea160acd);
    return $43a23f0d17e71ef5$export$80c871fe8d6b896(id, eventKey);
}

});

parcelRegister("eQzmH", function(module, exports) {

$parcel$export(module.exports, "MenuContext", () => $acf15ac6e5195ced$export$c7e742effb1c51e2);
$parcel$export(module.exports, "default", () => $acf15ac6e5195ced$export$2e2bcd8739ae039);

var $aX4Fp = parcelRequire("aX4Fp");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");

var $9nP3o = parcelRequire("9nP3o");

var $aTirs = parcelRequire("aTirs");
var $acf15ac6e5195ced$var$_excluded = [
    "children",
    "locked"
];
var $acf15ac6e5195ced$export$c7e742effb1c51e2 = /*#__PURE__*/ $aqdBs.createContext(null);
function $acf15ac6e5195ced$var$mergeProps(origin, target) {
    var clone = (0, $4f2X8.default)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $acf15ac6e5195ced$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $aX4Fp.default)(_ref, $acf15ac6e5195ced$var$_excluded);
    var context = $aqdBs.useContext($acf15ac6e5195ced$export$c7e742effb1c51e2);
    var inheritableContext = (0, $9nP3o.default)(function() {
        return $acf15ac6e5195ced$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $aTirs.default)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $aqdBs.createElement($acf15ac6e5195ced$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}

});

parcelRegister("irLxp", function(module, exports) {

$parcel$export(module.exports, "PathRegisterContext", () => $d6df9fa248057514$export$d9ffb5bfd108b003);
$parcel$export(module.exports, "useMeasure", () => $d6df9fa248057514$export$e295b0c537d32d7d);
$parcel$export(module.exports, "PathTrackerContext", () => $d6df9fa248057514$export$54d9e16aa4c8a7fa);
$parcel$export(module.exports, "useFullPath", () => $d6df9fa248057514$export$d3d2d0a05677870a);
$parcel$export(module.exports, "PathUserContext", () => $d6df9fa248057514$export$f0b9e0db98edfa53);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");
var $d6df9fa248057514$var$EmptyList = [];
var $d6df9fa248057514$export$d9ffb5bfd108b003 = /*#__PURE__*/ $aqdBs.createContext(null);
function $d6df9fa248057514$export$e295b0c537d32d7d() {
    return $aqdBs.useContext($d6df9fa248057514$export$d9ffb5bfd108b003);
}
var $d6df9fa248057514$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $aqdBs.createContext($d6df9fa248057514$var$EmptyList);
function $d6df9fa248057514$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $aqdBs.useContext($d6df9fa248057514$export$54d9e16aa4c8a7fa);
    return $aqdBs.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $dMbbs.default)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $d6df9fa248057514$export$f0b9e0db98edfa53 = /*#__PURE__*/ $aqdBs.createContext(null);

});

parcelRegister("xemlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $063e38a8b6914656$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $063e38a8b6914656$var$PrivateContext = /*#__PURE__*/ $aqdBs.createContext({});
var $063e38a8b6914656$export$2e2bcd8739ae039 = $063e38a8b6914656$var$PrivateContext;

});

parcelRegister("Wow47", function(module, exports) {

$parcel$export(module.exports, "getFocusableElements", () => $0af86f4c3b5dbc2d$export$433aaa1f216cf32d);
$parcel$export(module.exports, "refreshElements", () => $0af86f4c3b5dbc2d$export$20827b68c762d23);
$parcel$export(module.exports, "useAccessibility", () => $0af86f4c3b5dbc2d$export$aa6de64279d64603);

var $br1G4 = parcelRequire("br1G4");

var $m5dg0 = parcelRequire("m5dg0");

var $dHI2t = parcelRequire("dHI2t");

var $ebavw = parcelRequire("ebavw");

var $aqdBs = parcelRequire("aqdBs");

var $5O0NX = parcelRequire("5O0NX");
// destruct to reduce minify size
var $0af86f4c3b5dbc2d$var$LEFT = (0, $dHI2t.default).LEFT, $0af86f4c3b5dbc2d$var$RIGHT = (0, $dHI2t.default).RIGHT, $0af86f4c3b5dbc2d$var$UP = (0, $dHI2t.default).UP, $0af86f4c3b5dbc2d$var$DOWN = (0, $dHI2t.default).DOWN, $0af86f4c3b5dbc2d$var$ENTER = (0, $dHI2t.default).ENTER, $0af86f4c3b5dbc2d$var$ESC = (0, $dHI2t.default).ESC, $0af86f4c3b5dbc2d$var$HOME = (0, $dHI2t.default).HOME, $0af86f4c3b5dbc2d$var$END = (0, $dHI2t.default).END;
var $0af86f4c3b5dbc2d$var$ArrowKeys = [
    $0af86f4c3b5dbc2d$var$UP,
    $0af86f4c3b5dbc2d$var$DOWN,
    $0af86f4c3b5dbc2d$var$LEFT,
    $0af86f4c3b5dbc2d$var$RIGHT
];
function $0af86f4c3b5dbc2d$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _offsets;
    var prev = 'prev';
    var next = 'next';
    var children = 'children';
    var parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === $0af86f4c3b5dbc2d$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (0, $br1G4.default)((0, $br1G4.default)({}, $0af86f4c3b5dbc2d$var$UP, prev), $0af86f4c3b5dbc2d$var$DOWN, next);
    var horizontal = (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, $0af86f4c3b5dbc2d$var$LEFT, isRtl ? next : prev), $0af86f4c3b5dbc2d$var$RIGHT, isRtl ? prev : next), $0af86f4c3b5dbc2d$var$DOWN, children), $0af86f4c3b5dbc2d$var$ENTER, children);
    var vertical = (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, $0af86f4c3b5dbc2d$var$UP, prev), $0af86f4c3b5dbc2d$var$DOWN, next), $0af86f4c3b5dbc2d$var$ENTER, children), $0af86f4c3b5dbc2d$var$ESC, parent), $0af86f4c3b5dbc2d$var$LEFT, isRtl ? children : parent), $0af86f4c3b5dbc2d$var$RIGHT, isRtl ? parent : children);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? '' : 'Sub')]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $0af86f4c3b5dbc2d$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $0af86f4c3b5dbc2d$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $0af86f4c3b5dbc2d$export$433aaa1f216cf32d(container, elements) {
    var list = (0, $m5dg0.getFocusNodeList)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $0af86f4c3b5dbc2d$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $0af86f4c3b5dbc2d$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
var $0af86f4c3b5dbc2d$export$20827b68c762d23 = function refreshElements(keys, id) {
    var elements = new Set();
    var key2element = new Map();
    var element2key = new Map();
    keys.forEach(function(key) {
        var element = document.querySelector("[data-menu-id='".concat((0, $5O0NX.getMenuId)(id, key), "']"));
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $0af86f4c3b5dbc2d$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $aqdBs.useRef();
    var activeRef = $aqdBs.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $ebavw.default).cancel(rafRef.current);
    };
    $aqdBs.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($0af86f4c3b5dbc2d$var$ArrowKeys, [
            $0af86f4c3b5dbc2d$var$ENTER,
            $0af86f4c3b5dbc2d$var$ESC,
            $0af86f4c3b5dbc2d$var$HOME,
            $0af86f4c3b5dbc2d$var$END
        ]).includes(which)) {
            var keys = getKeys();
            var refreshedElements = $0af86f4c3b5dbc2d$export$20827b68c762d23(keys, id);
            var _refreshedElements = refreshedElements, elements = _refreshedElements.elements, key2element = _refreshedElements.key2element, element2key = _refreshedElements.element2key;
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $0af86f4c3b5dbc2d$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $0af86f4c3b5dbc2d$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $0af86f4c3b5dbc2d$var$HOME && which !== $0af86f4c3b5dbc2d$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($0af86f4c3b5dbc2d$var$ArrowKeys.includes(which) || [
                $0af86f4c3b5dbc2d$var$HOME,
                $0af86f4c3b5dbc2d$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector('a');
                    if (link !== null && link !== void 0 && link.getAttribute('href')) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $ebavw.default)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $0af86f4c3b5dbc2d$var$HOME,
                $0af86f4c3b5dbc2d$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = $0af86f4c3b5dbc2d$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $0af86f4c3b5dbc2d$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $0af86f4c3b5dbc2d$var$HOME) targetElement = focusableElements[0];
                else if (which === $0af86f4c3b5dbc2d$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $0af86f4c3b5dbc2d$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $ebavw.default)(function() {
                    // Async should resync elements
                    refreshedElements = $0af86f4c3b5dbc2d$export$20827b68c762d23(keys, id);
                    var controlId = focusMenuElement.getAttribute('aria-controls');
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $0af86f4c3b5dbc2d$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}

});
parcelRegister("m5dg0", function(module, exports) {

$parcel$export(module.exports, "getFocusNodeList", () => $04261958dbbcbc69$export$bbc7b5f11aba534b);

var $dMbbs = parcelRequire("dMbbs");

var $djRIe = parcelRequire("djRIe");
function $04261958dbbcbc69$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $djRIe.default)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        var tabIndexAttr = node.getAttribute('tabindex');
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $04261958dbbcbc69$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $dMbbs.default)(node.querySelectorAll('*')).filter(function(child) {
        return $04261958dbbcbc69$var$focusable(child, includePositive);
    });
    if ($04261958dbbcbc69$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $04261958dbbcbc69$var$lastFocusElement = null;
function $04261958dbbcbc69$export$79fea02f7a83293d() {
    $04261958dbbcbc69$var$lastFocusElement = document.activeElement;
}
function $04261958dbbcbc69$export$8785654047fe7352() {
    $04261958dbbcbc69$var$lastFocusElement = null;
}
function $04261958dbbcbc69$export$fac0a9974415d98f() {
    if ($04261958dbbcbc69$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $04261958dbbcbc69$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $04261958dbbcbc69$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $04261958dbbcbc69$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}

});


parcelRegister("aTGbS", function(module, exports) {

$parcel$export(module.exports, "OVERFLOW_KEY", () => $7eefc4964f725125$export$20a0132c46ce5b04);
$parcel$export(module.exports, "default", () => $7eefc4964f725125$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("i7X5i");

var $kqw0d = parcelRequire("kqw0d");
var $7eefc4964f725125$var$PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
var $7eefc4964f725125$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($7eefc4964f725125$var$PATH_SPLIT);
};
var $7eefc4964f725125$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($7eefc4964f725125$var$PATH_SPLIT);
};
var $7eefc4964f725125$export$20a0132c46ce5b04 = 'rc-menu-more';
function $7eefc4964f725125$export$2e2bcd8739ae039() {
    var _React$useState = $aqdBs.useState({}), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $aqdBs.useRef)(new Map());
    var path2keyRef = (0, $aqdBs.useRef)(new Map());
    var _React$useState3 = $aqdBs.useState([]), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $aqdBs.useRef)(0);
    var destroyRef = (0, $aqdBs.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $aqdBs.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $7eefc4964f725125$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $kqw0d.nextSlice)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $aqdBs.useCallback)(function(key, keyPath) {
        var connectedPath = $7eefc4964f725125$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $aqdBs.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $aqdBs.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || '';
        var keys = $7eefc4964f725125$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($7eefc4964f725125$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $aqdBs.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.filter(function(item) {
            return item !== undefined;
        }).some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $dMbbs.default)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($7eefc4964f725125$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $aqdBs.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($7eefc4964f725125$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $dMbbs.default)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $aqdBs.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}

});
parcelRegister("kqw0d", function(module, exports) {

$parcel$export(module.exports, "nextSlice", () => $edef0f6594c611c1$export$7693db51ef834b40);
function $edef0f6594c611c1$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}

});


parcelRegister("8UKDd", function(module, exports) {

$parcel$export(module.exports, "default", () => $67d7b9baaba92ae3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $67d7b9baaba92ae3$export$2e2bcd8739ae039(func) {
    var funRef = $aqdBs.useRef(func);
    funRef.current = func;
    var callback = $aqdBs.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}

});

parcelRegister("65gUz", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e053f204564bae$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $eAKDF = parcelRequire("eAKDF");
var $46e053f204564bae$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $46e053f204564bae$var$internalId = 0;
function $46e053f204564bae$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $eAKDF.default)(id, {
        value: id
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $aqdBs.useEffect(function() {
        $46e053f204564bae$var$internalId += 1;
        var newId = "".concat($46e053f204564bae$var$uniquePrefix, "-").concat($46e053f204564bae$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}

});

parcelRegister("8azox", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2ab68ee70d176d$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $bqPQ9 = parcelRequire("bqPQ9");

var $46nrX = parcelRequire("46nrX");

var $dHI2t = parcelRequire("dHI2t");

var $1iwLi = parcelRequire("1iwLi");

var $kBwE8 = parcelRequire("kBwE8");

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $5O0NX = parcelRequire("5O0NX");

var $eQzmH = parcelRequire("eQzmH");

var $irLxp = parcelRequire("irLxp");

var $xemlq = parcelRequire("xemlq");

var $g52tp = parcelRequire("g52tp");

var $bmCoL = parcelRequire("bmCoL");

var $levfA = parcelRequire("levfA");

var $39XhA = parcelRequire("39XhA");
var $5f2ab68ee70d176d$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $5f2ab68ee70d176d$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $5f2ab68ee70d176d$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $5f2ab68ee70d176d$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $9nc35.default)(LegacyMenuItem, _React$Component);
    var _super = (0, $lriWM.default)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $dYVVZ.default)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $hevvH.default)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $aX4Fp.default)(_this$props, $5f2ab68ee70d176d$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $1iwLi.default)(restProps, [
                    'eventKey',
                    'popupClassName',
                    'popupOffset',
                    'onTitleClick'
                ]);
                (0, $i7X5i.default)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
                return /*#__PURE__*/ $aqdBs.createElement((0, $46nrX.default).Item, (0, $13KW1.default)({}, attribute, {
                    title: typeof title === 'string' ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($aqdBs.Component);
/**
 * Real Menu Item component
 */ var $5f2ab68ee70d176d$var$InternalMenuItem = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $aX4Fp.default)(props, $5f2ab68ee70d176d$var$_excluded2);
    var domDataId = (0, $5O0NX.useMenuId)(eventKey);
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $aqdBs.useContext((0, $xemlq.default)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $aqdBs.useRef();
    var elementRef = $aqdBs.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $kBwE8.useComposeRef)(ref, elementRef);
    var connectedKeys = (0, $irLxp.useFullPath)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $dMbbs.default)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $g52tp.default)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $aX4Fp.default)(_useActive, $5f2ab68ee70d176d$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $bmCoL.default)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $39XhA.warnItemProp)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $dHI2t.default).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $39XhA.warnItemProp)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    var renderNode = /*#__PURE__*/ $aqdBs.createElement($5f2ab68ee70d176d$var$LegacyMenuItem, (0, $13KW1.default)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $1iwLi.default)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(itemCls, (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, "".concat(itemCls, "-active"), active), "".concat(itemCls, "-selected"), selected), "".concat(itemCls, "-disabled"), mergedDisabled), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $aqdBs.createElement((0, $levfA.default), {
        props: (0, $4f2X8.default)((0, $4f2X8.default)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $5f2ab68ee70d176d$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $irLxp.useMeasure)();
    var connectedKeyPath = (0, $irLxp.useFullPath)(eventKey);
    // eslint-disable-next-line consistent-return
    $aqdBs.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $aqdBs.createElement($5f2ab68ee70d176d$var$InternalMenuItem, (0, $13KW1.default)({}, props, {
        ref: ref
    }));
}
var $5f2ab68ee70d176d$export$2e2bcd8739ae039 = /*#__PURE__*/ $aqdBs.forwardRef($5f2ab68ee70d176d$var$MenuItem);

});
parcelRegister("g52tp", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4f081baf5cae0f$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $eQzmH = parcelRequire("eQzmH");
function $bb4f081baf5cae0f$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}

});

parcelRegister("bmCoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $845f88ec91ce9f9d$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $eQzmH = parcelRequire("eQzmH");
function $845f88ec91ce9f9d$export$2e2bcd8739ae039(level) {
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== 'inline') return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}

});

parcelRegister("levfA", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75325779cebbff5$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");
function $f75325779cebbff5$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ $aqdBs.createElement(icon, (0, $4f2X8.default)({}, props));
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}

});

parcelRegister("39XhA", function(module, exports) {

$parcel$export(module.exports, "warnItemProp", () => $24d032a7471c8bb7$export$e189bcd94b66c1db);

var $aX4Fp = parcelRequire("aX4Fp");

var $i7X5i = parcelRequire("i7X5i");
var $24d032a7471c8bb7$var$_excluded = [
    "item"
];
function $24d032a7471c8bb7$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $aX4Fp.default)(_ref, $24d032a7471c8bb7$var$_excluded);
    Object.defineProperty(restInfo, 'item', {
        get: function get() {
            (0, $i7X5i.default)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}

});


parcelRegister("aXEQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7faf199337a935fd$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $46nrX = parcelRequire("46nrX");
parcelRequire("i7X5i");

var $ljjeL = parcelRequire("ljjeL");

var $2Nrro = parcelRequire("2Nrro");

var $eQzmH = parcelRequire("eQzmH");

var $8UKDd = parcelRequire("8UKDd");

var $iCdzt = parcelRequire("iCdzt");

var $levfA = parcelRequire("levfA");

var $g52tp = parcelRequire("g52tp");

var $39XhA = parcelRequire("39XhA");

var $bmCoL = parcelRequire("bmCoL");

var $3nJb5 = parcelRequire("3nJb5");

var $irLxp = parcelRequire("irLxp");

var $5O0NX = parcelRequire("5O0NX");

var $xemlq = parcelRequire("xemlq");
var $7faf199337a935fd$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "popupStyle",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $7faf199337a935fd$var$_excluded2 = [
    "active"
];
var $7faf199337a935fd$var$InternalSubMenu = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $aX4Fp.default)(props, $7faf199337a935fd$var$_excluded);
    var domDataId = (0, $5O0NX.useMenuId)(eventKey);
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $aqdBs.useContext((0, $xemlq.default)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $aqdBs.useContext((0, $irLxp.PathUserContext)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $irLxp.useFullPath)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $aqdBs.useRef();
    var popupRef = $aqdBs.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
    var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $g52tp.default)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $aX4Fp.default)(_useActive, $7faf199337a935fd$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $aqdBs.useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $aqdBs.useMemo(function() {
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $bmCoL.default)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $8UKDd.default)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $39XhA.warnItemProp)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    var expandIconNode = $aqdBs.useMemo(function() {
        return /*#__PURE__*/ $aqdBs.createElement((0, $levfA.default), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: (0, $4f2X8.default)((0, $4f2X8.default)({}, props), {}, {
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            })
        }, /*#__PURE__*/ $aqdBs.createElement("i", {
            className: "".concat(subMenuPrefixCls, "-arrow")
        }));
    }, [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $aqdBs.createElement("div", (0, $13KW1.default)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $aqdBs.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $aqdBs.createElement((0, $iCdzt.default), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: /*#__PURE__*/ $aqdBs.createElement((0, $eQzmH.default), {
                mode: triggerMode === 'horizontal' ? 'vertical' : triggerMode
            }, /*#__PURE__*/ $aqdBs.createElement((0, $ljjeL.default), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $aqdBs.createElement((0, $46nrX.default).Item, (0, $13KW1.default)({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, "".concat(subMenuPrefixCls, "-open"), open), "".concat(subMenuPrefixCls, "-active"), mergedActive), "".concat(subMenuPrefixCls, "-selected"), childrenSelected), "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $aqdBs.createElement((0, $3nJb5.default), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $aqdBs.createElement((0, $eQzmH.default), {
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
var $7faf199337a935fd$var$SubMenu = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $irLxp.useFullPath)(eventKey);
    var childList = (0, $2Nrro.parseChildren)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $irLxp.useMeasure)();
    // eslint-disable-next-line consistent-return
    $aqdBs.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $aqdBs.createElement($7faf199337a935fd$var$InternalSubMenu, (0, $13KW1.default)({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $aqdBs.createElement((0, $irLxp.PathTrackerContext).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $7faf199337a935fd$export$2e2bcd8739ae039 = $7faf199337a935fd$var$SubMenu;

});
parcelRegister("ljjeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f83a4b6b1e043435$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eQzmH = parcelRequire("eQzmH");
var $f83a4b6b1e043435$var$_excluded = [
    "className",
    "children"
];
var $f83a4b6b1e043435$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $aX4Fp.default)(_ref, $f83a4b6b1e043435$var$_excluded);
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $aqdBs.createElement("ul", (0, $13KW1.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === 'inline' ? 'inline' : 'vertical'), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $f83a4b6b1e043435$var$SubMenuList = /*#__PURE__*/ $aqdBs.forwardRef($f83a4b6b1e043435$var$InternalSubMenuList);
$f83a4b6b1e043435$var$SubMenuList.displayName = 'SubMenuList';
var $f83a4b6b1e043435$export$2e2bcd8739ae039 = $f83a4b6b1e043435$var$SubMenuList;

});

parcelRegister("2Nrro", function(module, exports) {

$parcel$export(module.exports, "parseChildren", () => $209571876b8b7601$export$cd230e97e668be9);

var $dMbbs = parcelRequire("dMbbs");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $aqdBs = parcelRequire("aqdBs");
function $209571876b8b7601$export$cd230e97e668be9(children, keyPath) {
    return (0, $bZ6Ai.default)(children).map(function(child, index) {
        if (/*#__PURE__*/ $aqdBs.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $dMbbs.default)(keyPath), [
                index
            ]).join('-'));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $aqdBs.cloneElement(child, cloneProps);
        }
        return child;
    });
}

});

parcelRegister("iCdzt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d64d8e3e815d4e$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $iSQdk = parcelRequire("iSQdk");

var $bqPQ9 = parcelRequire("bqPQ9");

var $ebavw = parcelRequire("ebavw");

var $eQzmH = parcelRequire("eQzmH");

var $6ouMS = parcelRequire("6ouMS");

var $dGuZW = parcelRequire("dGuZW");
var $d8d64d8e3e815d4e$var$popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function $d8d64d8e3e815d4e$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $aqdBs.useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $4f2X8.default)((0, $4f2X8.default)({}, (0, $6ouMS.placementsRtl)), builtinPlacements) : (0, $4f2X8.default)((0, $4f2X8.default)({}, (0, $6ouMS.placements)), builtinPlacements);
    var popupPlacement = $d8d64d8e3e815d4e$var$popupPlacementMap[mode];
    var targetMotion = (0, $dGuZW.getMotion)(mode, motion, defaultMotions);
    var targetMotionRef = $aqdBs.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $4f2X8.default)((0, $4f2X8.default)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $aqdBs.useRef();
    $aqdBs.useEffect(function() {
        visibleRef.current = (0, $ebavw.default)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $ebavw.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $iSQdk.default), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-popup"), (0, $br1G4.default)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}

});
parcelRegister("iSQdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf5c5bba62916b5$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $6WvuR = parcelRequire("6WvuR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $jeSJT = parcelRequire("jeSJT");

var $bTIJW = parcelRequire("bTIJW");

var $f1XSo = parcelRequire("f1XSo");

var $k91S5 = parcelRequire("k91S5");

var $4zEIt = parcelRequire("4zEIt");

var $iEJaB = parcelRequire("iEJaB");

var $eVaSH = parcelRequire("eVaSH");

var $aqdBs = parcelRequire("aqdBs");

var $iU20Q = parcelRequire("iU20Q");

var $2gWqt = parcelRequire("2gWqt");

var $fzMbd = parcelRequire("fzMbd");

var $1Saio = parcelRequire("1Saio");

var $dSfMA = parcelRequire("dSfMA");

var $jb2uU = parcelRequire("jb2uU");

var $e9h6e = parcelRequire("e9h6e");

var $6FPAw = parcelRequire("6FPAw");
var $dbf5c5bba62916b5$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $dbf5c5bba62916b5$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $6WvuR.default);
    var Trigger = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-trigger-popup' : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? 'hover' : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $aX4Fp.default)(props, $dbf5c5bba62916b5$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $aqdBs.useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $iEJaB.default)(function() {
            setMobile((0, $eVaSH.default)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $aqdBs.useRef({});
        var parentContext = $aqdBs.useContext((0, $fzMbd.default));
        var context = $aqdBs.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $4zEIt.default)();
        var _React$useState3 = $aqdBs.useState(null), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        // Used for forwardRef popup. Not use internal
        var externalPopupRef = $aqdBs.useRef(null);
        var setPopupRef = (0, $k91S5.default)(function(node) {
            externalPopupRef.current = node;
            if ((0, $bTIJW.isDOM)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $aqdBs.useState(null), _React$useState6 = (0, $kelIR.default)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $aqdBs.useRef(null);
        var setTargetRef = (0, $k91S5.default)(function(node) {
            if ((0, $bTIJW.isDOM)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $aqdBs.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $k91S5.default)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $f1XSo.getShadowRoot)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $f1XSo.getShadowRoot)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $6FPAw.getMotion)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $6FPAw.getMotion)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $aqdBs.useState(defaultPopupVisible || false), _React$useState8 = (0, $kelIR.default)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $k91S5.default)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $iEJaB.default)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $aqdBs.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $aqdBs.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $k91S5.default)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $aqdBs.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $aqdBs.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $aqdBs.useState(false), _React$useState10 = (0, $kelIR.default)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $iEJaB.default)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $aqdBs.useState(null), _React$useState12 = (0, $kelIR.default)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $aqdBs.useState(null), _React$useState14 = (0, $kelIR.default)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $dSfMA.default)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $kelIR.default)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $1Saio.default)(mobile, action, showAction, hideAction), _useAction2 = (0, $kelIR.default)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has('click');
        var clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        var triggerAlign = (0, $k91S5.default)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $jb2uU.default)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $iEJaB.default)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $iEJaB.default)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $aqdBs.useMemo(function() {
            var baseClassName = (0, $6FPAw.getAlignPopupClassName)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $aqdBs.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $aqdBs.useState(0), _React$useState16 = (0, $kelIR.default)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $aqdBs.useState(0), _React$useState18 = (0, $kelIR.default)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $iEJaB.default)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        var onPopupPointerDown = (0, $e9h6e.default)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has('hover');
        var hoverToHide = hideActions.has('hover');
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction('onPointerEnter', true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter(event) {
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $4f2X8.default)((0, $4f2X8.default)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $aqdBs.cloneElement(child, (0, $4f2X8.default)((0, $4f2X8.default)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $4f2X8.default)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $jeSJT.default), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $aqdBs.createElement((0, $2gWqt.default), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $aqdBs.createElement((0, $fzMbd.default).Provider, {
            value: context
        }, /*#__PURE__*/ $aqdBs.createElement((0, $iU20Q.default), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $dbf5c5bba62916b5$export$2e2bcd8739ae039 = $dbf5c5bba62916b5$export$55e99723d7f71b47((0, $6WvuR.default));

});
parcelRegister("6WvuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e09773c064d47d$export$2e2bcd8739ae039);

var $32HIR = parcelRequire("32HIR");

var $7919B = parcelRequire("7919B");
var $50e09773c064d47d$export$2e2bcd8739ae039 = (0, $32HIR.default);

});
parcelRegister("32HIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2373795dcc15e70f$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $8Vh6n = parcelRequire("8Vh6n");
parcelRequire("i7X5i");

var $kBwE8 = parcelRequire("kBwE8");

var $lfLzI = parcelRequire("lfLzI");

var $jbQOj = parcelRequire("jbQOj");

var $kvczw = parcelRequire("kvczw");

var $7919B = parcelRequire("7919B");
var $2373795dcc15e70f$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $8Vh6n.default)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
var $2373795dcc15e70f$var$Portal = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $aqdBs.useState(open), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $aqdBs.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $aqdBs.useState(function() {
        return $2373795dcc15e70f$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $aqdBs.useEffect(function() {
        var customizeContainer = $2373795dcc15e70f$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $jbQOj.default)(mergedRender && !innerContainer, debug), _useDom2 = (0, $kelIR.default)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $kvczw.default)(autoLock && open && (0, $8Vh6n.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $kBwE8.supportRef)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $kBwE8.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $8Vh6n.default)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $7919B.inlineMock)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $aqdBs.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $aqdBs.createElement((0, $lfLzI.default).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $jVlfX.createPortal)(reffedChildren, mergedContainer));
});
var $2373795dcc15e70f$export$2e2bcd8739ae039 = $2373795dcc15e70f$var$Portal;

});
parcelRegister("lfLzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78fe71aad9fe38d$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $f78fe71aad9fe38d$var$OrderContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $f78fe71aad9fe38d$export$2e2bcd8739ae039 = $f78fe71aad9fe38d$var$OrderContext;

});

parcelRegister("jbQOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $df88027c0ceb8fee$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $iEJaB = parcelRequire("iEJaB");

var $8Vh6n = parcelRequire("8Vh6n");

var $lfLzI = parcelRequire("lfLzI");
var $df88027c0ceb8fee$var$EMPTY_LIST = [];
function $df88027c0ceb8fee$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $aqdBs.useState(function() {
        if (!(0, $8Vh6n.default)()) return null;
        var defaultEle = document.createElement('div');
        return defaultEle;
    }), _React$useState2 = (0, $kelIR.default)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $aqdBs.useRef(false);
    var queueCreate = $aqdBs.useContext((0, $lfLzI.default));
    var _React$useState3 = $aqdBs.useState($df88027c0ceb8fee$var$EMPTY_LIST), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $dMbbs.default)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $iEJaB.default)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $iEJaB.default)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($df88027c0ceb8fee$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}

});

parcelRegister("kvczw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed07469f49817ae$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $98AgF = parcelRequire("98AgF");

var $iEJaB = parcelRequire("iEJaB");

var $jwzaE = parcelRequire("jwzaE");

var $50gG4 = parcelRequire("50gG4");
var $eed07469f49817ae$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $eed07469f49817ae$var$uuid = 0;
function $eed07469f49817ae$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $aqdBs.useState(function() {
        $eed07469f49817ae$var$uuid += 1;
        return "".concat($eed07469f49817ae$var$UNIQUE_ID, "_").concat($eed07469f49817ae$var$uuid);
    }), _React$useState2 = (0, $kelIR.default)(_React$useState, 1), id = _React$useState2[0];
    (0, $iEJaB.default)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $jwzaE.getTargetScrollBarSize)(document.body).width;
            var isOverflow = (0, $50gG4.isBodyOverflowing)();
            (0, $98AgF.updateCSS)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : '', "\n}"), id);
        } else (0, $98AgF.removeCSS)(id);
        return function() {
            (0, $98AgF.removeCSS)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}

});
parcelRegister("jwzaE", function(module, exports) {

$parcel$export(module.exports, "getTargetScrollBarSize", () => $e36c49ac1ac7e325$export$4f3ef2310365b56a);
/* eslint-disable no-param-reassign */ 
var $98AgF = parcelRequire("98AgF");
var $e36c49ac1ac7e325$var$cached;
function $e36c49ac1ac7e325$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : '';
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : '';
            (0, $98AgF.updateCSS)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $98AgF.removeCSS)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $e36c49ac1ac7e325$export$2e2bcd8739ae039(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || $e36c49ac1ac7e325$var$cached === undefined) $e36c49ac1ac7e325$var$cached = $e36c49ac1ac7e325$var$measureScrollbarSize();
    return $e36c49ac1ac7e325$var$cached.width;
}
function $e36c49ac1ac7e325$export$4f3ef2310365b56a(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $e36c49ac1ac7e325$var$measureScrollbarSize(target);
}

});

parcelRegister("50gG4", function(module, exports) {

$parcel$export(module.exports, "isBodyOverflowing", () => $3a49e3aaef89c78b$export$31b5c8f1131a3a52);
/**
 * Test usage export. Do not use in your production
 */ function $3a49e3aaef89c78b$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

});


parcelRegister("7919B", function(module, exports) {

$parcel$export(module.exports, "inlineMock", () => $533a44d0d6a76791$export$121d9fd0ca615463);
var $533a44d0d6a76791$export$18c8ad048e32c7d5 = false;
function $533a44d0d6a76791$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === 'boolean') $533a44d0d6a76791$export$18c8ad048e32c7d5 = nextInline;
    return $533a44d0d6a76791$export$18c8ad048e32c7d5;
}

});



parcelRegister("4zEIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $354a03ba0661c469$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");
function $354a03ba0661c469$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $4f2X8.default)({}, $aqdBs);
    return fullClone.useId;
}
var $354a03ba0661c469$var$uuid = 0;
function $354a03ba0661c469$export$2f0435a662835942() {}
var $354a03ba0661c469$var$useOriginId = $354a03ba0661c469$var$getUseId();
var $354a03ba0661c469$export$2e2bcd8739ae039 = $354a03ba0661c469$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $354a03ba0661c469$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $aqdBs.useState('ssr-id'), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $aqdBs.useEffect(function() {
        var nextId = $354a03ba0661c469$var$uuid;
        $354a03ba0661c469$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};

});

parcelRegister("eVaSH", function(module, exports) {

$parcel$export(module.exports, "default", () => $adced45c26735078$export$2e2bcd8739ae039);
var $adced45c26735078$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

});

parcelRegister("iU20Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc2f049b01a99086$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $jeSJT = parcelRequire("jeSJT");

var $iEJaB = parcelRequire("iEJaB");

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");

var $4mhL0 = parcelRequire("4mhL0");

var $avOj3 = parcelRequire("avOj3");

var $d0p3W = parcelRequire("d0p3W");
var $dc2f049b01a99086$var$Popup = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, onPointerDownCapture = props.onPointerDownCapture, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $aqdBs.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $iEJaB.default)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = 'auto';
    var offsetStyle = {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === 'r';
        var alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ $aqdBs.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $aqdBs.createElement((0, $avOj3.default), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $aqdBs.createElement((0, $jeSJT.default), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), (0, $13KW1.default)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $aqdBs.createElement("div", {
                ref: (0, $kBwE8.composeRef)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $4f2X8.default)((0, $4f2X8.default)((0, $4f2X8.default)((0, $4f2X8.default)({
                    '--arrow-x': "".concat(arrowPos.x || 0, "px"),
                    '--arrow-y': "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: 'border-box',
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $aqdBs.createElement((0, $4mhL0.default), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $aqdBs.createElement((0, $d0p3W.default), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $dc2f049b01a99086$export$2e2bcd8739ae039 = $dc2f049b01a99086$var$Popup;

});
parcelRegister("4mhL0", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6fdb655ce72f2$export$2e2bcd8739ae039);

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");
function $32c6fdb655ce72f2$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $aqdBs.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $aqdBs.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}

});

parcelRegister("avOj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a73d26862ae75a8$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $aqdBs = parcelRequire("aqdBs");
function $7a73d26862ae75a8$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), (0, $13KW1.default)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $aqdBs.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-mask"), className)
        });
    });
}

});

parcelRegister("d0p3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $977eb75d7eb72643$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $977eb75d7eb72643$var$PopupContent = /*#__PURE__*/ $aqdBs.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $977eb75d7eb72643$export$2e2bcd8739ae039 = $977eb75d7eb72643$var$PopupContent;

});


parcelRegister("2gWqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a7a659122955988$export$2e2bcd8739ae039);

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");
var $1a7a659122955988$var$TriggerWrapper = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $kBwE8.supportRef)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $aqdBs.useCallback(function(node) {
        (0, $kBwE8.fillRef)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $kBwE8.useComposeRef)(setRef, (0, $kBwE8.getNodeRef)(children));
    return canUseRef ? /*#__PURE__*/ $aqdBs.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $1a7a659122955988$export$2e2bcd8739ae039 = $1a7a659122955988$var$TriggerWrapper;

});

parcelRegister("fzMbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b56f7f6cb86c7956$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $b56f7f6cb86c7956$var$TriggerContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $b56f7f6cb86c7956$export$2e2bcd8739ae039 = $b56f7f6cb86c7956$var$TriggerContext;

});

parcelRegister("1Saio", function(module, exports) {

$parcel$export(module.exports, "default", () => $15d2d21c25fbcbd1$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $15d2d21c25fbcbd1$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $15d2d21c25fbcbd1$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $aqdBs.useMemo(function() {
        var mergedShowAction = $15d2d21c25fbcbd1$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $15d2d21c25fbcbd1$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has('hover')) {
                showActionSet.delete('hover');
                showActionSet.add('click');
            }
            if (hideActionSet.has('hover')) {
                hideActionSet.delete('hover');
                hideActionSet.add('click');
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}

});

parcelRegister("dSfMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a19c8f9a33cfb7fe$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $bTIJW = parcelRequire("bTIJW");

var $djRIe = parcelRequire("djRIe");

var $k91S5 = parcelRequire("k91S5");

var $iEJaB = parcelRequire("iEJaB");

var $aqdBs = parcelRequire("aqdBs");

var $6FPAw = parcelRequire("6FPAw");
function $a19c8f9a33cfb7fe$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a19c8f9a33cfb7fe$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $kelIR.default)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $a19c8f9a33cfb7fe$var$getUnitOffset(rect.width, offsetX),
        $a19c8f9a33cfb7fe$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a19c8f9a33cfb7fe$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return [
        points[0],
        points[1]
    ];
}
function $a19c8f9a33cfb7fe$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a19c8f9a33cfb7fe$var$reversePoints(points, index) {
    var reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || 'c';
        return point;
    }).join('');
}
function $a19c8f9a33cfb7fe$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $aqdBs.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $aqdBs.useRef(0);
    var scrollerList = $aqdBs.useMemo(function() {
        if (!popupEle) return [];
        return (0, $6FPAw.collectScroller)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $aqdBs.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $k91S5.default)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupRect$x, _popupRect$y, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $6FPAw.getWin)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $4f2X8.default)((0, $4f2X8.default)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement('div');
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var _rect$x, _rect$y;
                var rect = target.getBoundingClientRect();
                rect.x = (_rect$x = rect.x) !== null && _rect$x !== void 0 ? _rect$x : rect.left;
                rect.y = (_rect$y = rect.y) !== null && _rect$y !== void 0 ? _rect$y : rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _win$getComputedStyle2 = win.getComputedStyle(popupElement), height = _win$getComputedStyle2.height, width = _win$getComputedStyle2.width;
            popupRect.x = (_popupRect$x = popupRect.x) !== null && _popupRect$x !== void 0 ? _popupRect$x : popupRect.left;
            popupRect.y = (_popupRect$y = popupRect.y) !== null && _popupRect$y !== void 0 ? _popupRect$y : popupRect.top;
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = 'visible';
            var VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $6FPAw.getVisibleArea)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $6FPAw.getVisibleArea)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $6FPAw.toNum)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $6FPAw.toNum)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $bTIJW.isDOM)(target) && !(0, $djRIe.default)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $a19c8f9a33cfb7fe$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $kelIR.default)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $a19c8f9a33cfb7fe$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $kelIR.default)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $kelIR.default)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $a19c8f9a33cfb7fe$var$splitPoints(targetPoint);
            var popupPoints = $a19c8f9a33cfb7fe$var$splitPoints(popupPoint);
            var targetAlignPoint = $a19c8f9a33cfb7fe$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $a19c8f9a33cfb7fe$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $4f2X8.default)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $a19c8f9a33cfb7fe$var$getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            var popupAlignPointTL = $a19c8f9a33cfb7fe$var$getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            var targetAlignPointBR = $a19c8f9a33cfb7fe$var$getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            var popupAlignPointBR = $a19c8f9a33cfb7fe$var$getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a19c8f9a33cfb7fe$var$reversePoints(popupPoints, 0),
                        $a19c8f9a33cfb7fe$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a19c8f9a33cfb7fe$var$reversePoints(popupPoints, 0),
                        $a19c8f9a33cfb7fe$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a19c8f9a33cfb7fe$var$reversePoints(popupPoints, 1),
                        $a19c8f9a33cfb7fe$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a19c8f9a33cfb7fe$var$reversePoints(popupPoints, 1),
                        $a19c8f9a33cfb7fe$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (_scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (_scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            var nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $4f2X8.default)((0, $4f2X8.default)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $iEJaB.default)(resetReady, [
        placement
    ]);
    (0, $iEJaB.default)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}

});
parcelRegister("6FPAw", function(module, exports) {

$parcel$export(module.exports, "getAlignPopupClassName", () => $4dbe96bb257b2ad5$export$faa0aa8ed2fe6432);
$parcel$export(module.exports, "getMotion", () => $4dbe96bb257b2ad5$export$7b8936ddc277a29a);
$parcel$export(module.exports, "getWin", () => $4dbe96bb257b2ad5$export$9c0584a7cc24d9e);
$parcel$export(module.exports, "collectScroller", () => $4dbe96bb257b2ad5$export$ba21ed9400ca485b);
$parcel$export(module.exports, "toNum", () => $4dbe96bb257b2ad5$export$34dfc8f73bbb64ae);
$parcel$export(module.exports, "getVisibleArea", () => $4dbe96bb257b2ad5$export$94be9d7985092f2d);

var $4f2X8 = parcelRequire("4f2X8");
function $4dbe96bb257b2ad5$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $4dbe96bb257b2ad5$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($4dbe96bb257b2ad5$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}
function $4dbe96bb257b2ad5$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $4dbe96bb257b2ad5$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $4dbe96bb257b2ad5$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        var _getWin$getComputedSt = $4dbe96bb257b2ad5$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $4dbe96bb257b2ad5$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $4dbe96bb257b2ad5$var$getPxValue(val) {
    return $4dbe96bb257b2ad5$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $4dbe96bb257b2ad5$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $4f2X8.default)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $4dbe96bb257b2ad5$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $4dbe96bb257b2ad5$var$getPxValue(borderTopWidth);
        var borderBottomNum = $4dbe96bb257b2ad5$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $4dbe96bb257b2ad5$var$getPxValue(borderLeftWidth);
        var borderRightNum = $4dbe96bb257b2ad5$var$getPxValue(borderRightWidth);
        var scaleX = $4dbe96bb257b2ad5$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $4dbe96bb257b2ad5$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === 'clip') {
            var clipNum = $4dbe96bb257b2ad5$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}

});


parcelRegister("jb2uU", function(module, exports) {

$parcel$export(module.exports, "default", () => $df60fb5a21fccad6$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $iEJaB = parcelRequire("iEJaB");

var $6FPAw = parcelRequire("6FPAw");
function $df60fb5a21fccad6$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $iEJaB.default)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $6FPAw.collectScroller)(targetElement);
            var popupScrollList = (0, $6FPAw.collectScroller)(popupElement);
            var win = (0, $6FPAw.getWin)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $dMbbs.default)(targetScrollList), (0, $dMbbs.default)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}

});

parcelRegister("e9h6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4cf2b90e01481a4$export$2e2bcd8739ae039);

var $f1XSo = parcelRequire("f1XSo");
parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $6FPAw = parcelRequire("6FPAw");
function $a4cf2b90e01481a4$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $aqdBs.useRef(open);
    openRef.current = open;
    var popupPointerDownRef = $aqdBs.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $aqdBs.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var onPointerDown = function onPointerDown() {
                popupPointerDownRef.current = false;
            };
            var onTriggerClose = function onTriggerClose(e) {
                var _e$composedPath;
                if (openRef.current && !inPopupOrChild(((_e$composedPath = e.composedPath) === null || _e$composedPath === void 0 || (_e$composedPath = _e$composedPath.call(e)) === null || _e$composedPath === void 0 ? void 0 : _e$composedPath[0]) || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            var win = (0, $6FPAw.getWin)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            var targetShadowRoot = (0, $f1XSo.getShadowRoot)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}

});


parcelRegister("6ouMS", function(module, exports) {

$parcel$export(module.exports, "placements", () => $4a7cddab4be359c3$export$803cd8101b6c182b);
$parcel$export(module.exports, "placementsRtl", () => $4a7cddab4be359c3$export$e2b3f69b0a16e1f);
var $4a7cddab4be359c3$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $4a7cddab4be359c3$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    }
};
var $4a7cddab4be359c3$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $4a7cddab4be359c3$var$autoAdjustOverflow
    }
};
var $4a7cddab4be359c3$export$2e2bcd8739ae039 = $4a7cddab4be359c3$export$803cd8101b6c182b;

});

parcelRegister("dGuZW", function(module, exports) {

$parcel$export(module.exports, "getMotion", () => $9f673e2d466b597d$export$7b8936ddc277a29a);
function $9f673e2d466b597d$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}

});


parcelRegister("3nJb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $27669079769e4499$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $6ufPd = parcelRequire("6ufPd");

var $dGuZW = parcelRequire("dGuZW");

var $eQzmH = parcelRequire("eQzmH");

var $ljjeL = parcelRequire("ljjeL");
function $27669079769e4499$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = 'inline';
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $aqdBs.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $aqdBs.useState(!sameModeRef.current), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $aqdBs.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $4f2X8.default)({}, (0, $dGuZW.getMotion)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $aqdBs.createElement((0, $eQzmH.default), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), (0, $13KW1.default)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $aqdBs.createElement((0, $ljjeL.default), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}

});


parcelRegister("d6bJY", function(module, exports) {

$parcel$export(module.exports, "parseItems", () => $9894f14fde2201f4$export$50458dc1a9a0f894);

var $4f2X8 = parcelRequire("4f2X8");

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $7IgoF = parcelRequire("7IgoF");

var $aqdBs = parcelRequire("aqdBs");

var $aqdcb = parcelRequire("aqdcb");

var $8azox = parcelRequire("8azox");

var $7YcE0 = parcelRequire("7YcE0");

var $aXEQC = parcelRequire("aXEQC");

var $2Nrro = parcelRequire("2Nrro");
var $9894f14fde2201f4$var$_excluded = [
    "label",
    "children",
    "key",
    "type",
    "extra"
];
function $9894f14fde2201f4$var$convertItemsToNodes(list, components, prefixCls) {
    var MergedMenuItem = components.item, MergedMenuItemGroup = components.group, MergedSubMenu = components.submenu, MergedDivider = components.divider;
    return (list || []).map(function(opt, index) {
        if (opt && (0, $7IgoF.default)(opt) === 'object') {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, extra = _ref.extra, restProps = (0, $aX4Fp.default)(_ref, $9894f14fde2201f4$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ $aqdBs.createElement(MergedMenuItemGroup, (0, $13KW1.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $9894f14fde2201f4$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $aqdBs.createElement(MergedSubMenu, (0, $13KW1.default)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $9894f14fde2201f4$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ $aqdBs.createElement(MergedDivider, (0, $13KW1.default)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $aqdBs.createElement(MergedMenuItem, (0, $13KW1.default)({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ $aqdBs.createElement("span", {
                className: "".concat(prefixCls, "-item-extra")
            }, extra));
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $9894f14fde2201f4$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    var childNodes = children;
    var mergedComponents = (0, $4f2X8.default)({
        divider: (0, $aqdcb.default),
        item: (0, $8azox.default),
        group: (0, $7YcE0.default),
        submenu: (0, $aXEQC.default)
    }, components);
    if (items) childNodes = $9894f14fde2201f4$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $2Nrro.parseChildren)(childNodes, keyPath);
}

});
parcelRegister("aqdcb", function(module, exports) {

$parcel$export(module.exports, "default", () => $796691711b43778f$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eQzmH = parcelRequire("eQzmH");

var $irLxp = parcelRequire("irLxp");
function $796691711b43778f$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $irLxp.useMeasure)();
    if (measure) return null;
    return /*#__PURE__*/ $aqdBs.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}

});

parcelRegister("7YcE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd7f1e07860845f$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");

var $aqdBs = parcelRequire("aqdBs");

var $eQzmH = parcelRequire("eQzmH");

var $irLxp = parcelRequire("irLxp");

var $2Nrro = parcelRequire("2Nrro");
var $5cd7f1e07860845f$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
];
var $5cd7f1e07860845f$var$InternalMenuItemGroup = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var className = props.className, title = props.title, eventKey = props.eventKey, children = props.children, restProps = (0, $aX4Fp.default)(props, $5cd7f1e07860845f$var$_excluded);
    var _React$useContext = $aqdBs.useContext((0, $eQzmH.MenuContext)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $aqdBs.createElement("li", (0, $13KW1.default)({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $aqdBs.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ $aqdBs.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
});
var $5cd7f1e07860845f$var$MenuItemGroup = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $irLxp.useFullPath)(eventKey);
    var childList = (0, $2Nrro.parseChildren)(children, connectedKeyPath);
    var measure = (0, $irLxp.useMeasure)();
    if (measure) return childList;
    return /*#__PURE__*/ $aqdBs.createElement($5cd7f1e07860845f$var$InternalMenuItemGroup, (0, $13KW1.default)({
        ref: ref
    }, (0, $1iwLi.default)(props, [
        'warnKey'
    ])), childList);
});
var $5cd7f1e07860845f$export$2e2bcd8739ae039 = $5cd7f1e07860845f$var$MenuItemGroup;

});




parcelRegister("7uUoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5757159eab844627$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $jIfWQ = parcelRequire("jIfWQ");

var $gL7Ec = parcelRequire("gL7Ec");
var $5757159eab844627$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $jIfWQ.default)
    }));
};
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ var $5757159eab844627$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($5757159eab844627$var$EllipsisOutlined);
var $5757159eab844627$export$2e2bcd8739ae039 = $5757159eab844627$var$RefIcon;

});
parcelRegister("jIfWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b41ad418549ee7$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $03b41ad418549ee7$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $03b41ad418549ee7$export$2e2bcd8739ae039 = $03b41ad418549ee7$var$EllipsisOutlined;

});


parcelRegister("aogQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $790937dd961e3c90$export$2e2bcd8739ae039);

var $jygCN = parcelRequire("jygCN");
/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $790937dd961e3c90$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $jygCN.default)();
    return cssVar ? `${prefixCls}-css-var` : '';
};
var $790937dd961e3c90$export$2e2bcd8739ae039 = $790937dd961e3c90$var$useCSSVarCls;

});

parcelRegister("LGNg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $08f595cc2977f2e4$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $7ruEM = parcelRequire("7ruEM");

var $eAKDF = parcelRequire("eAKDF");

var $cQKK1 = parcelRequire("cQKK1");

var $jHeh6 = parcelRequire("jHeh6");

var $dLmcO = parcelRequire("dLmcO");

var $i22RA = parcelRequire("i22RA");

var $iOHOh = parcelRequire("iOHOh");

var $dkjPS = parcelRequire("dkjPS");

var $jaW1p = parcelRequire("jaW1p");

var $kjlvF = parcelRequire("kjlvF");

var $jygCN = parcelRequire("jygCN");

var $2EtDh = parcelRequire("2EtDh");

var $bgU8K = parcelRequire("bgU8K");

var $hHt8P = parcelRequire("hHt8P");
"use client";
var $08f595cc2977f2e4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $08f595cc2977f2e4$var$InternalTooltip = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, overlayInnerStyle: overlayInnerStyle, children: children, afterOpenChange: afterOpenChange, afterVisibleChange: afterVisibleChange, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, arrow: arrow = true, title: title, overlay: overlay, builtinPlacements: builtinPlacements, arrowPointAtCenter: arrowPointAtCenter = false, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = 'top', mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle, rootClassName: rootClassName, overlayClassName: overlayClassName, styles: styles, classNames: tooltipClassNames } = props, restProps = $08f595cc2977f2e4$var$__rest(props, [
        "prefixCls",
        "openClassName",
        "getTooltipContainer",
        "color",
        "overlayInnerStyle",
        "children",
        "afterOpenChange",
        "afterVisibleChange",
        "destroyTooltipOnHide",
        "destroyOnHidden",
        "arrow",
        "title",
        "overlay",
        "builtinPlacements",
        "arrowPointAtCenter",
        "autoAdjustOverflow",
        "motion",
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName",
        "overlayClassName",
        "styles",
        "classNames"
    ]);
    const mergedShowArrow = !!arrow;
    const [, token] = (0, $jygCN.default)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $kjlvF.useComponentConfig)('tooltip');
    // ============================== Ref ===============================
    const warning = (0, $dkjPS.devUseWarning)('Tooltip');
    const tooltipRef = $aqdBs.useRef(null);
    const forceAlign = ()=>{
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $aqdBs.useImperativeHandle(ref, ()=>{
        var _a, _b;
        return {
            forceAlign: forceAlign,
            forcePopupAlign: ()=>{
                warning.deprecated(false, 'forcePopupAlign', 'forceAlign');
                forceAlign();
            },
            nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement,
            popupElement: (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.popupElement
        };
    });
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $eAKDF.default)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onOpenChange = (vis)=>{
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    const tooltipPlacements = $aqdBs.useMemo(()=>{
        var _a, _b;
        let mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === 'object') mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $i22RA.default)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    const memoOverlay = $aqdBs.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $aqdBs.createElement((0, $cQKK1.default), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && !('visible' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $aqdBs.isValidElement(children) && !(0, $iOHOh.isFragment)(children) ? children : /*#__PURE__*/ $aqdBs.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $bgU8K.default)(prefixCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $hHt8P.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const rootClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, hashId, cssVarCls, contextClassName, contextClassNames.root, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root);
    const bodyClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(contextClassNames.body, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $jHeh6.useZIndex)('Tooltip', restProps.zIndex);
    const content = /*#__PURE__*/ $aqdBs.createElement((0, $7ruEM.default), Object.assign({}, restProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            body: bodyClassNames
        },
        styles: {
            root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, arrowContentStyle), contextStyles.root), contextStyle), overlayStyle), styles === null || styles === void 0 ? void 0 : styles.root),
            body: Object.assign(Object.assign(Object.assign(Object.assign({}, contextStyles.body), overlayInnerStyle), styles === null || styles === void 0 ? void 0 : styles.body), colorInfo.overlayStyle)
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        arrowContent: /*#__PURE__*/ $aqdBs.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $dLmcO.getTransitionName)(rootPrefixCls, 'zoom-big-fast', props.transitionName),
            motionDeadline: 1000
        },
        // TODO: In the future, destroyTooltipOnHide in rc-tooltip needs to be upgrade to destroyOnHidden
        destroyTooltipOnHide: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : !!destroyTooltipOnHide
    }), tempOpen ? (0, $iOHOh.cloneElement)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $jaW1p.default).Provider, {
        value: contextZIndex
    }, content));
});
const $08f595cc2977f2e4$var$Tooltip = $08f595cc2977f2e4$var$InternalTooltip;
$08f595cc2977f2e4$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $2EtDh.default);
var $08f595cc2977f2e4$export$2e2bcd8739ae039 = $08f595cc2977f2e4$var$Tooltip;

});
parcelRegister("7ruEM", function(module, exports) {

$parcel$export(module.exports, "default", () => $56b2d5d2f0e5131a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("84bWi")).default);

var $84bWi = parcelRequire("84bWi");

var $cDUAR = parcelRequire("cDUAR");
var $56b2d5d2f0e5131a$export$2e2bcd8739ae039 = (0, $cDUAR.default);

});
parcelRegister("84bWi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df7f5558fb9ccc8$export$2e2bcd8739ae039);

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");
function $5df7f5558fb9ccc8$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, innerStyle = props.overlayInnerStyle, bodyClassName = props.bodyClassName, className = props.className, style = props.style;
    return /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-inner"), bodyClassName),
        id: id,
        role: "tooltip",
        style: innerStyle
    }, typeof children === 'function' ? children() : children));
}

});

parcelRegister("cDUAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $934506de05fdfdb4$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $iSQdk = parcelRequire("iSQdk");

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");

var $5b04H = parcelRequire("5b04H");

var $84bWi = parcelRequire("84bWi");

var $4zEIt = parcelRequire("4zEIt");
var $934506de05fdfdb4$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow",
    "classNames",
    "styles"
];
var $934506de05fdfdb4$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, tooltipClassNames = props.classNames, tooltipStyles = props.styles, restProps = (0, $aX4Fp.default)(props, $934506de05fdfdb4$var$_excluded);
    var mergedId = (0, $4zEIt.default)(id);
    var triggerRef = (0, $aqdBs.useRef)(null);
    (0, $aqdBs.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $4f2X8.default)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $aqdBs.createElement((0, $84bWi.default), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            bodyClassName: tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.body,
            overlayInnerStyle: (0, $4f2X8.default)((0, $4f2X8.default)({}, overlayInnerStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.body)
        }, overlay);
    };
    var getChildren = function getChildren() {
        var child = $aqdBs.Children.only(children);
        var originalProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var childProps = (0, $4f2X8.default)((0, $4f2X8.default)({}, originalProps), {}, {
            'aria-describedby': overlay ? mergedId : null
        });
        return /*#__PURE__*/ $aqdBs.cloneElement(children, childProps);
    };
    return /*#__PURE__*/ $aqdBs.createElement((0, $iSQdk.default), (0, $13KW1.default)({
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(overlayClassName, tooltipClassNames === null || tooltipClassNames === void 0 ? void 0 : tooltipClassNames.root),
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $5b04H.placements),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: (0, $4f2X8.default)((0, $4f2X8.default)({}, overlayStyle), tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.root),
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), getChildren());
};
var $934506de05fdfdb4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $aqdBs.forwardRef)($934506de05fdfdb4$var$Tooltip);

});
parcelRegister("5b04H", function(module, exports) {

$parcel$export(module.exports, "placements", () => $3c4e09b291ef91b3$export$803cd8101b6c182b);
var $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $3c4e09b291ef91b3$var$targetOffset = [
    0,
    0
];
var $3c4e09b291ef91b3$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $3c4e09b291ef91b3$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $3c4e09b291ef91b3$var$targetOffset
    }
};
var $3c4e09b291ef91b3$export$2e2bcd8739ae039 = $3c4e09b291ef91b3$export$803cd8101b6c182b;

});



parcelRegister("cQKK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ae9934f6766669$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $7YqzN = parcelRequire("7YqzN");

var $O3SCq = parcelRequire("O3SCq");
"use client";
const $95ae9934f6766669$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $7YqzN.NoFormStyle), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $O3SCq.NoCompactStyle), null, result);
    return result;
};
var $95ae9934f6766669$export$2e2bcd8739ae039 = $95ae9934f6766669$var$ContextIsolator;

});
parcelRegister("7YqzN", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $5ce2c08458c9667d$export$c24727297075ec6a);
$parcel$export(module.exports, "NoStyleItemContext", () => $5ce2c08458c9667d$export$d718247e9f9b0b9e);
$parcel$export(module.exports, "FormProvider", () => $5ce2c08458c9667d$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "FormItemPrefixContext", () => $5ce2c08458c9667d$export$fb6582d3042cc879);
$parcel$export(module.exports, "FormItemInputContext", () => $5ce2c08458c9667d$export$bbb5553c6c7a14ed);
$parcel$export(module.exports, "NoFormStyle", () => $5ce2c08458c9667d$export$80e4c53cb85dcab1);
$parcel$export(module.exports, "VariantContext", () => $5ce2c08458c9667d$export$6f0555dad42725fb);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("8rj45");
var $dc7XZ = parcelRequire("dc7XZ");

var $1iwLi = parcelRequire("1iwLi");
"use client";
const $5ce2c08458c9667d$export$c24727297075ec6a = /*#__PURE__*/ $aqdBs.createContext({
    labelAlign: 'right',
    vertical: false,
    itemRef: ()=>{}
});
const $5ce2c08458c9667d$export$d718247e9f9b0b9e = /*#__PURE__*/ $aqdBs.createContext(null);
const $5ce2c08458c9667d$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $1iwLi.default)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $dc7XZ.FormProvider), Object.assign({}, providerProps));
};
const $5ce2c08458c9667d$export$fb6582d3042cc879 = /*#__PURE__*/ $aqdBs.createContext({
    prefixCls: ''
});
const $5ce2c08458c9667d$export$bbb5553c6c7a14ed = /*#__PURE__*/ $aqdBs.createContext({});
const $5ce2c08458c9667d$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $aqdBs.useContext($5ce2c08458c9667d$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $aqdBs.useMemo(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($5ce2c08458c9667d$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $5ce2c08458c9667d$export$6f0555dad42725fb = /*#__PURE__*/ $aqdBs.createContext(undefined);

});
parcelRegister("8rj45", function(module, exports) {

$parcel$export(module.exports, "default", () => $624fa2416c7315d5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Field", () => (parcelRequire("5nc8d")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("enPe3")).default);
$parcel$export(module.exports, "useForm", () => (parcelRequire("8CXnA")).default);
$parcel$export(module.exports, "FormProvider", () => (parcelRequire("dc7XZ")).FormProvider);
$parcel$export(module.exports, "FieldContext", () => (parcelRequire("lJsob")).default);
$parcel$export(module.exports, "ListContext", () => (parcelRequire("hskPh")).default);
$parcel$export(module.exports, "useWatch", () => (parcelRequire("8nPZz")).default);

var $aqdBs = parcelRequire("aqdBs");

var $5nc8d = parcelRequire("5nc8d");

var $enPe3 = parcelRequire("enPe3");

var $8CXnA = parcelRequire("8CXnA");

var $56Hbl = parcelRequire("56Hbl");

var $dc7XZ = parcelRequire("dc7XZ");

var $lJsob = parcelRequire("lJsob");

var $hskPh = parcelRequire("hskPh");

var $8nPZz = parcelRequire("8nPZz");
var $624fa2416c7315d5$var$InternalForm = /*#__PURE__*/ $aqdBs.forwardRef((0, $56Hbl.default));
var $624fa2416c7315d5$var$RefForm = $624fa2416c7315d5$var$InternalForm;
$624fa2416c7315d5$var$RefForm.FormProvider = (0, $dc7XZ.FormProvider);
$624fa2416c7315d5$var$RefForm.Field = (0, $5nc8d.default);
$624fa2416c7315d5$var$RefForm.List = (0, $enPe3.default);
$624fa2416c7315d5$var$RefForm.useForm = (0, $8CXnA.default);
$624fa2416c7315d5$var$RefForm.useWatch = (0, $8nPZz.default);
var $624fa2416c7315d5$export$2e2bcd8739ae039 = $624fa2416c7315d5$var$RefForm;

});
parcelRegister("5nc8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9882c8fe6f1753$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aX4Fp = parcelRequire("aX4Fp");

var $6jwft = parcelRequire("6jwft");

var $8F2Cm = parcelRequire("8F2Cm");

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $br1G4 = parcelRequire("br1G4");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $aTirs = parcelRequire("aTirs");

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $lJsob = parcelRequire("lJsob");

var $hskPh = parcelRequire("hskPh");

var $4LGsO = parcelRequire("4LGsO");

var $cv8XK = parcelRequire("cv8XK");

var $fFsAH = parcelRequire("fFsAH");
var $fGBDZ = parcelRequire("fGBDZ");
var $3e9882c8fe6f1753$var$_excluded = [
    "name"
];
var $3e9882c8fe6f1753$var$EMPTY_ERRORS = [];
function $3e9882c8fe6f1753$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $3e9882c8fe6f1753$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $9nc35.default)(Field, _React$Component);
    var _super = (0, $lriWM.default)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $dYVVZ.default)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "state", {
            resetCount: 0
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "cancelRegisterFunc", null);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $br1G4.default)((0, $1FDZu.default)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $br1G4.default)((0, $1FDZu.default)(_this), "dirty", false);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "validatePromise", void 0);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "prevValidating", void 0);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "errors", $3e9882c8fe6f1753$var$EMPTY_ERRORS);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "warnings", $3e9882c8fe6f1753$var$EMPTY_ERRORS);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $fFsAH.getNamePath)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $dMbbs.default)(prefixName), (0, $dMbbs.default)(name)) : [];
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === 'function') return rule(fieldContext);
                return rule;
            });
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "metaCache", null);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $4f2X8.default)((0, $4f2X8.default)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $aTirs.default)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $fFsAH.containsNamePath)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === 'valueUpdate' && info.source === 'external' && !(0, $aTirs.default)(prevValue, curValue)) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                _this.warnings = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case 'reset':
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                        _this.warnings = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case 'remove':
                    if (shouldUpdate && $3e9882c8fe6f1753$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'setField':
                    var data = info.data;
                    if (namePathMatch) {
                        if ('touched' in data) _this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) _this.errors = data.errors || $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                        if ('warnings' in data) _this.warnings = data.warnings || $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ('value' in data && (0, $fFsAH.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $3e9882c8fe6f1753$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case 'dependenciesUpdate':
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $fFsAH.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $fFsAH.containsNamePath)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $3e9882c8fe6f1753$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $6jwft.default)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $4LGsO.toArray)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $cv8XK.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3e9882c8fe6f1753$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $3e9882c8fe6f1753$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $dMbbs.default)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $dMbbs.default)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
            _this.warnings = $3e9882c8fe6f1753$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $lJsob.HOOK_MARK)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === 'function') {
                var _meta2 = _this.getMeta();
                return (0, $4f2X8.default)((0, $4f2X8.default)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $bZ6Ai.default)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $aqdBs.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $fGBDZ.default)(store || getFieldsValue(true), namePath);
        });
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $lJsob.HOOK_MARK)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $br1G4.default)({}, valuePropName, val);
            };
            var originTriggerFunc = childProps[trigger];
            var valueProps = name !== undefined ? mergedGetValueProps(value) : {};
            var control = (0, $4f2X8.default)((0, $4f2X8.default)({}, childProps), valueProps);
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $fFsAH.defaultGetValueFromEvent).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                if (newValue !== value) dispatch({
                    type: 'updateValue',
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $4LGsO.toArray)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: 'validateField',
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $lJsob.HOOK_MARK)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $1FDZu.default)(_this));
        }
        return _this;
    }
    (0, $hevvH.default)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $lJsob.HOOK_MARK)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $aqdBs.isValidElement(child)) returnChildNode = /*#__PURE__*/ $aqdBs.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $i7X5i.default)(!child, '`children` of Field is not validate ReactElement.');
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($aqdBs.Component);
(0, $br1G4.default)($3e9882c8fe6f1753$var$Field, "contextType", (0, $lJsob.default));
(0, $br1G4.default)($3e9882c8fe6f1753$var$Field, "defaultProps", {
    trigger: 'onChange',
    valuePropName: 'value'
});
function $3e9882c8fe6f1753$var$WrapperField(_ref6) {
    var _restProps$isListFiel;
    var name = _ref6.name, restProps = (0, $aX4Fp.default)(_ref6, $3e9882c8fe6f1753$var$_excluded);
    var fieldContext = $aqdBs.useContext((0, $lJsob.default));
    var listContext = $aqdBs.useContext((0, $hskPh.default));
    var namePath = name !== undefined ? (0, $fFsAH.getNamePath)(name) : undefined;
    var isMergedListField = (_restProps$isListFiel = restProps.isListField) !== null && _restProps$isListFiel !== void 0 ? _restProps$isListFiel : !!listContext;
    var key = 'keep';
    if (!isMergedListField) key = "_".concat((namePath || []).join('_'));
    return /*#__PURE__*/ $aqdBs.createElement($3e9882c8fe6f1753$var$Field, (0, $13KW1.default)({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $3e9882c8fe6f1753$export$2e2bcd8739ae039 = $3e9882c8fe6f1753$var$WrapperField;

});
parcelRegister("lJsob", function(module, exports) {

$parcel$export(module.exports, "HOOK_MARK", () => $fd23d268e511a667$export$24829b7c0e49e9f7);
$parcel$export(module.exports, "default", () => $fd23d268e511a667$export$2e2bcd8739ae039);

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");
var $fd23d268e511a667$export$24829b7c0e49e9f7 = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $fd23d268e511a667$var$warningFunc = function warningFunc() {
    (0, $i7X5i.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
var $fd23d268e511a667$var$Context = /*#__PURE__*/ $aqdBs.createContext({
    getFieldValue: $fd23d268e511a667$var$warningFunc,
    getFieldsValue: $fd23d268e511a667$var$warningFunc,
    getFieldError: $fd23d268e511a667$var$warningFunc,
    getFieldWarning: $fd23d268e511a667$var$warningFunc,
    getFieldsError: $fd23d268e511a667$var$warningFunc,
    isFieldsTouched: $fd23d268e511a667$var$warningFunc,
    isFieldTouched: $fd23d268e511a667$var$warningFunc,
    isFieldValidating: $fd23d268e511a667$var$warningFunc,
    isFieldsValidating: $fd23d268e511a667$var$warningFunc,
    resetFields: $fd23d268e511a667$var$warningFunc,
    setFields: $fd23d268e511a667$var$warningFunc,
    setFieldValue: $fd23d268e511a667$var$warningFunc,
    setFieldsValue: $fd23d268e511a667$var$warningFunc,
    validateFields: $fd23d268e511a667$var$warningFunc,
    submit: $fd23d268e511a667$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $fd23d268e511a667$var$warningFunc();
        return {
            dispatch: $fd23d268e511a667$var$warningFunc,
            initEntityValue: $fd23d268e511a667$var$warningFunc,
            registerField: $fd23d268e511a667$var$warningFunc,
            useSubscribe: $fd23d268e511a667$var$warningFunc,
            setInitialValues: $fd23d268e511a667$var$warningFunc,
            destroyForm: $fd23d268e511a667$var$warningFunc,
            setCallbacks: $fd23d268e511a667$var$warningFunc,
            registerWatch: $fd23d268e511a667$var$warningFunc,
            getFields: $fd23d268e511a667$var$warningFunc,
            setValidateMessages: $fd23d268e511a667$var$warningFunc,
            setPreserve: $fd23d268e511a667$var$warningFunc,
            getInitialValue: $fd23d268e511a667$var$warningFunc
        };
    }
});
var $fd23d268e511a667$export$2e2bcd8739ae039 = $fd23d268e511a667$var$Context;

});

parcelRegister("hskPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5534d486adf3f0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $cb5534d486adf3f0$var$ListContext = /*#__PURE__*/ $aqdBs.createContext(null);
var $cb5534d486adf3f0$export$2e2bcd8739ae039 = $cb5534d486adf3f0$var$ListContext;

});

parcelRegister("4LGsO", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $378c7da000117e47$export$45b10814cc054894);
$parcel$export(module.exports, "isFormInstance", () => $378c7da000117e47$export$717b316e73068e8d);
function $378c7da000117e47$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $378c7da000117e47$export$717b316e73068e8d(form) {
    return form && !!form._init;
}

});

parcelRegister("cv8XK", function(module, exports) {

$parcel$export(module.exports, "validateRules", () => $919f551440657ccc$export$e1fc4b442d0297dd);

var $dMbbs = parcelRequire("dMbbs");

var $br1G4 = parcelRequire("br1G4");

var $6jwft = parcelRequire("6jwft");

var $4f2X8 = parcelRequire("4f2X8");

var $8F2Cm = parcelRequire("8F2Cm");

var $2vnTM = parcelRequire("2vnTM");

var $aqdBs = parcelRequire("aqdBs");

var $i7X5i = parcelRequire("i7X5i");

var $9zgy7 = parcelRequire("9zgy7");

var $acNyW = parcelRequire("acNyW");
// Remove incorrect original ts define
var $919f551440657ccc$var$AsyncValidator = (0, $2vnTM.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $919f551440657ccc$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, function(str) {
        if (str.startsWith('\\')) return str.slice(1);
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $919f551440657ccc$var$CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
function $919f551440657ccc$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $919f551440657ccc$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $919f551440657ccc$var$_validateRule() {
    $919f551440657ccc$var$_validateRule = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $6jwft.default)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $4f2X8.default)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $919f551440657ccc$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($919f551440657ccc$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $919f551440657ccc$var$AsyncValidator((0, $br1G4.default)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $acNyW.merge)((0, $9zgy7.defaultValidateMessages), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $br1G4.default)({}, name, value), (0, $4f2X8.default)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $919f551440657ccc$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $aqdBs.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $aqdBs.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $919f551440657ccc$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $dMbbs.default)(prev), (0, $dMbbs.default)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $4f2X8.default)((0, $4f2X8.default)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(', ')
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === 'string') return $919f551440657ccc$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $919f551440657ccc$var$_validateRule.apply(this, arguments);
}
function $919f551440657ccc$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join('.');
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $4f2X8.default)((0, $4f2X8.default)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $i7X5i.default)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $i7X5i.default)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $6jwft.default)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $919f551440657ccc$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $919f551440657ccc$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $919f551440657ccc$var$finishOnFirstFailed(rulePromises) : $919f551440657ccc$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $919f551440657ccc$var$finishOnAllFailed(_x8) {
    return $919f551440657ccc$var$_finishOnAllFailed.apply(this, arguments);
}
function $919f551440657ccc$var$_finishOnAllFailed() {
    $919f551440657ccc$var$_finishOnAllFailed = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee3(rulePromises) {
        return (0, $6jwft.default)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $dMbbs.default)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $919f551440657ccc$var$_finishOnAllFailed.apply(this, arguments);
}
function $919f551440657ccc$var$finishOnFirstFailed(_x9) {
    return $919f551440657ccc$var$_finishOnFirstFailed.apply(this, arguments);
}
function $919f551440657ccc$var$_finishOnFirstFailed() {
    $919f551440657ccc$var$_finishOnFirstFailed = (0, $8F2Cm.default)(/*#__PURE__*/ (0, $6jwft.default)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $6jwft.default)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $919f551440657ccc$var$_finishOnFirstFailed.apply(this, arguments);
}

});
parcelRegister("2vnTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d3103cdb8ecc4f8$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $7IgoF = parcelRequire("7IgoF");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");

var $bsyR1 = parcelRequire("bsyR1");

var $9wfY2 = parcelRequire("9wfY2");

var $cY1eH = parcelRequire("cY1eH");
parcelRequire("3X5Ez");
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $1d3103cdb8ecc4f8$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $dYVVZ.default)(this, Schema);
        // ======================== Instance ========================
        (0, $br1G4.default)(this, "rules", null);
        (0, $br1G4.default)(this, "_messages", (0, $bsyR1.messages));
        this.define(descriptor);
    }
    (0, $hevvH.default)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, $7IgoF.default)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $9wfY2.deepMerge)((0, $bsyR1.newMessages)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $dMbbs.default)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $9wfY2.convertFieldsError)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $bsyR1.messages)) messages = (0, $bsyR1.newMessages)();
                    (0, $9wfY2.deepMerge)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, $4f2X8.default)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, $7IgoF.default)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, $4f2X8.default)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $9wfY2.asyncMap)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, $7IgoF.default)(rule.fields) === 'object' || (0, $7IgoF.default)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $4f2X8.default)((0, $4f2X8.default)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $dMbbs.default)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $9wfY2.complementError)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $9wfY2.complementError)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $9wfY2.format)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $4f2X8.default)((0, $4f2X8.default)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $dMbbs.default)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $dMbbs.default)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, $cY1eH.default).hasOwnProperty(rule.type)) throw new Error((0, $9wfY2.format)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, $cY1eH.default).required;
                return (0, $cY1eH.default)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $br1G4.default)($1d3103cdb8ecc4f8$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, $cY1eH.default)[type] = validator;
});
(0, $br1G4.default)($1d3103cdb8ecc4f8$var$Schema, "warning", (0, $9wfY2.warning));
(0, $br1G4.default)($1d3103cdb8ecc4f8$var$Schema, "messages", (0, $bsyR1.messages));
(0, $br1G4.default)($1d3103cdb8ecc4f8$var$Schema, "validators", (0, $cY1eH.default));
var $1d3103cdb8ecc4f8$export$2e2bcd8739ae039 = $1d3103cdb8ecc4f8$var$Schema;

});
parcelRegister("bsyR1", function(module, exports) {

$parcel$export(module.exports, "newMessages", () => $857d5892f3d98dfe$export$f77fd0c3b25d8534);
$parcel$export(module.exports, "messages", () => $857d5892f3d98dfe$export$defe85febe8b728c);
function $857d5892f3d98dfe$export$f77fd0c3b25d8534() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $857d5892f3d98dfe$export$defe85febe8b728c = $857d5892f3d98dfe$export$f77fd0c3b25d8534();

});

parcelRegister("9wfY2", function(module, exports) {

$parcel$export(module.exports, "warning", () => $6ee37cfdf49d29b7$export$491112666e282270);
$parcel$export(module.exports, "convertFieldsError", () => $6ee37cfdf49d29b7$export$e85887f5ceeacced);
$parcel$export(module.exports, "format", () => $6ee37cfdf49d29b7$export$d9468344d3651243);
$parcel$export(module.exports, "isEmptyValue", () => $6ee37cfdf49d29b7$export$141eca273a04dc3e);
$parcel$export(module.exports, "asyncMap", () => $6ee37cfdf49d29b7$export$707ee4c4c95d39e3);
$parcel$export(module.exports, "complementError", () => $6ee37cfdf49d29b7$export$34d5fe50d2616cee);
$parcel$export(module.exports, "deepMerge", () => $6ee37cfdf49d29b7$export$6969335ea1e4e77c);

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");

var $hevvH = parcelRequire("hevvH");

var $dYVVZ = parcelRequire("dYVVZ");

var $1FDZu = parcelRequire("1FDZu");

var $9nc35 = parcelRequire("9nc35");

var $lriWM = parcelRequire("lriWM");

var $lH7OJ = parcelRequire("lH7OJ");

var $br1G4 = parcelRequire("br1G4");

var $dMbbs = parcelRequire("dMbbs");
/* eslint no-console:0 */ var $6ee37cfdf49d29b7$var$formatRegExp = /%[sdj%]/g;
var $6ee37cfdf49d29b7$export$491112666e282270 = function warning() {};
function $6ee37cfdf49d29b7$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $6ee37cfdf49d29b7$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace($6ee37cfdf49d29b7$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $6ee37cfdf49d29b7$var$isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function $6ee37cfdf49d29b7$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if ($6ee37cfdf49d29b7$var$isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function $6ee37cfdf49d29b7$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $6ee37cfdf49d29b7$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $dMbbs.default)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $6ee37cfdf49d29b7$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $6ee37cfdf49d29b7$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $dMbbs.default)(objArr[k] || []));
    });
    return ret;
}
var $6ee37cfdf49d29b7$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $9nc35.default)(AsyncValidationError, _Error);
    var _super = (0, $lriWM.default)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $dYVVZ.default)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "errors", void 0);
        (0, $br1G4.default)((0, $1FDZu.default)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $hevvH.default)(AsyncValidationError);
}(/*#__PURE__*/ (0, $lH7OJ.default)(Error));
function $6ee37cfdf49d29b7$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $6ee37cfdf49d29b7$export$188f48b73534b6f0(errors, $6ee37cfdf49d29b7$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $6ee37cfdf49d29b7$var$flattenObjArr(objArr);
            $6ee37cfdf49d29b7$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $6ee37cfdf49d29b7$export$188f48b73534b6f0(results, $6ee37cfdf49d29b7$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $6ee37cfdf49d29b7$var$asyncSerialArray(arr, func, next);
            else $6ee37cfdf49d29b7$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $6ee37cfdf49d29b7$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $6ee37cfdf49d29b7$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $6ee37cfdf49d29b7$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $6ee37cfdf49d29b7$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($6ee37cfdf49d29b7$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $6ee37cfdf49d29b7$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $7IgoF.default)(value) === 'object' && (0, $7IgoF.default)(target[s]) === 'object') target[s] = (0, $4f2X8.default)((0, $4f2X8.default)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}

});
parcelRegister("lH7OJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcb3ad728c6418cc$export$2e2bcd8739ae039);

var $9g5l6 = parcelRequire("9g5l6");

var $3AEpF = parcelRequire("3AEpF");

var $bmnOD = parcelRequire("bmnOD");

var $4y4XI = parcelRequire("4y4XI");
function $fcb3ad728c6418cc$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $fcb3ad728c6418cc$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $bmnOD.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $4y4XI.default)(t, arguments, (0, $9g5l6.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $3AEpF.default)(Wrapper, t);
    }, $fcb3ad728c6418cc$export$2e2bcd8739ae039(t);
}

});
parcelRegister("bmnOD", function(module, exports) {

$parcel$export(module.exports, "default", () => $84543916b471405a$export$2e2bcd8739ae039);
function $84543916b471405a$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("4y4XI", function(module, exports) {

$parcel$export(module.exports, "default", () => $34fe2fcb4e5338ae$export$2e2bcd8739ae039);

var $fo3td = parcelRequire("fo3td");

var $3AEpF = parcelRequire("3AEpF");
function $34fe2fcb4e5338ae$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $fo3td.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $3AEpF.default)(p, r.prototype), p;
}

});



parcelRegister("cY1eH", function(module, exports) {

$parcel$export(module.exports, "default", () => $970c0c15dc29b0ca$export$2e2bcd8739ae039);

var $7rX2B = parcelRequire("7rX2B");

var $9GlGq = parcelRequire("9GlGq");

var $20ddX = parcelRequire("20ddX");

var $jZiV3 = parcelRequire("jZiV3");

var $Vymmy = parcelRequire("Vymmy");

var $hytM4 = parcelRequire("hytM4");

var $iCsiQ = parcelRequire("iCsiQ");

var $lRxK8 = parcelRequire("lRxK8");

var $3VQa9 = parcelRequire("3VQa9");

var $9n9Rk = parcelRequire("9n9Rk");

var $jHWX1 = parcelRequire("jHWX1");

var $1Xb8X = parcelRequire("1Xb8X");

var $j98pW = parcelRequire("j98pW");

var $eJ6fY = parcelRequire("eJ6fY");

var $iDRwX = parcelRequire("iDRwX");
var $970c0c15dc29b0ca$export$2e2bcd8739ae039 = {
    string: (0, $eJ6fY.default),
    method: (0, $lRxK8.default),
    number: (0, $3VQa9.default),
    boolean: (0, $20ddX.default),
    regexp: (0, $1Xb8X.default),
    integer: (0, $iCsiQ.default),
    float: (0, $hytM4.default),
    array: (0, $9GlGq.default),
    object: (0, $9n9Rk.default),
    enum: (0, $Vymmy.default),
    pattern: (0, $jHWX1.default),
    date: (0, $jZiV3.default),
    url: (0, $iDRwX.default),
    hex: (0, $iDRwX.default),
    email: (0, $iDRwX.default),
    required: (0, $j98pW.default),
    any: (0, $7rX2B.default)
};

});
parcelRegister("7rX2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $56c8da588149fdc6$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $56c8da588149fdc6$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $56c8da588149fdc6$export$2e2bcd8739ae039 = $56c8da588149fdc6$var$any;

});
parcelRegister("1kAnp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f83e054747dbab9$export$2e2bcd8739ae039);

var $fhUVb = parcelRequire("fhUVb");

var $875ZY = parcelRequire("875ZY");

var $c8O7x = parcelRequire("c8O7x");

var $fLAq4 = parcelRequire("fLAq4");

var $czBl8 = parcelRequire("czBl8");

var $itsf6 = parcelRequire("itsf6");
var $0f83e054747dbab9$export$2e2bcd8739ae039 = {
    required: (0, $fLAq4.default),
    whitespace: (0, $itsf6.default),
    type: (0, $czBl8.default),
    range: (0, $c8O7x.default),
    enum: (0, $fhUVb.default),
    pattern: (0, $875ZY.default)
};

});
parcelRegister("fhUVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21498ec26a65fa8$export$2e2bcd8739ae039);

var $9wfY2 = parcelRequire("9wfY2");
var $b21498ec26a65fa8$var$ENUM = 'enum';
var $b21498ec26a65fa8$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$b21498ec26a65fa8$var$ENUM] = Array.isArray(rule[$b21498ec26a65fa8$var$ENUM]) ? rule[$b21498ec26a65fa8$var$ENUM] : [];
    if (rule[$b21498ec26a65fa8$var$ENUM].indexOf(value) === -1) errors.push((0, $9wfY2.format)(options.messages[$b21498ec26a65fa8$var$ENUM], rule.fullField, rule[$b21498ec26a65fa8$var$ENUM].join(', ')));
};
var $b21498ec26a65fa8$export$2e2bcd8739ae039 = $b21498ec26a65fa8$var$enumerable;

});

parcelRegister("875ZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e83a1644b7bdfa7$export$2e2bcd8739ae039);

var $9wfY2 = parcelRequire("9wfY2");
var $5e83a1644b7bdfa7$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $9wfY2.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $9wfY2.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $5e83a1644b7bdfa7$export$2e2bcd8739ae039 = $5e83a1644b7bdfa7$var$pattern;

});

parcelRegister("c8O7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d6d1c508ee41bf0$export$2e2bcd8739ae039);

var $9wfY2 = parcelRequire("9wfY2");
var $8d6d1c508ee41bf0$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, $9wfY2.format)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $9wfY2.format)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $9wfY2.format)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $9wfY2.format)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $8d6d1c508ee41bf0$export$2e2bcd8739ae039 = $8d6d1c508ee41bf0$var$range;

});

parcelRegister("fLAq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a77ef4cc752a2a$export$2e2bcd8739ae039);

var $9wfY2 = parcelRequire("9wfY2");
var $b7a77ef4cc752a2a$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $9wfY2.isEmptyValue)(value, type || rule.type))) errors.push((0, $9wfY2.format)(options.messages.required, rule.fullField));
};
var $b7a77ef4cc752a2a$export$2e2bcd8739ae039 = $b7a77ef4cc752a2a$var$required;

});

parcelRegister("czBl8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9275b7dd5cc8c1ee$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $9wfY2 = parcelRequire("9wfY2");

var $fLAq4 = parcelRequire("fLAq4");

var $9e7Bu = parcelRequire("9e7Bu");
/* eslint max-len:0 */ var $9275b7dd5cc8c1ee$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $9275b7dd5cc8c1ee$var$types = {
    integer: function integer(value) {
        return $9275b7dd5cc8c1ee$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $9275b7dd5cc8c1ee$var$types.number(value) && !$9275b7dd5cc8c1ee$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, $7IgoF.default)(value) === 'object' && !$9275b7dd5cc8c1ee$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match($9275b7dd5cc8c1ee$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, $9e7Bu.default)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match($9275b7dd5cc8c1ee$var$pattern.hex);
    }
};
var $9275b7dd5cc8c1ee$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $fLAq4.default)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$9275b7dd5cc8c1ee$var$types[ruleType](value)) errors.push((0, $9wfY2.format)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $7IgoF.default)(value) !== rule.type) errors.push((0, $9wfY2.format)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $9275b7dd5cc8c1ee$export$2e2bcd8739ae039 = $9275b7dd5cc8c1ee$var$type;

});
parcelRegister("9e7Bu", function(module, exports) {

$parcel$export(module.exports, "default", () => $01bbcba44529a2d2$export$2e2bcd8739ae039);
// https://github.com/kevva/url-regex/blob/master/index.js
var $01bbcba44529a2d2$var$urlReg;
var $01bbcba44529a2d2$export$2e2bcd8739ae039 = function() {
    if ($01bbcba44529a2d2$var$urlReg) return $01bbcba44529a2d2$var$urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $01bbcba44529a2d2$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return $01bbcba44529a2d2$var$urlReg;
};

});


parcelRegister("itsf6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d730d7cf007d1ae5$export$2e2bcd8739ae039);

var $9wfY2 = parcelRequire("9wfY2");
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $d730d7cf007d1ae5$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, $9wfY2.format)(options.messages.whitespace, rule.fullField));
};
var $d730d7cf007d1ae5$export$2e2bcd8739ae039 = $d730d7cf007d1ae5$var$whitespace;

});



parcelRegister("9GlGq", function(module, exports) {

$parcel$export(module.exports, "default", () => $70c8db2378e839bd$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");
var $70c8db2378e839bd$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, $1kAnp.default).type(rule, value, source, errors, options);
            (0, $1kAnp.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $70c8db2378e839bd$export$2e2bcd8739ae039 = $70c8db2378e839bd$var$array;

});

parcelRegister("20ddX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1755d6e0b51baf82$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $1755d6e0b51baf82$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $1kAnp.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $1755d6e0b51baf82$export$2e2bcd8739ae039 = $1755d6e0b51baf82$var$boolean;

});

parcelRegister("jZiV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d263c419ff4c2a$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $e8d263c419ff4c2a$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value, 'date') && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (!(0, $9wfY2.isEmptyValue)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $1kAnp.default).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $1kAnp.default).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $e8d263c419ff4c2a$export$2e2bcd8739ae039 = $e8d263c419ff4c2a$var$date;

});

parcelRegister("Vymmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acffa1aac6dbe0f$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $0acffa1aac6dbe0f$var$ENUM = 'enum';
var $0acffa1aac6dbe0f$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $1kAnp.default)[$0acffa1aac6dbe0f$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $0acffa1aac6dbe0f$export$2e2bcd8739ae039 = $0acffa1aac6dbe0f$var$enumerable;

});

parcelRegister("hytM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7cb5332d90a115$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $cc7cb5332d90a115$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $1kAnp.default).type(rule, value, source, errors, options);
            (0, $1kAnp.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $cc7cb5332d90a115$export$2e2bcd8739ae039 = $cc7cb5332d90a115$var$floatFn;

});

parcelRegister("iCsiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e1baf504ff3d94$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $d8e1baf504ff3d94$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $1kAnp.default).type(rule, value, source, errors, options);
            (0, $1kAnp.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $d8e1baf504ff3d94$export$2e2bcd8739ae039 = $d8e1baf504ff3d94$var$integer;

});

parcelRegister("lRxK8", function(module, exports) {

$parcel$export(module.exports, "default", () => $041b7eda4d6a93e7$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $041b7eda4d6a93e7$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $1kAnp.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $041b7eda4d6a93e7$export$2e2bcd8739ae039 = $041b7eda4d6a93e7$var$method;

});

parcelRegister("3VQa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dcf286202a57ad4$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $2dcf286202a57ad4$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $1kAnp.default).type(rule, value, source, errors, options);
            (0, $1kAnp.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $2dcf286202a57ad4$export$2e2bcd8739ae039 = $2dcf286202a57ad4$var$number;

});

parcelRegister("9n9Rk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2de8da7f1ffe1e$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $6d2de8da7f1ffe1e$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $1kAnp.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $6d2de8da7f1ffe1e$export$2e2bcd8739ae039 = $6d2de8da7f1ffe1e$var$object;

});

parcelRegister("jHWX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58fc2e8583e4256$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $e58fc2e8583e4256$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (!(0, $9wfY2.isEmptyValue)(value, 'string')) (0, $1kAnp.default).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $e58fc2e8583e4256$export$2e2bcd8739ae039 = $e58fc2e8583e4256$var$pattern;

});

parcelRegister("1Xb8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c3f201ba1f2813$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $16c3f201ba1f2813$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options);
        if (!(0, $9wfY2.isEmptyValue)(value)) (0, $1kAnp.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $16c3f201ba1f2813$export$2e2bcd8739ae039 = $16c3f201ba1f2813$var$regexp;

});

parcelRegister("j98pW", function(module, exports) {

$parcel$export(module.exports, "default", () => $df05631ecaa50976$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");

var $1kAnp = parcelRequire("1kAnp");
var $df05631ecaa50976$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, $7IgoF.default)(value);
    (0, $1kAnp.default).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $df05631ecaa50976$export$2e2bcd8739ae039 = $df05631ecaa50976$var$required;

});

parcelRegister("eJ6fY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8a1f146deb74ee$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $ab8a1f146deb74ee$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options, 'string');
        if (!(0, $9wfY2.isEmptyValue)(value, 'string')) {
            (0, $1kAnp.default).type(rule, value, source, errors, options);
            (0, $1kAnp.default).range(rule, value, source, errors, options);
            (0, $1kAnp.default).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $1kAnp.default).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $ab8a1f146deb74ee$export$2e2bcd8739ae039 = $ab8a1f146deb74ee$var$string;

});

parcelRegister("iDRwX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92564965be3128e$export$2e2bcd8739ae039);

var $1kAnp = parcelRequire("1kAnp");

var $9wfY2 = parcelRequire("9wfY2");
var $d92564965be3128e$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $9wfY2.isEmptyValue)(value, ruleType) && !rule.required) return callback();
        (0, $1kAnp.default).required(rule, value, source, errors, options, ruleType);
        if (!(0, $9wfY2.isEmptyValue)(value, ruleType)) (0, $1kAnp.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $d92564965be3128e$export$2e2bcd8739ae039 = $d92564965be3128e$var$type;

});


parcelRegister("3X5Ez", function(module, exports) {

});


parcelRegister("9zgy7", function(module, exports) {

$parcel$export(module.exports, "defaultValidateMessages", () => $6f74384e9535d1a7$export$c86b939816b8fbf8);
var $6f74384e9535d1a7$var$typeTemplate = "'${name}' is not a valid ${type}";
var $6f74384e9535d1a7$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $6f74384e9535d1a7$var$typeTemplate,
        method: $6f74384e9535d1a7$var$typeTemplate,
        array: $6f74384e9535d1a7$var$typeTemplate,
        object: $6f74384e9535d1a7$var$typeTemplate,
        number: $6f74384e9535d1a7$var$typeTemplate,
        date: $6f74384e9535d1a7$var$typeTemplate,
        boolean: $6f74384e9535d1a7$var$typeTemplate,
        integer: $6f74384e9535d1a7$var$typeTemplate,
        float: $6f74384e9535d1a7$var$typeTemplate,
        regexp: $6f74384e9535d1a7$var$typeTemplate,
        email: $6f74384e9535d1a7$var$typeTemplate,
        url: $6f74384e9535d1a7$var$typeTemplate,
        hex: $6f74384e9535d1a7$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

});


parcelRegister("fFsAH", function(module, exports) {

$parcel$export(module.exports, "getNamePath", () => $b680dce7b4d4bd22$export$f877b3cb4cb4ccf9);
$parcel$export(module.exports, "cloneByNamePathList", () => $b680dce7b4d4bd22$export$f5be6dfb30403c59);
$parcel$export(module.exports, "containsNamePath", () => $b680dce7b4d4bd22$export$646d5504364ae55b);
$parcel$export(module.exports, "matchNamePath", () => $b680dce7b4d4bd22$export$325a4bd0e71bdc3a);
$parcel$export(module.exports, "isSimilar", () => $b680dce7b4d4bd22$export$dfcec05bb7372a54);
$parcel$export(module.exports, "defaultGetValueFromEvent", () => $b680dce7b4d4bd22$export$6eeac3c5b406fb30);
$parcel$export(module.exports, "move", () => $b680dce7b4d4bd22$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "getValue", () => (parcelRequire("fGBDZ")).default);
$parcel$export(module.exports, "setValue", () => (parcelRequire("acNyW")).default);

var $dMbbs = parcelRequire("dMbbs");

var $7IgoF = parcelRequire("7IgoF");

var $fGBDZ = parcelRequire("fGBDZ");

var $acNyW = parcelRequire("acNyW");

var $4LGsO = parcelRequire("4LGsO");
function $b680dce7b4d4bd22$export$f877b3cb4cb4ccf9(path) {
    return (0, $4LGsO.toArray)(path);
}
function $b680dce7b4d4bd22$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $fGBDZ.default)(store, namePath);
        newStore = (0, $acNyW.default)(newStore, namePath, value);
    });
    return newStore;
}
function $b680dce7b4d4bd22$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $b680dce7b4d4bd22$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $b680dce7b4d4bd22$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $b680dce7b4d4bd22$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $7IgoF.default)(source) !== 'object' || (0, $7IgoF.default)(target) !== 'object') return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $dMbbs.default)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function $b680dce7b4d4bd22$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $7IgoF.default)(event.target) === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $b680dce7b4d4bd22$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $dMbbs.default)(array.slice(0, toIndex)), [
        item
    ], (0, $dMbbs.default)(array.slice(toIndex, moveIndex)), (0, $dMbbs.default)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $dMbbs.default)(array.slice(0, moveIndex)), (0, $dMbbs.default)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $dMbbs.default)(array.slice(toIndex + 1, length)));
    return array;
}

});


parcelRegister("enPe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a78af307792dcea7$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $i7X5i = parcelRequire("i7X5i");

var $lJsob = parcelRequire("lJsob");

var $5nc8d = parcelRequire("5nc8d");

var $fFsAH = parcelRequire("fFsAH");

var $hskPh = parcelRequire("hskPh");
function $a78af307792dcea7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $aqdBs.useContext((0, $lJsob.default));
    var wrapperListContext = $aqdBs.useContext((0, $hskPh.default));
    var keyRef = $aqdBs.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $aqdBs.useMemo(function() {
        var parentPrefixName = (0, $fFsAH.getNamePath)(context.prefixName) || [];
        return [].concat((0, $dMbbs.default)(parentPrefixName), (0, $dMbbs.default)((0, $fFsAH.getNamePath)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $aqdBs.useMemo(function() {
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $aqdBs.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, $i7X5i.default)(false, 'Form.List only accepts function as children.');
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $aqdBs.createElement((0, $hskPh.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $lJsob.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $5nc8d.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $dMbbs.default)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $dMbbs.default)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $dMbbs.default)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $dMbbs.default)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $dMbbs.default)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $dMbbs.default)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $fFsAH.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $fFsAH.move)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $a78af307792dcea7$export$2e2bcd8739ae039 = $a78af307792dcea7$var$List;

});

parcelRegister("8CXnA", function(module, exports) {

$parcel$export(module.exports, "default", () => $647feed551ef71fd$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $dMbbs = parcelRequire("dMbbs");

var $7IgoF = parcelRequire("7IgoF");

var $hevvH = parcelRequire("hevvH");

var $dYVVZ = parcelRequire("dYVVZ");

var $br1G4 = parcelRequire("br1G4");

var $acNyW = parcelRequire("acNyW");

var $i7X5i = parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $lJsob = parcelRequire("lJsob");

var $guxke = parcelRequire("guxke");

var $9zgy7 = parcelRequire("9zgy7");

var $5L5FI = parcelRequire("5L5FI");

var $fFsAH = parcelRequire("fFsAH");
var $fGBDZ = parcelRequire("fGBDZ");
var $acNyW = parcelRequire("acNyW");
var $647feed551ef71fd$var$_excluded = [
    "name"
];
var $647feed551ef71fd$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $hevvH.default)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $dYVVZ.default)(this, FormStore);
    (0, $br1G4.default)(this, "formHooked", false);
    (0, $br1G4.default)(this, "forceRootUpdate", void 0);
    (0, $br1G4.default)(this, "subscribable", true);
    (0, $br1G4.default)(this, "store", {});
    (0, $br1G4.default)(this, "fieldEntities", []);
    (0, $br1G4.default)(this, "initialValues", {});
    (0, $br1G4.default)(this, "callbacks", {});
    (0, $br1G4.default)(this, "validateMessages", null);
    (0, $br1G4.default)(this, "preserve", null);
    (0, $br1G4.default)(this, "lastValidatePromise", null);
    (0, $br1G4.default)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $br1G4.default)(this, "getInternalHooks", function(key) {
        if (key === (0, $lJsob.HOOK_MARK)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $i7X5i.default)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    });
    (0, $br1G4.default)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $br1G4.default)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $br1G4.default)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $acNyW.merge)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $acNyW.default)(nextStore, namePath, (0, $fGBDZ.default)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $br1G4.default)(this, "destroyForm", function(clearOnDestroy) {
        if (clearOnDestroy) // destroy form reset store
        _this.updateStore({});
        else {
            // Fill preserve fields
            var prevWithoutPreserves = new (0, $5L5FI.default)();
            _this.getFieldEntities(true).forEach(function(entity) {
                if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            _this.prevWithoutPreserves = prevWithoutPreserves;
        }
    });
    (0, $br1G4.default)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $fGBDZ.default)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $acNyW.merge)(initValue) : initValue;
    });
    (0, $br1G4.default)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $br1G4.default)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $br1G4.default)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $br1G4.default)(this, "watchList", []);
    (0, $br1G4.default)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $br1G4.default)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $br1G4.default)(this, "timeoutId", null);
    (0, $br1G4.default)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $br1G4.default)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $br1G4.default)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $br1G4.default)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $5L5FI.default)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $br1G4.default)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $fFsAH.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $fFsAH.getNamePath)(name)
            };
        });
    });
    (0, $br1G4.default)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $7IgoF.default)(nameList) === 'object') {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = 'INVALIDATE_NAME_PATH' in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $fFsAH.cloneByNamePathList)(_this.store, filteredNameList.map((0, $fFsAH.getNamePath)));
    });
    (0, $br1G4.default)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $fFsAH.getNamePath)(name);
        return (0, $fGBDZ.default)(_this.store, namePath);
    });
    (0, $br1G4.default)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !('INVALIDATE_NAME_PATH' in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $fFsAH.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $br1G4.default)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $fFsAH.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $br1G4.default)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $fFsAH.getNamePath)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $br1G4.default)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $fFsAH.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $fFsAH.getNamePath));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(function(entity) {
            return isFieldTouched(entity) || entity.isList();
        }) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $5L5FI.default)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $dMbbs.default)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $br1G4.default)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $br1G4.default)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $fFsAH.getNamePath));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $fFsAH.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $br1G4.default)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $br1G4.default)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $5L5FI.default)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $i7X5i.default)(false, "Form already set 'initialValues' with path '".concat(namePath.join('.'), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $i7X5i.default)(false, "Multiple Field with path '".concat(namePath.join('.'), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $acNyW.default)(_this.store, namePath, (0, $dMbbs.default)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $dMbbs.default)((0, $dMbbs.default)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $br1G4.default)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $acNyW.merge)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $fFsAH.getNamePath));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $acNyW.default)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        _this.notifyWatch(namePathList);
    });
    (0, $br1G4.default)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $aX4Fp.default)(fieldData, $647feed551ef71fd$var$_excluded);
            var namePath = (0, $fFsAH.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) _this.updateStore((0, $acNyW.default)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $br1G4.default)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $4f2X8.default)((0, $4f2X8.default)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $br1G4.default)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $fGBDZ.default)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $acNyW.default)(_this.store, namePath, initialValue));
        }
    });
    (0, $br1G4.default)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $br1G4.default)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $fFsAH.matchNamePath)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $acNyW.default)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $br1G4.default)(this, "dispatch", function(action) {
        switch(action.type){
            case 'updateValue':
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case 'validateField':
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $br1G4.default)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $4f2X8.default)((0, $4f2X8.default)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $br1G4.default)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath
            ].concat((0, $dMbbs.default)(childrenFields))
        });
        return childrenFields;
    });
    (0, $br1G4.default)(this, "updateValue", function(name, value) {
        var namePath = (0, $fFsAH.getNamePath)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $acNyW.default)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $fFsAH.cloneByNamePathList)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $dMbbs.default)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $br1G4.default)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $acNyW.merge)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        _this.notifyWatch();
    });
    (0, $br1G4.default)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: []
            }
        ]);
    });
    (0, $br1G4.default)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $5L5FI.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $fFsAH.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $br1G4.default)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $5L5FI.default)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $fFsAH.containsNamePath)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $br1G4.default)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $fFsAH.getNamePath)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $fFsAH.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $4f2X8.default)({
                    validateMessages: (0, $4f2X8.default)((0, $4f2X8.default)({}, (0, $9zgy7.defaultValidateMessages)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $dMbbs.default)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $dMbbs.default)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $guxke.allPromiseFinish)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $br1G4.default)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $647feed551ef71fd$var$useForm(form) {
    var formRef = $aqdBs.useRef();
    var _React$useState = $aqdBs.useState({}), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $647feed551ef71fd$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $647feed551ef71fd$export$2e2bcd8739ae039 = $647feed551ef71fd$var$useForm;

});
parcelRegister("guxke", function(module, exports) {

$parcel$export(module.exports, "allPromiseFinish", () => $c0194c6a131ffdb7$export$6152adfdcc6be2b5);
function $c0194c6a131ffdb7$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

});

parcelRegister("5L5FI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4315bdddd48b9f92$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");

var $dMbbs = parcelRequire("dMbbs");

var $dYVVZ = parcelRequire("dYVVZ");

var $hevvH = parcelRequire("hevvH");

var $br1G4 = parcelRequire("br1G4");

var $7IgoF = parcelRequire("7IgoF");
var $4315bdddd48b9f92$var$SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $4315bdddd48b9f92$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $7IgoF.default)(cell), ":").concat(cell);
    })// Magic split
    .join($4315bdddd48b9f92$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $4315bdddd48b9f92$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $dYVVZ.default)(this, NameMap);
        (0, $br1G4.default)(this, "kvs", new Map());
    }
    (0, $hevvH.default)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($4315bdddd48b9f92$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($4315bdddd48b9f92$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($4315bdddd48b9f92$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $dMbbs.default)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $kelIR.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($4315bdddd48b9f92$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $kelIR.default)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === 'number' ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join('.')] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $4315bdddd48b9f92$export$2e2bcd8739ae039 = $4315bdddd48b9f92$var$NameMap;

});


parcelRegister("56Hbl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7f0254e1115859$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $8CXnA = parcelRequire("8CXnA");

var $lJsob = parcelRequire("lJsob");

var $dc7XZ = parcelRequire("dc7XZ");

var $fFsAH = parcelRequire("fFsAH");

var $hskPh = parcelRequire("hskPh");
var $3b7f0254e1115859$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed",
    "clearOnDestroy"
];
var $3b7f0254e1115859$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? 'form' : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? 'onChange' : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = (0, $aX4Fp.default)(_ref, $3b7f0254e1115859$var$_excluded);
    var nativeElementRef = $aqdBs.useRef(null);
    var formContext = $aqdBs.useContext((0, $dc7XZ.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $8CXnA.default)(form), _useForm2 = (0, $kelIR.default)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $lJsob.HOOK_MARK)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $aqdBs.useImperativeHandle(ref, function() {
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, formInstance), {}, {
            nativeElement: nativeElementRef.current
        });
    });
    // Register form into Context
    $aqdBs.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $4f2X8.default)((0, $4f2X8.default)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $aqdBs.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $aqdBs.useEffect(function() {
        return function() {
            return destroyForm(clearOnDestroy);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $aqdBs.useRef();
    $aqdBs.useEffect(function() {
        if (!(0, $fFsAH.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $aqdBs.useMemo(function() {
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $aqdBs.createElement((0, $hskPh.default).Provider, {
        value: null
    }, /*#__PURE__*/ $aqdBs.createElement((0, $lJsob.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $aqdBs.createElement(Component, (0, $13KW1.default)({}, restProps, {
        ref: nativeElementRef,
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $3b7f0254e1115859$export$2e2bcd8739ae039 = $3b7f0254e1115859$var$Form;

});
parcelRegister("dc7XZ", function(module, exports) {

$parcel$export(module.exports, "FormProvider", () => $99b2935424312856$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "default", () => $99b2935424312856$export$2e2bcd8739ae039);

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");
var $99b2935424312856$var$FormContext = /*#__PURE__*/ $aqdBs.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $99b2935424312856$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $aqdBs.useContext($99b2935424312856$var$FormContext);
    var formsRef = $aqdBs.useRef({});
    return /*#__PURE__*/ $aqdBs.createElement($99b2935424312856$var$FormContext.Provider, {
        value: (0, $4f2X8.default)((0, $4f2X8.default)({}, formContext), {}, {
            validateMessages: (0, $4f2X8.default)((0, $4f2X8.default)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $4f2X8.default)((0, $4f2X8.default)({}, formsRef.current), {}, (0, $br1G4.default)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $4f2X8.default)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $99b2935424312856$export$2e2bcd8739ae039 = $99b2935424312856$var$FormContext;

});


parcelRegister("8nPZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a8cd43da86a01f$export$2e2bcd8739ae039);

var $kelIR = parcelRequire("kelIR");
parcelRequire("i7X5i");

var $aqdBs = parcelRequire("aqdBs");

var $lJsob = parcelRequire("lJsob");

var $4LGsO = parcelRequire("4LGsO");

var $fFsAH = parcelRequire("fFsAH");
var $fGBDZ = parcelRequire("fGBDZ");
function $61a8cd43da86a01f$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $61a8cd43da86a01f$var$useWatchWarning = function() {};
// ------- selector type -------
// ------- selector type end -------
function $61a8cd43da86a01f$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $4LGsO.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $aqdBs.useState)(), _useState2 = (0, $kelIR.default)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $aqdBs.useMemo)(function() {
        return $61a8cd43da86a01f$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $aqdBs.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $aqdBs.useContext)((0, $lJsob.default));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $fFsAH.getNamePath)(dependencies);
    var namePathRef = (0, $aqdBs.useRef)(namePath);
    namePathRef.current = namePath;
    $61a8cd43da86a01f$var$useWatchWarning(namePath);
    (0, $aqdBs.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $lJsob.HOOK_MARK)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === 'function' ? dependencies(watchValue) : (0, $fGBDZ.default)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $61a8cd43da86a01f$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $61a8cd43da86a01f$export$2e2bcd8739ae039 = $61a8cd43da86a01f$var$useWatch;

});




parcelRegister("jHeh6", function(module, exports) {

$parcel$export(module.exports, "CONTAINER_MAX_OFFSET", () => $e56d1b2a8eaac871$export$33ada7d8845f7e5);
$parcel$export(module.exports, "useZIndex", () => $e56d1b2a8eaac871$export$3e7906d4075187a4);

var $aqdBs = parcelRequire("aqdBs");

var $jygCN = parcelRequire("jygCN");


var $jaW1p = parcelRequire("jaW1p");
// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $e56d1b2a8eaac871$var$CONTAINER_OFFSET = 100;
const $e56d1b2a8eaac871$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $e56d1b2a8eaac871$export$33ada7d8845f7e5 = $e56d1b2a8eaac871$var$CONTAINER_OFFSET * $e56d1b2a8eaac871$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $e56d1b2a8eaac871$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $e56d1b2a8eaac871$export$33ada7d8845f7e5 + $e56d1b2a8eaac871$var$CONTAINER_OFFSET;
const $e56d1b2a8eaac871$export$1658852af8bb2a55 = {
    Modal: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    Drawer: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    Popover: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    Popconfirm: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    Tooltip: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    Tour: $e56d1b2a8eaac871$var$CONTAINER_OFFSET,
    FloatButton: $e56d1b2a8eaac871$var$CONTAINER_OFFSET
};
const $e56d1b2a8eaac871$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $e56d1b2a8eaac871$var$isContainerType(type) {
    return type in $e56d1b2a8eaac871$export$1658852af8bb2a55;
}
const $e56d1b2a8eaac871$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $jygCN.default)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $jaW1p.default));
    const isContainer = $e56d1b2a8eaac871$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $e56d1b2a8eaac871$export$1658852af8bb2a55[componentType];
        else zIndex += $e56d1b2a8eaac871$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};

});
parcelRegister("jaW1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5bf56146b446d3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
const $df5bf56146b446d3$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(undefined);
var $df5bf56146b446d3$export$2e2bcd8739ae039 = $df5bf56146b446d3$var$zIndexContext;

});


parcelRegister("i22RA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d20aa27dda8553a9$export$2e2bcd8739ae039);

var $kpffc = parcelRequire("kpffc");
function $d20aa27dda8553a9$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $d20aa27dda8553a9$var$PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const $d20aa27dda8553a9$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const $d20aa27dda8553a9$var$DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function $d20aa27dda8553a9$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    Object.keys($d20aa27dda8553a9$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $d20aa27dda8553a9$var$ArrowCenterPlacementAlignMap[key] || $d20aa27dda8553a9$var$PlacementAlignMap[key];
        const placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($d20aa27dda8553a9$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        // Dynamic offset
        const arrowOffset = (0, $kpffc.getArrowOffsetToken)({
            contentRadius: borderRadius,
            limitVerticalRadius: true
        });
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $d20aa27dda8553a9$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}

});
parcelRegister("kpffc", function(module, exports) {

$parcel$export(module.exports, "MAX_VERTICAL_CONTENT_RADIUS", () => $edb1f7a00b7cddc3$export$de6e4ffc9ec3c089);
$parcel$export(module.exports, "getArrowOffsetToken", () => $edb1f7a00b7cddc3$export$bddc192327bb9823);
$parcel$export(module.exports, "default", () => $edb1f7a00b7cddc3$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $l2rZk = parcelRequire("l2rZk");
const $edb1f7a00b7cddc3$export$de6e4ffc9ec3c089 = 8;
function $edb1f7a00b7cddc3$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $edb1f7a00b7cddc3$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $edb1f7a00b7cddc3$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $edb1f7a00b7cddc3$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                Object.assign(Object.assign({
                    position: 'absolute',
                    zIndex: 1,
                    display: 'block'
                }, (0, $l2rZk.genRoundedArrow)(token, colorBg, boxShadowPopoverArrow)), {
                    '&:before': {
                        background: colorBg
                    }
                })
            ]
        }, $edb1f7a00b7cddc3$var$isInject(!!arrowPlacement.top, {
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(',')]: {
                bottom: arrowDistance,
                transform: 'translateY(100%) rotate(180deg)'
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
            },
            '&-placement-topLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-topRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $aWTY1.unit)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $edb1f7a00b7cddc3$var$isInject(!!arrowPlacement.bottom, {
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(',')]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            '&-placement-bottomLeft': {
                '--arrow-offset-horizontal': arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            '&-placement-bottomRight': {
                '--arrow-offset-horizontal': `calc(100% - ${(0, $aWTY1.unit)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            }
        })), $edb1f7a00b7cddc3$var$isInject(!!arrowPlacement.left, {
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(',')]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(100%) rotate(90deg)'
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        })), $edb1f7a00b7cddc3$var$isInject(!!arrowPlacement.right, {
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(',')]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: 'translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: '50%'
                },
                transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }))
    };
}

});
parcelRegister("l2rZk", function(module, exports) {

$parcel$export(module.exports, "getArrowToken", () => $f50f7eb9a253f645$export$87e38ee403661ccc);
$parcel$export(module.exports, "genRoundedArrow", () => $f50f7eb9a253f645$export$601fa0375eb80eec);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
function $f50f7eb9a253f645$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $f50f7eb9a253f645$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $aWTY1.unit)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow: boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};

});



parcelRegister("2EtDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee64d9b787e1b54$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("7ruEM");
var $84bWi = parcelRequire("84bWi");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $bgU8K = parcelRequire("bgU8K");

var $hHt8P = parcelRequire("hHt8P");
"use client";
/** @private Internal Component. Do not use in your production. */ const $1ee64d9b787e1b54$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = 'top', title: title, color: color, overlayInnerStyle: overlayInnerStyle } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $bgU8K.default)(prefixCls);
    // Color
    const colorInfo = (0, $hHt8P.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $aqdBs.createElement((0, $84bWi.default), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $1ee64d9b787e1b54$export$2e2bcd8739ae039 = $1ee64d9b787e1b54$var$PurePanel;

});
parcelRegister("bgU8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $834cbc9a45381116$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $d9Xyr = parcelRequire("d9Xyr");

var $kpffc = parcelRequire("kpffc");

var $l2rZk = parcelRequire("l2rZk");

var $8NSmO = parcelRequire("8NSmO");
var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $834cbc9a45381116$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: centerAlignMinWidth,
                    minHeight: controlHeight,
                    padding: `${(0, $aWTY1.unit)(token.calc(paddingSM).div(2).equal())} ${(0, $aWTY1.unit)(paddingXS)}`,
                    color: tooltipColor,
                    textAlign: 'start',
                    textDecoration: 'none',
                    wordWrap: 'break-word',
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow: boxShadowSecondary,
                    boxSizing: 'border-box'
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $kpffc.MAX_VERTICAL_CONTENT_RADIUS))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                }
            }), (0, $8NSmO.default)(token, (colorKey, { darkColor: darkColor })=>({
                    [`&${componentCls}-${colorKey}`]: {
                        [`${componentCls}-inner`]: {
                            backgroundColor: darkColor
                        },
                        [`${componentCls}-arrow`]: {
                            '--antd-arrow-background-color': darkColor
                        }
                    }
                }))), {
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            })
        },
        // Arrow Style
        (0, $kpffc.default)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        }
    ];
};
const $834cbc9a45381116$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $kpffc.getArrowOffsetToken)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $l2rZk.getArrowToken)((0, $8Olk9.merge)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
var $834cbc9a45381116$export$2e2bcd8739ae039 = (prefixCls, injectStyle = true)=>{
    const useStyle = (0, $4wPvn.genStyleHooks)('Tooltip', (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $8Olk9.merge)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $834cbc9a45381116$var$genTooltipStyle(TooltipToken),
            (0, $d9Xyr.initZoomMotion)(token, 'zoom-big-fast')
        ];
    }, $834cbc9a45381116$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls);
};

});
parcelRegister("d9Xyr", function(module, exports) {

$parcel$export(module.exports, "zoomIn", () => $994a4fe757c9cc0c$export$3b71758b3ed5255f);
$parcel$export(module.exports, "initZoomMotion", () => $994a4fe757c9cc0c$export$f5d123412490d9dc);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $9V6Az = parcelRequire("9V6Az");
const $994a4fe757c9cc0c$export$3b71758b3ed5255f = new (0, $Zo2YC.default)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $994a4fe757c9cc0c$export$9fdb0a49c6b4b521 = new (0, $Zo2YC.default)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$export$be061d573c42e33a = new (0, $Zo2YC.default)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const $994a4fe757c9cc0c$export$582d93d613303da3 = new (0, $Zo2YC.default)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$export$45eddd18c599b827 = new (0, $Zo2YC.default)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const $994a4fe757c9cc0c$export$a85c97750adaa37a = new (0, $Zo2YC.default)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$export$bd2378f7814f5f1a = new (0, $Zo2YC.default)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const $994a4fe757c9cc0c$export$e58f88c751c4f04e = new (0, $Zo2YC.default)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$export$fee1456954aef331 = new (0, $Zo2YC.default)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const $994a4fe757c9cc0c$export$811ba6d3e2adb730 = new (0, $Zo2YC.default)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$export$633a68aa72dec21c = new (0, $Zo2YC.default)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const $994a4fe757c9cc0c$export$1cf46a906e8dede4 = new (0, $Zo2YC.default)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const $994a4fe757c9cc0c$var$zoomMotion = {
    zoom: {
        inKeyframes: $994a4fe757c9cc0c$export$3b71758b3ed5255f,
        outKeyframes: $994a4fe757c9cc0c$export$9fdb0a49c6b4b521
    },
    'zoom-big': {
        inKeyframes: $994a4fe757c9cc0c$export$be061d573c42e33a,
        outKeyframes: $994a4fe757c9cc0c$export$582d93d613303da3
    },
    'zoom-big-fast': {
        inKeyframes: $994a4fe757c9cc0c$export$be061d573c42e33a,
        outKeyframes: $994a4fe757c9cc0c$export$582d93d613303da3
    },
    'zoom-left': {
        inKeyframes: $994a4fe757c9cc0c$export$bd2378f7814f5f1a,
        outKeyframes: $994a4fe757c9cc0c$export$e58f88c751c4f04e
    },
    'zoom-right': {
        inKeyframes: $994a4fe757c9cc0c$export$fee1456954aef331,
        outKeyframes: $994a4fe757c9cc0c$export$811ba6d3e2adb730
    },
    'zoom-up': {
        inKeyframes: $994a4fe757c9cc0c$export$45eddd18c599b827,
        outKeyframes: $994a4fe757c9cc0c$export$a85c97750adaa37a
    },
    'zoom-down': {
        inKeyframes: $994a4fe757c9cc0c$export$633a68aa72dec21c,
        outKeyframes: $994a4fe757c9cc0c$export$1cf46a906e8dede4
    }
};
const $994a4fe757c9cc0c$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $994a4fe757c9cc0c$var$zoomMotion[motionName];
    return [
        (0, $9V6Az.initMotion)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};

});
parcelRegister("9V6Az", function(module, exports) {

$parcel$export(module.exports, "initMotion", () => $738e8c5166cf8f54$export$83e1da9e09ec9112);
const $738e8c5166cf8f54$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $738e8c5166cf8f54$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const $738e8c5166cf8f54$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $738e8c5166cf8f54$var$initMotionCommon(duration)), {
            animationPlayState: 'paused'
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $738e8c5166cf8f54$var$initMotionCommonLeave(duration)), {
            animationPlayState: 'paused'
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};

});


parcelRegister("8NSmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $668d1274d9fcc04c$export$2e2bcd8739ae039);

var $gGv71 = parcelRequire("gGv71");
function $668d1274d9fcc04c$export$2e2bcd8739ae039(token, genCss) {
    return (0, $gGv71.PresetColors).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}

});


parcelRegister("hHt8P", function(module, exports) {

$parcel$export(module.exports, "parseColor", () => $ce2d0eb543fb4156$export$6e865ea70d7724f);

var $bqPQ9 = parcelRequire("bqPQ9");

var $3IrVT = parcelRequire("3IrVT");
function $ce2d0eb543fb4156$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $3IrVT.isPresetColor)(color);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}

});
parcelRegister("3IrVT", function(module, exports) {

$parcel$export(module.exports, "isPresetColor", () => $2b4b2608780b0ef1$export$ee62ebd6a58c4884);

var $dMbbs = parcelRequire("dMbbs");

var $gGv71 = parcelRequire("gGv71");
const $2b4b2608780b0ef1$var$inverseColors = (0, $gGv71.PresetColors).map((color)=>`${color}-inverse`);
const $2b4b2608780b0ef1$export$bb684163c94c55ae = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function $2b4b2608780b0ef1$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $dMbbs.default)($2b4b2608780b0ef1$var$inverseColors), (0, $dMbbs.default)((0, $gGv71.PresetColors))).includes(color);
    return (0, $gGv71.PresetColors).includes(color);
}
function $2b4b2608780b0ef1$export$88a0ba1f7d1ea40e(color) {
    return $2b4b2608780b0ef1$export$bb684163c94c55ae.includes(color);
}

});




parcelRegister("8ccL3", function(module, exports) {

$parcel$export(module.exports, "slideUpIn", () => $5f795728d37d9d1c$export$e801b802b037de6a);
$parcel$export(module.exports, "slideUpOut", () => $5f795728d37d9d1c$export$f40f41df328ebc38);
$parcel$export(module.exports, "slideDownIn", () => $5f795728d37d9d1c$export$dd9f089fa5e819fe);
$parcel$export(module.exports, "slideDownOut", () => $5f795728d37d9d1c$export$f7243fdb9c27c3b7);
$parcel$export(module.exports, "initSlideMotion", () => $5f795728d37d9d1c$export$9018e60daecf7a6c);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $9V6Az = parcelRequire("9V6Az");
const $5f795728d37d9d1c$export$e801b802b037de6a = new (0, $Zo2YC.default)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $5f795728d37d9d1c$export$f40f41df328ebc38 = new (0, $Zo2YC.default)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $5f795728d37d9d1c$export$dd9f089fa5e819fe = new (0, $Zo2YC.default)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const $5f795728d37d9d1c$export$f7243fdb9c27c3b7 = new (0, $Zo2YC.default)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const $5f795728d37d9d1c$export$2ad3a07c3513a54 = new (0, $Zo2YC.default)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const $5f795728d37d9d1c$export$486fbda27512d5a9 = new (0, $Zo2YC.default)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const $5f795728d37d9d1c$export$dd03ad46dbbcd7e0 = new (0, $Zo2YC.default)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const $5f795728d37d9d1c$export$db8e3c9b93664f34 = new (0, $Zo2YC.default)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const $5f795728d37d9d1c$var$slideMotion = {
    'slide-up': {
        inKeyframes: $5f795728d37d9d1c$export$e801b802b037de6a,
        outKeyframes: $5f795728d37d9d1c$export$f40f41df328ebc38
    },
    'slide-down': {
        inKeyframes: $5f795728d37d9d1c$export$dd9f089fa5e819fe,
        outKeyframes: $5f795728d37d9d1c$export$f7243fdb9c27c3b7
    },
    'slide-left': {
        inKeyframes: $5f795728d37d9d1c$export$2ad3a07c3513a54,
        outKeyframes: $5f795728d37d9d1c$export$486fbda27512d5a9
    },
    'slide-right': {
        inKeyframes: $5f795728d37d9d1c$export$dd03ad46dbbcd7e0,
        outKeyframes: $5f795728d37d9d1c$export$db8e3c9b93664f34
    }
};
const $5f795728d37d9d1c$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $5f795728d37d9d1c$var$slideMotion[motionName];
    return [
        (0, $9V6Az.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};

});

parcelRegister("1Estt", function(module, exports) {

$parcel$export(module.exports, "default", () => $133f9d503bcc7dfa$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $iIHz4 = parcelRequire("iIHz4");


var $kjlvF = parcelRequire("kjlvF");

var $5bqsG = parcelRequire("5bqsG");

var $7ET9Q = parcelRequire("7ET9Q");

var $e5UtK = parcelRequire("e5UtK");
"use client";
var $133f9d503bcc7dfa$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $133f9d503bcc7dfa$var$_SpinSizes = [
    'small',
    'default',
    'large'
];
// Render indicator
let $133f9d503bcc7dfa$var$defaultIndicator;
function $133f9d503bcc7dfa$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $133f9d503bcc7dfa$var$Spin = (props)=>{
    var _a;
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = 'default', tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent } = props, restProps = $133f9d503bcc7dfa$var$__rest(props, [
        "prefixCls",
        "spinning",
        "delay",
        "className",
        "rootClassName",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children",
        "fullscreen",
        "indicator",
        "percent"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, indicator: contextIndicator } = (0, $kjlvF.useComponentConfig)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $7ET9Q.default)(prefixCls);
    const [spinning, setSpinning] = $aqdBs.useState(()=>customSpinning && !$133f9d503bcc7dfa$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $e5UtK.default)(spinning, percent);
    $aqdBs.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $iIHz4.debounce)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                var _a;
                (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 || _a.call(showSpinning);
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $aqdBs.useMemo(()=>typeof children !== 'undefined' && !fullscreen, [
        children,
        fullscreen
    ]);
    const spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, contextClassName, {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, !fullscreen && rootClassName, hashId, cssVarCls);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedIndicator = (_a = indicator !== null && indicator !== void 0 ? indicator : contextIndicator) !== null && _a !== void 0 ? _a : $133f9d503bcc7dfa$var$defaultIndicator;
    const mergedStyle = Object.assign(Object.assign({}, contextStyle), style);
    const spinElement = /*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, restProps, {
        style: mergedStyle,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }), /*#__PURE__*/ $aqdBs.createElement((0, $5bqsG.default), {
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${prefixCls}-text`
    }, tip) : null);
    if (isNestedPattern) return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, restProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /*#__PURE__*/ $aqdBs.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $aqdBs.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children)));
    if (fullscreen) return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls)
    }, spinElement));
    return wrapCSSVar(spinElement);
};
$133f9d503bcc7dfa$var$Spin.setDefaultIndicator = (indicator)=>{
    $133f9d503bcc7dfa$var$defaultIndicator = indicator;
};
var $133f9d503bcc7dfa$export$2e2bcd8739ae039 = $133f9d503bcc7dfa$var$Spin;

});
parcelRegister("iIHz4", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $da0e211d02f808af$export$61fc7d43ac8f84b0);
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $da0e211d02f808af$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $da0e211d02f808af$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $da0e211d02f808af$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}

});

parcelRegister("5bqsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c628194ca5a1536$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $iOHOh = parcelRequire("iOHOh");

var $emlCA = parcelRequire("emlCA");
"use client";
function $3c628194ca5a1536$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $aqdBs.isValidElement(indicator)) return (0, $iOHOh.cloneElement)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(indicator.props.className, dotClassName),
        percent: percent
    });
    return /*#__PURE__*/ $aqdBs.createElement((0, $emlCA.default), {
        prefixCls: prefixCls,
        percent: percent
    });
}

});
parcelRegister("emlCA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a743e456a6ae2acd$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eco6C = parcelRequire("eco6C");
"use client";
function $a743e456a6ae2acd$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0 } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(holderClassName, percent > 0 && hideClassName)
    }, /*#__PURE__*/ $aqdBs.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $aqdBs.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $aqdBs.createElement((0, $eco6C.default), {
        prefixCls: prefixCls,
        percent: percent
    }));
}

});
parcelRegister("eco6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a564e28e75167318$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $iEJaB = parcelRequire("iEJaB");
"use client";
const $a564e28e75167318$var$viewSize = 100;
const $a564e28e75167318$var$borderWidth = $a564e28e75167318$var$viewSize / 5;
const $a564e28e75167318$var$radius = $a564e28e75167318$var$viewSize / 2 - $a564e28e75167318$var$borderWidth / 2;
const $a564e28e75167318$var$circumference = $a564e28e75167318$var$radius * 2 * Math.PI;
const $a564e28e75167318$var$position = 50;
const $a564e28e75167318$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $aqdBs.createElement("circle", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $a564e28e75167318$var$radius,
        cx: $a564e28e75167318$var$position,
        cy: $a564e28e75167318$var$position,
        strokeWidth: $a564e28e75167318$var$borderWidth,
        style: style
    });
};
const $a564e28e75167318$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $aqdBs.useState(false);
    // ==================== Visible =====================
    (0, $iEJaB.default)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$a564e28e75167318$var$circumference / 4}`,
        strokeDasharray: `${$a564e28e75167318$var$circumference * safePtg / 100} ${$a564e28e75167318$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $aqdBs.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ $aqdBs.createElement("svg", {
        viewBox: `0 0 ${$a564e28e75167318$var$viewSize} ${$a564e28e75167318$var$viewSize}`,
        // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $aqdBs.createElement($a564e28e75167318$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $aqdBs.createElement($a564e28e75167318$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $a564e28e75167318$export$2e2bcd8739ae039 = $a564e28e75167318$var$Progress;

});



parcelRegister("7ET9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $59370e083a6af6f5$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $5kUb2 = parcelRequire("5kUb2");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $59370e083a6af6f5$var$antSpinMove = new (0, $Zo2YC.default)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const $59370e083a6af6f5$var$antRotate = new (0, $Zo2YC.default)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
const $59370e083a6af6f5$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
            position: 'absolute',
            display: 'none',
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: 'center',
            verticalAlign: 'middle',
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            '&-spinning': {
                position: 'relative',
                display: 'inline-block',
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            '&-fullscreen': {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                opacity: 0,
                visibility: 'hidden',
                transition: `all ${token.motionDurationMid}`,
                '&-show': {
                    opacity: 1,
                    visibility: 'visible'
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            '&-nested-loading': {
                position: 'relative',
                [`> div > ${componentCls}`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    '&-sm': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    '&-lg': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    transition: `opacity ${token.motionDurationSlow}`,
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: '100%',
                        height: '100%',
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // tip
            // ------------------------------
            '&-tip': {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-holder`]: {
                width: '1em',
                height: '1em',
                fontSize: token.dotSize,
                display: 'inline-block',
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: '50% 50%',
                lineHeight: 1,
                color: token.colorPrimary,
                '&-hidden': {
                    transform: 'scale(0.3)',
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: 'absolute',
                inset: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: 'relative',
                display: 'inline-block',
                fontSize: token.dotSize,
                width: '1em',
                height: '1em',
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: $59370e083a6af6f5$var$antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: $59370e083a6af6f5$var$antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeSM
                }
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeLG
                }
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: 'block'
            }
        })
    };
};
const $59370e083a6af6f5$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$59370e083a6af6f5$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Spin', (token)=>{
    const spinToken = (0, $8Olk9.merge)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $59370e083a6af6f5$var$genSpinStyle(spinToken)
    ];
}, $59370e083a6af6f5$export$9ca1be8807fe0675);

});

parcelRegister("e5UtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42d57d7299dffb3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
const $a42d57d7299dffb3$var$AUTO_INTERVAL = 200;
const $a42d57d7299dffb3$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $a42d57d7299dffb3$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $aqdBs.useState(0);
    const mockIntervalRef = $aqdBs.useRef(null);
    const isAuto = percent === 'auto';
    $aqdBs.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $a42d57d7299dffb3$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $a42d57d7299dffb3$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $a42d57d7299dffb3$var$AUTO_INTERVAL);
        }
        return ()=>{
            clearInterval(mockIntervalRef.current);
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}

});


parcelRegister("3JMMO", function(module, exports) {

$parcel$export(module.exports, "AlertContextProvider", () => $b6dcff0e484279f8$export$67cf3a21a3ed7452);
$parcel$export(module.exports, "useAlertApi", () => $b6dcff0e484279f8$export$77c330c0a17c9ae0);
$parcel$export(module.exports, "formatErrorAlert", () => $b6dcff0e484279f8$export$dcf07d093b981957);

var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");

var $bom0O = parcelRequire("bom0O");
const $b6dcff0e484279f8$var$MessageContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext(null);
const $b6dcff0e484279f8$export$67cf3a21a3ed7452 = ({ children: children })=>{
    const [messageApi, contextHolder] = (0, $bom0O.default).useMessage();
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            contextHolder,
            /*#__PURE__*/ (0, $1Ivrw.jsx)($b6dcff0e484279f8$var$MessageContext.Provider, {
                value: messageApi,
                children: children
            })
        ]
    });
};
const $b6dcff0e484279f8$export$77c330c0a17c9ae0 = ()=>{
    return (0, $aqdBs.useContext)($b6dcff0e484279f8$var$MessageContext);
};
const $b6dcff0e484279f8$export$dcf07d093b981957 = (error, prefix)=>{
    prefix = prefix ? prefix.trim() + " " : "Error: ";
    const contents = error.message || "" + error;
    if (contents.includes("\n")) return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $1Ivrw.Fragment), {
        children: [
            prefix,
            /*#__PURE__*/ (0, $1Ivrw.jsx)("pre", {
                style: {
                    alignContent: "normal",
                    textAlign: "left"
                },
                children: contents
            })
        ]
    });
    return `${prefix}: ${contents}`;
};

});
parcelRegister("bom0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $84b302bcf573dce7$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $5hCqx = parcelRequire("5hCqx");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
var $ky6DR = parcelRequire("ky6DR");

var $lxiZB = parcelRequire("lxiZB");

var $6sKmx = parcelRequire("6sKmx");

var $hyoxG = parcelRequire("hyoxG");

var $bP2Ik = parcelRequire("bP2Ik");
"use client";
let $84b302bcf573dce7$var$message = null;
let $84b302bcf573dce7$var$act = (callback)=>callback();
let $84b302bcf573dce7$var$taskQueue = [];
let $84b302bcf573dce7$var$defaultGlobalConfig = {};
function $84b302bcf573dce7$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $84b302bcf573dce7$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $84b302bcf573dce7$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
    const prefixCls = $84b302bcf573dce7$var$defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, $aqdBs.useContext)((0, $5hCqx.AppConfigContext));
    const [api, holder] = (0, $hyoxG.useInternalMessage)(Object.assign(Object.assign(Object.assign({}, messageConfig), {
        prefixCls: prefixCls
    }), appConfig.message));
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $84b302bcf573dce7$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState($84b302bcf573dce7$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($84b302bcf573dce7$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useEffect(sync, []);
    const global = (0, $ky6DR.globalConfig)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($84b302bcf573dce7$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $ky6DR.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $84b302bcf573dce7$var$flushNotice() {
    if (!$84b302bcf573dce7$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $84b302bcf573dce7$var$message = newMessage;
        // Delay render to avoid sync issue
        $84b302bcf573dce7$var$act(()=>{
            const reactRender = (0, $lxiZB.unstableSetRender)();
            reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($84b302bcf573dce7$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $84b302bcf573dce7$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$84b302bcf573dce7$var$message.instance) return;
    // >>> Execute task
    $84b302bcf573dce7$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                $84b302bcf573dce7$var$act(()=>{
                    const closeFn = $84b302bcf573dce7$var$message.instance.open(Object.assign(Object.assign({}, $84b302bcf573dce7$var$defaultGlobalConfig), task.config));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                $84b302bcf573dce7$var$act(()=>{
                    $84b302bcf573dce7$var$message === null || $84b302bcf573dce7$var$message === void 0 || $84b302bcf573dce7$var$message.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $84b302bcf573dce7$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $84b302bcf573dce7$var$message.instance)[type].apply(_message$instance, (0, $dMbbs.default)(task.args));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $84b302bcf573dce7$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $84b302bcf573dce7$var$setMessageGlobalConfig(config) {
    $84b302bcf573dce7$var$defaultGlobalConfig = Object.assign(Object.assign({}, $84b302bcf573dce7$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $84b302bcf573dce7$var$act(()=>{
        var _a;
        (_a = $84b302bcf573dce7$var$message === null || $84b302bcf573dce7$var$message === void 0 ? void 0 : $84b302bcf573dce7$var$message.sync) === null || _a === void 0 || _a.call($84b302bcf573dce7$var$message);
    });
}
function $84b302bcf573dce7$var$open(config) {
    const result = (0, $bP2Ik.wrapPromiseFn)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $84b302bcf573dce7$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $84b302bcf573dce7$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $84b302bcf573dce7$var$flushNotice();
    return result;
}
function $84b302bcf573dce7$var$typeOpen(type, args) {
    const global = (0, $ky6DR.globalConfig)();
    const result = (0, $bP2Ik.wrapPromiseFn)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $84b302bcf573dce7$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $84b302bcf573dce7$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $84b302bcf573dce7$var$flushNotice();
    return result;
}
const $84b302bcf573dce7$var$destroy = (key)=>{
    $84b302bcf573dce7$var$taskQueue.push({
        type: 'destroy',
        key: key
    });
    $84b302bcf573dce7$var$flushNotice();
};
const $84b302bcf573dce7$var$methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const $84b302bcf573dce7$var$baseStaticMethods = {
    open: $84b302bcf573dce7$var$open,
    destroy: $84b302bcf573dce7$var$destroy,
    config: $84b302bcf573dce7$var$setMessageGlobalConfig,
    useMessage: $hyoxG.default,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $6sKmx.default)
};
const $84b302bcf573dce7$var$staticMethods = $84b302bcf573dce7$var$baseStaticMethods;
$84b302bcf573dce7$var$methods.forEach((type)=>{
    $84b302bcf573dce7$var$staticMethods[type] = (...args)=>$84b302bcf573dce7$var$typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $84b302bcf573dce7$var$noop = ()=>{};
let $84b302bcf573dce7$export$71ceb3dabb09f455 = $84b302bcf573dce7$var$noop;
var $84b302bcf573dce7$var$wrapper;
let $84b302bcf573dce7$export$43de32c50edff050 = $84b302bcf573dce7$var$noop;
var $84b302bcf573dce7$export$2e2bcd8739ae039 = $84b302bcf573dce7$var$staticMethods;

});
parcelRegister("5hCqx", function(module, exports) {

$parcel$export(module.exports, "AppConfigContext", () => $3d8c5919bb0962ca$export$264c6064649f9206);

var $aqdBs = parcelRequire("aqdBs");
const $3d8c5919bb0962ca$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext({});
const $3d8c5919bb0962ca$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $3d8c5919bb0962ca$export$2e2bcd8739ae039 = $3d8c5919bb0962ca$var$AppContext;

});

parcelRegister("6sKmx", function(module, exports) {

$parcel$export(module.exports, "PureContent", () => $4b495236424917ef$export$429c001938db3a78);
$parcel$export(module.exports, "default", () => $4b495236424917ef$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $azecD = parcelRequire("azecD");

var $4l6rq = parcelRequire("4l6rq");

var $gwifb = parcelRequire("gwifb");

var $daRvi = parcelRequire("daRvi");

var $5BZxE = parcelRequire("5BZxE");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("fMNI3");
var $ldH2O = parcelRequire("ldH2O");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $6qIVk = parcelRequire("6qIVk");
"use client";
var $4b495236424917ef$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4b495236424917ef$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $aqdBs.createElement((0, $daRvi.default), null),
    success: /*#__PURE__*/ $aqdBs.createElement((0, $azecD.default), null),
    error: /*#__PURE__*/ $aqdBs.createElement((0, $4l6rq.default), null),
    warning: /*#__PURE__*/ $aqdBs.createElement((0, $gwifb.default), null),
    loading: /*#__PURE__*/ $aqdBs.createElement((0, $5BZxE.default), null)
};
const $4b495236424917ef$export$429c001938db3a78 = ({ prefixCls: prefixCls, type: type, icon: icon, children: children })=>/*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, icon || $4b495236424917ef$export$ad8f8fc3bcd61b4a[type], /*#__PURE__*/ $aqdBs.createElement("span", null, children));
/** @private Internal Component. Do not use in your production. */ const $4b495236424917ef$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, type: type, icon: icon, content: content } = props, restProps = $4b495236424917ef$var$__rest(props, [
        "prefixCls",
        "className",
        "type",
        "icon",
        "content"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6qIVk.default)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $ldH2O.default), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $aqdBs.createElement($4b495236424917ef$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon
        }, content)
    })));
};
var $4b495236424917ef$export$2e2bcd8739ae039 = $4b495236424917ef$var$PurePanel;

});
parcelRegister("azecD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b1830a16d848a98$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $3zZgy = parcelRequire("3zZgy");

var $gL7Ec = parcelRequire("gL7Ec");
var $7b1830a16d848a98$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $3zZgy.default)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ var $7b1830a16d848a98$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($7b1830a16d848a98$var$CheckCircleFilled);
var $7b1830a16d848a98$export$2e2bcd8739ae039 = $7b1830a16d848a98$var$RefIcon;

});
parcelRegister("3zZgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b42a28b91e63b3$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $29b42a28b91e63b3$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $29b42a28b91e63b3$export$2e2bcd8739ae039 = $29b42a28b91e63b3$var$CheckCircleFilled;

});


parcelRegister("4l6rq", function(module, exports) {

$parcel$export(module.exports, "default", () => $328e1eb6f05cfebb$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $5SWIR = parcelRequire("5SWIR");

var $gL7Ec = parcelRequire("gL7Ec");
var $328e1eb6f05cfebb$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $5SWIR.default)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $328e1eb6f05cfebb$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($328e1eb6f05cfebb$var$CloseCircleFilled);
var $328e1eb6f05cfebb$export$2e2bcd8739ae039 = $328e1eb6f05cfebb$var$RefIcon;

});
parcelRegister("5SWIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $448f8bfdd003c852$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $448f8bfdd003c852$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $448f8bfdd003c852$export$2e2bcd8739ae039 = $448f8bfdd003c852$var$CloseCircleFilled;

});


parcelRegister("gwifb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06dc961e724de28$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $cI8Z0 = parcelRequire("cI8Z0");

var $gL7Ec = parcelRequire("gL7Ec");
var $c06dc961e724de28$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $cI8Z0.default)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $c06dc961e724de28$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($c06dc961e724de28$var$ExclamationCircleFilled);
var $c06dc961e724de28$export$2e2bcd8739ae039 = $c06dc961e724de28$var$RefIcon;

});
parcelRegister("cI8Z0", function(module, exports) {

$parcel$export(module.exports, "default", () => $94108feffe355581$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $94108feffe355581$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $94108feffe355581$export$2e2bcd8739ae039 = $94108feffe355581$var$ExclamationCircleFilled;

});


parcelRegister("daRvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9975b6410263fd77$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $9JD8d = parcelRequire("9JD8d");

var $gL7Ec = parcelRequire("gL7Ec");
var $9975b6410263fd77$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $9JD8d.default)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $9975b6410263fd77$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($9975b6410263fd77$var$InfoCircleFilled);
var $9975b6410263fd77$export$2e2bcd8739ae039 = $9975b6410263fd77$var$RefIcon;

});
parcelRegister("9JD8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $7166abb8ab1baeac$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $7166abb8ab1baeac$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $7166abb8ab1baeac$export$2e2bcd8739ae039 = $7166abb8ab1baeac$var$InfoCircleFilled;

});


parcelRegister("fMNI3", function(module, exports) {

$parcel$export(module.exports, "useNotification", () => (parcelRequire("4R1kt")).default);
$parcel$export(module.exports, "Notice", () => (parcelRequire("ldH2O")).default);
$parcel$export(module.exports, "NotificationProvider", () => (parcelRequire("d139G")).default);

var $4R1kt = parcelRequire("4R1kt");

var $ldH2O = parcelRequire("ldH2O");

var $d139G = parcelRequire("d139G");

});
parcelRegister("4R1kt", function(module, exports) {

$parcel$export(module.exports, "default", () => $388d24a470fef80d$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $aqdBs = parcelRequire("aqdBs");

var $ly35R = parcelRequire("ly35R");
parcelRequire("2UjQ5");
var $k91S5 = parcelRequire("k91S5");
var $388d24a470fef80d$var$_excluded = [
    "getContainer",
    "motion",
    "prefixCls",
    "maxCount",
    "className",
    "style",
    "onAllRemoved",
    "stack",
    "renderNotifications"
];
var $388d24a470fef80d$var$defaultGetContainer = function defaultGetContainer() {
    return document.body;
};
var $388d24a470fef80d$var$uniqueKey = 0;
function $388d24a470fef80d$var$mergeConfig() {
    var clone = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $388d24a470fef80d$export$2e2bcd8739ae039() {
    var rootConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _rootConfig$getContai = rootConfig.getContainer, getContainer = _rootConfig$getContai === void 0 ? $388d24a470fef80d$var$defaultGetContainer : _rootConfig$getContai, motion = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className = rootConfig.className, style = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications = rootConfig.renderNotifications, shareConfig = (0, $aX4Fp.default)(rootConfig, $388d24a470fef80d$var$_excluded);
    var _React$useState = $aqdBs.useState(), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
    var notificationsRef = $aqdBs.useRef();
    var contextHolder = /*#__PURE__*/ $aqdBs.createElement((0, $ly35R.default), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    var _React$useState3 = $aqdBs.useState([]), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), taskQueue = _React$useState4[0], setTaskQueue = _React$useState4[1];
    var open = (0, $k91S5.default)(function(config) {
        var mergedConfig = $388d24a470fef80d$var$mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = "rc-notification-".concat($388d24a470fef80d$var$uniqueKey);
            $388d24a470fef80d$var$uniqueKey += 1;
        }
        setTaskQueue(function(queue) {
            return [].concat((0, $dMbbs.default)(queue), [
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
        });
    });
    // ========================= Refs =========================
    var api = $aqdBs.useMemo(function() {
        return {
            open: open,
            close: function close(key) {
                setTaskQueue(function(queue) {
                    return [].concat((0, $dMbbs.default)(queue), [
                        {
                            type: 'close',
                            key: key
                        }
                    ]);
                });
            },
            destroy: function destroy() {
                setTaskQueue(function(queue) {
                    return [].concat((0, $dMbbs.default)(queue), [
                        {
                            type: 'destroy'
                        }
                    ]);
                });
            }
        };
    }, []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $aqdBs.useEffect(function() {
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $aqdBs.useEffect(function() {
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach(function(task) {
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            var oriTaskQueue;
            var tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue(function(oriQueue) {
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter(function(task) {
                        return !taskQueue.includes(task);
                    });
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}

});
parcelRegister("ly35R", function(module, exports) {

$parcel$export(module.exports, "default", () => $faff2c3e9d7447b1$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $11utI = parcelRequire("11utI");
// ant-notification ant-notification-topRight
var $faff2c3e9d7447b1$var$Notifications = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-notification' : _props$prefixCls, container = props.container, motion = props.motion, maxCount = props.maxCount, className = props.className, style = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications = props.renderNotifications;
    var _React$useState = $aqdBs.useState([]), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
    // ======================== Close =========================
    var onNoticeClose = function onNoticeClose(key) {
        var _config$onClose;
        // Trigger close event
        var config = configList.find(function(item) {
            return item.key === key;
        });
        config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
        setConfigList(function(list) {
            return list.filter(function(item) {
                return item.key !== key;
            });
        });
    };
    // ========================= Refs =========================
    $aqdBs.useImperativeHandle(ref, function() {
        return {
            open: function open(config) {
                setConfigList(function(list) {
                    var clone = (0, $dMbbs.default)(list);
                    // Replace if exist
                    var index = clone.findIndex(function(item) {
                        return item.key === config.key;
                    });
                    var innerConfig = (0, $4f2X8.default)({}, config);
                    if (index >= 0) {
                        var _list$index;
                        innerConfig.times = (((_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: function close(key) {
                onNoticeClose(key);
            },
            destroy: function destroy() {
                setConfigList([]);
            }
        };
    });
    // ====================== Placements ======================
    var _React$useState3 = $aqdBs.useState({}), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), placements = _React$useState4[0], setPlacements = _React$useState4[1];
    $aqdBs.useEffect(function() {
        var nextPlacements = {};
        configList.forEach(function(config) {
            var _config$placement = config.placement, placement = _config$placement === void 0 ? 'topRight' : _config$placement;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach(function(placement) {
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    var onAllNoticeRemoved = function onAllNoticeRemoved(placement) {
        setPlacements(function(originPlacements) {
            var clone = (0, $4f2X8.default)({}, originPlacements);
            var list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    var emptyRef = $aqdBs.useRef(false);
    $aqdBs.useEffect(function() {
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    var placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $jVlfX.createPortal)(/*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, placementList.map(function(placement) {
        var placementConfigList = placements[placement];
        var list = /*#__PURE__*/ $aqdBs.createElement((0, $11utI.default), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className === null || className === void 0 ? void 0 : className(placement),
            style: style === null || style === void 0 ? void 0 : style(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $faff2c3e9d7447b1$export$2e2bcd8739ae039 = $faff2c3e9d7447b1$var$Notifications;

});
parcelRegister("11utI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bed86c5dcee8d87$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $dMbbs = parcelRequire("dMbbs");

var $4f2X8 = parcelRequire("4f2X8");

var $aX4Fp = parcelRequire("aX4Fp");

var $br1G4 = parcelRequire("br1G4");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("6ufPd");
var $eSxAB = parcelRequire("eSxAB");

var $ldH2O = parcelRequire("ldH2O");

var $d139G = parcelRequire("d139G");

var $dUr3F = parcelRequire("dUr3F");
var $0bed86c5dcee8d87$var$_excluded = [
    "className",
    "style",
    "classNames",
    "styles"
];
var $0bed86c5dcee8d87$var$NoticeList = function NoticeList(props) {
    var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className = props.className, style = props.style, motion = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
    var _useContext = (0, $aqdBs.useContext)((0, $d139G.NotificationContext)), ctxCls = _useContext.classNames;
    var dictRef = (0, $aqdBs.useRef)({});
    var _useState = (0, $aqdBs.useState)(null), _useState2 = (0, $kelIR.default)(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
    var _useState3 = (0, $aqdBs.useState)([]), _useState4 = (0, $kelIR.default)(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
    var keys = configList.map(function(config) {
        return {
            config: config,
            key: String(config.key)
        };
    });
    var _useStack = (0, $dUr3F.default)(stackConfig), _useStack2 = (0, $kelIR.default)(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
    var expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    var placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, $aqdBs.useEffect)(function() {
        if (stack && hoverKeys.length > 1) setHoverKeys(function(prev) {
            return prev.filter(function(key) {
                return keys.some(function(_ref) {
                    var dataKey = _ref.key;
                    return key === dataKey;
                });
            });
        });
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $aqdBs.useEffect)(function() {
        var _keys;
        if (stack && dictRef.current[(_keys = keys[keys.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
            var _keys2;
            setLatestNotice(dictRef.current[(_keys2 = keys[keys.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
        }
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $eSxAB.default), (0, $13KW1.default)({
        key: placement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: function onAllRemoved() {
            onAllNoticeRemoved(placement);
        }
    }), function(_ref2, nodeRef) {
        var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
        var _ref3 = config, key = _ref3.key, times = _ref3.times;
        var strKey = String(key);
        var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = (0, $aX4Fp.default)(_ref4, $0bed86c5dcee8d87$var$_excluded);
        var dataIndex = keys.findIndex(function(item) {
            return item.key === strKey;
        });
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        var stackStyle = {};
        if (stack) {
            var index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            var transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
                stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
                // Transform
                var verticalOffset = 0;
                for(var i = 0; i < index; i++){
                    var _dictRef$current$keys;
                    verticalOffset += ((_dictRef$current$keys = dictRef.current[keys[keys.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
                }
                var transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset * 2 * (index < 3 ? index : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
                stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
            } else stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
            ref: nodeRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
            style: (0, $4f2X8.default)((0, $4f2X8.default)((0, $4f2X8.default)({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
            onMouseEnter: function onMouseEnter() {
                return setHoverKeys(function(prev) {
                    return prev.includes(strKey) ? prev : [].concat((0, $dMbbs.default)(prev), [
                        strKey
                    ]);
                });
            },
            onMouseLeave: function onMouseLeave() {
                return setHoverKeys(function(prev) {
                    return prev.filter(function(k) {
                        return k !== strKey;
                    });
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $ldH2O.default), (0, $13KW1.default)({}, restConfig, {
            ref: function ref(node) {
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $0bed86c5dcee8d87$export$2e2bcd8739ae039 = $0bed86c5dcee8d87$var$NoticeList;

});
parcelRegister("ldH2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f72c3392a5bbba1b$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $7IgoF = parcelRequire("7IgoF");

var $kelIR = parcelRequire("kelIR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $dHI2t = parcelRequire("dHI2t");

var $aqdBs = parcelRequire("aqdBs");

var $bWa8g = parcelRequire("bWa8g");
var $f72c3392a5bbba1b$var$Notify = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, className = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, showProgress = props.showProgress, _props$pauseOnHover = props.pauseOnHover, pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? 'x' : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
    var _React$useState = $aqdBs.useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
    var _React$useState3 = $aqdBs.useState(0), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), percent = _React$useState4[0], setPercent = _React$useState4[1];
    var _React$useState5 = $aqdBs.useState(0), _React$useState6 = (0, $kelIR.default)(_React$useState5, 2), spentTime = _React$useState6[0], setSpentTime = _React$useState6[1];
    var mergedHovering = forcedHovering || hovering;
    var mergedShowProgress = duration > 0 && showProgress;
    // ======================== Close =========================
    var onInternalClose = function onInternalClose() {
        onNoticeClose(eventKey);
    };
    var onCloseKeyDown = function onCloseKeyDown(e) {
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, $dHI2t.default).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $aqdBs.useEffect(function() {
        if (!mergedHovering && duration > 0) {
            var start = Date.now() - spentTime;
            var timeout = setTimeout(function() {
                onInternalClose();
            }, duration * 1000 - spentTime);
            return function() {
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        mergedHovering,
        times
    ]);
    $aqdBs.useEffect(function() {
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            var start = performance.now();
            var animationFrame;
            var calculate = function calculate() {
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame(function(timestamp) {
                    var runtime = timestamp + spentTime - start;
                    var progress = Math.min(runtime / (duration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return function() {
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    var closableObj = $aqdBs.useMemo(function() {
        if ((0, $7IgoF.default)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon
        };
        return {};
    }, [
        closable,
        closeIcon
    ]);
    var ariaProps = (0, $bWa8g.default)(closableObj, true);
    // ======================== Progress ========================
    var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    var noticePrefixCls = "".concat(prefixCls, "-notice");
    return /*#__PURE__*/ $aqdBs.createElement("div", (0, $13KW1.default)({}, divProps, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(noticePrefixCls, className, (0, $br1G4.default)({}, "".concat(noticePrefixCls, "-closable"), closable)),
        style: style,
        onMouseEnter: function onMouseEnter(e) {
            var _divProps$onMouseEnte;
            setHovering(true);
            divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
        },
        onMouseLeave: function onMouseLeave(e) {
            var _divProps$onMouseLeav;
            setHovering(false);
            divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $aqdBs.createElement("div", {
        className: "".concat(noticePrefixCls, "-content")
    }, content), closable && /*#__PURE__*/ $aqdBs.createElement("a", (0, $13KW1.default)({
        tabIndex: 0,
        className: "".concat(noticePrefixCls, "-close"),
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon), mergedShowProgress && /*#__PURE__*/ $aqdBs.createElement("progress", {
        className: "".concat(noticePrefixCls, "-progress"),
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
var $f72c3392a5bbba1b$export$2e2bcd8739ae039 = $f72c3392a5bbba1b$var$Notify;

});

parcelRegister("d139G", function(module, exports) {

$parcel$export(module.exports, "NotificationContext", () => $979dd0e9549de569$export$a6e93d8cb5d50678);
$parcel$export(module.exports, "default", () => $979dd0e9549de569$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $979dd0e9549de569$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext({});
var $979dd0e9549de569$var$NotificationProvider = function NotificationProvider(_ref) {
    var children = _ref.children, classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($979dd0e9549de569$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $979dd0e9549de569$export$2e2bcd8739ae039 = $979dd0e9549de569$var$NotificationProvider;

});

parcelRegister("dUr3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2057e86ea4b5908$export$2e2bcd8739ae039);

var $7IgoF = parcelRequire("7IgoF");
var $a2057e86ea4b5908$var$DEFAULT_OFFSET = 8;
var $a2057e86ea4b5908$var$DEFAULT_THRESHOLD = 3;
var $a2057e86ea4b5908$var$DEFAULT_GAP = 16;
var $a2057e86ea4b5908$var$useStack = function useStack(config) {
    var result = {
        offset: $a2057e86ea4b5908$var$DEFAULT_OFFSET,
        threshold: $a2057e86ea4b5908$var$DEFAULT_THRESHOLD,
        gap: $a2057e86ea4b5908$var$DEFAULT_GAP
    };
    if (config && (0, $7IgoF.default)(config) === 'object') {
        var _config$offset, _config$threshold, _config$gap;
        result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : $a2057e86ea4b5908$var$DEFAULT_OFFSET;
        result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : $a2057e86ea4b5908$var$DEFAULT_THRESHOLD;
        result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : $a2057e86ea4b5908$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $a2057e86ea4b5908$export$2e2bcd8739ae039 = $a2057e86ea4b5908$var$useStack;

});





parcelRegister("6qIVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae804b33b3c0227$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $jHeh6 = parcelRequire("jHeh6");

var $5kUb2 = parcelRequire("5kUb2");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $4ae804b33b3c0227$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $Zo2YC.default)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $Zo2YC.default)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
                padding: 0,
                textAlign: 'start'
            })
        }
    ];
};
const $4ae804b33b3c0227$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $jHeh6.CONTAINER_MAX_OFFSET) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$4ae804b33b3c0227$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $8Olk9.merge)(token, {
        height: 150
    });
    return [
        $4ae804b33b3c0227$var$genMessageStyle(combinedToken)
    ];
}, $4ae804b33b3c0227$export$9ca1be8807fe0675);

});


parcelRegister("hyoxG", function(module, exports) {

$parcel$export(module.exports, "useInternalMessage", () => $cc78a63e1de75aba$export$1689db33b6c27d9e);
$parcel$export(module.exports, "default", () => $cc78a63e1de75aba$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $2Nj5k = parcelRequire("2Nj5k");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("fMNI3");
var $d139G = parcelRequire("d139G");
var $4R1kt = parcelRequire("4R1kt");

var $dkjPS = parcelRequire("dkjPS");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $6sKmx = parcelRequire("6sKmx");

var $6qIVk = parcelRequire("6qIVk");

var $bP2Ik = parcelRequire("bP2Ik");
"use client";
var $cc78a63e1de75aba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $cc78a63e1de75aba$var$DEFAULT_OFFSET = 8;
const $cc78a63e1de75aba$var$DEFAULT_DURATION = 3;
const $cc78a63e1de75aba$var$Wrapper = ({ children: children, prefixCls: prefixCls })=>{
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $6qIVk.default)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $d139G.default), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $cc78a63e1de75aba$var$renderNotifications = (node, { prefixCls: prefixCls, key: key })=>/*#__PURE__*/ $aqdBs.createElement($cc78a63e1de75aba$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const $cc78a63e1de75aba$var$Holder = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $cc78a63e1de75aba$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, message: message, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top !== null && top !== void 0 ? top : $cc78a63e1de75aba$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $bP2Ik.getMotion)(prefixCls, transitionName);
    // ============================ Close Icon =============================
    const mergedCloseIcon = /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-close-x`
    }, /*#__PURE__*/ $aqdBs.createElement((0, $2Nj5k.default), {
        className: `${prefixCls}-close-icon`
    }));
    // ============================== Origin ===============================
    const [api, holder] = (0, $4R1kt.default)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: false,
        closeIcon: mergedCloseIcon,
        duration: duration,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $cc78a63e1de75aba$var$renderNotifications
    });
    // ================================ Ref ================================
    $aqdBs.useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            message: message
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $cc78a63e1de75aba$var$keyIndex = 0;
function $cc78a63e1de75aba$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $aqdBs.useRef(null);
    const warning = (0, $dkjPS.devUseWarning)('Message');
    // ================================ API ================================
    const wrapAPI = $aqdBs.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            var _a;
            (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose } = config, restConfig = $cc78a63e1de75aba$var$__rest(config, [
                "content",
                "icon",
                "type",
                "key",
                "className",
                "style",
                "onClose"
            ]);
            let mergedKey = key;
            if (mergedKey === undefined || mergedKey === null) {
                $cc78a63e1de75aba$var$keyIndex += 1;
                mergedKey = `antd-message-${$cc78a63e1de75aba$var$keyIndex}`;
            }
            return (0, $bP2Ik.wrapPromiseFn)((resolve)=>{
                originOpen(Object.assign(Object.assign({}, restConfig), {
                    key: mergedKey,
                    content: /*#__PURE__*/ $aqdBs.createElement((0, $6sKmx.PureContent), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon
                    }, content),
                    placement: 'top',
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(type && `${noticePrefixCls}-${type}`, className, message === null || message === void 0 ? void 0 : message.className),
                    style: Object.assign(Object.assign({}, message === null || message === void 0 ? void 0 : message.style), style),
                    onClose: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        resolve();
                    }
                }));
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a;
            if (key !== undefined) close(key);
            else (_a = holderRef.current) === null || _a === void 0 || _a.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = Object.assign(Object.assign({
                    onClose: mergedOnClose,
                    duration: mergedDuration
                }, config), {
                    type: type
                });
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $aqdBs.createElement($cc78a63e1de75aba$var$Holder, Object.assign({
            key: "message-holder"
        }, messageConfig, {
            ref: holderRef
        }))
    ];
}
function $cc78a63e1de75aba$export$2e2bcd8739ae039(messageConfig) {
    return $cc78a63e1de75aba$export$1689db33b6c27d9e(messageConfig);
}

});
parcelRegister("2Nj5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $208ef63fba54c963$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $1AOLf = parcelRequire("1AOLf");

var $gL7Ec = parcelRequire("gL7Ec");
var $208ef63fba54c963$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $1AOLf.default)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $208ef63fba54c963$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($208ef63fba54c963$var$CloseOutlined);
var $208ef63fba54c963$export$2e2bcd8739ae039 = $208ef63fba54c963$var$RefIcon;

});
parcelRegister("1AOLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $12908751919ddbb6$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $12908751919ddbb6$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $12908751919ddbb6$export$2e2bcd8739ae039 = $12908751919ddbb6$var$CloseOutlined;

});


parcelRegister("bP2Ik", function(module, exports) {

$parcel$export(module.exports, "getMotion", () => $89b690172f27541f$export$7b8936ddc277a29a);
$parcel$export(module.exports, "wrapPromiseFn", () => $89b690172f27541f$export$52ce770daa307a45);
function $89b690172f27541f$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
    };
}
function $89b690172f27541f$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn === null || closeFn === void 0 || closeFn();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}

});




parcelRegister("dkYnv", function(module, exports) {

$parcel$export(module.exports, "ModalContextProvider", () => $e199f53fef32a81a$export$7c9538f5f3c365e9);
$parcel$export(module.exports, "useShowModal", () => $e199f53fef32a81a$export$8b3dc00ad7229500);

var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");
const $e199f53fef32a81a$var$ModalContext = /*#__PURE__*/ (0, $aqdBs.createContext)({
    model: null,
    setModel: ()=>{
        throw new Error("add a ModelContextProvider to your hierarchy");
    }
});
const $e199f53fef32a81a$export$7c9538f5f3c365e9 = ({ children: children })=>{
    const [modal, setModals] = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState([]);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)($e199f53fef32a81a$var$ModalContext.Provider, {
        value: {
            model: modal,
            setModel: setModals
        },
        children: [
            modal,
            children
        ]
    });
};
const $e199f53fef32a81a$export$8b3dc00ad7229500 = ()=>{
    const context = (0, $aqdBs.useContext)($e199f53fef32a81a$var$ModalContext);
    return context.setModel;
};

});

parcelRegister("3xSyo", function(module, exports) {

$parcel$export(module.exports, "isWindows", () => $547d5971932e6414$export$f993c945890e93ba);
$parcel$export(module.exports, "uiBuildVersion", () => $547d5971932e6414$export$8041345fc4cd5c01);
$parcel$export(module.exports, "isDevBuild", () => $547d5971932e6414$export$5728ee078eb364d);
$parcel$export(module.exports, "pathSeparator", () => $547d5971932e6414$export$4873d36de40006f9);
$parcel$export(module.exports, "backendUrl", () => $547d5971932e6414$export$f49b885ad9e68da5);
const $547d5971932e6414$export$ff6df29b0f5008bf = "unix".trim().toLowerCase();
const $547d5971932e6414$export$f993c945890e93ba = $547d5971932e6414$export$ff6df29b0f5008bf === "windows";
const $547d5971932e6414$export$8041345fc4cd5c01 = "1.9.2".trim();
const $547d5971932e6414$export$5728ee078eb364d = $547d5971932e6414$export$8041345fc4cd5c01 === "dev-snapshot-build";
const $547d5971932e6414$export$4873d36de40006f9 = $547d5971932e6414$export$f993c945890e93ba ? "\\" : "/";
const $547d5971932e6414$export$f49b885ad9e68da5 = "./";
console.log(`UI OS: ${$547d5971932e6414$export$ff6df29b0f5008bf}, Build Version: ${$547d5971932e6414$export$8041345fc4cd5c01}, Backend URL: ${$547d5971932e6414$export$f49b885ad9e68da5}`);

});

parcelRegister("c9ked", function(module, exports) {

$parcel$export(module.exports, "getOperations", () => $d28dc392b900997c$export$acc17f62bededcaf);
$parcel$export(module.exports, "subscribeToOperations", () => $d28dc392b900997c$export$6f873aff9e52545b);
$parcel$export(module.exports, "unsubscribeFromOperations", () => $d28dc392b900997c$export$eaca01ab7b4fbf9f);
$parcel$export(module.exports, "shouldHideOperation", () => $d28dc392b900997c$export$93f76c4e66583daa);
$parcel$export(module.exports, "shouldHideStatus", () => $d28dc392b900997c$export$fb873b7f53d17fbb);

var $81vtw = parcelRequire("81vtw");

var $1Yxub = parcelRequire("1Yxub");
const $d28dc392b900997c$var$subscribers = [];
// Start fetching and emitting operations.
(async ()=>{
    while(true){
        let nextConnWaitUntil = new Date().getTime() + 5000;
        try {
            for await (const event of (0, $1Yxub.backrestService).getOperationEvents({})){
                console.log("operation event", event);
                $d28dc392b900997c$var$subscribers.forEach((subscriber)=>subscriber(event, undefined));
            }
        } catch (e) {
            console.warn("operations stream died with exception: ", e);
        }
        await new Promise((accept, _)=>setTimeout(accept, nextConnWaitUntil - new Date().getTime()));
        $d28dc392b900997c$var$subscribers.forEach((subscriber)=>subscriber(undefined, new Error("reconnecting")));
    }
})();
const $d28dc392b900997c$export$acc17f62bededcaf = async (req)=>{
    const opList = await (0, $1Yxub.backrestService).getOperations(req);
    return opList.operations || [];
};
const $d28dc392b900997c$export$6f873aff9e52545b = (callback)=>{
    $d28dc392b900997c$var$subscribers.push(callback);
    console.log("subscribed to operations, subscriber count: ", $d28dc392b900997c$var$subscribers.length);
};
const $d28dc392b900997c$export$eaca01ab7b4fbf9f = (callback)=>{
    const index = $d28dc392b900997c$var$subscribers.indexOf(callback);
    if (index > -1) {
        $d28dc392b900997c$var$subscribers[index] = $d28dc392b900997c$var$subscribers[$d28dc392b900997c$var$subscribers.length - 1];
        $d28dc392b900997c$var$subscribers.pop();
    }
    console.log("unsubscribed from operations, subscriber count: ", $d28dc392b900997c$var$subscribers.length);
};
const $d28dc392b900997c$export$93f76c4e66583daa = (operation)=>{
    return operation.op.case === "operationStats" || operation.status === (0, $81vtw.OperationStatus).STATUS_SUCCESS && operation.op.case === "operationBackup" && !operation.snapshotId || $d28dc392b900997c$export$fb873b7f53d17fbb(operation.status);
};
const $d28dc392b900997c$export$fb873b7f53d17fbb = (status)=>{
    return status === (0, $81vtw.OperationStatus).STATUS_SYSTEM_CANCELLED;
};

});
parcelRegister("81vtw", function(module, exports) {

$parcel$export(module.exports, "file_v1_operations", () => $31968258335067cc$export$a221eadedf58802c);
$parcel$export(module.exports, "OperationEventType", () => $31968258335067cc$export$784e2fa3219f187);
$parcel$export(module.exports, "OperationStatus", () => $31968258335067cc$export$164675c46131f609);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/operations.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $3hwGY = parcelRequire("3hwGY");
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");

var $bv1KU = parcelRequire("bv1KU");

var $6Os56 = parcelRequire("6Os56");

var $8ffPJ = parcelRequire("8ffPJ");
const $31968258335067cc$export$a221eadedf58802c = /*@__PURE__*/ (0, $9CnIh.fileDesc)("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", [
    (0, $bv1KU.file_v1_restic),
    (0, $6Os56.file_v1_config),
    (0, $8ffPJ.file_types_value)
]);
const $31968258335067cc$export$46133584f1a56b8f = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 0);
const $31968258335067cc$export$921fe23a1f5039b0 = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 1);
const $31968258335067cc$export$87cfd9526a9bffd2 = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 2);
const $31968258335067cc$export$2fb02107fc49c20e = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 3);
const $31968258335067cc$export$dd04e85295b97752 = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 4);
const $31968258335067cc$export$19322b252862bf4e = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 5);
const $31968258335067cc$export$16ebbc882c4add1e = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 6);
const $31968258335067cc$export$45b6edbf963ff8b7 = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 7);
const $31968258335067cc$export$6e0d535bef3db1fb = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 8);
const $31968258335067cc$export$646fa581a4b5e4ac = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 9);
const $31968258335067cc$export$1b99fc4399e165c5 = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 10);
const $31968258335067cc$export$1a0f3a4df64171bc = /*@__PURE__*/ (0, $jHEye.messageDesc)($31968258335067cc$export$a221eadedf58802c, 11);
var $31968258335067cc$export$784e2fa3219f187 = /*#__PURE__*/ function(OperationEventType) {
    /**
   * @generated from enum value: EVENT_UNKNOWN = 0;
   */ OperationEventType[OperationEventType["EVENT_UNKNOWN"] = 0] = "EVENT_UNKNOWN";
    /**
   * @generated from enum value: EVENT_CREATED = 1;
   */ OperationEventType[OperationEventType["EVENT_CREATED"] = 1] = "EVENT_CREATED";
    /**
   * @generated from enum value: EVENT_UPDATED = 2;
   */ OperationEventType[OperationEventType["EVENT_UPDATED"] = 2] = "EVENT_UPDATED";
    /**
   * @generated from enum value: EVENT_DELETED = 3;
   */ OperationEventType[OperationEventType["EVENT_DELETED"] = 3] = "EVENT_DELETED";
    return OperationEventType;
}({});
const $31968258335067cc$export$c50521473f5759d4 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($31968258335067cc$export$a221eadedf58802c, 0);
var $31968258335067cc$export$164675c46131f609 = /*#__PURE__*/ function(OperationStatus) {
    /**
   * used to indicate that the status is unknown.
   *
   * @generated from enum value: STATUS_UNKNOWN = 0;
   */ OperationStatus[OperationStatus["STATUS_UNKNOWN"] = 0] = "STATUS_UNKNOWN";
    /**
   * used to indicate that the operation is pending.
   *
   * @generated from enum value: STATUS_PENDING = 1;
   */ OperationStatus[OperationStatus["STATUS_PENDING"] = 1] = "STATUS_PENDING";
    /**
   * used to indicate that the operation is in progress.
   *
   * @generated from enum value: STATUS_INPROGRESS = 2;
   */ OperationStatus[OperationStatus["STATUS_INPROGRESS"] = 2] = "STATUS_INPROGRESS";
    /**
   * used to indicate that the operation completed successfully.
   *
   * @generated from enum value: STATUS_SUCCESS = 3;
   */ OperationStatus[OperationStatus["STATUS_SUCCESS"] = 3] = "STATUS_SUCCESS";
    /**
   * used to indicate that the operation completed with warnings.
   *
   * @generated from enum value: STATUS_WARNING = 7;
   */ OperationStatus[OperationStatus["STATUS_WARNING"] = 7] = "STATUS_WARNING";
    /**
   * used to indicate that the operation failed.
   *
   * @generated from enum value: STATUS_ERROR = 4;
   */ OperationStatus[OperationStatus["STATUS_ERROR"] = 4] = "STATUS_ERROR";
    /**
   * indicates operation cancelled by the system.
   *
   * @generated from enum value: STATUS_SYSTEM_CANCELLED = 5;
   */ OperationStatus[OperationStatus["STATUS_SYSTEM_CANCELLED"] = 5] = "STATUS_SYSTEM_CANCELLED";
    /**
   * indicates operation cancelled by the user.
   *
   * @generated from enum value: STATUS_USER_CANCELLED = 6;
   */ OperationStatus[OperationStatus["STATUS_USER_CANCELLED"] = 6] = "STATUS_USER_CANCELLED";
    return OperationStatus;
}({});
const $31968258335067cc$export$daa76e4ccfe8a603 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($31968258335067cc$export$a221eadedf58802c, 1);

});
parcelRegister("3hwGY", function(module, exports) {

$parcel$export(module.exports, "enumDesc", () => $263c519d931d3ade$export$cea1ae13765aaf5d);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

function $263c519d931d3ade$export$cea1ae13765aaf5d(file, path, ...paths) {
    if (paths.length == 0) return file.enums[path];
    const e = paths.pop(); // we checked length above
    return paths.reduce((acc, cur)=>acc.nestedMessages[cur], file.messages[path]).nestedEnums[e];
}

});

parcelRegister("9CnIh", function(module, exports) {

$parcel$export(module.exports, "fileDesc", () => $700a0e9b94d0ccca$export$1d231b73bca958a8);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3xX2e = parcelRequire("3xX2e");

var $dKpyK = parcelRequire("dKpyK");

var $8U2QW = parcelRequire("8U2QW");

var $iarWv = parcelRequire("iarWv");

var $6PNZL = parcelRequire("6PNZL");
function $700a0e9b94d0ccca$export$1d231b73bca958a8(b64, imports) {
    var _a;
    const root = (0, $6PNZL.fromBinary)((0, $dKpyK.FileDescriptorProtoSchema), (0, $3xX2e.base64Decode)(b64));
    root.messageType.forEach((0, $iarWv.restoreJsonNames));
    root.dependency = (_a = imports === null || imports === void 0 ? void 0 : imports.map((f)=>f.proto.name)) !== null && _a !== void 0 ? _a : [];
    const reg = (0, $8U2QW.createFileRegistry)(root, (protoFileName)=>imports === null || imports === void 0 ? void 0 : imports.find((f)=>f.proto.name === protoFileName));
    // biome-ignore lint/style/noNonNullAssertion: non-null assertion because we just created the registry from the file we look up
    return reg.getFile(root.name);
}

});
parcelRegister("3xX2e", function(module, exports) {

$parcel$export(module.exports, "base64Decode", () => $29523f4e4c045e85$export$c62426fdd000a97e);
$parcel$export(module.exports, "base64Encode", () => $29523f4e4c045e85$export$e510a73ee562749);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Decodes a base64 string to a byte array.
 *
 * - ignores white-space, including line breaks and tabs
 * - allows inner padding (can decode concatenated base64 strings)
 * - does not require padding
 * - understands base64url encoding:
 *   "-" instead of "+",
 *   "_" instead of "/",
 *   no padding
 */ function $29523f4e4c045e85$export$c62426fdd000a97e(base64Str) {
    const table = $29523f4e4c045e85$var$getDecodeTable();
    // estimate byte size, not accounting for inner padding and whitespace
    let es = base64Str.length * 3 / 4;
    if (base64Str[base64Str.length - 2] == "=") es -= 2;
    else if (base64Str[base64Str.length - 1] == "=") es -= 1;
    let bytes = new Uint8Array(es), bytePos = 0, groupPos = 0, b, p = 0; // previous byte
    for(let i = 0; i < base64Str.length; i++){
        b = table[base64Str.charCodeAt(i)];
        if (b === undefined) switch(base64Str[i]){
            // @ts-expect-error TS7029: Fallthrough case in switch
            case "=":
                groupPos = 0; // reset state when padding found
            case "\n":
            case "\r":
            case "\t":
            case " ":
                continue; // skip white-space, and padding
            default:
                throw Error("invalid base64 string");
        }
        switch(groupPos){
            case 0:
                p = b;
                groupPos = 1;
                break;
            case 1:
                bytes[bytePos++] = p << 2 | (b & 48) >> 4;
                p = b;
                groupPos = 2;
                break;
            case 2:
                bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
                p = b;
                groupPos = 3;
                break;
            case 3:
                bytes[bytePos++] = (p & 3) << 6 | b;
                groupPos = 0;
                break;
        }
    }
    if (groupPos == 1) throw Error("invalid base64 string");
    return bytes.subarray(0, bytePos);
}
function $29523f4e4c045e85$export$e510a73ee562749(bytes, encoding = "std") {
    const table = $29523f4e4c045e85$var$getEncodeTable(encoding);
    const pad = encoding == "std";
    let base64 = "", groupPos = 0, b, p = 0; // carry over from previous byte
    for(let i = 0; i < bytes.length; i++){
        b = bytes[i];
        switch(groupPos){
            case 0:
                base64 += table[b >> 2];
                p = (b & 3) << 4;
                groupPos = 1;
                break;
            case 1:
                base64 += table[p | b >> 4];
                p = (b & 15) << 2;
                groupPos = 2;
                break;
            case 2:
                base64 += table[p | b >> 6];
                base64 += table[b & 63];
                groupPos = 0;
                break;
        }
    }
    // add output padding
    if (groupPos) {
        base64 += table[p];
        if (pad) {
            base64 += "=";
            if (groupPos == 1) base64 += "=";
        }
    }
    return base64;
}
// lookup table from base64 character to byte
let $29523f4e4c045e85$var$encodeTableStd;
let $29523f4e4c045e85$var$encodeTableUrl;
// lookup table from base64 character *code* to byte because lookup by number is fast
let $29523f4e4c045e85$var$decodeTable;
function $29523f4e4c045e85$var$getEncodeTable(encoding) {
    if (!$29523f4e4c045e85$var$encodeTableStd) {
        $29523f4e4c045e85$var$encodeTableStd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
        $29523f4e4c045e85$var$encodeTableUrl = $29523f4e4c045e85$var$encodeTableStd.slice(0, -2).concat("-", "_");
    }
    return encoding == "url" ? $29523f4e4c045e85$var$encodeTableUrl : $29523f4e4c045e85$var$encodeTableStd;
}
function $29523f4e4c045e85$var$getDecodeTable() {
    if (!$29523f4e4c045e85$var$decodeTable) {
        $29523f4e4c045e85$var$decodeTable = [];
        const encodeTable = $29523f4e4c045e85$var$getEncodeTable("std");
        for(let i = 0; i < encodeTable.length; i++)$29523f4e4c045e85$var$decodeTable[encodeTable[i].charCodeAt(0)] = i;
        // support base64url variants
        $29523f4e4c045e85$var$decodeTable["-".charCodeAt(0)] = encodeTable.indexOf("+");
        $29523f4e4c045e85$var$decodeTable["_".charCodeAt(0)] = encodeTable.indexOf("/");
    }
    return $29523f4e4c045e85$var$decodeTable;
}

});

parcelRegister("dKpyK", function(module, exports) {

$parcel$export(module.exports, "file_google_protobuf_descriptor", () => $a02365cfe34ea521$export$28b5a4f46d6a06a);
$parcel$export(module.exports, "FileDescriptorProtoSchema", () => $a02365cfe34ea521$export$3673c68f99dfc330);
$parcel$export(module.exports, "MethodOptions_IdempotencyLevel", () => $a02365cfe34ea521$export$49b4a905951fdc74);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $hvQKw = parcelRequire("hvQKw");

var $8ImrE = parcelRequire("8ImrE");

var $h4GxM = parcelRequire("h4GxM");
const $a02365cfe34ea521$export$28b5a4f46d6a06a = /*@__PURE__*/ (0, $hvQKw.boot)({
    "name": "google/protobuf/descriptor.proto",
    "package": "google.protobuf",
    "messageType": [
        {
            "name": "FileDescriptorSet",
            "field": [
                {
                    "name": "file",
                    "number": 1,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FileDescriptorProto"
                }
            ],
            "extensionRange": [
                {
                    "start": 536000000,
                    "end": 536000001
                }
            ]
        },
        {
            "name": "FileDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "package",
                    "number": 2,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "dependency",
                    "number": 3,
                    "type": 9,
                    "label": 3
                },
                {
                    "name": "public_dependency",
                    "number": 10,
                    "type": 5,
                    "label": 3
                },
                {
                    "name": "weak_dependency",
                    "number": 11,
                    "type": 5,
                    "label": 3
                },
                {
                    "name": "message_type",
                    "number": 4,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.DescriptorProto"
                },
                {
                    "name": "enum_type",
                    "number": 5,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.EnumDescriptorProto"
                },
                {
                    "name": "service",
                    "number": 6,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.ServiceDescriptorProto"
                },
                {
                    "name": "extension",
                    "number": 7,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FieldDescriptorProto"
                },
                {
                    "name": "options",
                    "number": 8,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FileOptions"
                },
                {
                    "name": "source_code_info",
                    "number": 9,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.SourceCodeInfo"
                },
                {
                    "name": "syntax",
                    "number": 12,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "edition",
                    "number": 14,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.Edition"
                }
            ]
        },
        {
            "name": "DescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "field",
                    "number": 2,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FieldDescriptorProto"
                },
                {
                    "name": "extension",
                    "number": 6,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FieldDescriptorProto"
                },
                {
                    "name": "nested_type",
                    "number": 3,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.DescriptorProto"
                },
                {
                    "name": "enum_type",
                    "number": 4,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.EnumDescriptorProto"
                },
                {
                    "name": "extension_range",
                    "number": 5,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.DescriptorProto.ExtensionRange"
                },
                {
                    "name": "oneof_decl",
                    "number": 8,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.OneofDescriptorProto"
                },
                {
                    "name": "options",
                    "number": 7,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.MessageOptions"
                },
                {
                    "name": "reserved_range",
                    "number": 9,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.DescriptorProto.ReservedRange"
                },
                {
                    "name": "reserved_name",
                    "number": 10,
                    "type": 9,
                    "label": 3
                }
            ],
            "nestedType": [
                {
                    "name": "ExtensionRange",
                    "field": [
                        {
                            "name": "start",
                            "number": 1,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "end",
                            "number": 2,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "options",
                            "number": 3,
                            "type": 11,
                            "label": 1,
                            "typeName": ".google.protobuf.ExtensionRangeOptions"
                        }
                    ]
                },
                {
                    "name": "ReservedRange",
                    "field": [
                        {
                            "name": "start",
                            "number": 1,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "end",
                            "number": 2,
                            "type": 5,
                            "label": 1
                        }
                    ]
                }
            ]
        },
        {
            "name": "ExtensionRangeOptions",
            "field": [
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                },
                {
                    "name": "declaration",
                    "number": 2,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.ExtensionRangeOptions.Declaration",
                    "options": {
                        "retention": 2
                    }
                },
                {
                    "name": "features",
                    "number": 50,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "verification",
                    "number": 3,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.ExtensionRangeOptions.VerificationState",
                    "defaultValue": "UNVERIFIED",
                    "options": {
                        "retention": 2
                    }
                }
            ],
            "nestedType": [
                {
                    "name": "Declaration",
                    "field": [
                        {
                            "name": "number",
                            "number": 1,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "full_name",
                            "number": 2,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "type",
                            "number": 3,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "reserved",
                            "number": 5,
                            "type": 8,
                            "label": 1
                        },
                        {
                            "name": "repeated",
                            "number": 6,
                            "type": 8,
                            "label": 1
                        }
                    ]
                }
            ],
            "enumType": [
                {
                    "name": "VerificationState",
                    "value": [
                        {
                            "name": "DECLARATION",
                            "number": 0
                        },
                        {
                            "name": "UNVERIFIED",
                            "number": 1
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "FieldDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "number",
                    "number": 3,
                    "type": 5,
                    "label": 1
                },
                {
                    "name": "label",
                    "number": 4,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldDescriptorProto.Label"
                },
                {
                    "name": "type",
                    "number": 5,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldDescriptorProto.Type"
                },
                {
                    "name": "type_name",
                    "number": 6,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "extendee",
                    "number": 2,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "default_value",
                    "number": 7,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "oneof_index",
                    "number": 9,
                    "type": 5,
                    "label": 1
                },
                {
                    "name": "json_name",
                    "number": 10,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "options",
                    "number": 8,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions"
                },
                {
                    "name": "proto3_optional",
                    "number": 17,
                    "type": 8,
                    "label": 1
                }
            ],
            "enumType": [
                {
                    "name": "Type",
                    "value": [
                        {
                            "name": "TYPE_DOUBLE",
                            "number": 1
                        },
                        {
                            "name": "TYPE_FLOAT",
                            "number": 2
                        },
                        {
                            "name": "TYPE_INT64",
                            "number": 3
                        },
                        {
                            "name": "TYPE_UINT64",
                            "number": 4
                        },
                        {
                            "name": "TYPE_INT32",
                            "number": 5
                        },
                        {
                            "name": "TYPE_FIXED64",
                            "number": 6
                        },
                        {
                            "name": "TYPE_FIXED32",
                            "number": 7
                        },
                        {
                            "name": "TYPE_BOOL",
                            "number": 8
                        },
                        {
                            "name": "TYPE_STRING",
                            "number": 9
                        },
                        {
                            "name": "TYPE_GROUP",
                            "number": 10
                        },
                        {
                            "name": "TYPE_MESSAGE",
                            "number": 11
                        },
                        {
                            "name": "TYPE_BYTES",
                            "number": 12
                        },
                        {
                            "name": "TYPE_UINT32",
                            "number": 13
                        },
                        {
                            "name": "TYPE_ENUM",
                            "number": 14
                        },
                        {
                            "name": "TYPE_SFIXED32",
                            "number": 15
                        },
                        {
                            "name": "TYPE_SFIXED64",
                            "number": 16
                        },
                        {
                            "name": "TYPE_SINT32",
                            "number": 17
                        },
                        {
                            "name": "TYPE_SINT64",
                            "number": 18
                        }
                    ]
                },
                {
                    "name": "Label",
                    "value": [
                        {
                            "name": "LABEL_OPTIONAL",
                            "number": 1
                        },
                        {
                            "name": "LABEL_REPEATED",
                            "number": 3
                        },
                        {
                            "name": "LABEL_REQUIRED",
                            "number": 2
                        }
                    ]
                }
            ]
        },
        {
            "name": "OneofDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "options",
                    "number": 2,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.OneofOptions"
                }
            ]
        },
        {
            "name": "EnumDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "value",
                    "number": 2,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.EnumValueDescriptorProto"
                },
                {
                    "name": "options",
                    "number": 3,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.EnumOptions"
                },
                {
                    "name": "reserved_range",
                    "number": 4,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.EnumDescriptorProto.EnumReservedRange"
                },
                {
                    "name": "reserved_name",
                    "number": 5,
                    "type": 9,
                    "label": 3
                }
            ],
            "nestedType": [
                {
                    "name": "EnumReservedRange",
                    "field": [
                        {
                            "name": "start",
                            "number": 1,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "end",
                            "number": 2,
                            "type": 5,
                            "label": 1
                        }
                    ]
                }
            ]
        },
        {
            "name": "EnumValueDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "number",
                    "number": 2,
                    "type": 5,
                    "label": 1
                },
                {
                    "name": "options",
                    "number": 3,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.EnumValueOptions"
                }
            ]
        },
        {
            "name": "ServiceDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "method",
                    "number": 2,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.MethodDescriptorProto"
                },
                {
                    "name": "options",
                    "number": 3,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.ServiceOptions"
                }
            ]
        },
        {
            "name": "MethodDescriptorProto",
            "field": [
                {
                    "name": "name",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "input_type",
                    "number": 2,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "output_type",
                    "number": 3,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "options",
                    "number": 4,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.MethodOptions"
                },
                {
                    "name": "client_streaming",
                    "number": 5,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "server_streaming",
                    "number": 6,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                }
            ]
        },
        {
            "name": "FileOptions",
            "field": [
                {
                    "name": "java_package",
                    "number": 1,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "java_outer_classname",
                    "number": 8,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "java_multiple_files",
                    "number": 10,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "java_generate_equals_and_hash",
                    "number": 20,
                    "type": 8,
                    "label": 1,
                    "options": {
                        "deprecated": true
                    }
                },
                {
                    "name": "java_string_check_utf8",
                    "number": 27,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "optimize_for",
                    "number": 9,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FileOptions.OptimizeMode",
                    "defaultValue": "SPEED"
                },
                {
                    "name": "go_package",
                    "number": 11,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "cc_generic_services",
                    "number": 16,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "java_generic_services",
                    "number": 17,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "py_generic_services",
                    "number": 18,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "deprecated",
                    "number": 23,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "cc_enable_arenas",
                    "number": 31,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "true"
                },
                {
                    "name": "objc_class_prefix",
                    "number": 36,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "csharp_namespace",
                    "number": 37,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "swift_prefix",
                    "number": 39,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "php_class_prefix",
                    "number": 40,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "php_namespace",
                    "number": 41,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "php_metadata_namespace",
                    "number": 44,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "ruby_package",
                    "number": 45,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "features",
                    "number": 50,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "enumType": [
                {
                    "name": "OptimizeMode",
                    "value": [
                        {
                            "name": "SPEED",
                            "number": 1
                        },
                        {
                            "name": "CODE_SIZE",
                            "number": 2
                        },
                        {
                            "name": "LITE_RUNTIME",
                            "number": 3
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "MessageOptions",
            "field": [
                {
                    "name": "message_set_wire_format",
                    "number": 1,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "no_standard_descriptor_accessor",
                    "number": 2,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "deprecated",
                    "number": 3,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "map_entry",
                    "number": 7,
                    "type": 8,
                    "label": 1
                },
                {
                    "name": "deprecated_legacy_json_field_conflicts",
                    "number": 11,
                    "type": 8,
                    "label": 1,
                    "options": {
                        "deprecated": true
                    }
                },
                {
                    "name": "features",
                    "number": 12,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "FieldOptions",
            "field": [
                {
                    "name": "ctype",
                    "number": 1,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions.CType",
                    "defaultValue": "STRING"
                },
                {
                    "name": "packed",
                    "number": 2,
                    "type": 8,
                    "label": 1
                },
                {
                    "name": "jstype",
                    "number": 6,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions.JSType",
                    "defaultValue": "JS_NORMAL"
                },
                {
                    "name": "lazy",
                    "number": 5,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "unverified_lazy",
                    "number": 15,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "deprecated",
                    "number": 3,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "weak",
                    "number": 10,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "debug_redact",
                    "number": 16,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "retention",
                    "number": 17,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions.OptionRetention"
                },
                {
                    "name": "targets",
                    "number": 19,
                    "type": 14,
                    "label": 3,
                    "typeName": ".google.protobuf.FieldOptions.OptionTargetType"
                },
                {
                    "name": "edition_defaults",
                    "number": 20,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FieldOptions.EditionDefault"
                },
                {
                    "name": "features",
                    "number": 21,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "feature_support",
                    "number": 22,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions.FeatureSupport"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "nestedType": [
                {
                    "name": "EditionDefault",
                    "field": [
                        {
                            "name": "edition",
                            "number": 3,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.Edition"
                        },
                        {
                            "name": "value",
                            "number": 2,
                            "type": 9,
                            "label": 1
                        }
                    ]
                },
                {
                    "name": "FeatureSupport",
                    "field": [
                        {
                            "name": "edition_introduced",
                            "number": 1,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.Edition"
                        },
                        {
                            "name": "edition_deprecated",
                            "number": 2,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.Edition"
                        },
                        {
                            "name": "deprecation_warning",
                            "number": 3,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "edition_removed",
                            "number": 4,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.Edition"
                        }
                    ]
                }
            ],
            "enumType": [
                {
                    "name": "CType",
                    "value": [
                        {
                            "name": "STRING",
                            "number": 0
                        },
                        {
                            "name": "CORD",
                            "number": 1
                        },
                        {
                            "name": "STRING_PIECE",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "JSType",
                    "value": [
                        {
                            "name": "JS_NORMAL",
                            "number": 0
                        },
                        {
                            "name": "JS_STRING",
                            "number": 1
                        },
                        {
                            "name": "JS_NUMBER",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "OptionRetention",
                    "value": [
                        {
                            "name": "RETENTION_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "RETENTION_RUNTIME",
                            "number": 1
                        },
                        {
                            "name": "RETENTION_SOURCE",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "OptionTargetType",
                    "value": [
                        {
                            "name": "TARGET_TYPE_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "TARGET_TYPE_FILE",
                            "number": 1
                        },
                        {
                            "name": "TARGET_TYPE_EXTENSION_RANGE",
                            "number": 2
                        },
                        {
                            "name": "TARGET_TYPE_MESSAGE",
                            "number": 3
                        },
                        {
                            "name": "TARGET_TYPE_FIELD",
                            "number": 4
                        },
                        {
                            "name": "TARGET_TYPE_ONEOF",
                            "number": 5
                        },
                        {
                            "name": "TARGET_TYPE_ENUM",
                            "number": 6
                        },
                        {
                            "name": "TARGET_TYPE_ENUM_ENTRY",
                            "number": 7
                        },
                        {
                            "name": "TARGET_TYPE_SERVICE",
                            "number": 8
                        },
                        {
                            "name": "TARGET_TYPE_METHOD",
                            "number": 9
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "OneofOptions",
            "field": [
                {
                    "name": "features",
                    "number": 1,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "EnumOptions",
            "field": [
                {
                    "name": "allow_alias",
                    "number": 2,
                    "type": 8,
                    "label": 1
                },
                {
                    "name": "deprecated",
                    "number": 3,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "deprecated_legacy_json_field_conflicts",
                    "number": 6,
                    "type": 8,
                    "label": 1,
                    "options": {
                        "deprecated": true
                    }
                },
                {
                    "name": "features",
                    "number": 7,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "EnumValueOptions",
            "field": [
                {
                    "name": "deprecated",
                    "number": 1,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "features",
                    "number": 2,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "debug_redact",
                    "number": 3,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "feature_support",
                    "number": 4,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FieldOptions.FeatureSupport"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "ServiceOptions",
            "field": [
                {
                    "name": "features",
                    "number": 34,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "deprecated",
                    "number": 33,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "MethodOptions",
            "field": [
                {
                    "name": "deprecated",
                    "number": 33,
                    "type": 8,
                    "label": 1,
                    "defaultValue": "false"
                },
                {
                    "name": "idempotency_level",
                    "number": 34,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.MethodOptions.IdempotencyLevel",
                    "defaultValue": "IDEMPOTENCY_UNKNOWN"
                },
                {
                    "name": "features",
                    "number": 35,
                    "type": 11,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet"
                },
                {
                    "name": "uninterpreted_option",
                    "number": 999,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption"
                }
            ],
            "enumType": [
                {
                    "name": "IdempotencyLevel",
                    "value": [
                        {
                            "name": "IDEMPOTENCY_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "NO_SIDE_EFFECTS",
                            "number": 1
                        },
                        {
                            "name": "IDEMPOTENT",
                            "number": 2
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 536870912
                }
            ]
        },
        {
            "name": "UninterpretedOption",
            "field": [
                {
                    "name": "name",
                    "number": 2,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.UninterpretedOption.NamePart"
                },
                {
                    "name": "identifier_value",
                    "number": 3,
                    "type": 9,
                    "label": 1
                },
                {
                    "name": "positive_int_value",
                    "number": 4,
                    "type": 4,
                    "label": 1
                },
                {
                    "name": "negative_int_value",
                    "number": 5,
                    "type": 3,
                    "label": 1
                },
                {
                    "name": "double_value",
                    "number": 6,
                    "type": 1,
                    "label": 1
                },
                {
                    "name": "string_value",
                    "number": 7,
                    "type": 12,
                    "label": 1
                },
                {
                    "name": "aggregate_value",
                    "number": 8,
                    "type": 9,
                    "label": 1
                }
            ],
            "nestedType": [
                {
                    "name": "NamePart",
                    "field": [
                        {
                            "name": "name_part",
                            "number": 1,
                            "type": 9,
                            "label": 2
                        },
                        {
                            "name": "is_extension",
                            "number": 2,
                            "type": 8,
                            "label": 2
                        }
                    ]
                }
            ]
        },
        {
            "name": "FeatureSet",
            "field": [
                {
                    "name": "field_presence",
                    "number": 1,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.FieldPresence",
                    "options": {
                        "retention": 1,
                        "targets": [
                            4,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "EXPLICIT",
                                "edition": 900
                            },
                            {
                                "value": "IMPLICIT",
                                "edition": 999
                            },
                            {
                                "value": "EXPLICIT",
                                "edition": 1000
                            }
                        ]
                    }
                },
                {
                    "name": "enum_type",
                    "number": 2,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.EnumType",
                    "options": {
                        "retention": 1,
                        "targets": [
                            6,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "CLOSED",
                                "edition": 900
                            },
                            {
                                "value": "OPEN",
                                "edition": 999
                            }
                        ]
                    }
                },
                {
                    "name": "repeated_field_encoding",
                    "number": 3,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.RepeatedFieldEncoding",
                    "options": {
                        "retention": 1,
                        "targets": [
                            4,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "EXPANDED",
                                "edition": 900
                            },
                            {
                                "value": "PACKED",
                                "edition": 999
                            }
                        ]
                    }
                },
                {
                    "name": "utf8_validation",
                    "number": 4,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.Utf8Validation",
                    "options": {
                        "retention": 1,
                        "targets": [
                            4,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "NONE",
                                "edition": 900
                            },
                            {
                                "value": "VERIFY",
                                "edition": 999
                            }
                        ]
                    }
                },
                {
                    "name": "message_encoding",
                    "number": 5,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.MessageEncoding",
                    "options": {
                        "retention": 1,
                        "targets": [
                            4,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "LENGTH_PREFIXED",
                                "edition": 900
                            }
                        ]
                    }
                },
                {
                    "name": "json_format",
                    "number": 6,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.JsonFormat",
                    "options": {
                        "retention": 1,
                        "targets": [
                            3,
                            6,
                            1
                        ],
                        "editionDefaults": [
                            {
                                "value": "LEGACY_BEST_EFFORT",
                                "edition": 900
                            },
                            {
                                "value": "ALLOW",
                                "edition": 999
                            }
                        ]
                    }
                },
                {
                    "name": "enforce_naming_style",
                    "number": 7,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.FeatureSet.EnforceNamingStyle",
                    "options": {
                        "retention": 2,
                        "targets": [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9
                        ],
                        "editionDefaults": [
                            {
                                "value": "STYLE_LEGACY",
                                "edition": 900
                            },
                            {
                                "value": "STYLE2024",
                                "edition": 1001
                            }
                        ]
                    }
                }
            ],
            "enumType": [
                {
                    "name": "FieldPresence",
                    "value": [
                        {
                            "name": "FIELD_PRESENCE_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "EXPLICIT",
                            "number": 1
                        },
                        {
                            "name": "IMPLICIT",
                            "number": 2
                        },
                        {
                            "name": "LEGACY_REQUIRED",
                            "number": 3
                        }
                    ]
                },
                {
                    "name": "EnumType",
                    "value": [
                        {
                            "name": "ENUM_TYPE_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "OPEN",
                            "number": 1
                        },
                        {
                            "name": "CLOSED",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "RepeatedFieldEncoding",
                    "value": [
                        {
                            "name": "REPEATED_FIELD_ENCODING_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "PACKED",
                            "number": 1
                        },
                        {
                            "name": "EXPANDED",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "Utf8Validation",
                    "value": [
                        {
                            "name": "UTF8_VALIDATION_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "VERIFY",
                            "number": 2
                        },
                        {
                            "name": "NONE",
                            "number": 3
                        }
                    ]
                },
                {
                    "name": "MessageEncoding",
                    "value": [
                        {
                            "name": "MESSAGE_ENCODING_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "LENGTH_PREFIXED",
                            "number": 1
                        },
                        {
                            "name": "DELIMITED",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "JsonFormat",
                    "value": [
                        {
                            "name": "JSON_FORMAT_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "ALLOW",
                            "number": 1
                        },
                        {
                            "name": "LEGACY_BEST_EFFORT",
                            "number": 2
                        }
                    ]
                },
                {
                    "name": "EnforceNamingStyle",
                    "value": [
                        {
                            "name": "ENFORCE_NAMING_STYLE_UNKNOWN",
                            "number": 0
                        },
                        {
                            "name": "STYLE2024",
                            "number": 1
                        },
                        {
                            "name": "STYLE_LEGACY",
                            "number": 2
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 1000,
                    "end": 9995
                },
                {
                    "start": 9995,
                    "end": 10000
                },
                {
                    "start": 10000,
                    "end": 10001
                }
            ]
        },
        {
            "name": "FeatureSetDefaults",
            "field": [
                {
                    "name": "defaults",
                    "number": 1,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.FeatureSetDefaults.FeatureSetEditionDefault"
                },
                {
                    "name": "minimum_edition",
                    "number": 4,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.Edition"
                },
                {
                    "name": "maximum_edition",
                    "number": 5,
                    "type": 14,
                    "label": 1,
                    "typeName": ".google.protobuf.Edition"
                }
            ],
            "nestedType": [
                {
                    "name": "FeatureSetEditionDefault",
                    "field": [
                        {
                            "name": "edition",
                            "number": 3,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.Edition"
                        },
                        {
                            "name": "overridable_features",
                            "number": 4,
                            "type": 11,
                            "label": 1,
                            "typeName": ".google.protobuf.FeatureSet"
                        },
                        {
                            "name": "fixed_features",
                            "number": 5,
                            "type": 11,
                            "label": 1,
                            "typeName": ".google.protobuf.FeatureSet"
                        }
                    ]
                }
            ]
        },
        {
            "name": "SourceCodeInfo",
            "field": [
                {
                    "name": "location",
                    "number": 1,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.SourceCodeInfo.Location"
                }
            ],
            "nestedType": [
                {
                    "name": "Location",
                    "field": [
                        {
                            "name": "path",
                            "number": 1,
                            "type": 5,
                            "label": 3,
                            "options": {
                                "packed": true
                            }
                        },
                        {
                            "name": "span",
                            "number": 2,
                            "type": 5,
                            "label": 3,
                            "options": {
                                "packed": true
                            }
                        },
                        {
                            "name": "leading_comments",
                            "number": 3,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "trailing_comments",
                            "number": 4,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "leading_detached_comments",
                            "number": 6,
                            "type": 9,
                            "label": 3
                        }
                    ]
                }
            ],
            "extensionRange": [
                {
                    "start": 536000000,
                    "end": 536000001
                }
            ]
        },
        {
            "name": "GeneratedCodeInfo",
            "field": [
                {
                    "name": "annotation",
                    "number": 1,
                    "type": 11,
                    "label": 3,
                    "typeName": ".google.protobuf.GeneratedCodeInfo.Annotation"
                }
            ],
            "nestedType": [
                {
                    "name": "Annotation",
                    "field": [
                        {
                            "name": "path",
                            "number": 1,
                            "type": 5,
                            "label": 3,
                            "options": {
                                "packed": true
                            }
                        },
                        {
                            "name": "source_file",
                            "number": 2,
                            "type": 9,
                            "label": 1
                        },
                        {
                            "name": "begin",
                            "number": 3,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "end",
                            "number": 4,
                            "type": 5,
                            "label": 1
                        },
                        {
                            "name": "semantic",
                            "number": 5,
                            "type": 14,
                            "label": 1,
                            "typeName": ".google.protobuf.GeneratedCodeInfo.Annotation.Semantic"
                        }
                    ],
                    "enumType": [
                        {
                            "name": "Semantic",
                            "value": [
                                {
                                    "name": "NONE",
                                    "number": 0
                                },
                                {
                                    "name": "SET",
                                    "number": 1
                                },
                                {
                                    "name": "ALIAS",
                                    "number": 2
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "enumType": [
        {
            "name": "Edition",
            "value": [
                {
                    "name": "EDITION_UNKNOWN",
                    "number": 0
                },
                {
                    "name": "EDITION_LEGACY",
                    "number": 900
                },
                {
                    "name": "EDITION_PROTO2",
                    "number": 998
                },
                {
                    "name": "EDITION_PROTO3",
                    "number": 999
                },
                {
                    "name": "EDITION_2023",
                    "number": 1000
                },
                {
                    "name": "EDITION_2024",
                    "number": 1001
                },
                {
                    "name": "EDITION_1_TEST_ONLY",
                    "number": 1
                },
                {
                    "name": "EDITION_2_TEST_ONLY",
                    "number": 2
                },
                {
                    "name": "EDITION_99997_TEST_ONLY",
                    "number": 99997
                },
                {
                    "name": "EDITION_99998_TEST_ONLY",
                    "number": 99998
                },
                {
                    "name": "EDITION_99999_TEST_ONLY",
                    "number": 99999
                },
                {
                    "name": "EDITION_MAX",
                    "number": 2147483647
                }
            ]
        }
    ]
});
const $a02365cfe34ea521$export$27736a1ff8a849c5 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 0);
const $a02365cfe34ea521$export$3673c68f99dfc330 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 1);
const $a02365cfe34ea521$export$1dc7a986572abd6 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 2);
const $a02365cfe34ea521$export$6944f2bdfacfb11 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 2, 0);
const $a02365cfe34ea521$export$e76d796de9ff2fad = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 2, 1);
const $a02365cfe34ea521$export$9a12d61aae1cc2ae = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 3);
const $a02365cfe34ea521$export$46201dadac274bcd = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 3, 0);
var $a02365cfe34ea521$export$2f2af17d88fd3ee8;
(function(ExtensionRangeOptions_VerificationState) {
    /**
     * All the extensions of the range must be declared.
     *
     * @generated from enum value: DECLARATION = 0;
     */ ExtensionRangeOptions_VerificationState[ExtensionRangeOptions_VerificationState["DECLARATION"] = 0] = "DECLARATION";
    /**
     * @generated from enum value: UNVERIFIED = 1;
     */ ExtensionRangeOptions_VerificationState[ExtensionRangeOptions_VerificationState["UNVERIFIED"] = 1] = "UNVERIFIED";
})($a02365cfe34ea521$export$2f2af17d88fd3ee8 || ($a02365cfe34ea521$export$2f2af17d88fd3ee8 = {}));
const $a02365cfe34ea521$export$fabffc4850b69dca = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 3, 0);
const $a02365cfe34ea521$export$c1386a4b7c9e058b = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 4);
var $a02365cfe34ea521$export$241f4869bb1f3db1;
(function(FieldDescriptorProto_Type) {
    /**
     * 0 is reserved for errors.
     * Order is weird for historical reasons.
     *
     * @generated from enum value: TYPE_DOUBLE = 1;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["DOUBLE"] = 1] = "DOUBLE";
    /**
     * @generated from enum value: TYPE_FLOAT = 2;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["FLOAT"] = 2] = "FLOAT";
    /**
     * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
     * negative values are likely.
     *
     * @generated from enum value: TYPE_INT64 = 3;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["INT64"] = 3] = "INT64";
    /**
     * @generated from enum value: TYPE_UINT64 = 4;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["UINT64"] = 4] = "UINT64";
    /**
     * Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
     * negative values are likely.
     *
     * @generated from enum value: TYPE_INT32 = 5;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["INT32"] = 5] = "INT32";
    /**
     * @generated from enum value: TYPE_FIXED64 = 6;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["FIXED64"] = 6] = "FIXED64";
    /**
     * @generated from enum value: TYPE_FIXED32 = 7;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["FIXED32"] = 7] = "FIXED32";
    /**
     * @generated from enum value: TYPE_BOOL = 8;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["BOOL"] = 8] = "BOOL";
    /**
     * @generated from enum value: TYPE_STRING = 9;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["STRING"] = 9] = "STRING";
    /**
     * Tag-delimited aggregate.
     * Group type is deprecated and not supported after google.protobuf. However, Proto3
     * implementations should still be able to parse the group wire format and
     * treat group fields as unknown fields.  In Editions, the group wire format
     * can be enabled via the `message_encoding` feature.
     *
     * @generated from enum value: TYPE_GROUP = 10;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["GROUP"] = 10] = "GROUP";
    /**
     * Length-delimited aggregate.
     *
     * @generated from enum value: TYPE_MESSAGE = 11;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["MESSAGE"] = 11] = "MESSAGE";
    /**
     * New in version 2.
     *
     * @generated from enum value: TYPE_BYTES = 12;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["BYTES"] = 12] = "BYTES";
    /**
     * @generated from enum value: TYPE_UINT32 = 13;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["UINT32"] = 13] = "UINT32";
    /**
     * @generated from enum value: TYPE_ENUM = 14;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["ENUM"] = 14] = "ENUM";
    /**
     * @generated from enum value: TYPE_SFIXED32 = 15;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["SFIXED32"] = 15] = "SFIXED32";
    /**
     * @generated from enum value: TYPE_SFIXED64 = 16;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["SFIXED64"] = 16] = "SFIXED64";
    /**
     * Uses ZigZag encoding.
     *
     * @generated from enum value: TYPE_SINT32 = 17;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["SINT32"] = 17] = "SINT32";
    /**
     * Uses ZigZag encoding.
     *
     * @generated from enum value: TYPE_SINT64 = 18;
     */ FieldDescriptorProto_Type[FieldDescriptorProto_Type["SINT64"] = 18] = "SINT64";
})($a02365cfe34ea521$export$241f4869bb1f3db1 || ($a02365cfe34ea521$export$241f4869bb1f3db1 = {}));
const $a02365cfe34ea521$export$7ef354c5a2555876 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 4, 0);
var $a02365cfe34ea521$export$f6ea5be5c842745b;
(function(FieldDescriptorProto_Label) {
    /**
     * 0 is reserved for errors
     *
     * @generated from enum value: LABEL_OPTIONAL = 1;
     */ FieldDescriptorProto_Label[FieldDescriptorProto_Label["OPTIONAL"] = 1] = "OPTIONAL";
    /**
     * @generated from enum value: LABEL_REPEATED = 3;
     */ FieldDescriptorProto_Label[FieldDescriptorProto_Label["REPEATED"] = 3] = "REPEATED";
    /**
     * The required label is only allowed in google.protobuf.  In proto3 and Editions
     * it's explicitly prohibited.  In Editions, the `field_presence` feature
     * can be used to get this behavior.
     *
     * @generated from enum value: LABEL_REQUIRED = 2;
     */ FieldDescriptorProto_Label[FieldDescriptorProto_Label["REQUIRED"] = 2] = "REQUIRED";
})($a02365cfe34ea521$export$f6ea5be5c842745b || ($a02365cfe34ea521$export$f6ea5be5c842745b = {}));
const $a02365cfe34ea521$export$638f34781dda7372 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 4, 1);
const $a02365cfe34ea521$export$7a372ee4c81c98ad = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 5);
const $a02365cfe34ea521$export$19086a06cb98be6c = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 6);
const $a02365cfe34ea521$export$e671c2d972dea953 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 6, 0);
const $a02365cfe34ea521$export$678be3ea1ada9242 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 7);
const $a02365cfe34ea521$export$13cf6e34d92f95e3 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 8);
const $a02365cfe34ea521$export$b03028c0302c2e28 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 9);
const $a02365cfe34ea521$export$4d9c3d5e5d8ce223 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 10);
var $a02365cfe34ea521$export$ce914483272af8ab;
(function(FileOptions_OptimizeMode) {
    /**
     * Generate complete code for parsing, serialization,
     *
     * @generated from enum value: SPEED = 1;
     */ FileOptions_OptimizeMode[FileOptions_OptimizeMode["SPEED"] = 1] = "SPEED";
    /**
     * etc.
     *
     * Use ReflectionOps to implement these methods.
     *
     * @generated from enum value: CODE_SIZE = 2;
     */ FileOptions_OptimizeMode[FileOptions_OptimizeMode["CODE_SIZE"] = 2] = "CODE_SIZE";
    /**
     * Generate code using MessageLite and the lite runtime.
     *
     * @generated from enum value: LITE_RUNTIME = 3;
     */ FileOptions_OptimizeMode[FileOptions_OptimizeMode["LITE_RUNTIME"] = 3] = "LITE_RUNTIME";
})($a02365cfe34ea521$export$ce914483272af8ab || ($a02365cfe34ea521$export$ce914483272af8ab = {}));
const $a02365cfe34ea521$export$de3a76620235f46b = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 10, 0);
const $a02365cfe34ea521$export$496526ac7dfa006c = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 11);
const $a02365cfe34ea521$export$da5e850aa295a51 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12);
const $a02365cfe34ea521$export$acbe01ba23be2487 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 0);
const $a02365cfe34ea521$export$a8b768792b989735 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 1);
var $a02365cfe34ea521$export$9baece44e9df89a8;
(function(FieldOptions_CType) {
    /**
     * Default mode.
     *
     * @generated from enum value: STRING = 0;
     */ FieldOptions_CType[FieldOptions_CType["STRING"] = 0] = "STRING";
    /**
     * The option [ctype=CORD] may be applied to a non-repeated field of type
     * "bytes". It indicates that in C++, the data should be stored in a Cord
     * instead of a string.  For very large strings, this may reduce memory
     * fragmentation. It may also allow better performance when parsing from a
     * Cord, or when parsing with aliasing enabled, as the parsed Cord may then
     * alias the original buffer.
     *
     * @generated from enum value: CORD = 1;
     */ FieldOptions_CType[FieldOptions_CType["CORD"] = 1] = "CORD";
    /**
     * @generated from enum value: STRING_PIECE = 2;
     */ FieldOptions_CType[FieldOptions_CType["STRING_PIECE"] = 2] = "STRING_PIECE";
})($a02365cfe34ea521$export$9baece44e9df89a8 || ($a02365cfe34ea521$export$9baece44e9df89a8 = {}));
const $a02365cfe34ea521$export$7eb36dc6c06eb097 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 0);
var $a02365cfe34ea521$export$9e7aa114019f0036;
(function(FieldOptions_JSType) {
    /**
     * Use the default type.
     *
     * @generated from enum value: JS_NORMAL = 0;
     */ FieldOptions_JSType[FieldOptions_JSType["JS_NORMAL"] = 0] = "JS_NORMAL";
    /**
     * Use JavaScript strings.
     *
     * @generated from enum value: JS_STRING = 1;
     */ FieldOptions_JSType[FieldOptions_JSType["JS_STRING"] = 1] = "JS_STRING";
    /**
     * Use JavaScript numbers.
     *
     * @generated from enum value: JS_NUMBER = 2;
     */ FieldOptions_JSType[FieldOptions_JSType["JS_NUMBER"] = 2] = "JS_NUMBER";
})($a02365cfe34ea521$export$9e7aa114019f0036 || ($a02365cfe34ea521$export$9e7aa114019f0036 = {}));
const $a02365cfe34ea521$export$c4422aa5bf4ff3dd = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 1);
var $a02365cfe34ea521$export$3570c3071e8f4c2f;
(function(FieldOptions_OptionRetention) {
    /**
     * @generated from enum value: RETENTION_UNKNOWN = 0;
     */ FieldOptions_OptionRetention[FieldOptions_OptionRetention["RETENTION_UNKNOWN"] = 0] = "RETENTION_UNKNOWN";
    /**
     * @generated from enum value: RETENTION_RUNTIME = 1;
     */ FieldOptions_OptionRetention[FieldOptions_OptionRetention["RETENTION_RUNTIME"] = 1] = "RETENTION_RUNTIME";
    /**
     * @generated from enum value: RETENTION_SOURCE = 2;
     */ FieldOptions_OptionRetention[FieldOptions_OptionRetention["RETENTION_SOURCE"] = 2] = "RETENTION_SOURCE";
})($a02365cfe34ea521$export$3570c3071e8f4c2f || ($a02365cfe34ea521$export$3570c3071e8f4c2f = {}));
const $a02365cfe34ea521$export$1f313858deb1182f = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 2);
var $a02365cfe34ea521$export$9f4cd3731d79be21;
(function(FieldOptions_OptionTargetType) {
    /**
     * @generated from enum value: TARGET_TYPE_UNKNOWN = 0;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_UNKNOWN"] = 0] = "TARGET_TYPE_UNKNOWN";
    /**
     * @generated from enum value: TARGET_TYPE_FILE = 1;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_FILE"] = 1] = "TARGET_TYPE_FILE";
    /**
     * @generated from enum value: TARGET_TYPE_EXTENSION_RANGE = 2;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_EXTENSION_RANGE"] = 2] = "TARGET_TYPE_EXTENSION_RANGE";
    /**
     * @generated from enum value: TARGET_TYPE_MESSAGE = 3;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_MESSAGE"] = 3] = "TARGET_TYPE_MESSAGE";
    /**
     * @generated from enum value: TARGET_TYPE_FIELD = 4;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_FIELD"] = 4] = "TARGET_TYPE_FIELD";
    /**
     * @generated from enum value: TARGET_TYPE_ONEOF = 5;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_ONEOF"] = 5] = "TARGET_TYPE_ONEOF";
    /**
     * @generated from enum value: TARGET_TYPE_ENUM = 6;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_ENUM"] = 6] = "TARGET_TYPE_ENUM";
    /**
     * @generated from enum value: TARGET_TYPE_ENUM_ENTRY = 7;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_ENUM_ENTRY"] = 7] = "TARGET_TYPE_ENUM_ENTRY";
    /**
     * @generated from enum value: TARGET_TYPE_SERVICE = 8;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_SERVICE"] = 8] = "TARGET_TYPE_SERVICE";
    /**
     * @generated from enum value: TARGET_TYPE_METHOD = 9;
     */ FieldOptions_OptionTargetType[FieldOptions_OptionTargetType["TARGET_TYPE_METHOD"] = 9] = "TARGET_TYPE_METHOD";
})($a02365cfe34ea521$export$9f4cd3731d79be21 || ($a02365cfe34ea521$export$9f4cd3731d79be21 = {}));
const $a02365cfe34ea521$export$ddcde66242a64f90 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 12, 3);
const $a02365cfe34ea521$export$a5664c8d48f55a29 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 13);
const $a02365cfe34ea521$export$880783747fcb6410 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 14);
const $a02365cfe34ea521$export$3204605df718f1ab = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 15);
const $a02365cfe34ea521$export$bd25f29bc51055b8 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 16);
const $a02365cfe34ea521$export$33fcf1fe7ac92ac4 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 17);
var $a02365cfe34ea521$export$49b4a905951fdc74;
(function(MethodOptions_IdempotencyLevel) {
    /**
     * @generated from enum value: IDEMPOTENCY_UNKNOWN = 0;
     */ MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["IDEMPOTENCY_UNKNOWN"] = 0] = "IDEMPOTENCY_UNKNOWN";
    /**
     * implies idempotent
     *
     * @generated from enum value: NO_SIDE_EFFECTS = 1;
     */ MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["NO_SIDE_EFFECTS"] = 1] = "NO_SIDE_EFFECTS";
    /**
     * idempotent, but may have side effects
     *
     * @generated from enum value: IDEMPOTENT = 2;
     */ MethodOptions_IdempotencyLevel[MethodOptions_IdempotencyLevel["IDEMPOTENT"] = 2] = "IDEMPOTENT";
})($a02365cfe34ea521$export$49b4a905951fdc74 || ($a02365cfe34ea521$export$49b4a905951fdc74 = {}));
const $a02365cfe34ea521$export$d65c33d16755164a = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 17, 0);
const $a02365cfe34ea521$export$d4fa4eb9bf471783 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 18);
const $a02365cfe34ea521$export$630f0043a5cf6dff = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 18, 0);
const $a02365cfe34ea521$export$410ccc62b4a1f069 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19);
var $a02365cfe34ea521$export$a63377d77e46d6de;
(function(FeatureSet_FieldPresence) {
    /**
     * @generated from enum value: FIELD_PRESENCE_UNKNOWN = 0;
     */ FeatureSet_FieldPresence[FeatureSet_FieldPresence["FIELD_PRESENCE_UNKNOWN"] = 0] = "FIELD_PRESENCE_UNKNOWN";
    /**
     * @generated from enum value: EXPLICIT = 1;
     */ FeatureSet_FieldPresence[FeatureSet_FieldPresence["EXPLICIT"] = 1] = "EXPLICIT";
    /**
     * @generated from enum value: IMPLICIT = 2;
     */ FeatureSet_FieldPresence[FeatureSet_FieldPresence["IMPLICIT"] = 2] = "IMPLICIT";
    /**
     * @generated from enum value: LEGACY_REQUIRED = 3;
     */ FeatureSet_FieldPresence[FeatureSet_FieldPresence["LEGACY_REQUIRED"] = 3] = "LEGACY_REQUIRED";
})($a02365cfe34ea521$export$a63377d77e46d6de || ($a02365cfe34ea521$export$a63377d77e46d6de = {}));
const $a02365cfe34ea521$export$a1d818d3139d9c33 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 0);
var $a02365cfe34ea521$export$f9401cfafaf426df;
(function(FeatureSet_EnumType) {
    /**
     * @generated from enum value: ENUM_TYPE_UNKNOWN = 0;
     */ FeatureSet_EnumType[FeatureSet_EnumType["ENUM_TYPE_UNKNOWN"] = 0] = "ENUM_TYPE_UNKNOWN";
    /**
     * @generated from enum value: OPEN = 1;
     */ FeatureSet_EnumType[FeatureSet_EnumType["OPEN"] = 1] = "OPEN";
    /**
     * @generated from enum value: CLOSED = 2;
     */ FeatureSet_EnumType[FeatureSet_EnumType["CLOSED"] = 2] = "CLOSED";
})($a02365cfe34ea521$export$f9401cfafaf426df || ($a02365cfe34ea521$export$f9401cfafaf426df = {}));
const $a02365cfe34ea521$export$fe8c1e904666845d = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 1);
var $a02365cfe34ea521$export$7de3d0e9fc5ff6a2;
(function(FeatureSet_RepeatedFieldEncoding) {
    /**
     * @generated from enum value: REPEATED_FIELD_ENCODING_UNKNOWN = 0;
     */ FeatureSet_RepeatedFieldEncoding[FeatureSet_RepeatedFieldEncoding["REPEATED_FIELD_ENCODING_UNKNOWN"] = 0] = "REPEATED_FIELD_ENCODING_UNKNOWN";
    /**
     * @generated from enum value: PACKED = 1;
     */ FeatureSet_RepeatedFieldEncoding[FeatureSet_RepeatedFieldEncoding["PACKED"] = 1] = "PACKED";
    /**
     * @generated from enum value: EXPANDED = 2;
     */ FeatureSet_RepeatedFieldEncoding[FeatureSet_RepeatedFieldEncoding["EXPANDED"] = 2] = "EXPANDED";
})($a02365cfe34ea521$export$7de3d0e9fc5ff6a2 || ($a02365cfe34ea521$export$7de3d0e9fc5ff6a2 = {}));
const $a02365cfe34ea521$export$57b3d4796039a8e0 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 2);
var $a02365cfe34ea521$export$9b0d7ed359bd4d4;
(function(FeatureSet_Utf8Validation) {
    /**
     * @generated from enum value: UTF8_VALIDATION_UNKNOWN = 0;
     */ FeatureSet_Utf8Validation[FeatureSet_Utf8Validation["UTF8_VALIDATION_UNKNOWN"] = 0] = "UTF8_VALIDATION_UNKNOWN";
    /**
     * @generated from enum value: VERIFY = 2;
     */ FeatureSet_Utf8Validation[FeatureSet_Utf8Validation["VERIFY"] = 2] = "VERIFY";
    /**
     * @generated from enum value: NONE = 3;
     */ FeatureSet_Utf8Validation[FeatureSet_Utf8Validation["NONE"] = 3] = "NONE";
})($a02365cfe34ea521$export$9b0d7ed359bd4d4 || ($a02365cfe34ea521$export$9b0d7ed359bd4d4 = {}));
const $a02365cfe34ea521$export$cb04eac9f7ad30dd = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 3);
var $a02365cfe34ea521$export$1706a4c6e103716e;
(function(FeatureSet_MessageEncoding) {
    /**
     * @generated from enum value: MESSAGE_ENCODING_UNKNOWN = 0;
     */ FeatureSet_MessageEncoding[FeatureSet_MessageEncoding["MESSAGE_ENCODING_UNKNOWN"] = 0] = "MESSAGE_ENCODING_UNKNOWN";
    /**
     * @generated from enum value: LENGTH_PREFIXED = 1;
     */ FeatureSet_MessageEncoding[FeatureSet_MessageEncoding["LENGTH_PREFIXED"] = 1] = "LENGTH_PREFIXED";
    /**
     * @generated from enum value: DELIMITED = 2;
     */ FeatureSet_MessageEncoding[FeatureSet_MessageEncoding["DELIMITED"] = 2] = "DELIMITED";
})($a02365cfe34ea521$export$1706a4c6e103716e || ($a02365cfe34ea521$export$1706a4c6e103716e = {}));
const $a02365cfe34ea521$export$1670a46b5ae01bd5 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 4);
var $a02365cfe34ea521$export$1b7ede54480d9af;
(function(FeatureSet_JsonFormat) {
    /**
     * @generated from enum value: JSON_FORMAT_UNKNOWN = 0;
     */ FeatureSet_JsonFormat[FeatureSet_JsonFormat["JSON_FORMAT_UNKNOWN"] = 0] = "JSON_FORMAT_UNKNOWN";
    /**
     * @generated from enum value: ALLOW = 1;
     */ FeatureSet_JsonFormat[FeatureSet_JsonFormat["ALLOW"] = 1] = "ALLOW";
    /**
     * @generated from enum value: LEGACY_BEST_EFFORT = 2;
     */ FeatureSet_JsonFormat[FeatureSet_JsonFormat["LEGACY_BEST_EFFORT"] = 2] = "LEGACY_BEST_EFFORT";
})($a02365cfe34ea521$export$1b7ede54480d9af || ($a02365cfe34ea521$export$1b7ede54480d9af = {}));
const $a02365cfe34ea521$export$f4795d5eb2085877 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 5);
var $a02365cfe34ea521$export$5cb461de84580033;
(function(FeatureSet_EnforceNamingStyle) {
    /**
     * @generated from enum value: ENFORCE_NAMING_STYLE_UNKNOWN = 0;
     */ FeatureSet_EnforceNamingStyle[FeatureSet_EnforceNamingStyle["ENFORCE_NAMING_STYLE_UNKNOWN"] = 0] = "ENFORCE_NAMING_STYLE_UNKNOWN";
    /**
     * @generated from enum value: STYLE2024 = 1;
     */ FeatureSet_EnforceNamingStyle[FeatureSet_EnforceNamingStyle["STYLE2024"] = 1] = "STYLE2024";
    /**
     * @generated from enum value: STYLE_LEGACY = 2;
     */ FeatureSet_EnforceNamingStyle[FeatureSet_EnforceNamingStyle["STYLE_LEGACY"] = 2] = "STYLE_LEGACY";
})($a02365cfe34ea521$export$5cb461de84580033 || ($a02365cfe34ea521$export$5cb461de84580033 = {}));
const $a02365cfe34ea521$export$28d7063ce076a317 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 19, 6);
const $a02365cfe34ea521$export$9a0e36424664d585 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 20);
const $a02365cfe34ea521$export$2edcaeab8a4cc321 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 20, 0);
const $a02365cfe34ea521$export$15ec62435ce6792a = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 21);
const $a02365cfe34ea521$export$df25be0b1dc06dd3 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 21, 0);
const $a02365cfe34ea521$export$64d209158be82e5 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 22);
const $a02365cfe34ea521$export$7089878efcac66c4 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 22, 0);
var $a02365cfe34ea521$export$e4edf8c70d10d853;
(function(GeneratedCodeInfo_Annotation_Semantic) {
    /**
     * There is no effect or the effect is indescribable.
     *
     * @generated from enum value: NONE = 0;
     */ GeneratedCodeInfo_Annotation_Semantic[GeneratedCodeInfo_Annotation_Semantic["NONE"] = 0] = "NONE";
    /**
     * The element is set or otherwise mutated.
     *
     * @generated from enum value: SET = 1;
     */ GeneratedCodeInfo_Annotation_Semantic[GeneratedCodeInfo_Annotation_Semantic["SET"] = 1] = "SET";
    /**
     * An alias to the element is returned.
     *
     * @generated from enum value: ALIAS = 2;
     */ GeneratedCodeInfo_Annotation_Semantic[GeneratedCodeInfo_Annotation_Semantic["ALIAS"] = 2] = "ALIAS";
})($a02365cfe34ea521$export$e4edf8c70d10d853 || ($a02365cfe34ea521$export$e4edf8c70d10d853 = {}));
const $a02365cfe34ea521$export$cbb5631935eb504a = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 22, 0, 0);
var $a02365cfe34ea521$export$6f4a0f769e61929;
(function(Edition) {
    /**
     * A placeholder for an unknown edition value.
     *
     * @generated from enum value: EDITION_UNKNOWN = 0;
     */ Edition[Edition["EDITION_UNKNOWN"] = 0] = "EDITION_UNKNOWN";
    /**
     * A placeholder edition for specifying default behaviors *before* a feature
     * was first introduced.  This is effectively an "infinite past".
     *
     * @generated from enum value: EDITION_LEGACY = 900;
     */ Edition[Edition["EDITION_LEGACY"] = 900] = "EDITION_LEGACY";
    /**
     * Legacy syntax "editions".  These pre-date editions, but behave much like
     * distinct editions.  These can't be used to specify the edition of proto
     * files, but feature definitions must supply proto2/proto3 defaults for
     * backwards compatibility.
     *
     * @generated from enum value: EDITION_PROTO2 = 998;
     */ Edition[Edition["EDITION_PROTO2"] = 998] = "EDITION_PROTO2";
    /**
     * @generated from enum value: EDITION_PROTO3 = 999;
     */ Edition[Edition["EDITION_PROTO3"] = 999] = "EDITION_PROTO3";
    /**
     * Editions that have been released.  The specific values are arbitrary and
     * should not be depended on, but they will always be time-ordered for easy
     * comparison.
     *
     * @generated from enum value: EDITION_2023 = 1000;
     */ Edition[Edition["EDITION_2023"] = 1000] = "EDITION_2023";
    /**
     * @generated from enum value: EDITION_2024 = 1001;
     */ Edition[Edition["EDITION_2024"] = 1001] = "EDITION_2024";
    /**
     * Placeholder editions for testing feature resolution.  These should not be
     * used or relied on outside of tests.
     *
     * @generated from enum value: EDITION_1_TEST_ONLY = 1;
     */ Edition[Edition["EDITION_1_TEST_ONLY"] = 1] = "EDITION_1_TEST_ONLY";
    /**
     * @generated from enum value: EDITION_2_TEST_ONLY = 2;
     */ Edition[Edition["EDITION_2_TEST_ONLY"] = 2] = "EDITION_2_TEST_ONLY";
    /**
     * @generated from enum value: EDITION_99997_TEST_ONLY = 99997;
     */ Edition[Edition["EDITION_99997_TEST_ONLY"] = 99997] = "EDITION_99997_TEST_ONLY";
    /**
     * @generated from enum value: EDITION_99998_TEST_ONLY = 99998;
     */ Edition[Edition["EDITION_99998_TEST_ONLY"] = 99998] = "EDITION_99998_TEST_ONLY";
    /**
     * @generated from enum value: EDITION_99999_TEST_ONLY = 99999;
     */ Edition[Edition["EDITION_99999_TEST_ONLY"] = 99999] = "EDITION_99999_TEST_ONLY";
    /**
     * Placeholder for specifying unbounded edition support.  This should only
     * ever be used by plugins that can expect to never require any changes to
     * support a new edition.
     *
     * @generated from enum value: EDITION_MAX = 2147483647;
     */ Edition[Edition["EDITION_MAX"] = 2147483647] = "EDITION_MAX";
})($a02365cfe34ea521$export$6f4a0f769e61929 || ($a02365cfe34ea521$export$6f4a0f769e61929 = {}));
const $a02365cfe34ea521$export$34bbee8cc46bd2d7 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($a02365cfe34ea521$export$28b5a4f46d6a06a, 0);

});
parcelRegister("hvQKw", function(module, exports) {

$parcel$export(module.exports, "boot", () => $cbfe3fd1d49c4283$export$a0bdb191b5cd44cd);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $iarWv = parcelRequire("iarWv");

var $8U2QW = parcelRequire("8U2QW");
function $cbfe3fd1d49c4283$export$a0bdb191b5cd44cd(boot) {
    const root = $cbfe3fd1d49c4283$export$a803697760441488(boot);
    root.messageType.forEach((0, $iarWv.restoreJsonNames));
    const reg = (0, $8U2QW.createFileRegistry)(root, ()=>undefined);
    // biome-ignore lint/style/noNonNullAssertion: non-null assertion because we just created the registry from the file we look up
    return reg.getFile(root.name);
}
function $cbfe3fd1d49c4283$export$a803697760441488(init) {
    const proto = Object.create({
        syntax: "",
        edition: 0
    });
    return Object.assign(proto, Object.assign(Object.assign({
        $typeName: "google.protobuf.FileDescriptorProto",
        dependency: [],
        publicDependency: [],
        weakDependency: [],
        service: [],
        extension: []
    }, init), {
        messageType: init.messageType.map($cbfe3fd1d49c4283$var$bootDescriptorProto),
        enumType: init.enumType.map($cbfe3fd1d49c4283$var$bootEnumDescriptorProto)
    }));
}
function $cbfe3fd1d49c4283$var$bootDescriptorProto(init) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        $typeName: "google.protobuf.DescriptorProto",
        name: init.name,
        field: (_b = (_a = init.field) === null || _a === void 0 ? void 0 : _a.map($cbfe3fd1d49c4283$var$bootFieldDescriptorProto)) !== null && _b !== void 0 ? _b : [],
        extension: [],
        nestedType: (_d = (_c = init.nestedType) === null || _c === void 0 ? void 0 : _c.map($cbfe3fd1d49c4283$var$bootDescriptorProto)) !== null && _d !== void 0 ? _d : [],
        enumType: (_f = (_e = init.enumType) === null || _e === void 0 ? void 0 : _e.map($cbfe3fd1d49c4283$var$bootEnumDescriptorProto)) !== null && _f !== void 0 ? _f : [],
        extensionRange: (_h = (_g = init.extensionRange) === null || _g === void 0 ? void 0 : _g.map((e)=>Object.assign({
                $typeName: "google.protobuf.DescriptorProto.ExtensionRange"
            }, e))) !== null && _h !== void 0 ? _h : [],
        oneofDecl: [],
        reservedRange: [],
        reservedName: []
    };
}
function $cbfe3fd1d49c4283$var$bootFieldDescriptorProto(init) {
    const proto = Object.create({
        label: 1,
        typeName: "",
        extendee: "",
        defaultValue: "",
        oneofIndex: 0,
        jsonName: "",
        proto3Optional: false
    });
    return Object.assign(proto, Object.assign(Object.assign({
        $typeName: "google.protobuf.FieldDescriptorProto"
    }, init), {
        options: init.options ? $cbfe3fd1d49c4283$var$bootFieldOptions(init.options) : undefined
    }));
}
function $cbfe3fd1d49c4283$var$bootFieldOptions(init) {
    var _a, _b, _c;
    const proto = Object.create({
        ctype: 0,
        packed: false,
        jstype: 0,
        lazy: false,
        unverifiedLazy: false,
        deprecated: false,
        weak: false,
        debugRedact: false,
        retention: 0
    });
    return Object.assign(proto, Object.assign(Object.assign({
        $typeName: "google.protobuf.FieldOptions"
    }, init), {
        targets: (_a = init.targets) !== null && _a !== void 0 ? _a : [],
        editionDefaults: (_c = (_b = init.editionDefaults) === null || _b === void 0 ? void 0 : _b.map((e)=>Object.assign({
                $typeName: "google.protobuf.FieldOptions.EditionDefault"
            }, e))) !== null && _c !== void 0 ? _c : [],
        uninterpretedOption: []
    }));
}
function $cbfe3fd1d49c4283$var$bootEnumDescriptorProto(init) {
    return {
        $typeName: "google.protobuf.EnumDescriptorProto",
        name: init.name,
        reservedName: [],
        reservedRange: [],
        value: init.value.map((e)=>Object.assign({
                $typeName: "google.protobuf.EnumValueDescriptorProto"
            }, e))
    };
}

});
parcelRegister("iarWv", function(module, exports) {

$parcel$export(module.exports, "restoreJsonNames", () => $d39ed604074a0c5a$export$ad82a4c46161b5b1);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $kLINC = parcelRequire("kLINC");

var $2eQsm = parcelRequire("2eQsm");
function $d39ed604074a0c5a$export$ad82a4c46161b5b1(message) {
    for (const f of message.field)if (!(0, $2eQsm.unsafeIsSetExplicit)(f, "jsonName")) f.jsonName = (0, $kLINC.protoCamelCase)(f.name);
    message.nestedType.forEach($d39ed604074a0c5a$export$ad82a4c46161b5b1);
}

});
parcelRegister("kLINC", function(module, exports) {

$parcel$export(module.exports, "protoCamelCase", () => $f1eaf2a4b2486bf1$export$704013643ef6897e);
$parcel$export(module.exports, "safeObjectProperty", () => $f1eaf2a4b2486bf1$export$a155f4a1728b38bf);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Return a fully-qualified name for a Protobuf descriptor.
 * For a file descriptor, return the original file path.
 *
 * See https://protobuf.com/docs/language-spec#fully-qualified-names
 */ function $f1eaf2a4b2486bf1$export$5e8161a5fb00e354(desc) {
    switch(desc.kind){
        case "field":
        case "oneof":
        case "rpc":
            return desc.parent.typeName + "." + desc.name;
        case "enum_value":
            {
                const p = desc.parent.parent ? desc.parent.parent.typeName : desc.parent.file.proto.package;
                return p + (p.length > 0 ? "." : "") + desc.name;
            }
        case "service":
        case "message":
        case "enum":
        case "extension":
            return desc.typeName;
        case "file":
            return desc.proto.name;
    }
}
function $f1eaf2a4b2486bf1$export$704013643ef6897e(snakeCase) {
    let capNext = false;
    const b = [];
    for(let i = 0; i < snakeCase.length; i++){
        let c = snakeCase.charAt(i);
        switch(c){
            case "_":
                capNext = true;
                break;
            case "0":
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                b.push(c);
                capNext = false;
                break;
            default:
                if (capNext) {
                    capNext = false;
                    c = c.toUpperCase();
                }
                b.push(c);
                break;
        }
    }
    return b.join("");
}
/**
 * Names that cannot be used for object properties because they are reserved
 * by built-in JavaScript properties.
 */ const $f1eaf2a4b2486bf1$var$reservedObjectProperties = new Set([
    // names reserved by JavaScript
    "constructor",
    "toString",
    "toJSON",
    "valueOf"
]);
function $f1eaf2a4b2486bf1$export$a155f4a1728b38bf(name) {
    return $f1eaf2a4b2486bf1$var$reservedObjectProperties.has(name) ? name + "$" : name;
}

});

parcelRegister("2eQsm", function(module, exports) {

$parcel$export(module.exports, "unsafeLocal", () => $1a159452f78154d5$export$b82922263072e30d);
$parcel$export(module.exports, "unsafeOneofCase", () => $1a159452f78154d5$export$fa9e598f657b3d86);
$parcel$export(module.exports, "unsafeIsSet", () => $1a159452f78154d5$export$1be5f429ab68754f);
$parcel$export(module.exports, "unsafeIsSetExplicit", () => $1a159452f78154d5$export$87475b4dc2997dc5);
$parcel$export(module.exports, "unsafeGet", () => $1a159452f78154d5$export$1d94535d2cda4eda);
$parcel$export(module.exports, "unsafeSet", () => $1a159452f78154d5$export$444262986932b766);
$parcel$export(module.exports, "unsafeClear", () => $1a159452f78154d5$export$c90a3332b5affbfe);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lipan = parcelRequire("lipan");
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name: FeatureSet_FieldPresence.$localName = $number;
const $1a159452f78154d5$var$IMPLICIT = 2;
const $1a159452f78154d5$export$b82922263072e30d = Symbol.for("reflect unsafe local");
function $1a159452f78154d5$export$fa9e598f657b3d86(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, oneof) {
    const c = target[oneof.localName].case;
    if (c === undefined) return c;
    return oneof.fields.find((f)=>f.localName === c);
}
function $1a159452f78154d5$export$1be5f429ab68754f(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, field) {
    const name = field.localName;
    if (field.oneof) return target[field.oneof.localName].case === name;
    if (field.presence != $1a159452f78154d5$var$IMPLICIT) // Fields with explicit presence have properties on the prototype chain
    // for default / zero values (except for proto3).
    return target[name] !== undefined && Object.prototype.hasOwnProperty.call(target, name);
    switch(field.fieldKind){
        case "list":
            return target[name].length > 0;
        case "map":
            return Object.keys(target[name]).length > 0;
        case "scalar":
            return !(0, $lipan.isScalarZeroValue)(field.scalar, target[name]);
        case "enum":
            return target[name] !== field.enum.values[0].number;
    }
    throw new Error("message field with implicit presence");
}
function $1a159452f78154d5$export$87475b4dc2997dc5(target, localName) {
    return Object.prototype.hasOwnProperty.call(target, localName) && target[localName] !== undefined;
}
function $1a159452f78154d5$export$1d94535d2cda4eda(target, field) {
    if (field.oneof) {
        const oneof = target[field.oneof.localName];
        if (oneof.case === field.localName) return oneof.value;
        return undefined;
    }
    return target[field.localName];
}
function $1a159452f78154d5$export$444262986932b766(target, field, value) {
    if (field.oneof) target[field.oneof.localName] = {
        case: field.localName,
        value: value
    };
    else target[field.localName] = value;
}
function $1a159452f78154d5$export$c90a3332b5affbfe(// biome-ignore lint/suspicious/noExplicitAny: `any` is the best choice for dynamic access
target, field) {
    const name = field.localName;
    if (field.oneof) {
        const oneofLocalName = field.oneof.localName;
        if (target[oneofLocalName].case === name) target[oneofLocalName] = {
            case: undefined
        };
    } else if (field.presence != $1a159452f78154d5$var$IMPLICIT) // Fields with explicit presence have properties on the prototype chain
    // for default / zero values (except for proto3). By deleting their own
    // property, the field is reset.
    delete target[name];
    else switch(field.fieldKind){
        case "map":
            target[name] = {};
            break;
        case "list":
            target[name] = [];
            break;
        case "enum":
            target[name] = field.enum.values[0].number;
            break;
        case "scalar":
            target[name] = (0, $lipan.scalarZeroValue)(field.scalar, field.longAsString);
            break;
    }
}

});
parcelRegister("lipan", function(module, exports) {

$parcel$export(module.exports, "scalarEquals", () => $f80eccec2f6d1cdd$export$6441cb6ddae1ded);
$parcel$export(module.exports, "scalarZeroValue", () => $f80eccec2f6d1cdd$export$85ea56b49d274603);
$parcel$export(module.exports, "isScalarZeroValue", () => $f80eccec2f6d1cdd$export$c054332acc90976);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $6zK55 = parcelRequire("6zK55");

var $8xxTQ = parcelRequire("8xxTQ");
function $f80eccec2f6d1cdd$export$6441cb6ddae1ded(type, a, b) {
    if (a === b) // This correctly matches equal values except BYTES and (possibly) 64-bit integers.
    return true;
    // Special case BYTES - we need to compare each byte individually
    if (type == (0, $8xxTQ.ScalarType).BYTES) {
        if (!(a instanceof Uint8Array) || !(b instanceof Uint8Array)) return false;
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // Special case 64-bit integers - we support number, string and bigint representation.
    switch(type){
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            // Loose comparison will match between 0n, 0 and "0".
            return a == b;
    }
    // Anything that hasn't been caught by strict comparison or special cased
    // BYTES and 64-bit integers is not equal.
    return false;
}
function $f80eccec2f6d1cdd$export$85ea56b49d274603(type, longAsString) {
    switch(type){
        case (0, $8xxTQ.ScalarType).STRING:
            return "";
        case (0, $8xxTQ.ScalarType).BOOL:
            return false;
        case (0, $8xxTQ.ScalarType).DOUBLE:
        case (0, $8xxTQ.ScalarType).FLOAT:
            return 0.0;
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            return longAsString ? "0" : (0, $6zK55.protoInt64).zero;
        case (0, $8xxTQ.ScalarType).BYTES:
            return new Uint8Array(0);
        default:
            // Handles INT32, UINT32, SINT32, FIXED32, SFIXED32.
            // We do not use individual cases to save a few bytes code size.
            return 0;
    }
}
function $f80eccec2f6d1cdd$export$c054332acc90976(type, value) {
    switch(type){
        case (0, $8xxTQ.ScalarType).BOOL:
            return value === false;
        case (0, $8xxTQ.ScalarType).STRING:
            return value === "";
        case (0, $8xxTQ.ScalarType).BYTES:
            return value instanceof Uint8Array && !value.byteLength;
        default:
            return value == 0; // Loose comparison matches 0n, 0 and "0"
    }
}

});
parcelRegister("6zK55", function(module, exports) {

$parcel$export(module.exports, "protoInt64", () => $4c99c1b3db3bc3e5$export$e60de6d3049738ba);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $ftkgD = parcelRequire("ftkgD");
const $4c99c1b3db3bc3e5$export$e60de6d3049738ba = /*@__PURE__*/ $4c99c1b3db3bc3e5$var$makeInt64Support();
function $4c99c1b3db3bc3e5$var$makeInt64Support() {
    const dv = new DataView(new ArrayBuffer(8));
    // note that Safari 14 implements BigInt, but not the DataView methods
    const ok = typeof BigInt === "function" && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function" && true;
    if (ok) {
        const MIN = BigInt("-9223372036854775808");
        const MAX = BigInt("9223372036854775807");
        const UMIN = BigInt("0");
        const UMAX = BigInt("18446744073709551615");
        return {
            zero: BigInt(0),
            supported: true,
            parse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > MAX || bi < MIN) throw new Error(`invalid int64: ${value}`);
                return bi;
            },
            uParse (value) {
                const bi = typeof value == "bigint" ? value : BigInt(value);
                if (bi > UMAX || bi < UMIN) throw new Error(`invalid uint64: ${value}`);
                return bi;
            },
            enc (value) {
                dv.setBigInt64(0, this.parse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            uEnc (value) {
                dv.setBigInt64(0, this.uParse(value), true);
                return {
                    lo: dv.getInt32(0, true),
                    hi: dv.getInt32(4, true)
                };
            },
            dec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigInt64(0, true);
            },
            uDec (lo, hi) {
                dv.setInt32(0, lo, true);
                dv.setInt32(4, hi, true);
                return dv.getBigUint64(0, true);
            }
        };
    }
    return {
        zero: "0",
        supported: false,
        parse (value) {
            if (typeof value != "string") value = value.toString();
            $4c99c1b3db3bc3e5$var$assertInt64String(value);
            return value;
        },
        uParse (value) {
            if (typeof value != "string") value = value.toString();
            $4c99c1b3db3bc3e5$var$assertUInt64String(value);
            return value;
        },
        enc (value) {
            if (typeof value != "string") value = value.toString();
            $4c99c1b3db3bc3e5$var$assertInt64String(value);
            return (0, $ftkgD.int64FromString)(value);
        },
        uEnc (value) {
            if (typeof value != "string") value = value.toString();
            $4c99c1b3db3bc3e5$var$assertUInt64String(value);
            return (0, $ftkgD.int64FromString)(value);
        },
        dec (lo, hi) {
            return (0, $ftkgD.int64ToString)(lo, hi);
        },
        uDec (lo, hi) {
            return (0, $ftkgD.uInt64ToString)(lo, hi);
        }
    };
}
function $4c99c1b3db3bc3e5$var$assertInt64String(value) {
    if (!/^-?[0-9]+$/.test(value)) throw new Error("invalid int64: " + value);
}
function $4c99c1b3db3bc3e5$var$assertUInt64String(value) {
    if (!/^[0-9]+$/.test(value)) throw new Error("invalid uint64: " + value);
}

});
parcelRegister("ftkgD", function(module, exports) {

$parcel$export(module.exports, "varint64read", () => $b439491fd1adc660$export$e5171d1968013adb);
$parcel$export(module.exports, "varint64write", () => $b439491fd1adc660$export$ff01ce396ff3d61f);
$parcel$export(module.exports, "int64FromString", () => $b439491fd1adc660$export$d17ea9dc9808b4fc);
$parcel$export(module.exports, "int64ToString", () => $b439491fd1adc660$export$4012a95a346cab46);
$parcel$export(module.exports, "uInt64ToString", () => $b439491fd1adc660$export$8a12d437d2c35d8f);
$parcel$export(module.exports, "varint32write", () => $b439491fd1adc660$export$77a3057e70db7f11);
$parcel$export(module.exports, "varint32read", () => $b439491fd1adc660$export$7138ea6223338e60);
// Copyright 2008 Google Inc.  All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
// * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
// * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
// * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
// Code generated by the Protocol Buffer compiler is owned by the owner
// of the input file used when generating it.  This code is not
// standalone and requires a support library to be linked with it.  This
// support library is itself covered by the above license.
/**
 * Read a 64 bit varint as two JS numbers.
 *
 * Returns tuple:
 * [0]: low bits
 * [1]: high bits
 *
 * Copyright 2008 Google Inc.  All rights reserved.
 *
 * See https://github.com/protocolbuffers/protobuf/blob/8a71927d74a4ce34efe2d8769fda198f52d20d12/js/experimental/runtime/kernel/buffer_decoder.js#L175
 */ function $b439491fd1adc660$export$e5171d1968013adb() {
    let lowBits = 0;
    let highBits = 0;
    for(let shift = 0; shift < 28; shift += 7){
        let b = this.buf[this.pos++];
        lowBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    let middleByte = this.buf[this.pos++];
    // last four bits of the first 32 bit number
    lowBits |= (middleByte & 0x0f) << 28;
    // 3 upper bits are part of the next 32 bit number
    highBits = (middleByte & 0x70) >> 4;
    if ((middleByte & 0x80) == 0) {
        this.assertBounds();
        return [
            lowBits,
            highBits
        ];
    }
    for(let shift = 3; shift <= 31; shift += 7){
        let b = this.buf[this.pos++];
        highBits |= (b & 0x7f) << shift;
        if ((b & 0x80) == 0) {
            this.assertBounds();
            return [
                lowBits,
                highBits
            ];
        }
    }
    throw new Error("invalid varint");
}
function $b439491fd1adc660$export$ff01ce396ff3d61f(lo, hi, bytes) {
    for(let i = 0; i < 28; i = i + 7){
        const shift = lo >>> i;
        const hasNext = !(shift >>> 7 == 0 && hi == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    const splitBits = lo >>> 28 & 0x0f | (hi & 0x07) << 4;
    const hasMoreBits = !(hi >> 3 == 0);
    bytes.push((hasMoreBits ? splitBits | 0x80 : splitBits) & 0xff);
    if (!hasMoreBits) return;
    for(let i = 3; i < 31; i = i + 7){
        const shift = hi >>> i;
        const hasNext = !(shift >>> 7 == 0);
        const byte = (hasNext ? shift | 0x80 : shift) & 0xff;
        bytes.push(byte);
        if (!hasNext) return;
    }
    bytes.push(hi >>> 31 & 0x01);
}
// constants for binary math
const $b439491fd1adc660$var$TWO_PWR_32_DBL = 0x100000000;
function $b439491fd1adc660$export$d17ea9dc9808b4fc(dec) {
    // Check for minus sign.
    const minus = dec[0] === "-";
    if (minus) dec = dec.slice(1);
    // Work 6 decimal digits at a time, acting like we're converting base 1e6
    // digits to binary. This is safe to do with floating point math because
    // Number.isSafeInteger(ALL_32_BITS * 1e6) == true.
    const base = 1e6;
    let lowBits = 0;
    let highBits = 0;
    function add1e6digit(begin, end) {
        // Note: Number('') is 0.
        const digit1e6 = Number(dec.slice(begin, end));
        highBits *= base;
        lowBits = lowBits * base + digit1e6;
        // Carry bits from lowBits to
        if (lowBits >= $b439491fd1adc660$var$TWO_PWR_32_DBL) {
            highBits = highBits + (lowBits / $b439491fd1adc660$var$TWO_PWR_32_DBL | 0);
            lowBits = lowBits % $b439491fd1adc660$var$TWO_PWR_32_DBL;
        }
    }
    add1e6digit(-24, -18);
    add1e6digit(-18, -12);
    add1e6digit(-12, -6);
    add1e6digit(-6);
    return minus ? $b439491fd1adc660$var$negate(lowBits, highBits) : $b439491fd1adc660$var$newBits(lowBits, highBits);
}
function $b439491fd1adc660$export$4012a95a346cab46(lo, hi) {
    let bits = $b439491fd1adc660$var$newBits(lo, hi);
    // If we're treating the input as a signed value and the high bit is set, do
    // a manual two's complement conversion before the decimal conversion.
    const negative = bits.hi & 0x80000000;
    if (negative) bits = $b439491fd1adc660$var$negate(bits.lo, bits.hi);
    const result = $b439491fd1adc660$export$8a12d437d2c35d8f(bits.lo, bits.hi);
    return negative ? "-" + result : result;
}
function $b439491fd1adc660$export$8a12d437d2c35d8f(lo, hi) {
    ({ lo: lo, hi: hi } = $b439491fd1adc660$var$toUnsigned(lo, hi));
    // Skip the expensive conversion if the number is small enough to use the
    // built-in conversions.
    // Number.MAX_SAFE_INTEGER = 0x001FFFFF FFFFFFFF, thus any number with
    // highBits <= 0x1FFFFF can be safely expressed with a double and retain
    // integer precision.
    // Proven by: Number.isSafeInteger(0x1FFFFF * 2**32 + 0xFFFFFFFF) == true.
    if (hi <= 0x1fffff) return String($b439491fd1adc660$var$TWO_PWR_32_DBL * hi + lo);
    // What this code is doing is essentially converting the input number from
    // base-2 to base-1e7, which allows us to represent the 64-bit range with
    // only 3 (very large) digits. Those digits are then trivial to convert to
    // a base-10 string.
    // The magic numbers used here are -
    // 2^24 = 16777216 = (1,6777216) in base-1e7.
    // 2^48 = 281474976710656 = (2,8147497,6710656) in base-1e7.
    // Split 32:32 representation into 16:24:24 representation so our
    // intermediate digits don't overflow.
    const low = lo & 0xffffff;
    const mid = (lo >>> 24 | hi << 8) & 0xffffff;
    const high = hi >> 16 & 0xffff;
    // Assemble our three base-1e7 digits, ignoring carries. The maximum
    // value in a digit at this step is representable as a 48-bit integer, which
    // can be stored in a 64-bit floating point number.
    let digitA = low + mid * 6777216 + high * 6710656;
    let digitB = mid + high * 8147497;
    let digitC = high * 2;
    // Apply carries from A to B and from B to C.
    const base = 10000000;
    if (digitA >= base) {
        digitB += Math.floor(digitA / base);
        digitA %= base;
    }
    if (digitB >= base) {
        digitC += Math.floor(digitB / base);
        digitB %= base;
    }
    // If digitC is 0, then we should have returned in the trivial code path
    // at the top for non-safe integers. Given this, we can assume both digitB
    // and digitA need leading zeros.
    return digitC.toString() + $b439491fd1adc660$var$decimalFrom1e7WithLeadingZeros(digitB) + $b439491fd1adc660$var$decimalFrom1e7WithLeadingZeros(digitA);
}
function $b439491fd1adc660$var$toUnsigned(lo, hi) {
    return {
        lo: lo >>> 0,
        hi: hi >>> 0
    };
}
function $b439491fd1adc660$var$newBits(lo, hi) {
    return {
        lo: lo | 0,
        hi: hi | 0
    };
}
/**
 * Returns two's compliment negation of input.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators#Signed_32-bit_integers
 */ function $b439491fd1adc660$var$negate(lowBits, highBits) {
    highBits = ~highBits;
    if (lowBits) lowBits = ~lowBits + 1;
    else // If lowBits is 0, then bitwise-not is 0xFFFFFFFF,
    // adding 1 to that, results in 0x100000000, which leaves
    // the low bits 0x0 and simply adds one to the high bits.
    highBits += 1;
    return $b439491fd1adc660$var$newBits(lowBits, highBits);
}
/**
 * Returns decimal representation of digit1e7 with leading zeros.
 */ const $b439491fd1adc660$var$decimalFrom1e7WithLeadingZeros = (digit1e7)=>{
    const partial = String(digit1e7);
    return "0000000".slice(partial.length) + partial;
};
function $b439491fd1adc660$export$77a3057e70db7f11(value, bytes) {
    if (value >= 0) {
        // write value as varint 32
        while(value > 0x7f){
            bytes.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        bytes.push(value);
    } else {
        for(let i = 0; i < 9; i++){
            bytes.push(value & 127 | 128);
            value = value >> 7;
        }
        bytes.push(1);
    }
}
function $b439491fd1adc660$export$7138ea6223338e60() {
    let b = this.buf[this.pos++];
    let result = b & 0x7f;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 7;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 14;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    b = this.buf[this.pos++];
    result |= (b & 0x7f) << 21;
    if ((b & 0x80) == 0) {
        this.assertBounds();
        return result;
    }
    // Extract only last 4 bits
    b = this.buf[this.pos++];
    result |= (b & 0x0f) << 28;
    for(let readBytes = 5; (b & 0x80) !== 0 && readBytes < 10; readBytes++)b = this.buf[this.pos++];
    if ((b & 0x80) != 0) throw new Error("invalid varint");
    this.assertBounds();
    // Result can have 32 bits, convert it to unsigned
    return result >>> 0;
}

});


parcelRegister("8xxTQ", function(module, exports) {

$parcel$export(module.exports, "ScalarType", () => $637bb392c3f8b147$export$d40a369a25702af0);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Scalar value types. This is a subset of field types declared by protobuf
 * enum google.protobuf.FieldDescriptorProto.Type The types GROUP and MESSAGE
 * are omitted, but the numerical values are identical.
 */ var $637bb392c3f8b147$export$d40a369a25702af0;
(function(ScalarType) {
    // 0 is reserved for errors.
    // Order is weird for historical reasons.
    ScalarType[ScalarType["DOUBLE"] = 1] = "DOUBLE";
    ScalarType[ScalarType["FLOAT"] = 2] = "FLOAT";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT64 if
    // negative values are likely.
    ScalarType[ScalarType["INT64"] = 3] = "INT64";
    ScalarType[ScalarType["UINT64"] = 4] = "UINT64";
    // Not ZigZag encoded.  Negative numbers take 10 bytes.  Use TYPE_SINT32 if
    // negative values are likely.
    ScalarType[ScalarType["INT32"] = 5] = "INT32";
    ScalarType[ScalarType["FIXED64"] = 6] = "FIXED64";
    ScalarType[ScalarType["FIXED32"] = 7] = "FIXED32";
    ScalarType[ScalarType["BOOL"] = 8] = "BOOL";
    ScalarType[ScalarType["STRING"] = 9] = "STRING";
    // Tag-delimited aggregate.
    // Group type is deprecated and not supported in proto3. However, Proto3
    // implementations should still be able to parse the group wire format and
    // treat group fields as unknown fields.
    // TYPE_GROUP = 10,
    // TYPE_MESSAGE = 11,  // Length-delimited aggregate.
    // New in version 2.
    ScalarType[ScalarType["BYTES"] = 12] = "BYTES";
    ScalarType[ScalarType["UINT32"] = 13] = "UINT32";
    // TYPE_ENUM = 14,
    ScalarType[ScalarType["SFIXED32"] = 15] = "SFIXED32";
    ScalarType[ScalarType["SFIXED64"] = 16] = "SFIXED64";
    ScalarType[ScalarType["SINT32"] = 17] = "SINT32";
    ScalarType[ScalarType["SINT64"] = 18] = "SINT64";
})($637bb392c3f8b147$export$d40a369a25702af0 || ($637bb392c3f8b147$export$d40a369a25702af0 = {}));

});




parcelRegister("8U2QW", function(module, exports) {

$parcel$export(module.exports, "createFileRegistry", () => $67b5c43433466522$export$9e45c794508819fd);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $ajp25 = parcelRequire("ajp25");

var $jEoHp = parcelRequire("jEoHp");

var $2eQsm = parcelRequire("2eQsm");

var $kLINC = parcelRequire("kLINC");
function $67b5c43433466522$export$b877d3ed23ba6b7a(...input) {
    return $67b5c43433466522$var$initBaseRegistry(input);
}
function $67b5c43433466522$export$1f78a241948dc3fa(...input) {
    const reg = $67b5c43433466522$var$initBaseRegistry(input);
    return Object.assign(Object.assign({}, reg), {
        remove (desc) {
            var _a;
            if (desc.kind == "extension") (_a = reg.extendees.get(desc.extendee.typeName)) === null || _a === void 0 || _a.delete(desc.number);
            reg.types.delete(desc.typeName);
        }
    });
}
function $67b5c43433466522$export$9e45c794508819fd(...args) {
    const registry = $67b5c43433466522$var$createBaseRegistry();
    if (!args.length) return registry;
    if ("$typeName" in args[0] && args[0].$typeName == "google.protobuf.FileDescriptorSet") {
        for (const file of args[0].file)$67b5c43433466522$var$addFile(file, registry);
        return registry;
    }
    if ("$typeName" in args[0]) {
        const input = args[0];
        const resolve = args[1];
        const seen = new Set();
        function recurseDeps(file) {
            const deps = [];
            for (const protoFileName of file.dependency){
                if (registry.getFile(protoFileName) != undefined) continue;
                if (seen.has(protoFileName)) continue;
                const dep = resolve(protoFileName);
                if (!dep) throw new Error(`Unable to resolve ${protoFileName}, imported by ${file.name}`);
                if ("kind" in dep) registry.addFile(dep, false, true);
                else {
                    seen.add(dep.name);
                    deps.push(dep);
                }
            }
            return deps.concat(...deps.map(recurseDeps));
        }
        for (const file of [
            input,
            ...recurseDeps(input)
        ].reverse())$67b5c43433466522$var$addFile(file, registry);
    } else {
        for (const fileReg of args)for (const file of fileReg.files)registry.addFile(file);
    }
    return registry;
}
/**
 * @private
 */ function $67b5c43433466522$var$createBaseRegistry() {
    const types = new Map();
    const extendees = new Map();
    const files = new Map();
    return {
        kind: "registry",
        types: types,
        extendees: extendees,
        [Symbol.iterator] () {
            return types.values();
        },
        get files () {
            return files.values();
        },
        addFile (file, skipTypes, withDeps) {
            files.set(file.proto.name, file);
            if (!skipTypes) for (const type of (0, $jEoHp.nestedTypes)(file))this.add(type);
            if (withDeps) for (const f of file.dependencies)this.addFile(f, skipTypes, withDeps);
        },
        add (desc) {
            if (desc.kind == "extension") {
                let numberToExt = extendees.get(desc.extendee.typeName);
                if (!numberToExt) extendees.set(desc.extendee.typeName, // biome-ignore lint/suspicious/noAssignInExpressions: no
                numberToExt = new Map());
                numberToExt.set(desc.number, desc);
            }
            types.set(desc.typeName, desc);
        },
        get (typeName) {
            return types.get(typeName);
        },
        getFile (fileName) {
            return files.get(fileName);
        },
        getMessage (typeName) {
            const t = types.get(typeName);
            return (t === null || t === void 0 ? void 0 : t.kind) == "message" ? t : undefined;
        },
        getEnum (typeName) {
            const t = types.get(typeName);
            return (t === null || t === void 0 ? void 0 : t.kind) == "enum" ? t : undefined;
        },
        getExtension (typeName) {
            const t = types.get(typeName);
            return (t === null || t === void 0 ? void 0 : t.kind) == "extension" ? t : undefined;
        },
        getExtensionFor (extendee, no) {
            var _a;
            return (_a = extendees.get(extendee.typeName)) === null || _a === void 0 ? void 0 : _a.get(no);
        },
        getService (typeName) {
            const t = types.get(typeName);
            return (t === null || t === void 0 ? void 0 : t.kind) == "service" ? t : undefined;
        }
    };
}
/**
 * @private
 */ function $67b5c43433466522$var$initBaseRegistry(inputs) {
    const registry = $67b5c43433466522$var$createBaseRegistry();
    for (const input of inputs)switch(input.kind){
        case "registry":
            for (const n of input)registry.add(n);
            break;
        case "file":
            registry.addFile(input);
            break;
        default:
            registry.add(input);
            break;
    }
    return registry;
}
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO2: const $name: Edition.$localName = $number;
const $67b5c43433466522$var$EDITION_PROTO2 = 998;
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO3: const $name: Edition.$localName = $number;
const $67b5c43433466522$var$EDITION_PROTO3 = 999;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Type.TYPE_STRING: const $name: FieldDescriptorProto_Type.$localName = $number;
const $67b5c43433466522$var$TYPE_STRING = 9;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Type.TYPE_GROUP: const $name: FieldDescriptorProto_Type.$localName = $number;
const $67b5c43433466522$var$TYPE_GROUP = 10;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Type.TYPE_MESSAGE: const $name: FieldDescriptorProto_Type.$localName = $number;
const $67b5c43433466522$var$TYPE_MESSAGE = 11;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Type.TYPE_BYTES: const $name: FieldDescriptorProto_Type.$localName = $number;
const $67b5c43433466522$var$TYPE_BYTES = 12;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Type.TYPE_ENUM: const $name: FieldDescriptorProto_Type.$localName = $number;
const $67b5c43433466522$var$TYPE_ENUM = 14;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Label.LABEL_REPEATED: const $name: FieldDescriptorProto_Label.$localName = $number;
const $67b5c43433466522$var$LABEL_REPEATED = 3;
// bootstrap-inject google.protobuf.FieldDescriptorProto.Label.LABEL_REQUIRED: const $name: FieldDescriptorProto_Label.$localName = $number;
const $67b5c43433466522$var$LABEL_REQUIRED = 2;
// bootstrap-inject google.protobuf.FieldOptions.JSType.JS_STRING: const $name: FieldOptions_JSType.$localName = $number;
const $67b5c43433466522$var$JS_STRING = 1;
// bootstrap-inject google.protobuf.MethodOptions.IdempotencyLevel.IDEMPOTENCY_UNKNOWN: const $name: MethodOptions_IdempotencyLevel.$localName = $number;
const $67b5c43433466522$var$IDEMPOTENCY_UNKNOWN = 0;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.EXPLICIT: const $name: FeatureSet_FieldPresence.$localName = $number;
const $67b5c43433466522$var$EXPLICIT = 1;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name: FeatureSet_FieldPresence.$localName = $number;
const $67b5c43433466522$var$IMPLICIT = 2;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.LEGACY_REQUIRED: const $name: FeatureSet_FieldPresence.$localName = $number;
const $67b5c43433466522$var$LEGACY_REQUIRED = 3;
// bootstrap-inject google.protobuf.FeatureSet.RepeatedFieldEncoding.PACKED: const $name: FeatureSet_RepeatedFieldEncoding.$localName = $number;
const $67b5c43433466522$var$PACKED = 1;
// bootstrap-inject google.protobuf.FeatureSet.MessageEncoding.DELIMITED: const $name: FeatureSet_MessageEncoding.$localName = $number;
const $67b5c43433466522$var$DELIMITED = 2;
// bootstrap-inject google.protobuf.FeatureSet.EnumType.OPEN: const $name: FeatureSet_EnumType.$localName = $number;
const $67b5c43433466522$var$OPEN = 1;
const $67b5c43433466522$export$24b28376843731e2 = 998, $67b5c43433466522$export$a0d282df7c6d576b = 1000;
const $67b5c43433466522$var$featureDefaults = {
    // EDITION_PROTO2
    998: {
        fieldPresence: 1,
        enumType: 2,
        repeatedFieldEncoding: 2,
        utf8Validation: 3,
        messageEncoding: 1,
        jsonFormat: 2,
        enforceNamingStyle: 2
    },
    // EDITION_PROTO3
    999: {
        fieldPresence: 2,
        enumType: 1,
        repeatedFieldEncoding: 1,
        utf8Validation: 2,
        messageEncoding: 1,
        jsonFormat: 1,
        enforceNamingStyle: 2
    },
    // EDITION_2023
    1000: {
        fieldPresence: 1,
        enumType: 1,
        repeatedFieldEncoding: 1,
        utf8Validation: 2,
        messageEncoding: 1,
        jsonFormat: 1,
        enforceNamingStyle: 2
    }
};
/**
 * Create a descriptor for a file, add it to the registry.
 */ function $67b5c43433466522$var$addFile(proto, reg) {
    var _a, _b;
    const file = {
        kind: "file",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        edition: $67b5c43433466522$var$getFileEdition(proto),
        name: proto.name.replace(/\.proto$/, ""),
        dependencies: $67b5c43433466522$var$findFileDependencies(proto, reg),
        enums: [],
        messages: [],
        extensions: [],
        services: [],
        toString () {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- we asserted above
            return `file ${proto.name}`;
        }
    };
    const mapEntriesStore = new Map();
    const mapEntries = {
        get (typeName) {
            return mapEntriesStore.get(typeName);
        },
        add (desc) {
            var _a;
            $67b5c43433466522$var$assert(((_a = desc.proto.options) === null || _a === void 0 ? void 0 : _a.mapEntry) === true);
            mapEntriesStore.set(desc.typeName, desc);
        }
    };
    for (const enumProto of proto.enumType)$67b5c43433466522$var$addEnum(enumProto, file, undefined, reg);
    for (const messageProto of proto.messageType)$67b5c43433466522$var$addMessage(messageProto, file, undefined, reg, mapEntries);
    for (const serviceProto of proto.service)$67b5c43433466522$var$addService(serviceProto, file, reg);
    $67b5c43433466522$var$addExtensions(file, reg);
    for (const mapEntry of mapEntriesStore.values())// to create a map field, we need access to the map entry's fields
    $67b5c43433466522$var$addFields(mapEntry, reg, mapEntries);
    for (const message of file.messages){
        $67b5c43433466522$var$addFields(message, reg, mapEntries);
        $67b5c43433466522$var$addExtensions(message, reg);
    }
    reg.addFile(file, true);
}
/**
 * Create descriptors for extensions, and add them to the message / file,
 * and to our cart.
 * Recurses into nested types.
 */ function $67b5c43433466522$var$addExtensions(desc, reg) {
    switch(desc.kind){
        case "file":
            for (const proto of desc.proto.extension){
                const ext = $67b5c43433466522$var$newField(proto, desc, reg);
                desc.extensions.push(ext);
                reg.add(ext);
            }
            break;
        case "message":
            for (const proto of desc.proto.extension){
                const ext = $67b5c43433466522$var$newField(proto, desc, reg);
                desc.nestedExtensions.push(ext);
                reg.add(ext);
            }
            for (const message of desc.nestedMessages)$67b5c43433466522$var$addExtensions(message, reg);
            break;
    }
}
/**
 * Create descriptors for fields and oneof groups, and add them to the message.
 * Recurses into nested types.
 */ function $67b5c43433466522$var$addFields(message, reg, mapEntries) {
    const allOneofs = message.proto.oneofDecl.map((proto)=>$67b5c43433466522$var$newOneof(proto, message));
    const oneofsSeen = new Set();
    for (const proto of message.proto.field){
        const oneof = $67b5c43433466522$var$findOneof(proto, allOneofs);
        const field = $67b5c43433466522$var$newField(proto, message, reg, oneof, mapEntries);
        message.fields.push(field);
        message.field[field.localName] = field;
        if (oneof === undefined) message.members.push(field);
        else {
            oneof.fields.push(field);
            if (!oneofsSeen.has(oneof)) {
                oneofsSeen.add(oneof);
                message.members.push(oneof);
            }
        }
    }
    for (const oneof of allOneofs.filter((o)=>oneofsSeen.has(o)))message.oneofs.push(oneof);
    for (const child of message.nestedMessages)$67b5c43433466522$var$addFields(child, reg, mapEntries);
}
/**
 * Create a descriptor for an enumeration, and add it our cart and to the
 * parent type, if any.
 */ function $67b5c43433466522$var$addEnum(proto, file, parent, reg) {
    var _a, _b, _c, _d, _e;
    const sharedPrefix = $67b5c43433466522$var$findEnumSharedPrefix(proto.name, proto.value);
    const desc = {
        kind: "enum",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        file: file,
        parent: parent,
        open: true,
        name: proto.name,
        typeName: $67b5c43433466522$var$makeTypeName(proto, parent, file),
        value: {},
        values: [],
        sharedPrefix: sharedPrefix,
        toString () {
            return `enum ${this.typeName}`;
        }
    };
    desc.open = $67b5c43433466522$var$isEnumOpen(desc);
    reg.add(desc);
    for (const p of proto.value){
        const name = p.name;
        desc.values.push(// biome-ignore lint/suspicious/noAssignInExpressions: no
        desc.value[p.number] = {
            kind: "enum_value",
            proto: p,
            deprecated: (_d = (_c = p.options) === null || _c === void 0 ? void 0 : _c.deprecated) !== null && _d !== void 0 ? _d : false,
            parent: desc,
            name: name,
            localName: (0, $kLINC.safeObjectProperty)(sharedPrefix == undefined ? name : name.substring(sharedPrefix.length)),
            number: p.number,
            toString () {
                return `enum value ${desc.typeName}.${name}`;
            }
        });
    }
    ((_e = parent === null || parent === void 0 ? void 0 : parent.nestedEnums) !== null && _e !== void 0 ? _e : file.enums).push(desc);
}
/**
 * Create a descriptor for a message, including nested types, and add it to our
 * cart. Note that this does not create descriptors fields.
 */ function $67b5c43433466522$var$addMessage(proto, file, parent, reg, mapEntries) {
    var _a, _b, _c, _d;
    const desc = {
        kind: "message",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        file: file,
        parent: parent,
        name: proto.name,
        typeName: $67b5c43433466522$var$makeTypeName(proto, parent, file),
        fields: [],
        field: {},
        oneofs: [],
        members: [],
        nestedEnums: [],
        nestedMessages: [],
        nestedExtensions: [],
        toString () {
            return `message ${this.typeName}`;
        }
    };
    if (((_c = proto.options) === null || _c === void 0 ? void 0 : _c.mapEntry) === true) mapEntries.add(desc);
    else {
        ((_d = parent === null || parent === void 0 ? void 0 : parent.nestedMessages) !== null && _d !== void 0 ? _d : file.messages).push(desc);
        reg.add(desc);
    }
    for (const enumProto of proto.enumType)$67b5c43433466522$var$addEnum(enumProto, file, desc, reg);
    for (const messageProto of proto.nestedType)$67b5c43433466522$var$addMessage(messageProto, file, desc, reg, mapEntries);
}
/**
 * Create a descriptor for a service, including methods, and add it to our
 * cart.
 */ function $67b5c43433466522$var$addService(proto, file, reg) {
    var _a, _b;
    const desc = {
        kind: "service",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        file: file,
        name: proto.name,
        typeName: $67b5c43433466522$var$makeTypeName(proto, undefined, file),
        methods: [],
        method: {},
        toString () {
            return `service ${this.typeName}`;
        }
    };
    file.services.push(desc);
    reg.add(desc);
    for (const methodProto of proto.method){
        const method = $67b5c43433466522$var$newMethod(methodProto, desc, reg);
        desc.methods.push(method);
        desc.method[method.localName] = method;
    }
}
/**
 * Create a descriptor for a method.
 */ function $67b5c43433466522$var$newMethod(proto, parent, reg) {
    var _a, _b, _c, _d;
    let methodKind;
    if (proto.clientStreaming && proto.serverStreaming) methodKind = "bidi_streaming";
    else if (proto.clientStreaming) methodKind = "client_streaming";
    else if (proto.serverStreaming) methodKind = "server_streaming";
    else methodKind = "unary";
    const input = reg.getMessage($67b5c43433466522$var$trimLeadingDot(proto.inputType));
    const output = reg.getMessage($67b5c43433466522$var$trimLeadingDot(proto.outputType));
    $67b5c43433466522$var$assert(input, `invalid MethodDescriptorProto: input_type ${proto.inputType} not found`);
    $67b5c43433466522$var$assert(output, `invalid MethodDescriptorProto: output_type ${proto.inputType} not found`);
    const name = proto.name;
    return {
        kind: "rpc",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        parent: parent,
        name: name,
        localName: (0, $kLINC.safeObjectProperty)(name.length ? (0, $kLINC.safeObjectProperty)(name[0].toLowerCase() + name.substring(1)) : name),
        methodKind: methodKind,
        input: input,
        output: output,
        idempotency: (_d = (_c = proto.options) === null || _c === void 0 ? void 0 : _c.idempotencyLevel) !== null && _d !== void 0 ? _d : $67b5c43433466522$var$IDEMPOTENCY_UNKNOWN,
        toString () {
            return `rpc ${parent.typeName}.${name}`;
        }
    };
}
/**
 * Create a descriptor for a oneof group.
 */ function $67b5c43433466522$var$newOneof(proto, parent) {
    return {
        kind: "oneof",
        proto: proto,
        deprecated: false,
        parent: parent,
        fields: [],
        name: proto.name,
        localName: (0, $kLINC.safeObjectProperty)((0, $kLINC.protoCamelCase)(proto.name)),
        toString () {
            return `oneof ${parent.typeName}.${this.name}`;
        }
    };
}
function $67b5c43433466522$var$newField(proto, parentOrFile, reg, oneof, mapEntries) {
    var _a, _b, _c;
    const isExtension = mapEntries === undefined;
    const field = {
        kind: "field",
        proto: proto,
        deprecated: (_b = (_a = proto.options) === null || _a === void 0 ? void 0 : _a.deprecated) !== null && _b !== void 0 ? _b : false,
        name: proto.name,
        number: proto.number,
        scalar: undefined,
        message: undefined,
        enum: undefined,
        presence: $67b5c43433466522$var$getFieldPresence(proto, oneof, isExtension, parentOrFile),
        listKind: undefined,
        mapKind: undefined,
        mapKey: undefined,
        delimitedEncoding: undefined,
        packed: undefined,
        longAsString: false,
        getDefaultValue: undefined
    };
    if (isExtension) {
        // extension field
        const file = parentOrFile.kind == "file" ? parentOrFile : parentOrFile.file;
        const parent = parentOrFile.kind == "file" ? undefined : parentOrFile;
        const typeName = $67b5c43433466522$var$makeTypeName(proto, parent, file);
        field.kind = "extension";
        field.file = file;
        field.parent = parent;
        field.oneof = undefined;
        field.typeName = typeName;
        field.jsonName = `[${typeName}]`; // option json_name is not allowed on extension fields
        field.toString = ()=>`extension ${typeName}`;
        const extendee = reg.getMessage($67b5c43433466522$var$trimLeadingDot(proto.extendee));
        $67b5c43433466522$var$assert(extendee, `invalid FieldDescriptorProto: extendee ${proto.extendee} not found`);
        field.extendee = extendee;
    } else {
        // regular field
        const parent = parentOrFile;
        $67b5c43433466522$var$assert(parent.kind == "message");
        field.parent = parent;
        field.oneof = oneof;
        field.localName = oneof ? (0, $kLINC.protoCamelCase)(proto.name) : (0, $kLINC.safeObjectProperty)((0, $kLINC.protoCamelCase)(proto.name));
        field.jsonName = proto.jsonName;
        field.toString = ()=>`field ${parent.typeName}.${proto.name}`;
    }
    const label = proto.label;
    const type = proto.type;
    const jstype = (_c = proto.options) === null || _c === void 0 ? void 0 : _c.jstype;
    if (label === $67b5c43433466522$var$LABEL_REPEATED) {
        // list or map field
        const mapEntry = type == $67b5c43433466522$var$TYPE_MESSAGE ? mapEntries === null || mapEntries === void 0 ? void 0 : mapEntries.get($67b5c43433466522$var$trimLeadingDot(proto.typeName)) : undefined;
        if (mapEntry) {
            // map field
            field.fieldKind = "map";
            const { key: key, value: value } = $67b5c43433466522$var$findMapEntryFields(mapEntry);
            field.mapKey = key.scalar;
            field.mapKind = value.fieldKind;
            field.message = value.message;
            field.delimitedEncoding = false; // map fields are always LENGTH_PREFIXED
            field.enum = value.enum;
            field.scalar = value.scalar;
            return field;
        }
        // list field
        field.fieldKind = "list";
        switch(type){
            case $67b5c43433466522$var$TYPE_MESSAGE:
            case $67b5c43433466522$var$TYPE_GROUP:
                field.listKind = "message";
                field.message = reg.getMessage($67b5c43433466522$var$trimLeadingDot(proto.typeName));
                $67b5c43433466522$var$assert(field.message);
                field.delimitedEncoding = $67b5c43433466522$var$isDelimitedEncoding(proto, parentOrFile);
                break;
            case $67b5c43433466522$var$TYPE_ENUM:
                field.listKind = "enum";
                field.enum = reg.getEnum($67b5c43433466522$var$trimLeadingDot(proto.typeName));
                $67b5c43433466522$var$assert(field.enum);
                break;
            default:
                field.listKind = "scalar";
                field.scalar = type;
                field.longAsString = jstype == $67b5c43433466522$var$JS_STRING;
                break;
        }
        field.packed = $67b5c43433466522$var$isPackedField(proto, parentOrFile);
        return field;
    }
    // singular
    switch(type){
        case $67b5c43433466522$var$TYPE_MESSAGE:
        case $67b5c43433466522$var$TYPE_GROUP:
            field.fieldKind = "message";
            field.message = reg.getMessage($67b5c43433466522$var$trimLeadingDot(proto.typeName));
            $67b5c43433466522$var$assert(field.message, `invalid FieldDescriptorProto: type_name ${proto.typeName} not found`);
            field.delimitedEncoding = $67b5c43433466522$var$isDelimitedEncoding(proto, parentOrFile);
            field.getDefaultValue = ()=>undefined;
            break;
        case $67b5c43433466522$var$TYPE_ENUM:
            {
                const enumeration = reg.getEnum($67b5c43433466522$var$trimLeadingDot(proto.typeName));
                $67b5c43433466522$var$assert(enumeration !== undefined, `invalid FieldDescriptorProto: type_name ${proto.typeName} not found`);
                field.fieldKind = "enum";
                field.enum = reg.getEnum($67b5c43433466522$var$trimLeadingDot(proto.typeName));
                field.getDefaultValue = ()=>{
                    return (0, $2eQsm.unsafeIsSetExplicit)(proto, "defaultValue") ? (0, $ajp25.parseTextFormatEnumValue)(enumeration, proto.defaultValue) : undefined;
                };
                break;
            }
        default:
            field.fieldKind = "scalar";
            field.scalar = type;
            field.longAsString = jstype == $67b5c43433466522$var$JS_STRING;
            field.getDefaultValue = ()=>{
                return (0, $2eQsm.unsafeIsSetExplicit)(proto, "defaultValue") ? (0, $ajp25.parseTextFormatScalarValue)(type, proto.defaultValue) : undefined;
            };
            break;
    }
    return field;
}
/**
 * Parse the "syntax" and "edition" fields, returning one of the supported
 * editions.
 */ function $67b5c43433466522$var$getFileEdition(proto) {
    switch(proto.syntax){
        case "":
        case "proto2":
            return $67b5c43433466522$var$EDITION_PROTO2;
        case "proto3":
            return $67b5c43433466522$var$EDITION_PROTO3;
        case "editions":
            if (proto.edition in $67b5c43433466522$var$featureDefaults) return proto.edition;
            throw new Error(`${proto.name}: unsupported edition`);
        default:
            throw new Error(`${proto.name}: unsupported syntax "${proto.syntax}"`);
    }
}
/**
 * Resolve dependencies of FileDescriptorProto to DescFile.
 */ function $67b5c43433466522$var$findFileDependencies(proto, reg) {
    return proto.dependency.map((wantName)=>{
        const dep = reg.getFile(wantName);
        if (!dep) throw new Error(`Cannot find ${wantName}, imported by ${proto.name}`);
        return dep;
    });
}
/**
 * Finds a prefix shared by enum values, for example `my_enum_` for
 * `enum MyEnum {MY_ENUM_A=0; MY_ENUM_B=1;}`.
 */ function $67b5c43433466522$var$findEnumSharedPrefix(enumName, values) {
    const prefix = $67b5c43433466522$var$camelToSnakeCase(enumName) + "_";
    for (const value of values){
        if (!value.name.toLowerCase().startsWith(prefix)) return undefined;
        const shortName = value.name.substring(prefix.length);
        if (shortName.length == 0) return undefined;
        if (/^\d/.test(shortName)) // identifiers must not start with numbers
        return undefined;
    }
    return prefix;
}
/**
 * Converts lowerCamelCase or UpperCamelCase into lower_snake_case.
 * This is used to find shared prefixes in an enum.
 */ function $67b5c43433466522$var$camelToSnakeCase(camel) {
    return (camel.substring(0, 1) + camel.substring(1).replace(/[A-Z]/g, (c)=>"_" + c)).toLowerCase();
}
/**
 * Create a fully qualified name for a protobuf type or extension field.
 *
 * The fully qualified name for messages, enumerations, and services is
 * constructed by concatenating the package name (if present), parent
 * message names (for nested types), and the type name. We omit the leading
 * dot added by protobuf compilers. Examples:
 * - mypackage.MyMessage
 * - mypackage.MyMessage.NestedMessage
 *
 * The fully qualified name for extension fields is constructed by
 * concatenating the package name (if present), parent message names (for
 * extensions declared within a message), and the field name. Examples:
 * - mypackage.extfield
 * - mypackage.MyMessage.extfield
 */ function $67b5c43433466522$var$makeTypeName(proto, parent, file) {
    let typeName;
    if (parent) typeName = `${parent.typeName}.${proto.name}`;
    else if (file.proto.package.length > 0) typeName = `${file.proto.package}.${proto.name}`;
    else typeName = `${proto.name}`;
    return typeName;
}
/**
 * Remove the leading dot from a fully qualified type name.
 */ function $67b5c43433466522$var$trimLeadingDot(typeName) {
    return typeName.startsWith(".") ? typeName.substring(1) : typeName;
}
/**
 * Did the user put the field in a oneof group?
 * Synthetic oneofs for proto3 optionals are ignored.
 */ function $67b5c43433466522$var$findOneof(proto, allOneofs) {
    if (!(0, $2eQsm.unsafeIsSetExplicit)(proto, "oneofIndex")) return undefined;
    if (proto.proto3Optional) return undefined;
    const oneof = allOneofs[proto.oneofIndex];
    $67b5c43433466522$var$assert(oneof, `invalid FieldDescriptorProto: oneof #${proto.oneofIndex} for field #${proto.number} not found`);
    return oneof;
}
/**
 * Presence of the field.
 * See https://protobuf.dev/programming-guides/field_presence/
 */ function $67b5c43433466522$var$getFieldPresence(proto, oneof, isExtension, parent) {
    if (proto.label == $67b5c43433466522$var$LABEL_REQUIRED) // proto2 required is LEGACY_REQUIRED
    return $67b5c43433466522$var$LEGACY_REQUIRED;
    if (proto.label == $67b5c43433466522$var$LABEL_REPEATED) // repeated fields (including maps) do not track presence
    return $67b5c43433466522$var$IMPLICIT;
    if (!!oneof || proto.proto3Optional) // oneof is always explicit
    return $67b5c43433466522$var$EXPLICIT;
    if (isExtension) // extensions always track presence
    return $67b5c43433466522$var$EXPLICIT;
    const resolved = $67b5c43433466522$var$resolveFeature("fieldPresence", {
        proto: proto,
        parent: parent
    });
    if (resolved == $67b5c43433466522$var$IMPLICIT && (proto.type == $67b5c43433466522$var$TYPE_MESSAGE || proto.type == $67b5c43433466522$var$TYPE_GROUP)) // singular message field cannot be implicit
    return $67b5c43433466522$var$EXPLICIT;
    return resolved;
}
/**
 * Pack this repeated field?
 */ function $67b5c43433466522$var$isPackedField(proto, parent) {
    if (proto.label != $67b5c43433466522$var$LABEL_REPEATED) return false;
    switch(proto.type){
        case $67b5c43433466522$var$TYPE_STRING:
        case $67b5c43433466522$var$TYPE_BYTES:
        case $67b5c43433466522$var$TYPE_GROUP:
        case $67b5c43433466522$var$TYPE_MESSAGE:
            // length-delimited types cannot be packed
            return false;
    }
    const o = proto.options;
    if (o && (0, $2eQsm.unsafeIsSetExplicit)(o, "packed")) // prefer the field option over edition features
    return o.packed;
    return $67b5c43433466522$var$PACKED == $67b5c43433466522$var$resolveFeature("repeatedFieldEncoding", {
        proto: proto,
        parent: parent
    });
}
/**
 * Find the key and value fields of a synthetic map entry message.
 */ function $67b5c43433466522$var$findMapEntryFields(mapEntry) {
    const key = mapEntry.fields.find((f)=>f.number === 1);
    const value = mapEntry.fields.find((f)=>f.number === 2);
    $67b5c43433466522$var$assert(key && key.fieldKind == "scalar" && key.scalar != (0, $8xxTQ.ScalarType).BYTES && key.scalar != (0, $8xxTQ.ScalarType).FLOAT && key.scalar != (0, $8xxTQ.ScalarType).DOUBLE && value && value.fieldKind != "list" && value.fieldKind != "map");
    return {
        key: key,
        value: value
    };
}
/**
 * Enumerations can be open or closed.
 * See https://protobuf.dev/programming-guides/enum/
 */ function $67b5c43433466522$var$isEnumOpen(desc) {
    var _a;
    return $67b5c43433466522$var$OPEN == $67b5c43433466522$var$resolveFeature("enumType", {
        proto: desc.proto,
        parent: (_a = desc.parent) !== null && _a !== void 0 ? _a : desc.file
    });
}
/**
 * Encode the message delimited (a.k.a. proto2 group encoding), or
 * length-prefixed?
 */ function $67b5c43433466522$var$isDelimitedEncoding(proto, parent) {
    if (proto.type == $67b5c43433466522$var$TYPE_GROUP) return true;
    return $67b5c43433466522$var$DELIMITED == $67b5c43433466522$var$resolveFeature("messageEncoding", {
        proto: proto,
        parent: parent
    });
}
function $67b5c43433466522$var$resolveFeature(name, ref) {
    var _a, _b;
    const featureSet = (_a = ref.proto.options) === null || _a === void 0 ? void 0 : _a.features;
    if (featureSet) {
        const val = featureSet[name];
        if (val != 0) return val;
    }
    if ("kind" in ref) {
        if (ref.kind == "message") return $67b5c43433466522$var$resolveFeature(name, (_b = ref.parent) !== null && _b !== void 0 ? _b : ref.file);
        const editionDefaults = $67b5c43433466522$var$featureDefaults[ref.edition];
        if (!editionDefaults) throw new Error(`feature default for edition ${ref.edition} not found`);
        return editionDefaults[name];
    }
    return $67b5c43433466522$var$resolveFeature(name, ref.parent);
}
/**
 * Assert that condition is truthy or throw error (with message)
 */ function $67b5c43433466522$var$assert(condition, msg) {
    if (!condition) throw new Error(msg);
}

});
parcelRegister("ajp25", function(module, exports) {

$parcel$export(module.exports, "parseTextFormatEnumValue", () => $781f18aeec14c41e$export$c4321d212d8b80f7);
$parcel$export(module.exports, "parseTextFormatScalarValue", () => $781f18aeec14c41e$export$d7164c2351c2ed64);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $6zK55 = parcelRequire("6zK55");
function $781f18aeec14c41e$export$c4321d212d8b80f7(descEnum, value) {
    const enumValue = descEnum.values.find((v)=>v.name === value);
    if (!enumValue) throw new Error(`cannot parse ${descEnum} default value: ${value}`);
    return enumValue.number;
}
function $781f18aeec14c41e$export$d7164c2351c2ed64(type, value) {
    switch(type){
        case (0, $8xxTQ.ScalarType).STRING:
            return value;
        case (0, $8xxTQ.ScalarType).BYTES:
            {
                const u = $781f18aeec14c41e$var$unescapeBytesDefaultValue(value);
                if (u === false) throw new Error(`cannot parse ${(0, $8xxTQ.ScalarType)[type]} default value: ${value}`);
                return u;
            }
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            return (0, $6zK55.protoInt64).parse(value);
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).FIXED64:
            return (0, $6zK55.protoInt64).uParse(value);
        case (0, $8xxTQ.ScalarType).DOUBLE:
        case (0, $8xxTQ.ScalarType).FLOAT:
            switch(value){
                case "inf":
                    return Number.POSITIVE_INFINITY;
                case "-inf":
                    return Number.NEGATIVE_INFINITY;
                case "nan":
                    return Number.NaN;
                default:
                    return parseFloat(value);
            }
        case (0, $8xxTQ.ScalarType).BOOL:
            return value === "true";
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).UINT32:
        case (0, $8xxTQ.ScalarType).SINT32:
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
            return parseInt(value, 10);
    }
}
/**
 * Parses a text-encoded default value (proto2) of a BYTES field.
 */ function $781f18aeec14c41e$var$unescapeBytesDefaultValue(str) {
    const b = [];
    const input = {
        tail: str,
        c: "",
        next () {
            if (this.tail.length == 0) return false;
            this.c = this.tail[0];
            this.tail = this.tail.substring(1);
            return true;
        },
        take (n) {
            if (this.tail.length >= n) {
                const r = this.tail.substring(0, n);
                this.tail = this.tail.substring(n);
                return r;
            }
            return false;
        }
    };
    while(input.next())switch(input.c){
        case "\\":
            if (input.next()) switch(input.c){
                case "\\":
                    b.push(input.c.charCodeAt(0));
                    break;
                case "b":
                    b.push(0x08);
                    break;
                case "f":
                    b.push(0x0c);
                    break;
                case "n":
                    b.push(0x0a);
                    break;
                case "r":
                    b.push(0x0d);
                    break;
                case "t":
                    b.push(0x09);
                    break;
                case "v":
                    b.push(0x0b);
                    break;
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                    {
                        const s = input.c;
                        const t = input.take(2);
                        if (t === false) return false;
                        const n = parseInt(s + t, 8);
                        if (Number.isNaN(n)) return false;
                        b.push(n);
                        break;
                    }
                case "x":
                    {
                        const s = input.c;
                        const t = input.take(2);
                        if (t === false) return false;
                        const n = parseInt(s + t, 16);
                        if (Number.isNaN(n)) return false;
                        b.push(n);
                        break;
                    }
                case "u":
                    {
                        const s = input.c;
                        const t = input.take(4);
                        if (t === false) return false;
                        const n = parseInt(s + t, 16);
                        if (Number.isNaN(n)) return false;
                        const chunk = new Uint8Array(4);
                        const view = new DataView(chunk.buffer);
                        view.setInt32(0, n, true);
                        b.push(chunk[0], chunk[1], chunk[2], chunk[3]);
                        break;
                    }
                case "U":
                    {
                        const s = input.c;
                        const t = input.take(8);
                        if (t === false) return false;
                        const tc = (0, $6zK55.protoInt64).uEnc(s + t);
                        const chunk = new Uint8Array(8);
                        const view = new DataView(chunk.buffer);
                        view.setInt32(0, tc.lo, true);
                        view.setInt32(4, tc.hi, true);
                        b.push(chunk[0], chunk[1], chunk[2], chunk[3], chunk[4], chunk[5], chunk[6], chunk[7]);
                        break;
                    }
            }
            break;
        default:
            b.push(input.c.charCodeAt(0));
    }
    return new Uint8Array(b);
}

});

parcelRegister("jEoHp", function(module, exports) {

$parcel$export(module.exports, "nestedTypes", () => $e4e4e97ca5d95222$export$bc565ce344945e16);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Iterate over all types - enumerations, extensions, services, messages -
 * and enumerations, extensions and messages nested in messages.
 */ function* $e4e4e97ca5d95222$export$bc565ce344945e16(desc) {
    switch(desc.kind){
        case "file":
            for (const message of desc.messages){
                yield message;
                yield* $e4e4e97ca5d95222$export$bc565ce344945e16(message);
            }
            yield* desc.enums;
            yield* desc.services;
            yield* desc.extensions;
            break;
        case "message":
            for (const message of desc.nestedMessages){
                yield message;
                yield* $e4e4e97ca5d95222$export$bc565ce344945e16(message);
            }
            yield* desc.nestedEnums;
            yield* desc.nestedExtensions;
            break;
    }
}
function $e4e4e97ca5d95222$export$34be6b15f00a97dd(descMessage) {
    return $e4e4e97ca5d95222$var$usedTypesInternal(descMessage, new Set());
}
function* $e4e4e97ca5d95222$var$usedTypesInternal(descMessage, seen) {
    var _a, _b;
    for (const field of descMessage.fields){
        const ref = (_b = (_a = field.enum) !== null && _a !== void 0 ? _a : field.message) !== null && _b !== void 0 ? _b : undefined;
        if (!ref || seen.has(ref.typeName)) continue;
        seen.add(ref.typeName);
        yield ref;
        if (ref.kind == "message") yield* $e4e4e97ca5d95222$var$usedTypesInternal(ref, seen);
    }
}
function $e4e4e97ca5d95222$export$11b2fdfaf6bc74d3(desc) {
    const parents = [];
    while(desc.kind !== "file"){
        const p = $e4e4e97ca5d95222$var$parent(desc);
        desc = p;
        parents.push(p);
    }
    return parents;
}
function $e4e4e97ca5d95222$var$parent(desc) {
    var _a;
    switch(desc.kind){
        case "enum_value":
        case "field":
        case "oneof":
        case "rpc":
            return desc.parent;
        case "service":
            return desc.file;
        case "extension":
        case "enum":
        case "message":
            return (_a = desc.parent) !== null && _a !== void 0 ? _a : desc.file;
    }
}

});



parcelRegister("8ImrE", function(module, exports) {

$parcel$export(module.exports, "messageDesc", () => $6583d7e030b3400b$export$4b54b39321d1b337);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Hydrate a message descriptor.
 *
 * @private
 */ function $6583d7e030b3400b$export$4b54b39321d1b337(file, path, ...paths) {
    return paths.reduce((acc, cur)=>acc.nestedMessages[cur], file.messages[path]);
}

});

parcelRegister("h4GxM", function(module, exports) {

$parcel$export(module.exports, "enumDesc", () => $c6e3cfb2c3d3ecb4$export$cea1ae13765aaf5d);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Hydrate an enum descriptor.
 *
 * @private
 */ function $c6e3cfb2c3d3ecb4$export$cea1ae13765aaf5d(file, path, ...paths) {
    if (paths.length == 0) return file.enums[path];
    const e = paths.pop(); // we checked length above
    return paths.reduce((acc, cur)=>acc.nestedMessages[cur], file.messages[path]).nestedEnums[e];
}
function $c6e3cfb2c3d3ecb4$export$996449220a7ac95c(desc) {
    const enumObject = {};
    for (const value of desc.values){
        enumObject[value.localName] = value.number;
        enumObject[value.number] = value.localName;
    }
    return enumObject;
}

});


parcelRegister("6PNZL", function(module, exports) {

$parcel$export(module.exports, "fromBinary", () => $4f9e497c6f4ec062$export$a178423dcbaef037);
$parcel$export(module.exports, "mergeFromBinary", () => $4f9e497c6f4ec062$export$16844beab8b2a17e);
$parcel$export(module.exports, "readField", () => $4f9e497c6f4ec062$export$382f22472809782a);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $lipan = parcelRequire("lipan");

var $lItxZ = parcelRequire("lItxZ");

var $fqP57 = parcelRequire("fqP57");
// Default options for parsing binary data.
const $4f9e497c6f4ec062$var$readDefaults = {
    readUnknownFields: true
};
function $4f9e497c6f4ec062$var$makeReadOptions(options) {
    return options ? Object.assign(Object.assign({}, $4f9e497c6f4ec062$var$readDefaults), options) : $4f9e497c6f4ec062$var$readDefaults;
}
function $4f9e497c6f4ec062$export$a178423dcbaef037(schema, bytes, options) {
    const msg = (0, $lItxZ.reflect)(schema, undefined, false);
    $4f9e497c6f4ec062$var$readMessage(msg, new (0, $fqP57.BinaryReader)(bytes), $4f9e497c6f4ec062$var$makeReadOptions(options), false, bytes.byteLength);
    return msg.message;
}
function $4f9e497c6f4ec062$export$16844beab8b2a17e(schema, target, bytes, options) {
    $4f9e497c6f4ec062$var$readMessage((0, $lItxZ.reflect)(schema, target, false), new (0, $fqP57.BinaryReader)(bytes), $4f9e497c6f4ec062$var$makeReadOptions(options), false, bytes.byteLength);
    return target;
}
/**
 * If `delimited` is false, read the length given in `lengthOrDelimitedFieldNo`.
 *
 * If `delimited` is true, read until an EndGroup tag. `lengthOrDelimitedFieldNo`
 * is the expected field number.
 *
 * @private
 */ function $4f9e497c6f4ec062$var$readMessage(message, reader, options, delimited, lengthOrDelimitedFieldNo) {
    var _a;
    const end = delimited ? reader.len : reader.pos + lengthOrDelimitedFieldNo;
    let fieldNo;
    let wireType;
    const unknownFields = (_a = message.getUnknown()) !== null && _a !== void 0 ? _a : [];
    while(reader.pos < end){
        [fieldNo, wireType] = reader.tag();
        if (delimited && wireType == (0, $fqP57.WireType).EndGroup) break;
        const field = message.findNumber(fieldNo);
        if (!field) {
            const data = reader.skip(wireType, fieldNo);
            if (options.readUnknownFields) unknownFields.push({
                no: fieldNo,
                wireType: wireType,
                data: data
            });
            continue;
        }
        $4f9e497c6f4ec062$export$382f22472809782a(message, reader, field, wireType, options);
    }
    if (delimited) {
        if (wireType != (0, $fqP57.WireType).EndGroup || fieldNo !== lengthOrDelimitedFieldNo) throw new Error("invalid end group tag");
    }
    if (unknownFields.length > 0) message.setUnknown(unknownFields);
}
function $4f9e497c6f4ec062$export$382f22472809782a(message, reader, field, wireType, options) {
    switch(field.fieldKind){
        case "scalar":
            message.set(field, $4f9e497c6f4ec062$var$readScalar(reader, field.scalar));
            break;
        case "enum":
            message.set(field, $4f9e497c6f4ec062$var$readScalar(reader, (0, $8xxTQ.ScalarType).INT32));
            break;
        case "message":
            message.set(field, $4f9e497c6f4ec062$var$readMessageField(reader, options, field, message.get(field)));
            break;
        case "list":
            $4f9e497c6f4ec062$var$readListField(reader, wireType, message.get(field), options);
            break;
        case "map":
            $4f9e497c6f4ec062$var$readMapEntry(reader, message.get(field), options);
            break;
    }
}
// Read a map field, expecting key field = 1, value field = 2
function $4f9e497c6f4ec062$var$readMapEntry(reader, map, options) {
    const field = map.field();
    let key;
    let val;
    const end = reader.pos + reader.uint32();
    while(reader.pos < end){
        const [fieldNo] = reader.tag();
        switch(fieldNo){
            case 1:
                key = $4f9e497c6f4ec062$var$readScalar(reader, field.mapKey);
                break;
            case 2:
                switch(field.mapKind){
                    case "scalar":
                        val = $4f9e497c6f4ec062$var$readScalar(reader, field.scalar);
                        break;
                    case "enum":
                        val = reader.int32();
                        break;
                    case "message":
                        val = $4f9e497c6f4ec062$var$readMessageField(reader, options, field);
                        break;
                }
                break;
        }
    }
    if (key === undefined) key = (0, $lipan.scalarZeroValue)(field.mapKey, false);
    if (val === undefined) switch(field.mapKind){
        case "scalar":
            val = (0, $lipan.scalarZeroValue)(field.scalar, false);
            break;
        case "enum":
            val = field.enum.values[0].number;
            break;
        case "message":
            val = (0, $lItxZ.reflect)(field.message, undefined, false);
            break;
    }
    map.set(key, val);
}
function $4f9e497c6f4ec062$var$readListField(reader, wireType, list, options) {
    var _a;
    const field = list.field();
    if (field.listKind === "message") {
        list.add($4f9e497c6f4ec062$var$readMessageField(reader, options, field));
        return;
    }
    const scalarType = (_a = field.scalar) !== null && _a !== void 0 ? _a : (0, $8xxTQ.ScalarType).INT32;
    const packed = wireType == (0, $fqP57.WireType).LengthDelimited && scalarType != (0, $8xxTQ.ScalarType).STRING && scalarType != (0, $8xxTQ.ScalarType).BYTES;
    if (!packed) {
        list.add($4f9e497c6f4ec062$var$readScalar(reader, scalarType));
        return;
    }
    const e = reader.uint32() + reader.pos;
    while(reader.pos < e)list.add($4f9e497c6f4ec062$var$readScalar(reader, scalarType));
}
function $4f9e497c6f4ec062$var$readMessageField(reader, options, field, mergeMessage) {
    const delimited = field.delimitedEncoding;
    const message = mergeMessage !== null && mergeMessage !== void 0 ? mergeMessage : (0, $lItxZ.reflect)(field.message, undefined, false);
    $4f9e497c6f4ec062$var$readMessage(message, reader, options, delimited, delimited ? field.number : reader.uint32());
    return message;
}
function $4f9e497c6f4ec062$var$readScalar(reader, type) {
    switch(type){
        case (0, $8xxTQ.ScalarType).STRING:
            return reader.string();
        case (0, $8xxTQ.ScalarType).BOOL:
            return reader.bool();
        case (0, $8xxTQ.ScalarType).DOUBLE:
            return reader.double();
        case (0, $8xxTQ.ScalarType).FLOAT:
            return reader.float();
        case (0, $8xxTQ.ScalarType).INT32:
            return reader.int32();
        case (0, $8xxTQ.ScalarType).INT64:
            return reader.int64();
        case (0, $8xxTQ.ScalarType).UINT64:
            return reader.uint64();
        case (0, $8xxTQ.ScalarType).FIXED64:
            return reader.fixed64();
        case (0, $8xxTQ.ScalarType).BYTES:
            return reader.bytes();
        case (0, $8xxTQ.ScalarType).FIXED32:
            return reader.fixed32();
        case (0, $8xxTQ.ScalarType).SFIXED32:
            return reader.sfixed32();
        case (0, $8xxTQ.ScalarType).SFIXED64:
            return reader.sfixed64();
        case (0, $8xxTQ.ScalarType).SINT64:
            return reader.sint64();
        case (0, $8xxTQ.ScalarType).UINT32:
            return reader.uint32();
        case (0, $8xxTQ.ScalarType).SINT32:
            return reader.sint32();
    }
}

});
parcelRegister("lItxZ", function(module, exports) {

$parcel$export(module.exports, "reflect", () => $fcf4a0832395b38a$export$9debe8cffacea23);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $g7x8s = parcelRequire("g7x8s");

var $2J3jP = parcelRequire("2J3jP");

var $2eQsm = parcelRequire("2eQsm");

var $1jDsz = parcelRequire("1jDsz");

var $AYHoV = parcelRequire("AYHoV");

var $lipan = parcelRequire("lipan");

var $6zK55 = parcelRequire("6zK55");

var $dcCoF = parcelRequire("dcCoF");
function $fcf4a0832395b38a$export$9debe8cffacea23(messageDesc, message, /**
 * By default, field values are validated when setting them. For example,
 * a value for an uint32 field must be a ECMAScript Number >= 0.
 *
 * When field values are trusted, performance can be improved by disabling
 * checks.
 */ check = true) {
    return new $fcf4a0832395b38a$var$ReflectMessageImpl(messageDesc, message, check);
}
class $fcf4a0832395b38a$var$ReflectMessageImpl {
    get sortedFields() {
        var _a;
        return (_a = this._sortedFields) !== null && _a !== void 0 ? _a : // biome-ignore lint/suspicious/noAssignInExpressions: no
        this._sortedFields = this.desc.fields.concat().sort((a, b)=>a.number - b.number);
    }
    constructor(messageDesc, message, check = true){
        this.lists = new Map();
        this.maps = new Map();
        this.check = check;
        this.desc = messageDesc;
        this.message = this[0, $2eQsm.unsafeLocal] = message !== null && message !== void 0 ? message : (0, $1jDsz.create)(messageDesc);
        this.fields = messageDesc.fields;
        this.oneofs = messageDesc.oneofs;
        this.members = messageDesc.members;
    }
    findNumber(number) {
        if (!this._fieldsByNumber) this._fieldsByNumber = new Map(this.desc.fields.map((f)=>[
                f.number,
                f
            ]));
        return this._fieldsByNumber.get(number);
    }
    oneofCase(oneof) {
        $fcf4a0832395b38a$var$assertOwn(this.message, oneof);
        return (0, $2eQsm.unsafeOneofCase)(this.message, oneof);
    }
    isSet(field) {
        $fcf4a0832395b38a$var$assertOwn(this.message, field);
        return (0, $2eQsm.unsafeIsSet)(this.message, field);
    }
    clear(field) {
        $fcf4a0832395b38a$var$assertOwn(this.message, field);
        (0, $2eQsm.unsafeClear)(this.message, field);
    }
    get(field) {
        $fcf4a0832395b38a$var$assertOwn(this.message, field);
        const value = (0, $2eQsm.unsafeGet)(this.message, field);
        switch(field.fieldKind){
            case "list":
                // eslint-disable-next-line no-case-declarations
                let list = this.lists.get(field);
                if (!list || list[0, $2eQsm.unsafeLocal] !== value) this.lists.set(field, // biome-ignore lint/suspicious/noAssignInExpressions: no
                list = new $fcf4a0832395b38a$var$ReflectListImpl(field, value, this.check));
                return list;
            case "map":
                let map = this.maps.get(field);
                if (!map || map[0, $2eQsm.unsafeLocal] !== value) this.maps.set(field, // biome-ignore lint/suspicious/noAssignInExpressions: no
                map = new $fcf4a0832395b38a$var$ReflectMapImpl(field, value, this.check));
                return map;
            case "message":
                return $fcf4a0832395b38a$var$messageToReflect(field, value, this.check);
            case "scalar":
                return value === undefined ? (0, $lipan.scalarZeroValue)(field.scalar, false) : $fcf4a0832395b38a$var$longToReflect(field, value);
            case "enum":
                return value !== null && value !== void 0 ? value : field.enum.values[0].number;
        }
    }
    set(field, value) {
        $fcf4a0832395b38a$var$assertOwn(this.message, field);
        if (this.check) {
            const err = (0, $g7x8s.checkField)(field, value);
            if (err) throw err;
        }
        let local;
        if (field.fieldKind == "message") local = $fcf4a0832395b38a$var$messageToLocal(field, value);
        else if ((0, $dcCoF.isReflectMap)(value) || (0, $dcCoF.isReflectList)(value)) local = value[0, $2eQsm.unsafeLocal];
        else local = $fcf4a0832395b38a$var$longToLocal(field, value);
        (0, $2eQsm.unsafeSet)(this.message, field, local);
    }
    getUnknown() {
        return this.message.$unknown;
    }
    setUnknown(value) {
        this.message.$unknown = value;
    }
}
function $fcf4a0832395b38a$var$assertOwn(owner, member) {
    if (member.parent.typeName !== owner.$typeName) throw new (0, $2J3jP.FieldError)(member, `cannot use ${member.toString()} with message ${owner.$typeName}`, "ForeignFieldError");
}
function $fcf4a0832395b38a$export$232efe13ea44f083(field, unsafeInput, /**
 * By default, field values are validated when setting them. For example,
 * a value for an uint32 field must be a ECMAScript Number >= 0.
 *
 * When field values are trusted, performance can be improved by disabling
 * checks.
 */ check = true) {
    return new $fcf4a0832395b38a$var$ReflectListImpl(field, unsafeInput !== null && unsafeInput !== void 0 ? unsafeInput : [], check);
}
class $fcf4a0832395b38a$var$ReflectListImpl {
    field() {
        return this._field;
    }
    get size() {
        return this._arr.length;
    }
    constructor(field, unsafeInput, check){
        this._field = field;
        this._arr = this[0, $2eQsm.unsafeLocal] = unsafeInput;
        this.check = check;
    }
    get(index) {
        const item = this._arr[index];
        return item === undefined ? undefined : $fcf4a0832395b38a$var$listItemToReflect(this._field, item, this.check);
    }
    set(index, item) {
        if (index < 0 || index >= this._arr.length) throw new (0, $2J3jP.FieldError)(this._field, `list item #${index + 1}: out of range`);
        if (this.check) {
            const err = (0, $g7x8s.checkListItem)(this._field, index, item);
            if (err) throw err;
        }
        this._arr[index] = $fcf4a0832395b38a$var$listItemToLocal(this._field, item);
    }
    add(item) {
        if (this.check) {
            const err = (0, $g7x8s.checkListItem)(this._field, this._arr.length, item);
            if (err) throw err;
        }
        this._arr.push($fcf4a0832395b38a$var$listItemToLocal(this._field, item));
        return undefined;
    }
    clear() {
        this._arr.splice(0, this._arr.length);
    }
    [Symbol.iterator]() {
        return this.values();
    }
    keys() {
        return this._arr.keys();
    }
    *values() {
        for (const item of this._arr)yield $fcf4a0832395b38a$var$listItemToReflect(this._field, item, this.check);
    }
    *entries() {
        for(let i = 0; i < this._arr.length; i++)yield [
            i,
            $fcf4a0832395b38a$var$listItemToReflect(this._field, this._arr[i], this.check)
        ];
    }
}
function $fcf4a0832395b38a$export$9370db70f99f966(field, unsafeInput, /**
 * By default, field values are validated when setting them. For example,
 * a value for an uint32 field must be a ECMAScript Number >= 0.
 *
 * When field values are trusted, performance can be improved by disabling
 * checks.
 */ check = true) {
    return new $fcf4a0832395b38a$var$ReflectMapImpl(field, unsafeInput, check);
}
class $fcf4a0832395b38a$var$ReflectMapImpl {
    constructor(field, unsafeInput, check = true){
        this.obj = this[0, $2eQsm.unsafeLocal] = unsafeInput !== null && unsafeInput !== void 0 ? unsafeInput : {};
        this.check = check;
        this._field = field;
    }
    field() {
        return this._field;
    }
    set(key, value) {
        if (this.check) {
            const err = (0, $g7x8s.checkMapEntry)(this._field, key, value);
            if (err) throw err;
        }
        this.obj[$fcf4a0832395b38a$var$mapKeyToLocal(key)] = $fcf4a0832395b38a$var$mapValueToLocal(this._field, value);
        return this;
    }
    delete(key) {
        const k = $fcf4a0832395b38a$var$mapKeyToLocal(key);
        const has = Object.prototype.hasOwnProperty.call(this.obj, k);
        if (has) delete this.obj[k];
        return has;
    }
    clear() {
        for (const key of Object.keys(this.obj))delete this.obj[key];
    }
    get(key) {
        let val = this.obj[$fcf4a0832395b38a$var$mapKeyToLocal(key)];
        if (val !== undefined) val = $fcf4a0832395b38a$var$mapValueToReflect(this._field, val, this.check);
        return val;
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.obj, $fcf4a0832395b38a$var$mapKeyToLocal(key));
    }
    *keys() {
        for (const objKey of Object.keys(this.obj))yield $fcf4a0832395b38a$var$mapKeyToReflect(objKey, this._field.mapKey);
    }
    *entries() {
        for (const objEntry of Object.entries(this.obj))yield [
            $fcf4a0832395b38a$var$mapKeyToReflect(objEntry[0], this._field.mapKey),
            $fcf4a0832395b38a$var$mapValueToReflect(this._field, objEntry[1], this.check)
        ];
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    get size() {
        return Object.keys(this.obj).length;
    }
    *values() {
        for (const val of Object.values(this.obj))yield $fcf4a0832395b38a$var$mapValueToReflect(this._field, val, this.check);
    }
    forEach(callbackfn, thisArg) {
        for (const mapEntry of this.entries())callbackfn.call(thisArg, mapEntry[1], mapEntry[0], this);
    }
}
function $fcf4a0832395b38a$var$messageToLocal(field, value) {
    if (!(0, $dcCoF.isReflectMessage)(value)) return value;
    if ((0, $AYHoV.isWrapper)(value.message) && !field.oneof && field.fieldKind == "message") // Types from google/protobuf/wrappers.proto are unwrapped when used in
    // a singular field that is not part of a oneof group.
    return value.message.value;
    if (value.desc.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value") // google.protobuf.Struct is represented with JsonObject when used in a
    // field, except when used in google.protobuf.Value.
    return $fcf4a0832395b38a$var$wktStructToLocal(value.message);
    return value.message;
}
function $fcf4a0832395b38a$var$messageToReflect(field, value, check) {
    if (value !== undefined) {
        if ((0, $AYHoV.isWrapperDesc)(field.message) && !field.oneof && field.fieldKind == "message") // Types from google/protobuf/wrappers.proto are unwrapped when used in
        // a singular field that is not part of a oneof group.
        value = {
            $typeName: field.message.typeName,
            value: $fcf4a0832395b38a$var$longToReflect(field.message.fields[0], value)
        };
        else if (field.message.typeName == "google.protobuf.Struct" && field.parent.typeName != "google.protobuf.Value" && (0, $dcCoF.isObject)(value)) // google.protobuf.Struct is represented with JsonObject when used in a
        // field, except when used in google.protobuf.Value.
        value = $fcf4a0832395b38a$var$wktStructToReflect(value);
    }
    return new $fcf4a0832395b38a$var$ReflectMessageImpl(field.message, value, check);
}
function $fcf4a0832395b38a$var$listItemToLocal(field, value) {
    if (field.listKind == "message") return $fcf4a0832395b38a$var$messageToLocal(field, value);
    return $fcf4a0832395b38a$var$longToLocal(field, value);
}
function $fcf4a0832395b38a$var$listItemToReflect(field, value, check) {
    if (field.listKind == "message") return $fcf4a0832395b38a$var$messageToReflect(field, value, check);
    return $fcf4a0832395b38a$var$longToReflect(field, value);
}
function $fcf4a0832395b38a$var$mapValueToLocal(field, value) {
    if (field.mapKind == "message") return $fcf4a0832395b38a$var$messageToLocal(field, value);
    return $fcf4a0832395b38a$var$longToLocal(field, value);
}
function $fcf4a0832395b38a$var$mapValueToReflect(field, value, check) {
    if (field.mapKind == "message") return $fcf4a0832395b38a$var$messageToReflect(field, value, check);
    return value;
}
function $fcf4a0832395b38a$var$mapKeyToLocal(key) {
    return typeof key == "string" || typeof key == "number" ? key : String(key);
}
/**
 * Converts a map key (any scalar value except float, double, or bytes) from its
 * representation in a message (string or number, the only possible object key
 * types) to the closest possible type in ECMAScript.
 */ function $fcf4a0832395b38a$var$mapKeyToReflect(key, type) {
    switch(type){
        case (0, $8xxTQ.ScalarType).STRING:
            return key;
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).UINT32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
            {
                const n = Number.parseInt(key);
                if (Number.isFinite(n)) return n;
                break;
            }
        case (0, $8xxTQ.ScalarType).BOOL:
            switch(key){
                case "true":
                    return true;
                case "false":
                    return false;
            }
            break;
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).FIXED64:
            try {
                return (0, $6zK55.protoInt64).uParse(key);
            } catch (_a) {
            //
            }
            break;
        default:
            // INT64, SFIXED64, SINT64
            try {
                return (0, $6zK55.protoInt64).parse(key);
            } catch (_b) {
            //
            }
            break;
    }
    return key;
}
function $fcf4a0832395b38a$var$longToReflect(field, value) {
    switch(field.scalar){
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            if ("longAsString" in field && field.longAsString && typeof value == "string") value = (0, $6zK55.protoInt64).parse(value);
            break;
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).UINT64:
            if ("longAsString" in field && field.longAsString && typeof value == "string") value = (0, $6zK55.protoInt64).uParse(value);
            break;
    }
    return value;
}
function $fcf4a0832395b38a$var$longToLocal(field, value) {
    switch(field.scalar){
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            if ("longAsString" in field && field.longAsString) value = String(value);
            else if (typeof value == "string" || typeof value == "number") value = (0, $6zK55.protoInt64).parse(value);
            break;
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).UINT64:
            if ("longAsString" in field && field.longAsString) value = String(value);
            else if (typeof value == "string" || typeof value == "number") value = (0, $6zK55.protoInt64).uParse(value);
            break;
    }
    return value;
}
function $fcf4a0832395b38a$var$wktStructToReflect(json) {
    const struct = {
        $typeName: "google.protobuf.Struct",
        fields: {}
    };
    if ((0, $dcCoF.isObject)(json)) for (const [k, v] of Object.entries(json))struct.fields[k] = $fcf4a0832395b38a$var$wktValueToReflect(v);
    return struct;
}
function $fcf4a0832395b38a$var$wktStructToLocal(val) {
    const json = {};
    for (const [k, v] of Object.entries(val.fields))json[k] = $fcf4a0832395b38a$var$wktValueToLocal(v);
    return json;
}
function $fcf4a0832395b38a$var$wktValueToLocal(val) {
    switch(val.kind.case){
        case "structValue":
            return $fcf4a0832395b38a$var$wktStructToLocal(val.kind.value);
        case "listValue":
            return val.kind.value.values.map($fcf4a0832395b38a$var$wktValueToLocal);
        case "nullValue":
        case undefined:
            return null;
        default:
            return val.kind.value;
    }
}
function $fcf4a0832395b38a$var$wktValueToReflect(json) {
    const value = {
        $typeName: "google.protobuf.Value",
        kind: {
            case: undefined
        }
    };
    switch(typeof json){
        case "number":
            value.kind = {
                case: "numberValue",
                value: json
            };
            break;
        case "string":
            value.kind = {
                case: "stringValue",
                value: json
            };
            break;
        case "boolean":
            value.kind = {
                case: "boolValue",
                value: json
            };
            break;
        case "object":
            if (json === null) {
                const nullValue = 0;
                value.kind = {
                    case: "nullValue",
                    value: nullValue
                };
            } else if (Array.isArray(json)) {
                const listValue = {
                    $typeName: "google.protobuf.ListValue",
                    values: []
                };
                if (Array.isArray(json)) for (const e of json)listValue.values.push($fcf4a0832395b38a$var$wktValueToReflect(e));
                value.kind = {
                    case: "listValue",
                    value: listValue
                };
            } else value.kind = {
                case: "structValue",
                value: $fcf4a0832395b38a$var$wktStructToReflect(json)
            };
            break;
    }
    return value;
}

});
parcelRegister("g7x8s", function(module, exports) {

$parcel$export(module.exports, "checkField", () => $bbc700cda7c857da$export$740ab33a5720d673);
$parcel$export(module.exports, "formatVal", () => $bbc700cda7c857da$export$8d6ee5d1a4364c0f);
$parcel$export(module.exports, "checkListItem", () => $bbc700cda7c857da$export$cae3e2d8e8d4b644);
$parcel$export(module.exports, "checkMapEntry", () => $bbc700cda7c857da$export$bd89c54367b23c86);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $cV1QK = parcelRequire("cV1QK");

var $2J3jP = parcelRequire("2J3jP");

var $dcCoF = parcelRequire("dcCoF");

var $fqP57 = parcelRequire("fqP57");

var $fkN3E = parcelRequire("fkN3E");

var $6zK55 = parcelRequire("6zK55");
function $bbc700cda7c857da$export$740ab33a5720d673(field, value) {
    const check = field.fieldKind == "list" ? (0, $dcCoF.isReflectList)(value, field) : field.fieldKind == "map" ? (0, $dcCoF.isReflectMap)(value, field) : $bbc700cda7c857da$var$checkSingular(field, value);
    if (check === true) return undefined;
    let reason;
    switch(field.fieldKind){
        case "list":
            reason = `expected ${$bbc700cda7c857da$var$formatReflectList(field)}, got ${$bbc700cda7c857da$export$8d6ee5d1a4364c0f(value)}`;
            break;
        case "map":
            reason = `expected ${$bbc700cda7c857da$var$formatReflectMap(field)}, got ${$bbc700cda7c857da$export$8d6ee5d1a4364c0f(value)}`;
            break;
        default:
            reason = $bbc700cda7c857da$var$reasonSingular(field, value, check);
    }
    return new (0, $2J3jP.FieldError)(field, reason);
}
function $bbc700cda7c857da$export$cae3e2d8e8d4b644(field, index, value) {
    const check = $bbc700cda7c857da$var$checkSingular(field, value);
    if (check !== true) return new (0, $2J3jP.FieldError)(field, `list item #${index + 1}: ${$bbc700cda7c857da$var$reasonSingular(field, value, check)}`);
    return undefined;
}
function $bbc700cda7c857da$export$bd89c54367b23c86(field, key, value) {
    const checkKey = $bbc700cda7c857da$var$checkScalarValue(key, field.mapKey);
    if (checkKey !== true) return new (0, $2J3jP.FieldError)(field, `invalid map key: ${$bbc700cda7c857da$var$reasonSingular({
        scalar: field.mapKey
    }, key, checkKey)}`);
    const checkVal = $bbc700cda7c857da$var$checkSingular(field, value);
    if (checkVal !== true) return new (0, $2J3jP.FieldError)(field, `map entry ${$bbc700cda7c857da$export$8d6ee5d1a4364c0f(key)}: ${$bbc700cda7c857da$var$reasonSingular(field, value, checkVal)}`);
    return undefined;
}
function $bbc700cda7c857da$var$checkSingular(field, value) {
    if (field.scalar !== undefined) return $bbc700cda7c857da$var$checkScalarValue(value, field.scalar);
    if (field.enum !== undefined) {
        if (field.enum.open) return Number.isInteger(value);
        return field.enum.values.some((v)=>v.number === value);
    }
    return (0, $dcCoF.isReflectMessage)(value, field.message);
}
function $bbc700cda7c857da$var$checkScalarValue(value, scalar) {
    switch(scalar){
        case (0, $8xxTQ.ScalarType).DOUBLE:
            return typeof value == "number";
        case (0, $8xxTQ.ScalarType).FLOAT:
            if (typeof value != "number") return false;
            if (Number.isNaN(value) || !Number.isFinite(value)) return true;
            if (value > (0, $fqP57.FLOAT32_MAX) || value < (0, $fqP57.FLOAT32_MIN)) return `${value.toFixed()} out of range`;
            return true;
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
            // signed
            if (typeof value !== "number" || !Number.isInteger(value)) return false;
            if (value > (0, $fqP57.INT32_MAX) || value < (0, $fqP57.INT32_MIN)) return `${value.toFixed()} out of range`;
            return true;
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).UINT32:
            // unsigned
            if (typeof value !== "number" || !Number.isInteger(value)) return false;
            if (value > (0, $fqP57.UINT32_MAX) || value < 0) return `${value.toFixed()} out of range`;
            return true;
        case (0, $8xxTQ.ScalarType).BOOL:
            return typeof value == "boolean";
        case (0, $8xxTQ.ScalarType).STRING:
            if (typeof value != "string") return false;
            return (0, $fkN3E.getTextEncoding)().checkUtf8(value) || "invalid UTF8";
        case (0, $8xxTQ.ScalarType).BYTES:
            return value instanceof Uint8Array;
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            // signed
            if (typeof value == "bigint" || typeof value == "number" || typeof value == "string" && value.length > 0) try {
                (0, $6zK55.protoInt64).parse(value);
                return true;
            } catch (_) {
                return `${value} out of range`;
            }
            return false;
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).UINT64:
            // unsigned
            if (typeof value == "bigint" || typeof value == "number" || typeof value == "string" && value.length > 0) try {
                (0, $6zK55.protoInt64).uParse(value);
                return true;
            } catch (_) {
                return `${value} out of range`;
            }
            return false;
    }
}
function $bbc700cda7c857da$var$reasonSingular(field, val, details) {
    details = typeof details == "string" ? `: ${details}` : `, got ${$bbc700cda7c857da$export$8d6ee5d1a4364c0f(val)}`;
    if (field.scalar !== undefined) return `expected ${$bbc700cda7c857da$var$scalarTypeDescription(field.scalar)}` + details;
    if (field.enum !== undefined) return `expected ${field.enum.toString()}` + details;
    return `expected ${$bbc700cda7c857da$var$formatReflectMessage(field.message)}` + details;
}
function $bbc700cda7c857da$export$8d6ee5d1a4364c0f(val) {
    switch(typeof val){
        case "object":
            if (val === null) return "null";
            if (val instanceof Uint8Array) return `Uint8Array(${val.length})`;
            if (Array.isArray(val)) return `Array(${val.length})`;
            if ((0, $dcCoF.isReflectList)(val)) return $bbc700cda7c857da$var$formatReflectList(val.field());
            if ((0, $dcCoF.isReflectMap)(val)) return $bbc700cda7c857da$var$formatReflectMap(val.field());
            if ((0, $dcCoF.isReflectMessage)(val)) return $bbc700cda7c857da$var$formatReflectMessage(val.desc);
            if ((0, $cV1QK.isMessage)(val)) return `message ${val.$typeName}`;
            return "object";
        case "string":
            return val.length > 30 ? "string" : `"${val.split('"').join('\\"')}"`;
        case "boolean":
            return String(val);
        case "number":
            return String(val);
        case "bigint":
            return String(val) + "n";
        default:
            // "symbol" | "undefined" | "object" | "function"
            return typeof val;
    }
}
function $bbc700cda7c857da$var$formatReflectMessage(desc) {
    return `ReflectMessage (${desc.typeName})`;
}
function $bbc700cda7c857da$var$formatReflectList(field) {
    switch(field.listKind){
        case "message":
            return `ReflectList (${field.message.toString()})`;
        case "enum":
            return `ReflectList (${field.enum.toString()})`;
        case "scalar":
            return `ReflectList (${(0, $8xxTQ.ScalarType)[field.scalar]})`;
    }
}
function $bbc700cda7c857da$var$formatReflectMap(field) {
    switch(field.mapKind){
        case "message":
            return `ReflectMap (${(0, $8xxTQ.ScalarType)[field.mapKey]}, ${field.message.toString()})`;
        case "enum":
            return `ReflectMap (${(0, $8xxTQ.ScalarType)[field.mapKey]}, ${field.enum.toString()})`;
        case "scalar":
            return `ReflectMap (${(0, $8xxTQ.ScalarType)[field.mapKey]}, ${(0, $8xxTQ.ScalarType)[field.scalar]})`;
    }
}
function $bbc700cda7c857da$var$scalarTypeDescription(scalar) {
    switch(scalar){
        case (0, $8xxTQ.ScalarType).STRING:
            return "string";
        case (0, $8xxTQ.ScalarType).BOOL:
            return "boolean";
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SINT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
            return "bigint (int64)";
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).FIXED64:
            return "bigint (uint64)";
        case (0, $8xxTQ.ScalarType).BYTES:
            return "Uint8Array";
        case (0, $8xxTQ.ScalarType).DOUBLE:
            return "number (float64)";
        case (0, $8xxTQ.ScalarType).FLOAT:
            return "number (float32)";
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).UINT32:
            return "number (uint32)";
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
            return "number (int32)";
    }
}

});
parcelRegister("cV1QK", function(module, exports) {

$parcel$export(module.exports, "isMessage", () => $967c3e41de6498ae$export$9e0e49e75fa7d548);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Determine whether the given `arg` is a message.
 * If `desc` is set, determine whether `arg` is this specific message.
 */ function $967c3e41de6498ae$export$9e0e49e75fa7d548(arg, schema) {
    const isMessage = arg !== null && typeof arg == "object" && "$typeName" in arg && typeof arg.$typeName == "string";
    if (!isMessage) return false;
    if (schema === undefined) return true;
    return schema.typeName === arg.$typeName;
}

});

parcelRegister("2J3jP", function(module, exports) {

$parcel$export(module.exports, "FieldError", () => $1fc25bcc6aeb82bf$export$f551688fc98f2e09);
$parcel$export(module.exports, "isFieldError", () => $1fc25bcc6aeb82bf$export$a0fa8435378938c1);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const $1fc25bcc6aeb82bf$var$errorNames = [
    "FieldValueInvalidError",
    "FieldListRangeError",
    "ForeignFieldError"
];
class $1fc25bcc6aeb82bf$export$f551688fc98f2e09 extends Error {
    constructor(fieldOrOneof, message, name = "FieldValueInvalidError"){
        super(message);
        this.name = name;
        this.field = ()=>fieldOrOneof;
    }
}
function $1fc25bcc6aeb82bf$export$a0fa8435378938c1(arg) {
    return arg instanceof Error && $1fc25bcc6aeb82bf$var$errorNames.includes(arg.name) && "field" in arg && typeof arg.field == "function";
}

});

parcelRegister("dcCoF", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $99ca2e29a4678524$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isReflectList", () => $99ca2e29a4678524$export$d46c5f08c347974b);
$parcel$export(module.exports, "isReflectMap", () => $99ca2e29a4678524$export$6b46db8599f1daaf);
$parcel$export(module.exports, "isReflectMessage", () => $99ca2e29a4678524$export$addd36cea3d1aa1b);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $2eQsm = parcelRequire("2eQsm");
function $99ca2e29a4678524$export$a6cdc56e425d0d0a(arg) {
    return arg !== null && typeof arg == "object" && !Array.isArray(arg);
}
function $99ca2e29a4678524$export$c6c3989554a41329(arg) {
    return arg !== null && typeof arg == "object" && "case" in arg && (typeof arg.case == "string" && "value" in arg && arg.value != null || arg.case === undefined && (!("value" in arg) || arg.value === undefined));
}
function $99ca2e29a4678524$export$d46c5f08c347974b(arg, field) {
    var _a, _b, _c, _d;
    if ($99ca2e29a4678524$export$a6cdc56e425d0d0a(arg) && (0, $2eQsm.unsafeLocal) in arg && "add" in arg && "field" in arg && typeof arg.field == "function") {
        if (field !== undefined) {
            const a = field;
            const b = arg.field();
            return a.listKind == b.listKind && a.scalar === b.scalar && ((_a = a.message) === null || _a === void 0 ? void 0 : _a.typeName) === ((_b = b.message) === null || _b === void 0 ? void 0 : _b.typeName) && ((_c = a.enum) === null || _c === void 0 ? void 0 : _c.typeName) === ((_d = b.enum) === null || _d === void 0 ? void 0 : _d.typeName);
        }
        return true;
    }
    return false;
}
function $99ca2e29a4678524$export$6b46db8599f1daaf(arg, field) {
    var _a, _b, _c, _d;
    if ($99ca2e29a4678524$export$a6cdc56e425d0d0a(arg) && (0, $2eQsm.unsafeLocal) in arg && "has" in arg && "field" in arg && typeof arg.field == "function") {
        if (field !== undefined) {
            const a = field, b = arg.field();
            return a.mapKey === b.mapKey && a.mapKind == b.mapKind && a.scalar === b.scalar && ((_a = a.message) === null || _a === void 0 ? void 0 : _a.typeName) === ((_b = b.message) === null || _b === void 0 ? void 0 : _b.typeName) && ((_c = a.enum) === null || _c === void 0 ? void 0 : _c.typeName) === ((_d = b.enum) === null || _d === void 0 ? void 0 : _d.typeName);
        }
        return true;
    }
    return false;
}
function $99ca2e29a4678524$export$addd36cea3d1aa1b(arg, messageDesc) {
    return $99ca2e29a4678524$export$a6cdc56e425d0d0a(arg) && (0, $2eQsm.unsafeLocal) in arg && "desc" in arg && $99ca2e29a4678524$export$a6cdc56e425d0d0a(arg.desc) && arg.desc.kind === "message" && (messageDesc === undefined || arg.desc.typeName == messageDesc.typeName);
}

});

parcelRegister("fqP57", function(module, exports) {

$parcel$export(module.exports, "WireType", () => $b3c0e87688f82eba$export$e5d73eed61ade2af);
$parcel$export(module.exports, "FLOAT32_MAX", () => $b3c0e87688f82eba$export$7f74075a11343bb);
$parcel$export(module.exports, "FLOAT32_MIN", () => $b3c0e87688f82eba$export$690e420a4438df51);
$parcel$export(module.exports, "UINT32_MAX", () => $b3c0e87688f82eba$export$3314b2c271c86d70);
$parcel$export(module.exports, "INT32_MAX", () => $b3c0e87688f82eba$export$b60fbbf9d0cca865);
$parcel$export(module.exports, "INT32_MIN", () => $b3c0e87688f82eba$export$7c8d084d4d24b822);
$parcel$export(module.exports, "BinaryWriter", () => $b3c0e87688f82eba$export$b6da98667e5e554f);
$parcel$export(module.exports, "BinaryReader", () => $b3c0e87688f82eba$export$76c443c41c20b286);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $ftkgD = parcelRequire("ftkgD");

var $6zK55 = parcelRequire("6zK55");

var $fkN3E = parcelRequire("fkN3E");
var $b3c0e87688f82eba$export$e5d73eed61ade2af;
(function(WireType) {
    /**
     * Used for int32, int64, uint32, uint64, sint32, sint64, bool, enum
     */ WireType[WireType["Varint"] = 0] = "Varint";
    /**
     * Used for fixed64, sfixed64, double.
     * Always 8 bytes with little-endian byte order.
     */ WireType[WireType["Bit64"] = 1] = "Bit64";
    /**
     * Used for string, bytes, embedded messages, packed repeated fields
     *
     * Only repeated numeric types (types which use the varint, 32-bit,
     * or 64-bit wire types) can be packed. In proto3, such fields are
     * packed by default.
     */ WireType[WireType["LengthDelimited"] = 2] = "LengthDelimited";
    /**
     * Start of a tag-delimited aggregate, such as a proto2 group, or a message
     * in editions with message_encoding = DELIMITED.
     */ WireType[WireType["StartGroup"] = 3] = "StartGroup";
    /**
     * End of a tag-delimited aggregate.
     */ WireType[WireType["EndGroup"] = 4] = "EndGroup";
    /**
     * Used for fixed32, sfixed32, float.
     * Always 4 bytes with little-endian byte order.
     */ WireType[WireType["Bit32"] = 5] = "Bit32";
})($b3c0e87688f82eba$export$e5d73eed61ade2af || ($b3c0e87688f82eba$export$e5d73eed61ade2af = {}));
const $b3c0e87688f82eba$export$7f74075a11343bb = 3.4028234663852886e38;
const $b3c0e87688f82eba$export$690e420a4438df51 = -340282346638528860000000000000000000000;
const $b3c0e87688f82eba$export$3314b2c271c86d70 = 0xffffffff;
const $b3c0e87688f82eba$export$b60fbbf9d0cca865 = 0x7fffffff;
const $b3c0e87688f82eba$export$7c8d084d4d24b822 = -2147483648;
class $b3c0e87688f82eba$export$b6da98667e5e554f {
    constructor(encodeUtf8 = (0, $fkN3E.getTextEncoding)().encodeUtf8){
        this.encodeUtf8 = encodeUtf8;
        /**
         * Previous fork states.
         */ this.stack = [];
        this.chunks = [];
        this.buf = [];
    }
    /**
     * Return all bytes written and reset this writer.
     */ finish() {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf)); // flush the buffer
            this.buf = [];
        }
        let len = 0;
        for(let i = 0; i < this.chunks.length; i++)len += this.chunks[i].length;
        let bytes = new Uint8Array(len);
        let offset = 0;
        for(let i = 0; i < this.chunks.length; i++){
            bytes.set(this.chunks[i], offset);
            offset += this.chunks[i].length;
        }
        this.chunks = [];
        return bytes;
    }
    /**
     * Start a new fork for length-delimited data like a message
     * or a packed repeated field.
     *
     * Must be joined later with `join()`.
     */ fork() {
        this.stack.push({
            chunks: this.chunks,
            buf: this.buf
        });
        this.chunks = [];
        this.buf = [];
        return this;
    }
    /**
     * Join the last fork. Write its length and bytes, then
     * return to the previous state.
     */ join() {
        // get chunk of fork
        let chunk = this.finish();
        // restore previous state
        let prev = this.stack.pop();
        if (!prev) throw new Error("invalid state, fork stack empty");
        this.chunks = prev.chunks;
        this.buf = prev.buf;
        // write length of chunk as varint
        this.uint32(chunk.byteLength);
        return this.raw(chunk);
    }
    /**
     * Writes a tag (field number and wire type).
     *
     * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
     *
     * Generated code should compute the tag ahead of time and call `uint32()`.
     */ tag(fieldNo, type) {
        return this.uint32((fieldNo << 3 | type) >>> 0);
    }
    /**
     * Write a chunk of raw bytes.
     */ raw(chunk) {
        if (this.buf.length) {
            this.chunks.push(new Uint8Array(this.buf));
            this.buf = [];
        }
        this.chunks.push(chunk);
        return this;
    }
    /**
     * Write a `uint32` value, an unsigned 32 bit varint.
     */ uint32(value) {
        $b3c0e87688f82eba$var$assertUInt32(value);
        // write value as varint 32, inlined for speed
        while(value > 0x7f){
            this.buf.push(value & 0x7f | 0x80);
            value = value >>> 7;
        }
        this.buf.push(value);
        return this;
    }
    /**
     * Write a `int32` value, a signed 32 bit varint.
     */ int32(value) {
        $b3c0e87688f82eba$var$assertInt32(value);
        (0, $ftkgD.varint32write)(value, this.buf);
        return this;
    }
    /**
     * Write a `bool` value, a variant.
     */ bool(value) {
        this.buf.push(value ? 1 : 0);
        return this;
    }
    /**
     * Write a `bytes` value, length-delimited arbitrary data.
     */ bytes(value) {
        this.uint32(value.byteLength); // write length of chunk as varint
        return this.raw(value);
    }
    /**
     * Write a `string` value, length-delimited data converted to UTF-8 text.
     */ string(value) {
        let chunk = this.encodeUtf8(value);
        this.uint32(chunk.byteLength); // write length of chunk as varint
        return this.raw(chunk);
    }
    /**
     * Write a `float` value, 32-bit floating point number.
     */ float(value) {
        $b3c0e87688f82eba$var$assertFloat32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setFloat32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `double` value, a 64-bit floating point number.
     */ double(value) {
        let chunk = new Uint8Array(8);
        new DataView(chunk.buffer).setFloat64(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
     */ fixed32(value) {
        $b3c0e87688f82eba$var$assertUInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setUint32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
     */ sfixed32(value) {
        $b3c0e87688f82eba$var$assertInt32(value);
        let chunk = new Uint8Array(4);
        new DataView(chunk.buffer).setInt32(0, value, true);
        return this.raw(chunk);
    }
    /**
     * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
     */ sint32(value) {
        $b3c0e87688f82eba$var$assertInt32(value);
        // zigzag encode
        value = (value << 1 ^ value >> 31) >>> 0;
        (0, $ftkgD.varint32write)(value, this.buf);
        return this;
    }
    /**
     * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
     */ sfixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = (0, $6zK55.protoInt64).enc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
     */ fixed64(value) {
        let chunk = new Uint8Array(8), view = new DataView(chunk.buffer), tc = (0, $6zK55.protoInt64).uEnc(value);
        view.setInt32(0, tc.lo, true);
        view.setInt32(4, tc.hi, true);
        return this.raw(chunk);
    }
    /**
     * Write a `int64` value, a signed 64-bit varint.
     */ int64(value) {
        let tc = (0, $6zK55.protoInt64).enc(value);
        (0, $ftkgD.varint64write)(tc.lo, tc.hi, this.buf);
        return this;
    }
    /**
     * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
     */ sint64(value) {
        const tc = (0, $6zK55.protoInt64).enc(value), // zigzag encode
        sign = tc.hi >> 31, lo = tc.lo << 1 ^ sign, hi = (tc.hi << 1 | tc.lo >>> 31) ^ sign;
        (0, $ftkgD.varint64write)(lo, hi, this.buf);
        return this;
    }
    /**
     * Write a `uint64` value, an unsigned 64-bit varint.
     */ uint64(value) {
        const tc = (0, $6zK55.protoInt64).uEnc(value);
        (0, $ftkgD.varint64write)(tc.lo, tc.hi, this.buf);
        return this;
    }
}
class $b3c0e87688f82eba$export$76c443c41c20b286 {
    constructor(buf, decodeUtf8 = (0, $fkN3E.getTextEncoding)().decodeUtf8){
        this.decodeUtf8 = decodeUtf8;
        this.varint64 = (0, $ftkgD.varint64read); // dirty cast for `this`
        /**
         * Read a `uint32` field, an unsigned 32 bit varint.
         */ this.uint32 = (0, $ftkgD.varint32read);
        this.buf = buf;
        this.len = buf.length;
        this.pos = 0;
        this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
     * Reads a tag - field number and wire type.
     */ tag() {
        let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
        if (fieldNo <= 0 || wireType < 0 || wireType > 5) throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
        return [
            fieldNo,
            wireType
        ];
    }
    /**
     * Skip one element and return the skipped data.
     *
     * When skipping StartGroup, provide the tags field number to check for
     * matching field number in the EndGroup tag.
     */ skip(wireType, fieldNo) {
        let start = this.pos;
        switch(wireType){
            case $b3c0e87688f82eba$export$e5d73eed61ade2af.Varint:
                while(this.buf[this.pos++] & 0x80);
                break;
            // @ts-expect-error TS7029: Fallthrough case in switch
            case $b3c0e87688f82eba$export$e5d73eed61ade2af.Bit64:
                this.pos += 4;
            case $b3c0e87688f82eba$export$e5d73eed61ade2af.Bit32:
                this.pos += 4;
                break;
            case $b3c0e87688f82eba$export$e5d73eed61ade2af.LengthDelimited:
                let len = this.uint32();
                this.pos += len;
                break;
            case $b3c0e87688f82eba$export$e5d73eed61ade2af.StartGroup:
                for(;;){
                    const [fn, wt] = this.tag();
                    if (wt === $b3c0e87688f82eba$export$e5d73eed61ade2af.EndGroup) {
                        if (fieldNo !== undefined && fn !== fieldNo) throw new Error("invalid end group tag");
                        break;
                    }
                    this.skip(wt, fn);
                }
                break;
            default:
                throw new Error("cant skip wire type " + wireType);
        }
        this.assertBounds();
        return this.buf.subarray(start, this.pos);
    }
    /**
     * Throws error if position in byte array is out of range.
     */ assertBounds() {
        if (this.pos > this.len) throw new RangeError("premature EOF");
    }
    /**
     * Read a `int32` field, a signed 32 bit varint.
     */ int32() {
        return this.uint32() | 0;
    }
    /**
     * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
     */ sint32() {
        let zze = this.uint32();
        // decode zigzag
        return zze >>> 1 ^ -(zze & 1);
    }
    /**
     * Read a `int64` field, a signed 64-bit varint.
     */ int64() {
        return (0, $6zK55.protoInt64).dec(...this.varint64());
    }
    /**
     * Read a `uint64` field, an unsigned 64-bit varint.
     */ uint64() {
        return (0, $6zK55.protoInt64).uDec(...this.varint64());
    }
    /**
     * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
     */ sint64() {
        let [lo, hi] = this.varint64();
        // decode zig zag
        let s = -(lo & 1);
        lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
        hi = hi >>> 1 ^ s;
        return (0, $6zK55.protoInt64).dec(lo, hi);
    }
    /**
     * Read a `bool` field, a variant.
     */ bool() {
        let [lo, hi] = this.varint64();
        return lo !== 0 || hi !== 0;
    }
    /**
     * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
     */ fixed32() {
        // biome-ignore lint/suspicious/noAssignInExpressions: no
        return this.view.getUint32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
     */ sfixed32() {
        // biome-ignore lint/suspicious/noAssignInExpressions: no
        return this.view.getInt32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
     */ fixed64() {
        return (0, $6zK55.protoInt64).uDec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
     */ sfixed64() {
        return (0, $6zK55.protoInt64).dec(this.sfixed32(), this.sfixed32());
    }
    /**
     * Read a `float` field, 32-bit floating point number.
     */ float() {
        // biome-ignore lint/suspicious/noAssignInExpressions: no
        return this.view.getFloat32((this.pos += 4) - 4, true);
    }
    /**
     * Read a `double` field, a 64-bit floating point number.
     */ double() {
        // biome-ignore lint/suspicious/noAssignInExpressions: no
        return this.view.getFloat64((this.pos += 8) - 8, true);
    }
    /**
     * Read a `bytes` field, length-delimited arbitrary data.
     */ bytes() {
        let len = this.uint32(), start = this.pos;
        this.pos += len;
        this.assertBounds();
        return this.buf.subarray(start, start + len);
    }
    /**
     * Read a `string` field, length-delimited data converted to UTF-8 text.
     */ string() {
        return this.decodeUtf8(this.bytes());
    }
}
/**
 * Assert a valid signed protobuf 32-bit integer as a number or string.
 */ function $b3c0e87688f82eba$var$assertInt32(arg) {
    if (typeof arg == "string") arg = Number(arg);
    else if (typeof arg != "number") throw new Error("invalid int32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $b3c0e87688f82eba$export$b60fbbf9d0cca865 || arg < $b3c0e87688f82eba$export$7c8d084d4d24b822) throw new Error("invalid int32: " + arg);
}
/**
 * Assert a valid unsigned protobuf 32-bit integer as a number or string.
 */ function $b3c0e87688f82eba$var$assertUInt32(arg) {
    if (typeof arg == "string") arg = Number(arg);
    else if (typeof arg != "number") throw new Error("invalid uint32: " + typeof arg);
    if (!Number.isInteger(arg) || arg > $b3c0e87688f82eba$export$3314b2c271c86d70 || arg < 0) throw new Error("invalid uint32: " + arg);
}
/**
 * Assert a valid protobuf float value as a number or string.
 */ function $b3c0e87688f82eba$var$assertFloat32(arg) {
    if (typeof arg == "string") {
        const o = arg;
        arg = Number(arg);
        if (Number.isNaN(arg) && o !== "NaN") throw new Error("invalid float32: " + o);
    } else if (typeof arg != "number") throw new Error("invalid float32: " + typeof arg);
    if (Number.isFinite(arg) && (arg > $b3c0e87688f82eba$export$7f74075a11343bb || arg < $b3c0e87688f82eba$export$690e420a4438df51)) throw new Error("invalid float32: " + arg);
}

});
parcelRegister("fkN3E", function(module, exports) {

$parcel$export(module.exports, "getTextEncoding", () => $b29ec725f6562473$export$e23a555aef1af100);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const $b29ec725f6562473$var$symbol = Symbol.for("@bufbuild/protobuf/text-encoding");
function $b29ec725f6562473$export$699cc2c1f8a87aea(textEncoding) {
    globalThis[$b29ec725f6562473$var$symbol] = textEncoding;
}
function $b29ec725f6562473$export$e23a555aef1af100() {
    if (globalThis[$b29ec725f6562473$var$symbol] == undefined) {
        const te = new globalThis.TextEncoder();
        const td = new globalThis.TextDecoder();
        globalThis[$b29ec725f6562473$var$symbol] = {
            encodeUtf8 (text) {
                return te.encode(text);
            },
            decodeUtf8 (bytes) {
                return td.decode(bytes);
            },
            checkUtf8 (text) {
                try {
                    encodeURIComponent(text);
                    return true;
                } catch (_) {
                    return false;
                }
            }
        };
    }
    return globalThis[$b29ec725f6562473$var$symbol];
}

});



parcelRegister("1jDsz", function(module, exports) {

$parcel$export(module.exports, "create", () => $0f562cad1da3f534$export$185802fd694ee1f5);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $cV1QK = parcelRequire("cV1QK");

var $8xxTQ = parcelRequire("8xxTQ");

var $lipan = parcelRequire("lipan");

var $dcCoF = parcelRequire("dcCoF");

var $2eQsm = parcelRequire("2eQsm");

var $AYHoV = parcelRequire("AYHoV");
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO3: const $name: Edition.$localName = $number;
const $0f562cad1da3f534$var$EDITION_PROTO3 = 999;
// bootstrap-inject google.protobuf.Edition.EDITION_PROTO2: const $name: Edition.$localName = $number;
const $0f562cad1da3f534$var$EDITION_PROTO2 = 998;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name: FeatureSet_FieldPresence.$localName = $number;
const $0f562cad1da3f534$var$IMPLICIT = 2;
function $0f562cad1da3f534$export$185802fd694ee1f5(schema, init) {
    if ((0, $cV1QK.isMessage)(init, schema)) return init;
    const message = $0f562cad1da3f534$var$createZeroMessage(schema);
    if (init !== undefined) $0f562cad1da3f534$var$initMessage(schema, message, init);
    return message;
}
/**
 * Sets field values from a MessageInitShape on a zero message.
 */ function $0f562cad1da3f534$var$initMessage(messageDesc, message, init) {
    for (const member of messageDesc.members){
        let value = init[member.localName];
        if (value == null) continue;
        let field;
        if (member.kind == "oneof") {
            const oneofField = (0, $2eQsm.unsafeOneofCase)(init, member);
            if (!oneofField) continue;
            field = oneofField;
            value = (0, $2eQsm.unsafeGet)(init, oneofField);
        } else field = member;
        switch(field.fieldKind){
            case "message":
                value = $0f562cad1da3f534$var$toMessage(field, value);
                break;
            case "scalar":
                value = $0f562cad1da3f534$var$initScalar(field, value);
                break;
            case "list":
                value = $0f562cad1da3f534$var$initList(field, value);
                break;
            case "map":
                value = $0f562cad1da3f534$var$initMap(field, value);
                break;
        }
        (0, $2eQsm.unsafeSet)(message, field, value);
    }
    return message;
}
function $0f562cad1da3f534$var$initScalar(field, value) {
    if (field.scalar == (0, $8xxTQ.ScalarType).BYTES) return $0f562cad1da3f534$var$toU8Arr(value);
    return value;
}
function $0f562cad1da3f534$var$initMap(field, value) {
    if ((0, $dcCoF.isObject)(value)) {
        if (field.scalar == (0, $8xxTQ.ScalarType).BYTES) return $0f562cad1da3f534$var$convertObjectValues(value, $0f562cad1da3f534$var$toU8Arr);
        if (field.mapKind == "message") return $0f562cad1da3f534$var$convertObjectValues(value, (val)=>$0f562cad1da3f534$var$toMessage(field, val));
    }
    return value;
}
function $0f562cad1da3f534$var$initList(field, value) {
    if (Array.isArray(value)) {
        if (field.scalar == (0, $8xxTQ.ScalarType).BYTES) return value.map($0f562cad1da3f534$var$toU8Arr);
        if (field.listKind == "message") return value.map((item)=>$0f562cad1da3f534$var$toMessage(field, item));
    }
    return value;
}
function $0f562cad1da3f534$var$toMessage(field, value) {
    if (field.fieldKind == "message" && !field.oneof && (0, $AYHoV.isWrapperDesc)(field.message)) // Types from google/protobuf/wrappers.proto are unwrapped when used in
    // a singular field that is not part of a oneof group.
    return $0f562cad1da3f534$var$initScalar(field.message.fields[0], value);
    if ((0, $dcCoF.isObject)(value)) {
        if (field.message.typeName == "google.protobuf.Struct" && field.parent.typeName !== "google.protobuf.Value") // google.protobuf.Struct is represented with JsonObject when used in a
        // field, except when used in google.protobuf.Value.
        return value;
        if (!(0, $cV1QK.isMessage)(value, field.message)) return $0f562cad1da3f534$export$185802fd694ee1f5(field.message, value);
    }
    return value;
}
// converts any ArrayLike<number> to Uint8Array if necessary.
function $0f562cad1da3f534$var$toU8Arr(value) {
    return Array.isArray(value) ? new Uint8Array(value) : value;
}
function $0f562cad1da3f534$var$convertObjectValues(obj, fn) {
    const ret = {};
    for (const entry of Object.entries(obj))ret[entry[0]] = fn(entry[1]);
    return ret;
}
const $0f562cad1da3f534$var$tokenZeroMessageField = Symbol();
const $0f562cad1da3f534$var$messagePrototypes = new WeakMap();
/**
 * Create a zero message.
 */ function $0f562cad1da3f534$var$createZeroMessage(desc) {
    let msg;
    if (!$0f562cad1da3f534$var$needsPrototypeChain(desc)) {
        msg = {
            $typeName: desc.typeName
        };
        for (const member of desc.members)if (member.kind == "oneof" || member.presence == $0f562cad1da3f534$var$IMPLICIT) msg[member.localName] = $0f562cad1da3f534$var$createZeroField(member);
    } else {
        // Support default values and track presence via the prototype chain
        const cached = $0f562cad1da3f534$var$messagePrototypes.get(desc);
        let prototype;
        let members;
        if (cached) ({ prototype: prototype, members: members } = cached);
        else {
            prototype = {};
            members = new Set();
            for (const member of desc.members){
                if (member.kind == "oneof") continue;
                if (member.fieldKind != "scalar" && member.fieldKind != "enum") continue;
                if (member.presence == $0f562cad1da3f534$var$IMPLICIT) continue;
                members.add(member);
                prototype[member.localName] = $0f562cad1da3f534$var$createZeroField(member);
            }
            $0f562cad1da3f534$var$messagePrototypes.set(desc, {
                prototype: prototype,
                members: members
            });
        }
        msg = Object.create(prototype);
        msg.$typeName = desc.typeName;
        for (const member of desc.members){
            if (members.has(member)) continue;
            if (member.kind == "field") {
                if (member.fieldKind == "message") continue;
                if (member.fieldKind == "scalar" || member.fieldKind == "enum") {
                    if (member.presence != $0f562cad1da3f534$var$IMPLICIT) continue;
                }
            }
            msg[member.localName] = $0f562cad1da3f534$var$createZeroField(member);
        }
    }
    return msg;
}
/**
 * Do we need the prototype chain to track field presence?
 */ function $0f562cad1da3f534$var$needsPrototypeChain(desc) {
    switch(desc.file.edition){
        case $0f562cad1da3f534$var$EDITION_PROTO3:
            // proto3 always uses implicit presence, we never need the prototype chain.
            return false;
        case $0f562cad1da3f534$var$EDITION_PROTO2:
            // proto2 never uses implicit presence, we always need the prototype chain.
            return true;
        default:
            // If a message uses scalar or enum fields with explicit presence, we need
            // the prototype chain to track presence. This rule does not apply to fields
            // in a oneof group - they use a different mechanism to track presence.
            return desc.fields.some((f)=>f.presence != $0f562cad1da3f534$var$IMPLICIT && f.fieldKind != "message" && !f.oneof);
    }
}
/**
 * Returns a zero value for oneof groups, and for every field kind except
 * messages. Scalar and enum fields can have default values.
 */ function $0f562cad1da3f534$var$createZeroField(field) {
    if (field.kind == "oneof") return {
        case: undefined
    };
    if (field.fieldKind == "list") return [];
    if (field.fieldKind == "map") return {}; // Object.create(null) would be desirable here, but is unsupported by react https://react.dev/reference/react/use-server#serializable-parameters-and-return-values
    if (field.fieldKind == "message") return $0f562cad1da3f534$var$tokenZeroMessageField;
    const defaultValue = field.getDefaultValue();
    if (defaultValue !== undefined) return field.fieldKind == "scalar" && field.longAsString ? defaultValue.toString() : defaultValue;
    return field.fieldKind == "scalar" ? (0, $lipan.scalarZeroValue)(field.scalar, field.longAsString) : field.enum.values[0].number;
}

});
parcelRegister("AYHoV", function(module, exports) {

$parcel$export(module.exports, "isWrapper", () => $06f27277b4d9af84$export$100b3a8ecc806c3b);
$parcel$export(module.exports, "isWrapperDesc", () => $06f27277b4d9af84$export$d1c762d5922f3118);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function $06f27277b4d9af84$export$100b3a8ecc806c3b(arg) {
    return $06f27277b4d9af84$var$isWrapperTypeName(arg.$typeName);
}
function $06f27277b4d9af84$export$d1c762d5922f3118(messageDesc) {
    const f = messageDesc.fields[0];
    return $06f27277b4d9af84$var$isWrapperTypeName(messageDesc.typeName) && f !== undefined && f.fieldKind == "scalar" && f.name == "value" && f.number == 1;
}
function $06f27277b4d9af84$var$isWrapperTypeName(name) {
    return name.startsWith("google.protobuf.") && [
        "DoubleValue",
        "FloatValue",
        "Int64Value",
        "UInt64Value",
        "Int32Value",
        "UInt32Value",
        "BoolValue",
        "StringValue",
        "BytesValue"
    ].includes(name.substring(16));
}

});





parcelRegister("jHEye", function(module, exports) {

$parcel$export(module.exports, "messageDesc", () => $e5817d13e738c981$export$4b54b39321d1b337);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Hydrate a message descriptor.
 *
 * @private
 */ function $e5817d13e738c981$export$4b54b39321d1b337(file, path, ...paths) {
    return paths.reduce((acc, cur)=>acc.nestedMessages[cur], file.messages[path]);
}

});

parcelRegister("bv1KU", function(module, exports) {

$parcel$export(module.exports, "file_v1_restic", () => $a87fb4e5ac6457a5$export$1a711f7964636b03);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/restic.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
const $a87fb4e5ac6457a5$export$1a711f7964636b03 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("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");
const $a87fb4e5ac6457a5$export$15dc6653334d41fd = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 0);
const $a87fb4e5ac6457a5$export$f9f0b37c2f6de82a = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 1);
const $a87fb4e5ac6457a5$export$b1b31c5d8ce38627 = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 2);
const $a87fb4e5ac6457a5$export$948b2d9a8b37cc32 = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 3);
const $a87fb4e5ac6457a5$export$7b1c514c8118551d = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 4);
const $a87fb4e5ac6457a5$export$c6dce6d4caf2ea9a = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 5);
const $a87fb4e5ac6457a5$export$743009df9fc5f282 = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 6);
const $a87fb4e5ac6457a5$export$cf1ba43ecb2eae41 = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 7);
const $a87fb4e5ac6457a5$export$3314dabe81be06a3 = /*@__PURE__*/ (0, $jHEye.messageDesc)($a87fb4e5ac6457a5$export$1a711f7964636b03, 8);

});

parcelRegister("6Os56", function(module, exports) {

$parcel$export(module.exports, "file_v1_config", () => $5627a58e424cdfa3$export$5d787e7bcbb50094);
$parcel$export(module.exports, "ConfigSchema", () => $5627a58e424cdfa3$export$e54a743cb2cd79b9);
$parcel$export(module.exports, "MultihostSchema", () => $5627a58e424cdfa3$export$99aba7d2a0c361b8);
$parcel$export(module.exports, "Multihost_PeerSchema", () => $5627a58e424cdfa3$export$3a9da95111cf4f7f);
$parcel$export(module.exports, "Multihost_Permission_Type", () => $5627a58e424cdfa3$export$33d1cad2074e0b99);
$parcel$export(module.exports, "RepoSchema", () => $5627a58e424cdfa3$export$61cfb543e85994f6);
$parcel$export(module.exports, "PlanSchema", () => $5627a58e424cdfa3$export$63d74a290f29052a);
$parcel$export(module.exports, "CommandPrefix_IONiceLevel", () => $5627a58e424cdfa3$export$2c69ee56049a016d);
$parcel$export(module.exports, "CommandPrefix_IONiceLevelSchema", () => $5627a58e424cdfa3$export$678ced0361a4102b);
$parcel$export(module.exports, "CommandPrefix_CPUNiceLevel", () => $5627a58e424cdfa3$export$5134cf17b7f2623d);
$parcel$export(module.exports, "CommandPrefix_CPUNiceLevelSchema", () => $5627a58e424cdfa3$export$2e9357326a6787db);
$parcel$export(module.exports, "RetentionPolicySchema", () => $5627a58e424cdfa3$export$178386e1d831154b);
$parcel$export(module.exports, "Schedule_Clock", () => $5627a58e424cdfa3$export$7a107beb3a32a89);
$parcel$export(module.exports, "Schedule_ClockSchema", () => $5627a58e424cdfa3$export$e23e55eb749998cb);
$parcel$export(module.exports, "Hook_ConditionSchema", () => $5627a58e424cdfa3$export$830f278e1bb6fbd0);
$parcel$export(module.exports, "Hook_OnErrorSchema", () => $5627a58e424cdfa3$export$9df71ba9a3384b86);
$parcel$export(module.exports, "AuthSchema", () => $5627a58e424cdfa3$export$b63c30c0b05b5d17);
$parcel$export(module.exports, "UserSchema", () => $5627a58e424cdfa3$export$50459aae8e896057);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/config.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $3hwGY = parcelRequire("3hwGY");
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");

var $l6s0m = parcelRequire("l6s0m");

var $9kWNX = parcelRequire("9kWNX");
const $5627a58e424cdfa3$export$5d787e7bcbb50094 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("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", [
    (0, $l6s0m.file_google_protobuf_empty),
    (0, $9kWNX.file_v1_crypto)
]);
const $5627a58e424cdfa3$export$3230c702ef694db8 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 0);
const $5627a58e424cdfa3$export$7b8936b8aba04e6d = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 0, 0);
const $5627a58e424cdfa3$export$e54a743cb2cd79b9 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 1);
const $5627a58e424cdfa3$export$99aba7d2a0c361b8 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 2);
const $5627a58e424cdfa3$export$3a9da95111cf4f7f = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 2, 0);
const $5627a58e424cdfa3$export$d4f60e7b55ef8e72 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 2, 1);
var $5627a58e424cdfa3$export$33d1cad2074e0b99 = /*#__PURE__*/ function(Multihost_Permission_Type) {
    /**
   * @generated from enum value: PERMISSION_UNKNOWN = 0;
   */ Multihost_Permission_Type[Multihost_Permission_Type["PERMISSION_UNKNOWN"] = 0] = "PERMISSION_UNKNOWN";
    /**
   * When granted to a knownHost the local instance will push local changes to that known host.
   *
   * @generated from enum value: PERMISSION_READ_OPERATIONS = 1;
   */ Multihost_Permission_Type[Multihost_Permission_Type["PERMISSION_READ_OPERATIONS"] = 1] = "PERMISSION_READ_OPERATIONS";
    /**
   * When granted to an authorizedClient, the client will be able to pull the configuration from the server.
   * When granted to a knownHost, the known host will be able to pull configuration from the client.
   *
   * read configuration for the resource in scope.
   *
   * @generated from enum value: PERMISSION_READ_CONFIG = 2;
   */ Multihost_Permission_Type[Multihost_Permission_Type["PERMISSION_READ_CONFIG"] = 2] = "PERMISSION_READ_CONFIG";
    /**
   * When granted to an authorizedClient, the client will be able to write the configuration to the server.
   * When granted to a knownHost, the known host will be able to write configuration.
   *
   * read and write configuration for the resource in scope.
   *
   * @generated from enum value: PERMISSION_READ_WRITE_CONFIG = 3;
   */ Multihost_Permission_Type[Multihost_Permission_Type["PERMISSION_READ_WRITE_CONFIG"] = 3] = "PERMISSION_READ_WRITE_CONFIG";
    return Multihost_Permission_Type;
}({});
const $5627a58e424cdfa3$export$11fd286a32de1797 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 2, 1, 0);
const $5627a58e424cdfa3$export$61cfb543e85994f6 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 3);
const $5627a58e424cdfa3$export$63d74a290f29052a = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 4);
const $5627a58e424cdfa3$export$40903288f04c4b09 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 5);
var $5627a58e424cdfa3$export$2c69ee56049a016d = /*#__PURE__*/ function(CommandPrefix_IONiceLevel) {
    /**
   * @generated from enum value: IO_DEFAULT = 0;
   */ CommandPrefix_IONiceLevel[CommandPrefix_IONiceLevel["IO_DEFAULT"] = 0] = "IO_DEFAULT";
    /**
   * @generated from enum value: IO_BEST_EFFORT_LOW = 1;
   */ CommandPrefix_IONiceLevel[CommandPrefix_IONiceLevel["IO_BEST_EFFORT_LOW"] = 1] = "IO_BEST_EFFORT_LOW";
    /**
   * @generated from enum value: IO_BEST_EFFORT_HIGH = 2;
   */ CommandPrefix_IONiceLevel[CommandPrefix_IONiceLevel["IO_BEST_EFFORT_HIGH"] = 2] = "IO_BEST_EFFORT_HIGH";
    /**
   * @generated from enum value: IO_IDLE = 3;
   */ CommandPrefix_IONiceLevel[CommandPrefix_IONiceLevel["IO_IDLE"] = 3] = "IO_IDLE";
    return CommandPrefix_IONiceLevel;
}({});
const $5627a58e424cdfa3$export$678ced0361a4102b = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 5, 0);
var $5627a58e424cdfa3$export$5134cf17b7f2623d = /*#__PURE__*/ function(CommandPrefix_CPUNiceLevel) {
    /**
   * @generated from enum value: CPU_DEFAULT = 0;
   */ CommandPrefix_CPUNiceLevel[CommandPrefix_CPUNiceLevel["CPU_DEFAULT"] = 0] = "CPU_DEFAULT";
    /**
   * @generated from enum value: CPU_HIGH = 1;
   */ CommandPrefix_CPUNiceLevel[CommandPrefix_CPUNiceLevel["CPU_HIGH"] = 1] = "CPU_HIGH";
    /**
   * @generated from enum value: CPU_LOW = 2;
   */ CommandPrefix_CPUNiceLevel[CommandPrefix_CPUNiceLevel["CPU_LOW"] = 2] = "CPU_LOW";
    return CommandPrefix_CPUNiceLevel;
}({});
const $5627a58e424cdfa3$export$2e9357326a6787db = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 5, 1);
const $5627a58e424cdfa3$export$178386e1d831154b = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 6);
const $5627a58e424cdfa3$export$1a3d09a99d37ebbe = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 6, 0);
const $5627a58e424cdfa3$export$d6d5c03a25f2f207 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 7);
const $5627a58e424cdfa3$export$54b9d53dc272b8c3 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 8);
const $5627a58e424cdfa3$export$b6f835218a946d20 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 9);
var $5627a58e424cdfa3$export$7a107beb3a32a89 = /*#__PURE__*/ function(Schedule_Clock) {
    /**
   * same as CLOCK_LOCAL
   *
   * @generated from enum value: CLOCK_DEFAULT = 0;
   */ Schedule_Clock[Schedule_Clock["DEFAULT"] = 0] = "DEFAULT";
    /**
   * @generated from enum value: CLOCK_LOCAL = 1;
   */ Schedule_Clock[Schedule_Clock["LOCAL"] = 1] = "LOCAL";
    /**
   * @generated from enum value: CLOCK_UTC = 2;
   */ Schedule_Clock[Schedule_Clock["UTC"] = 2] = "UTC";
    /**
   * @generated from enum value: CLOCK_LAST_RUN_TIME = 3;
   */ Schedule_Clock[Schedule_Clock["LAST_RUN_TIME"] = 3] = "LAST_RUN_TIME";
    return Schedule_Clock;
}({});
const $5627a58e424cdfa3$export$e23e55eb749998cb = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 9, 0);
const $5627a58e424cdfa3$export$377c3480060cfdb3 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10);
const $5627a58e424cdfa3$export$889f3176fcfdbfd3 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 0);
const $5627a58e424cdfa3$export$9a396738c3d23b55 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 1);
var $5627a58e424cdfa3$export$2f42861e4deba1ef = /*#__PURE__*/ function(Hook_Webhook_Method) {
    /**
   * @generated from enum value: UNKNOWN = 0;
   */ Hook_Webhook_Method[Hook_Webhook_Method["UNKNOWN"] = 0] = "UNKNOWN";
    /**
   * @generated from enum value: GET = 1;
   */ Hook_Webhook_Method[Hook_Webhook_Method["GET"] = 1] = "GET";
    /**
   * @generated from enum value: POST = 2;
   */ Hook_Webhook_Method[Hook_Webhook_Method["POST"] = 2] = "POST";
    return Hook_Webhook_Method;
}({});
const $5627a58e424cdfa3$export$9483a2afea03df3e = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 1, 0);
const $5627a58e424cdfa3$export$9f370fb47c078dc6 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 2);
const $5627a58e424cdfa3$export$4c21f17d2b769f49 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 3);
const $5627a58e424cdfa3$export$a638ec492fa969eb = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 4);
const $5627a58e424cdfa3$export$8b9671785cc472fa = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 5);
const $5627a58e424cdfa3$export$fd821c9fa6354ba9 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 6);
var $5627a58e424cdfa3$export$a5a473d698d554c5 = /*#__PURE__*/ function(Hook_Condition) {
    /**
   * @generated from enum value: CONDITION_UNKNOWN = 0;
   */ Hook_Condition[Hook_Condition["UNKNOWN"] = 0] = "UNKNOWN";
    /**
   * error running any operation.
   *
   * @generated from enum value: CONDITION_ANY_ERROR = 1;
   */ Hook_Condition[Hook_Condition["ANY_ERROR"] = 1] = "ANY_ERROR";
    /**
   * backup started.
   *
   * @generated from enum value: CONDITION_SNAPSHOT_START = 2;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_START"] = 2] = "SNAPSHOT_START";
    /**
   * backup completed (success or fail).
   *
   * @generated from enum value: CONDITION_SNAPSHOT_END = 3;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_END"] = 3] = "SNAPSHOT_END";
    /**
   * snapshot failed.
   *
   * @generated from enum value: CONDITION_SNAPSHOT_ERROR = 4;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_ERROR"] = 4] = "SNAPSHOT_ERROR";
    /**
   * snapshot completed with warnings.
   *
   * @generated from enum value: CONDITION_SNAPSHOT_WARNING = 5;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_WARNING"] = 5] = "SNAPSHOT_WARNING";
    /**
   * snapshot succeeded.
   *
   * @generated from enum value: CONDITION_SNAPSHOT_SUCCESS = 6;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_SUCCESS"] = 6] = "SNAPSHOT_SUCCESS";
    /**
   * snapshot was skipped e.g. due to no changes.
   *
   * @generated from enum value: CONDITION_SNAPSHOT_SKIPPED = 7;
   */ Hook_Condition[Hook_Condition["SNAPSHOT_SKIPPED"] = 7] = "SNAPSHOT_SKIPPED";
    /**
   * prune conditions
   *
   * prune started.
   *
   * @generated from enum value: CONDITION_PRUNE_START = 100;
   */ Hook_Condition[Hook_Condition["PRUNE_START"] = 100] = "PRUNE_START";
    /**
   * prune failed.
   *
   * @generated from enum value: CONDITION_PRUNE_ERROR = 101;
   */ Hook_Condition[Hook_Condition["PRUNE_ERROR"] = 101] = "PRUNE_ERROR";
    /**
   * prune succeeded.
   *
   * @generated from enum value: CONDITION_PRUNE_SUCCESS = 102;
   */ Hook_Condition[Hook_Condition["PRUNE_SUCCESS"] = 102] = "PRUNE_SUCCESS";
    /**
   * check conditions
   *
   * check started.
   *
   * @generated from enum value: CONDITION_CHECK_START = 200;
   */ Hook_Condition[Hook_Condition["CHECK_START"] = 200] = "CHECK_START";
    /**
   * check failed.
   *
   * @generated from enum value: CONDITION_CHECK_ERROR = 201;
   */ Hook_Condition[Hook_Condition["CHECK_ERROR"] = 201] = "CHECK_ERROR";
    /**
   * check succeeded.
   *
   * @generated from enum value: CONDITION_CHECK_SUCCESS = 202;
   */ Hook_Condition[Hook_Condition["CHECK_SUCCESS"] = 202] = "CHECK_SUCCESS";
    /**
   * forget conditions
   *
   * forget started.
   *
   * @generated from enum value: CONDITION_FORGET_START = 300;
   */ Hook_Condition[Hook_Condition["FORGET_START"] = 300] = "FORGET_START";
    /**
   * forget failed.
   *
   * @generated from enum value: CONDITION_FORGET_ERROR = 301;
   */ Hook_Condition[Hook_Condition["FORGET_ERROR"] = 301] = "FORGET_ERROR";
    /**
   * forget succeeded.
   *
   * @generated from enum value: CONDITION_FORGET_SUCCESS = 302;
   */ Hook_Condition[Hook_Condition["FORGET_SUCCESS"] = 302] = "FORGET_SUCCESS";
    return Hook_Condition;
}({});
const $5627a58e424cdfa3$export$830f278e1bb6fbd0 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 0);
var $5627a58e424cdfa3$export$c9efc5bf6fe51929 = /*#__PURE__*/ function(Hook_OnError) {
    /**
   * @generated from enum value: ON_ERROR_IGNORE = 0;
   */ Hook_OnError[Hook_OnError["IGNORE"] = 0] = "IGNORE";
    /**
   * cancels the operation and skips subsequent hooks
   *
   * @generated from enum value: ON_ERROR_CANCEL = 1;
   */ Hook_OnError[Hook_OnError["CANCEL"] = 1] = "CANCEL";
    /**
   * fails the operation and subsequent hooks.
   *
   * @generated from enum value: ON_ERROR_FATAL = 2;
   */ Hook_OnError[Hook_OnError["FATAL"] = 2] = "FATAL";
    /**
   * retry the operation every minute 
   *
   * @generated from enum value: ON_ERROR_RETRY_1MINUTE = 100;
   */ Hook_OnError[Hook_OnError["RETRY_1MINUTE"] = 100] = "RETRY_1MINUTE";
    /**
   * retry the operation every 10 minutes
   *
   * @generated from enum value: ON_ERROR_RETRY_10MINUTES = 101;
   */ Hook_OnError[Hook_OnError["RETRY_10MINUTES"] = 101] = "RETRY_10MINUTES";
    /**
   * retry the operation with exponential backoff up to 1h max.
   *
   * @generated from enum value: ON_ERROR_RETRY_EXPONENTIAL_BACKOFF = 103;
   */ Hook_OnError[Hook_OnError["RETRY_EXPONENTIAL_BACKOFF"] = 103] = "RETRY_EXPONENTIAL_BACKOFF";
    return Hook_OnError;
}({});
const $5627a58e424cdfa3$export$9df71ba9a3384b86 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 10, 1);
const $5627a58e424cdfa3$export$b63c30c0b05b5d17 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 11);
const $5627a58e424cdfa3$export$50459aae8e896057 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5627a58e424cdfa3$export$5d787e7bcbb50094, 12);

});
parcelRegister("l6s0m", function(module, exports) {

$parcel$export(module.exports, "file_google_protobuf_empty", () => $f5cfe1ada56c87f5$export$5e4ffd160812943b);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $9CnIh = parcelRequire("9CnIh");

var $8ImrE = parcelRequire("8ImrE");
const $f5cfe1ada56c87f5$export$5e4ffd160812943b = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Chtnb29nbGUvcHJvdG9idWYvZW1wdHkucHJvdG8SD2dvb2dsZS5wcm90b2J1ZiIHCgVFbXB0eUJ9ChNjb20uZ29vZ2xlLnByb3RvYnVmQgpFbXB0eVByb3RvUAFaLmdvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL2VtcHR5cGL4AQGiAgNHUEKqAh5Hb29nbGUuUHJvdG9idWYuV2VsbEtub3duVHlwZXNiBnByb3RvMw");
const $f5cfe1ada56c87f5$export$6c687b567a6bd2ff = /*@__PURE__*/ (0, $8ImrE.messageDesc)($f5cfe1ada56c87f5$export$5e4ffd160812943b, 0);

});

parcelRegister("9kWNX", function(module, exports) {

$parcel$export(module.exports, "file_v1_crypto", () => $bdebf562229ada2e$export$6d4f1e5b02269820);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/crypto.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
const $bdebf562229ada2e$export$6d4f1e5b02269820 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Cg92MS9jcnlwdG8ucHJvdG8SAnYxIlsKDVNpZ25lZE1lc3NhZ2USDQoFa2V5aWQYASABKAkSDwoHcGF5bG9hZBgCIAEoDBIRCglzaWduYXR1cmUYAyABKAwSFwoPdGltZXN0YW1wTWlsbGlzGAQgASgDIjUKCVB1YmxpY0tleRIUCgVrZXlpZBgBIAEoCVIFa2V5SWQSEgoKZWQyNTUxOXB1YhgCIAEoCSJLCgpQcml2YXRlS2V5EhQKBWtleWlkGAEgASgJUgVrZXlJZBITCgtlZDI1NTE5cHJpdhgCIAEoCRISCgplZDI1NTE5cHViGAMgASgJQixaKmdpdGh1Yi5jb20vZ2FyZXRoZ2VvcmdlL2JhY2tyZXN0L2dlbi9nby92MWIGcHJvdG8z");
const $bdebf562229ada2e$export$3632e769a005631d = /*@__PURE__*/ (0, $jHEye.messageDesc)($bdebf562229ada2e$export$6d4f1e5b02269820, 0);
const $bdebf562229ada2e$export$f67aa1d72abd39d7 = /*@__PURE__*/ (0, $jHEye.messageDesc)($bdebf562229ada2e$export$6d4f1e5b02269820, 1);
const $bdebf562229ada2e$export$7426bbc71d4b7058 = /*@__PURE__*/ (0, $jHEye.messageDesc)($bdebf562229ada2e$export$6d4f1e5b02269820, 2);

});


parcelRegister("8ffPJ", function(module, exports) {

$parcel$export(module.exports, "file_types_value", () => $e8699567292aa78c$export$cb012f3c869224a9);
$parcel$export(module.exports, "StringValueSchema", () => $e8699567292aa78c$export$8adda2de9a1d810b);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file types/value.proto (package types, syntax proto3)
/* eslint-disable */ 
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
const $e8699567292aa78c$export$cb012f3c869224a9 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("ChF0eXBlcy92YWx1ZS5wcm90bxIFdHlwZXMiGgoJQm9vbFZhbHVlEg0KBXZhbHVlGAEgASgIIhwKC1N0cmluZ1ZhbHVlEg0KBXZhbHVlGAEgASgJIhsKCkJ5dGVzVmFsdWUSDQoFdmFsdWUYASABKAwiHAoKU3RyaW5nTGlzdBIOCgZ2YWx1ZXMYASADKAkiGwoKSW50NjRWYWx1ZRINCgV2YWx1ZRgBIAEoAyIbCglJbnQ2NExpc3QSDgoGdmFsdWVzGAEgAygDIgcKBUVtcHR5Qi9aLWdpdGh1Yi5jb20vZ2FyZXRoZ2VvcmdlL2JhY2tyZXN0L2dlbi9nby90eXBlc2IGcHJvdG8z");
const $e8699567292aa78c$export$92a6827dcf73fd70 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 0);
const $e8699567292aa78c$export$8adda2de9a1d810b = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 1);
const $e8699567292aa78c$export$9018e3e8e9429b71 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 2);
const $e8699567292aa78c$export$339165b96b289e07 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 3);
const $e8699567292aa78c$export$b34d4b2af7ea435c = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 4);
const $e8699567292aa78c$export$1ab3efd327aa053 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 5);
const $e8699567292aa78c$export$6c687b567a6bd2ff = /*@__PURE__*/ (0, $jHEye.messageDesc)($e8699567292aa78c$export$cb012f3c869224a9, 6);

});


parcelRegister("1Yxub", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", () => $b6a0b7007b404cc4$export$3c4602e16d9ace38);
$parcel$export(module.exports, "authenticationService", () => $b6a0b7007b404cc4$export$38e7ffee86a65864);
$parcel$export(module.exports, "backrestService", () => $b6a0b7007b404cc4$export$95603a0dc02cbbeb);
$parcel$export(module.exports, "syncStateService", () => $b6a0b7007b404cc4$export$59b4f6b4668404c8);

var $ccPOw = parcelRequire("ccPOw");

var $irvbz = parcelRequire("irvbz");

var $h3scz = parcelRequire("h3scz");

var $cT7kT = parcelRequire("cT7kT");

var $kndvn = parcelRequire("kndvn");

var $3xSyo = parcelRequire("3xSyo");
const $b6a0b7007b404cc4$var$tokenKey = "backrest-ui-authToken";
const $b6a0b7007b404cc4$export$3c4602e16d9ace38 = (token)=>{
    localStorage.setItem($b6a0b7007b404cc4$var$tokenKey, token);
};
const $b6a0b7007b404cc4$var$fetch = (input, init)=>{
    const headers = new Headers(init?.headers);
    let token = localStorage.getItem($b6a0b7007b404cc4$var$tokenKey);
    if (token && token !== "") headers.set("Authorization", "Bearer " + token);
    init = {
        ...init,
        headers: headers
    };
    return window.fetch(input, init);
};
const $b6a0b7007b404cc4$var$transport = (0, $ccPOw.createConnectTransport)({
    baseUrl: (0, $3xSyo.backendUrl),
    useBinaryFormat: true,
    fetch: $b6a0b7007b404cc4$var$fetch
});
const $b6a0b7007b404cc4$export$38e7ffee86a65864 = (0, $irvbz.createClient)((0, $h3scz.Authentication), $b6a0b7007b404cc4$var$transport);
const $b6a0b7007b404cc4$export$95603a0dc02cbbeb = (0, $irvbz.createClient)((0, $cT7kT.Backrest), $b6a0b7007b404cc4$var$transport);
const $b6a0b7007b404cc4$export$59b4f6b4668404c8 = (0, $irvbz.createClient)((0, $kndvn.BackrestSyncStateService), $b6a0b7007b404cc4$var$transport);

});
parcelRegister("ccPOw", function(module, exports) {

$parcel$export(module.exports, "createConnectTransport", () => $8e2ecc2b5575cc23$export$72bad5ad7e4cd3bf);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3XMHQ = parcelRequire("3XMHQ");

var $7BsIG = parcelRequire("7BsIG");
var $lBjkW = parcelRequire("lBjkW");
var $4tXo7 = parcelRequire("4tXo7");
var $gPrvR = parcelRequire("gPrvR");

var $cQTV6 = parcelRequire("cQTV6");
var $gKdXS = parcelRequire("gKdXS");
var $1DjLH = parcelRequire("1DjLH");
var $ffts0 = parcelRequire("ffts0");
var $hUotL = parcelRequire("hUotL");

var $5L9d9 = parcelRequire("5L9d9");
var $bcquV = parcelRequire("bcquV");
var $izpVM = parcelRequire("izpVM");
var $77HR1 = parcelRequire("77HR1");
var $dv2Oz = parcelRequire("dv2Oz");
var $667KG = parcelRequire("667KG");

var $DwjgK = parcelRequire("DwjgK");

var $dKpyK = parcelRequire("dKpyK");
var $8e2ecc2b5575cc23$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $8e2ecc2b5575cc23$var$__await ? (this.v = v, this) : new $8e2ecc2b5575cc23$var$__await(v);
};
var $8e2ecc2b5575cc23$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2ecc2b5575cc23$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
const $8e2ecc2b5575cc23$var$fetchOptions = {
    redirect: "error"
};
function $8e2ecc2b5575cc23$export$72bad5ad7e4cd3bf(options) {
    var _a;
    (0, $DwjgK.assertFetchApi)();
    const useBinaryFormat = (_a = options.useBinaryFormat) !== null && _a !== void 0 ? _a : false;
    return {
        async unary (method, signal, timeoutMs, header, message, contextValues) {
            const { serialize: serialize, parse: parse } = (0, $gKdXS.createClientMethodSerializers)(method, useBinaryFormat, options.jsonOptions, options.binaryOptions);
            timeoutMs = timeoutMs === undefined ? options.defaultTimeoutMs : timeoutMs <= 0 ? undefined : timeoutMs;
            return await (0, $hUotL.runUnaryCall)({
                interceptors: options.interceptors,
                signal: signal,
                timeoutMs: timeoutMs,
                req: {
                    stream: false,
                    service: method.parent,
                    method: method,
                    requestMethod: "POST",
                    url: (0, $ffts0.createMethodUrl)(options.baseUrl, method),
                    header: (0, $izpVM.requestHeader)(method.methodKind, useBinaryFormat, timeoutMs, header, false),
                    contextValues: contextValues !== null && contextValues !== void 0 ? contextValues : (0, $gPrvR.createContextValues)(),
                    message: message
                },
                next: async (req)=>{
                    var _a;
                    const useGet = options.useHttpGet === true && method.idempotency === (0, $dKpyK.MethodOptions_IdempotencyLevel).NO_SIDE_EFFECTS;
                    let body = null;
                    if (useGet) req = (0, $dv2Oz.transformConnectPostToGetRequest)(req, serialize(req.message), useBinaryFormat);
                    else body = serialize(req.message);
                    const fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : globalThis.fetch;
                    const response = await fetch(req.url, Object.assign(Object.assign({}, $8e2ecc2b5575cc23$var$fetchOptions), {
                        method: req.requestMethod,
                        headers: req.header,
                        signal: req.signal,
                        body: body
                    }));
                    const { isUnaryError: isUnaryError, unaryError: unaryError } = (0, $667KG.validateResponse)(method.methodKind, useBinaryFormat, response.status, response.headers);
                    if (isUnaryError) throw (0, $bcquV.errorFromJson)(await response.json(), (0, $7BsIG.appendHeaders)(...(0, $77HR1.trailerDemux)(response.headers)), unaryError);
                    const [demuxedHeader, demuxedTrailer] = (0, $77HR1.trailerDemux)(response.headers);
                    return {
                        stream: false,
                        service: method.parent,
                        method: method,
                        header: demuxedHeader,
                        message: useBinaryFormat ? parse(new Uint8Array(await response.arrayBuffer())) : (0, $3XMHQ.fromJson)(method.output, await response.json(), (0, $gKdXS.getJsonOptions)(options.jsonOptions)),
                        trailer: demuxedTrailer
                    };
                }
            });
        },
        async stream (method, signal, timeoutMs, header, input, contextValues) {
            const { serialize: serialize, parse: parse } = (0, $gKdXS.createClientMethodSerializers)(method, useBinaryFormat, options.jsonOptions, options.binaryOptions);
            function parseResponseBody(body, trailerTarget, header, signal) {
                return $8e2ecc2b5575cc23$var$__asyncGenerator(this, arguments, function* parseResponseBody_1() {
                    const reader = (0, $1DjLH.createEnvelopeReadableStream)(body).getReader();
                    let endStreamReceived = false;
                    for(;;){
                        const result = yield $8e2ecc2b5575cc23$var$__await(reader.read());
                        if (result.done) break;
                        const { flags: flags, data: data } = result.value;
                        if ((flags & (0, $cQTV6.compressedFlag)) === (0, $cQTV6.compressedFlag)) throw new (0, $4tXo7.ConnectError)(`protocol error: received unsupported compressed output`, (0, $lBjkW.Code).Internal);
                        if ((flags & (0, $5L9d9.endStreamFlag)) === (0, $5L9d9.endStreamFlag)) {
                            endStreamReceived = true;
                            const endStream = (0, $5L9d9.endStreamFromJson)(data);
                            if (endStream.error) {
                                const error = endStream.error;
                                header.forEach((value, key)=>{
                                    error.metadata.append(key, value);
                                });
                                throw error;
                            }
                            endStream.metadata.forEach((value, key)=>trailerTarget.set(key, value));
                            continue;
                        }
                        yield yield $8e2ecc2b5575cc23$var$__await(parse(data));
                    }
                    // Node wil not throw an AbortError on `read` if the
                    // signal is aborted before `getReader` is called.
                    // As a work around we check at the end and throw.
                    //
                    // Ref: https://github.com/nodejs/undici/issues/1940
                    if ("throwIfAborted" in signal) // We assume that implementations without `throwIfAborted` (old
                    // browsers) do honor aborted signals on `read`.
                    signal.throwIfAborted();
                    if (!endStreamReceived) throw "missing EndStreamResponse";
                });
            }
            async function createRequestBody(input) {
                if (method.methodKind != "server_streaming") throw "The fetch API does not support streaming request bodies";
                const r = await input[Symbol.asyncIterator]().next();
                if (r.done == true) throw "missing request message";
                return (0, $1DjLH.encodeEnvelope)(0, serialize(r.value));
            }
            timeoutMs = timeoutMs === undefined ? options.defaultTimeoutMs : timeoutMs <= 0 ? undefined : timeoutMs;
            return await (0, $hUotL.runStreamingCall)({
                interceptors: options.interceptors,
                timeoutMs: timeoutMs,
                signal: signal,
                req: {
                    stream: true,
                    service: method.parent,
                    method: method,
                    requestMethod: "POST",
                    url: (0, $ffts0.createMethodUrl)(options.baseUrl, method),
                    header: (0, $izpVM.requestHeader)(method.methodKind, useBinaryFormat, timeoutMs, header, false),
                    contextValues: contextValues !== null && contextValues !== void 0 ? contextValues : (0, $gPrvR.createContextValues)(),
                    message: input
                },
                next: async (req)=>{
                    var _a;
                    const fetch = (_a = options.fetch) !== null && _a !== void 0 ? _a : globalThis.fetch;
                    const fRes = await fetch(req.url, Object.assign(Object.assign({}, $8e2ecc2b5575cc23$var$fetchOptions), {
                        method: req.requestMethod,
                        headers: req.header,
                        signal: req.signal,
                        body: await createRequestBody(req.message)
                    }));
                    (0, $667KG.validateResponse)(method.methodKind, useBinaryFormat, fRes.status, fRes.headers);
                    if (fRes.body === null) throw "missing response body";
                    const trailer = new Headers();
                    const res = Object.assign(Object.assign({}, req), {
                        header: fRes.headers,
                        trailer: trailer,
                        message: parseResponseBody(fRes.body, trailer, fRes.headers, req.signal)
                    });
                    return res;
                }
            });
        }
    };
}

});
parcelRegister("3XMHQ", function(module, exports) {

$parcel$export(module.exports, "fromJsonString", () => $2e2ca9d4981fb1c5$export$c528d315c40013a2);
$parcel$export(module.exports, "fromJson", () => $2e2ca9d4981fb1c5$export$7ae2d2a8b28a8cb8);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $6zK55 = parcelRequire("6zK55");

var $1jDsz = parcelRequire("1jDsz");

var $lItxZ = parcelRequire("lItxZ");

var $2J3jP = parcelRequire("2J3jP");

var $g7x8s = parcelRequire("g7x8s");

var $lipan = parcelRequire("lipan");

var $3xX2e = parcelRequire("3xX2e");

var $kq7Xn = parcelRequire("kq7Xn");
var $AYHoV = parcelRequire("AYHoV");
var $jrWrJ = parcelRequire("jrWrJ");

var $1jtuq = parcelRequire("1jtuq");
// Default options for parsing JSON.
const $2e2ca9d4981fb1c5$var$jsonReadDefaults = {
    ignoreUnknownFields: false
};
function $2e2ca9d4981fb1c5$var$makeReadOptions(options) {
    return options ? Object.assign(Object.assign({}, $2e2ca9d4981fb1c5$var$jsonReadDefaults), options) : $2e2ca9d4981fb1c5$var$jsonReadDefaults;
}
function $2e2ca9d4981fb1c5$export$c528d315c40013a2(schema, json, options) {
    return $2e2ca9d4981fb1c5$export$7ae2d2a8b28a8cb8(schema, $2e2ca9d4981fb1c5$var$parseJsonString(json, schema.typeName), options);
}
function $2e2ca9d4981fb1c5$export$7c44f20629ceb451(schema, target, json, options) {
    return $2e2ca9d4981fb1c5$export$511e992156a9cd92(schema, target, $2e2ca9d4981fb1c5$var$parseJsonString(json, schema.typeName), options);
}
function $2e2ca9d4981fb1c5$export$7ae2d2a8b28a8cb8(schema, json, options) {
    const msg = (0, $lItxZ.reflect)(schema);
    try {
        $2e2ca9d4981fb1c5$var$readMessage(msg, json, $2e2ca9d4981fb1c5$var$makeReadOptions(options));
    } catch (e) {
        if ((0, $2J3jP.isFieldError)(e)) // @ts-expect-error we use the ES2022 error CTOR option "cause" for better stack traces
        throw new Error(`cannot decode ${e.field()} from JSON: ${e.message}`, {
            cause: e
        });
        throw e;
    }
    return msg.message;
}
function $2e2ca9d4981fb1c5$export$511e992156a9cd92(schema, target, json, options) {
    try {
        $2e2ca9d4981fb1c5$var$readMessage((0, $lItxZ.reflect)(schema, target), json, $2e2ca9d4981fb1c5$var$makeReadOptions(options));
    } catch (e) {
        if ((0, $2J3jP.isFieldError)(e)) // @ts-expect-error we use the ES2022 error CTOR option "cause" for better stack traces
        throw new Error(`cannot decode ${e.field()} from JSON: ${e.message}`, {
            cause: e
        });
        throw e;
    }
    return target;
}
function $2e2ca9d4981fb1c5$export$b4d67592ae2834e0(descEnum, json) {
    const val = $2e2ca9d4981fb1c5$var$readEnum(descEnum, json, false, false);
    if (val === $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum) throw new Error(`cannot decode ${descEnum} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    return val;
}
function $2e2ca9d4981fb1c5$export$f7c8ea5d8c90801e(descEnum, value) {
    return undefined !== descEnum.values.find((v)=>v.name === value);
}
function $2e2ca9d4981fb1c5$var$readMessage(msg, json, opts) {
    var _a;
    if ($2e2ca9d4981fb1c5$var$tryWktFromJson(msg, json, opts)) return;
    if (json == null || Array.isArray(json) || typeof json != "object") throw new Error(`cannot decode ${msg.desc} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    const oneofSeen = new Map();
    const jsonNames = new Map();
    for (const field of msg.desc.fields)jsonNames.set(field.name, field).set(field.jsonName, field);
    for (const [jsonKey, jsonValue] of Object.entries(json)){
        const field = jsonNames.get(jsonKey);
        if (field) {
            if (field.oneof) {
                if (jsonValue === null && field.fieldKind == "scalar") continue;
                const seen = oneofSeen.get(field.oneof);
                if (seen !== undefined) throw new (0, $2J3jP.FieldError)(field.oneof, `oneof set multiple times by ${seen.name} and ${field.name}`);
                oneofSeen.set(field.oneof, field);
            }
            $2e2ca9d4981fb1c5$var$readField(msg, field, jsonValue, opts);
        } else {
            let extension = undefined;
            if (jsonKey.startsWith("[") && jsonKey.endsWith("]") && // biome-ignore lint/suspicious/noAssignInExpressions: no
            (extension = (_a = opts.registry) === null || _a === void 0 ? void 0 : _a.getExtension(jsonKey.substring(1, jsonKey.length - 1))) && extension.extendee.typeName === msg.desc.typeName) {
                const [container, field, get] = (0, $1jtuq.createExtensionContainer)(extension);
                $2e2ca9d4981fb1c5$var$readField(container, field, jsonValue, opts);
                (0, $1jtuq.setExtension)(msg.message, extension, get());
            }
            if (!extension && !opts.ignoreUnknownFields) throw new Error(`cannot decode ${msg.desc} from JSON: key "${jsonKey}" is unknown`);
        }
    }
}
function $2e2ca9d4981fb1c5$var$readField(msg, field, json, opts) {
    switch(field.fieldKind){
        case "scalar":
            $2e2ca9d4981fb1c5$var$readScalarField(msg, field, json);
            break;
        case "enum":
            $2e2ca9d4981fb1c5$var$readEnumField(msg, field, json, opts);
            break;
        case "message":
            $2e2ca9d4981fb1c5$var$readMessageField(msg, field, json, opts);
            break;
        case "list":
            $2e2ca9d4981fb1c5$var$readListField(msg.get(field), json, opts);
            break;
        case "map":
            $2e2ca9d4981fb1c5$var$readMapField(msg.get(field), json, opts);
            break;
    }
}
function $2e2ca9d4981fb1c5$var$readMapField(map, json, opts) {
    if (json === null) return;
    const field = map.field();
    if (typeof json != "object" || Array.isArray(json)) throw new (0, $2J3jP.FieldError)(field, "expected object, got " + (0, $g7x8s.formatVal)(json));
    for (const [jsonMapKey, jsonMapValue] of Object.entries(json)){
        if (jsonMapValue === null) throw new (0, $2J3jP.FieldError)(field, "map value must not be null");
        let value;
        switch(field.mapKind){
            case "message":
                const msgValue = (0, $lItxZ.reflect)(field.message);
                $2e2ca9d4981fb1c5$var$readMessage(msgValue, jsonMapValue, opts);
                value = msgValue;
                break;
            case "enum":
                value = $2e2ca9d4981fb1c5$var$readEnum(field.enum, jsonMapValue, opts.ignoreUnknownFields, true);
                if (value === $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum) return;
                break;
            case "scalar":
                value = $2e2ca9d4981fb1c5$var$scalarFromJson(field, jsonMapValue, true);
                break;
        }
        const key = $2e2ca9d4981fb1c5$var$mapKeyFromJson(field.mapKey, jsonMapKey);
        map.set(key, value);
    }
}
function $2e2ca9d4981fb1c5$var$readListField(list, json, opts) {
    if (json === null) return;
    const field = list.field();
    if (!Array.isArray(json)) throw new (0, $2J3jP.FieldError)(field, "expected Array, got " + (0, $g7x8s.formatVal)(json));
    for (const jsonItem of json){
        if (jsonItem === null) throw new (0, $2J3jP.FieldError)(field, "list item must not be null");
        switch(field.listKind){
            case "message":
                const msgValue = (0, $lItxZ.reflect)(field.message);
                $2e2ca9d4981fb1c5$var$readMessage(msgValue, jsonItem, opts);
                list.add(msgValue);
                break;
            case "enum":
                const enumValue = $2e2ca9d4981fb1c5$var$readEnum(field.enum, jsonItem, opts.ignoreUnknownFields, true);
                if (enumValue !== $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum) list.add(enumValue);
                break;
            case "scalar":
                list.add($2e2ca9d4981fb1c5$var$scalarFromJson(field, jsonItem, true));
                break;
        }
    }
}
function $2e2ca9d4981fb1c5$var$readMessageField(msg, field, json, opts) {
    if (json === null && field.message.typeName != "google.protobuf.Value") {
        msg.clear(field);
        return;
    }
    const msgValue = msg.isSet(field) ? msg.get(field) : (0, $lItxZ.reflect)(field.message);
    $2e2ca9d4981fb1c5$var$readMessage(msgValue, json, opts);
    msg.set(field, msgValue);
}
function $2e2ca9d4981fb1c5$var$readEnumField(msg, field, json, opts) {
    const enumValue = $2e2ca9d4981fb1c5$var$readEnum(field.enum, json, opts.ignoreUnknownFields, false);
    if (enumValue === $2e2ca9d4981fb1c5$var$tokenNull) msg.clear(field);
    else if (enumValue !== $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum) msg.set(field, enumValue);
}
function $2e2ca9d4981fb1c5$var$readScalarField(msg, field, json) {
    const scalarValue = $2e2ca9d4981fb1c5$var$scalarFromJson(field, json, false);
    if (scalarValue === $2e2ca9d4981fb1c5$var$tokenNull) msg.clear(field);
    else msg.set(field, scalarValue);
}
const $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum = Symbol();
function $2e2ca9d4981fb1c5$var$readEnum(desc, json, ignoreUnknownFields, nullAsZeroValue) {
    if (json === null) {
        if (desc.typeName == "google.protobuf.NullValue") return 0; // google.protobuf.NullValue.NULL_VALUE = 0
        return nullAsZeroValue ? desc.values[0].number : $2e2ca9d4981fb1c5$var$tokenNull;
    }
    switch(typeof json){
        case "number":
            if (Number.isInteger(json)) return json;
            break;
        case "string":
            const value = desc.values.find((ev)=>ev.name === json);
            if (value !== undefined) return value.number;
            if (ignoreUnknownFields) return $2e2ca9d4981fb1c5$var$tokenIgnoredUnknownEnum;
            break;
    }
    throw new Error(`cannot decode ${desc} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
}
const $2e2ca9d4981fb1c5$var$tokenNull = Symbol();
function $2e2ca9d4981fb1c5$var$scalarFromJson(field, json, nullAsZeroValue) {
    if (json === null) {
        if (nullAsZeroValue) return (0, $lipan.scalarZeroValue)(field.scalar, false);
        return $2e2ca9d4981fb1c5$var$tokenNull;
    }
    // int64, sfixed64, sint64, fixed64, uint64: Reflect supports string and number.
    // string, bool: Supported by reflect.
    switch(field.scalar){
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case (0, $8xxTQ.ScalarType).DOUBLE:
        case (0, $8xxTQ.ScalarType).FLOAT:
            if (json === "NaN") return NaN;
            if (json === "Infinity") return Number.POSITIVE_INFINITY;
            if (json === "-Infinity") return Number.NEGATIVE_INFINITY;
            if (typeof json == "number") {
                if (Number.isNaN(json)) // NaN must be encoded with string constants
                throw new (0, $2J3jP.FieldError)(field, "unexpected NaN number");
                if (!Number.isFinite(json)) // Infinity must be encoded with string constants
                throw new (0, $2J3jP.FieldError)(field, "unexpected infinite number");
                break;
            }
            if (typeof json == "string") {
                if (json === "") break;
                if (json.trim().length !== json.length) break;
                const float = Number(json);
                if (!Number.isFinite(float)) break;
                return float;
            }
            break;
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
        case (0, $8xxTQ.ScalarType).UINT32:
            return $2e2ca9d4981fb1c5$var$int32FromJson(json);
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case (0, $8xxTQ.ScalarType).BYTES:
            if (typeof json == "string") {
                if (json === "") return new Uint8Array(0);
                try {
                    return (0, $3xX2e.base64Decode)(json);
                } catch (e) {
                    const message = e instanceof Error ? e.message : String(e);
                    throw new (0, $2J3jP.FieldError)(field, message);
                }
            }
            break;
    }
    return json;
}
/**
 * Try to parse a JSON value to a map key for the reflect API.
 *
 * Returns the input if the JSON value cannot be converted.
 */ function $2e2ca9d4981fb1c5$var$mapKeyFromJson(type, json) {
    switch(type){
        case (0, $8xxTQ.ScalarType).BOOL:
            switch(json){
                case "true":
                    return true;
                case "false":
                    return false;
            }
            return json;
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).UINT32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
            return $2e2ca9d4981fb1c5$var$int32FromJson(json);
        default:
            return json;
    }
}
/**
 * Try to parse a JSON value to a 32-bit integer for the reflect API.
 *
 * Returns the input if the JSON value cannot be converted.
 */ function $2e2ca9d4981fb1c5$var$int32FromJson(json) {
    if (typeof json == "string") {
        if (json === "") // empty string is not a number
        return json;
        if (json.trim().length !== json.length) // extra whitespace
        return json;
        const num = Number(json);
        if (Number.isNaN(num)) // not a number
        return json;
        return num;
    }
    return json;
}
function $2e2ca9d4981fb1c5$var$parseJsonString(jsonString, typeName) {
    try {
        return JSON.parse(jsonString);
    } catch (e) {
        const message = e instanceof Error ? e.message : String(e);
        throw new Error(`cannot decode message ${typeName} from JSON: ${message}`, // @ts-expect-error we use the ES2022 error CTOR option "cause" for better stack traces
        {
            cause: e
        });
    }
}
function $2e2ca9d4981fb1c5$var$tryWktFromJson(msg, jsonValue, opts) {
    if (!msg.desc.typeName.startsWith("google.protobuf.")) return false;
    switch(msg.desc.typeName){
        case "google.protobuf.Any":
            $2e2ca9d4981fb1c5$var$anyFromJson(msg.message, jsonValue, opts);
            return true;
        case "google.protobuf.Timestamp":
            $2e2ca9d4981fb1c5$var$timestampFromJson(msg.message, jsonValue);
            return true;
        case "google.protobuf.Duration":
            $2e2ca9d4981fb1c5$var$durationFromJson(msg.message, jsonValue);
            return true;
        case "google.protobuf.FieldMask":
            $2e2ca9d4981fb1c5$var$fieldMaskFromJson(msg.message, jsonValue);
            return true;
        case "google.protobuf.Struct":
            $2e2ca9d4981fb1c5$var$structFromJson(msg.message, jsonValue);
            return true;
        case "google.protobuf.Value":
            $2e2ca9d4981fb1c5$var$valueFromJson(msg.message, jsonValue);
            return true;
        case "google.protobuf.ListValue":
            $2e2ca9d4981fb1c5$var$listValueFromJson(msg.message, jsonValue);
            return true;
        default:
            if ((0, $AYHoV.isWrapperDesc)(msg.desc)) {
                const valueField = msg.desc.fields[0];
                if (jsonValue === null) msg.clear(valueField);
                else msg.set(valueField, $2e2ca9d4981fb1c5$var$scalarFromJson(valueField, jsonValue, true));
                return true;
            }
            return false;
    }
}
function $2e2ca9d4981fb1c5$var$anyFromJson(any, json, opts) {
    var _a;
    if (json === null || Array.isArray(json) || typeof json != "object") throw new Error(`cannot decode message ${any.$typeName} from JSON: expected object but got ${(0, $g7x8s.formatVal)(json)}`);
    if (Object.keys(json).length == 0) return;
    const typeUrl = json["@type"];
    if (typeof typeUrl != "string" || typeUrl == "") throw new Error(`cannot decode message ${any.$typeName} from JSON: "@type" is empty`);
    const typeName = typeUrl.includes("/") ? typeUrl.substring(typeUrl.lastIndexOf("/") + 1) : typeUrl;
    if (!typeName.length) throw new Error(`cannot decode message ${any.$typeName} from JSON: "@type" is invalid`);
    const desc = (_a = opts.registry) === null || _a === void 0 ? void 0 : _a.getMessage(typeName);
    if (!desc) throw new Error(`cannot decode message ${any.$typeName} from JSON: ${typeUrl} is not in the type registry`);
    const msg = (0, $lItxZ.reflect)(desc);
    if (typeName.startsWith("google.protobuf.") && Object.prototype.hasOwnProperty.call(json, "value")) {
        const value = json.value;
        $2e2ca9d4981fb1c5$var$readMessage(msg, value, opts);
    } else {
        const copy = Object.assign({}, json);
        // biome-ignore lint/performance/noDelete: <explanation>
        delete copy["@type"];
        $2e2ca9d4981fb1c5$var$readMessage(msg, copy, opts);
    }
    (0, $kq7Xn.anyPack)(msg.desc, msg.message, any);
}
function $2e2ca9d4981fb1c5$var$timestampFromJson(timestamp, json) {
    if (typeof json !== "string") throw new Error(`cannot decode message ${timestamp.$typeName} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    const matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:\.([0-9]{1,9}))?(?:Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!matches) throw new Error(`cannot decode message ${timestamp.$typeName} from JSON: invalid RFC 3339 string`);
    const ms = Date.parse(// biome-ignore format: want this to read well
    matches[1] + "-" + matches[2] + "-" + matches[3] + "T" + matches[4] + ":" + matches[5] + ":" + matches[6] + (matches[8] ? matches[8] : "Z"));
    if (Number.isNaN(ms)) throw new Error(`cannot decode message ${timestamp.$typeName} from JSON: invalid RFC 3339 string`);
    if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error(`cannot decode message ${timestamp.$typeName} from JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive`);
    timestamp.seconds = (0, $6zK55.protoInt64).parse(ms / 1000);
    timestamp.nanos = 0;
    if (matches[7]) timestamp.nanos = parseInt("1" + matches[7] + "0".repeat(9 - matches[7].length)) - 1000000000;
}
function $2e2ca9d4981fb1c5$var$durationFromJson(duration, json) {
    if (typeof json !== "string") throw new Error(`cannot decode message ${duration.$typeName} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    const match = json.match(/^(-?[0-9]+)(?:\.([0-9]+))?s/);
    if (match === null) throw new Error(`cannot decode message ${duration.$typeName} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    const longSeconds = Number(match[1]);
    if (longSeconds > 315576000000 || longSeconds < -315576000000) throw new Error(`cannot decode message ${duration.$typeName} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    duration.seconds = (0, $6zK55.protoInt64).parse(longSeconds);
    if (typeof match[2] !== "string") return;
    const nanosStr = match[2] + "0".repeat(9 - match[2].length);
    duration.nanos = parseInt(nanosStr);
    if (longSeconds < 0 || Object.is(longSeconds, -0)) duration.nanos = -duration.nanos;
}
function $2e2ca9d4981fb1c5$var$fieldMaskFromJson(fieldMask, json) {
    if (typeof json !== "string") throw new Error(`cannot decode message ${fieldMask.$typeName} from JSON: ${(0, $g7x8s.formatVal)(json)}`);
    if (json === "") return;
    function camelToSnake(str) {
        if (str.includes("_")) throw new Error(`cannot decode message ${fieldMask.$typeName} from JSON: path names must be lowerCamelCase`);
        const sc = str.replace(/[A-Z]/g, (letter)=>"_" + letter.toLowerCase());
        return sc[0] === "_" ? sc.substring(1) : sc;
    }
    fieldMask.paths = json.split(",").map(camelToSnake);
}
function $2e2ca9d4981fb1c5$var$structFromJson(struct, json) {
    if (typeof json != "object" || json == null || Array.isArray(json)) throw new Error(`cannot decode message ${struct.$typeName} from JSON ${(0, $g7x8s.formatVal)(json)}`);
    for (const [k, v] of Object.entries(json)){
        const parsedV = (0, $1jDsz.create)((0, $jrWrJ.ValueSchema));
        $2e2ca9d4981fb1c5$var$valueFromJson(parsedV, v);
        struct.fields[k] = parsedV;
    }
}
function $2e2ca9d4981fb1c5$var$valueFromJson(value, json) {
    switch(typeof json){
        case "number":
            value.kind = {
                case: "numberValue",
                value: json
            };
            break;
        case "string":
            value.kind = {
                case: "stringValue",
                value: json
            };
            break;
        case "boolean":
            value.kind = {
                case: "boolValue",
                value: json
            };
            break;
        case "object":
            if (json === null) value.kind = {
                case: "nullValue",
                value: (0, $jrWrJ.NullValue).NULL_VALUE
            };
            else if (Array.isArray(json)) {
                const listValue = (0, $1jDsz.create)((0, $jrWrJ.ListValueSchema));
                $2e2ca9d4981fb1c5$var$listValueFromJson(listValue, json);
                value.kind = {
                    case: "listValue",
                    value: listValue
                };
            } else {
                const struct = (0, $1jDsz.create)((0, $jrWrJ.StructSchema));
                $2e2ca9d4981fb1c5$var$structFromJson(struct, json);
                value.kind = {
                    case: "structValue",
                    value: struct
                };
            }
            break;
        default:
            throw new Error(`cannot decode message ${value.$typeName} from JSON ${(0, $g7x8s.formatVal)(json)}`);
    }
    return value;
}
function $2e2ca9d4981fb1c5$var$listValueFromJson(listValue, json) {
    if (!Array.isArray(json)) throw new Error(`cannot decode message ${listValue.$typeName} from JSON ${(0, $g7x8s.formatVal)(json)}`);
    for (const e of json){
        const value = (0, $1jDsz.create)((0, $jrWrJ.ValueSchema));
        $2e2ca9d4981fb1c5$var$valueFromJson(value, e);
        listValue.values.push(value);
    }
}

});
parcelRegister("kq7Xn", function(module, exports) {

$parcel$export(module.exports, "anyPack", () => $03d622b751d27ad7$export$3f0c1bfe9daf31c5);
$parcel$export(module.exports, "anyUnpack", () => $03d622b751d27ad7$export$d3c8ecd0fb72b0);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $eJPbX = parcelRequire("eJPbX");

var $1jDsz = parcelRequire("1jDsz");

var $cQRoD = parcelRequire("cQRoD");

var $6PNZL = parcelRequire("6PNZL");
function $03d622b751d27ad7$export$3f0c1bfe9daf31c5(schema, message, into) {
    let ret = false;
    if (!into) {
        into = (0, $1jDsz.create)((0, $eJPbX.AnySchema));
        ret = true;
    }
    into.value = (0, $cQRoD.toBinary)(schema, message);
    into.typeUrl = $03d622b751d27ad7$var$typeNameToUrl(message.$typeName);
    return ret ? into : undefined;
}
function $03d622b751d27ad7$export$e2910bf9bf14b0c9(any, descOrTypeName) {
    if (any.typeUrl === "") return false;
    const want = typeof descOrTypeName == "string" ? descOrTypeName : descOrTypeName.typeName;
    const got = $03d622b751d27ad7$var$typeUrlToName(any.typeUrl);
    return want === got;
}
function $03d622b751d27ad7$export$d3c8ecd0fb72b0(any, registryOrMessageDesc) {
    if (any.typeUrl === "") return undefined;
    const desc = registryOrMessageDesc.kind == "message" ? registryOrMessageDesc : registryOrMessageDesc.getMessage($03d622b751d27ad7$var$typeUrlToName(any.typeUrl));
    if (!desc || !$03d622b751d27ad7$export$e2910bf9bf14b0c9(any, desc)) return undefined;
    return (0, $6PNZL.fromBinary)(desc, any.value);
}
function $03d622b751d27ad7$export$3414ba225d6bca2c(any, schema, message) {
    if (!$03d622b751d27ad7$export$e2910bf9bf14b0c9(any, schema)) return undefined;
    return (0, $6PNZL.mergeFromBinary)(schema, message, any.value);
}
function $03d622b751d27ad7$var$typeNameToUrl(name) {
    return `type.googleapis.com/${name}`;
}
function $03d622b751d27ad7$var$typeUrlToName(url) {
    const slash = url.lastIndexOf("/");
    const name = slash >= 0 ? url.substring(slash + 1) : url;
    if (!name.length) throw new Error(`invalid type url: ${url}`);
    return name;
}

});
parcelRegister("eJPbX", function(module, exports) {

$parcel$export(module.exports, "file_google_protobuf_any", () => $abacfa4cb076d2ad$export$2dcf02fec6bcb23a);
$parcel$export(module.exports, "AnySchema", () => $abacfa4cb076d2ad$export$ad7c104f9cea9c52);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $9CnIh = parcelRequire("9CnIh");

var $8ImrE = parcelRequire("8ImrE");
const $abacfa4cb076d2ad$export$2dcf02fec6bcb23a = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Chlnb29nbGUvcHJvdG9idWYvYW55LnByb3RvEg9nb29nbGUucHJvdG9idWYiJgoDQW55EhAKCHR5cGVfdXJsGAEgASgJEg0KBXZhbHVlGAIgASgMQnYKE2NvbS5nb29nbGUucHJvdG9idWZCCEFueVByb3RvUAFaLGdvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL2FueXBiogIDR1BCqgIeR29vZ2xlLlByb3RvYnVmLldlbGxLbm93blR5cGVzYgZwcm90bzM");
const $abacfa4cb076d2ad$export$ad7c104f9cea9c52 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($abacfa4cb076d2ad$export$2dcf02fec6bcb23a, 0);

});

parcelRegister("cQRoD", function(module, exports) {

$parcel$export(module.exports, "toBinary", () => $95b3c2c4bee2d1d2$export$ee892b06e1166e2f);
$parcel$export(module.exports, "writeField", () => $95b3c2c4bee2d1d2$export$ee5267f5d5c48e29);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lItxZ = parcelRequire("lItxZ");

var $fqP57 = parcelRequire("fqP57");

var $8xxTQ = parcelRequire("8xxTQ");
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.LEGACY_REQUIRED: const $name: FeatureSet_FieldPresence.$localName = $number;
const $95b3c2c4bee2d1d2$var$LEGACY_REQUIRED = 3;
// Default options for serializing binary data.
const $95b3c2c4bee2d1d2$var$writeDefaults = {
    writeUnknownFields: true
};
function $95b3c2c4bee2d1d2$var$makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, $95b3c2c4bee2d1d2$var$writeDefaults), options) : $95b3c2c4bee2d1d2$var$writeDefaults;
}
function $95b3c2c4bee2d1d2$export$ee892b06e1166e2f(schema, message, options) {
    return $95b3c2c4bee2d1d2$var$writeFields(new (0, $fqP57.BinaryWriter)(), $95b3c2c4bee2d1d2$var$makeWriteOptions(options), (0, $lItxZ.reflect)(schema, message)).finish();
}
function $95b3c2c4bee2d1d2$var$writeFields(writer, opts, msg) {
    var _a;
    for (const f of msg.sortedFields){
        if (!msg.isSet(f)) {
            if (f.presence == $95b3c2c4bee2d1d2$var$LEGACY_REQUIRED) throw new Error(`cannot encode ${f} to binary: required field not set`);
            continue;
        }
        $95b3c2c4bee2d1d2$export$ee5267f5d5c48e29(writer, opts, msg, f);
    }
    if (opts.writeUnknownFields) for (const { no: no, wireType: wireType, data: data } of (_a = msg.getUnknown()) !== null && _a !== void 0 ? _a : [])writer.tag(no, wireType).raw(data);
    return writer;
}
function $95b3c2c4bee2d1d2$export$ee5267f5d5c48e29(writer, opts, msg, field) {
    var _a;
    switch(field.fieldKind){
        case "scalar":
        case "enum":
            $95b3c2c4bee2d1d2$var$writeScalar(writer, msg.desc.typeName, field.name, (_a = field.scalar) !== null && _a !== void 0 ? _a : (0, $8xxTQ.ScalarType).INT32, field.number, msg.get(field));
            break;
        case "list":
            $95b3c2c4bee2d1d2$var$writeListField(writer, opts, field, msg.get(field));
            break;
        case "message":
            $95b3c2c4bee2d1d2$var$writeMessageField(writer, opts, field, msg.get(field));
            break;
        case "map":
            for (const [key, val] of msg.get(field))$95b3c2c4bee2d1d2$var$writeMapEntry(writer, opts, field, key, val);
            break;
    }
}
function $95b3c2c4bee2d1d2$var$writeScalar(writer, msgName, fieldName, scalarType, fieldNo, value) {
    $95b3c2c4bee2d1d2$var$writeScalarValue(writer.tag(fieldNo, $95b3c2c4bee2d1d2$var$writeTypeOfScalar(scalarType)), msgName, fieldName, scalarType, value);
}
function $95b3c2c4bee2d1d2$var$writeMessageField(writer, opts, field, message) {
    if (field.delimitedEncoding) $95b3c2c4bee2d1d2$var$writeFields(writer.tag(field.number, (0, $fqP57.WireType).StartGroup), opts, message).tag(field.number, (0, $fqP57.WireType).EndGroup);
    else $95b3c2c4bee2d1d2$var$writeFields(writer.tag(field.number, (0, $fqP57.WireType).LengthDelimited).fork(), opts, message).join();
}
function $95b3c2c4bee2d1d2$var$writeListField(writer, opts, field, list) {
    var _a;
    if (field.listKind == "message") {
        for (const item of list)$95b3c2c4bee2d1d2$var$writeMessageField(writer, opts, field, item);
        return;
    }
    const scalarType = (_a = field.scalar) !== null && _a !== void 0 ? _a : (0, $8xxTQ.ScalarType).INT32;
    if (field.packed) {
        if (!list.size) return;
        writer.tag(field.number, (0, $fqP57.WireType).LengthDelimited).fork();
        for (const item of list)$95b3c2c4bee2d1d2$var$writeScalarValue(writer, field.parent.typeName, field.name, scalarType, item);
        writer.join();
        return;
    }
    for (const item of list)$95b3c2c4bee2d1d2$var$writeScalar(writer, field.parent.typeName, field.name, scalarType, field.number, item);
}
function $95b3c2c4bee2d1d2$var$writeMapEntry(writer, opts, field, key, value) {
    var _a;
    writer.tag(field.number, (0, $fqP57.WireType).LengthDelimited).fork();
    // write key, expecting key field number = 1
    $95b3c2c4bee2d1d2$var$writeScalar(writer, field.parent.typeName, field.name, field.mapKey, 1, key);
    // write value, expecting value field number = 2
    switch(field.mapKind){
        case "scalar":
        case "enum":
            $95b3c2c4bee2d1d2$var$writeScalar(writer, field.parent.typeName, field.name, (_a = field.scalar) !== null && _a !== void 0 ? _a : (0, $8xxTQ.ScalarType).INT32, 2, value);
            break;
        case "message":
            $95b3c2c4bee2d1d2$var$writeFields(writer.tag(2, (0, $fqP57.WireType).LengthDelimited).fork(), opts, value).join();
            break;
    }
    writer.join();
}
function $95b3c2c4bee2d1d2$var$writeScalarValue(writer, msgName, fieldName, type, value) {
    try {
        switch(type){
            case (0, $8xxTQ.ScalarType).STRING:
                writer.string(value);
                break;
            case (0, $8xxTQ.ScalarType).BOOL:
                writer.bool(value);
                break;
            case (0, $8xxTQ.ScalarType).DOUBLE:
                writer.double(value);
                break;
            case (0, $8xxTQ.ScalarType).FLOAT:
                writer.float(value);
                break;
            case (0, $8xxTQ.ScalarType).INT32:
                writer.int32(value);
                break;
            case (0, $8xxTQ.ScalarType).INT64:
                writer.int64(value);
                break;
            case (0, $8xxTQ.ScalarType).UINT64:
                writer.uint64(value);
                break;
            case (0, $8xxTQ.ScalarType).FIXED64:
                writer.fixed64(value);
                break;
            case (0, $8xxTQ.ScalarType).BYTES:
                writer.bytes(value);
                break;
            case (0, $8xxTQ.ScalarType).FIXED32:
                writer.fixed32(value);
                break;
            case (0, $8xxTQ.ScalarType).SFIXED32:
                writer.sfixed32(value);
                break;
            case (0, $8xxTQ.ScalarType).SFIXED64:
                writer.sfixed64(value);
                break;
            case (0, $8xxTQ.ScalarType).SINT64:
                writer.sint64(value);
                break;
            case (0, $8xxTQ.ScalarType).UINT32:
                writer.uint32(value);
                break;
            case (0, $8xxTQ.ScalarType).SINT32:
                writer.sint32(value);
                break;
        }
    } catch (e) {
        if (e instanceof Error) throw new Error(`cannot encode field ${msgName}.${fieldName} to binary: ${e.message}`);
        throw e;
    }
}
function $95b3c2c4bee2d1d2$var$writeTypeOfScalar(type) {
    switch(type){
        case (0, $8xxTQ.ScalarType).BYTES:
        case (0, $8xxTQ.ScalarType).STRING:
            return (0, $fqP57.WireType).LengthDelimited;
        case (0, $8xxTQ.ScalarType).DOUBLE:
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
            return (0, $fqP57.WireType).Bit64;
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).FLOAT:
            return (0, $fqP57.WireType).Bit32;
        default:
            return (0, $fqP57.WireType).Varint;
    }
}

});


parcelRegister("jrWrJ", function(module, exports) {

$parcel$export(module.exports, "StructSchema", () => $03a77319606e5a2f$export$87654b1f5dac85a8);
$parcel$export(module.exports, "ValueSchema", () => $03a77319606e5a2f$export$166b4bb9b1a6ee3b);
$parcel$export(module.exports, "ListValueSchema", () => $03a77319606e5a2f$export$8fe1ebb7fbcba471);
$parcel$export(module.exports, "NullValue", () => $03a77319606e5a2f$export$2b9002e549dccbbd);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $9CnIh = parcelRequire("9CnIh");

var $8ImrE = parcelRequire("8ImrE");

var $h4GxM = parcelRequire("h4GxM");
const $03a77319606e5a2f$export$72a5d6ef820f9f40 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Chxnb29nbGUvcHJvdG9idWYvc3RydWN0LnByb3RvEg9nb29nbGUucHJvdG9idWYihAEKBlN0cnVjdBIzCgZmaWVsZHMYASADKAsyIy5nb29nbGUucHJvdG9idWYuU3RydWN0LkZpZWxkc0VudHJ5GkUKC0ZpZWxkc0VudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEi6gEKBVZhbHVlEjAKCm51bGxfdmFsdWUYASABKA4yGi5nb29nbGUucHJvdG9idWYuTnVsbFZhbHVlSAASFgoMbnVtYmVyX3ZhbHVlGAIgASgBSAASFgoMc3RyaW5nX3ZhbHVlGAMgASgJSAASFAoKYm9vbF92YWx1ZRgEIAEoCEgAEi8KDHN0cnVjdF92YWx1ZRgFIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3RIABIwCgpsaXN0X3ZhbHVlGAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLkxpc3RWYWx1ZUgAQgYKBGtpbmQiMwoJTGlzdFZhbHVlEiYKBnZhbHVlcxgBIAMoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZSobCglOdWxsVmFsdWUSDgoKTlVMTF9WQUxVRRAAQn8KE2NvbS5nb29nbGUucHJvdG9idWZCC1N0cnVjdFByb3RvUAFaL2dvb2dsZS5nb2xhbmcub3JnL3Byb3RvYnVmL3R5cGVzL2tub3duL3N0cnVjdHBi+AEBogIDR1BCqgIeR29vZ2xlLlByb3RvYnVmLldlbGxLbm93blR5cGVzYgZwcm90bzM");
const $03a77319606e5a2f$export$87654b1f5dac85a8 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($03a77319606e5a2f$export$72a5d6ef820f9f40, 0);
const $03a77319606e5a2f$export$166b4bb9b1a6ee3b = /*@__PURE__*/ (0, $8ImrE.messageDesc)($03a77319606e5a2f$export$72a5d6ef820f9f40, 1);
const $03a77319606e5a2f$export$8fe1ebb7fbcba471 = /*@__PURE__*/ (0, $8ImrE.messageDesc)($03a77319606e5a2f$export$72a5d6ef820f9f40, 2);
var $03a77319606e5a2f$export$2b9002e549dccbbd;
(function(NullValue) {
    /**
     * Null value.
     *
     * @generated from enum value: NULL_VALUE = 0;
     */ NullValue[NullValue["NULL_VALUE"] = 0] = "NULL_VALUE";
})($03a77319606e5a2f$export$2b9002e549dccbbd || ($03a77319606e5a2f$export$2b9002e549dccbbd = {}));
const $03a77319606e5a2f$export$45202ed756af1a94 = /*@__PURE__*/ (0, $h4GxM.enumDesc)($03a77319606e5a2f$export$72a5d6ef820f9f40, 0);

});

parcelRegister("1jtuq", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $0f4e70d4af3c981d$export$78d71f9ed5534abe);
$parcel$export(module.exports, "createExtensionContainer", () => $0f4e70d4af3c981d$export$b5b3b28c2ee4d2c);
$parcel$export(module.exports, "setExtension", () => $0f4e70d4af3c981d$export$8577384a5a8eb14);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $1jDsz = parcelRequire("1jDsz");

var $6PNZL = parcelRequire("6PNZL");

var $lItxZ = parcelRequire("lItxZ");

var $lipan = parcelRequire("lipan");

var $cQRoD = parcelRequire("cQRoD");

var $fqP57 = parcelRequire("fqP57");

var $AYHoV = parcelRequire("AYHoV");
function $0f4e70d4af3c981d$export$78d71f9ed5534abe(message, extension) {
    $0f4e70d4af3c981d$var$assertExtendee(extension, message);
    const ufs = $0f4e70d4af3c981d$var$filterUnknownFields(message.$unknown, extension);
    const [container, field, get] = $0f4e70d4af3c981d$export$b5b3b28c2ee4d2c(extension);
    for (const uf of ufs)(0, $6PNZL.readField)(container, new (0, $fqP57.BinaryReader)(uf.data), field, uf.wireType, {
        readUnknownFields: true
    });
    return get();
}
function $0f4e70d4af3c981d$export$8577384a5a8eb14(message, extension, value) {
    var _a;
    $0f4e70d4af3c981d$var$assertExtendee(extension, message);
    const ufs = ((_a = message.$unknown) !== null && _a !== void 0 ? _a : []).filter((uf)=>uf.no !== extension.number);
    const [container, field] = $0f4e70d4af3c981d$export$b5b3b28c2ee4d2c(extension, value);
    const writer = new (0, $fqP57.BinaryWriter)();
    (0, $cQRoD.writeField)(writer, {
        writeUnknownFields: true
    }, container, field);
    const reader = new (0, $fqP57.BinaryReader)(writer.finish());
    while(reader.pos < reader.len){
        const [no, wireType] = reader.tag();
        const data = reader.skip(wireType, no);
        ufs.push({
            no: no,
            wireType: wireType,
            data: data
        });
    }
    message.$unknown = ufs;
}
function $0f4e70d4af3c981d$export$4985bb959c8c7c86(message, extension) {
    $0f4e70d4af3c981d$var$assertExtendee(extension, message);
    if (message.$unknown === undefined) return;
    message.$unknown = message.$unknown.filter((uf)=>uf.no !== extension.number);
}
function $0f4e70d4af3c981d$export$4f402f57c05c9ec3(message, extension) {
    var _a;
    return extension.extendee.typeName === message.$typeName && !!((_a = message.$unknown) === null || _a === void 0 ? void 0 : _a.find((uf)=>uf.no === extension.number));
}
function $0f4e70d4af3c981d$export$48a033fa44b68eb3(element, option) {
    const message = element.proto.options;
    if (!message) return false;
    return $0f4e70d4af3c981d$export$4f402f57c05c9ec3(message, option);
}
function $0f4e70d4af3c981d$export$6df0712d20d2cc08(element, option) {
    const message = element.proto.options;
    if (!message) {
        const [, , get] = $0f4e70d4af3c981d$export$b5b3b28c2ee4d2c(option);
        return get();
    }
    return $0f4e70d4af3c981d$export$78d71f9ed5534abe(message, option);
}
function $0f4e70d4af3c981d$var$filterUnknownFields(unknownFields, extension) {
    if (unknownFields === undefined) return [];
    if (extension.fieldKind === "enum" || extension.fieldKind === "scalar") {
        // singular scalar fields do not merge, we pick the last
        for(let i = unknownFields.length - 1; i >= 0; --i){
            if (unknownFields[i].no == extension.number) return [
                unknownFields[i]
            ];
        }
        return [];
    }
    return unknownFields.filter((uf)=>uf.no === extension.number);
}
function $0f4e70d4af3c981d$export$b5b3b28c2ee4d2c(extension, value) {
    const localName = extension.typeName;
    const field = Object.assign(Object.assign({}, extension), {
        kind: "field",
        parent: extension.extendee,
        localName: localName
    });
    const desc = Object.assign(Object.assign({}, extension.extendee), {
        fields: [
            field
        ],
        members: [
            field
        ],
        oneofs: []
    });
    const container = (0, $1jDsz.create)(desc, value !== undefined ? {
        [localName]: value
    } : undefined);
    return [
        (0, $lItxZ.reflect)(desc, container),
        field,
        ()=>{
            const value = container[localName];
            if (value === undefined) {
                // biome-ignore lint/style/noNonNullAssertion: Only message fields are undefined, rest will have a zero value.
                const desc = extension.message;
                if ((0, $AYHoV.isWrapperDesc)(desc)) return (0, $lipan.scalarZeroValue)(desc.fields[0].scalar, desc.fields[0].longAsString);
                return (0, $1jDsz.create)(desc);
            }
            return value;
        }
    ];
}
function $0f4e70d4af3c981d$var$assertExtendee(extension, message) {
    if (extension.extendee.typeName != message.$typeName) throw new Error(`extension ${extension.typeName} can only be applied to message ${extension.extendee.typeName}`);
}

});


parcelRegister("7BsIG", function(module, exports) {

$parcel$export(module.exports, "appendHeaders", () => $5892444330b2e968$export$d4b1f8621cbc4b2f);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $6PNZL = parcelRequire("6PNZL");
var $cQRoD = parcelRequire("cQRoD");

var $3xX2e = parcelRequire("3xX2e");

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
function $5892444330b2e968$export$b1d66a846f3e2122(value, desc) {
    let bytes;
    if (desc !== undefined) bytes = (0, $cQRoD.toBinary)(desc, value);
    else if (typeof value == "string") bytes = new TextEncoder().encode(value);
    else bytes = value instanceof Uint8Array ? value : new Uint8Array(value);
    return (0, $3xX2e.base64Encode)(bytes, "std_raw");
}
function $5892444330b2e968$export$bbf395108408876a(value, desc, options) {
    try {
        const bytes = (0, $3xX2e.base64Decode)(value);
        if (desc) return (0, $6PNZL.fromBinary)(desc, bytes, options);
        return bytes;
    } catch (e) {
        throw (0, $4tXo7.ConnectError).from(e, (0, $lBjkW.Code).DataLoss);
    }
}
function $5892444330b2e968$export$d4b1f8621cbc4b2f(...headers) {
    const h = new Headers();
    for (const e of headers)e.forEach((value, key)=>{
        h.append(key, value);
    });
    return h;
}

});
parcelRegister("4tXo7", function(module, exports) {

$parcel$export(module.exports, "ConnectError", () => $3437f00edf808464$export$aaa3fc6bdea78d4d);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lBjkW = parcelRequire("lBjkW");

var $1jDsz = parcelRequire("1jDsz");
var $6PNZL = parcelRequire("6PNZL");

var $kWRje = parcelRequire("kWRje");
class $3437f00edf808464$export$aaa3fc6bdea78d4d extends Error {
    /**
     * Create a new ConnectError.
     * If no code is provided, code "unknown" is used.
     * Outgoing details are only relevant for the server side - a service may
     * raise an error with details, and it is up to the protocol implementation
     * to encode and send the details along with error.
     */ constructor(message, code = (0, $lBjkW.Code).Unknown, metadata, outgoingDetails, cause){
        super($3437f00edf808464$var$createMessage(message, code));
        this.name = "ConnectError";
        // see https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#example
        Object.setPrototypeOf(this, new.target.prototype);
        this.rawMessage = message;
        this.code = code;
        this.metadata = new Headers(metadata !== null && metadata !== void 0 ? metadata : {});
        this.details = outgoingDetails !== null && outgoingDetails !== void 0 ? outgoingDetails : [];
        this.cause = cause;
    }
    /**
     * Convert any value - typically a caught error into a ConnectError,
     * following these rules:
     * - If the value is already a ConnectError, return it as is.
     * - If the value is an AbortError from the fetch API, return the message
     *   of the AbortError with code Canceled.
     * - For other Errors, return the error message with code Unknown by default.
     * - For other values, return the values String representation as a message,
     *   with the code Unknown by default.
     * The original value will be used for the "cause" property for the new
     * ConnectError.
     */ static from(reason, code = (0, $lBjkW.Code).Unknown) {
        if (reason instanceof $3437f00edf808464$export$aaa3fc6bdea78d4d) return reason;
        if (reason instanceof Error) {
            if (reason.name == "AbortError") // Fetch requests can only be canceled with an AbortController.
            // We detect that condition by looking at the name of the raised
            // error object, and translate to the appropriate status code.
            return new $3437f00edf808464$export$aaa3fc6bdea78d4d(reason.message, (0, $lBjkW.Code).Canceled);
            return new $3437f00edf808464$export$aaa3fc6bdea78d4d(reason.message, code, undefined, undefined, reason);
        }
        return new $3437f00edf808464$export$aaa3fc6bdea78d4d(String(reason), code, undefined, undefined, reason);
    }
    static [Symbol.hasInstance](v) {
        if (!(v instanceof Error)) return false;
        if (Object.getPrototypeOf(v) === $3437f00edf808464$export$aaa3fc6bdea78d4d.prototype) return true;
        return v.name === "ConnectError" && "code" in v && typeof v.code === "number" && "metadata" in v && "details" in v && Array.isArray(v.details) && "rawMessage" in v && typeof v.rawMessage == "string" && "cause" in v;
    }
    findDetails(typeOrRegistry) {
        const registry = typeOrRegistry.kind === "message" ? {
            getMessage: (typeName)=>typeName === typeOrRegistry.typeName ? typeOrRegistry : undefined
        } : typeOrRegistry;
        const details = [];
        for (const data of this.details){
            if ("desc" in data) {
                if (registry.getMessage(data.desc.typeName)) details.push((0, $1jDsz.create)(data.desc, data.value));
                continue;
            }
            const desc = registry.getMessage(data.type);
            if (desc) try {
                details.push((0, $6PNZL.fromBinary)(desc, data.value));
            } catch (_) {
            // We silently give up if we are unable to parse the detail, because
            // that appears to be the least worst behavior.
            // It is very unlikely that a user surrounds a catch body handling the
            // error with another try-catch statement, and we do not want to
            // recommend doing so.
            }
        }
        return details;
    }
}
/**
 * Create an error message, prefixing the given code.
 */ function $3437f00edf808464$var$createMessage(message, code) {
    return message.length ? `[${(0, $kWRje.codeToString)(code)}] ${message}` : `[${(0, $kWRje.codeToString)(code)}]`;
}

});
parcelRegister("lBjkW", function(module, exports) {

$parcel$export(module.exports, "Code", () => $fb9c0d8e1e64c410$export$52f0f02147b12c03);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Connect represents categories of errors as codes, and each code maps to a
 * specific HTTP status code. The codes and their semantics were chosen to
 * match gRPC. Only the codes below are valid — there are no user-defined
 * codes.
 *
 * See the specification at https://connectrpc.com/docs/protocol#error-codes
 * for details.
 */ var $fb9c0d8e1e64c410$export$52f0f02147b12c03;
(function(Code) {
    /**
     * Canceled, usually be the user
     */ Code[Code["Canceled"] = 1] = "Canceled";
    /**
     * Unknown error
     */ Code[Code["Unknown"] = 2] = "Unknown";
    /**
     * Argument invalid regardless of system state
     */ Code[Code["InvalidArgument"] = 3] = "InvalidArgument";
    /**
     * Operation expired, may or may not have completed.
     */ Code[Code["DeadlineExceeded"] = 4] = "DeadlineExceeded";
    /**
     * Entity not found.
     */ Code[Code["NotFound"] = 5] = "NotFound";
    /**
     * Entity already exists.
     */ Code[Code["AlreadyExists"] = 6] = "AlreadyExists";
    /**
     * Operation not authorized.
     */ Code[Code["PermissionDenied"] = 7] = "PermissionDenied";
    /**
     * Quota exhausted.
     */ Code[Code["ResourceExhausted"] = 8] = "ResourceExhausted";
    /**
     * Argument invalid in current system state.
     */ Code[Code["FailedPrecondition"] = 9] = "FailedPrecondition";
    /**
     * Operation aborted.
     */ Code[Code["Aborted"] = 10] = "Aborted";
    /**
     * Out of bounds, use instead of FailedPrecondition.
     */ Code[Code["OutOfRange"] = 11] = "OutOfRange";
    /**
     * Operation not implemented or disabled.
     */ Code[Code["Unimplemented"] = 12] = "Unimplemented";
    /**
     * Internal error, reserved for "serious errors".
     */ Code[Code["Internal"] = 13] = "Internal";
    /**
     * Unavailable, client should back off and retry.
     */ Code[Code["Unavailable"] = 14] = "Unavailable";
    /**
     * Unrecoverable data loss or corruption.
     */ Code[Code["DataLoss"] = 15] = "DataLoss";
    /**
     * Request isn't authenticated.
     */ Code[Code["Unauthenticated"] = 16] = "Unauthenticated";
})($fb9c0d8e1e64c410$export$52f0f02147b12c03 || ($fb9c0d8e1e64c410$export$52f0f02147b12c03 = {}));

});

parcelRegister("kWRje", function(module, exports) {

$parcel$export(module.exports, "codeToString", () => $f402938bebfa0357$export$33d7ca6494ecd928);
$parcel$export(module.exports, "codeFromString", () => $f402938bebfa0357$export$ab44a6f2fc25215e);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lBjkW = parcelRequire("lBjkW");
function $f402938bebfa0357$export$33d7ca6494ecd928(value) {
    const name = (0, $lBjkW.Code)[value];
    if (typeof name != "string") return value.toString();
    return name[0].toLowerCase() + name.substring(1).replace(/[A-Z]/g, (c)=>"_" + c.toLowerCase());
}
let $f402938bebfa0357$var$stringToCode;
function $f402938bebfa0357$export$ab44a6f2fc25215e(value) {
    if (!$f402938bebfa0357$var$stringToCode) {
        $f402938bebfa0357$var$stringToCode = {};
        for (const value of Object.values((0, $lBjkW.Code))){
            if (typeof value == "string") continue;
            $f402938bebfa0357$var$stringToCode[$f402938bebfa0357$export$33d7ca6494ecd928(value)] = value;
        }
    }
    return $f402938bebfa0357$var$stringToCode[value];
}

});



parcelRegister("gPrvR", function(module, exports) {

$parcel$export(module.exports, "createContextValues", () => $c406c03c8e1fccf0$export$c7e89650db422ec0);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * createContextValues creates a new ContextValues.
 */ function $c406c03c8e1fccf0$export$c7e89650db422ec0() {
    return {
        get (key) {
            return key.id in this ? this[key.id] : key.defaultValue;
        },
        set (key, value) {
            this[key.id] = value;
            return this;
        },
        delete (key) {
            delete this[key.id];
            return this;
        }
    };
}
function $c406c03c8e1fccf0$export$b8c322c5a7cfce78(defaultValue, options) {
    return {
        id: Symbol(options === null || options === void 0 ? void 0 : options.description),
        defaultValue: defaultValue
    };
}

});

parcelRegister("cQTV6", function(module, exports) {

$parcel$export(module.exports, "compressedFlag", () => $95b5b7e50f3cda88$export$196e47a15ac49fbc);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
const $95b5b7e50f3cda88$export$196e47a15ac49fbc = 1;
function $95b5b7e50f3cda88$export$c1055e1eabdb1944(available, requested, accepted, headerNameAcceptEncoding) {
    let request = null;
    let response = null;
    let error = undefined;
    if (requested !== null && requested !== "identity") {
        const found = available.find((c)=>c.name === requested);
        if (found) request = found;
        else {
            // To comply with https://github.com/grpc/grpc/blob/master/doc/compression.md
            // and the Connect protocol, we return code "unimplemented" and specify
            // acceptable compression(s).
            const acceptable = available.map((c)=>c.name).join(",");
            error = new (0, $4tXo7.ConnectError)(`unknown compression "${requested}": supported encodings are ${acceptable}`, (0, $lBjkW.Code).Unimplemented, {
                [headerNameAcceptEncoding]: acceptable
            });
        }
    }
    if (accepted === null || accepted === "") // Support asymmetric compression. This logic follows
    // https://github.com/grpc/grpc/blob/master/doc/compression.md and common
    // sense.
    response = request;
    else {
        const acceptNames = accepted.split(",").map((n)=>n.trim());
        for (const name of acceptNames){
            const found = available.find((c)=>c.name === name);
            if (found) {
                response = found;
                break;
            }
        }
    }
    return {
        request: request,
        response: response,
        error: error
    };
}

});

parcelRegister("gKdXS", function(module, exports) {

$parcel$export(module.exports, "getJsonOptions", () => $c30bc657dd0ced5e$export$78fc91f6515ce177);
$parcel$export(module.exports, "createClientMethodSerializers", () => $c30bc657dd0ced5e$export$56d5743c5b5ac637);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $6PNZL = parcelRequire("6PNZL");
var $3XMHQ = parcelRequire("3XMHQ");
var $cQRoD = parcelRequire("cQRoD");
var $ef0ax = parcelRequire("ef0ax");

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");

var $1WJ2v = parcelRequire("1WJ2v");
function $c30bc657dd0ced5e$export$78fc91f6515ce177(options) {
    var _a;
    const o = Object.assign({}, options);
    (_a = o.ignoreUnknownFields) !== null && _a !== void 0 ? _a : o.ignoreUnknownFields = true;
    return o;
}
function $c30bc657dd0ced5e$export$ef2a960eeb6616d1(method, binaryOptions, jsonOptions, limitOptions) {
    const inputBinary = $c30bc657dd0ced5e$export$af9f10590e9793ed($c30bc657dd0ced5e$export$70dc868eda6f5cba(method.input, binaryOptions), limitOptions);
    const inputJson = $c30bc657dd0ced5e$export$af9f10590e9793ed($c30bc657dd0ced5e$export$ae4068f4dad8eb85(method.input, jsonOptions), limitOptions);
    const outputBinary = $c30bc657dd0ced5e$export$af9f10590e9793ed($c30bc657dd0ced5e$export$70dc868eda6f5cba(method.output, binaryOptions), limitOptions);
    const outputJson = $c30bc657dd0ced5e$export$af9f10590e9793ed($c30bc657dd0ced5e$export$ae4068f4dad8eb85(method.output, jsonOptions), limitOptions);
    return {
        getI (useBinaryFormat) {
            return useBinaryFormat ? inputBinary : inputJson;
        },
        getO (useBinaryFormat) {
            return useBinaryFormat ? outputBinary : outputJson;
        }
    };
}
function $c30bc657dd0ced5e$export$56d5743c5b5ac637(method, useBinaryFormat, jsonOptions, binaryOptions) {
    const input = useBinaryFormat ? $c30bc657dd0ced5e$export$70dc868eda6f5cba(method.input, binaryOptions) : $c30bc657dd0ced5e$export$ae4068f4dad8eb85(method.input, jsonOptions);
    const output = useBinaryFormat ? $c30bc657dd0ced5e$export$70dc868eda6f5cba(method.output, binaryOptions) : $c30bc657dd0ced5e$export$ae4068f4dad8eb85(method.output, jsonOptions);
    return {
        parse: output.parse,
        serialize: input.serialize
    };
}
function $c30bc657dd0ced5e$export$af9f10590e9793ed(serialization, limitOptions) {
    return {
        serialize (data) {
            const bytes = serialization.serialize(data);
            (0, $1WJ2v.assertWriteMaxBytes)(limitOptions.writeMaxBytes, bytes.byteLength);
            return bytes;
        },
        parse (data) {
            (0, $1WJ2v.assertReadMaxBytes)(limitOptions.readMaxBytes, data.byteLength, true);
            return serialization.parse(data);
        }
    };
}
function $c30bc657dd0ced5e$export$70dc868eda6f5cba(desc, options) {
    return {
        parse (data) {
            try {
                return (0, $6PNZL.fromBinary)(desc, data, options);
            } catch (e) {
                const m = e instanceof Error ? e.message : String(e);
                throw new (0, $4tXo7.ConnectError)(`parse binary: ${m}`, (0, $lBjkW.Code).Internal);
            }
        },
        serialize (data) {
            try {
                return (0, $cQRoD.toBinary)(desc, data, options);
            } catch (e) {
                const m = e instanceof Error ? e.message : String(e);
                throw new (0, $4tXo7.ConnectError)(`serialize binary: ${m}`, (0, $lBjkW.Code).Internal);
            }
        }
    };
}
function $c30bc657dd0ced5e$export$ae4068f4dad8eb85(desc, options) {
    var _a, _b;
    const textEncoder = (_a = options === null || options === void 0 ? void 0 : options.textEncoder) !== null && _a !== void 0 ? _a : new TextEncoder();
    const textDecoder = (_b = options === null || options === void 0 ? void 0 : options.textDecoder) !== null && _b !== void 0 ? _b : new TextDecoder();
    const o = $c30bc657dd0ced5e$export$78fc91f6515ce177(options);
    return {
        parse (data) {
            try {
                const json = textDecoder.decode(data);
                return (0, $3XMHQ.fromJsonString)(desc, json, o);
            } catch (e) {
                throw (0, $4tXo7.ConnectError).from(e, (0, $lBjkW.Code).InvalidArgument);
            }
        },
        serialize (data) {
            try {
                const json = (0, $ef0ax.toJsonString)(desc, data, o);
                return textEncoder.encode(json);
            } catch (e) {
                throw (0, $4tXo7.ConnectError).from(e, (0, $lBjkW.Code).Internal);
            }
        }
    };
}

});
parcelRegister("ef0ax", function(module, exports) {

$parcel$export(module.exports, "toJson", () => $a5e298f669082936$export$d5b7a8bf56ee1fe2);
$parcel$export(module.exports, "toJsonString", () => $a5e298f669082936$export$4e21c2b19c1e81a4);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $8xxTQ = parcelRequire("8xxTQ");

var $kLINC = parcelRequire("kLINC");

var $lItxZ = parcelRequire("lItxZ");

var $kq7Xn = parcelRequire("kq7Xn");

var $AYHoV = parcelRequire("AYHoV");

var $3xX2e = parcelRequire("3xX2e");

var $1jtuq = parcelRequire("1jtuq");

var $g7x8s = parcelRequire("g7x8s");
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.LEGACY_REQUIRED: const $name: FeatureSet_FieldPresence.$localName = $number;
const $a5e298f669082936$var$LEGACY_REQUIRED = 3;
// bootstrap-inject google.protobuf.FeatureSet.FieldPresence.IMPLICIT: const $name: FeatureSet_FieldPresence.$localName = $number;
const $a5e298f669082936$var$IMPLICIT = 2;
// Default options for serializing to JSON.
const $a5e298f669082936$var$jsonWriteDefaults = {
    alwaysEmitImplicit: false,
    enumAsInteger: false,
    useProtoFieldName: false
};
function $a5e298f669082936$var$makeWriteOptions(options) {
    return options ? Object.assign(Object.assign({}, $a5e298f669082936$var$jsonWriteDefaults), options) : $a5e298f669082936$var$jsonWriteDefaults;
}
function $a5e298f669082936$export$d5b7a8bf56ee1fe2(schema, message, options) {
    return $a5e298f669082936$var$reflectToJson((0, $lItxZ.reflect)(schema, message), $a5e298f669082936$var$makeWriteOptions(options));
}
function $a5e298f669082936$export$4e21c2b19c1e81a4(schema, message, options) {
    var _a;
    const jsonValue = $a5e298f669082936$export$d5b7a8bf56ee1fe2(schema, message, options);
    return JSON.stringify(jsonValue, null, (_a = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a !== void 0 ? _a : 0);
}
function $a5e298f669082936$export$80dd636890a17812(descEnum, value) {
    var _a;
    if (descEnum.typeName == "google.protobuf.NullValue") return null;
    const name = (_a = descEnum.value[value]) === null || _a === void 0 ? void 0 : _a.name;
    if (name === undefined) throw new Error(`${value} is not a value in ${descEnum}`);
    return name;
}
function $a5e298f669082936$var$reflectToJson(msg, opts) {
    var _a;
    const wktJson = $a5e298f669082936$var$tryWktToJson(msg, opts);
    if (wktJson !== undefined) return wktJson;
    const json = {};
    for (const f of msg.sortedFields){
        if (!msg.isSet(f)) {
            if (f.presence == $a5e298f669082936$var$LEGACY_REQUIRED) throw new Error(`cannot encode ${f} to JSON: required field not set`);
            if (!opts.alwaysEmitImplicit || f.presence !== $a5e298f669082936$var$IMPLICIT) continue;
        }
        const jsonValue = $a5e298f669082936$var$fieldToJson(f, msg.get(f), opts);
        if (jsonValue !== undefined) json[$a5e298f669082936$var$jsonName(f, opts)] = jsonValue;
    }
    if (opts.registry) {
        const tagSeen = new Set();
        for (const { no: no } of (_a = msg.getUnknown()) !== null && _a !== void 0 ? _a : [])// Same tag can appear multiple times, so we
        // keep track and skip identical ones.
        if (!tagSeen.has(no)) {
            tagSeen.add(no);
            const extension = opts.registry.getExtensionFor(msg.desc, no);
            if (!extension) continue;
            const value = (0, $1jtuq.getExtension)(msg.message, extension);
            const [container, field] = (0, $1jtuq.createExtensionContainer)(extension, value);
            const jsonValue = $a5e298f669082936$var$fieldToJson(field, container.get(field), opts);
            if (jsonValue !== undefined) json[extension.jsonName] = jsonValue;
        }
    }
    return json;
}
function $a5e298f669082936$var$fieldToJson(f, val, opts) {
    switch(f.fieldKind){
        case "scalar":
            return $a5e298f669082936$var$scalarToJson(f, val);
        case "message":
            return $a5e298f669082936$var$reflectToJson(val, opts);
        case "enum":
            return $a5e298f669082936$var$enumToJsonInternal(f.enum, val, opts.enumAsInteger);
        case "list":
            return $a5e298f669082936$var$listToJson(val, opts);
        case "map":
            return $a5e298f669082936$var$mapToJson(val, opts);
    }
}
function $a5e298f669082936$var$mapToJson(map, opts) {
    const f = map.field();
    const jsonObj = {};
    switch(f.mapKind){
        case "scalar":
            for (const [entryKey, entryValue] of map)jsonObj[entryKey] = $a5e298f669082936$var$scalarToJson(f, entryValue);
            break;
        case "message":
            for (const [entryKey, entryValue] of map)jsonObj[entryKey] = $a5e298f669082936$var$reflectToJson(entryValue, opts);
            break;
        case "enum":
            for (const [entryKey, entryValue] of map)jsonObj[entryKey] = $a5e298f669082936$var$enumToJsonInternal(f.enum, entryValue, opts.enumAsInteger);
            break;
    }
    return opts.alwaysEmitImplicit || map.size > 0 ? jsonObj : undefined;
}
function $a5e298f669082936$var$listToJson(list, opts) {
    const f = list.field();
    const jsonArr = [];
    switch(f.listKind){
        case "scalar":
            for (const item of list)jsonArr.push($a5e298f669082936$var$scalarToJson(f, item));
            break;
        case "enum":
            for (const item of list)jsonArr.push($a5e298f669082936$var$enumToJsonInternal(f.enum, item, opts.enumAsInteger));
            break;
        case "message":
            for (const item of list)jsonArr.push($a5e298f669082936$var$reflectToJson(item, opts));
            break;
    }
    return opts.alwaysEmitImplicit || jsonArr.length > 0 ? jsonArr : undefined;
}
function $a5e298f669082936$var$enumToJsonInternal(desc, value, enumAsInteger) {
    var _a;
    if (typeof value != "number") throw new Error(`cannot encode ${desc} to JSON: expected number, got ${(0, $g7x8s.formatVal)(value)}`);
    if (desc.typeName == "google.protobuf.NullValue") return null;
    if (enumAsInteger) return value;
    const val = desc.value[value];
    return (_a = val === null || val === void 0 ? void 0 : val.name) !== null && _a !== void 0 ? _a : value; // if we don't know the enum value, just return the number
}
function $a5e298f669082936$var$scalarToJson(field, value) {
    var _a, _b, _c, _d, _e, _f;
    switch(field.scalar){
        // int32, fixed32, uint32: JSON value will be a decimal number. Either numbers or strings are accepted.
        case (0, $8xxTQ.ScalarType).INT32:
        case (0, $8xxTQ.ScalarType).SFIXED32:
        case (0, $8xxTQ.ScalarType).SINT32:
        case (0, $8xxTQ.ScalarType).FIXED32:
        case (0, $8xxTQ.ScalarType).UINT32:
            if (typeof value != "number") throw new Error(`cannot encode ${field} to JSON: ${(_a = (0, $g7x8s.checkField)(field, value)) === null || _a === void 0 ? void 0 : _a.message}`);
            return value;
        // float, double: JSON value will be a number or one of the special string values "NaN", "Infinity", and "-Infinity".
        // Either numbers or strings are accepted. Exponent notation is also accepted.
        case (0, $8xxTQ.ScalarType).FLOAT:
        case (0, $8xxTQ.ScalarType).DOUBLE:
            if (typeof value != "number") throw new Error(`cannot encode ${field} to JSON: ${(_b = (0, $g7x8s.checkField)(field, value)) === null || _b === void 0 ? void 0 : _b.message}`);
            if (Number.isNaN(value)) return "NaN";
            if (value === Number.POSITIVE_INFINITY) return "Infinity";
            if (value === Number.NEGATIVE_INFINITY) return "-Infinity";
            return value;
        // string:
        case (0, $8xxTQ.ScalarType).STRING:
            if (typeof value != "string") throw new Error(`cannot encode ${field} to JSON: ${(_c = (0, $g7x8s.checkField)(field, value)) === null || _c === void 0 ? void 0 : _c.message}`);
            return value;
        // bool:
        case (0, $8xxTQ.ScalarType).BOOL:
            if (typeof value != "boolean") throw new Error(`cannot encode ${field} to JSON: ${(_d = (0, $g7x8s.checkField)(field, value)) === null || _d === void 0 ? void 0 : _d.message}`);
            return value;
        // JSON value will be a decimal string. Either numbers or strings are accepted.
        case (0, $8xxTQ.ScalarType).UINT64:
        case (0, $8xxTQ.ScalarType).FIXED64:
        case (0, $8xxTQ.ScalarType).INT64:
        case (0, $8xxTQ.ScalarType).SFIXED64:
        case (0, $8xxTQ.ScalarType).SINT64:
            if (typeof value != "bigint" && typeof value != "string") throw new Error(`cannot encode ${field} to JSON: ${(_e = (0, $g7x8s.checkField)(field, value)) === null || _e === void 0 ? void 0 : _e.message}`);
            return value.toString();
        // bytes: JSON value will be the data encoded as a string using standard base64 encoding with paddings.
        // Either standard or URL-safe base64 encoding with/without paddings are accepted.
        case (0, $8xxTQ.ScalarType).BYTES:
            if (value instanceof Uint8Array) return (0, $3xX2e.base64Encode)(value);
            throw new Error(`cannot encode ${field} to JSON: ${(_f = (0, $g7x8s.checkField)(field, value)) === null || _f === void 0 ? void 0 : _f.message}`);
    }
}
function $a5e298f669082936$var$jsonName(f, opts) {
    return opts.useProtoFieldName ? f.name : f.jsonName;
}
// returns a json value if wkt, otherwise returns undefined.
function $a5e298f669082936$var$tryWktToJson(msg, opts) {
    if (!msg.desc.typeName.startsWith("google.protobuf.")) return undefined;
    switch(msg.desc.typeName){
        case "google.protobuf.Any":
            return $a5e298f669082936$var$anyToJson(msg.message, opts);
        case "google.protobuf.Timestamp":
            return $a5e298f669082936$var$timestampToJson(msg.message);
        case "google.protobuf.Duration":
            return $a5e298f669082936$var$durationToJson(msg.message);
        case "google.protobuf.FieldMask":
            return $a5e298f669082936$var$fieldMaskToJson(msg.message);
        case "google.protobuf.Struct":
            return $a5e298f669082936$var$structToJson(msg.message);
        case "google.protobuf.Value":
            return $a5e298f669082936$var$valueToJson(msg.message);
        case "google.protobuf.ListValue":
            return $a5e298f669082936$var$listValueToJson(msg.message);
        default:
            if ((0, $AYHoV.isWrapperDesc)(msg.desc)) {
                const valueField = msg.desc.fields[0];
                return $a5e298f669082936$var$scalarToJson(valueField, msg.get(valueField));
            }
            return undefined;
    }
}
function $a5e298f669082936$var$anyToJson(val, opts) {
    if (val.typeUrl === "") return {};
    const { registry: registry } = opts;
    let message;
    let desc;
    if (registry) {
        message = (0, $kq7Xn.anyUnpack)(val, registry);
        if (message) desc = registry.getMessage(message.$typeName);
    }
    if (!desc || !message) throw new Error(`cannot encode message ${val.$typeName} to JSON: "${val.typeUrl}" is not in the type registry`);
    let json = $a5e298f669082936$var$reflectToJson((0, $lItxZ.reflect)(desc, message), opts);
    if (desc.typeName.startsWith("google.protobuf.") || json === null || Array.isArray(json) || typeof json !== "object") json = {
        value: json
    };
    json["@type"] = val.typeUrl;
    return json;
}
function $a5e298f669082936$var$durationToJson(val) {
    if (Number(val.seconds) > 315576000000 || Number(val.seconds) < -315576000000) throw new Error(`cannot encode message ${val.$typeName} to JSON: value out of range`);
    let text = val.seconds.toString();
    if (val.nanos !== 0) {
        let nanosStr = Math.abs(val.nanos).toString();
        nanosStr = "0".repeat(9 - nanosStr.length) + nanosStr;
        if (nanosStr.substring(3) === "000000") nanosStr = nanosStr.substring(0, 3);
        else if (nanosStr.substring(6) === "000") nanosStr = nanosStr.substring(0, 6);
        text += "." + nanosStr;
        if (val.nanos < 0 && Number(val.seconds) == 0) text = "-" + text;
    }
    return text + "s";
}
function $a5e298f669082936$var$fieldMaskToJson(val) {
    return val.paths.map((p)=>{
        if (p.match(/_[0-9]?_/g) || p.match(/[A-Z]/g)) throw new Error(`cannot encode message ${val.$typeName} to JSON: lowerCamelCase of path name "` + p + '" is irreversible');
        return (0, $kLINC.protoCamelCase)(p);
    }).join(",");
}
function $a5e298f669082936$var$structToJson(val) {
    const json = {};
    for (const [k, v] of Object.entries(val.fields))json[k] = $a5e298f669082936$var$valueToJson(v);
    return json;
}
function $a5e298f669082936$var$valueToJson(val) {
    switch(val.kind.case){
        case "nullValue":
            return null;
        case "numberValue":
            if (!Number.isFinite(val.kind.value)) throw new Error(`${val.$typeName} cannot be NaN or Infinity`);
            return val.kind.value;
        case "boolValue":
            return val.kind.value;
        case "stringValue":
            return val.kind.value;
        case "structValue":
            return $a5e298f669082936$var$structToJson(val.kind.value);
        case "listValue":
            return $a5e298f669082936$var$listValueToJson(val.kind.value);
        default:
            throw new Error(`${val.$typeName} must have a value`);
    }
}
function $a5e298f669082936$var$listValueToJson(val) {
    return val.values.map($a5e298f669082936$var$valueToJson);
}
function $a5e298f669082936$var$timestampToJson(val) {
    const ms = Number(val.seconds) * 1000;
    if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z")) throw new Error(`cannot encode message ${val.$typeName} to JSON: must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive`);
    if (val.nanos < 0) throw new Error(`cannot encode message ${val.$typeName} to JSON: nanos must not be negative`);
    let z = "Z";
    if (val.nanos > 0) {
        const nanosStr = (val.nanos + 1000000000).toString().substring(1);
        if (nanosStr.substring(3) === "000000") z = "." + nanosStr.substring(0, 3) + "Z";
        else if (nanosStr.substring(6) === "000") z = "." + nanosStr.substring(0, 6) + "Z";
        else z = "." + nanosStr + "Z";
    }
    return new Date(ms).toISOString().replace(".000Z", z);
}

});

parcelRegister("1WJ2v", function(module, exports) {

$parcel$export(module.exports, "assertWriteMaxBytes", () => $16ae251e42b68c71$export$8b47620a939d9db4);
$parcel$export(module.exports, "assertReadMaxBytes", () => $16ae251e42b68c71$export$e8c2f5dabca09b46);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
/**
 * At most, allow ~4GiB to be received or sent per message.
 * zlib used by Node.js caps maxOutputLength at this value. It also happens to
 * be the maximum theoretical message size supported by protobuf-es.
 */ const $16ae251e42b68c71$var$maxReadMaxBytes = 0xffffffff;
const $16ae251e42b68c71$var$maxWriteMaxBytes = $16ae251e42b68c71$var$maxReadMaxBytes;
/**
 * The default value for the compressMinBytes option. The CPU cost of compressing
 * very small messages usually isn't worth the small reduction in network I/O, so
 * the default value is 1 kibibyte.
 */ const $16ae251e42b68c71$var$defaultCompressMinBytes = 1024;
function $16ae251e42b68c71$export$b8155e84974d618b(readMaxBytes, writeMaxBytes, compressMinBytes) {
    writeMaxBytes !== null && writeMaxBytes !== void 0 ? writeMaxBytes : writeMaxBytes = $16ae251e42b68c71$var$maxWriteMaxBytes;
    readMaxBytes !== null && readMaxBytes !== void 0 ? readMaxBytes : readMaxBytes = $16ae251e42b68c71$var$maxReadMaxBytes;
    compressMinBytes !== null && compressMinBytes !== void 0 ? compressMinBytes : compressMinBytes = $16ae251e42b68c71$var$defaultCompressMinBytes;
    if (writeMaxBytes < 1 || writeMaxBytes > $16ae251e42b68c71$var$maxWriteMaxBytes) throw new (0, $4tXo7.ConnectError)(`writeMaxBytes ${writeMaxBytes} must be >= 1 and <= ${$16ae251e42b68c71$var$maxWriteMaxBytes}`, (0, $lBjkW.Code).Internal);
    if (readMaxBytes < 1 || readMaxBytes > $16ae251e42b68c71$var$maxReadMaxBytes) throw new (0, $4tXo7.ConnectError)(`readMaxBytes ${readMaxBytes} must be >= 1 and <= ${$16ae251e42b68c71$var$maxReadMaxBytes}`, (0, $lBjkW.Code).Internal);
    return {
        readMaxBytes: readMaxBytes,
        writeMaxBytes: writeMaxBytes,
        compressMinBytes: compressMinBytes
    };
}
function $16ae251e42b68c71$export$8b47620a939d9db4(writeMaxBytes, bytesWritten) {
    if (bytesWritten > writeMaxBytes) throw new (0, $4tXo7.ConnectError)(`message size ${bytesWritten} is larger than configured writeMaxBytes ${writeMaxBytes}`, (0, $lBjkW.Code).ResourceExhausted);
}
function $16ae251e42b68c71$export$e8c2f5dabca09b46(readMaxBytes, bytesRead, totalSizeKnown = false) {
    if (bytesRead > readMaxBytes) {
        let message = `message size is larger than configured readMaxBytes ${readMaxBytes}`;
        if (totalSizeKnown) message = `message size ${bytesRead} is larger than configured readMaxBytes ${readMaxBytes}`;
        throw new (0, $4tXo7.ConnectError)(message, (0, $lBjkW.Code).ResourceExhausted);
    }
}

});


parcelRegister("1DjLH", function(module, exports) {

$parcel$export(module.exports, "createEnvelopeReadableStream", () => $1308c48ae62c3643$export$de7b77e3036937c3);
$parcel$export(module.exports, "envelopeCompress", () => $1308c48ae62c3643$export$fc7c007da56bf987);
$parcel$export(module.exports, "envelopeDecompress", () => $1308c48ae62c3643$export$a6d606fbcf5295a5);
$parcel$export(module.exports, "encodeEnvelope", () => $1308c48ae62c3643$export$b25bfe021e1535dc);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");

var $cQTV6 = parcelRequire("cQTV6");
function $1308c48ae62c3643$export$de7b77e3036937c3(stream) {
    let reader;
    let buffer = new Uint8Array(0);
    function append(chunk) {
        const n = new Uint8Array(buffer.length + chunk.length);
        n.set(buffer);
        n.set(chunk, buffer.length);
        buffer = n;
    }
    return new ReadableStream({
        start () {
            reader = stream.getReader();
        },
        async pull (controller) {
            let header = undefined;
            for(;;){
                if (header === undefined && buffer.byteLength >= 5) {
                    let length = 0;
                    for(let i = 1; i < 5; i++)length = (length << 8) + buffer[i];
                    header = {
                        flags: buffer[0],
                        length: length
                    };
                }
                if (header !== undefined && buffer.byteLength >= header.length + 5) break;
                const result = await reader.read();
                if (result.done) break;
                append(result.value);
            }
            if (header === undefined) {
                if (buffer.byteLength == 0) {
                    controller.close();
                    return;
                }
                controller.error(new (0, $4tXo7.ConnectError)("premature end of stream", (0, $lBjkW.Code).DataLoss));
                return;
            }
            const data = buffer.subarray(5, 5 + header.length);
            buffer = buffer.subarray(5 + header.length);
            controller.enqueue({
                flags: header.flags,
                data: data
            });
        }
    });
}
async function $1308c48ae62c3643$export$fc7c007da56bf987(envelope, compression, compressMinBytes) {
    let { flags: flags, data: data } = envelope;
    if ((flags & (0, $cQTV6.compressedFlag)) === (0, $cQTV6.compressedFlag)) throw new (0, $4tXo7.ConnectError)("invalid envelope, already compressed", (0, $lBjkW.Code).Internal);
    if (compression && data.byteLength >= compressMinBytes) {
        data = await compression.compress(data);
        flags = flags | (0, $cQTV6.compressedFlag);
    }
    return {
        data: data,
        flags: flags
    };
}
async function $1308c48ae62c3643$export$a6d606fbcf5295a5(envelope, compression, readMaxBytes) {
    let { flags: flags, data: data } = envelope;
    if ((flags & (0, $cQTV6.compressedFlag)) === (0, $cQTV6.compressedFlag)) {
        if (!compression) throw new (0, $4tXo7.ConnectError)("received compressed envelope, but do not know how to decompress", (0, $lBjkW.Code).Internal);
        data = await compression.decompress(data, readMaxBytes);
        flags = flags ^ (0, $cQTV6.compressedFlag);
    }
    return {
        data: data,
        flags: flags
    };
}
function $1308c48ae62c3643$export$b25bfe021e1535dc(flags, data) {
    const bytes = new Uint8Array(data.length + 5);
    bytes.set(data, 5);
    const v = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    v.setUint8(0, flags); // first byte is flags
    v.setUint32(1, data.length); // 4 bytes message length
    return bytes;
}
function $1308c48ae62c3643$export$487a48bf26bc2fde(...envelopes) {
    const len = envelopes.reduce((previousValue, currentValue)=>previousValue + currentValue.data.length + 5, 0);
    const bytes = new Uint8Array(len);
    const v = new DataView(bytes.buffer);
    let offset = 0;
    for (const e of envelopes){
        v.setUint8(offset, e.flags); // first byte is flags
        v.setUint32(offset + 1, e.data.length); // 4 bytes message length
        bytes.set(e.data, offset + 5);
        offset += e.data.length + 5;
    }
    return bytes;
}

});

parcelRegister("ffts0", function(module, exports) {

$parcel$export(module.exports, "createMethodUrl", () => $b19f1a0aa1c1ec7f$export$7adad25fc67d2110);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create a URL for the given RPC. This simply adds the qualified
 * service name, a slash, and the method name to the path of the given
 * baseUrl.
 *
 * For example, the baseUri https://example.com and method "Say" from
 * the service example.ElizaService results in:
 * https://example.com/example.ElizaService/Say
 *
 * This format is used by the protocols Connect, gRPC and Twirp.
 *
 * Note that this function also accepts a protocol-relative baseUrl.
 * If given an empty string or "/" as a baseUrl, it returns just the
 * path.
 */ function $b19f1a0aa1c1ec7f$export$7adad25fc67d2110(baseUrl, method) {
    return baseUrl.toString().replace(/\/?$/, `/${method.parent.typeName}/${method.name}`);
}

});

parcelRegister("hUotL", function(module, exports) {

$parcel$export(module.exports, "runUnaryCall", () => $d09aa7a62c41f31f$export$1dd0a60ae825098d);
$parcel$export(module.exports, "runStreamingCall", () => $d09aa7a62c41f31f$export$f4c80b19dca40a0b);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $6Doxt = parcelRequire("6Doxt");

var $4tXo7 = parcelRequire("4tXo7");

var $iNWww = parcelRequire("iNWww");

var $cj5j4 = parcelRequire("cj5j4");
function $d09aa7a62c41f31f$export$1dd0a60ae825098d(opt) {
    const next = (0, $6Doxt.applyInterceptors)(opt.next, opt.interceptors);
    const [signal, abort, done] = $d09aa7a62c41f31f$var$setupSignal(opt);
    const req = Object.assign(Object.assign({}, opt.req), {
        message: (0, $cj5j4.normalize)(opt.req.method.input, opt.req.message),
        signal: signal
    });
    return next(req).then((res)=>{
        done();
        return res;
    }, abort);
}
function $d09aa7a62c41f31f$export$f4c80b19dca40a0b(opt) {
    const next = (0, $6Doxt.applyInterceptors)(opt.next, opt.interceptors);
    const [signal, abort, done] = $d09aa7a62c41f31f$var$setupSignal(opt);
    const req = Object.assign(Object.assign({}, opt.req), {
        message: (0, $cj5j4.normalizeIterable)(opt.req.method.input, opt.req.message),
        signal: signal
    });
    let doneCalled = false;
    // Call return on the request iterable to indicate
    // that we will no longer consume it and it should
    // cleanup any allocated resources.
    signal.addEventListener("abort", function() {
        var _a, _b;
        const it = opt.req.message[Symbol.asyncIterator]();
        // If the signal is aborted due to an error, we want to throw
        // the error to the request iterator.
        if (!doneCalled) (_a = it.throw) === null || _a === void 0 || _a.call(it, this.reason).catch(()=>{
        // throw returns a promise, which we don't care about.
        //
        // Uncaught promises are thrown at sometime/somewhere by the event loop,
        // this is to ensure error is caught and ignored.
        });
        (_b = it.return) === null || _b === void 0 || _b.call(it).catch(()=>{
        // return returns a promise, which we don't care about.
        //
        // Uncaught promises are thrown at sometime/somewhere by the event loop,
        // this is to ensure error is caught and ignored.
        });
    });
    return next(req).then((res)=>{
        return Object.assign(Object.assign({}, res), {
            message: {
                [Symbol.asyncIterator] () {
                    const it = res.message[Symbol.asyncIterator]();
                    return {
                        next () {
                            return it.next().then((r)=>{
                                if (r.done == true) {
                                    doneCalled = true;
                                    done();
                                }
                                return r;
                            }, abort);
                        }
                    };
                }
            }
        });
    }, abort);
}
/**
 * Create an AbortSignal for Transport implementations. The signal is available
 * in UnaryRequest and StreamingRequest, and is triggered when the call is
 * aborted (via a timeout or explicit cancellation), errored (e.g. when reading
 * an error from the server from the wire), or finished successfully.
 *
 * Transport implementations can pass the signal to HTTP clients to ensure that
 * there are no unused connections leak.
 *
 * Returns a tuple:
 * [0]: The signal, which is also aborted if the optional deadline is reached.
 * [1]: Function to call if the Transport encountered an error.
 * [2]: Function to call if the Transport finished without an error.
 */ function $d09aa7a62c41f31f$var$setupSignal(opt) {
    const { signal: signal, cleanup: cleanup } = (0, $iNWww.createDeadlineSignal)(opt.timeoutMs);
    const controller = (0, $iNWww.createLinkedAbortController)(opt.signal, signal);
    return [
        controller.signal,
        function abort(reason) {
            // We peek at the deadline signal because fetch() will throw an error on
            // abort that discards the signal reason.
            const e = (0, $4tXo7.ConnectError).from(signal.aborted ? (0, $iNWww.getAbortSignalReason)(signal) : reason);
            controller.abort(e);
            cleanup();
            return Promise.reject(e);
        },
        function done() {
            cleanup();
            controller.abort();
        }
    ];
}

});
parcelRegister("6Doxt", function(module, exports) {

$parcel$export(module.exports, "applyInterceptors", () => $4d496b886ab7980b$export$dba8a657bef90160);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * applyInterceptors takes the given UnaryFn or ServerStreamingFn, and wraps
 * it with each of the given interceptors, returning a new UnaryFn or
 * ServerStreamingFn.
 */ function $4d496b886ab7980b$export$dba8a657bef90160(next, interceptors) {
    var _a;
    return (_a = interceptors === null || interceptors === void 0 ? void 0 : interceptors.concat().reverse().reduce(// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    (n, i)=>i(n), next)) !== null && _a !== void 0 ? _a : next;
}

});

parcelRegister("iNWww", function(module, exports) {

$parcel$export(module.exports, "createLinkedAbortController", () => $db0a3322a98a61f3$export$381d0f359258a299);
$parcel$export(module.exports, "getAbortSignalReason", () => $db0a3322a98a61f3$export$c2799c9b533f1602);
$parcel$export(module.exports, "createDeadlineSignal", () => $db0a3322a98a61f3$export$ca444e2769898ba3);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
function $db0a3322a98a61f3$export$381d0f359258a299(...signals) {
    const controller = new AbortController();
    const sa = signals.filter((s)=>s !== undefined).concat(controller.signal);
    for (const signal of sa){
        if (signal.aborted) {
            onAbort.apply(signal);
            break;
        }
        signal.addEventListener("abort", onAbort);
    }
    function onAbort() {
        if (!controller.signal.aborted) controller.abort($db0a3322a98a61f3$export$c2799c9b533f1602(this));
        for (const signal of sa)signal.removeEventListener("abort", onAbort);
    }
    return controller;
}
function $db0a3322a98a61f3$export$ca444e2769898ba3(timeoutMs) {
    const controller = new AbortController();
    const listener = ()=>{
        controller.abort(new (0, $4tXo7.ConnectError)("the operation timed out", (0, $lBjkW.Code).DeadlineExceeded));
    };
    let timeoutId;
    if (timeoutMs !== undefined) {
        if (timeoutMs <= 0) listener();
        else timeoutId = setTimeout(listener, timeoutMs);
    }
    return {
        signal: controller.signal,
        cleanup: ()=>clearTimeout(timeoutId)
    };
}
function $db0a3322a98a61f3$export$c2799c9b533f1602(signal) {
    if (!signal.aborted) return undefined;
    if (signal.reason !== undefined) return signal.reason;
    // AbortSignal.reason is available in Node.js v16, v18, and later,
    // and in all browsers since early 2022.
    const e = new Error("This operation was aborted");
    e.name = "AbortError";
    return e;
}

});

parcelRegister("cj5j4", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $8f5b60269b3b5b39$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeIterable", () => $8f5b60269b3b5b39$export$7f56037808bbaa16);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $1jDsz = parcelRequire("1jDsz");
function $8f5b60269b3b5b39$export$a3295358bff77e(desc, message) {
    return (0, $1jDsz.create)(desc, message);
}
function $8f5b60269b3b5b39$export$7f56037808bbaa16(desc, input) {
    function transform(result) {
        if (result.done === true) return result;
        return {
            done: result.done,
            value: $8f5b60269b3b5b39$export$a3295358bff77e(desc, result.value)
        };
    }
    return {
        [Symbol.asyncIterator] () {
            const it = input[Symbol.asyncIterator]();
            const res = {
                next: ()=>it.next().then(transform)
            };
            if (it.throw !== undefined) res.throw = (e)=>it.throw(e).then(transform); // eslint-disable-line @typescript-eslint/no-non-null-assertion
            if (it.return !== undefined) res.return = (v)=>it.return(v).then(transform); // eslint-disable-line @typescript-eslint/no-non-null-assertion
            return res;
        }
    };
}

});


parcelRegister("5L9d9", function(module, exports) {

$parcel$export(module.exports, "endStreamFlag", () => $43187caed519047d$export$6da97d6998a9e211);
$parcel$export(module.exports, "endStreamFromJson", () => $43187caed519047d$export$c3d1ba378b73b451);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $bcquV = parcelRequire("bcquV");

var $7BsIG = parcelRequire("7BsIG");

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
const $43187caed519047d$export$6da97d6998a9e211 = 2;
function $43187caed519047d$export$c3d1ba378b73b451(data) {
    const parseErr = new (0, $4tXo7.ConnectError)("invalid end stream", (0, $lBjkW.Code).Unknown);
    let jsonValue;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        jsonValue = JSON.parse(typeof data == "string" ? data : new TextDecoder().decode(data));
    } catch (e) {
        throw parseErr;
    }
    if (typeof jsonValue != "object" || jsonValue == null || Array.isArray(jsonValue)) throw parseErr;
    const metadata = new Headers();
    if ("metadata" in jsonValue) {
        if (typeof jsonValue.metadata != "object" || jsonValue.metadata == null || Array.isArray(jsonValue.metadata)) throw parseErr;
        for (const [key, values] of Object.entries(jsonValue.metadata)){
            if (!Array.isArray(values) || values.some((value)=>typeof value != "string")) throw parseErr;
            for (const value of values)metadata.append(key, value);
        }
    }
    const error = "error" in jsonValue && jsonValue.error != null ? (0, $bcquV.errorFromJson)(jsonValue.error, metadata, parseErr) : undefined;
    return {
        metadata: metadata,
        error: error
    };
}
function $43187caed519047d$export$c2c7cc561b1410f0(metadata, error, jsonWriteOptions) {
    const es = {};
    if (error !== undefined) {
        es.error = (0, $bcquV.errorToJson)(error, jsonWriteOptions);
        metadata = (0, $7BsIG.appendHeaders)(metadata, error.metadata);
    }
    let hasMetadata = false;
    const md = {};
    metadata.forEach((value, key)=>{
        hasMetadata = true;
        md[key] = [
            value
        ];
    });
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (hasMetadata) es.metadata = md;
    return es;
}
function $43187caed519047d$export$cc55f427b11ae8f3(options) {
    const textEncoder = new TextEncoder();
    return {
        serialize (data) {
            try {
                const jsonObject = $43187caed519047d$export$c2c7cc561b1410f0(data.metadata, data.error, options);
                const jsonString = JSON.stringify(jsonObject);
                return textEncoder.encode(jsonString);
            } catch (e) {
                const m = e instanceof Error ? e.message : String(e);
                throw new (0, $4tXo7.ConnectError)(`failed to serialize EndStreamResponse: ${m}`, (0, $lBjkW.Code).Internal);
            }
        },
        parse (data) {
            try {
                return $43187caed519047d$export$c3d1ba378b73b451(data);
            } catch (e) {
                const m = e instanceof Error ? e.message : String(e);
                throw new (0, $4tXo7.ConnectError)(`failed to parse EndStreamResponse: ${m}`, (0, $lBjkW.Code).InvalidArgument);
            }
        }
    };
}

});
parcelRegister("bcquV", function(module, exports) {

$parcel$export(module.exports, "errorFromJson", () => $82755ea124121b1c$export$2108b2c0b36b344f);
$parcel$export(module.exports, "errorToJson", () => $82755ea124121b1c$export$c419154d62000846);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3xX2e = parcelRequire("3xX2e");

var $1jDsz = parcelRequire("1jDsz");
var $cQRoD = parcelRequire("cQRoD");
var $ef0ax = parcelRequire("ef0ax");

var $lBjkW = parcelRequire("lBjkW");

var $4tXo7 = parcelRequire("4tXo7");

var $kWRje = parcelRequire("kWRje");
var $82755ea124121b1c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $82755ea124121b1c$export$2108b2c0b36b344f(jsonValue, metadata, fallback) {
    var _a;
    if (metadata) new Headers(metadata).forEach((value, key)=>fallback.metadata.append(key, value));
    if (typeof jsonValue !== "object" || jsonValue == null || Array.isArray(jsonValue)) throw fallback;
    let code = fallback.code;
    if ("code" in jsonValue && typeof jsonValue.code === "string") code = (_a = (0, $kWRje.codeFromString)(jsonValue.code)) !== null && _a !== void 0 ? _a : code;
    const message = jsonValue.message;
    if (message != null && typeof message !== "string") throw fallback;
    const error = new (0, $4tXo7.ConnectError)(message !== null && message !== void 0 ? message : "", code, metadata);
    if ("details" in jsonValue && Array.isArray(jsonValue.details)) for (const detail of jsonValue.details){
        if (detail === null || typeof detail != "object" || Array.isArray(detail) || typeof detail.type != "string" || typeof detail.value != "string") throw fallback;
        try {
            error.details.push({
                type: detail.type,
                value: (0, $3xX2e.base64Decode)(detail.value),
                debug: detail.debug
            });
        } catch (e) {
            throw fallback;
        }
    }
    return error;
}
function $82755ea124121b1c$export$c411be527d18d0fe(bytes, metadata, fallback) {
    let jsonValue;
    try {
        jsonValue = JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) {
        throw fallback;
    }
    return $82755ea124121b1c$export$2108b2c0b36b344f(jsonValue, metadata, fallback);
}
function $82755ea124121b1c$export$c419154d62000846(error, jsonWriteOptions) {
    const o = {
        code: (0, $kWRje.codeToString)(error.code)
    };
    if (error.rawMessage.length > 0) o.message = error.rawMessage;
    if (error.details.length > 0) o.details = error.details.map((detail)=>{
        if ("desc" in detail) {
            const msg = (0, $1jDsz.create)(detail.desc, detail.value);
            const i = {
                type: detail.desc.typeName,
                value: (0, $cQRoD.toBinary)(detail.desc, msg)
            };
            try {
                i.debug = (0, $ef0ax.toJson)(detail.desc, msg, jsonWriteOptions);
            } catch (e) {
            // We deliberately ignore errors that may occur when serializing
            // a message to JSON (the message contains an Any).
            // The rationale is that we are only trying to provide optional
            // debug information.
            }
            return i;
        }
        return detail;
    }).map((_a)=>{
        var { value: value } = _a, rest = $82755ea124121b1c$var$__rest(_a, [
            "value"
        ]);
        return Object.assign(Object.assign({}, rest), {
            value: (0, $3xX2e.base64Encode)(value, "std_raw")
        });
    });
    return o;
}
function $82755ea124121b1c$export$88ce40a677ad90f0(error, jsonWriteOptions) {
    const textEncoder = new TextEncoder();
    try {
        const jsonObject = $82755ea124121b1c$export$c419154d62000846(error, jsonWriteOptions);
        const jsonString = JSON.stringify(jsonObject);
        return textEncoder.encode(jsonString);
    } catch (e) {
        const m = e instanceof Error ? e.message : String(e);
        throw new (0, $4tXo7.ConnectError)(`failed to serialize Connect Error: ${m}`, (0, $lBjkW.Code).Internal);
    }
}

});


parcelRegister("izpVM", function(module, exports) {

$parcel$export(module.exports, "requestHeader", () => $d84f9c38573bc7df$export$dc50b2f0f47d89b1);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3f1b4 = parcelRequire("3f1b4");

var $2wYpJ = parcelRequire("2wYpJ");

var $iT9aT = parcelRequire("iT9aT");
function $d84f9c38573bc7df$export$dc50b2f0f47d89b1(methodKind, useBinaryFormat, timeoutMs, userProvidedHeaders, setUserAgent) {
    const result = new Headers(userProvidedHeaders !== null && userProvidedHeaders !== void 0 ? userProvidedHeaders : {});
    if (timeoutMs !== undefined) result.set((0, $3f1b4.headerTimeout), `${timeoutMs}`);
    result.set((0, $3f1b4.headerContentType), methodKind == "unary" ? useBinaryFormat ? (0, $iT9aT.contentTypeUnaryProto) : (0, $iT9aT.contentTypeUnaryJson) : useBinaryFormat ? (0, $iT9aT.contentTypeStreamProto) : (0, $iT9aT.contentTypeStreamJson));
    result.set((0, $3f1b4.headerProtocolVersion), (0, $2wYpJ.protocolVersion));
    if (!result.has((0, $3f1b4.headerUserAgent)) && setUserAgent) // Note that we do not strictly comply with gRPC user agents.
    // We use "connect-es/1.2.3" where gRPC would use "grpc-es/1.2.3".
    // See https://github.com/grpc/grpc/blob/c462bb8d485fc1434ecfae438823ca8d14cf3154/doc/PROTOCOL-HTTP2.md#user-agents
    result.set((0, $3f1b4.headerUserAgent), "connect-es/2.0.2");
    return result;
}
function $d84f9c38573bc7df$export$b3f6b03154758c85(methodKind, useBinaryFormat, timeoutMs, userProvidedHeaders, acceptCompression, sendCompression, setUserAgent) {
    const result = $d84f9c38573bc7df$export$dc50b2f0f47d89b1(methodKind, useBinaryFormat, timeoutMs, userProvidedHeaders, setUserAgent);
    if (sendCompression != null) {
        const name = methodKind == "unary" ? (0, $3f1b4.headerUnaryEncoding) : (0, $3f1b4.headerStreamEncoding);
        result.set(name, sendCompression.name);
    }
    if (acceptCompression.length > 0) {
        const name = methodKind == "unary" ? (0, $3f1b4.headerUnaryAcceptEncoding) : (0, $3f1b4.headerStreamAcceptEncoding);
        result.set(name, acceptCompression.map((c)=>c.name).join(","));
    }
    return result;
}

});
parcelRegister("3f1b4", function(module, exports) {

$parcel$export(module.exports, "headerContentType", () => $25c3afaad8cd31ba$export$488666a5ba4983da);
$parcel$export(module.exports, "headerUnaryContentLength", () => $25c3afaad8cd31ba$export$18ceef31cef175b1);
$parcel$export(module.exports, "headerUnaryEncoding", () => $25c3afaad8cd31ba$export$607974df7c82c00a);
$parcel$export(module.exports, "headerStreamEncoding", () => $25c3afaad8cd31ba$export$12e88ad19c94c6f3);
$parcel$export(module.exports, "headerUnaryAcceptEncoding", () => $25c3afaad8cd31ba$export$fd55288083ff7c0e);
$parcel$export(module.exports, "headerStreamAcceptEncoding", () => $25c3afaad8cd31ba$export$346c39874399d7ba);
$parcel$export(module.exports, "headerTimeout", () => $25c3afaad8cd31ba$export$9e27722251a824ed);
$parcel$export(module.exports, "headerProtocolVersion", () => $25c3afaad8cd31ba$export$af3e5cecfc39cd11);
$parcel$export(module.exports, "headerUserAgent", () => $25c3afaad8cd31ba$export$80e9ac7e97de04c3);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @private Internal code, does not follow semantic versioning.
 */ const $25c3afaad8cd31ba$export$488666a5ba4983da = "Content-Type";
const $25c3afaad8cd31ba$export$18ceef31cef175b1 = "Content-Length";
const $25c3afaad8cd31ba$export$607974df7c82c00a = "Content-Encoding";
const $25c3afaad8cd31ba$export$12e88ad19c94c6f3 = "Connect-Content-Encoding";
const $25c3afaad8cd31ba$export$fd55288083ff7c0e = "Accept-Encoding";
const $25c3afaad8cd31ba$export$346c39874399d7ba = "Connect-Accept-Encoding";
const $25c3afaad8cd31ba$export$9e27722251a824ed = "Connect-Timeout-Ms";
const $25c3afaad8cd31ba$export$af3e5cecfc39cd11 = "Connect-Protocol-Version";
const $25c3afaad8cd31ba$export$80e9ac7e97de04c3 = "User-Agent";

});

parcelRegister("2wYpJ", function(module, exports) {

$parcel$export(module.exports, "protocolVersion", () => $1d7d6ee306213230$export$94587fadffb515a1);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3f1b4 = parcelRequire("3f1b4");

var $72Zof = parcelRequire("72Zof");

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");
const $1d7d6ee306213230$export$94587fadffb515a1 = "1";
function $1d7d6ee306213230$export$fd3f6abf2230c2d5(requestHeader) {
    const v = requestHeader.get((0, $3f1b4.headerProtocolVersion));
    if (v === null) throw new (0, $4tXo7.ConnectError)(`missing required header: set ${(0, $3f1b4.headerProtocolVersion)} to "${$1d7d6ee306213230$export$94587fadffb515a1}"`, (0, $lBjkW.Code).InvalidArgument);
    else if (v !== $1d7d6ee306213230$export$94587fadffb515a1) throw new (0, $4tXo7.ConnectError)(`${(0, $3f1b4.headerProtocolVersion)} must be "${$1d7d6ee306213230$export$94587fadffb515a1}": got "${v}"`, (0, $lBjkW.Code).InvalidArgument);
}
function $1d7d6ee306213230$export$8ca19e88698426c8(queryParams) {
    const v = queryParams.get((0, $72Zof.paramConnectVersion));
    if (v === null) throw new (0, $4tXo7.ConnectError)(`missing required parameter: set ${(0, $72Zof.paramConnectVersion)} to "v${$1d7d6ee306213230$export$94587fadffb515a1}"`, (0, $lBjkW.Code).InvalidArgument);
    else if (v !== `v${$1d7d6ee306213230$export$94587fadffb515a1}`) throw new (0, $4tXo7.ConnectError)(`${(0, $72Zof.paramConnectVersion)} must be "v${$1d7d6ee306213230$export$94587fadffb515a1}": got "${v}"`, (0, $lBjkW.Code).InvalidArgument);
}

});
parcelRegister("72Zof", function(module, exports) {

$parcel$export(module.exports, "paramConnectVersion", () => $521857185300a183$export$ff8cc71e9b7b2f84);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @private Internal code, does not follow semantic versioning.
 */ const $521857185300a183$export$ff8cc71e9b7b2f84 = "connect";
const $521857185300a183$export$a2c2a616c9f2b0e = "encoding";
const $521857185300a183$export$f7c874ff478e317f = "compression";
const $521857185300a183$export$57d1c9b074393d70 = "base64";
const $521857185300a183$export$b9f36fbebfb7998b = "message";

});


parcelRegister("iT9aT", function(module, exports) {

$parcel$export(module.exports, "contentTypeUnaryProto", () => $dc047af7677e41dc$export$34ce50fe9478cf50);
$parcel$export(module.exports, "contentTypeUnaryJson", () => $dc047af7677e41dc$export$bfcb707159d25f8d);
$parcel$export(module.exports, "contentTypeStreamProto", () => $dc047af7677e41dc$export$5c0ee10217279a98);
$parcel$export(module.exports, "contentTypeStreamJson", () => $dc047af7677e41dc$export$a29962838a734c36);
$parcel$export(module.exports, "parseContentType", () => $dc047af7677e41dc$export$e001d06e78b9d402);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Regular Expression that matches any valid Connect Content-Type header value.
 *
 * @private Internal code, does not follow semantic versioning.
 */ const $dc047af7677e41dc$export$81bdbb873bd7a853 = /^application\/(connect\+)?(?:(json)(?:; ?charset=utf-?8)?|(proto))$/i;
const $dc047af7677e41dc$export$17268da75d70e5c3 = /^application\/(?:json(?:; ?charset=utf-?8)?|proto)$/i;
const $dc047af7677e41dc$export$6f10773f05f7ca1c = /^application\/connect\+?(?:json(?:; ?charset=utf-?8)?|proto)$/i;
const $dc047af7677e41dc$export$34ce50fe9478cf50 = "application/proto";
const $dc047af7677e41dc$export$bfcb707159d25f8d = "application/json";
const $dc047af7677e41dc$export$5c0ee10217279a98 = "application/connect+proto";
const $dc047af7677e41dc$export$a29962838a734c36 = "application/connect+json";
const $dc047af7677e41dc$var$encodingProto = "proto";
const $dc047af7677e41dc$var$encodingJson = "json";
function $dc047af7677e41dc$export$e001d06e78b9d402(contentType) {
    const match = contentType === null || contentType === void 0 ? void 0 : contentType.match($dc047af7677e41dc$export$81bdbb873bd7a853);
    if (!match) return undefined;
    const stream = !!match[1];
    const binary = !!match[3];
    return {
        stream: stream,
        binary: binary
    };
}
function $dc047af7677e41dc$export$3caaae07489b7824(encoding) {
    switch(encoding){
        case $dc047af7677e41dc$var$encodingProto:
            return {
                stream: false,
                binary: true
            };
        case $dc047af7677e41dc$var$encodingJson:
            return {
                stream: false,
                binary: false
            };
        default:
            return undefined;
    }
}

});


parcelRegister("77HR1", function(module, exports) {

$parcel$export(module.exports, "trailerDemux", () => $52fb345fcfc5c320$export$4c182fb46a3cddc3);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * In unary RPCs, Connect transports trailing metadata as response header
 * fields, prefixed with "trailer-".
 *
 * This function demuxes headers and trailers into two separate Headers
 * objects.
 *
 * @private Internal code, does not follow semantic versioning.
 */ function $52fb345fcfc5c320$export$4c182fb46a3cddc3(header) {
    const h = new Headers(), t = new Headers();
    header.forEach((value, key)=>{
        if (key.toLowerCase().startsWith("trailer-")) t.append(key.substring(8), value);
        else h.append(key, value);
    });
    return [
        h,
        t
    ];
}
function $52fb345fcfc5c320$export$fc1a98d7c6cf2223(header, trailer) {
    const h = new Headers(header);
    trailer.forEach((value, key)=>{
        h.append(`trailer-${key}`, value);
    });
    return h;
}

});

parcelRegister("dv2Oz", function(module, exports) {

$parcel$export(module.exports, "transformConnectPostToGetRequest", () => $9d405a8f6cb16a68$export$2dc995e9b9370563);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $3xX2e = parcelRequire("3xX2e");

var $3f1b4 = parcelRequire("3f1b4");

var $2wYpJ = parcelRequire("2wYpJ");
const $9d405a8f6cb16a68$var$contentTypePrefix = "application/";
function $9d405a8f6cb16a68$var$encodeMessageForUrl(message, useBase64) {
    if (useBase64) return (0, $3xX2e.base64Encode)(message, "url");
    else return encodeURIComponent(new TextDecoder().decode(message));
}
function $9d405a8f6cb16a68$export$2dc995e9b9370563(request, message, useBase64) {
    let query = `?connect=v${(0, $2wYpJ.protocolVersion)}`;
    const contentType = request.header.get((0, $3f1b4.headerContentType));
    if ((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf($9d405a8f6cb16a68$var$contentTypePrefix)) === 0) query += "&encoding=" + encodeURIComponent(contentType.slice($9d405a8f6cb16a68$var$contentTypePrefix.length));
    const compression = request.header.get((0, $3f1b4.headerUnaryEncoding));
    if (compression !== null && compression !== "identity") {
        query += "&compression=" + encodeURIComponent(compression);
        // Force base64 for compressed payloads.
        useBase64 = true;
    }
    if (useBase64) query += "&base64=1";
    query += "&message=" + $9d405a8f6cb16a68$var$encodeMessageForUrl(message, useBase64);
    const url = request.url + query;
    // Omit headers that are not used for unary GET requests.
    const header = new Headers(request.header);
    [
        (0, $3f1b4.headerProtocolVersion),
        (0, $3f1b4.headerContentType),
        (0, $3f1b4.headerUnaryContentLength),
        (0, $3f1b4.headerUnaryEncoding),
        (0, $3f1b4.headerUnaryAcceptEncoding)
    ].forEach((h)=>header.delete(h));
    return Object.assign(Object.assign({}, request), {
        requestMethod: "GET",
        url: url,
        header: header
    });
}

});

parcelRegister("667KG", function(module, exports) {

$parcel$export(module.exports, "validateResponse", () => $470950ffb13a58fc$export$fcee8a88e10e2f31);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lBjkW = parcelRequire("lBjkW");

var $k94rK = parcelRequire("k94rK");

var $4tXo7 = parcelRequire("4tXo7");

var $iT9aT = parcelRequire("iT9aT");

var $3f1b4 = parcelRequire("3f1b4");
function $470950ffb13a58fc$export$fcee8a88e10e2f31(methodKind, useBinaryFormat, status, headers) {
    const mimeType = headers.get((0, $3f1b4.headerContentType));
    const parsedType = (0, $iT9aT.parseContentType)(mimeType);
    if (status !== 200) {
        const errorFromStatus = new (0, $4tXo7.ConnectError)(`HTTP ${status}`, (0, $k94rK.codeFromHttpStatus)(status), headers);
        // If parsedType is defined and it is not binary, then this is a unary JSON response
        if (methodKind == "unary" && parsedType && !parsedType.binary) return {
            isUnaryError: true,
            unaryError: errorFromStatus
        };
        throw errorFromStatus;
    }
    const allowedContentType = {
        binary: useBinaryFormat,
        stream: methodKind !== "unary"
    };
    if ((parsedType === null || parsedType === void 0 ? void 0 : parsedType.binary) !== allowedContentType.binary || parsedType.stream !== allowedContentType.stream) throw new (0, $4tXo7.ConnectError)(`unsupported content type ${mimeType}`, parsedType === undefined ? (0, $lBjkW.Code).Unknown : (0, $lBjkW.Code).Internal, headers);
    return {
        isUnaryError: false
    };
}
function $470950ffb13a58fc$export$10be7aa23f81a2b3(methodKind, acceptCompression, useBinaryFormat, status, headers) {
    let compression;
    const encoding = headers.get(methodKind == "unary" ? (0, $3f1b4.headerUnaryEncoding) : (0, $3f1b4.headerStreamEncoding));
    if (encoding != null && encoding.toLowerCase() !== "identity") {
        compression = acceptCompression.find((c)=>c.name === encoding);
        if (!compression) throw new (0, $4tXo7.ConnectError)(`unsupported response encoding "${encoding}"`, (0, $lBjkW.Code).Internal, headers);
    }
    return Object.assign({
        compression: compression
    }, $470950ffb13a58fc$export$fcee8a88e10e2f31(methodKind, useBinaryFormat, status, headers));
}

});
parcelRegister("k94rK", function(module, exports) {

$parcel$export(module.exports, "codeFromHttpStatus", () => $eaa818e41fa41b33$export$94bd4cbfb56db553);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lBjkW = parcelRequire("lBjkW");
function $eaa818e41fa41b33$export$94bd4cbfb56db553(httpStatus) {
    switch(httpStatus){
        case 400:
            return (0, $lBjkW.Code).Internal;
        case 401:
            return (0, $lBjkW.Code).Unauthenticated;
        case 403:
            return (0, $lBjkW.Code).PermissionDenied;
        case 404:
            return (0, $lBjkW.Code).Unimplemented;
        case 429:
            return (0, $lBjkW.Code).Unavailable;
        case 502:
            return (0, $lBjkW.Code).Unavailable;
        case 503:
            return (0, $lBjkW.Code).Unavailable;
        case 504:
            return (0, $lBjkW.Code).Unavailable;
        default:
            return (0, $lBjkW.Code).Unknown;
    }
}
function $eaa818e41fa41b33$export$176a4e27b85d4f65(code) {
    switch(code){
        case (0, $lBjkW.Code).Canceled:
            return 499; // Client Closed Request
        case (0, $lBjkW.Code).Unknown:
            return 500; // Internal Server Error
        case (0, $lBjkW.Code).InvalidArgument:
            return 400; // Bad Request
        case (0, $lBjkW.Code).DeadlineExceeded:
            return 504; // Gateway Timeout
        case (0, $lBjkW.Code).NotFound:
            return 404; // Not Found
        case (0, $lBjkW.Code).AlreadyExists:
            return 409; // Conflict
        case (0, $lBjkW.Code).PermissionDenied:
            return 403; // Forbidden
        case (0, $lBjkW.Code).ResourceExhausted:
            return 429; // Too Many Requests
        case (0, $lBjkW.Code).FailedPrecondition:
            return 400; // Bad Request
        case (0, $lBjkW.Code).Aborted:
            return 409; // Conflict
        case (0, $lBjkW.Code).OutOfRange:
            return 400; // Bad Request
        case (0, $lBjkW.Code).Unimplemented:
            return 501; // Not Implemented
        case (0, $lBjkW.Code).Internal:
            return 500; // Internal Server Error
        case (0, $lBjkW.Code).Unavailable:
            return 503; // Service Unavailable
        case (0, $lBjkW.Code).DataLoss:
            return 500; // Internal Server Error
        case (0, $lBjkW.Code).Unauthenticated:
            return 401; // Unauthorized
        default:
            return 500; // same as CodeUnknown
    }
}

});


parcelRegister("DwjgK", function(module, exports) {

$parcel$export(module.exports, "assertFetchApi", () => $076cb4af4cf9093a$export$f2f1a89362e2e441);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Asserts that the fetch API is available.
 */ function $076cb4af4cf9093a$export$f2f1a89362e2e441() {
    try {
        new Headers();
    } catch (_) {
        throw new Error("connect-web requires the fetch API. Are you running on an old version of Node.js? Node.js is not supported in Connect for Web - please stay tuned for Connect for Node.");
    }
}

});


parcelRegister("irvbz", function(module, exports) {

$parcel$export(module.exports, "createClient", () => $d6d2f07309a9ee04$export$5d730b7aed1a3eb0);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $73PuX = parcelRequire("73PuX");

var $4tXo7 = parcelRequire("4tXo7");

var $lBjkW = parcelRequire("lBjkW");

var $aQtRW = parcelRequire("aQtRW");
var $d6d2f07309a9ee04$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $d6d2f07309a9ee04$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $d6d2f07309a9ee04$var$__await ? (this.v = v, this) : new $d6d2f07309a9ee04$var$__await(v);
};
var $d6d2f07309a9ee04$var$__asyncDelegator = undefined && undefined.__asyncDelegator || function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d6d2f07309a9ee04$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $d6d2f07309a9ee04$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d6d2f07309a9ee04$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $d6d2f07309a9ee04$export$5d730b7aed1a3eb0(service, transport) {
    return (0, $73PuX.makeAnyClient)(service, (method)=>{
        switch(method.methodKind){
            case "unary":
                return $d6d2f07309a9ee04$export$ef7d0634269f2d6a(transport, method);
            case "server_streaming":
                return $d6d2f07309a9ee04$export$2ca66f1526f4fb9b(transport, method);
            case "client_streaming":
                return $d6d2f07309a9ee04$export$e9b6dd703acc1bd5(transport, method);
            case "bidi_streaming":
                return $d6d2f07309a9ee04$export$6f76c1ce326fd8e5(transport, method);
            default:
                return null;
        }
    });
}
function $d6d2f07309a9ee04$export$ef7d0634269f2d6a(transport, method) {
    return async function(input, options) {
        var _a, _b;
        const response = await transport.unary(method, options === null || options === void 0 ? void 0 : options.signal, options === null || options === void 0 ? void 0 : options.timeoutMs, options === null || options === void 0 ? void 0 : options.headers, input, options === null || options === void 0 ? void 0 : options.contextValues);
        (_a = options === null || options === void 0 ? void 0 : options.onHeader) === null || _a === void 0 || _a.call(options, response.header);
        (_b = options === null || options === void 0 ? void 0 : options.onTrailer) === null || _b === void 0 || _b.call(options, response.trailer);
        return response.message;
    };
}
function $d6d2f07309a9ee04$export$2ca66f1526f4fb9b(transport, method) {
    return function(input, options) {
        return $d6d2f07309a9ee04$var$handleStreamResponse(transport.stream(method, options === null || options === void 0 ? void 0 : options.signal, options === null || options === void 0 ? void 0 : options.timeoutMs, options === null || options === void 0 ? void 0 : options.headers, (0, $aQtRW.createAsyncIterable)([
            input
        ]), options === null || options === void 0 ? void 0 : options.contextValues), options);
    };
}
function $d6d2f07309a9ee04$export$e9b6dd703acc1bd5(transport, method) {
    return async function(request, options) {
        var _a, e_1, _b, _c;
        var _d, _e;
        const response = await transport.stream(method, options === null || options === void 0 ? void 0 : options.signal, options === null || options === void 0 ? void 0 : options.timeoutMs, options === null || options === void 0 ? void 0 : options.headers, request, options === null || options === void 0 ? void 0 : options.contextValues);
        (_d = options === null || options === void 0 ? void 0 : options.onHeader) === null || _d === void 0 || _d.call(options, response.header);
        let singleMessage;
        let count = 0;
        try {
            for(var _f = true, _g = $d6d2f07309a9ee04$var$__asyncValues(response.message), _h; _h = await _g.next(), _a = _h.done, !_a; _f = true){
                _c = _h.value;
                _f = false;
                const message = _c;
                singleMessage = message;
                count++;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_f && !_a && (_b = _g.return)) await _b.call(_g);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (!singleMessage) throw new (0, $4tXo7.ConnectError)("protocol error: missing response message", (0, $lBjkW.Code).Unimplemented);
        if (count > 1) throw new (0, $4tXo7.ConnectError)("protocol error: received extra messages for client streaming method", (0, $lBjkW.Code).Unimplemented);
        (_e = options === null || options === void 0 ? void 0 : options.onTrailer) === null || _e === void 0 || _e.call(options, response.trailer);
        return singleMessage;
    };
}
function $d6d2f07309a9ee04$export$6f76c1ce326fd8e5(transport, method) {
    return function(request, options) {
        return $d6d2f07309a9ee04$var$handleStreamResponse(transport.stream(method, options === null || options === void 0 ? void 0 : options.signal, options === null || options === void 0 ? void 0 : options.timeoutMs, options === null || options === void 0 ? void 0 : options.headers, request, options === null || options === void 0 ? void 0 : options.contextValues), options);
    };
}
function $d6d2f07309a9ee04$var$handleStreamResponse(stream, options) {
    const it = (function() {
        return $d6d2f07309a9ee04$var$__asyncGenerator(this, arguments, function*() {
            var _a, _b;
            const response = yield $d6d2f07309a9ee04$var$__await(stream);
            (_a = options === null || options === void 0 ? void 0 : options.onHeader) === null || _a === void 0 || _a.call(options, response.header);
            yield $d6d2f07309a9ee04$var$__await((yield* $d6d2f07309a9ee04$var$__asyncDelegator($d6d2f07309a9ee04$var$__asyncValues(response.message))));
            (_b = options === null || options === void 0 ? void 0 : options.onTrailer) === null || _b === void 0 || _b.call(options, response.trailer);
        });
    })()[Symbol.asyncIterator]();
    // Create a new iterable to omit throw/return.
    return {
        [Symbol.asyncIterator]: ()=>({
                next: ()=>it.next()
            })
    };
}

});
parcelRegister("73PuX", function(module, exports) {

$parcel$export(module.exports, "makeAnyClient", () => $5240c2af197d2aa5$export$2552993fc101780);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Create any client for the given service.
 *
 * The given createMethod function is called for each method definition
 * of the service. The function it returns is added to the client object
 * as a method.
 */ function $5240c2af197d2aa5$export$2552993fc101780(service, createMethod) {
    const client = {};
    for (const desc of service.methods){
        const method = createMethod(desc);
        if (method != null) client[desc.localName] = method;
    }
    return client;
}

});

parcelRegister("aQtRW", function(module, exports) {

$parcel$export(module.exports, "createAsyncIterable", () => $7e55ee1178c50e80$export$9b9eb69fad02e04e);
// Copyright 2021-2025 The Connect Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $lBjkW = parcelRequire("lBjkW");

var $4tXo7 = parcelRequire("4tXo7");

var $1DjLH = parcelRequire("1DjLH");

var $1WJ2v = parcelRequire("1WJ2v");
var $7e55ee1178c50e80$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $7e55ee1178c50e80$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $7e55ee1178c50e80$var$__await ? (this.v = v, this) : new $7e55ee1178c50e80$var$__await(v);
};
var $7e55ee1178c50e80$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7e55ee1178c50e80$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $7e55ee1178c50e80$var$__asyncDelegator = undefined && undefined.__asyncDelegator || function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7e55ee1178c50e80$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
function $7e55ee1178c50e80$export$87fc01f6c0d9c71d(source, ...rest) {
    const [transforms, sink, opt] = $7e55ee1178c50e80$var$pickTransformsAndSink(rest);
    let iterable = source;
    let abortable;
    if ((opt === null || opt === void 0 ? void 0 : opt.propagateDownStreamError) === true) iterable = abortable = $7e55ee1178c50e80$export$a0ef0c9354bb3f0a(iterable);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    iterable = $7e55ee1178c50e80$export$a4627e546088548d(iterable, ...transforms, {
        propagateDownStreamError: false
    });
    return sink(iterable).catch((reason)=>{
        if (abortable) return abortable.abort(reason).then(()=>Promise.reject(reason));
        return Promise.reject(reason);
    });
}
// pick transforms, the sink, and options from the pipeTo() rest parameter
function $7e55ee1178c50e80$var$pickTransformsAndSink(rest) {
    let opt;
    if (typeof rest[rest.length - 1] != "function") opt = rest.pop();
    const sink = rest.pop();
    return [
        rest,
        sink,
        opt
    ];
}
function $7e55ee1178c50e80$export$1283d7b3b7e08786() {
    return async function(iterable) {
        var _a, e_1, _b, _c;
        const all = [];
        try {
            for(var _d = true, iterable_1 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_1_1; iterable_1_1 = await iterable_1.next(), _a = iterable_1_1.done, !_a; _d = true){
                _c = iterable_1_1.value;
                _d = false;
                const chunk = _c;
                all.push(chunk);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = iterable_1.return)) await _b.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return all;
    };
}
function $7e55ee1178c50e80$export$180f9274d81174a4(readMaxBytes, lengthHint) {
    return async function(iterable) {
        return await $7e55ee1178c50e80$export$7df450cc47ed77a1(iterable, readMaxBytes, lengthHint);
    };
}
function $7e55ee1178c50e80$export$a4627e546088548d(source, ...rest) {
    return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function* pipe_1() {
        var _a;
        const [transforms, opt] = $7e55ee1178c50e80$var$pickTransforms(rest);
        let abortable;
        const sourceIt = source[Symbol.asyncIterator]();
        const cachedSource = {
            [Symbol.asyncIterator] () {
                return sourceIt;
            }
        };
        let iterable = cachedSource;
        if ((opt === null || opt === void 0 ? void 0 : opt.propagateDownStreamError) === true) iterable = abortable = $7e55ee1178c50e80$export$a0ef0c9354bb3f0a(iterable);
        for (const t of transforms)iterable = t(iterable);
        const it = iterable[Symbol.asyncIterator]();
        try {
            for(;;){
                const r = yield $7e55ee1178c50e80$var$__await(it.next());
                if (r.done === true) break;
                if (!abortable) {
                    yield yield $7e55ee1178c50e80$var$__await(r.value);
                    continue;
                }
                try {
                    yield yield $7e55ee1178c50e80$var$__await(r.value);
                } catch (e) {
                    yield $7e55ee1178c50e80$var$__await(abortable.abort(e)); // propagate downstream error to the source
                    throw e;
                }
            }
        } finally{
            if ((opt === null || opt === void 0 ? void 0 : opt.propagateDownStreamError) === true) // Call return on the source iterable to indicate
            // that we will no longer consume it and it should
            // cleanup any allocated resources.
            (_a = sourceIt.return) === null || _a === void 0 || _a.call(sourceIt).catch(()=>{
            // return returns a promise, which we don't care about.
            //
            // Uncaught promises are thrown at sometime/somewhere by the event loop,
            // this is to ensure error is caught and ignored.
            });
        }
    });
}
function $7e55ee1178c50e80$var$pickTransforms(rest) {
    let opt;
    if (typeof rest[rest.length - 1] != "function") opt = rest.pop();
    return [
        rest,
        opt
    ];
}
function $7e55ee1178c50e80$export$f1d8cd4c5a45e9f4(catchError) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            // we deliberate avoid a for-await loop because we only want to catch upstream
            // errors, not downstream errors (yield).
            const it = iterable[Symbol.asyncIterator]();
            for(;;){
                let r;
                try {
                    r = yield $7e55ee1178c50e80$var$__await(it.next());
                } catch (e) {
                    const caught = yield $7e55ee1178c50e80$var$__await(catchError(e));
                    if (caught !== undefined) yield yield $7e55ee1178c50e80$var$__await(caught);
                    break;
                }
                if (r.done === true) break;
                yield yield $7e55ee1178c50e80$var$__await(r.value);
            }
        });
    };
}
function $7e55ee1178c50e80$export$c94807d11e178927(catchFinally) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            // we deliberate avoid a for-await loop because we only want to catch upstream
            // errors, not downstream errors (yield).
            let err;
            const it = iterable[Symbol.asyncIterator]();
            for(;;){
                let r;
                try {
                    r = yield $7e55ee1178c50e80$var$__await(it.next());
                } catch (e) {
                    err = e;
                    break;
                }
                if (r.done === true) break;
                yield yield $7e55ee1178c50e80$var$__await(r.value);
            }
            const caught = yield $7e55ee1178c50e80$var$__await(catchFinally(err));
            if (caught !== undefined) yield yield $7e55ee1178c50e80$var$__await(caught);
        });
    };
}
function $7e55ee1178c50e80$export$8c82fb9ceec82bfb(provide) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_2, _b, _c;
            try {
                for(var _d = true, iterable_2 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_2_1; iterable_2_1 = yield $7e55ee1178c50e80$var$__await(iterable_2.next()), _a = iterable_2_1.done, !_a; _d = true){
                    _c = iterable_2_1.value;
                    _d = false;
                    const chunk = _c;
                    yield yield $7e55ee1178c50e80$var$__await(chunk);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_2.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_2));
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            const append = yield $7e55ee1178c50e80$var$__await(provide());
            if (append !== undefined) yield yield $7e55ee1178c50e80$var$__await(append);
        });
    };
}
function $7e55ee1178c50e80$export$6a7928974a2b0edf(provide) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_3, _b, _c;
            const prepend = yield $7e55ee1178c50e80$var$__await(provide());
            if (prepend !== undefined) yield yield $7e55ee1178c50e80$var$__await(prepend);
            try {
                for(var _d = true, iterable_3 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_3_1; iterable_3_1 = yield $7e55ee1178c50e80$var$__await(iterable_3.next()), _a = iterable_3_1.done, !_a; _d = true){
                    _c = iterable_3_1.value;
                    _d = false;
                    const chunk = _c;
                    yield yield $7e55ee1178c50e80$var$__await(chunk);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_3.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_3));
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$777e38ff34c98496(readMaxBytes, lengthHint) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            yield yield $7e55ee1178c50e80$var$__await((yield $7e55ee1178c50e80$var$__await($7e55ee1178c50e80$export$7df450cc47ed77a1(iterable, readMaxBytes, lengthHint))));
        });
    };
}
function $7e55ee1178c50e80$export$a106d808a7f61035(serialization, endStreamFlag, endSerialization) {
    if (endStreamFlag === undefined || endSerialization === undefined) return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_4, _b, _c;
            try {
                for(var _d = true, iterable_4 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_4_1; iterable_4_1 = yield $7e55ee1178c50e80$var$__await(iterable_4.next()), _a = iterable_4_1.done, !_a; _d = true){
                    _c = iterable_4_1.value;
                    _d = false;
                    const chunk = _c;
                    const data = serialization.serialize(chunk);
                    yield yield $7e55ee1178c50e80$var$__await({
                        flags: 0,
                        data: data
                    });
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_4.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_4));
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
        });
    };
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_5, _b, _c;
            try {
                for(var _d = true, iterable_5 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_5_1; iterable_5_1 = yield $7e55ee1178c50e80$var$__await(iterable_5.next()), _a = iterable_5_1.done, !_a; _d = true){
                    _c = iterable_5_1.value;
                    _d = false;
                    const chunk = _c;
                    let data;
                    let flags = 0;
                    if (chunk.end) {
                        flags = flags | endStreamFlag;
                        data = endSerialization.serialize(chunk.value);
                    } else data = serialization.serialize(chunk.value);
                    yield yield $7e55ee1178c50e80$var$__await({
                        flags: flags,
                        data: data
                    });
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_5.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_5));
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$4b1b40fabef2051e(serialization, endStreamFlag, endSerialization) {
    // code path always yields ParsedEnvelopedMessage<T, E>
    if (endSerialization && endStreamFlag !== undefined) return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_6, _b, _c;
            try {
                for(var _d = true, iterable_6 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_6_1; iterable_6_1 = yield $7e55ee1178c50e80$var$__await(iterable_6.next()), _a = iterable_6_1.done, !_a; _d = true){
                    _c = iterable_6_1.value;
                    _d = false;
                    const { flags: flags, data: data } = _c;
                    if ((flags & endStreamFlag) === endStreamFlag) yield yield $7e55ee1178c50e80$var$__await({
                        value: endSerialization.parse(data),
                        end: true
                    });
                    else yield yield $7e55ee1178c50e80$var$__await({
                        value: serialization.parse(data),
                        end: false
                    });
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_6.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_6));
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
        });
    };
    // code path always yields T
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_7, _b, _c;
            try {
                for(var _d = true, iterable_7 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_7_1; iterable_7_1 = yield $7e55ee1178c50e80$var$__await(iterable_7.next()), _a = iterable_7_1.done, !_a; _d = true){
                    _c = iterable_7_1.value;
                    _d = false;
                    const { flags: flags, data: data } = _c;
                    if (endStreamFlag !== undefined && (flags & endStreamFlag) === endStreamFlag) {
                        if (endSerialization === null) throw new (0, $4tXo7.ConnectError)("unexpected end flag", (0, $lBjkW.Code).InvalidArgument);
                        continue;
                    }
                    yield yield $7e55ee1178c50e80$var$__await(serialization.parse(data));
                }
            } catch (e_7_1) {
                e_7 = {
                    error: e_7_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_7.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_7));
                } finally{
                    if (e_7) throw e_7.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$7f398bd34b8c96c3(compression, compressMinBytes) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_8, _b, _c;
            try {
                for(var _d = true, iterable_8 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_8_1; iterable_8_1 = yield $7e55ee1178c50e80$var$__await(iterable_8.next()), _a = iterable_8_1.done, !_a; _d = true){
                    _c = iterable_8_1.value;
                    _d = false;
                    const env = _c;
                    yield yield $7e55ee1178c50e80$var$__await((yield $7e55ee1178c50e80$var$__await((0, $1DjLH.envelopeCompress)(env, compression, compressMinBytes))));
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_8.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_8));
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$3f43345fb19ab82a(compression, readMaxBytes) {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_9, _b, _c;
            try {
                for(var _d = true, iterable_9 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_9_1; iterable_9_1 = yield $7e55ee1178c50e80$var$__await(iterable_9.next()), _a = iterable_9_1.done, !_a; _d = true){
                    _c = iterable_9_1.value;
                    _d = false;
                    const env = _c;
                    yield yield $7e55ee1178c50e80$var$__await((yield $7e55ee1178c50e80$var$__await((0, $1DjLH.envelopeDecompress)(env, compression, readMaxBytes))));
                }
            } catch (e_9_1) {
                e_9 = {
                    error: e_9_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_9.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_9));
                } finally{
                    if (e_9) throw e_9.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$43057badfce49443() {
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_10, _b, _c;
            try {
                for(var _d = true, iterable_10 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_10_1; iterable_10_1 = yield $7e55ee1178c50e80$var$__await(iterable_10.next()), _a = iterable_10_1.done, !_a; _d = true){
                    _c = iterable_10_1.value;
                    _d = false;
                    const { flags: flags, data: data } = _c;
                    yield yield $7e55ee1178c50e80$var$__await((0, $1DjLH.encodeEnvelope)(flags, data));
                }
            } catch (e_10_1) {
                e_10 = {
                    error: e_10_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_10.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_10));
                } finally{
                    if (e_10) throw e_10.error;
                }
            }
        });
    };
}
function $7e55ee1178c50e80$export$3b6a5f0fbdb386a6(readMaxBytes) {
    // append chunk to buffer, returning updated buffer
    function append(buffer, chunk) {
        const n = new Uint8Array(buffer.byteLength + chunk.byteLength);
        n.set(buffer);
        n.set(chunk, buffer.length);
        return n;
    }
    // tuple 0: envelope, or undefined if incomplete
    // tuple 1: remainder of the buffer
    function shiftEnvelope(buffer, header) {
        if (buffer.byteLength < 5 + header.length) return [
            undefined,
            buffer
        ];
        return [
            {
                flags: header.flags,
                data: buffer.subarray(5, 5 + header.length)
            },
            buffer.subarray(5 + header.length)
        ];
    }
    // undefined: header is incomplete
    function peekHeader(buffer) {
        if (buffer.byteLength < 5) return undefined;
        const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        const length = view.getUint32(1); // 4 bytes message length
        const flags = view.getUint8(0); // first byte is flags
        return {
            length: length,
            flags: flags
        };
    }
    return function(iterable) {
        return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function*() {
            var _a, e_11, _b, _c;
            let buffer = new Uint8Array(0);
            try {
                for(var _d = true, iterable_11 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_11_1; iterable_11_1 = yield $7e55ee1178c50e80$var$__await(iterable_11.next()), _a = iterable_11_1.done, !_a; _d = true){
                    _c = iterable_11_1.value;
                    _d = false;
                    const chunk = _c;
                    buffer = append(buffer, chunk);
                    for(;;){
                        const header = peekHeader(buffer);
                        if (!header) break;
                        (0, $1WJ2v.assertReadMaxBytes)(readMaxBytes, header.length, true);
                        let env;
                        [env, buffer] = shiftEnvelope(buffer, header);
                        if (!env) break;
                        yield yield $7e55ee1178c50e80$var$__await(env);
                    }
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (!_d && !_a && (_b = iterable_11.return)) yield $7e55ee1178c50e80$var$__await(_b.call(iterable_11));
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
            if (buffer.byteLength > 0) {
                const header = peekHeader(buffer);
                let message = "protocol error: incomplete envelope";
                if (header) message = `protocol error: promised ${header.length} bytes in enveloped message, got ${buffer.byteLength - 5} bytes`;
                throw new (0, $4tXo7.ConnectError)(message, (0, $lBjkW.Code).InvalidArgument);
            }
        });
    };
}
async function $7e55ee1178c50e80$export$7df450cc47ed77a1(iterable, readMaxBytes, lengthHint) {
    var _a, e_12, _b, _c, _d, e_13, _e, _f;
    const [ok, hint] = $7e55ee1178c50e80$var$parseLengthHint(lengthHint);
    if (ok) {
        if (hint > readMaxBytes) (0, $1WJ2v.assertReadMaxBytes)(readMaxBytes, hint, true);
        const buffer = new Uint8Array(hint);
        let offset = 0;
        try {
            for(var _g = true, iterable_12 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_12_1; iterable_12_1 = await iterable_12.next(), _a = iterable_12_1.done, !_a; _g = true){
                _c = iterable_12_1.value;
                _g = false;
                const chunk = _c;
                if (offset + chunk.byteLength > hint) throw new (0, $4tXo7.ConnectError)(`protocol error: promised ${hint} bytes, received ${offset + chunk.byteLength}`, (0, $lBjkW.Code).InvalidArgument);
                buffer.set(chunk, offset);
                offset += chunk.byteLength;
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (!_g && !_a && (_b = iterable_12.return)) await _b.call(iterable_12);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
        if (offset < hint) throw new (0, $4tXo7.ConnectError)(`protocol error: promised ${hint} bytes, received ${offset}`, (0, $lBjkW.Code).InvalidArgument);
        return buffer;
    }
    const chunks = [];
    let count = 0;
    try {
        for(var _h = true, iterable_13 = $7e55ee1178c50e80$var$__asyncValues(iterable), iterable_13_1; iterable_13_1 = await iterable_13.next(), _d = iterable_13_1.done, !_d; _h = true){
            _f = iterable_13_1.value;
            _h = false;
            const chunk = _f;
            count += chunk.byteLength;
            (0, $1WJ2v.assertReadMaxBytes)(readMaxBytes, count);
            chunks.push(chunk);
        }
    } catch (e_13_1) {
        e_13 = {
            error: e_13_1
        };
    } finally{
        try {
            if (!_h && !_d && (_e = iterable_13.return)) await _e.call(iterable_13);
        } finally{
            if (e_13) throw e_13.error;
        }
    }
    const all = new Uint8Array(count);
    let offset = 0;
    for(let chunk = chunks.shift(); chunk; chunk = chunks.shift()){
        all.set(chunk, offset);
        offset += chunk.byteLength;
    }
    return all;
}
// parse the lengthHint argument of readAllBytes()
function $7e55ee1178c50e80$var$parseLengthHint(lengthHint) {
    if (lengthHint === undefined || lengthHint === null) return [
        false,
        0
    ];
    const n = typeof lengthHint == "string" ? parseInt(lengthHint, 10) : lengthHint;
    if (!Number.isSafeInteger(n) || n < 0) return [
        false,
        n
    ];
    return [
        true,
        n
    ];
}
async function $7e55ee1178c50e80$export$71d79f4b5c27b4a(iterable) {
    const it = iterable[Symbol.asyncIterator]();
    let first = await it.next();
    return {
        [Symbol.asyncIterator] () {
            const w = {
                async next () {
                    if (first !== null) {
                        const n = first;
                        first = null;
                        return n;
                    }
                    return await it.next();
                }
            };
            if (it.throw !== undefined) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- can't handle mutated object sensibly
            w.throw = (e)=>it.throw(e);
            if (it.return !== undefined) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,@typescript-eslint/no-explicit-any -- can't handle mutated object sensibly
            w.return = (value)=>it.return(value);
            return w;
        }
    };
}
function $7e55ee1178c50e80$export$a0ef0c9354bb3f0a(iterable) {
    const innerCandidate = iterable[Symbol.asyncIterator]();
    if (innerCandidate.throw === undefined) throw new Error("AsyncIterable does not implement throw");
    const inner = innerCandidate;
    let aborted;
    let resultPromise;
    let it = {
        next () {
            resultPromise = inner.next().finally(()=>{
                resultPromise = undefined;
            });
            return resultPromise;
        },
        throw (e) {
            return inner.throw(e);
        }
    };
    if (innerCandidate.return !== undefined) it = Object.assign(Object.assign({}, it), {
        return (value) {
            return inner.return(value);
        }
    });
    let used = false;
    return {
        abort (reason) {
            if (aborted) return aborted.state;
            const f = ()=>{
                return inner.throw(reason).then((r)=>r.done === true ? "completed" : "caught", ()=>"rethrown");
            };
            if (resultPromise) {
                aborted = {
                    reason: reason,
                    state: resultPromise.then(f, f)
                };
                return aborted.state;
            }
            aborted = {
                reason: reason,
                state: f()
            };
            return aborted.state;
        },
        [Symbol.asyncIterator] () {
            if (used) throw new Error("AsyncIterable cannot be re-used");
            used = true;
            return it;
        }
    };
}
function $7e55ee1178c50e80$export$4cac95b30e075cff() {
    // We start with two queues to capture the read and write attempts.
    //
    // The writes and reads each check of their counterpart is
    // already available and either interact/add themselves to the queue.
    const readQueue = [];
    const writeQueue = [];
    let err = undefined;
    let nextResolve;
    let nextReject;
    let nextPromise = new Promise((resolve, reject)=>{
        nextResolve = resolve;
        nextReject = reject;
    });
    let closed = false;
    // drain the readQueue in case of error/writer is closed by sending a
    // done result.
    function drain() {
        for (const next of readQueue.splice(0, readQueue.length))next({
            done: true,
            value: undefined
        });
    }
    return {
        close () {
            closed = true;
            drain();
        },
        async write (payload) {
            if (closed) throw err !== null && err !== void 0 ? err : new Error("cannot write, WritableIterable already closed");
            const read = readQueue.shift();
            if (read === undefined) // We didn't find a pending read so we add the payload to the write queue.
            writeQueue.push(payload);
            else {
                // We found a pending read so we respond with the payload.
                read({
                    done: false,
                    value: payload
                });
                if (readQueue.length > 0) // If there are more in the read queue we can mark the write as complete.
                // as the error reporting is not guaranteed to be sequential and therefore cannot
                // to linked to a specific write.
                return;
            }
            // We await the next call for as many times as there are items in the queue + 1
            //
            // If there are no items in the write queue that means write happened and we just have
            // to wait for one more call likewise if we are the nth write in the queue we
            // have to wait for n writes to complete and one more.
            const limit = writeQueue.length + 1;
            for(let i = 0; i < limit; i++)await nextPromise;
        },
        [Symbol.asyncIterator] () {
            return {
                next () {
                    // Resolve the nextPromise to indicate
                    // pending writes that a read attempt has been made
                    // after their write.
                    //
                    // We also need to reset the promise for future writes.
                    nextResolve();
                    nextPromise = new Promise((resolve, reject)=>{
                        nextResolve = resolve;
                        nextReject = reject;
                    });
                    const write = writeQueue.shift();
                    if (write !== undefined) // We found a pending write so response with the payload.
                    return Promise.resolve({
                        done: false,
                        value: write
                    });
                    if (closed) return Promise.resolve({
                        done: true,
                        value: undefined
                    });
                    // We return a promise immediately that is either resolved/rejected
                    // as writes happen.
                    let readResolve;
                    const readPromise = new Promise((resolve)=>readResolve = resolve);
                    readQueue.push(readResolve); // eslint-disable-line @typescript-eslint/no-non-null-assertion
                    return readPromise;
                },
                throw (throwErr) {
                    err = throwErr;
                    closed = true;
                    writeQueue.splice(0, writeQueue.length);
                    nextPromise.catch(()=>{
                    // To make sure that the nextPromise is always resolved.
                    });
                    // This will reject all pending writes.
                    nextReject(err);
                    drain();
                    return Promise.resolve({
                        done: true,
                        value: undefined
                    });
                },
                return () {
                    closed = true;
                    writeQueue.splice(0, writeQueue.length);
                    // Resolve once for the write awaiting confirmation.
                    nextResolve();
                    // Reject all future writes.
                    nextPromise = Promise.reject(new Error("cannot write, consumer called return"));
                    nextPromise.catch(()=>{
                    // To make sure that the nextPromise is always resolved.
                    });
                    drain();
                    return Promise.resolve({
                        done: true,
                        value: undefined
                    });
                }
            };
        }
    };
}
function $7e55ee1178c50e80$export$9b9eb69fad02e04e(items) {
    return $7e55ee1178c50e80$var$__asyncGenerator(this, arguments, function* createAsyncIterable_1() {
        yield $7e55ee1178c50e80$var$__await((yield* $7e55ee1178c50e80$var$__asyncDelegator($7e55ee1178c50e80$var$__asyncValues(items))));
    });
}

});


parcelRegister("h3scz", function(module, exports) {

$parcel$export(module.exports, "LoginRequestSchema", () => $15e5c3a01eb181d8$export$e2c7f6f2463ce797);
$parcel$export(module.exports, "Authentication", () => $15e5c3a01eb181d8$export$d9e3c9dc7eaad0c3);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/authentication.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
var $cdmiO = parcelRequire("cdmiO");

var $6Os56 = parcelRequire("6Os56");

var $8ffPJ = parcelRequire("8ffPJ");

var $l6s0m = parcelRequire("l6s0m");

var $ipnxV = parcelRequire("ipnxV");
const $15e5c3a01eb181d8$export$11bb6aa1573516b4 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Chd2MS9hdXRoZW50aWNhdGlvbi5wcm90bxICdjEiMgoMTG9naW5SZXF1ZXN0EhAKCHVzZXJuYW1lGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIh4KDUxvZ2luUmVzcG9uc2USDQoFdG9rZW4YASABKAkyegoOQXV0aGVudGljYXRpb24SLgoFTG9naW4SEC52MS5Mb2dpblJlcXVlc3QaES52MS5Mb2dpblJlc3BvbnNlIgASOAoMSGFzaFBhc3N3b3JkEhIudHlwZXMuU3RyaW5nVmFsdWUaEi50eXBlcy5TdHJpbmdWYWx1ZSIAQixaKmdpdGh1Yi5jb20vZ2FyZXRoZ2VvcmdlL2JhY2tyZXN0L2dlbi9nby92MWIGcHJvdG8z", [
    (0, $6Os56.file_v1_config),
    (0, $8ffPJ.file_types_value),
    (0, $l6s0m.file_google_protobuf_empty),
    (0, $ipnxV.file_google_api_annotations)
]);
const $15e5c3a01eb181d8$export$e2c7f6f2463ce797 = /*@__PURE__*/ (0, $jHEye.messageDesc)($15e5c3a01eb181d8$export$11bb6aa1573516b4, 0);
const $15e5c3a01eb181d8$export$dd9303aa98daf71d = /*@__PURE__*/ (0, $jHEye.messageDesc)($15e5c3a01eb181d8$export$11bb6aa1573516b4, 1);
const $15e5c3a01eb181d8$export$d9e3c9dc7eaad0c3 = /*@__PURE__*/ (0, $cdmiO.serviceDesc)($15e5c3a01eb181d8$export$11bb6aa1573516b4, 0);

});
parcelRegister("cdmiO", function(module, exports) {

$parcel$export(module.exports, "serviceDesc", () => $8e47ffb807551968$export$97693cf7f91d6714);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Hydrate a service descriptor.
 *
 * @private
 */ function $8e47ffb807551968$export$97693cf7f91d6714(file, path, ...paths) {
    if (paths.length > 0) throw new Error();
    return file.services[path];
}

});

parcelRegister("ipnxV", function(module, exports) {

$parcel$export(module.exports, "file_google_api_annotations", () => $7081cbc26d39306d$export$14f40d6d5328a87b);
// Copyright 2015 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file google/api/annotations.proto (package google.api, syntax proto3)
/* eslint-disable */ 
var $hrfIQ = parcelRequire("hrfIQ");
var $9CnIh = parcelRequire("9CnIh");

var $fkHvi = parcelRequire("fkHvi");

var $dKpyK = parcelRequire("dKpyK");
const $7081cbc26d39306d$export$14f40d6d5328a87b = /*@__PURE__*/ (0, $9CnIh.fileDesc)("Chxnb29nbGUvYXBpL2Fubm90YXRpb25zLnByb3RvEgpnb29nbGUuYXBpOksKBGh0dHASHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxiwyrwiIAEoCzIULmdvb2dsZS5hcGkuSHR0cFJ1bGVSBGh0dHBCbgoOY29tLmdvb2dsZS5hcGlCEEFubm90YXRpb25zUHJvdG9QAVpBZ29vZ2xlLmdvbGFuZy5vcmcvZ2VucHJvdG8vZ29vZ2xlYXBpcy9hcGkvYW5ub3RhdGlvbnM7YW5ub3RhdGlvbnOiAgRHQVBJYgZwcm90bzM", [
    (0, $fkHvi.file_google_api_http),
    (0, $dKpyK.file_google_protobuf_descriptor)
]);
const $7081cbc26d39306d$export$7d6f1c8842f9f527 = /*@__PURE__*/ (0, $hrfIQ.extDesc)($7081cbc26d39306d$export$14f40d6d5328a87b, 0);

});
parcelRegister("hrfIQ", function(module, exports) {

$parcel$export(module.exports, "extDesc", () => $cb212767c41fd636$export$3c7b2686d544f4e6);
// Copyright 2021-2025 Buf Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * Hydrate an extension descriptor.
 *
 * @private
 */ function $cb212767c41fd636$export$3c7b2686d544f4e6(file, path, ...paths) {
    if (paths.length == 0) return file.extensions[path];
    const e = paths.pop(); // we checked length above
    return paths.reduce((acc, cur)=>acc.nestedMessages[cur], file.messages[path]).nestedExtensions[e];
}

});

parcelRegister("fkHvi", function(module, exports) {

$parcel$export(module.exports, "file_google_api_http", () => $e89f046c7b86d097$export$c38a39abc21b1df5);
// Copyright 2023 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file google/api/http.proto (package google.api, syntax proto3)
/* eslint-disable */ 
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
const $e89f046c7b86d097$export$c38a39abc21b1df5 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("ChVnb29nbGUvYXBpL2h0dHAucHJvdG8SCmdvb2dsZS5hcGkiVAoESHR0cBIjCgVydWxlcxgBIAMoCzIULmdvb2dsZS5hcGkuSHR0cFJ1bGUSJwofZnVsbHlfZGVjb2RlX3Jlc2VydmVkX2V4cGFuc2lvbhgCIAEoCCKBAgoISHR0cFJ1bGUSEAoIc2VsZWN0b3IYASABKAkSDQoDZ2V0GAIgASgJSAASDQoDcHV0GAMgASgJSAASDgoEcG9zdBgEIAEoCUgAEhAKBmRlbGV0ZRgFIAEoCUgAEg8KBXBhdGNoGAYgASgJSAASLwoGY3VzdG9tGAggASgLMh0uZ29vZ2xlLmFwaS5DdXN0b21IdHRwUGF0dGVybkgAEgwKBGJvZHkYByABKAkSFQoNcmVzcG9uc2VfYm9keRgMIAEoCRIxChNhZGRpdGlvbmFsX2JpbmRpbmdzGAsgAygLMhQuZ29vZ2xlLmFwaS5IdHRwUnVsZUIJCgdwYXR0ZXJuIi8KEUN1c3RvbUh0dHBQYXR0ZXJuEgwKBGtpbmQYASABKAkSDAoEcGF0aBgCIAEoCUJqCg5jb20uZ29vZ2xlLmFwaUIJSHR0cFByb3RvUAFaQWdvb2dsZS5nb2xhbmcub3JnL2dlbnByb3RvL2dvb2dsZWFwaXMvYXBpL2Fubm90YXRpb25zO2Fubm90YXRpb25z+AEBogIER0FQSWIGcHJvdG8z");
const $e89f046c7b86d097$export$851ebc38f6003c23 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e89f046c7b86d097$export$c38a39abc21b1df5, 0);
const $e89f046c7b86d097$export$9cd37c4c19d47742 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e89f046c7b86d097$export$c38a39abc21b1df5, 1);
const $e89f046c7b86d097$export$2b2dd075f46bba76 = /*@__PURE__*/ (0, $jHEye.messageDesc)($e89f046c7b86d097$export$c38a39abc21b1df5, 2);

});



parcelRegister("cT7kT", function(module, exports) {

$parcel$export(module.exports, "file_v1_service", () => $9ac9ac6c4c40e499$export$cd2dda544b71d6);
$parcel$export(module.exports, "OpSelectorSchema", () => $9ac9ac6c4c40e499$export$551363507e588c07);
$parcel$export(module.exports, "DoRepoTaskRequestSchema", () => $9ac9ac6c4c40e499$export$17ffff81b397da16);
$parcel$export(module.exports, "DoRepoTaskRequest_Task", () => $9ac9ac6c4c40e499$export$2e1d53496370605f);
$parcel$export(module.exports, "ClearHistoryRequestSchema", () => $9ac9ac6c4c40e499$export$8d2fa3ce0e72399d);
$parcel$export(module.exports, "ForgetRequestSchema", () => $9ac9ac6c4c40e499$export$c2f65ec1c931ef5a);
$parcel$export(module.exports, "GetOperationsRequestSchema", () => $9ac9ac6c4c40e499$export$44a087daf00384a7);
$parcel$export(module.exports, "RestoreSnapshotRequestSchema", () => $9ac9ac6c4c40e499$export$d3eece7f7e965184);
$parcel$export(module.exports, "ListSnapshotFilesResponseSchema", () => $9ac9ac6c4c40e499$export$4e33b08847bc65bb);
$parcel$export(module.exports, "LogDataRequestSchema", () => $9ac9ac6c4c40e499$export$5e72fac4ef40069e);
$parcel$export(module.exports, "LsEntrySchema", () => $9ac9ac6c4c40e499$export$8cfc718652be3f3c);
$parcel$export(module.exports, "RunCommandRequestSchema", () => $9ac9ac6c4c40e499$export$8ccece495b1e9503);
$parcel$export(module.exports, "Backrest", () => $9ac9ac6c4c40e499$export$ab6bf6342b1eca85);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/service.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $3hwGY = parcelRequire("3hwGY");
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
var $cdmiO = parcelRequire("cdmiO");

var $6Os56 = parcelRequire("6Os56");

var $bv1KU = parcelRequire("bv1KU");

var $81vtw = parcelRequire("81vtw");

var $8ffPJ = parcelRequire("8ffPJ");

var $l6s0m = parcelRequire("l6s0m");

var $ipnxV = parcelRequire("ipnxV");
const $9ac9ac6c4c40e499$export$cd2dda544b71d6 = /*@__PURE__*/ (0, $9CnIh.fileDesc)("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", [
    (0, $6Os56.file_v1_config),
    (0, $bv1KU.file_v1_restic),
    (0, $81vtw.file_v1_operations),
    (0, $8ffPJ.file_types_value),
    (0, $l6s0m.file_google_protobuf_empty),
    (0, $ipnxV.file_google_api_annotations)
]);
const $9ac9ac6c4c40e499$export$551363507e588c07 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 0);
const $9ac9ac6c4c40e499$export$17ffff81b397da16 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 1);
var $9ac9ac6c4c40e499$export$2e1d53496370605f = /*#__PURE__*/ function(DoRepoTaskRequest_Task) {
    /**
   * @generated from enum value: TASK_NONE = 0;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["NONE"] = 0] = "NONE";
    /**
   * @generated from enum value: TASK_INDEX_SNAPSHOTS = 1;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["INDEX_SNAPSHOTS"] = 1] = "INDEX_SNAPSHOTS";
    /**
   * @generated from enum value: TASK_PRUNE = 2;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["PRUNE"] = 2] = "PRUNE";
    /**
   * @generated from enum value: TASK_CHECK = 3;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["CHECK"] = 3] = "CHECK";
    /**
   * @generated from enum value: TASK_STATS = 4;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["STATS"] = 4] = "STATS";
    /**
   * @generated from enum value: TASK_UNLOCK = 5;
   */ DoRepoTaskRequest_Task[DoRepoTaskRequest_Task["UNLOCK"] = 5] = "UNLOCK";
    return DoRepoTaskRequest_Task;
}({});
const $9ac9ac6c4c40e499$export$97680325aff1d2d0 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 1, 0);
const $9ac9ac6c4c40e499$export$8d2fa3ce0e72399d = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 2);
const $9ac9ac6c4c40e499$export$c2f65ec1c931ef5a = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 3);
const $9ac9ac6c4c40e499$export$c0f4d88bdc0d34fa = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 4);
const $9ac9ac6c4c40e499$export$44a087daf00384a7 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 5);
const $9ac9ac6c4c40e499$export$d3eece7f7e965184 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 6);
const $9ac9ac6c4c40e499$export$c3285f8589a6bb0a = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 7);
const $9ac9ac6c4c40e499$export$4e33b08847bc65bb = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 8);
const $9ac9ac6c4c40e499$export$5e72fac4ef40069e = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 9);
const $9ac9ac6c4c40e499$export$8cfc718652be3f3c = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 10);
const $9ac9ac6c4c40e499$export$8ccece495b1e9503 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 11);
const $9ac9ac6c4c40e499$export$a5e0073c1e2fbfc3 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 12);
const $9ac9ac6c4c40e499$export$18d1eecdbc153326 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 12, 0);
const $9ac9ac6c4c40e499$export$563c3f521b90bd29 = /*@__PURE__*/ (0, $jHEye.messageDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 12, 1);
const $9ac9ac6c4c40e499$export$ab6bf6342b1eca85 = /*@__PURE__*/ (0, $cdmiO.serviceDesc)($9ac9ac6c4c40e499$export$cd2dda544b71d6, 0);

});

parcelRegister("kndvn", function(module, exports) {

$parcel$export(module.exports, "SyncConnectionState", () => $5a3e85ff55c89d08$export$9a38a3addb839a0f);
$parcel$export(module.exports, "BackrestSyncStateService", () => $5a3e85ff55c89d08$export$79e2f3af494bf3b3);
// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/syncservice.proto (package v1, syntax proto3)
/* eslint-disable */ 
var $3hwGY = parcelRequire("3hwGY");
var $9CnIh = parcelRequire("9CnIh");
var $jHEye = parcelRequire("jHEye");
var $cdmiO = parcelRequire("cdmiO");

var $6Os56 = parcelRequire("6Os56");

var $9kWNX = parcelRequire("9kWNX");

var $bv1KU = parcelRequire("bv1KU");

var $cT7kT = parcelRequire("cT7kT");

var $81vtw = parcelRequire("81vtw");

var $8ffPJ = parcelRequire("8ffPJ");

var $eJPbX = parcelRequire("eJPbX");
var $l6s0m = parcelRequire("l6s0m");

var $ipnxV = parcelRequire("ipnxV");
const $5a3e85ff55c89d08$export$9edd9be355cec87e = /*@__PURE__*/ (0, $9CnIh.fileDesc)("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", [
    (0, $6Os56.file_v1_config),
    (0, $9kWNX.file_v1_crypto),
    (0, $bv1KU.file_v1_restic),
    (0, $cT7kT.file_v1_service),
    (0, $81vtw.file_v1_operations),
    (0, $8ffPJ.file_types_value),
    (0, $l6s0m.file_google_protobuf_empty),
    (0, $ipnxV.file_google_api_annotations),
    (0, $eJPbX.file_google_protobuf_any)
]);
const $5a3e85ff55c89d08$export$7697e279e1957614 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 0);
const $5a3e85ff55c89d08$export$172a5a911ce5c30d = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 1);
const $5a3e85ff55c89d08$export$5e002003e06f14f8 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 2);
const $5a3e85ff55c89d08$export$56e5db026c3c580c = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3);
const $5a3e85ff55c89d08$export$6d952064334f23be = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 0);
const $5a3e85ff55c89d08$export$728df01233a1607f = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 1);
const $5a3e85ff55c89d08$export$3257deafbd460f26 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 2);
const $5a3e85ff55c89d08$export$f1eb9cdcd685f435 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 3);
const $5a3e85ff55c89d08$export$7fe3f50a34ca216c = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 4);
const $5a3e85ff55c89d08$export$1adb85ef8102cda5 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 5);
const $5a3e85ff55c89d08$export$26225a0a09c4d486 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 6);
const $5a3e85ff55c89d08$export$899c56bab1b1454d = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 7);
const $5a3e85ff55c89d08$export$9969461364df5e86 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 8);
const $5a3e85ff55c89d08$export$df2238a723edf5d8 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 9);
var $5a3e85ff55c89d08$export$5155b294e536e04e = /*#__PURE__*/ function(SyncStreamItem_RepoConnectionState) {
    /**
   * @generated from enum value: CONNECTION_STATE_UNKNOWN = 0;
   */ SyncStreamItem_RepoConnectionState[SyncStreamItem_RepoConnectionState["CONNECTION_STATE_UNKNOWN"] = 0] = "CONNECTION_STATE_UNKNOWN";
    /**
   * queried, response not yet received.
   *
   * @generated from enum value: CONNECTION_STATE_PENDING = 1;
   */ SyncStreamItem_RepoConnectionState[SyncStreamItem_RepoConnectionState["CONNECTION_STATE_PENDING"] = 1] = "CONNECTION_STATE_PENDING";
    /**
   * @generated from enum value: CONNECTION_STATE_CONNECTED = 2;
   */ SyncStreamItem_RepoConnectionState[SyncStreamItem_RepoConnectionState["CONNECTION_STATE_CONNECTED"] = 2] = "CONNECTION_STATE_CONNECTED";
    /**
   * @generated from enum value: CONNECTION_STATE_UNAUTHORIZED = 3;
   */ SyncStreamItem_RepoConnectionState[SyncStreamItem_RepoConnectionState["CONNECTION_STATE_UNAUTHORIZED"] = 3] = "CONNECTION_STATE_UNAUTHORIZED";
    /**
   * @generated from enum value: CONNECTION_STATE_NOT_FOUND = 4;
   */ SyncStreamItem_RepoConnectionState[SyncStreamItem_RepoConnectionState["CONNECTION_STATE_NOT_FOUND"] = 4] = "CONNECTION_STATE_NOT_FOUND";
    return SyncStreamItem_RepoConnectionState;
}({});
const $5a3e85ff55c89d08$export$a8b1771ee4c28fe7 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 3, 0);
const $5a3e85ff55c89d08$export$dce6ab126d845ed6 = /*@__PURE__*/ (0, $jHEye.messageDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 4);
var $5a3e85ff55c89d08$export$9a38a3addb839a0f = /*#__PURE__*/ function(SyncConnectionState) {
    /**
   * @generated from enum value: CONNECTION_STATE_UNKNOWN = 0;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_UNKNOWN"] = 0] = "CONNECTION_STATE_UNKNOWN";
    /**
   * @generated from enum value: CONNECTION_STATE_PENDING = 1;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_PENDING"] = 1] = "CONNECTION_STATE_PENDING";
    /**
   * @generated from enum value: CONNECTION_STATE_CONNECTED = 2;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_CONNECTED"] = 2] = "CONNECTION_STATE_CONNECTED";
    /**
   * @generated from enum value: CONNECTION_STATE_DISCONNECTED = 3;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_DISCONNECTED"] = 3] = "CONNECTION_STATE_DISCONNECTED";
    /**
   * @generated from enum value: CONNECTION_STATE_RETRY_WAIT = 4;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_RETRY_WAIT"] = 4] = "CONNECTION_STATE_RETRY_WAIT";
    /**
   * @generated from enum value: CONNECTION_STATE_ERROR_AUTH = 10;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_ERROR_AUTH"] = 10] = "CONNECTION_STATE_ERROR_AUTH";
    /**
   * @generated from enum value: CONNECTION_STATE_ERROR_PROTOCOL = 11;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_ERROR_PROTOCOL"] = 11] = "CONNECTION_STATE_ERROR_PROTOCOL";
    /**
   * @generated from enum value: CONNECTION_STATE_ERROR_INTERNAL = 12;
   */ SyncConnectionState[SyncConnectionState["CONNECTION_STATE_ERROR_INTERNAL"] = 12] = "CONNECTION_STATE_ERROR_INTERNAL";
    return SyncConnectionState;
}({});
const $5a3e85ff55c89d08$export$c49ab6b68940dae9 = /*@__PURE__*/ (0, $3hwGY.enumDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 0);
const $5a3e85ff55c89d08$export$b4245c3b454747f = /*@__PURE__*/ (0, $cdmiO.serviceDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 0);
const $5a3e85ff55c89d08$export$de16d560a34d34f6 = /*@__PURE__*/ (0, $cdmiO.serviceDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 1);
const $5a3e85ff55c89d08$export$79e2f3af494bf3b3 = /*@__PURE__*/ (0, $cdmiO.serviceDesc)($5a3e85ff55c89d08$export$9edd9be355cec87e, 2);

});



parcelRegister("9oUau", function(module, exports) {

$parcel$export(module.exports, "formatBytes", () => $7ad9e1c6628eb33d$export$e1a3971de07c83b5);
$parcel$export(module.exports, "formatTime", () => $7ad9e1c6628eb33d$export$3203edd9e5edd663);
$parcel$export(module.exports, "localISOTime", () => $7ad9e1c6628eb33d$export$2c87ea246b8d1a7c);
$parcel$export(module.exports, "formatDate", () => $7ad9e1c6628eb33d$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatMonth", () => $7ad9e1c6628eb33d$export$d0536c8e7f45796e);
$parcel$export(module.exports, "formatDuration", () => $7ad9e1c6628eb33d$export$bc733b0c5cbb3e8a);
$parcel$export(module.exports, "normalizeSnapshotId", () => $7ad9e1c6628eb33d$export$fdcdb0158df5dbeb);
const $7ad9e1c6628eb33d$var$units = [
    "B",
    "KiB",
    "MiB",
    "GiB",
    "TiB",
    "PiB"
];
const $7ad9e1c6628eb33d$export$e1a3971de07c83b5 = (bytes)=>{
    if (!bytes) return "0B";
    if (typeof bytes === "string") bytes = parseInt(bytes);
    let unit = 0;
    while(bytes > 1024){
        bytes /= 1024;
        unit++;
    }
    return `${Math.round(bytes * 100) / 100} ${$7ad9e1c6628eb33d$var$units[unit]}`;
};
const $7ad9e1c6628eb33d$var$fmtHourMinute = new Intl.DateTimeFormat(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
});
const $7ad9e1c6628eb33d$var$timezoneOffsetMs = new Date().getTimezoneOffset() * 60000;
const $7ad9e1c6628eb33d$export$3203edd9e5edd663 = (time)=>{
    if (typeof time === "string") time = parseInt(time);
    else if (time instanceof Date) time = time.getTime();
    const d = new Date(time);
    return $7ad9e1c6628eb33d$var$fmtHourMinute.format(d);
};
const $7ad9e1c6628eb33d$export$2c87ea246b8d1a7c = (time)=>{
    if (typeof time === "string") time = parseInt(time);
    else if (time instanceof Date) time = time.getTime();
    const d = new Date();
    d.setTime(time - $7ad9e1c6628eb33d$var$timezoneOffsetMs);
    return d.toISOString();
};
const $7ad9e1c6628eb33d$var$fmtDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
});
const $7ad9e1c6628eb33d$export$3ae94a2503e890a1 = (time)=>{
    if (typeof time === "string") time = parseInt(time);
    else if (time instanceof Date) time = time.getTime();
    let d = new Date();
    d.setTime(time);
    return $7ad9e1c6628eb33d$var$fmtDate.format(d);
};
const $7ad9e1c6628eb33d$var$fmtMonth = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit"
});
const $7ad9e1c6628eb33d$export$d0536c8e7f45796e = (time)=>{
    if (typeof time === "string") time = parseInt(time);
    else if (time instanceof Date) time = time.getTime();
    let d = new Date();
    d.setTime(time);
    return $7ad9e1c6628eb33d$var$fmtMonth.format(d);
};
const $7ad9e1c6628eb33d$var$durationSteps = [
    1000,
    60,
    60,
    24,
    Number.MAX_VALUE
];
const $7ad9e1c6628eb33d$var$durationFactors = [
    1,
    1000,
    60000,
    3600000,
    86400000
];
const $7ad9e1c6628eb33d$var$shortDurationUnits = [
    "ms",
    "s",
    "m",
    "h",
    "d"
];
const $7ad9e1c6628eb33d$export$bc733b0c5cbb3e8a = (ms, options)=>{
    if (!ms && ms !== 0) return "";
    if (!options && ms < 60000) // If no options and less than a minute, show seconds
    // Performance optimization
    return `${Math.round(ms / 1000)}s`;
    const minUnitIndex = options?.minUnit ? $7ad9e1c6628eb33d$var$shortDurationUnits.indexOf(options.minUnit) : 1; // Don't show ms by default
    const maxUnitIndex = options?.maxUnit ? $7ad9e1c6628eb33d$var$shortDurationUnits.indexOf(options.maxUnit) : $7ad9e1c6628eb33d$var$shortDurationUnits.length - 1;
    const absMs = Math.abs(ms);
    let result = "";
    for(let i = maxUnitIndex; i >= minUnitIndex; i--){
        const value = Math.floor(absMs / $7ad9e1c6628eb33d$var$durationFactors[i]) % $7ad9e1c6628eb33d$var$durationSteps[i];
        if (value > 0) result += `${value}${$7ad9e1c6628eb33d$var$shortDurationUnits[i]}`;
    }
    if (!result) result = `0${$7ad9e1c6628eb33d$var$shortDurationUnits[minUnitIndex]}`;
    return ms < 0 ? `-${result}` : result;
};
const $7ad9e1c6628eb33d$export$fdcdb0158df5dbeb = (id)=>{
    return id.substring(0, 8);
};

});

parcelRegister("aDcZc", function(module, exports) {

$parcel$export(module.exports, "DisplayType", () => $d89df9c8400021fa$export$63a2ebf5a63e2961);
$parcel$export(module.exports, "displayInfoForFlow", () => $d89df9c8400021fa$export$d81ec58b4a215be1);
$parcel$export(module.exports, "getTypeForDisplay", () => $d89df9c8400021fa$export$eefc7bffabfd3dc3);
$parcel$export(module.exports, "displayTypeToString", () => $d89df9c8400021fa$export$83ed0427229eacf1);
$parcel$export(module.exports, "colorForStatus", () => $d89df9c8400021fa$export$d157f58e3fabfd2f);
$parcel$export(module.exports, "nameForStatus", () => $d89df9c8400021fa$export$6e171f9afb1d05c5);

var $81vtw = parcelRequire("81vtw");

var $9oUau = parcelRequire("9oUau");
var $d89df9c8400021fa$export$63a2ebf5a63e2961 = /*#__PURE__*/ function(DisplayType) {
    DisplayType[DisplayType["UNKNOWN"] = 0] = "UNKNOWN";
    DisplayType[DisplayType["BACKUP"] = 1] = "BACKUP";
    DisplayType[DisplayType["SNAPSHOT"] = 2] = "SNAPSHOT";
    DisplayType[DisplayType["FORGET"] = 3] = "FORGET";
    DisplayType[DisplayType["PRUNE"] = 4] = "PRUNE";
    DisplayType[DisplayType["CHECK"] = 5] = "CHECK";
    DisplayType[DisplayType["RESTORE"] = 6] = "RESTORE";
    DisplayType[DisplayType["STATS"] = 7] = "STATS";
    DisplayType[DisplayType["RUNHOOK"] = 8] = "RUNHOOK";
    DisplayType[DisplayType["RUNCOMMAND"] = 9] = "RUNCOMMAND";
    return DisplayType;
}({});
const $d89df9c8400021fa$export$d81ec58b4a215be1 = (ops)=>{
    ops.sort((a, b)=>Number(a.id - b.id));
    const firstOp = ops[0];
    const info = {
        flowID: firstOp.flowId,
        planID: firstOp.planId,
        repoID: firstOp.repoId,
        snapshotID: firstOp.snapshotId,
        instanceID: firstOp.instanceId,
        type: $d89df9c8400021fa$export$eefc7bffabfd3dc3(firstOp),
        status: firstOp.status,
        displayTime: Number(firstOp.unixTimeStartMs),
        subtitleComponents: [],
        hidden: false,
        operations: [
            ...ops
        ]
    };
    const duration = Number(firstOp.unixTimeEndMs - firstOp.unixTimeStartMs);
    if (firstOp.status === (0, $81vtw.OperationStatus).STATUS_PENDING) info.subtitleComponents.push("scheduled, waiting");
    switch(firstOp.op.case){
        case "operationBackup":
            {
                const lastStatus = firstOp.op.value.lastStatus;
                if (lastStatus) {
                    if (lastStatus.entry.case === "status") {
                        const percentage = lastStatus.entry.value.percentDone * 100;
                        const bytesDone = (0, $9oUau.formatBytes)(Number(lastStatus.entry.value.bytesDone));
                        const totalBytes = (0, $9oUau.formatBytes)(Number(lastStatus.entry.value.totalBytes));
                        info.subtitleComponents.push(`${percentage.toFixed(2)}% processed`);
                        info.subtitleComponents.push(`${bytesDone}/${totalBytes}`);
                    } else if (lastStatus.entry.case === "summary") {
                        const totalBytes = (0, $9oUau.formatBytes)(Number(lastStatus.entry.value.totalBytesProcessed));
                        info.subtitleComponents.push(`${totalBytes} in ${(0, $9oUau.formatDuration)(duration)}`);
                        info.subtitleComponents.push(`ID: ${(0, $9oUau.normalizeSnapshotId)(lastStatus.entry.value.snapshotId)}`);
                    }
                }
            }
            break;
        case "operationRestore":
            {
                const lastStatus = firstOp.op.value.lastStatus;
                if (lastStatus) {
                    if (lastStatus.messageType === "summary") {
                        const totalBytes = (0, $9oUau.formatBytes)(Number(lastStatus.totalBytes));
                        info.subtitleComponents.push(`${totalBytes} in ${(0, $9oUau.formatDuration)(duration)}`);
                    } else if (lastStatus.messageType === "status") {
                        const percentage = lastStatus.percentDone * 100;
                        const bytesDone = (0, $9oUau.formatBytes)(Number(lastStatus.bytesRestored));
                        const totalBytes = (0, $9oUau.formatBytes)(Number(lastStatus.totalBytes));
                        info.subtitleComponents.push(`${percentage.toFixed(2)}% processed`);
                        info.subtitleComponents.push(`${bytesDone}/${totalBytes}`);
                    }
                }
                info.subtitleComponents.push(`ID: ${(0, $9oUau.normalizeSnapshotId)(firstOp.snapshotId)}`);
            }
            break;
        case "operationIndexSnapshot":
            const snapshot = firstOp.op.value.snapshot;
            if (!snapshot) break;
            if (snapshot.summary && snapshot.summary.totalBytesProcessed) info.subtitleComponents.push(`${(0, $9oUau.formatBytes)(Number(snapshot.summary.totalBytesProcessed))} in ${(0, $9oUau.formatDuration)(snapshot.summary.totalDuration * 1000)}`);
            info.subtitleComponents.push(`ID: ${(0, $9oUau.normalizeSnapshotId)(snapshot.id)}`);
            break;
        default:
            switch(firstOp.status){
                case (0, $81vtw.OperationStatus).STATUS_INPROGRESS:
                    info.subtitleComponents.push("running");
                    break;
                case (0, $81vtw.OperationStatus).STATUS_USER_CANCELLED:
                    info.subtitleComponents.push("cancelled by user");
                    break;
                case (0, $81vtw.OperationStatus).STATUS_SYSTEM_CANCELLED:
                    info.subtitleComponents.push("cancelled by system");
                    break;
                default:
                    if (duration > 100) info.subtitleComponents.push(`took ${(0, $9oUau.formatDuration)(duration)}`);
                    break;
            }
    }
    for (let op of ops){
        if (op.op.case === "operationIndexSnapshot") {
            if (op.op.value.forgot) info.hidden = true;
        }
        if (op.op.case === "operationRunHook" && op.status === (0, $81vtw.OperationStatus).STATUS_ERROR) {
            if (info.status === (0, $81vtw.OperationStatus).STATUS_SUCCESS) info.status = (0, $81vtw.OperationStatus).STATUS_WARNING;
        } else if (op.status === (0, $81vtw.OperationStatus).STATUS_INPROGRESS || op.status === (0, $81vtw.OperationStatus).STATUS_ERROR || op.status === (0, $81vtw.OperationStatus).STATUS_WARNING) info.status = op.status;
    }
    return info;
};
const $d89df9c8400021fa$export$93f76c4e66583daa = (operation)=>{
    return operation.op.case === "operationStats" || $d89df9c8400021fa$export$fb873b7f53d17fbb(operation.status);
};
const $d89df9c8400021fa$export$fb873b7f53d17fbb = (status)=>{
    return status === (0, $81vtw.OperationStatus).STATUS_SYSTEM_CANCELLED;
};
const $d89df9c8400021fa$export$eefc7bffabfd3dc3 = (op)=>{
    switch(op.op.case){
        case "operationBackup":
            return 1;
        case "operationIndexSnapshot":
            return 2;
        case "operationForget":
            return 3;
        case "operationPrune":
            return 4;
        case "operationCheck":
            return 5;
        case "operationRestore":
            return 6;
        case "operationStats":
            return 7;
        case "operationRunHook":
            return 8;
        case "operationRunCommand":
            return 9;
        default:
            return 0;
    }
};
const $d89df9c8400021fa$export$83ed0427229eacf1 = (type)=>{
    switch(type){
        case 1:
            return "Backup";
        case 2:
            return "Snapshot";
        case 3:
            return "Forget";
        case 4:
            return "Prune";
        case 5:
            return "Check";
        case 6:
            return "Restore";
        case 7:
            return "Stats";
        case 8:
            return "Run Hook";
        case 9:
            return "Run Command";
        default:
            return "Unknown";
    }
};
const $d89df9c8400021fa$export$d157f58e3fabfd2f = (status)=>{
    switch(status){
        case (0, $81vtw.OperationStatus).STATUS_PENDING:
            return "grey";
        case (0, $81vtw.OperationStatus).STATUS_INPROGRESS:
            return "blue";
        case (0, $81vtw.OperationStatus).STATUS_ERROR:
            return "red";
        case (0, $81vtw.OperationStatus).STATUS_WARNING:
            return "orange";
        case (0, $81vtw.OperationStatus).STATUS_SUCCESS:
            return "green";
        case (0, $81vtw.OperationStatus).STATUS_USER_CANCELLED:
            return "orange";
        default:
            return "grey";
    }
};
const $d89df9c8400021fa$export$6e171f9afb1d05c5 = (status)=>{
    switch(status){
        case (0, $81vtw.OperationStatus).STATUS_PENDING:
            return "pending";
        case (0, $81vtw.OperationStatus).STATUS_INPROGRESS:
            return "in progress";
        case (0, $81vtw.OperationStatus).STATUS_ERROR:
            return "error";
        case (0, $81vtw.OperationStatus).STATUS_WARNING:
            return "warning";
        case (0, $81vtw.OperationStatus).STATUS_SUCCESS:
            return "success";
        case (0, $81vtw.OperationStatus).STATUS_USER_CANCELLED:
            return "cancelled";
        case (0, $81vtw.OperationStatus).STATUS_SYSTEM_CANCELLED:
            return "cancelled";
        default:
            return "Unknown";
    }
};

});

parcelRegister("aMH3h", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("4mi0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c730c55c77ae7d$export$2e2bcd8739ae039);

var $8OXWQ = parcelRequire("8OXWQ");
"use client";
var $32c730c55c77ae7d$export$2e2bcd8739ae039 = (0, $8OXWQ.default);

});
parcelRegister("8OXWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c17eaa99d15e68$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $c8oE7 = parcelRequire("c8oE7");

var $amB8F = parcelRequire("amB8F");
"use client";
var $66c17eaa99d15e68$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $66c17eaa99d15e68$var$parseFlex(flex) {
    if (typeof flex === 'number') return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $66c17eaa99d15e68$var$sizes = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
const $66c17eaa99d15e68$var$Col = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const { gutter: gutter, wrap: wrap } = $aqdBs.useContext((0, $c8oE7.default));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style } = props, others = $66c17eaa99d15e68$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    const prefixCls = getPrefixCls('col', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $amB8F.useColStyle)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $66c17eaa99d15e68$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') sizeProps.span = propSize;
        else if (typeof propSize === 'object') sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === 'rtl'
        });
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $66c17eaa99d15e68$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        const horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $66c17eaa99d15e68$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, others, {
        style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
        className: classes,
        ref: ref
    }), children));
});
var $66c17eaa99d15e68$export$2e2bcd8739ae039 = $66c17eaa99d15e68$var$Col;

});
parcelRegister("c8oE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5959930e0a5ea3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
const $8d5959930e0a5ea3$var$RowContext = /*#__PURE__*/ (0, $aqdBs.createContext)({});
var $8d5959930e0a5ea3$export$2e2bcd8739ae039 = $8d5959930e0a5ea3$var$RowContext;

});

parcelRegister("amB8F", function(module, exports) {

$parcel$export(module.exports, "useRowStyle", () => $78b8c46c5b7be88b$export$b0d9c6b8be4e14cd);
$parcel$export(module.exports, "getMediaSize", () => $78b8c46c5b7be88b$export$6353f655434817c5);
$parcel$export(module.exports, "useColStyle", () => $78b8c46c5b7be88b$export$4d3e83959861592f);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
// ============================== Row-Shared ==============================
const $78b8c46c5b7be88b$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $78b8c46c5b7be88b$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $78b8c46c5b7be88b$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $78b8c46c5b7be88b$var$genGridStyle = (token, sizeCls)=>$78b8c46c5b7be88b$var$genLoopGridColumnsStyle(token, sizeCls);
const $78b8c46c5b7be88b$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $aWTY1.unit)(screenSize)})`]: Object.assign({}, $78b8c46c5b7be88b$var$genGridStyle(token, sizeCls))
    });
const $78b8c46c5b7be88b$export$519f4f378a4f8e85 = ()=>({});
const $78b8c46c5b7be88b$export$5504d86ab3175593 = ()=>({});
const $78b8c46c5b7be88b$export$b0d9c6b8be4e14cd = (0, $4wPvn.genStyleHooks)('Grid', $78b8c46c5b7be88b$var$genGridRowStyle, $78b8c46c5b7be88b$export$519f4f378a4f8e85);
const $78b8c46c5b7be88b$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const $78b8c46c5b7be88b$export$4d3e83959861592f = (0, $4wPvn.genStyleHooks)('Grid', (token)=>{
    const gridToken = (0, $8Olk9.merge)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $78b8c46c5b7be88b$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $78b8c46c5b7be88b$var$genGridColStyle(gridToken),
        $78b8c46c5b7be88b$var$genGridStyle(gridToken, ''),
        $78b8c46c5b7be88b$var$genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>$78b8c46c5b7be88b$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>Object.assign(Object.assign({}, pre), cur), {})
    ];
}, $78b8c46c5b7be88b$export$5504d86ab3175593);

});



parcelRegister("1TmFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $160c842ff68128b7$export$2e2bcd8739ae039);


var $7YqzN = parcelRequire("7YqzN");

var $afIxp = parcelRequire("afIxp");

var $8JD5E = parcelRequire("8JD5E");
var $1G2wQ = parcelRequire("1G2wQ");parcelRequire("8rj45");
var $8nPZz = parcelRequire("8nPZz");

var $9x38Q = parcelRequire("9x38Q");

var $5B5VU = parcelRequire("5B5VU");

var $dy7Ge = parcelRequire("dy7Ge");
"use client";
const $160c842ff68128b7$var$Form = (0, $8JD5E.default);
$160c842ff68128b7$var$Form.Item = (0, $9x38Q.default);
$160c842ff68128b7$var$Form.List = (0, $5B5VU.default);
$160c842ff68128b7$var$Form.ErrorList = (0, $afIxp.default);
$160c842ff68128b7$var$Form.useForm = (0, $1G2wQ.default);
$160c842ff68128b7$var$Form.useFormInstance = (0, $dy7Ge.default);
$160c842ff68128b7$var$Form.useWatch = (0, $8nPZz.default);
$160c842ff68128b7$var$Form.Provider = (0, $7YqzN.FormProvider);
$160c842ff68128b7$var$Form.create = ()=>{};
var $160c842ff68128b7$export$2e2bcd8739ae039 = $160c842ff68128b7$var$Form;

});
parcelRegister("afIxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $776dda6796c27d99$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("6ufPd");
var $eSxAB = parcelRequire("eSxAB");
var $6ufPd = parcelRequire("6ufPd");

var $dLmcO = parcelRequire("dLmcO");

var $aogQV = parcelRequire("aogQV");

var $7YqzN = parcelRequire("7YqzN");

var $bDm9q = parcelRequire("bDm9q");

var $g2QZ8 = parcelRequire("g2QZ8");
"use client";
const $776dda6796c27d99$var$EMPTY_LIST = [];
function $776dda6796c27d99$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $776dda6796c27d99$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $776dda6796c27d99$var$EMPTY_LIST, warnings: warnings = $776dda6796c27d99$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $aqdBs.useContext((0, $7YqzN.FormItemPrefixContext));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $g2QZ8.default)(prefixCls, rootCls);
    const collapseMotion = $aqdBs.useMemo(()=>(0, $dLmcO.default)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $bDm9q.default)(errors);
    const debounceWarnings = (0, $bDm9q.default)(warnings);
    const fullKeyList = $aqdBs.useMemo(()=>{
        if (help !== undefined && help !== null) return [
            $776dda6796c27d99$var$toErrorEntity(help, 'help', helpStatus)
        ];
        return [].concat((0, $dMbbs.default)(debounceErrors.map((error, index)=>$776dda6796c27d99$var$toErrorEntity(error, 'error', 'error', index))), (0, $dMbbs.default)(debounceWarnings.map((warning, index)=>$776dda6796c27d99$var$toErrorEntity(warning, 'warning', 'warning', index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $aqdBs.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>Object.assign(Object.assign({}, entity), {
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle
        }), /*#__PURE__*/ $aqdBs.createElement((0, $eSxAB.default), Object.assign({
            keys: filledKeyFullKeyList
        }, (0, $dLmcO.default)(prefixCls), {
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }), (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $aqdBs.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    }));
};
var $776dda6796c27d99$export$2e2bcd8739ae039 = $776dda6796c27d99$var$ErrorList;

});
parcelRegister("bDm9q", function(module, exports) {

$parcel$export(module.exports, "default", () => $878484ef3849160a$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $878484ef3849160a$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $aqdBs.useState(value);
    $aqdBs.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}

});

parcelRegister("g2QZ8", function(module, exports) {

$parcel$export(module.exports, "prepareToken", () => $bae5eef873e1e43c$export$362fb92a8f81bbf9);
$parcel$export(module.exports, "default", () => $bae5eef873e1e43c$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $ZA9h0 = parcelRequire("ZA9h0");
var $d9Xyr = parcelRequire("d9Xyr");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $ccbYf = parcelRequire("ccbYf");
const $bae5eef873e1e43c$var$resetForm = (token)=>({
        legend: {
            display: 'block',
            width: '100%',
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: 'inherit',
            border: 0,
            borderBottom: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: 'border-box'
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: 'normal'
        },
        'input[type="file"]': {
            display: 'block'
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: 'block',
            width: '100%'
        },
        // Make multiple select elements height not fixed
        'select[multiple], select[size]': {
            height: 'auto'
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $aWTY1.unit)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: 'block',
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $bae5eef873e1e43c$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $bae5eef873e1e43c$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), $bae5eef873e1e43c$var$resetForm(token)), {
            [`${componentCls}-text`]: {
                display: 'inline-block',
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            '&-small': Object.assign({}, $bae5eef873e1e43c$var$genFormSize(token, token.controlHeightSM)),
            '&-large': Object.assign({}, $bae5eef873e1e43c$var$genFormSize(token, token.controlHeightLG))
        })
    };
};
const $bae5eef873e1e43c$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
            marginBottom: itemMarginBottom,
            verticalAlign: 'top',
            '&-with-help': {
                transition: 'none'
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: 'none'
            },
            '&-has-warning': {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            '&-has-error': {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textAlign: 'end',
                verticalAlign: 'middle',
                '&-left': {
                    textAlign: 'start'
                },
                '&-wrap': {
                    overflow: 'unset',
                    lineHeight: token.lineHeight,
                    whiteSpace: 'unset',
                    '> label': {
                        verticalAlign: 'middle',
                        textWrap: 'balance'
                    }
                },
                '> label': {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    maxWidth: '100%',
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: 'top'
                    },
                    [`&${formItemCls}-required`]: {
                        '&::before': {
                            display: 'inline-block',
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: 'SimSun, sans-serif',
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            '&::before': {
                                display: 'none'
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: 'inline-block',
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: 'none'
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: 'help',
                        writingMode: 'horizontal-tb',
                        marginInlineStart: token.marginXXS
                    },
                    '&::after': {
                        content: '":"',
                        position: 'relative',
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ['--ant-display']: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: '100%'
                },
                '&-input': {
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: token.controlHeight,
                    '&-content': {
                        flex: 'auto',
                        maxWidth: '100%'
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                '&-additional': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '&-explain, &-extra': {
                    clear: 'both',
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                '&-explain-connected': {
                    width: '100%'
                },
                '&-extra': {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                '&-explain': {
                    '&-error': {
                        color: token.colorError
                    },
                    '&-warning': {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: 'auto',
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: 'center',
                visibility: 'visible',
                animationName: (0, $d9Xyr.zoomIn),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: 'none',
                '&-success': {
                    color: token.colorSuccess
                },
                '&-error': {
                    color: token.colorError
                },
                '&-warning': {
                    color: token.colorWarning
                },
                '&-validating': {
                    color: token.colorPrimary
                }
            }
        })
    };
};
const $bae5eef873e1e43c$var$genHorizontalStyle = (token, className)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [`${className}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: '1 1 0',
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: 'unset'
                }
            }
        }
    };
};
const $bae5eef873e1e43c$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: 'flex',
            flexWrap: 'wrap',
            [formItemCls]: {
                flex: 'none',
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                '&-row': {
                    flexWrap: 'nowrap'
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: 'inline-block',
                    verticalAlign: 'top'
                },
                [`> ${formItemCls}-label`]: {
                    flex: 'none'
                },
                [`${componentCls}-text`]: {
                    display: 'inline-block'
                },
                [`${formItemCls}-has-feedback`]: {
                    display: 'inline-block'
                }
            }
        }
    };
};
const $bae5eef873e1e43c$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: 'initial',
        textAlign: 'start',
        '> label': {
            margin: 0,
            '&::after': {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: 'hidden'
            }
        }
    });
const $bae5eef873e1e43c$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: 'wrap',
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: '0 0 100%',
                        maxWidth: '100%'
                    }
                }
            }
        }
    };
};
const $bae5eef873e1e43c$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                [`${formItemCls}-row`]: {
                    flexDirection: 'column'
                },
                [`${formItemCls}-label > label`]: {
                    height: 'auto'
                },
                [`${formItemCls}-control`]: {
                    width: '100%'
                },
                [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenXSMax)})`]: [
            $bae5eef873e1e43c$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $bae5eef873e1e43c$var$genItemVerticalStyle = (token)=>{
    const { formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: 'column'
            },
            [`${formItemCls}-label > label`]: {
                height: 'auto'
            },
            [`${formItemCls}-control`]: {
                width: '100%'
            }
        },
        [`${formItemCls}-vertical ${formItemCls}-label,
      ${antCls}-col-24${formItemCls}-label,
      ${antCls}-col-xl-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token),
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenXSMax)})`]: [
            $bae5eef873e1e43c$var$makeVerticalLayout(token),
            {
                [formItemCls]: {
                    [`${antCls}-col-xs-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
                }
            }
        ],
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenSMMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-sm-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenMDMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-md-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $aWTY1.unit)(token.screenLGMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-lg-24${formItemCls}-label`]: $bae5eef873e1e43c$var$makeVerticalLayoutLabel(token)
            }
        }
    };
};
const $bae5eef873e1e43c$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $bae5eef873e1e43c$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $8Olk9.merge)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $bae5eef873e1e43c$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Form', (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $bae5eef873e1e43c$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $bae5eef873e1e43c$var$genFormStyle(formToken),
        $bae5eef873e1e43c$var$genFormItemStyle(formToken),
        (0, $ccbYf.default)(formToken),
        $bae5eef873e1e43c$var$genHorizontalStyle(formToken, formToken.componentCls),
        $bae5eef873e1e43c$var$genHorizontalStyle(formToken, formToken.formItemCls),
        $bae5eef873e1e43c$var$genInlineStyle(formToken),
        $bae5eef873e1e43c$var$genVerticalStyle(formToken),
        $bae5eef873e1e43c$var$genItemVerticalStyle(formToken),
        (0, $ZA9h0.default)(formToken),
        (0, $d9Xyr.zoomIn)
    ];
}, $bae5eef873e1e43c$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});

});
parcelRegister("ccbYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e0fe42e8059e47c$export$2e2bcd8739ae039);
const $8e0fe42e8059e47c$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationFast} ${token.motionEaseInOut}`,
            '&-appear, &-enter': {
                opacity: 0,
                '&-active': {
                    opacity: 1
                }
            },
            '&-leave': {
                opacity: 1,
                '&-active': {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationFast} ${token.motionEaseInOut},
                     opacity ${token.motionDurationFast} ${token.motionEaseInOut},
                     transform ${token.motionDurationFast} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    '&-active': {
                        transform: 'translateY(0)',
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $8e0fe42e8059e47c$export$2e2bcd8739ae039 = $8e0fe42e8059e47c$var$genFormValidateMotionStyle;

});



parcelRegister("8JD5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $65c0d92b247c029a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useForm", () => (parcelRequire("1G2wQ")).default);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $8rj45 = parcelRequire("8rj45");
var $8nPZz = parcelRequire("8nPZz");

var $kjlvF = parcelRequire("kjlvF");

var $bpKJo = parcelRequire("bpKJo");

var $aogQV = parcelRequire("aogQV");

var $3m1Z3 = parcelRequire("3m1Z3");

var $fo0uV = parcelRequire("fo0uV");

var $7YqzN = parcelRequire("7YqzN");

var $1G2wQ = parcelRequire("1G2wQ");


var $g2QZ8 = parcelRequire("g2QZ8");

var $79Tx6 = parcelRequire("79Tx6");
"use client";
var $65c0d92b247c029a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $65c0d92b247c029a$var$InternalForm = (props, ref)=>{
    const contextDisabled = $aqdBs.useContext((0, $bpKJo.default));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle } = (0, $kjlvF.useComponentConfig)('form');
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, hideRequiredMark: hideRequiredMark, layout: layout = 'horizontal', scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant } = props, restFormProps = $65c0d92b247c029a$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name",
        "style",
        "feedbackIcons",
        "variant"
    ]);
    const mergedSize = (0, $3m1Z3.default)(size);
    const contextValidateMessages = $aqdBs.useContext((0, $79Tx6.default));
    const mergedRequiredMark = $aqdBs.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (hideRequiredMark) return false;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon !== null && colon !== void 0 ? colon : contextColon;
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $g2QZ8.default)(prefixCls, rootCls);
    const formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName);
    const [wrapForm] = (0, $1G2wQ.default)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $aqdBs.useMemo(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === 'vertical',
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons
    ]);
    const nativeElementRef = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(ref, ()=>{
        var _a;
        return Object.assign(Object.assign({}, wrapForm), {
            nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        });
    });
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: 'nearest'
            };
            if (typeof options === 'object') defaultScrollToFirstError = Object.assign(Object.assign({}, defaultScrollToFirstError), options);
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.VariantContext).Provider, {
        value: variant
    }, /*#__PURE__*/ $aqdBs.createElement((0, $bpKJo.DisabledContextProvider), {
        disabled: disabled
    }, /*#__PURE__*/ $aqdBs.createElement((0, $fo0uV.default).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormProvider), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormContext).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $aqdBs.createElement((0, $8rj45.default), Object.assign({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: Object.assign(Object.assign({}, contextStyle), style),
        className: formClassName
    }))))))));
};
const $65c0d92b247c029a$var$Form = /*#__PURE__*/ $aqdBs.forwardRef($65c0d92b247c029a$var$InternalForm);
var $65c0d92b247c029a$export$2e2bcd8739ae039 = $65c0d92b247c029a$var$Form;

});
parcelRegister("1G2wQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $138bacdc56be63cd$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("8rj45");
var $8CXnA = parcelRequire("8CXnA");

var $bTIJW = parcelRequire("bTIJW");

var $iDquh = parcelRequire("iDquh");

var $FDxid = parcelRequire("FDxid");
var $138bacdc56be63cd$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $138bacdc56be63cd$var$toNamePathStr(name) {
    const namePath = (0, $FDxid.toArray)(name);
    return namePath.join('_');
}
function $138bacdc56be63cd$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $bTIJW.getDOM)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $FDxid.getFieldId)((0, $FDxid.toArray)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $138bacdc56be63cd$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $8CXnA.default)();
    const itemsRef = $aqdBs.useRef({});
    const wrapForm = $aqdBs.useMemo(()=>form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $138bacdc56be63cd$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus } = options, restOpt = $138bacdc56be63cd$var$__rest(options, [
                    "focus"
                ]);
                const node = $138bacdc56be63cd$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $iDquh.default)(node, Object.assign({
                        scrollMode: 'if-needed',
                        block: 'nearest'
                    }, restOpt));
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                var _a, _b;
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof (itemRef === null || itemRef === void 0 ? void 0 : itemRef.focus) === 'function') itemRef.focus();
                else (_b = (_a = $138bacdc56be63cd$var$getFieldDOMNode(name, wrapForm)) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
            },
            getFieldInstance: (name)=>{
                const namePathStr = $138bacdc56be63cd$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        }), [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}

});
parcelRegister("iDquh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9106a5b9745d941$export$2e2bcd8739ae039);

var $bohZs = parcelRequire("bohZs");
const $d9106a5b9745d941$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $d9106a5b9745d941$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $bohZs.compute)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $bohZs.compute)(e, $d9106a5b9745d941$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}

});
parcelRegister("bohZs", function(module, exports) {

$parcel$export(module.exports, "compute", () => $84afe414f2660b16$export$3b12cb22b12b954b);
const $84afe414f2660b16$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $84afe414f2660b16$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $84afe414f2660b16$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $84afe414f2660b16$var$e(o.overflowY, n) || $84afe414f2660b16$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $84afe414f2660b16$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $84afe414f2660b16$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $84afe414f2660b16$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$84afe414f2660b16$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $84afe414f2660b16$var$t(W) && p(W);){
        if (W = $84afe414f2660b16$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $84afe414f2660b16$var$n(W) && !$84afe414f2660b16$var$n(document.documentElement) || null != W && $84afe414f2660b16$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$84afe414f2660b16$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $84afe414f2660b16$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $84afe414f2660b16$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $84afe414f2660b16$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $84afe414f2660b16$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};

});


parcelRegister("FDxid", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $07d27f78f614194c$export$45b10814cc054894);
$parcel$export(module.exports, "getFieldId", () => $07d27f78f614194c$export$f4457e83c74ac000);
$parcel$export(module.exports, "getStatus", () => $07d27f78f614194c$export$b70265791d2079d4);
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $07d27f78f614194c$var$formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const $07d27f78f614194c$var$defaultItemNamePrefixCls = 'form_item';
function $07d27f78f614194c$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $07d27f78f614194c$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $07d27f78f614194c$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$07d27f78f614194c$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $07d27f78f614194c$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}

});



parcelRegister("9x38Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f09a1f771051e71$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("8rj45");
var $5nc8d = parcelRequire("5nc8d");
var $lJsob = parcelRequire("lJsob");
var $hskPh = parcelRequire("hskPh");

var $7fRGY = parcelRequire("7fRGY");

var $kBwE8 = parcelRequire("kBwE8");

var $iOHOh = parcelRequire("iOHOh");

var $dkjPS = parcelRequire("dkjPS");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $7YqzN = parcelRequire("7YqzN");

var $ftKwU = parcelRequire("ftKwU");

var $dP1Dl = parcelRequire("dP1Dl");

var $734pL = parcelRequire("734pL");

var $7w6hl = parcelRequire("7w6hl");

var $g2QZ8 = parcelRequire("g2QZ8");

var $FDxid = parcelRequire("FDxid");

var $9g5U5 = parcelRequire("9g5U5");

var $31zrK = parcelRequire("31zrK");
"use client";
const $6f09a1f771051e71$var$NAME_SPLIT = '__SPLIT__';
const $6f09a1f771051e71$var$_ValidateStatuses = [
    'success',
    'warning',
    'error',
    'validating',
    ''
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $6f09a1f771051e71$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === 'function' || typeof propValueB === 'function';
    });
}
const $6f09a1f771051e71$var$MemoInput = /*#__PURE__*/ $aqdBs.memo(({ children: children })=>children, (prev, next)=>$6f09a1f771051e71$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $6f09a1f771051e71$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $6f09a1f771051e71$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = 'onChange', validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const { name: formName } = $aqdBs.useContext((0, $7YqzN.FormContext));
    const mergedChildren = (0, $ftKwU.default)(children);
    const isRenderProps = typeof mergedChildren === 'function';
    const notifyParentMetaChange = $aqdBs.useContext((0, $7YqzN.NoStyleItemContext));
    const { validateTrigger: contextValidateTrigger } = $aqdBs.useContext((0, $lJsob.default));
    const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    const hasName = !(name === undefined || name === null);
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    // Style
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $g2QZ8.default)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $dkjPS.devUseWarning)('Form.Item');
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $aqdBs.useContext((0, $hskPh.default));
    const fieldKeyPathRef = $aqdBs.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $734pL.default)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $7fRGY.default)(()=>$6f09a1f771051e71$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $6f09a1f771051e71$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $dMbbs.default)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = Object.assign({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $dMbbs.default)(subMeta.name.slice(0, -1)), (0, $dMbbs.default)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($6f09a1f771051e71$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $aqdBs.useMemo(()=>{
        const errorList = (0, $dMbbs.default)(meta.errors);
        const warningList = (0, $dMbbs.default)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $dMbbs.default)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $dMbbs.default)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $7w6hl.default)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $aqdBs.createElement((0, $31zrK.default), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true
        }, baseChildren);
        return /*#__PURE__*/ $aqdBs.createElement((0, $9g5U5.default), Object.assign({
            key: "row"
        }, props, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return wrapCSSVar(renderLayout(mergedChildren));
    let variables = {};
    if (typeof label === 'string') variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = Object.assign(Object.assign({}, variables), messageVariables);
    // >>>>> With Field
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $5nc8d.default), Object.assign({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), (control, renderMeta, context)=>{
        const mergedName = (0, $FDxid.toArray)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $FDxid.getFieldId)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!(rules === null || rules === void 0 ? void 0 : rules.some((rule)=>{
            if (rule && typeof rule === 'object' && rule.required && !rule.warningOnly) return true;
            if (typeof rule === 'function') {
                const ruleEntity = rule(context);
                return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
            }
            return false;
        }));
        // ======================= Children =======================
        const mergedControl = Object.assign({}, control);
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $aqdBs.isValidElement(mergedChildren)) {
            const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps['aria-describedby'] = describedbyArr.join(' ');
            }
            if (mergedErrors.length > 0) childProps['aria-invalid'] = 'true';
            if (isRequired) childProps['aria-required'] = 'true';
            if ((0, $kBwE8.supportRef)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $dMbbs.default)((0, $FDxid.toArray)(trigger)), (0, $dMbbs.default)((0, $FDxid.toArray)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    var _a2, _c2;
                    var _a, _b, _c;
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps['aria-required'],
                childProps['aria-invalid'],
                childProps['aria-describedby']
            ];
            childNode = /*#__PURE__*/ $aqdBs.createElement($6f09a1f771051e71$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $iOHOh.cloneElement)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    }));
}
const $6f09a1f771051e71$var$FormItem = $6f09a1f771051e71$var$InternalFormItem;
$6f09a1f771051e71$var$FormItem.useStatus = (0, $dP1Dl.default);
var $6f09a1f771051e71$export$2e2bcd8739ae039 = $6f09a1f771051e71$var$FormItem;

});
parcelRegister("ftKwU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b44da848455a2bef$export$2e2bcd8739ae039);

var $bZ6Ai = parcelRequire("bZ6Ai");
function $b44da848455a2bef$export$2e2bcd8739ae039(children) {
    if (typeof children === 'function') return children;
    const childList = (0, $bZ6Ai.default)(children);
    return childList.length <= 1 ? childList[0] : childList;
}

});

parcelRegister("dP1Dl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1014e312d54cde1$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");


var $7YqzN = parcelRequire("7YqzN");
const $a1014e312d54cde1$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $aqdBs.useContext((0, $7YqzN.FormItemInputContext));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$a1014e312d54cde1$var$useFormItemStatus.Context = (0, $7YqzN.FormItemInputContext);
var $a1014e312d54cde1$export$2e2bcd8739ae039 = $a1014e312d54cde1$var$useFormItemStatus;

});

parcelRegister("734pL", function(module, exports) {

$parcel$export(module.exports, "default", () => $521c3cde5256ba74$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $ebavw = parcelRequire("ebavw");
function $521c3cde5256ba74$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $aqdBs.useState(defaultValue);
    const frameRef = $aqdBs.useRef(null);
    const batchRef = $aqdBs.useRef([]);
    const destroyRef = $aqdBs.useRef(false);
    $aqdBs.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $ebavw.default).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $ebavw.default)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}

});

parcelRegister("7w6hl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5790645f154a1071$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $kBwE8 = parcelRequire("kBwE8");

var $7YqzN = parcelRequire("7YqzN");
function $5790645f154a1071$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $aqdBs.useContext((0, $7YqzN.FormContext));
    const cacheRef = $aqdBs.useRef({});
    function getRef(name, children) {
        // Outer caller already check the `supportRef`
        const childrenRef = children && typeof children === 'object' && (0, $kBwE8.getNodeRef)(children);
        const nameStr = name.join('_');
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $kBwE8.composeRef)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}

});

parcelRegister("9g5U5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bda3004d912b5b2$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $djRIe = parcelRequire("djRIe");

var $iEJaB = parcelRequire("iEJaB");

var $1iwLi = parcelRequire("1iwLi");

var $fuGj2 = parcelRequire("fuGj2");

var $7YqzN = parcelRequire("7YqzN");

var $amZZA = parcelRequire("amZZA");

var $gYFPo = parcelRequire("gYFPo");

var $bDm9q = parcelRequire("bDm9q");

var $FDxid = parcelRequire("FDxid");

var $31zrK = parcelRequire("31zrK");
"use client";
var $6bda3004d912b5b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6bda3004d912b5b2$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: layout } = props, restProps = $6bda3004d912b5b2$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "required",
        "isRequired",
        "onSubItemMetaChange",
        "layout"
    ]);
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, vertical: formVertical } = $aqdBs.useContext((0, $7YqzN.FormContext));
    const vertical = formVertical || layout === 'vertical';
    // ======================== Margin ========================
    const itemRef = $aqdBs.useRef(null);
    const debounceErrors = (0, $bDm9q.default)(errors);
    const debounceWarnings = (0, $bDm9q.default)(warnings);
    const hasHelp = help !== undefined && help !== null;
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $djRIe.default)(itemRef.current);
    const [marginBottom, setMarginBottom] = $aqdBs.useState(null);
    (0, $iEJaB.default)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $FDxid.getStatus)(_errors, _warnings, meta, '', !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === 'success',
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === 'warning',
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === 'error',
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === 'validating',
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $aqdBs.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $aqdBs.createElement((0, $fuGj2.default), Object.assign({
        className: `${itemPrefixCls}-row`
    }, (0, $1iwLi.default)(restProps, [
        '_internalItemRender',
        'colon',
        'dependencies',
        'extra',
        'fieldKey',
        'getValueFromEvent',
        'getValueProps',
        'htmlFor',
        'id',
        // It is deprecated because `htmlFor` is its replacement.
        'initialValue',
        'isListField',
        'label',
        'labelAlign',
        'labelCol',
        'labelWrap',
        'messageVariables',
        'name',
        'normalize',
        'noStyle',
        'preserve',
        'requiredMark',
        'rules',
        'shouldUpdate',
        'trigger',
        'tooltip',
        'validateFirst',
        'validateTrigger',
        'valuePropName',
        'wrapperCol',
        'validateDebounce'
    ])), /*#__PURE__*/ $aqdBs.createElement((0, $gYFPo.default), Object.assign({
        htmlFor: fieldId
    }, props, {
        requiredMark: requiredMark,
        required: required !== null && required !== void 0 ? required : isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    })), /*#__PURE__*/ $aqdBs.createElement((0, $amZZA.default), Object.assign({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.NoStyleItemContext).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $aqdBs.createElement((0, $31zrK.default), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus
    }, children)))), !!marginBottom && /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}

});
parcelRegister("fuGj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b47a797805d782f0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $9nZ6b = parcelRequire("9nZ6b");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $kHpYW = parcelRequire("kHpYW");

var $2j42m = parcelRequire("2j42m");

var $c8oE7 = parcelRequire("c8oE7");

var $amB8F = parcelRequire("amB8F");
"use client";
var $b47a797805d782f0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b47a797805d782f0$var$_RowAligns = [
    'top',
    'middle',
    'bottom',
    'stretch'
];
const $b47a797805d782f0$var$_RowJustify = [
    'start',
    'end',
    'center',
    'space-around',
    'space-between',
    'space-evenly'
];
function $b47a797805d782f0$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $aqdBs.useState(typeof oriProp === 'string' ? oriProp : '');
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === 'string') setProp(oriProp);
        if (typeof oriProp !== 'object') return;
        for(let i = 0; i < (0, $9nZ6b.responsiveArray).length; i++){
            const breakpoint = (0, $9nZ6b.responsiveArray)[i];
            // if do not match, do nothing
            if (!screen || !screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $aqdBs.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $b47a797805d782f0$var$Row = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap } = props, others = $b47a797805d782f0$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const screens = (0, $kHpYW.default)(true, null);
    const mergedAlign = $b47a797805d782f0$var$useMergedPropByScreen(align, screens);
    const mergedJustify = $b47a797805d782f0$var$useMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls('row', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $amB8F.useRowStyle)(prefixCls);
    const gutters = (0, $2j42m.default)(gutter, screens);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $aqdBs.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $c8oE7.default).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, others, {
        className: classes,
        style: Object.assign(Object.assign({}, rowStyle), style),
        ref: ref
    }), children)));
});
var $b47a797805d782f0$export$2e2bcd8739ae039 = $b47a797805d782f0$var$Row;

});
parcelRegister("9nZ6b", function(module, exports) {

$parcel$export(module.exports, "responsiveArray", () => $6d55a7fa9b6a7fe2$export$74c1bf8296b1541f);
$parcel$export(module.exports, "matchScreen", () => $6d55a7fa9b6a7fe2$export$862220c15691d248);
$parcel$export(module.exports, "default", () => $6d55a7fa9b6a7fe2$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $jygCN = parcelRequire("jygCN");

var $9WypM = parcelRequire("9WypM");
const $6d55a7fa9b6a7fe2$export$74c1bf8296b1541f = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $6d55a7fa9b6a7fe2$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $6d55a7fa9b6a7fe2$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($6d55a7fa9b6a7fe2$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $6d55a7fa9b6a7fe2$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $6d55a7fa9b6a7fe2$export$74c1bf8296b1541f){
        if (screens[breakpoint] && (screenSizes === null || screenSizes === void 0 ? void 0 : screenSizes[breakpoint]) !== undefined) return screenSizes[breakpoint];
    }
};
const $6d55a7fa9b6a7fe2$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $jygCN.default)();
    const responsiveMap = $6d55a7fa9b6a7fe2$var$getResponsiveMap($6d55a7fa9b6a7fe2$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch(Object.assign(Object.assign({}, screens), {
                            [screen]: matches
                        }));
                    };
                    const mql = window.matchMedia(mediaQuery);
                    (0, $9WypM.addMediaQueryListener)(mql, listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    (0, $9WypM.removeMediaQueryListener)(handler === null || handler === void 0 ? void 0 : handler.mql, handler === null || handler === void 0 ? void 0 : handler.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        token
    ]);
};
var $6d55a7fa9b6a7fe2$export$2e2bcd8739ae039 = $6d55a7fa9b6a7fe2$var$useResponsiveObserver;

});
parcelRegister("9WypM", function(module, exports) {

$parcel$export(module.exports, "addMediaQueryListener", () => $73d439ecc8d8128a$export$33d4bfa367d0ee08);
$parcel$export(module.exports, "removeMediaQueryListener", () => $73d439ecc8d8128a$export$8b5fab0a56c137c5);
const $73d439ecc8d8128a$export$33d4bfa367d0ee08 = (mql, handler)=>{
    // Don't delete here, please keep the code compatible
    if (typeof (mql === null || mql === void 0 ? void 0 : mql.addEventListener) !== 'undefined') mql.addEventListener('change', handler);
    else if (typeof (mql === null || mql === void 0 ? void 0 : mql.addListener) !== 'undefined') mql.addListener(handler);
};
const $73d439ecc8d8128a$export$8b5fab0a56c137c5 = (mql, handler)=>{
    // Don't delete here, please keep the code compatible
    if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeEventListener) !== 'undefined') mql.removeEventListener('change', handler);
    else if (typeof (mql === null || mql === void 0 ? void 0 : mql.removeListener) !== 'undefined') mql.removeListener(handler);
};

});


parcelRegister("kHpYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11bfa4aa0f401b8$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $iEJaB = parcelRequire("iEJaB");

var $f2pii = parcelRequire("f2pii");

var $9nZ6b = parcelRequire("9nZ6b");
"use client";
function $f11bfa4aa0f401b8$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $aqdBs.useRef)(defaultScreens);
    const forceUpdate = (0, $f2pii.default)();
    const responsiveObserver = (0, $9nZ6b.default)();
    (0, $iEJaB.default)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $f11bfa4aa0f401b8$export$2e2bcd8739ae039 = $f11bfa4aa0f401b8$var$useBreakpoint;

});
parcelRegister("f2pii", function(module, exports) {

$parcel$export(module.exports, "default", () => $af2aa9ccda760fa6$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $af2aa9ccda760fa6$export$2e2bcd8739ae039() {
    const [, forceUpdate] = $aqdBs.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}

});


parcelRegister("2j42m", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae07cc8d318ce06$export$2e2bcd8739ae039);

var $9nZ6b = parcelRequire("9nZ6b");
function $1ae07cc8d318ce06$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if (typeof g === 'object' && g !== null) for(let i = 0; i < (0, $9nZ6b.responsiveArray).length; i++){
            const breakpoint = (0, $9nZ6b.responsiveArray)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}

});


parcelRegister("amZZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $78cc0bd2f44ea4e0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("2UjQ5");
var $fGBDZ = parcelRequire("fGBDZ");
var $acNyW = parcelRequire("acNyW");

var $iEJaB = parcelRequire("iEJaB");

var $8OXWQ = parcelRequire("8OXWQ");

var $7YqzN = parcelRequire("7YqzN");

var $afIxp = parcelRequire("afIxp");

var $jjSIH = parcelRequire("jjSIH");
"use client";
var $78cc0bd2f44ea4e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $78cc0bd2f44ea4e0$var$GRID_MAX = 24;
const $78cc0bd2f44ea4e0$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $aqdBs.useContext((0, $7YqzN.FormContext));
    const mergedWrapperCol = $aqdBs.useMemo(()=>{
        let mergedWrapper = Object.assign({}, wrapperCol || formContext.wrapperCol || {});
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined,
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'xxl'
            ];
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $fGBDZ.default)(formContext.labelCol, _size);
                const formLabelObj = typeof formLabel === 'object' ? formLabel : {};
                const wrapper = (0, $fGBDZ.default)(mergedWrapper, _size);
                const wrapperObj = typeof wrapper === 'object' ? wrapper : {};
                if ('span' in formLabelObj && !('offset' in wrapperObj) && formLabelObj.span < $78cc0bd2f44ea4e0$var$GRID_MAX) mergedWrapper = (0, $acNyW.default)(mergedWrapper, [].concat(_size, [
                    'offset'
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext
    ]);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $aqdBs.useMemo(()=>{
        const { labelCol: labelCol, wrapperCol: wrapperCol } = formContext, rest = $78cc0bd2f44ea4e0$var$__rest(formContext, [
            "labelCol",
            "wrapperCol"
        ]);
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $aqdBs.useRef(null);
    const [extraHeight, setExtraHeight] = $aqdBs.useState(0);
    (0, $iEJaB.default)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${baseClassName}-control-input-content`
    }, children));
    const formItemContext = $aqdBs.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormItemPrefixContext).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $afIxp.default), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, extraProps, {
        className: `${baseClassName}-extra`,
        ref: extraRef
    }), extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === 'pro_table_render' && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormContext).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $8OXWQ.default), Object.assign({}, mergedWrapperCol, {
        className: className
    }), dom), /*#__PURE__*/ $aqdBs.createElement((0, $jjSIH.default), {
        prefixCls: prefixCls
    }));
};
var $78cc0bd2f44ea4e0$export$2e2bcd8739ae039 = $78cc0bd2f44ea4e0$var$FormItemInput;

});
parcelRegister("jjSIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10a3cf0075b5d33$export$2e2bcd8739ae039);
/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component

var $g2QZ8 = parcelRequire("g2QZ8");

var $4wPvn = parcelRequire("4wPvn");
// ============================= Fallback =============================
const $e10a3cf0075b5d33$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: 'flex'
            }
        }
    };
};
var // ============================== Export ==============================
$e10a3cf0075b5d33$export$2e2bcd8739ae039 = (0, $4wPvn.genSubStyleComponent)([
    'Form',
    'item-item'
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $g2QZ8.prepareToken)(token, rootPrefixCls);
    return [
        $e10a3cf0075b5d33$var$genFallbackStyle(formToken)
    ];
});

});


parcelRegister("gYFPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c2b21ab4cd698d$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $69ly0 = parcelRequire("69ly0");

var $bqPQ9 = parcelRequire("bqPQ9");

var $63sg0 = parcelRequire("63sg0");

var $8OXWQ = parcelRequire("8OXWQ");

var $h1ynd = parcelRequire("h1ynd");

var $iPGr2 = parcelRequire("iPGr2");

var $LGNg6 = parcelRequire("LGNg6");

var $7YqzN = parcelRequire("7YqzN");
"use client";
var $c5c2b21ab4cd698d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c5c2b21ab4cd698d$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    var _a;
    const [formLocale] = (0, $h1ynd.default)('Form');
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon } = $aqdBs.useContext((0, $7YqzN.FormContext));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(labelClsBasic, mergedLabelAlign === 'left' && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === 'string' && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, '');
    // Tooltip
    const tooltipProps = (0, $63sg0.default)(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $aqdBs.createElement((0, $69ly0.default), null) } = tooltipProps, restTooltipProps = $c5c2b21ab4cd698d$var$__rest(tooltipProps, [
            "icon"
        ]);
        const tooltipNode = /*#__PURE__*/ $aqdBs.createElement((0, $LGNg6.default), Object.assign({}, restTooltipProps), /*#__PURE__*/ $aqdBs.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: '',
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === 'optional';
    const isRenderMark = typeof requiredMark === 'function';
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, labelChildren, /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $iPGr2.default).Form) === null || _a === void 0 ? void 0 : _a.optional)));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = 'hidden';
    else if (isOptionalMark || isRenderMark) markType = 'optional';
    const labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $aqdBs.createElement((0, $8OXWQ.default), Object.assign({}, mergedLabelCol, {
        className: labelColClassName
    }), /*#__PURE__*/ $aqdBs.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        title: typeof label === 'string' ? label : ''
    }, labelChildren));
};
var $c5c2b21ab4cd698d$export$2e2bcd8739ae039 = $c5c2b21ab4cd698d$var$FormItemLabel;

});
parcelRegister("69ly0", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a44c32b7d0be69$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $cPUNx = parcelRequire("cPUNx");

var $gL7Ec = parcelRequire("gL7Ec");
var $47a44c32b7d0be69$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $cPUNx.default)
    }));
};
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ var $47a44c32b7d0be69$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($47a44c32b7d0be69$var$QuestionCircleOutlined);
var $47a44c32b7d0be69$export$2e2bcd8739ae039 = $47a44c32b7d0be69$var$RefIcon;

});
parcelRegister("cPUNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $95864e56c735dd89$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $95864e56c735dd89$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $95864e56c735dd89$export$2e2bcd8739ae039 = $95864e56c735dd89$var$QuestionCircleOutlined;

});


parcelRegister("63sg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4688f130fc8b5319$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $4688f130fc8b5319$var$convertToTooltipProps(tooltip) {
    // isNil
    if (tooltip === undefined || tooltip === null) return null;
    if (typeof tooltip === 'object' && !/*#__PURE__*/ (0, $aqdBs.isValidElement)(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
var $4688f130fc8b5319$export$2e2bcd8739ae039 = $4688f130fc8b5319$var$convertToTooltipProps;

});


parcelRegister("31zrK", function(module, exports) {

$parcel$export(module.exports, "default", () => $233cf60d0d7d37ef$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $azecD = parcelRequire("azecD");

var $4l6rq = parcelRequire("4l6rq");

var $gwifb = parcelRequire("gwifb");

var $5BZxE = parcelRequire("5BZxE");

var $bqPQ9 = parcelRequire("bqPQ9");

var $7YqzN = parcelRequire("7YqzN");

var $FDxid = parcelRequire("FDxid");
"use client";
const $233cf60d0d7d37ef$var$iconMap = {
    success: (0, $azecD.default),
    warning: (0, $gwifb.default),
    error: (0, $4l6rq.default),
    validating: (0, $5BZxE.default)
};
function $233cf60d0d7d37ef$export$2e2bcd8739ae039({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $aqdBs.useContext((0, $7YqzN.FormContext));
    const mergedValidateStatus = (0, $FDxid.getStatus)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon } = $aqdBs.useContext((0, $7YqzN.FormItemInputContext));
    // ====================== Context =======================
    const formItemStatusContext = $aqdBs.useMemo(()=>{
        var _a;
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
            const IconNode = mergedValidateStatus && $233cf60d0d7d37ef$var$iconMap[mergedValidateStatus];
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $aqdBs.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $aqdBs.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || '',
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || '';
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormItemInputContext).Provider, {
        value: formItemStatusContext
    }, children);
}

});



parcelRegister("5B5VU", function(module, exports) {

$parcel$export(module.exports, "default", () => $413502a4ac7ac355$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("8rj45");
var $enPe3 = parcelRequire("enPe3");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $7YqzN = parcelRequire("7YqzN");
"use client";
var $413502a4ac7ac355$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $413502a4ac7ac355$var$FormList = (_a)=>{
    var { prefixCls: customizePrefixCls, children: children } = _a, props = $413502a4ac7ac355$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('form', customizePrefixCls);
    const contextValue = $aqdBs.useMemo(()=>({
            prefixCls: prefixCls,
            status: 'error'
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $enPe3.default), Object.assign({}, props), (fields, operation, meta)=>/*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormItemPrefixContext).Provider, {
            value: contextValue
        }, children(fields.map((field)=>Object.assign(Object.assign({}, field), {
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $413502a4ac7ac355$export$2e2bcd8739ae039 = $413502a4ac7ac355$var$FormList;

});

parcelRegister("dy7Ge", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd468775e40b1a4$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $7YqzN = parcelRequire("7YqzN");
function $9dd468775e40b1a4$export$2e2bcd8739ae039() {
    const { form: form } = $aqdBs.useContext((0, $7YqzN.FormContext));
    return form;
}

});


parcelRegister("172oi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cf84ca4c65bc297$export$2e2bcd8739ae039);

var $5AuJ5 = parcelRequire("5AuJ5");

var $dvo59 = parcelRequire("dvo59");

var $3b7YP = parcelRequire("3b7YP");

var $f1fjg = parcelRequire("f1fjg");

var $1SDl9 = parcelRequire("1SDl9");

var $aWXec = parcelRequire("aWXec");
"use client";
const $0cf84ca4c65bc297$var$Input = (0, $dvo59.default);
$0cf84ca4c65bc297$var$Input.Group = (0, $5AuJ5.default);
$0cf84ca4c65bc297$var$Input.Search = (0, $1SDl9.default);
$0cf84ca4c65bc297$var$Input.TextArea = (0, $aWXec.default);
$0cf84ca4c65bc297$var$Input.Password = (0, $f1fjg.default);
$0cf84ca4c65bc297$var$Input.OTP = (0, $3b7YP.default);
var $0cf84ca4c65bc297$export$2e2bcd8739ae039 = $0cf84ca4c65bc297$var$Input;

});
parcelRegister("5AuJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4118261d6769f1c0$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $7YqzN = parcelRequire("7YqzN");

var $hBR2T = parcelRequire("hBR2T");
"use client";
/** @deprecated Please use `Space.Compact` */ const $4118261d6769f1c0$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [wrapCSSVar, hashId, cssVarCls] = (0, $hBR2T.default)(inputPrefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, $aqdBs.useContext)((0, $7YqzN.FormItemInputContext));
    const groupFormItemContext = (0, $aqdBs.useMemo)(()=>Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormItemInputContext).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $4118261d6769f1c0$export$2e2bcd8739ae039 = $4118261d6769f1c0$var$Group;

});
parcelRegister("hBR2T", function(module, exports) {

$parcel$export(module.exports, "genPlaceholderStyle", () => $cd1f0a1bc2782f56$export$92095d0f4c77bd56);
$parcel$export(module.exports, "genInputSmallStyle", () => $cd1f0a1bc2782f56$export$bb047f62c5a56f90);
$parcel$export(module.exports, "genBasicInputStyle", () => $cd1f0a1bc2782f56$export$8c9a381315f3ebcd);
$parcel$export(module.exports, "genInputGroupStyle", () => $cd1f0a1bc2782f56$export$ffe8b2a9bd2e5cfe);
$parcel$export(module.exports, "useSharedStyle", () => $cd1f0a1bc2782f56$export$de732caeaad5f68e);
$parcel$export(module.exports, "default", () => $cd1f0a1bc2782f56$export$2e2bcd8739ae039);
$parcel$export(module.exports, "initComponentToken", () => (parcelRequire("aYhX4")).initComponentToken);
$parcel$export(module.exports, "initInputToken", () => (parcelRequire("aYhX4")).initInputToken);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $46oWY = parcelRequire("46oWY");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $aYhX4 = parcelRequire("aYhX4");

var $i72MD = parcelRequire("i72MD");
const $cd1f0a1bc2782f56$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color: color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const $cd1f0a1bc2782f56$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $cd1f0a1bc2782f56$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $aWTY1.unit)(paddingBlockLG)} ${(0, $aWTY1.unit)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $cd1f0a1bc2782f56$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $aWTY1.unit)(token.paddingBlockSM)} ${(0, $aWTY1.unit)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $cd1f0a1bc2782f56$export$8c9a381315f3ebcd = (token)=>Object.assign(Object.assign({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, $aWTY1.unit)(token.paddingBlock)} ${(0, $aWTY1.unit)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $cd1f0a1bc2782f56$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        // Size
        '&-lg': Object.assign({}, $cd1f0a1bc2782f56$var$genInputLargeStyle(token)),
        '&-sm': Object.assign({}, $cd1f0a1bc2782f56$export$bb047f62c5a56f90(token)),
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const $cd1f0a1bc2782f56$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $cd1f0a1bc2782f56$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $cd1f0a1bc2782f56$export$bb047f62c5a56f90(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, $aWTY1.unit)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $aWTY1.unit)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $aWTY1.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: 'inherit',
                            border: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: 'none'
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $aWTY1.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: 'block'
        }, (0, $5kUb2.clearFix)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
const $cd1f0a1bc2782f56$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), $cd1f0a1bc2782f56$export$8c9a381315f3ebcd(token)), (0, $i72MD.genOutlinedStyle)(token)), (0, $i72MD.genFilledStyle)(token)), (0, $i72MD.genBorderlessStyle)(token)), (0, $i72MD.genUnderlinedStyle)(token)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        })
    };
};
const $cd1f0a1bc2782f56$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, $aWTY1.unit)(token.inputAffixPadding)}`
            }
        }
    };
};
const $cd1f0a1bc2782f56$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $cd1f0a1bc2782f56$export$8c9a381315f3ebcd(token)), {
            display: 'inline-flex',
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $cd1f0a1bc2782f56$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        }),
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const $cd1f0a1bc2782f56$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), $cd1f0a1bc2782f56$export$ffe8b2a9bd2e5cfe(token)), {
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': Object.assign(Object.assign(Object.assign({
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                }
            }, (0, $i72MD.genOutlinedGroupStyle)(token)), (0, $i72MD.genFilledGroupStyle)(token)), {
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            })
        })
    };
};
const $cd1f0a1bc2782f56$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [componentCls]: {
                '&:hover, &:focus': {
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-color-primary):not(${antCls}-btn-variant-text)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                height: token.controlHeight,
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        // Fix https://github.com/ant-design/ant-design/issues/47150
                        marginInlineEnd: -1,
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0,
                        boxShadow: 'none'
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-color-primary)`]: {
                        color: token.colorTextDescription,
                        '&:hover': {
                            color: token.colorPrimaryHover
                        },
                        '&:active': {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            inset: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            '&-large': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightLG
                }
            },
            '&-small': {
                [`${componentCls}-affix-wrapper, ${searchPrefixCls}-button`]: {
                    height: token.controlHeightSM
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
// ============================== Range ===============================
const $cd1f0a1bc2782f56$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $cd1f0a1bc2782f56$export$de732caeaad5f68e = (0, $4wPvn.genStyleHooks)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, $8Olk9.merge)(token, (0, $aYhX4.initInputToken)(token));
    return [
        $cd1f0a1bc2782f56$export$9a752c3888370836(inputToken),
        $cd1f0a1bc2782f56$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $aYhX4.initComponentToken), {
    resetFont: false
});
var $cd1f0a1bc2782f56$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, $8Olk9.merge)(token, (0, $aYhX4.initInputToken)(token));
    return [
        $cd1f0a1bc2782f56$var$genGroupStyle(inputToken),
        $cd1f0a1bc2782f56$var$genSearchInputStyle(inputToken),
        $cd1f0a1bc2782f56$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $46oWY.genCompactItemStyle)(inputToken)
    ];
}, (0, $aYhX4.initComponentToken), {
    resetFont: false
});

});
parcelRegister("aYhX4", function(module, exports) {

$parcel$export(module.exports, "initInputToken", () => $7fcd6ed0e6dfab7c$export$a157d95850191a12);
$parcel$export(module.exports, "initComponentToken", () => $7fcd6ed0e6dfab7c$export$bd8b682992bc9781);
parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
function $7fcd6ed0e6dfab7c$export$a157d95850191a12(token) {
    return (0, $8Olk9.merge)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $7fcd6ed0e6dfab7c$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};

});

parcelRegister("i72MD", function(module, exports) {

$parcel$export(module.exports, "genDisabledStyle", () => $d2fb0a28154e7d11$export$12789f962d420a93);
$parcel$export(module.exports, "genBaseOutlinedStyle", () => $d2fb0a28154e7d11$export$8c569e4cc3fd115f);
$parcel$export(module.exports, "genOutlinedStyle", () => $d2fb0a28154e7d11$export$53795bafd774ce02);
$parcel$export(module.exports, "genOutlinedGroupStyle", () => $d2fb0a28154e7d11$export$8f88f32c046ff727);
$parcel$export(module.exports, "genBorderlessStyle", () => $d2fb0a28154e7d11$export$b6de5da7f39edfcb);
$parcel$export(module.exports, "genFilledStyle", () => $d2fb0a28154e7d11$export$b8365cd7e6671d79);
$parcel$export(module.exports, "genFilledGroupStyle", () => $d2fb0a28154e7d11$export$542c0fce51b1d515);
$parcel$export(module.exports, "genUnderlinedStyle", () => $d2fb0a28154e7d11$export$34771e60e0439351);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $d2fb0a28154e7d11$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $d2fb0a28154e7d11$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': Object.assign({}, $d2fb0a28154e7d11$export$bf820fba296f2fd8((0, $8Olk9.merge)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
const $d2fb0a28154e7d11$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $d2fb0a28154e7d11$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $d2fb0a28154e7d11$export$8c569e4cc3fd115f(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $d2fb0a28154e7d11$export$53795bafd774ce02 = (token, extraStyles)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $d2fb0a28154e7d11$export$8c569e4cc3fd115f(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $d2fb0a28154e7d11$export$12789f962d420a93(token))
        }), $d2fb0a28154e7d11$var$genOutlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $d2fb0a28154e7d11$var$genOutlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $d2fb0a28154e7d11$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $d2fb0a28154e7d11$export$8f88f32c046ff727 = (token)=>({
        '&-outlined': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            }
        }, $d2fb0a28154e7d11$var$genOutlinedGroupStatusStyle(token, {
            status: 'error',
            addonBorderColor: token.colorError,
            addonColor: token.colorErrorText
        })), $d2fb0a28154e7d11$var$genOutlinedGroupStatusStyle(token, {
            status: 'warning',
            addonBorderColor: token.colorWarning,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: Object.assign({}, $d2fb0a28154e7d11$export$12789f962d420a93(token))
            }
        })
    });
const $d2fb0a28154e7d11$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        '&-borderless': Object.assign({
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            }
        }, extraStyles)
    };
};
/* ============== Filled ============== */ const $d2fb0a28154e7d11$var$genBaseFilledStyle = (token, options)=>{
    var _a;
    return {
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: (_a = options === null || options === void 0 ? void 0 : options.inputColor) !== null && _a !== void 0 ? _a : 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    };
};
const $d2fb0a28154e7d11$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $d2fb0a28154e7d11$var$genBaseFilledStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        })
    });
const $d2fb0a28154e7d11$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        '&-filled': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $d2fb0a28154e7d11$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $d2fb0a28154e7d11$export$12789f962d420a93(token))
        }), $d2fb0a28154e7d11$var$genFilledStatusStyle(token, {
            status: 'error',
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            inputColor: token.colorErrorText,
            affixColor: token.colorError
        })), $d2fb0a28154e7d11$var$genFilledStatusStyle(token, {
            status: 'warning',
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            inputColor: token.colorWarningText,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $d2fb0a28154e7d11$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $d2fb0a28154e7d11$export$542c0fce51b1d515 = (token)=>({
        '&-filled': Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            }
        }, $d2fb0a28154e7d11$var$genFilledGroupStatusStyle(token, {
            status: 'error',
            addonBg: token.colorErrorBg,
            addonColor: token.colorErrorText
        })), $d2fb0a28154e7d11$var$genFilledGroupStatusStyle(token, {
            status: 'warning',
            addonBg: token.colorWarningBg,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        })
    });
const $d2fb0a28154e7d11$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $aWTY1.unit)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.borderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.borderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $d2fb0a28154e7d11$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $d2fb0a28154e7d11$export$7617a11352d704b9(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $d2fb0a28154e7d11$export$34771e60e0439351 = (token, extraStyles)=>({
        '&-underlined': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $d2fb0a28154e7d11$export$7617a11352d704b9(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            }
        }), $d2fb0a28154e7d11$var$genUnderlinedStatusStyle(token, {
            status: 'error',
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $d2fb0a28154e7d11$var$genUnderlinedStatusStyle(token, {
            status: 'warning',
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });

});



parcelRegister("dvo59", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d50d9c9e089a27c$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $fwyGL = parcelRequire("fwyGL");

var $5egt2 = parcelRequire("5egt2");

var $kBwE8 = parcelRequire("kBwE8");

var $cQKK1 = parcelRequire("cQKK1");

var $6683J = parcelRequire("6683J");

var $iQ4Ey = parcelRequire("iQ4Ey");


var $kjlvF = parcelRequire("kjlvF");

var $bpKJo = parcelRequire("bpKJo");

var $aogQV = parcelRequire("aogQV");

var $3m1Z3 = parcelRequire("3m1Z3");

var $7YqzN = parcelRequire("7YqzN");

var $30zio = parcelRequire("30zio");

var $O3SCq = parcelRequire("O3SCq");

var $8Ol8J = parcelRequire("8Ol8J");

var $hBR2T = parcelRequire("hBR2T");

var $5kvlm = parcelRequire("5kvlm");
"use client";
var $9d50d9c9e089a27c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9d50d9c9e089a27c$var$Input = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classes, variant: customVariant } = props, rest = $9d50d9c9e089a27c$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames",
        "variant"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $kjlvF.useComponentConfig)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, $aqdBs.useRef)(null);
    // Style
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapSharedCSSVar, hashId, cssVarCls] = (0, $hBR2T.useSharedStyle)(prefixCls, rootClassName);
    const [wrapCSSVar] = (0, $hBR2T.default)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $O3SCq.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $3m1Z3.default)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $bpKJo.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $aqdBs.useContext)((0, $7YqzN.FormItemInputContext));
    const mergedStatus = (0, $iQ4Ey.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $5kvlm.hasPrefixSuffix)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $aqdBs.useRef)(inputHasPrefixSuffix);
    var _a;
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $8Ol8J.default)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $6683J.default)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
    const [variant, enableVariantCls] = (0, $30zio.default)('input', customVariant, bordered);
    return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $fwyGL.default), Object.assign({
        ref: (0, $kBwE8.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, contextStyle), style),
        styles: Object.assign(Object.assign({}, contextStyles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $cQKK1.default), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $cQKK1.default), {
            form: true,
            space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, classes === null || classes === void 0 ? void 0 : classes.input, contextClassNames.input, hashId),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $iQ4Ey.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $iQ4Ey.getStatusClassNames)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
    }))));
});
var $9d50d9c9e089a27c$export$2e2bcd8739ae039 = $9d50d9c9e089a27c$var$Input;

});
parcelRegister("fwyGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d4c0a030ab9040$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BaseInput", () => (parcelRequire("51ZdQ")).default);

var $51ZdQ = parcelRequire("51ZdQ");

var $8jPz7 = parcelRequire("8jPz7");
var $b4d4c0a030ab9040$export$2e2bcd8739ae039 = (0, $8jPz7.default);

});
parcelRegister("51ZdQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9c893450f78c76$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $7IgoF = parcelRequire("7IgoF");

var $bqPQ9 = parcelRequire("bqPQ9");

var $aqdBs = parcelRequire("aqdBs");

var $5egt2 = parcelRequire("5egt2");
var $3a9c893450f78c76$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
    var _props, _props2, _props3;
    var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components, onClear = props.onClear;
    var inputElement = children !== null && children !== void 0 ? children : inputEl;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || 'span';
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || 'span';
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || 'span';
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || 'span';
    var containerRef = (0, $aqdBs.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    var hasAffix = (0, $5egt2.hasPrefixSuffix)(props);
    var element = /*#__PURE__*/ (0, $aqdBs.cloneElement)(inputElement, {
        value: value,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))((_props = inputElement.props) === null || _props === void 0 ? void 0 : _props.className, !hasAffix && (classNames === null || classNames === void 0 ? void 0 : classNames.variant)) || null
    });
    // ======================== Ref ======================== //
    var groupRef = (0, $aqdBs.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useImperativeHandle(ref, function() {
        return {
            nativeElement: groupRef.current || containerRef.current
        };
    });
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        var clearIcon = null;
        if (allowClear) {
            var needClear = !disabled && !readOnly && value;
            var clearIconCls = "".concat(prefixCls, "-clear-icon");
            var iconNode = (0, $7IgoF.default)(allowClear) === 'object' && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: function onClick(event) {
                    handleReset === null || handleReset === void 0 || handleReset(event);
                    onClear === null || onClear === void 0 || onClear();
                },
                onMouseDown: function onMouseDown(e) {
                    return e.preventDefault();
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(clearIconCls, (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(clearIconCls, "-hidden"), !needClear), "".concat(clearIconCls, "-has-suffix"), !!suffix))
            }, iconNode);
        }
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(affixWrapperPrefixCls, (0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-disabled"), disabled), "".concat(affixWrapperPrefixCls, "-focused"), focused), "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.variant);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(AffixWrapperComponent, (0, $13KW1.default)({
            className: affixWrapperCls,
            style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $5egt2.hasAddon)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(groupWrapperCls, (0, $br1G4.default)({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames === null || classNames === void 0 ? void 0 : classNames.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(element, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))((_props2 = element.props) === null || _props2 === void 0 ? void 0 : _props2.className, className) || null,
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, (_props3 = element.props) === null || _props3 === void 0 ? void 0 : _props3.style), style),
        hidden: hidden
    });
});
var $3a9c893450f78c76$export$2e2bcd8739ae039 = $3a9c893450f78c76$var$BaseInput;

});
parcelRegister("5egt2", function(module, exports) {

$parcel$export(module.exports, "hasAddon", () => $3ceb089fe87a262b$export$ae6255aa850a31d1);
$parcel$export(module.exports, "hasPrefixSuffix", () => $3ceb089fe87a262b$export$a19010aeeaa0c7a);
$parcel$export(module.exports, "resolveOnChange", () => $3ceb089fe87a262b$export$c28984794956ddc0);
$parcel$export(module.exports, "triggerFocus", () => $3ceb089fe87a262b$export$2b92016deb0b7aad);
function $3ceb089fe87a262b$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $3ceb089fe87a262b$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $3ceb089fe87a262b$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    var currentTarget = target.cloneNode(true);
    // click clear icon
    var newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
        target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
}
function $3ceb089fe87a262b$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $3ceb089fe87a262b$var$cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = $3ceb089fe87a262b$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}
function $3ceb089fe87a262b$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}

});


parcelRegister("8jPz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e818ea78095ee8$export$2e2bcd8739ae039);

var $4f2X8 = parcelRequire("4f2X8");

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");

var $eAKDF = parcelRequire("eAKDF");

var $1iwLi = parcelRequire("1iwLi");

var $aqdBs = parcelRequire("aqdBs");

var $51ZdQ = parcelRequire("51ZdQ");

var $5c8Fx = parcelRequire("5c8Fx");

var $5egt2 = parcelRequire("5egt2");
var $60e818ea78095ee8$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "onKeyUp",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $60e818ea78095ee8$var$Input = /*#__PURE__*/ (0, $aqdBs.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-input' : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $aX4Fp.default)(props, $60e818ea78095ee8$var$_excluded);
    var _useState = (0, $aqdBs.useState)(false), _useState2 = (0, $kelIR.default)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, $aqdBs.useRef)(false);
    var keyLockRef = (0, $aqdBs.useRef)(false);
    var inputRef = (0, $aqdBs.useRef)(null);
    var holderRef = (0, $aqdBs.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $5egt2.triggerFocus)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $eAKDF.default)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    var _useState3 = (0, $aqdBs.useState)(null), _useState4 = (0, $kelIR.default)(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
    // ====================== Count =======================
    var countConfig = (0, $5c8Fx.default)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $aqdBs.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current,
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
        };
    });
    (0, $aqdBs.useEffect)(function() {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue, info) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $5egt2.resolveOnChange)(inputRef.current, e, onChange, cutValue);
    };
    (0, $aqdBs.useEffect)(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $dMbbs.default)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleKeyUp = function handleKeyUp(e) {
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        if (inputRef.current) (0, $5egt2.resolveOnChange)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $1iwLi.default)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("input", (0, $13KW1.default)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, (0, $br1G4.default)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-show-count-suffix"), (0, $br1G4.default)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $4f2X8.default)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $51ZdQ.default), (0, $13KW1.default)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $60e818ea78095ee8$export$2e2bcd8739ae039 = $60e818ea78095ee8$var$Input;

});
parcelRegister("5c8Fx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c84cc3b15cadc3c$export$2e2bcd8739ae039);

var $aX4Fp = parcelRequire("aX4Fp");

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");

var $aqdBs = parcelRequire("aqdBs");
var $3c84cc3b15cadc3c$var$_excluded = [
    "show"
];
function $3c84cc3b15cadc3c$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $3c84cc3b15cadc3c$export$2e2bcd8739ae039(count, showCount) {
    return $aqdBs.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $7IgoF.default)(showCount) === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $4f2X8.default)((0, $4f2X8.default)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $aX4Fp.default)(_ref, $3c84cc3b15cadc3c$var$_excluded);
        return (0, $4f2X8.default)((0, $4f2X8.default)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}

});



parcelRegister("6683J", function(module, exports) {

$parcel$export(module.exports, "default", () => $47098dfbc589ef88$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $4l6rq = parcelRequire("4l6rq");
"use client";
const $47098dfbc589ef88$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $4l6rq.default), null)
    };
    return mergedAllowClear;
};
var $47098dfbc589ef88$export$2e2bcd8739ae039 = $47098dfbc589ef88$var$getAllowClear;

});

parcelRegister("iQ4Ey", function(module, exports) {

$parcel$export(module.exports, "getStatusClassNames", () => $db70b152f53c677c$export$b08e7b47149942a2);
$parcel$export(module.exports, "getMergedStatus", () => $db70b152f53c677c$export$314e193082d7ba49);

var $bqPQ9 = parcelRequire("bqPQ9");
const $db70b152f53c677c$var$_InputStatuses = [
    'warning',
    'error',
    ''
];
function $db70b152f53c677c$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $db70b152f53c677c$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;

});

parcelRegister("30zio", function(module, exports) {

$parcel$export(module.exports, "default", () => $230cc02dac0a41e9$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $7YqzN = parcelRequire("7YqzN");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
var $kjlvF = parcelRequire("kjlvF");
/**
 * Compatible for legacy `bordered` prop.
 */ const $230cc02dac0a41e9$var$useVariant = (component, variant, legacyBordered)=>{
    var _a, _b;
    const { variant: configVariant, [component]: componentConfig } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const ctxVariant = $aqdBs.useContext((0, $7YqzN.VariantContext));
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : 'outlined';
    const enableVariantCls = (0, $kjlvF.Variants).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $230cc02dac0a41e9$export$2e2bcd8739ae039 = $230cc02dac0a41e9$var$useVariant;

});

parcelRegister("8Ol8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a3642cf00621d5$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
function $66a3642cf00621d5$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $aqdBs.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute('type')) === 'password' && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute('value'))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute('value');
        }));
    };
    (0, $aqdBs.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}

});

parcelRegister("5kvlm", function(module, exports) {

$parcel$export(module.exports, "hasPrefixSuffix", () => $3e172232218e9d08$export$a19010aeeaa0c7a);
function $3e172232218e9d08$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}

});


parcelRegister("3b7YP", function(module, exports) {

$parcel$export(module.exports, "default", () => $250896d9dbe1bcdc$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $k91S5 = parcelRequire("k91S5");

var $bWa8g = parcelRequire("bWa8g");

var $iQ4Ey = parcelRequire("iQ4Ey");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $3m1Z3 = parcelRequire("3m1Z3");

var $7YqzN = parcelRequire("7YqzN");

var $d8F2i = parcelRequire("d8F2i");

var $a8t4h = parcelRequire("a8t4h");
"use client";
var $250896d9dbe1bcdc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $250896d9dbe1bcdc$var$strToArr(str) {
    return (str || '').split('');
}
const $250896d9dbe1bcdc$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-separator`
    }, separatorNode);
};
const $250896d9dbe1bcdc$var$OTP = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, onInput: onInput, inputMode: inputMode } = props, restProps = $250896d9dbe1bcdc$var$__rest(props, [
        "prefixCls",
        "length",
        "size",
        "defaultValue",
        "value",
        "onChange",
        "formatter",
        "separator",
        "variant",
        "disabled",
        "status",
        "autoFocus",
        "mask",
        "type",
        "onInput",
        "inputMode"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const domAttrs = (0, $bWa8g.default)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d8F2i.default)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $3m1Z3.default)((ctx)=>customSize !== null && customSize !== void 0 ? customSize : ctx);
    // ======================== Status ========================
    const formContext = $aqdBs.useContext((0, $7YqzN.FormItemInputContext));
    const mergedStatus = (0, $iQ4Ey.getMergedStatus)(formContext.status, customStatus);
    const proxyFormContext = $aqdBs.useMemo(()=>Object.assign(Object.assign({}, formContext), {
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $aqdBs.useRef(null);
    const refs = $aqdBs.useRef({});
    $aqdBs.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                (_a = refs.current[0]) === null || _a === void 0 || _a.focus();
            },
            blur: ()=>{
                var _a;
                for(let i = 0; i < length; i += 1)(_a = refs.current[i]) === null || _a === void 0 || _a.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $aqdBs.useState(()=>$250896d9dbe1bcdc$var$strToArr(internalFormatter(defaultValue || '')));
    $aqdBs.useEffect(()=>{
        if (value !== undefined) setValueCells($250896d9dbe1bcdc$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $k91S5.default)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, $k91S5.default)((index, txt)=>{
        let nextCells = (0, $dMbbs.default)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($250896d9dbe1bcdc$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = $250896d9dbe1bcdc$var$strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        var _a;
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        var _a;
        (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode
    };
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", Object.assign({}, domAttrs, {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId),
        role: "group"
    }), /*#__PURE__*/ $aqdBs.createElement((0, $7YqzN.FormItemInputContext).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, {
            key: key
        }, /*#__PURE__*/ $aqdBs.createElement((0, $a8t4h.default), Object.assign({
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: `${prefixCls}-input`,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus
        }, inputSharedProps)), index < length - 1 && /*#__PURE__*/ $aqdBs.createElement($250896d9dbe1bcdc$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls
        }));
    }))));
});
var $250896d9dbe1bcdc$export$2e2bcd8739ae039 = $250896d9dbe1bcdc$var$OTP;

});
parcelRegister("d8F2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $990bda9f3f47fe50$export$2e2bcd8739ae039);

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $aYhX4 = parcelRequire("aYhX4");
// =============================== OTP ================================
const $990bda9f3f47fe50$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: 'var(--ant-color-text)'
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$990bda9f3f47fe50$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, $8Olk9.merge)(token, (0, $aYhX4.initInputToken)(token));
    return [
        $990bda9f3f47fe50$var$genOTPStyle(inputToken)
    ];
}, (0, $aYhX4.initComponentToken));

});

parcelRegister("a8t4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $76113305bdbbcd05$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $ebavw = parcelRequire("ebavw");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $dvo59 = parcelRequire("dvo59");
"use client";
var $76113305bdbbcd05$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $76113305bdbbcd05$var$OTPInput = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask } = props, restProps = $76113305bdbbcd05$var$__rest(props, [
        "className",
        "value",
        "onChange",
        "onActiveChange",
        "index",
        "mask"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $ebavw.default)(()=>{
            var _a;
            const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        syncSelection();
    };
    const onInternalKeyUp = (e)=>{
        if (e.key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $aqdBs.createElement((0, $dvo59.default), Object.assign({
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text'
    }, restProps, {
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: syncSelection,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    })));
});
var $76113305bdbbcd05$export$2e2bcd8739ae039 = $76113305bdbbcd05$var$OTPInput;

});


parcelRegister("f1fjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $aef2d334c004d942$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $gNQaz = parcelRequire("gNQaz");

var $aduIk = parcelRequire("aduIk");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");

var $kBwE8 = parcelRequire("kBwE8");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $bpKJo = parcelRequire("bpKJo");

var $8Ol8J = parcelRequire("8Ol8J");

var $dvo59 = parcelRequire("dvo59");
"use client";
var $aef2d334c004d942$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $aef2d334c004d942$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $aqdBs.createElement((0, $aduIk.default), null) : /*#__PURE__*/ $aqdBs.createElement((0, $gNQaz.default), null);
const $aef2d334c004d942$var$actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const $aef2d334c004d942$var$Password = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = 'click', visibilityToggle: visibilityToggle = true, iconRender: iconRender = $aef2d334c004d942$var$defaultIconRender } = props;
    // ===================== Disabled =====================
    const disabled = $aqdBs.useContext((0, $bpKJo.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $aqdBs.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $aqdBs.useRef)(null);
    $aqdBs.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $8Ol8J.default)(inputRef);
    const onVisibleChange = ()=>{
        var _a;
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $aef2d334c004d942$var$actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $aqdBs.cloneElement(/*#__PURE__*/ $aqdBs.isValidElement(icon) ? icon : /*#__PURE__*/ $aqdBs.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size } = props, restProps = $aef2d334c004d942$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = Object.assign(Object.assign({}, (0, $1iwLi.default)(restProps, [
        'suffix',
        'iconRender',
        'visibilityToggle'
    ])), {
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $aqdBs.createElement((0, $dvo59.default), Object.assign({
        ref: (0, $kBwE8.composeRef)(ref, inputRef)
    }, omittedProps));
});
var $aef2d334c004d942$export$2e2bcd8739ae039 = $aef2d334c004d942$var$Password;

});
parcelRegister("gNQaz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3b9b0b5d105f87d$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $5bwE8 = parcelRequire("5bwE8");

var $gL7Ec = parcelRequire("gL7Ec");
var $c3b9b0b5d105f87d$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $5bwE8.default)
    }));
};
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ var $c3b9b0b5d105f87d$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($c3b9b0b5d105f87d$var$EyeInvisibleOutlined);
var $c3b9b0b5d105f87d$export$2e2bcd8739ae039 = $c3b9b0b5d105f87d$var$RefIcon;

});
parcelRegister("5bwE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c674db196247565$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $3c674db196247565$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $3c674db196247565$export$2e2bcd8739ae039 = $3c674db196247565$var$EyeInvisibleOutlined;

});


parcelRegister("aduIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7702f16b18f613f1$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $2MLy0 = parcelRequire("2MLy0");

var $gL7Ec = parcelRequire("gL7Ec");
var $7702f16b18f613f1$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $2MLy0.default)
    }));
};
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ var $7702f16b18f613f1$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($7702f16b18f613f1$var$EyeOutlined);
var $7702f16b18f613f1$export$2e2bcd8739ae039 = $7702f16b18f613f1$var$RefIcon;

});
parcelRegister("2MLy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2074f26e4d4f1320$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $2074f26e4d4f1320$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $2074f26e4d4f1320$export$2e2bcd8739ae039 = $2074f26e4d4f1320$var$EyeOutlined;

});



parcelRegister("1SDl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e959bf77e8bda5$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $h649e = parcelRequire("h649e");

var $bqPQ9 = parcelRequire("bqPQ9");

var $kBwE8 = parcelRequire("kBwE8");

var $iOHOh = parcelRequire("iOHOh");

var $ffbQF = parcelRequire("ffbQF");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $3m1Z3 = parcelRequire("3m1Z3");

var $O3SCq = parcelRequire("O3SCq");

var $dvo59 = parcelRequire("dvo59");
"use client";
var $15e959bf77e8bda5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $15e959bf77e8bda5$var$Search = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, suffix: suffix, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: variant, onPressEnter: customOnPressEnter } = props, restProps = $15e959bf77e8bda5$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd",
        "variant",
        "onPressEnter"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const composedRef = $aqdBs.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const { compactSize: compactSize } = (0, $O3SCq.useCompactItemContext)(prefixCls, direction);
    const size = (0, $3m1Z3.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const inputRef = $aqdBs.useRef(null);
    const onChange = (e)=>{
        if ((e === null || e === void 0 ? void 0 : e.target) && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange === null || customOnChange === void 0 || customOnChange(e);
    };
    const onMouseDown = (e)=>{
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    const onSearch = (e)=>{
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter === null || customOnPressEnter === void 0 || customOnPressEnter(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ $aqdBs.createElement((0, $h649e.default), null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, $iOHOh.cloneElement)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: 'enterButton'
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $aqdBs.createElement((0, $ffbQF.default), {
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $iOHOh.cloneElement)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    const inputProps = Object.assign(Object.assign({}, restProps), {
        className: cls,
        prefixCls: inputPrefixCls,
        type: 'search',
        size: size,
        variant: variant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        disabled: disabled
    });
    return /*#__PURE__*/ $aqdBs.createElement((0, $dvo59.default), Object.assign({
        ref: (0, $kBwE8.composeRef)(inputRef, ref)
    }, inputProps));
});
var $15e959bf77e8bda5$export$2e2bcd8739ae039 = $15e959bf77e8bda5$var$Search;

});
parcelRegister("h649e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72636e4696ecc6f$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $fIbIC = parcelRequire("fIbIC");

var $gL7Ec = parcelRequire("gL7Ec");
var $c72636e4696ecc6f$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $fIbIC.default)
    }));
};
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ var $c72636e4696ecc6f$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($c72636e4696ecc6f$var$SearchOutlined);
var $c72636e4696ecc6f$export$2e2bcd8739ae039 = $c72636e4696ecc6f$var$RefIcon;

});
parcelRegister("fIbIC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7040e248591e738$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $b7040e248591e738$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $b7040e248591e738$export$2e2bcd8739ae039 = $b7040e248591e738$var$SearchOutlined;

});



parcelRegister("aWXec", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8d439e4698abc8$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $Ia57p = parcelRequire("Ia57p");

var $6683J = parcelRequire("6683J");

var $iQ4Ey = parcelRequire("iQ4Ey");


var $kjlvF = parcelRequire("kjlvF");

var $bpKJo = parcelRequire("bpKJo");

var $aogQV = parcelRequire("aogQV");

var $3m1Z3 = parcelRequire("3m1Z3");

var $7YqzN = parcelRequire("7YqzN");

var $30zio = parcelRequire("30zio");

var $O3SCq = parcelRequire("O3SCq");

var $5egt2 = parcelRequire("5egt2");

var $hBR2T = parcelRequire("hBR2T");

var $ffcu2 = parcelRequire("ffcu2");
"use client";
var $7f8d439e4698abc8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7f8d439e4698abc8$var$TextArea = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize } = props, rest = $7f8d439e4698abc8$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className",
        "style",
        "styles",
        "variant",
        "showCount",
        "onMouseDown",
        "onResize"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $kjlvF.useComponentConfig)('textArea');
    // =================== Disabled ===================
    const disabled = $aqdBs.useContext((0, $bpKJo.default));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $aqdBs.useContext((0, $7YqzN.FormItemInputContext));
    const mergedStatus = (0, $iQ4Ey.getMergedStatus)(contextStatus, customStatus);
    // ===================== Ref ======================
    const innerRef = $aqdBs.useRef(null);
    $aqdBs.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $5egt2.triggerFocus)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapSharedCSSVar, hashId, cssVarCls] = (0, $hBR2T.useSharedStyle)(prefixCls, rootClassName);
    const [wrapCSSVar] = (0, $ffcu2.default)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $O3SCq.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $3m1Z3.default)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const [variant, enableVariantCls] = (0, $30zio.default)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, $6683J.default)(allowClear !== null && allowClear !== void 0 ? allowClear : contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $aqdBs.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $aqdBs.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown === null || onMouseDown === void 0 || onMouseDown(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        var _a, _b;
        onResize === null || onResize === void 0 || onResize(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = (_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return wrapSharedCSSVar(wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $Ia57p.default), Object.assign({
        autoComplete: contextAutoComplete
    }, rest, {
        style: Object.assign(Object.assign({}, contextStyle), style),
        styles: Object.assign(Object.assign({}, contextStyles), styles),
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, // Only for wrapper
        resizeDirty && `${prefixCls}-textarea-affix-wrapper-resize-dirty`),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), contextClassNames), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, contextClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $iQ4Ey.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
            }, hashId)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $aqdBs.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    }))));
});
var $7f8d439e4698abc8$export$2e2bcd8739ae039 = $7f8d439e4698abc8$var$TextArea;

});
parcelRegister("Ia57p", function(module, exports) {

$parcel$export(module.exports, "default", () => $084bee29922ab503$export$2e2bcd8739ae039);

var $1RqpS = parcelRequire("1RqpS");

var $2x49V = parcelRequire("2x49V");
var $084bee29922ab503$export$2e2bcd8739ae039 = (0, $1RqpS.default);

});
parcelRegister("1RqpS", function(module, exports) {

$parcel$export(module.exports, "default", () => $15af3b6ee0b9556e$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $dMbbs = parcelRequire("dMbbs");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("fwyGL");
var $51ZdQ = parcelRequire("51ZdQ");

var $5c8Fx = parcelRequire("5c8Fx");

var $5egt2 = parcelRequire("5egt2");

var $eAKDF = parcelRequire("eAKDF");

var $aqdBs = parcelRequire("aqdBs");

var $2x49V = parcelRequire("2x49V");
var $15af3b6ee0b9556e$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize",
    "onClear",
    "onPressEnter",
    "readOnly",
    "autoSize",
    "onKeyDown"
];
var $15af3b6ee0b9556e$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(_ref, ref) {
    var _countConfig$max;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? 'rc-textarea' : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, onClear = _ref.onClear, onPressEnter = _ref.onPressEnter, readOnly = _ref.readOnly, autoSize = _ref.autoSize, onKeyDown = _ref.onKeyDown, rest = (0, $aX4Fp.default)(_ref, $15af3b6ee0b9556e$var$_excluded);
    var _useMergedState = (0, $eAKDF.default)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? '' : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState(false), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState(null), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var holderRef = (0, $aqdBs.useRef)(null);
    var resizableTextAreaRef = (0, $aqdBs.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $aqdBs.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            },
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
        };
    });
    (0, $aqdBs.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState(null), _React$useState6 = (0, $kelIR.default)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $dMbbs.default)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $5c8Fx.default)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $5egt2.resolveOnChange)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue('');
        focus();
        (0, $5egt2.resolveOnChange)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : '');
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $51ZdQ.default), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: (0, $4f2X8.default)((0, $4f2X8.default)({}, classNames), {}, {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, (0, $br1G4.default)((0, $br1G4.default)({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
        }),
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, style), textareaResized && !isPureTextArea ? {
            height: 'auto'
        } : {}),
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $2x49V.default), (0, $13KW1.default)({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
            resize: style === null || style === void 0 ? void 0 : style.resize
        }),
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $15af3b6ee0b9556e$export$2e2bcd8739ae039 = $15af3b6ee0b9556e$var$TextArea;

});
parcelRegister("2x49V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d81e3bc776414f0$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $4f2X8 = parcelRequire("4f2X8");

var $7IgoF = parcelRequire("7IgoF");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $bqPQ9 = parcelRequire("bqPQ9");

var $jeSJT = parcelRequire("jeSJT");

var $iEJaB = parcelRequire("iEJaB");

var $eAKDF = parcelRequire("eAKDF");

var $ebavw = parcelRequire("ebavw");

var $aqdBs = parcelRequire("aqdBs");

var $7z0St = parcelRequire("7z0St");
var $1d81e3bc776414f0$var$_excluded = [
    "prefixCls",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $1d81e3bc776414f0$var$RESIZE_START = 0;
var $1d81e3bc776414f0$var$RESIZE_MEASURING = 1;
var $1d81e3bc776414f0$var$RESIZE_STABLE = 2;
var $1d81e3bc776414f0$var$ResizableTextArea = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $aX4Fp.default)(_ref, $1d81e3bc776414f0$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $eAKDF.default)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : '';
        }
    }), _useMergedState2 = (0, $kelIR.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $aqdBs.useRef();
    $aqdBs.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $aqdBs.useMemo(function() {
        if (autoSize && (0, $7IgoF.default)(autoSize) === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $kelIR.default)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $aqdBs.useState($1d81e3bc776414f0$var$RESIZE_STABLE), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $aqdBs.useState(), _React$useState4 = (0, $kelIR.default)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($1d81e3bc776414f0$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $iEJaB.default)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $iEJaB.default)(function() {
        if (resizeState === $1d81e3bc776414f0$var$RESIZE_START) setResizeState($1d81e3bc776414f0$var$RESIZE_MEASURING);
        else if (resizeState === $1d81e3bc776414f0$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $7z0St.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($1d81e3bc776414f0$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $aqdBs.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $ebavw.default).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $1d81e3bc776414f0$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $ebavw.default)(function() {
                    startResize();
                });
            }
        }
    };
    $aqdBs.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $4f2X8.default)((0, $4f2X8.default)({}, style), mergedAutoSizeStyle);
    if (resizeState === $1d81e3bc776414f0$var$RESIZE_START || resizeState === $1d81e3bc776414f0$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ $aqdBs.createElement((0, $jeSJT.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $aqdBs.createElement("textarea", (0, $13KW1.default)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className, (0, $br1G4.default)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $1d81e3bc776414f0$export$2e2bcd8739ae039 = $1d81e3bc776414f0$var$ResizableTextArea;

});
parcelRegister("7z0St", function(module, exports) {

$parcel$export(module.exports, "default", () => $581c7b9477370932$export$2e2bcd8739ae039);
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $581c7b9477370932$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $581c7b9477370932$var$SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
var $581c7b9477370932$var$computedStyleCache = {};
var $581c7b9477370932$var$hiddenTextarea;
function $581c7b9477370932$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && $581c7b9477370932$var$computedStyleCache[nodeRef]) return $581c7b9477370932$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    var sizingStyle = $581c7b9477370932$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(';');
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $581c7b9477370932$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $581c7b9477370932$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$581c7b9477370932$var$hiddenTextarea) {
        $581c7b9477370932$var$hiddenTextarea = document.createElement('textarea');
        $581c7b9477370932$var$hiddenTextarea.setAttribute('tab-index', '-1');
        $581c7b9477370932$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $581c7b9477370932$var$hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild($581c7b9477370932$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) $581c7b9477370932$var$hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else $581c7b9477370932$var$hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $581c7b9477370932$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $581c7b9477370932$var$hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat($581c7b9477370932$var$HIDDEN_TEXTAREA_STYLE));
    $581c7b9477370932$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $581c7b9477370932$var$hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $581c7b9477370932$var$hiddenTextarea.value = ' ';
        var singleRowHeight = $581c7b9477370932$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

});




parcelRegister("ffcu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b191f0ae64cf1403$export$2e2bcd8739ae039);

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $aYhX4 = parcelRequire("aYhX4");
const $b191f0ae64cf1403$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$b191f0ae64cf1403$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, $8Olk9.merge)(token, (0, $aYhX4.initInputToken)(token));
    return [
        $b191f0ae64cf1403$var$genTextAreaStyle(inputToken)
    ];
}, (0, $aYhX4.initComponentToken), {
    resetFont: false
});

});



parcelRegister("RqC3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a09981a45616524$export$2e2bcd8739ae039);

var $8DDDH = parcelRequire("8DDDH");

var $41TBD = parcelRequire("41TBD");

var $73kYs = parcelRequire("73kYs");

var $9IqLe = parcelRequire("9IqLe");

var $hYh07 = parcelRequire("hYh07");
"use client";
function $0a09981a45616524$var$modalWarn(props) {
    return (0, $8DDDH.default)((0, $8DDDH.withWarn)(props));
}
const $0a09981a45616524$var$Modal = (0, $73kYs.default);
$0a09981a45616524$var$Modal.useModal = (0, $hYh07.default);
$0a09981a45616524$var$Modal.info = function infoFn(props) {
    return (0, $8DDDH.default)((0, $8DDDH.withInfo)(props));
};
$0a09981a45616524$var$Modal.success = function successFn(props) {
    return (0, $8DDDH.default)((0, $8DDDH.withSuccess)(props));
};
$0a09981a45616524$var$Modal.error = function errorFn(props) {
    return (0, $8DDDH.default)((0, $8DDDH.withError)(props));
};
$0a09981a45616524$var$Modal.warning = $0a09981a45616524$var$modalWarn;
$0a09981a45616524$var$Modal.warn = $0a09981a45616524$var$modalWarn;
$0a09981a45616524$var$Modal.confirm = function confirmFn(props) {
    return (0, $8DDDH.default)((0, $8DDDH.withConfirm)(props));
};
$0a09981a45616524$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $41TBD.default).length){
        const close = (0, $41TBD.default).pop();
        if (close) close();
    }
};
$0a09981a45616524$var$Modal.config = (0, $8DDDH.modalGlobalConfig);
$0a09981a45616524$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $9IqLe.default);
var $0a09981a45616524$export$2e2bcd8739ae039 = $0a09981a45616524$var$Modal;

});
parcelRegister("8DDDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $64a0b6d090f3f05a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withWarn", () => $64a0b6d090f3f05a$export$503fa8fed137d104);
$parcel$export(module.exports, "withInfo", () => $64a0b6d090f3f05a$export$2f728eab0dacbb2e);
$parcel$export(module.exports, "withSuccess", () => $64a0b6d090f3f05a$export$2b5f8d7f29c805d4);
$parcel$export(module.exports, "withError", () => $64a0b6d090f3f05a$export$60e9e0884ce12b55);
$parcel$export(module.exports, "withConfirm", () => $64a0b6d090f3f05a$export$665b64399d4af99c);
$parcel$export(module.exports, "modalGlobalConfig", () => $64a0b6d090f3f05a$export$ff0b30c638ae2396);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
var $ky6DR = parcelRequire("ky6DR");

var $lxiZB = parcelRequire("lxiZB");

var $hnODd = parcelRequire("hnODd");

var $41TBD = parcelRequire("41TBD");

var $k3aBe = parcelRequire("k3aBe");
"use client";
let $64a0b6d090f3f05a$var$defaultRootPrefixCls = '';
function $64a0b6d090f3f05a$var$getRootPrefixCls() {
    return $64a0b6d090f3f05a$var$defaultRootPrefixCls;
}
const $64a0b6d090f3f05a$var$ConfirmDialogWrapper = (props)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $k3aBe.getConfirmLocale)();
    const config = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
    const rootPrefixCls = $64a0b6d090f3f05a$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $hnODd.default), Object.assign({}, props, {
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction !== null && direction !== void 0 ? direction : config.direction,
        locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
        getContainer: mergedGetContainer
    }));
};
function $64a0b6d090f3f05a$export$2e2bcd8739ae039(config) {
    const global = (0, $ky6DR.globalConfig)();
    const container = document.createDocumentFragment();
    let currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    let timeoutId;
    let reactUnmount;
    function destroy(...args) {
        var _a;
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = config.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                config,
                ()=>{}
            ].concat((0, $dMbbs.default)(args.slice(1))));
        }
        for(let i = 0; i < (0, $41TBD.default).length; i++){
            const fn = (0, $41TBD.default)[i];
            if (fn === close) {
                (0, $41TBD.default).splice(i, 1);
                break;
            }
        }
        reactUnmount();
    }
    function render(props) {
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $64a0b6d090f3f05a$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement($64a0b6d090f3f05a$var$ConfirmDialogWrapper, Object.assign({}, props));
            const reactRender = (0, $lxiZB.unstableSetRender)();
            reactUnmount = reactRender(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $ky6DR.default), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, global.holderRender ? global.holderRender(dom) : dom), container);
        });
    }
    function close(...args) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $41TBD.default).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $64a0b6d090f3f05a$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'warning'
    });
}
function $64a0b6d090f3f05a$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'info'
    });
}
function $64a0b6d090f3f05a$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'success'
    });
}
function $64a0b6d090f3f05a$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'error'
    });
}
function $64a0b6d090f3f05a$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: 'confirm'
    });
}
function $64a0b6d090f3f05a$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $64a0b6d090f3f05a$var$defaultRootPrefixCls = rootPrefixCls;
}

});
parcelRegister("hnODd", function(module, exports) {

$parcel$export(module.exports, "ConfirmContent", () => $03440fefa382941a$export$78cf841dc2c9f0b5);
$parcel$export(module.exports, "default", () => $03440fefa382941a$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $azecD = parcelRequire("azecD");

var $4l6rq = parcelRequire("4l6rq");

var $gwifb = parcelRequire("gwifb");

var $daRvi = parcelRequire("daRvi");

var $bqPQ9 = parcelRequire("bqPQ9");

var $jHeh6 = parcelRequire("jHeh6");

var $dLmcO = parcelRequire("dLmcO");


var $ky6DR = parcelRequire("ky6DR");

var $h1ynd = parcelRequire("h1ynd");

var $jygCN = parcelRequire("jygCN");

var $3gd79 = parcelRequire("3gd79");

var $6rJgw = parcelRequire("6rJgw");

var $jqBdW = parcelRequire("jqBdW");

var $73kYs = parcelRequire("73kYs");

var $1MibB = parcelRequire("1MibB");
"use client";
var $03440fefa382941a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $03440fefa382941a$export$78cf841dc2c9f0b5(props) {
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale } = props, resetProps = $03440fefa382941a$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ $aqdBs.createElement((0, $daRvi.default), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ $aqdBs.createElement((0, $azecD.default), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ $aqdBs.createElement((0, $4l6rq.default), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $aqdBs.createElement((0, $gwifb.default), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, $h1ynd.default)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = Object.assign({
        autoFocusButton: autoFocusButton,
        cancelTextLocale: cancelTextLocale,
        okTextLocale: okTextLocale,
        mergedOkCancel: mergedOkCancel
    }, resetProps);
    const btnCtxValueMemo = $aqdBs.useMemo(()=>btnCtxValue, (0, $dMbbs.default)(Object.values(btnCtxValue)));
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $3gd79.default), null), /*#__PURE__*/ $aqdBs.createElement((0, $6rJgw.default), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ $aqdBs.createElement((0, $jqBdW.ModalContextProvider), {
        value: btnCtxValueMemo
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: $6rJgw.default,
        CancelBtn: $3gd79.default
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $aqdBs.createElement((0, $1MibB.default), {
        prefixCls: prefixCls
    }));
}
const $03440fefa382941a$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles } = props;
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $jygCN.default)();
    const mergedZIndex = $aqdBs.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $jHeh6.CONTAINER_MAX_OFFSET);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $aqdBs.createElement((0, $73kYs.default), Object.assign({}, props, {
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        title: "",
        footer: null,
        transitionName: (0, $dLmcO.getTransitionName)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, $dLmcO.getTransitionName)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }), /*#__PURE__*/ $aqdBs.createElement($03440fefa382941a$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
const $03440fefa382941a$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $aqdBs.createElement((0, $ky6DR.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $aqdBs.createElement($03440fefa382941a$var$ConfirmDialog, Object.assign({}, props)));
};
var $03440fefa382941a$export$2e2bcd8739ae039 = $03440fefa382941a$var$ConfirmDialogWrapper;

});
parcelRegister("3gd79", function(module, exports) {

$parcel$export(module.exports, "default", () => $25fd09f5cdeb7b80$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $3pYJW = parcelRequire("3pYJW");

var $jqBdW = parcelRequire("jqBdW");
"use client";
const $25fd09f5cdeb7b80$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm } = (0, $aqdBs.useContext)((0, $jqBdW.ModalContext));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $3pYJW.default), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close === null || close === void 0 || close.apply(void 0, args);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $25fd09f5cdeb7b80$export$2e2bcd8739ae039 = $25fd09f5cdeb7b80$var$ConfirmCancelBtn;

});
parcelRegister("3pYJW", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d2d2955dbff6e1$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $7fRGY = parcelRequire("7fRGY");

var $ffbQF = parcelRequire("ffbQF");

var $1TaA8 = parcelRequire("1TaA8");
"use client";
function $27d2d2955dbff6e1$var$isThenable(thing) {
    return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
const $27d2d2955dbff6e1$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $aqdBs.useRef(false);
    const buttonRef = $aqdBs.useRef(null);
    const [loading, setLoading] = (0, $7fRGY.default)(false);
    const onInternalClose = (...args)=>{
        close === null || close === void 0 || close.apply(void 0, args);
    };
    $aqdBs.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$27d2d2955dbff6e1$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$27d2d2955dbff6e1$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$27d2d2955dbff6e1$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $aqdBs.createElement((0, $ffbQF.default), Object.assign({}, (0, $1TaA8.convertLegacyProps)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $27d2d2955dbff6e1$export$2e2bcd8739ae039 = $27d2d2955dbff6e1$var$ActionButton;

});

parcelRegister("jqBdW", function(module, exports) {

$parcel$export(module.exports, "ModalContext", () => $e24d51e84af0b356$export$ab57792b9b6974a6);
$parcel$export(module.exports, "ModalContextProvider", () => $e24d51e84af0b356$export$7c9538f5f3c365e9);

var $aqdBs = parcelRequire("aqdBs");
const $e24d51e84af0b356$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext({});
const { Provider: $e24d51e84af0b356$export$7c9538f5f3c365e9 } = $e24d51e84af0b356$export$ab57792b9b6974a6;

});


parcelRegister("6rJgw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1860792f42e6d3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $3pYJW = parcelRequire("3pYJW");

var $jqBdW = parcelRequire("jqBdW");
"use client";
const $4b1860792f42e6d3$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk } = (0, $aqdBs.useContext)((0, $jqBdW.ModalContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $3pYJW.default), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close === null || close === void 0 || close.apply(void 0, args);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $4b1860792f42e6d3$export$2e2bcd8739ae039 = $4b1860792f42e6d3$var$ConfirmOkBtn;

});

parcelRegister("73kYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5229153e91116387$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $2Nj5k = parcelRequire("2Nj5k");

var $bqPQ9 = parcelRequire("bqPQ9");

var $8HOCw = parcelRequire("8HOCw");

var $cQKK1 = parcelRequire("cQKK1");

var $5U0Pk = parcelRequire("5U0Pk");

var $jHeh6 = parcelRequire("jHeh6");

var $dLmcO = parcelRequire("dLmcO");

var $5YeTZ = parcelRequire("5YeTZ");


var $jaW1p = parcelRequire("jaW1p");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $g99Jl = parcelRequire("g99Jl");

var $bOdxD = parcelRequire("bOdxD");

var $6cYyQ = parcelRequire("6cYyQ");

var $kz5Ra = parcelRequire("kz5Ra");
"use client";
var $5229153e91116387$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $5229153e91116387$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $5229153e91116387$var$getClickPosition = (e)=>{
    $5229153e91116387$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $5229153e91116387$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $5YeTZ.canUseDocElement)()) document.documentElement.addEventListener('click', $5229153e91116387$var$getClickPosition, true);
const $5229153e91116387$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, visible: // Deprecated
    visible, width: width = 520, footer: footer, classNames: modalClassNames, styles: modalStyles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose } = props, restProps = $5229153e91116387$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles",
        "children",
        "loading",
        "confirmLoading",
        "zIndex",
        "mousePosition",
        "onOk",
        "onCancel",
        "destroyOnHidden",
        "destroyOnClose"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, modal: modalContext } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    const handleOk = (e)=>{
        onOk === null || onOk === void 0 || onOk(e);
    };
    var deprecatedName, newName;
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // Style
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $kz5Ra.default)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(wrapClassName, {
        [`${prefixCls}-centered`]: centered !== null && centered !== void 0 ? centered : modalContext === null || modalContext === void 0 ? void 0 : modalContext.centered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $aqdBs.createElement((0, $6cYyQ.Footer), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    })) : null;
    const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $5U0Pk.default)((0, $5U0Pk.pickClosable)(props), (0, $5U0Pk.pickClosable)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $aqdBs.createElement((0, $2Nj5k.default), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $6cYyQ.renderCloseIcon)(prefixCls, icon)
    });
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelRef = (0, $bOdxD.usePanelRef)(`.${prefixCls}-content`);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $jHeh6.useZIndex)('Modal', customizeZIndex);
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $aqdBs.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $aqdBs.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $cQKK1.default), {
        form: true,
        space: true
    }, /*#__PURE__*/ $aqdBs.createElement((0, $jaW1p.default).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $aqdBs.createElement((0, $8HOCw.default), Object.assign({
        width: numWidth
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, rootClassName, cssVarCls, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: customizeMousePosition !== null && customizeMousePosition !== void 0 ? customizeMousePosition : $5229153e91116387$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable ? Object.assign({
            disabled: closeBtnIsDisabled,
            closeIcon: mergedCloseIcon
        }, ariaProps) : mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $dLmcO.getTransitionName)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, $dLmcO.getTransitionName)(rootPrefixCls, 'fade', props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
        style: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style), responsiveWidthVars),
        classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
        }),
        styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
        panelRef: panelRef,
        // TODO: In the future, destroyOnClose in rc-dialog needs to be upgrade to destroyOnHidden
        destroyOnClose: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyOnClose
    }), loading ? /*#__PURE__*/ $aqdBs.createElement((0, $g99Jl.default), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children))));
};
var $5229153e91116387$export$2e2bcd8739ae039 = $5229153e91116387$var$Modal;

});
parcelRegister("8HOCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $65699b01a25e3332$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Panel", () => (parcelRequire("c0K1i")).default);

var $9IJAK = parcelRequire("9IJAK");

var $c0K1i = parcelRequire("c0K1i");
var $65699b01a25e3332$export$2e2bcd8739ae039 = (0, $9IJAK.default);

});
parcelRegister("9IJAK", function(module, exports) {

$parcel$export(module.exports, "default", () => $713b96ab54a0f260$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $kelIR = parcelRequire("kelIR");

var $6WvuR = parcelRequire("6WvuR");

var $aqdBs = parcelRequire("aqdBs");

var $9IPwf = parcelRequire("9IPwf");

var $cS5tB = parcelRequire("cS5tB");
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $713b96ab54a0f260$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $aqdBs.useState(visible), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $aqdBs.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $aqdBs.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $aqdBs.createElement((0, $9IPwf.RefContext).Provider, {
        value: refContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $6WvuR.default), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $aqdBs.createElement((0, $cS5tB.default), (0, $13KW1.default)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$713b96ab54a0f260$var$DialogWrap.displayName = 'Dialog';
var $713b96ab54a0f260$export$2e2bcd8739ae039 = $713b96ab54a0f260$var$DialogWrap;

});
parcelRegister("9IPwf", function(module, exports) {

$parcel$export(module.exports, "RefContext", () => $71402fc319576aeb$export$ee4e38b469b6f5d1);

var $aqdBs = parcelRequire("aqdBs");
var $71402fc319576aeb$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $aqdBs.createContext({});

});

parcelRegister("cS5tB", function(module, exports) {

$parcel$export(module.exports, "default", () => $95eec6ab6572d2fe$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $i3X5I = parcelRequire("i3X5I");

var $4zEIt = parcelRequire("4zEIt");

var $dHI2t = parcelRequire("dHI2t");

var $bWa8g = parcelRequire("bWa8g");

var $aqdBs = parcelRequire("aqdBs");

var $1ZNo9 = parcelRequire("1ZNo9");

var $c843q = parcelRequire("c843q");

var $1uk7X = parcelRequire("1uk7X");
parcelRequire("i7X5i");
var $95eec6ab6572d2fe$var$Dialog = function Dialog(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    var lastOutSideActiveElementRef = (0, $aqdBs.useRef)();
    var wrapperRef = (0, $aqdBs.useRef)();
    var contentRef = (0, $aqdBs.useRef)();
    var _React$useState = $aqdBs.useState(visible), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $4zEIt.default)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $i3X5I.default)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $i3X5I.default)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $aqdBs.useRef)(false);
    var contentTimeoutRef = (0, $aqdBs.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $dHI2t.default).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $dHI2t.default).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $aqdBs.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $aqdBs.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    var mergedStyle = (0, $4f2X8.default)((0, $4f2X8.default)((0, $4f2X8.default)({
        zIndex: zIndex
    }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
        display: !animatedVisible ? 'none' : null
    });
    // ========================= Render =========================
    return /*#__PURE__*/ $aqdBs.createElement("div", (0, $13KW1.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $bWa8g.default)(props, {
        data: true
    })), /*#__PURE__*/ $aqdBs.createElement((0, $1uk7X.default), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $1ZNo9.getMotionName)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $4f2X8.default)((0, $4f2X8.default)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $aqdBs.createElement("div", (0, $13KW1.default)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $aqdBs.createElement((0, $c843q.default), (0, $13KW1.default)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $1ZNo9.getMotionName)(prefixCls, transitionName, animation)
    }))));
};
var $95eec6ab6572d2fe$export$2e2bcd8739ae039 = $95eec6ab6572d2fe$var$Dialog;

});
parcelRegister("1ZNo9", function(module, exports) {

$parcel$export(module.exports, "getMotionName", () => $1741cc80ccb9fb46$export$ec1a7ebf4579c1c3);
$parcel$export(module.exports, "offset", () => $1741cc80ccb9fb46$export$cc800923e997bb8);
// =============================== Motion ===============================
function $1741cc80ccb9fb46$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $1741cc80ccb9fb46$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function $1741cc80ccb9fb46$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $1741cc80ccb9fb46$var$getScroll(w);
    pos.top += $1741cc80ccb9fb46$var$getScroll(w, true);
    return pos;
}

});

parcelRegister("c843q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d4960795703afd5$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $kelIR = parcelRequire("kelIR");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");

var $1ZNo9 = parcelRequire("1ZNo9");

var $c0K1i = parcelRequire("c0K1i");
var $8d4960795703afd5$var$Content = /*#__PURE__*/ $aqdBs.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $aqdBs.useRef)();
    // ============================= Style ==============================
    var _React$useState = $aqdBs.useState(), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $1ZNo9.offset)(dialogRef.current);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $aqdBs.createElement((0, $c0K1i.default), (0, $13KW1.default)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $4f2X8.default)((0, $4f2X8.default)((0, $4f2X8.default)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, motionClassName)
        }));
    });
});
$8d4960795703afd5$var$Content.displayName = 'Content';
var $8d4960795703afd5$export$2e2bcd8739ae039 = $8d4960795703afd5$var$Content;

});
parcelRegister("c0K1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8be92ebb66ef5805$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $7IgoF = parcelRequire("7IgoF");

var $4f2X8 = parcelRequire("4f2X8");

var $bqPQ9 = parcelRequire("bqPQ9");

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");

var $9IPwf = parcelRequire("9IPwf");

var $1We1o = parcelRequire("1We1o");

var $bWa8g = parcelRequire("bWa8g");
var $8be92ebb66ef5805$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
var $8be92ebb66ef5805$var$entityStyle = {
    outline: 'none'
};
var $8be92ebb66ef5805$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useContext((0, $9IPwf.RefContext)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $kBwE8.useComposeRef)(holderRef, panelRef);
    var sentinelStartRef = (0, $aqdBs.useRef)();
    var sentinelEndRef = (0, $aqdBs.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _sentinelStartRef$cur;
                (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $4f2X8.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer) : null;
    var headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $4f2X8.default)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title)) : null;
    var closableObj = (0, $aqdBs.useMemo)(function() {
        if ((0, $7IgoF.default)(closable) === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
                className: "".concat(prefixCls, "-close-x")
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    var ariaProps = (0, $bWa8g.default)(closableObj, true);
    var closeBtnIsDisabled = (0, $7IgoF.default)(closable) === 'object' && closable.disabled;
    var closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("button", (0, $13KW1.default)({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: "".concat(prefixCls, "-close"),
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", (0, $13KW1.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $4f2X8.default)((0, $4f2X8.default)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: $8be92ebb66ef5805$var$entityStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $1We1o.default), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $8be92ebb66ef5805$var$sentinelStyle
    }));
});
var $8be92ebb66ef5805$export$2e2bcd8739ae039 = $8be92ebb66ef5805$var$Panel;

});
parcelRegister("1We1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $1696159c938a376c$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
var $1696159c938a376c$export$2e2bcd8739ae039 = /*#__PURE__*/ $aqdBs.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});

});



parcelRegister("1uk7X", function(module, exports) {

$parcel$export(module.exports, "default", () => $115834aef1669e1a$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $4f2X8 = parcelRequire("4f2X8");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $6ufPd = parcelRequire("6ufPd");
var $115834aef1669e1a$var$Mask = function Mask(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $aqdBs.createElement((0, $6ufPd.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $aqdBs.createElement("div", (0, $13KW1.default)({
            ref: ref,
            style: (0, $4f2X8.default)((0, $4f2X8.default)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
};
var $115834aef1669e1a$export$2e2bcd8739ae039 = $115834aef1669e1a$var$Mask;

});




parcelRegister("5U0Pk", function(module, exports) {

$parcel$export(module.exports, "pickClosable", () => $44c2d2e775d9c87a$export$51ad9c30389f050b);
$parcel$export(module.exports, "default", () => $44c2d2e775d9c87a$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $2Nj5k = parcelRequire("2Nj5k");

var $bWa8g = parcelRequire("bWa8g");

var $h1ynd = parcelRequire("h1ynd");

var $iPGr2 = parcelRequire("iPGr2");

var $fSzax = parcelRequire("fSzax");
"use client";
function $44c2d2e775d9c87a$export$51ad9c30389f050b(context) {
    if (!context) return undefined;
    return {
        closable: context.closable,
        closeIcon: context.closeIcon
    };
}
/** Convert `closable` and `closeIcon` to config object */ function $44c2d2e775d9c87a$var$useClosableConfig(closableCollection) {
    const { closable: closable, closeIcon: closeIcon } = closableCollection || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>{
        if (// If `closable`, whatever rest be should be true
        !closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
        if (closable === undefined && closeIcon === undefined) return null;
        let closableConfig = {
            closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
        };
        if (closable && typeof closable === 'object') closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
        return closableConfig;
    }, [
        closable,
        closeIcon
    ]);
}
/** Use same object to support `useMemo` optimization */ const $44c2d2e775d9c87a$var$EmptyFallbackCloseCollection = {};
function $44c2d2e775d9c87a$export$2e2bcd8739ae039(propCloseCollection, contextCloseCollection, fallbackCloseCollection = $44c2d2e775d9c87a$var$EmptyFallbackCloseCollection) {
    // Align the `props`, `context` `fallback` to config object first
    const propCloseConfig = $44c2d2e775d9c87a$var$useClosableConfig(propCloseCollection);
    const contextCloseConfig = $44c2d2e775d9c87a$var$useClosableConfig(contextCloseCollection);
    const [contextLocale] = (0, $h1ynd.default)('global', (0, $iPGr2.default).global);
    const closeBtnIsDisabled = typeof propCloseConfig !== 'boolean' ? !!(propCloseConfig === null || propCloseConfig === void 0 ? void 0 : propCloseConfig.disabled) : false;
    const mergedFallbackCloseCollection = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>Object.assign({
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $2Nj5k.default), null)
        }, fallbackCloseCollection), [
        fallbackCloseCollection
    ]);
    // Use fallback logic to fill the config
    const mergedClosableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>{
        // ================ Props First ================
        // Skip if prop is disabled
        if (propCloseConfig === false) return false;
        if (propCloseConfig) return (0, $fSzax.default)(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
        // =============== Context Second ==============
        // Skip if context is disabled
        if (contextCloseConfig === false) return false;
        if (contextCloseConfig) return (0, $fSzax.default)(mergedFallbackCloseCollection, contextCloseConfig);
        // ============= Fallback Default ==============
        return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
    }, [
        propCloseConfig,
        contextCloseConfig,
        mergedFallbackCloseCollection
    ]);
    // Calculate the final closeIcon
    return (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>{
        if (mergedClosableConfig === false) return [
            false,
            null,
            closeBtnIsDisabled,
            {}
        ];
        const { closeIconRender: closeIconRender } = mergedFallbackCloseCollection;
        const { closeIcon: closeIcon } = mergedClosableConfig;
        let mergedCloseIcon = closeIcon;
        // Wrap the closeIcon with aria props
        const ariaOrDataProps = (0, $bWa8g.default)(mergedClosableConfig, true);
        if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
            // Wrap the closeIcon if needed
            if (closeIconRender) mergedCloseIcon = closeIconRender(closeIcon);
            mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).isValidElement(mergedCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(mergedCloseIcon, Object.assign({
                'aria-label': contextLocale.close
            }, ariaOrDataProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", Object.assign({
                "aria-label": contextLocale.close
            }, ariaOrDataProps), mergedCloseIcon);
        }
        return [
            true,
            mergedCloseIcon,
            closeBtnIsDisabled,
            ariaOrDataProps
        ];
    }, [
        mergedClosableConfig,
        mergedFallbackCloseCollection
    ]);
}

});
parcelRegister("fSzax", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f72e013985af10$export$2e2bcd8739ae039);
function $b8f72e013985af10$var$mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
var $b8f72e013985af10$export$2e2bcd8739ae039 = $b8f72e013985af10$var$mergeProps;

});


parcelRegister("5YeTZ", function(module, exports) {

$parcel$export(module.exports, "canUseDocElement", () => $458e1d95479e8f4e$export$7dbdadf5e9653129);

var $8Vh6n = parcelRequire("8Vh6n");

var $4w4RP = parcelRequire("4w4RP");
const $458e1d95479e8f4e$export$7dbdadf5e9653129 = ()=>(0, $8Vh6n.default)() && window.document.documentElement;

});
parcelRegister("4w4RP", function(module, exports) {

$parcel$export(module.exports, "isStyleSupport", () => $349ded1e8f1684d3$export$d616d7831008e86c);

var $8Vh6n = parcelRequire("8Vh6n");
var $349ded1e8f1684d3$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $8Vh6n.default)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $349ded1e8f1684d3$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$349ded1e8f1684d3$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement('div');
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $349ded1e8f1684d3$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $349ded1e8f1684d3$var$isStyleValueSupport(styleName, styleValue);
    return $349ded1e8f1684d3$var$isStyleNameSupport(styleName);
}

});


parcelRegister("g99Jl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc1508e06ec6fa59$export$2e2bcd8739ae039);

var $40vht = parcelRequire("40vht");
"use client";
var $bc1508e06ec6fa59$export$2e2bcd8739ae039 = (0, $40vht.default);

});
parcelRegister("40vht", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eaf6d372c4900cd$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $kjlvF = parcelRequire("kjlvF");

var $12a4b = parcelRequire("12a4b");

var $t3mAh = parcelRequire("t3mAh");

var $h3oBo = parcelRequire("h3oBo");

var $dk4lH = parcelRequire("dk4lH");

var $8pWhu = parcelRequire("8pWhu");

var $3iM00 = parcelRequire("3iM00");

var $ki2dD = parcelRequire("ki2dD");

var $2zHUy = parcelRequire("2zHUy");

var $T8T9O = parcelRequire("T8T9O");
"use client";
function $2eaf6d372c4900cd$var$getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function $2eaf6d372c4900cd$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function $2eaf6d372c4900cd$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function $2eaf6d372c4900cd$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
const $2eaf6d372c4900cd$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, style: style, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle } = (0, $kjlvF.useComponentConfig)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = Object.assign(Object.assign({
                prefixCls: `${prefixCls}-avatar`
            }, $2eaf6d372c4900cd$var$getAvatarBasicProps(hasTitle, hasParagraph)), $2eaf6d372c4900cd$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $aqdBs.createElement("div", {
                className: `${prefixCls}-header`
            }, /*#__PURE__*/ $aqdBs.createElement((0, $h3oBo.default), Object.assign({}, avatarProps)));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-title`
                }, $2eaf6d372c4900cd$var$getTitleBasicProps(hasAvatar, hasParagraph)), $2eaf6d372c4900cd$var$getComponentProps(title));
                $title = /*#__PURE__*/ $aqdBs.createElement((0, $T8T9O.default), Object.assign({}, titleProps));
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-paragraph`
                }, $2eaf6d372c4900cd$var$getParagraphBasicProps(hasAvatar, hasTitle)), $2eaf6d372c4900cd$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $aqdBs.createElement((0, $ki2dD.default), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $aqdBs.createElement("div", {
                className: `${prefixCls}-content`
            }, $title, paragraphNode);
        }
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, contextClassName, className, rootClassName, hashId, cssVarCls);
        return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, contextStyle), style)
        }, avatarNode, contentNode));
    }
    return children !== null && children !== void 0 ? children : null;
};
$2eaf6d372c4900cd$var$Skeleton.Button = (0, $t3mAh.default);
$2eaf6d372c4900cd$var$Skeleton.Avatar = (0, $12a4b.default);
$2eaf6d372c4900cd$var$Skeleton.Input = (0, $8pWhu.default);
$2eaf6d372c4900cd$var$Skeleton.Image = (0, $dk4lH.default);
$2eaf6d372c4900cd$var$Skeleton.Node = (0, $3iM00.default);
var $2eaf6d372c4900cd$export$2e2bcd8739ae039 = $2eaf6d372c4900cd$var$Skeleton;

});
parcelRegister("12a4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0dc95ccae7ff25$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $h3oBo = parcelRequire("h3oBo");

var $2zHUy = parcelRequire("2zHUy");
"use client";
const $0c0dc95ccae7ff25$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, shape: shape = 'circle', size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    const otherProps = (0, $1iwLi.default)(props, [
        'prefixCls',
        'className'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $aqdBs.createElement((0, $h3oBo.default), Object.assign({
        prefixCls: `${prefixCls}-avatar`,
        shape: shape,
        size: size
    }, otherProps))));
};
var $0c0dc95ccae7ff25$export$2e2bcd8739ae039 = $0c0dc95ccae7ff25$var$SkeletonAvatar;

});
parcelRegister("h3oBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6a5ccf15d5e2e21$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
"use client";
const $c6a5ccf15d5e2e21$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = $aqdBs.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $aqdBs.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $c6a5ccf15d5e2e21$export$2e2bcd8739ae039 = $c6a5ccf15d5e2e21$var$Element;

});

parcelRegister("2zHUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e00e97dc0049191$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");
var $aWTY1 = parcelRequire("aWTY1");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $1e00e97dc0049191$var$skeletonClsLoading = new (0, $Zo2YC.default)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const $1e00e97dc0049191$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $aWTY1.unit)(size)
    });
const $1e00e97dc0049191$var$genSkeletonElementAvatarSize = (size)=>Object.assign({
        width: size
    }, $1e00e97dc0049191$var$genSkeletonElementCommonSize(size));
const $1e00e97dc0049191$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: $1e00e97dc0049191$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const $1e00e97dc0049191$var$genSkeletonElementInputSize = (size, calc)=>Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $1e00e97dc0049191$var$genSkeletonElementCommonSize(size));
const $1e00e97dc0049191$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor
        }, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeightSM))
    };
};
const $1e00e97dc0049191$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $1e00e97dc0049191$var$genSkeletonElementInputSize(controlHeight, calc)),
        [`${skeletonInputCls}-lg`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementInputSize(controlHeightLG, calc)),
        [`${skeletonInputCls}-sm`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementInputSize(controlHeightSM, calc))
    };
};
const $1e00e97dc0049191$var$genSkeletonElementImageSize = (size)=>Object.assign({
        width: size
    }, $1e00e97dc0049191$var$genSkeletonElementCommonSize(size));
const $1e00e97dc0049191$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    return {
        [skeletonImageCls]: Object.assign(Object.assign({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign: 'middle',
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $1e00e97dc0049191$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementImageSize(imageSizeBase)), {
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            }),
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        }),
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const $1e00e97dc0049191$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $1e00e97dc0049191$var$genSkeletonElementButtonSize = (size, calc)=>Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $1e00e97dc0049191$var$genSkeletonElementCommonSize(size));
const $1e00e97dc0049191$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [skeletonButtonCls]: Object.assign({
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal()
        }, $1e00e97dc0049191$var$genSkeletonElementButtonSize(controlHeight, calc))
    }, $1e00e97dc0049191$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
        [`${skeletonButtonCls}-lg`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementButtonSize(controlHeightLG, calc))
    }), $1e00e97dc0049191$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
        [`${skeletonButtonCls}-sm`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementButtonSize(controlHeightSM, calc))
    }), $1e00e97dc0049191$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const $1e00e97dc0049191$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: Object.assign({
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor
                }, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeight)),
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeightLG)),
                [`${skeletonAvatarCls}-sm`]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonElementAvatarSize(controlHeightSM))
            },
            [`${componentCls}-content`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-content`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-content`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton element
        [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
            display: 'inline-block',
            width: 'auto'
        }, $1e00e97dc0049191$var$genSkeletonElementButton(token)), $1e00e97dc0049191$var$genSkeletonElementAvatar(token)), $1e00e97dc0049191$var$genSkeletonElementInput(token)), $1e00e97dc0049191$var$genSkeletonElementImage(token)),
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, $1e00e97dc0049191$var$genSkeletonColor(token))
        }
    };
};
const $1e00e97dc0049191$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $1e00e97dc0049191$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Skeleton', (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $8Olk9.merge)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return [
        $1e00e97dc0049191$var$genBaseStyle(skeletonToken)
    ];
}, $1e00e97dc0049191$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});

});


parcelRegister("t3mAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0575516be8320601$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $h3oBo = parcelRequire("h3oBo");

var $2zHUy = parcelRequire("2zHUy");
"use client";
const $0575516be8320601$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block = false, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    const otherProps = (0, $1iwLi.default)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $aqdBs.createElement((0, $h3oBo.default), Object.assign({
        prefixCls: `${prefixCls}-button`,
        size: size
    }, otherProps))));
};
var $0575516be8320601$export$2e2bcd8739ae039 = $0575516be8320601$var$SkeletonButton;

});

parcelRegister("dk4lH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b30843b4cda424d$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $2zHUy = parcelRequire("2zHUy");
"use client";
const $9b30843b4cda424d$var$path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const $9b30843b4cda424d$var$SkeletonImage = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-image`, className),
        style: style
    }, /*#__PURE__*/ $aqdBs.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $aqdBs.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $aqdBs.createElement("path", {
        d: $9b30843b4cda424d$var$path,
        className: `${prefixCls}-image-path`
    })))));
};
var $9b30843b4cda424d$export$2e2bcd8739ae039 = $9b30843b4cda424d$var$SkeletonImage;

});

parcelRegister("8pWhu", function(module, exports) {

$parcel$export(module.exports, "default", () => $620dddf14c1ceec1$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $h3oBo = parcelRequire("h3oBo");

var $2zHUy = parcelRequire("2zHUy");
"use client";
const $620dddf14c1ceec1$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block, size: size = 'default' } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    const otherProps = (0, $1iwLi.default)(props, [
        'prefixCls'
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $aqdBs.createElement((0, $h3oBo.default), Object.assign({
        prefixCls: `${prefixCls}-input`,
        size: size
    }, otherProps))));
};
var $620dddf14c1ceec1$export$2e2bcd8739ae039 = $620dddf14c1ceec1$var$SkeletonInput;

});

parcelRegister("3iM00", function(module, exports) {

$parcel$export(module.exports, "default", () => $26784927d509606b$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $2zHUy = parcelRequire("2zHUy");
"use client";
const $26784927d509606b$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $2zHUy.default)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, className, rootClassName, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $aqdBs.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-image`, className),
        style: style
    }, children)));
};
var $26784927d509606b$export$2e2bcd8739ae039 = $26784927d509606b$var$SkeletonNode;

});

parcelRegister("ki2dD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec5735b3ff294fec$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
"use client";
const $ec5735b3ff294fec$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $ec5735b3ff294fec$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $aqdBs.createElement("li", {
            key: index,
            style: {
                width: $ec5735b3ff294fec$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $aqdBs.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className),
        style: style
    }, rowList);
};
var $ec5735b3ff294fec$export$2e2bcd8739ae039 = $ec5735b3ff294fec$var$Paragraph;

});

parcelRegister("T8T9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5c084439046fd3$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
"use client";
const $0a5c084439046fd3$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $aqdBs.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    });
var $0a5c084439046fd3$export$2e2bcd8739ae039 = $0a5c084439046fd3$var$Title;

});



parcelRegister("bOdxD", function(module, exports) {

$parcel$export(module.exports, "usePanelRef", () => $898ede45e3049bc3$export$94ab53417567be34);

var $aqdBs = parcelRequire("aqdBs");

var $k91S5 = parcelRequire("k91S5");
function $898ede45e3049bc3$var$voidFunc() {}
const $898ede45e3049bc3$var$WatermarkContext = /*#__PURE__*/ $aqdBs.createContext({
    add: $898ede45e3049bc3$var$voidFunc,
    remove: $898ede45e3049bc3$var$voidFunc
});
function $898ede45e3049bc3$export$94ab53417567be34(panelSelector) {
    const watermark = $aqdBs.useContext($898ede45e3049bc3$var$WatermarkContext);
    const panelEleRef = $aqdBs.useRef(null);
    const panelRef = (0, $k91S5.default)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            watermark.add(innerContentEle);
            panelEleRef.current = innerContentEle;
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $898ede45e3049bc3$export$2e2bcd8739ae039 = $898ede45e3049bc3$var$WatermarkContext;

});

parcelRegister("6cYyQ", function(module, exports) {

$parcel$export(module.exports, "renderCloseIcon", () => $4852d7381cae74c3$export$97c34646962d356e);
$parcel$export(module.exports, "Footer", () => $4852d7381cae74c3$export$a06f1c675e846f6f);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $2Nj5k = parcelRequire("2Nj5k");

var $bpKJo = parcelRequire("bpKJo");

var $h1ynd = parcelRequire("h1ynd");

var $llJMK = parcelRequire("llJMK");

var $dXzrf = parcelRequire("dXzrf");

var $jqBdW = parcelRequire("jqBdW");

var $k3aBe = parcelRequire("k3aBe");
"use client";
function $4852d7381cae74c3$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $2Nj5k.default), {
        className: `${prefixCls}-close-icon`
    }));
}
const $4852d7381cae74c3$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = 'primary', cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $h1ynd.default)('Modal', (0, $k3aBe.getConfirmLocale)());
    // ================== Locale Text ==================
    const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = {
        confirmLoading: confirmLoading,
        okButtonProps: okButtonProps,
        cancelButtonProps: cancelButtonProps,
        okTextLocale: okTextLocale,
        cancelTextLocale: cancelTextLocale,
        okType: okType,
        onOk: onOk,
        onCancel: onCancel
    };
    const btnCtxValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useMemo(()=>btnCtxValue, (0, $dMbbs.default)(Object.values(btnCtxValue)));
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $llJMK.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $dXzrf.default), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, $dXzrf.default),
            CancelBtn: (0, $llJMK.default)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $jqBdW.ModalContextProvider), {
            value: btnCtxValueMemo
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $bpKJo.DisabledContextProvider), {
        disabled: false
    }, footerNode);
};

});
parcelRegister("llJMK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8af1328fbf89931$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $ffbQF = parcelRequire("ffbQF");

var $jqBdW = parcelRequire("jqBdW");
"use client";
const $f8af1328fbf89931$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $aqdBs.useContext)((0, $jqBdW.ModalContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $ffbQF.default), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $f8af1328fbf89931$export$2e2bcd8739ae039 = $f8af1328fbf89931$var$NormalCancelBtn;

});

parcelRegister("dXzrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a29c466991853fad$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $ffbQF = parcelRequire("ffbQF");

var $1TaA8 = parcelRequire("1TaA8");

var $jqBdW = parcelRequire("jqBdW");
"use client";
const $a29c466991853fad$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $aqdBs.useContext)((0, $jqBdW.ModalContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $ffbQF.default), Object.assign({}, (0, $1TaA8.convertLegacyProps)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $a29c466991853fad$export$2e2bcd8739ae039 = $a29c466991853fad$var$NormalOkBtn;

});


parcelRegister("kz5Ra", function(module, exports) {

$parcel$export(module.exports, "prepareToken", () => $ef8b9e7fa921c406$export$362fb92a8f81bbf9);
$parcel$export(module.exports, "prepareComponentToken", () => $ef8b9e7fa921c406$export$9ca1be8807fe0675);
$parcel$export(module.exports, "default", () => $ef8b9e7fa921c406$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $amB8F = parcelRequire("amB8F");

var $5kUb2 = parcelRequire("5kUb2");

var $mquRV = parcelRequire("mquRV");
var $d9Xyr = parcelRequire("d9Xyr");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
function $ef8b9e7fa921c406$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $ef8b9e7fa921c406$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: Object.assign(Object.assign({}, $ef8b9e7fa921c406$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                }),
                [`${componentCls}-wrap`]: Object.assign(Object.assign({}, $ef8b9e7fa921c406$var$box('fixed')), {
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                })
            }
        },
        {
            [`${componentCls}-root`]: (0, $mquRV.initFadeMotion)(token)
        }
    ];
};
const $ef8b9e7fa921c406$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, $aWTY1.unit)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, $aWTY1.unit)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-content`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: Object.assign({
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, $aWTY1.unit)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    }
                }, (0, $5kUb2.genFocusStyle)(token)),
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $aWTY1.unit)(token.borderRadiusLG)} ${(0, $aWTY1.unit)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, $aWTY1.unit)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            })
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const $ef8b9e7fa921c406$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const $ef8b9e7fa921c406$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const gridMediaSizesMap = (0, $amB8F.getMediaSize)(token);
    delete gridMediaSizesMap.xs;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $aWTY1.unit)(gridMediaSizesMap[key])})`]: {
                width: `var(--${componentCls.replace('.', '')}-${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [
                {
                    width: `var(--${componentCls.replace('.', '')}-xs-width)`
                }
            ].concat((0, $dMbbs.default)(responsiveStyles))
        }
    };
};
const $ef8b9e7fa921c406$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $8Olk9.merge)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $ef8b9e7fa921c406$export$9ca1be8807fe0675 = (token)=>({
        footerBg: 'transparent',
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $aWTY1.unit)(token.paddingMD)} ${(0, $aWTY1.unit)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $aWTY1.unit)(token.padding)} ${(0, $aWTY1.unit)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $aWTY1.unit)(token.paddingXS)} ${(0, $aWTY1.unit)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $aWTY1.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $aWTY1.unit)(token.borderRadiusLG)} ${(0, $aWTY1.unit)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $aWTY1.unit)(token.padding * 2)} ${(0, $aWTY1.unit)(token.padding * 2)} ${(0, $aWTY1.unit)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    });
var $ef8b9e7fa921c406$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Modal', (token)=>{
    const modalToken = $ef8b9e7fa921c406$export$362fb92a8f81bbf9(token);
    return [
        $ef8b9e7fa921c406$var$genModalStyle(modalToken),
        $ef8b9e7fa921c406$var$genRTLStyle(modalToken),
        $ef8b9e7fa921c406$export$8bb6dada04673ddd(modalToken),
        (0, $d9Xyr.initZoomMotion)(modalToken, 'zoom'),
        $ef8b9e7fa921c406$var$genResponsiveWidthStyle(modalToken)
    ];
}, $ef8b9e7fa921c406$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});

});
parcelRegister("mquRV", function(module, exports) {

$parcel$export(module.exports, "initFadeMotion", () => $04369beaf6e6826c$export$2909268c8354a12);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $9V6Az = parcelRequire("9V6Az");
const $04369beaf6e6826c$export$82e6205b15e6c637 = new (0, $Zo2YC.default)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const $04369beaf6e6826c$export$c091916f1530334c = new (0, $Zo2YC.default)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const $04369beaf6e6826c$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, $9V6Az.initMotion)(motionCls, $04369beaf6e6826c$export$82e6205b15e6c637, $04369beaf6e6826c$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};

});



parcelRegister("1MibB", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b86183a11d55f3$export$2e2bcd8739ae039);
// Style as confirm component
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $kz5Ra = parcelRequire("kz5Ra");

var $5kUb2 = parcelRequire("5kUb2");

var $4wPvn = parcelRequire("4wPvn");
// ============================= Confirm ==============================
const $14b86183a11d55f3$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0, $5kUb2.clearFix)()),
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $aWTY1.unit)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $aWTY1.unit)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-content`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$14b86183a11d55f3$export$2e2bcd8739ae039 = (0, $4wPvn.genSubStyleComponent)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, $kz5Ra.prepareToken)(token);
    return [
        $14b86183a11d55f3$var$genModalConfirmStyle(modalToken)
    ];
}, (0, $kz5Ra.prepareComponentToken), {
    // confirm is weak than modal since no conflict here
    order: -1000
});

});


parcelRegister("41TBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef263a358d6b090$export$2e2bcd8739ae039);
const $2ef263a358d6b090$var$destroyFns = [];
var $2ef263a358d6b090$export$2e2bcd8739ae039 = $2ef263a358d6b090$var$destroyFns;

});


parcelRegister("9IqLe", function(module, exports) {

$parcel$export(module.exports, "default", () => $712cfb41ef262bab$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("8HOCw");
var $c0K1i = parcelRequire("c0K1i");

var $iJhZR = parcelRequire("iJhZR");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $hnODd = parcelRequire("hnODd");

var $6cYyQ = parcelRequire("6cYyQ");

var $kz5Ra = parcelRequire("kz5Ra");
"use client";
var $712cfb41ef262bab$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $712cfb41ef262bab$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer } = props, restProps = $712cfb41ef262bab$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, $aogQV.default)(rootPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $kz5Ra.default)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ $aqdBs.createElement((0, $hnODd.ConfirmContent), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $aqdBs.createElement((0, $6cYyQ.Footer), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $c0K1i.default), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
    }, restProps, {
        closeIcon: (0, $6cYyQ.renderCloseIcon)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $712cfb41ef262bab$export$2e2bcd8739ae039 = (0, $iJhZR.withPureRenderTheme)($712cfb41ef262bab$var$PurePanel);

});
parcelRegister("iJhZR", function(module, exports) {

$parcel$export(module.exports, "withPureRenderTheme", () => $da2a63b80fe89ff2$export$29e2a8c3cdb34b03);
$parcel$export(module.exports, "default", () => $da2a63b80fe89ff2$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $eAKDF = parcelRequire("eAKDF");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
var $ky6DR = parcelRequire("ky6DR");
"use client";
function $da2a63b80fe89ff2$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $aqdBs.createElement((0, $ky6DR.default), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $aqdBs.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $da2a63b80fe89ff2$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $aqdBs.useRef(null);
        const [popupHeight, setPopupHeight] = $aqdBs.useState(0);
        const [popupWidth, setPopupWidth] = $aqdBs.useState(0);
        const [open, setOpen] = (0, $eAKDF.default)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        $aqdBs.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $aqdBs.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $aqdBs.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $da2a63b80fe89ff2$export$29e2a8c3cdb34b03(PurePanel);
};
var $da2a63b80fe89ff2$export$2e2bcd8739ae039 = $da2a63b80fe89ff2$var$genPurePanel;

});


parcelRegister("hYh07", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1553a4757c2842b$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $hsPO1 = parcelRequire("hsPO1");

var $8DDDH = parcelRequire("8DDDH");

var $41TBD = parcelRequire("41TBD");

var $byj09 = parcelRequire("byj09");
"use client";
let $d1553a4757c2842b$var$uuid = 0;
const $d1553a4757c2842b$var$ElementsHolder = /*#__PURE__*/ $aqdBs.memo(/*#__PURE__*/ $aqdBs.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $hsPO1.default)();
    $aqdBs.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), []);
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, elements);
}));
function $d1553a4757c2842b$var$useModal() {
    const holderRef = $aqdBs.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $aqdBs.useState([]);
    $aqdBs.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $dMbbs.default)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $aqdBs.useCallback((withFunc)=>function hookConfirm(config) {
            var _a;
            $d1553a4757c2842b$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $aqdBs.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $aqdBs.createElement((0, $byj09.default), {
                key: `modal-${$d1553a4757c2842b$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $41TBD.default).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $dMbbs.default)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $dMbbs.default)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $aqdBs.useMemo(()=>({
            info: getConfirmFunc((0, $8DDDH.withInfo)),
            success: getConfirmFunc((0, $8DDDH.withSuccess)),
            error: getConfirmFunc((0, $8DDDH.withError)),
            warning: getConfirmFunc((0, $8DDDH.withWarn)),
            confirm: getConfirmFunc((0, $8DDDH.withConfirm))
        }), []);
    return [
        fns,
        /*#__PURE__*/ $aqdBs.createElement($d1553a4757c2842b$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $d1553a4757c2842b$export$2e2bcd8739ae039 = $d1553a4757c2842b$var$useModal;

});
parcelRegister("hsPO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb6d3cc18fa620c5$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");
function $cb6d3cc18fa620c5$export$2e2bcd8739ae039() {
    const [elements, setElements] = $aqdBs.useState([]);
    const patchElement = $aqdBs.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $dMbbs.default)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}

});

parcelRegister("byj09", function(module, exports) {

$parcel$export(module.exports, "default", () => $86919bf7d7b45674$export$2e2bcd8739ae039);

var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $iPGr2 = parcelRequire("iPGr2");

var $h1ynd = parcelRequire("h1ynd");

var $hnODd = parcelRequire("hnODd");
"use client";
var $86919bf7d7b45674$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $86919bf7d7b45674$var$HookModal = (_a, ref)=>{
    var _b;
    var { afterClose: hookAfterClose, config: config } = _a, restProps = $86919bf7d7b45674$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    const [open, setOpen] = $aqdBs.useState(true);
    const [innerConfig, setInnerConfig] = $aqdBs.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        var _a;
        hookAfterClose();
        (_a = innerConfig.afterClose) === null || _a === void 0 || _a.call(innerConfig);
    };
    const close = (...args)=>{
        var _a;
        setOpen(false);
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = innerConfig.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                innerConfig,
                ()=>{}
            ].concat((0, $dMbbs.default)(args.slice(1))));
        }
    };
    $aqdBs.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
                    return Object.assign(Object.assign({}, originConfig), nextConfig);
                });
            }
        }));
    const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === 'confirm';
    const [contextLocale] = (0, $h1ynd.default)('Modal', (0, $iPGr2.default).Modal);
    return /*#__PURE__*/ $aqdBs.createElement((0, $hnODd.default), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $86919bf7d7b45674$export$2e2bcd8739ae039 = /*#__PURE__*/ $aqdBs.forwardRef($86919bf7d7b45674$var$HookModal);

});



parcelRegister("fcEEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b117821ff5c99f06$export$2e2bcd8739ae039);

var $fuGj2 = parcelRequire("fuGj2");
"use client";
var $b117821ff5c99f06$export$2e2bcd8739ae039 = (0, $fuGj2.default);

});

parcelRegister("1VQWV", function(module, exports) {

$parcel$export(module.exports, "ConfigContextProvider", () => $8d5e398678951c0e$export$971ebf973ae8b56d);
$parcel$export(module.exports, "useConfig", () => $8d5e398678951c0e$export$b3611e87cd5ba6ce);

var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");
const $8d5e398678951c0e$var$ConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createContext([
    null,
    ()=>{}
]);
const $8d5e398678951c0e$export$971ebf973ae8b56d = ({ children: children })=>{
    const [config, setConfig] = (0, $aqdBs.useState)(null);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($8d5e398678951c0e$var$ConfigContext.Provider, {
            value: [
                config,
                setConfig
            ],
            children: children
        })
    });
};
const $8d5e398678951c0e$export$b3611e87cd5ba6ce = ()=>{
    const context = (0, $aqdBs.useContext)($8d5e398678951c0e$var$ConfigContext);
    return context;
};

});

parcelRegister("b0VD2", function(module, exports) {

$parcel$export(module.exports, "syncStateFromRequest", () => $4dcc4e38b5218753$export$7aad4b57ca7f6412);
$parcel$export(module.exports, "matchSelector", () => $4dcc4e38b5218753$export$ef96375905129b31);
$parcel$export(module.exports, "getStatusForSelector", () => $4dcc4e38b5218753$export$b2534105be62e61b);
$parcel$export(module.exports, "OplogState", () => $4dcc4e38b5218753$export$7e883c62b0dc20c2);

var $81vtw = parcelRequire("81vtw");

var $cT7kT = parcelRequire("cT7kT");

var $c9ked = parcelRequire("c9ked");

var $1jDsz = parcelRequire("1jDsz");
const $4dcc4e38b5218753$export$7aad4b57ca7f6412 = (state, req, onError)=>{
    (0, $c9ked.getOperations)(req).then((res)=>{
        state.add(...res);
    }).catch((e)=>{
        if (onError) onError(e);
    });
    const cbHelper = (event, err)=>{
        if (err) {
            if (onError) onError(err);
            state.reset();
            (0, $c9ked.getOperations)(req).then((res)=>{
                state.add(...res);
            }).catch((e)=>{
                if (onError) onError(e);
            });
        } else if (event) switch(event.event.case){
            case "createdOperations":
            case "updatedOperations":
                let ops = event.event.value.operations;
                if (req.selector) ops = ops.filter((op)=>$4dcc4e38b5218753$export$ef96375905129b31(req.selector, op));
                state.add(...ops);
                break;
            case "deletedOperations":
                state.removeIDs(...event.event.value.values);
                break;
        }
    };
    (0, $c9ked.subscribeToOperations)(cbHelper);
    return ()=>{
        (0, $c9ked.unsubscribeFromOperations)(cbHelper);
    };
};
// getStatus returns the status of the last N operations that belong to a single snapshot.
const $4dcc4e38b5218753$var$getStatus = async (req)=>{
    let ops = await (0, $c9ked.getOperations)(req);
    ops.sort((a, b)=>{
        return Number(b.unixTimeStartMs - a.unixTimeStartMs);
    });
    let flowID = undefined;
    for (const op of ops){
        if (op.status === (0, $81vtw.OperationStatus).STATUS_PENDING || op.status === (0, $81vtw.OperationStatus).STATUS_SYSTEM_CANCELLED || op.op.case === "operationRunHook") continue;
        if (!flowID) flowID = op.flowId;
        else if (flowID !== op.flowId) break;
        if (op.status !== (0, $81vtw.OperationStatus).STATUS_SUCCESS) return op.status;
    }
    return (0, $81vtw.OperationStatus).STATUS_SUCCESS;
};
const $4dcc4e38b5218753$export$b2534105be62e61b = async (sel)=>{
    const req = (0, $1jDsz.create)((0, $cT7kT.GetOperationsRequestSchema), {
        selector: sel,
        lastN: BigInt(20)
    });
    return await $4dcc4e38b5218753$var$getStatus(req);
};
class $4dcc4e38b5218753$export$7e883c62b0dc20c2 {
    constructor(filter = ()=>true){
        this.filter = filter;
        this.byID = new Map();
        this.byFlowID = new Map();
        this.subscribers = new Set();
    }
    subscribe(subscriber) {
        this.subscribers.add(subscriber);
    }
    unsubscribe(subscriber) {
        this.subscribers.delete(subscriber);
    }
    reset() {
        const idsRemoved = Array.from(this.byID.keys());
        const flowIDsRemoved = Array.from(this.byFlowID.keys());
        this.byID.clear();
        this.byFlowID.clear();
        for (let subscriber of this.subscribers)subscriber(idsRemoved, flowIDsRemoved, (0, $81vtw.OperationEventType).EVENT_DELETED);
    }
    getByFlowID(flowID) {
        return this.byFlowID.get(flowID);
    }
    getByID(id) {
        return this.byID.get(id);
    }
    getAll() {
        return Array.from(this.byID.values());
    }
    add(...ops) {
        const idsRemoved = [];
        const ids = [];
        const flowIDsRemoved = new Set();
        const flowIDs = new Set();
        for (let op of ops)if (!this.filter(op)) {
            idsRemoved.push(op.id);
            flowIDsRemoved.add(op.flowId);
            this.removeHelper(op);
        } else {
            const flow = this.byFlowID.get(op.flowId);
            if (op.op.case === "operationIndexSnapshot" && flow && flow.find((o)=>o.id !== op.id && o.op.case === "operationIndexSnapshot" && o.snapshotId === op.snapshotId)) continue;
            ids.push(op.id);
            flowIDs.add(op.flowId);
            this.addHelper(op);
        }
        if (idsRemoved.length > 0) for (let subscriber of this.subscribers)subscriber(idsRemoved, Array.from(flowIDsRemoved), (0, $81vtw.OperationEventType).EVENT_DELETED);
        if (ids.length > 0) for (let subscriber of this.subscribers)subscriber(ids, Array.from(flowIDs), (0, $81vtw.OperationEventType).EVENT_CREATED);
    }
    removeIDs(...ids) {
        const ops = [];
        for (let id of ids){
            let op = this.byID.get(id);
            if (op) ops.push(op);
        }
        this.remove(...ops);
    }
    remove(...ops) {
        const ids = [];
        const flowIDs = new Set();
        for (let op of ops){
            ids.push(op.id);
            flowIDs.add(op.flowId);
            this.removeHelper(op);
        }
        for (let subscriber of this.subscribers)subscriber(ids, Array.from(flowIDs), (0, $81vtw.OperationEventType).EVENT_DELETED);
    }
    addHelper(op) {
        this.byID.set(op.id, op);
        let ops = this.byFlowID.get(op.flowId);
        if (!ops) {
            ops = [];
            this.byFlowID.set(op.flowId, ops);
        }
        let index = ops.findIndex((o)=>o.id === op.id);
        if (index !== -1) ops[index] = op;
        else ops.push(op);
    }
    removeHelper(op) {
        this.byID.delete(op.id);
        let ops = this.byFlowID.get(op.flowId);
        if (ops) {
            let index = ops.indexOf(op);
            if (index !== -1) ops.splice(index, 1);
        }
    }
}
const $4dcc4e38b5218753$export$ef96375905129b31 = (selector, op)=>{
    if (selector.planId && selector.planId !== op.planId) return false;
    if (selector.repoGuid && selector.repoGuid !== op.repoGuid) return false;
    if (selector.flowId && selector.flowId !== op.flowId) return false;
    return true;
};

});

parcelRegister("ebiy2", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $a5307b094a1b61c3$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $a5307b094a1b61c3$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $a5307b094a1b61c3$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $a5307b094a1b61c3$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $a5307b094a1b61c3$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $a5307b094a1b61c3$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $a5307b094a1b61c3$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $a5307b094a1b61c3$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $a5307b094a1b61c3$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $a5307b094a1b61c3$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $a5307b094a1b61c3$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $a5307b094a1b61c3$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $a5307b094a1b61c3$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $a5307b094a1b61c3$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $a5307b094a1b61c3$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $a5307b094a1b61c3$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Route", () => $a5307b094a1b61c3$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $a5307b094a1b61c3$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $a5307b094a1b61c3$export$52b333d321859367);
/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

var $9FOsn = parcelRequire("9FOsn");
function $a5307b094a1b61c3$var$_extends() {
    $a5307b094a1b61c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a5307b094a1b61c3$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $a5307b094a1b61c3$export$3add0d5dce533e2e = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$145dfa71566a64dc = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$var$AwaitContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $a5307b094a1b61c3$export$26749e8557646306 = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$c7914228fb69b0f5 = /*#__PURE__*/ $aqdBs.createContext(null);
const $a5307b094a1b61c3$export$9072aa6dd1f93057 = /*#__PURE__*/ $aqdBs.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $a5307b094a1b61c3$var$RouteErrorContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $a5307b094a1b61c3$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $a5307b094a1b61c3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $a5307b094a1b61c3$export$9c954a9d03d32f4a() {
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $a5307b094a1b61c3$export$45d76561a5302f2b() {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $a5307b094a1b61c3$export$1b3f31771c5d07c() {
    return $aqdBs.useContext($a5307b094a1b61c3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $a5307b094a1b61c3$export$6c330e8992e8a295(pattern) {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { pathname: pathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    return $aqdBs.useMemo(()=>(0, $9FOsn.matchPath)(pattern, (0, $9FOsn.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $a5307b094a1b61c3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aqdBs.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $a5307b094a1b61c3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $a5307b094a1b61c3$var$useNavigateStable() : $a5307b094a1b61c3$var$useNavigateUnstable();
}
function $a5307b094a1b61c3$var$useNavigateUnstable() {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let dataRouterContext = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $aqdBs.useRef(false);
    $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $9FOsn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $a5307b094a1b61c3$var$OutletContext = /*#__PURE__*/ $aqdBs.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $a5307b094a1b61c3$export$4138103a3ae699cc() {
    return $aqdBs.useContext($a5307b094a1b61c3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $a5307b094a1b61c3$export$a3be3530d8e40d0b(context) {
    let outlet = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $a5307b094a1b61c3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $a5307b094a1b61c3$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $aqdBs.useMemo(()=>(0, $9FOsn.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $a5307b094a1b61c3$export$5d3fca4a98652595(routes, locationArg) {
    return $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { navigator: navigator } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: parentMatches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $9FOsn.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $9FOsn.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $9FOsn.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $a5307b094a1b61c3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $9FOsn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $9FOsn.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $a5307b094a1b61c3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $9FOsn.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $a5307b094a1b61c3$var$DefaultErrorComponent() {
    let error = $a5307b094a1b61c3$export$ed527bf60f6e05f2();
    let message = (0, $9FOsn.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aqdBs.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aqdBs.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $a5307b094a1b61c3$var$defaultErrorElement = /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$DefaultErrorComponent, null);
class $a5307b094a1b61c3$var$RenderErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $a5307b094a1b61c3$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $a5307b094a1b61c3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $9FOsn.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $a5307b094a1b61c3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $a5307b094a1b61c3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aqdBs.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $a5307b094a1b61c3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($a5307b094a1b61c3$var$DataRouterHook || {});
var $a5307b094a1b61c3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($a5307b094a1b61c3$var$DataRouterStateHook || {});
function $a5307b094a1b61c3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a5307b094a1b61c3$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext($a5307b094a1b61c3$export$3add0d5dce533e2e);
    !ctx && (0, $9FOsn.UNSAFE_invariant)(false);
    return ctx;
}
function $a5307b094a1b61c3$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext($a5307b094a1b61c3$export$145dfa71566a64dc);
    !state && (0, $9FOsn.UNSAFE_invariant)(false);
    return state;
}
function $a5307b094a1b61c3$var$useRouteContext(hookName) {
    let route = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    !route && (0, $9FOsn.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $a5307b094a1b61c3$var$useCurrentRouteId(hookName) {
    let route = $a5307b094a1b61c3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $9FOsn.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $a5307b094a1b61c3$export$5fc8298006ad9e58() {
    return $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $a5307b094a1b61c3$export$d0fd4b7106de2769() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $a5307b094a1b61c3$export$600dc272ed516c15() {
    let dataRouterContext = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseRevalidator);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRevalidator);
    return $aqdBs.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $a5307b094a1b61c3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseMatches);
    return $aqdBs.useMemo(()=>matches.map((m)=>(0, $9FOsn.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $a5307b094a1b61c3$export$1448a5050d252c4d() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $a5307b094a1b61c3$export$fd5d37484eab868d(routeId) {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $a5307b094a1b61c3$export$fdc00f3f26066d5e() {
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseActionData);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $a5307b094a1b61c3$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aqdBs.useContext($a5307b094a1b61c3$var$RouteErrorContext);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteError);
    let routeId = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $a5307b094a1b61c3$export$78a72ddb39bdd145() {
    let value = $aqdBs.useContext($a5307b094a1b61c3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $a5307b094a1b61c3$export$17f53340677d5831() {
    let value = $aqdBs.useContext($a5307b094a1b61c3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $a5307b094a1b61c3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $a5307b094a1b61c3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseBlocker);
    let state = $a5307b094a1b61c3$var$useDataRouterState($a5307b094a1b61c3$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aqdBs.useState("");
    let blockerFunction = $aqdBs.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $a5307b094a1b61c3$var$_extends({}, currentLocation, {
                pathname: (0, $9FOsn.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $a5307b094a1b61c3$var$_extends({}, nextLocation, {
                pathname: (0, $9FOsn.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aqdBs.useEffect(()=>{
        let key = String(++$a5307b094a1b61c3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aqdBs.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9FOsn.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $a5307b094a1b61c3$var$useNavigateStable() {
    let { router: router } = $a5307b094a1b61c3$var$useDataRouterContext($a5307b094a1b61c3$var$DataRouterHook.UseNavigateStable);
    let id = $a5307b094a1b61c3$var$useCurrentRouteId($a5307b094a1b61c3$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aqdBs.useRef(false);
    $a5307b094a1b61c3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aqdBs.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $a5307b094a1b61c3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $a5307b094a1b61c3$var$alreadyWarned$1 = {};
function $a5307b094a1b61c3$var$warningOnce(key, cond, message) {
    if (!cond && !$a5307b094a1b61c3$var$alreadyWarned$1[key]) $a5307b094a1b61c3$var$alreadyWarned$1[key] = true;
}
const $a5307b094a1b61c3$var$alreadyWarned = {};
function $a5307b094a1b61c3$var$warnOnce(key, message) {}
const $a5307b094a1b61c3$var$logDeprecation = (flag, msg, link)=>$a5307b094a1b61c3$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $a5307b094a1b61c3$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $a5307b094a1b61c3$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $a5307b094a1b61c3$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a5307b094a1b61c3$var$START_TRANSITION = "startTransition";
const $a5307b094a1b61c3$var$startTransitionImpl = $aqdBs[$a5307b094a1b61c3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a5307b094a1b61c3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        if (v7_startTransition && $a5307b094a1b61c3$var$startTransitionImpl) $a5307b094a1b61c3$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $aqdBs.useEffect(()=>$a5307b094a1b61c3$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $a5307b094a1b61c3$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $a5307b094a1b61c3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $a5307b094a1b61c3$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $a5307b094a1b61c3$var$startTransitionImpl ? $a5307b094a1b61c3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>$a5307b094a1b61c3$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $a5307b094a1b61c3$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $aqdBs.useContext($a5307b094a1b61c3$export$26749e8557646306);
    let { matches: matches } = $aqdBs.useContext($a5307b094a1b61c3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $a5307b094a1b61c3$export$45d76561a5302f2b();
    let navigate = $a5307b094a1b61c3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $9FOsn.resolveTo)(to, (0, $9FOsn.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aqdBs.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $a5307b094a1b61c3$export$910ae8079b2c2852(props) {
    return $a5307b094a1b61c3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $a5307b094a1b61c3$export$e7b0ac011bb776c6(_props) {
    (0, $9FOsn.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $a5307b094a1b61c3$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $9FOsn.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$a5307b094a1b61c3$export$9c954a9d03d32f4a() && (0, $9FOsn.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aqdBs.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $a5307b094a1b61c3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $9FOsn.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aqdBs.useMemo(()=>{
        let trailingPathname = (0, $9FOsn.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $a5307b094a1b61c3$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $a5307b094a1b61c3$export$5d3fca4a98652595($a5307b094a1b61c3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $a5307b094a1b61c3$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$ResolveAwait, null, children));
}
var $a5307b094a1b61c3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($a5307b094a1b61c3$var$AwaitRenderStatus || {});
const $a5307b094a1b61c3$var$neverSettledPromise = new Promise(()=>{});
class $a5307b094a1b61c3$var$AwaitErrorBoundary extends $aqdBs.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $a5307b094a1b61c3$var$AwaitRenderStatus.error : "_data" in promise ? $a5307b094a1b61c3$var$AwaitRenderStatus.success : $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $a5307b094a1b61c3$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error && promise._error instanceof (0, $9FOsn.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $a5307b094a1b61c3$var$neverSettledPromise;
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $a5307b094a1b61c3$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aqdBs.createElement($a5307b094a1b61c3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $a5307b094a1b61c3$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $a5307b094a1b61c3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $a5307b094a1b61c3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aqdBs.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aqdBs.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aqdBs.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $a5307b094a1b61c3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $a5307b094a1b61c3$export$e7b0ac011bb776c6) && (0, $9FOsn.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $9FOsn.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $a5307b094a1b61c3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $a5307b094a1b61c3$export$daf73786167a7f72(matches) {
    return $a5307b094a1b61c3$var$_renderMatches(matches);
}
function $a5307b094a1b61c3$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aqdBs.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $aqdBs.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aqdBs.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $a5307b094a1b61c3$export$f30f7e456d254e83(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a5307b094a1b61c3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $a5307b094a1b61c3$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("9FOsn", function(module, exports) {

$parcel$export(module.exports, "Action", () => $01d146888511578c$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $01d146888511578c$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $01d146888511578c$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $01d146888511578c$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $01d146888511578c$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $01d146888511578c$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $01d146888511578c$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $01d146888511578c$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $01d146888511578c$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $01d146888511578c$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $01d146888511578c$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $01d146888511578c$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $01d146888511578c$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $01d146888511578c$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $01d146888511578c$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $01d146888511578c$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $01d146888511578c$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $01d146888511578c$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $01d146888511578c$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $01d146888511578c$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $01d146888511578c$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $01d146888511578c$var$_extends() {
    $01d146888511578c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01d146888511578c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $01d146888511578c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($01d146888511578c$export$e19cd5f9376f8cee || ($01d146888511578c$export$e19cd5f9376f8cee = {}));
const $01d146888511578c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $01d146888511578c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $01d146888511578c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $01d146888511578c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $01d146888511578c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $01d146888511578c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
    }
    return $01d146888511578c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $01d146888511578c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $01d146888511578c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $01d146888511578c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $01d146888511578c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $01d146888511578c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $01d146888511578c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $01d146888511578c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $01d146888511578c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $01d146888511578c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $01d146888511578c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $01d146888511578c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $01d146888511578c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $01d146888511578c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $01d146888511578c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $01d146888511578c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($01d146888511578c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Push;
        let location = $01d146888511578c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $01d146888511578c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        let location = $01d146888511578c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $01d146888511578c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $01d146888511578c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $01d146888511578c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($01d146888511578c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($01d146888511578c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $01d146888511578c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($01d146888511578c$var$ResultType || ($01d146888511578c$var$ResultType = {}));
const $01d146888511578c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $01d146888511578c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $01d146888511578c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $01d146888511578c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $01d146888511578c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($01d146888511578c$var$isIndexRoute(route)) {
            let indexRoute = $01d146888511578c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $01d146888511578c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $01d146888511578c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $01d146888511578c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $01d146888511578c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $01d146888511578c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $01d146888511578c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $01d146888511578c$var$flattenRoutes(routes);
    $01d146888511578c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $01d146888511578c$export$30d21fd6d7295f52(pathname);
        matches = $01d146888511578c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $01d146888511578c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $01d146888511578c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $01d146888511578c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $01d146888511578c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $01d146888511578c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $01d146888511578c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $01d146888511578c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $01d146888511578c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $01d146888511578c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $01d146888511578c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $01d146888511578c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $01d146888511578c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $01d146888511578c$var$paramRe = /^:[\w-]+$/;
const $01d146888511578c$var$dynamicSegmentValue = 3;
const $01d146888511578c$var$indexRouteValue = 2;
const $01d146888511578c$var$emptySegmentValue = 1;
const $01d146888511578c$var$staticSegmentValue = 10;
const $01d146888511578c$var$splatPenalty = -2;
const $01d146888511578c$var$isSplat = (s)=>s === "*";
function $01d146888511578c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($01d146888511578c$var$isSplat)) initialScore += $01d146888511578c$var$splatPenalty;
    if (index) initialScore += $01d146888511578c$var$indexRouteValue;
    return segments.filter((s)=>!$01d146888511578c$var$isSplat(s)).reduce((score, segment)=>score + ($01d146888511578c$var$paramRe.test(segment) ? $01d146888511578c$var$dynamicSegmentValue : segment === "" ? $01d146888511578c$var$emptySegmentValue : $01d146888511578c$var$staticSegmentValue), initialScore);
}
function $01d146888511578c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $01d146888511578c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $01d146888511578c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $01d146888511578c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $01d146888511578c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $01d146888511578c$export$a5c6d149b50c1d86($01d146888511578c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $01d146888511578c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $01d146888511578c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $01d146888511578c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $01d146888511578c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $01d146888511578c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $01d146888511578c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $01d146888511578c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $01d146888511578c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $01d146888511578c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $01d146888511578c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $01d146888511578c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $01d146888511578c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $01d146888511578c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $01d146888511578c$var$normalizeSearch(search),
        hash: $01d146888511578c$var$normalizeHash(hash)
    };
}
function $01d146888511578c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $01d146888511578c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $01d146888511578c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $01d146888511578c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $01d146888511578c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $01d146888511578c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $01d146888511578c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $01d146888511578c$var$_extends({}, toArg);
        $01d146888511578c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $01d146888511578c$var$getInvalidPathError("?", "pathname", "search", to));
        $01d146888511578c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $01d146888511578c$var$getInvalidPathError("#", "pathname", "hash", to));
        $01d146888511578c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $01d146888511578c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $01d146888511578c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $01d146888511578c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $01d146888511578c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $01d146888511578c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $01d146888511578c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $01d146888511578c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $01d146888511578c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $01d146888511578c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $01d146888511578c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $01d146888511578c$export$4051a07651545597(data, init) {
    return new $01d146888511578c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $01d146888511578c$export$42a99a7a4bc0e76a extends Error {
}
class $01d146888511578c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $01d146888511578c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $01d146888511578c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $01d146888511578c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $01d146888511578c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $01d146888511578c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $01d146888511578c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $01d146888511578c$var$unwrapTrackedPromise(value) {
    if (!$01d146888511578c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $01d146888511578c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $01d146888511578c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $01d146888511578c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $01d146888511578c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $01d146888511578c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $01d146888511578c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $01d146888511578c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $01d146888511578c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $01d146888511578c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $01d146888511578c$var$validMutationMethods = new Set($01d146888511578c$var$validMutationMethodsArr);
const $01d146888511578c$var$validRequestMethodsArr = [
    "get",
    ...$01d146888511578c$var$validMutationMethodsArr
];
const $01d146888511578c$var$validRequestMethods = new Set($01d146888511578c$var$validRequestMethodsArr);
const $01d146888511578c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $01d146888511578c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $01d146888511578c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $01d146888511578c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $01d146888511578c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $01d146888511578c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $01d146888511578c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $01d146888511578c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $01d146888511578c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $01d146888511578c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $01d146888511578c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $01d146888511578c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $01d146888511578c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $01d146888511578c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$01d146888511578c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$01d146888511578c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $01d146888511578c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $01d146888511578c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $01d146888511578c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $01d146888511578c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$01d146888511578c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($01d146888511578c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $01d146888511578c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $01d146888511578c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $01d146888511578c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $01d146888511578c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $01d146888511578c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $01d146888511578c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($01d146888511578c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $01d146888511578c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $01d146888511578c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $01d146888511578c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $01d146888511578c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $01d146888511578c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $01d146888511578c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $01d146888511578c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $01d146888511578c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $01d146888511578c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $01d146888511578c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $01d146888511578c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $01d146888511578c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $01d146888511578c$var$findNearestBoundary(matches).route.id,
            {
                type: $01d146888511578c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $01d146888511578c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($01d146888511578c$var$isErrorResult(result) && $01d146888511578c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $01d146888511578c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $01d146888511578c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $01d146888511578c$var$_extends({
            matches: updatedMatches || matches
        }, $01d146888511578c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $01d146888511578c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $01d146888511578c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $01d146888511578c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $01d146888511578c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $01d146888511578c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $01d146888511578c$var$ResultType.error,
            error: $01d146888511578c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($01d146888511578c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $01d146888511578c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($01d146888511578c$var$isDeferredResult(result)) throw $01d146888511578c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($01d146888511578c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $01d146888511578c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $01d146888511578c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $01d146888511578c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $01d146888511578c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($01d146888511578c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $01d146888511578c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $01d146888511578c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $01d146888511578c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $01d146888511578c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $01d146888511578c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $01d146888511578c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $01d146888511578c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $01d146888511578c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$01d146888511578c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $01d146888511578c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $01d146888511578c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $01d146888511578c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $01d146888511578c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $01d146888511578c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $01d146888511578c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $01d146888511578c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $01d146888511578c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $01d146888511578c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $01d146888511578c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($01d146888511578c$var$isRedirectResult(actionResult) || $01d146888511578c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($01d146888511578c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $01d146888511578c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($01d146888511578c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($01d146888511578c$var$isDeferredResult(actionResult)) throw $01d146888511578c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $01d146888511578c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $01d146888511578c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $01d146888511578c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $01d146888511578c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $01d146888511578c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $01d146888511578c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $01d146888511578c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $01d146888511578c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $01d146888511578c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $01d146888511578c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $01d146888511578c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $01d146888511578c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $01d146888511578c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $01d146888511578c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($01d146888511578c$var$isDeferredResult(result)) result = await $01d146888511578c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($01d146888511578c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($01d146888511578c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $01d146888511578c$export$3e9cee6b33872309(!$01d146888511578c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $01d146888511578c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $01d146888511578c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $01d146888511578c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $01d146888511578c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $01d146888511578c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $01d146888511578c$export$e19cd5f9376f8cee.Replace : $01d146888511578c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $01d146888511578c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($01d146888511578c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $01d146888511578c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $01d146888511578c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $01d146888511578c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $01d146888511578c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $01d146888511578c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($01d146888511578c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $01d146888511578c$var$ResultType.redirect,
                response: $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $01d146888511578c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $01d146888511578c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $01d146888511578c$var$ResultType.error,
                    error: $01d146888511578c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $01d146888511578c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $01d146888511578c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $01d146888511578c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $01d146888511578c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $01d146888511578c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $01d146888511578c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $01d146888511578c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $01d146888511578c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $01d146888511578c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $01d146888511578c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $01d146888511578c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $01d146888511578c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $01d146888511578c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$01d146888511578c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $01d146888511578c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $01d146888511578c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $01d146888511578c$export$4d0306f8f6a4585b = Symbol("deferred");
function $01d146888511578c$export$3336b097a6fbc59a(routes, opts) {
    $01d146888511578c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $01d146888511578c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $01d146888511578c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $01d146888511578c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $01d146888511578c$var$createLocation("", $01d146888511578c$export$fe53371bee54353d(url), null, "default");
        let matches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$01d146888511578c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $01d146888511578c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $01d146888511578c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $01d146888511578c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($01d146888511578c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $01d146888511578c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $01d146888511578c$var$createLocation("", $01d146888511578c$export$fe53371bee54353d(url), null, "default");
        let matches = $01d146888511578c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$01d146888511578c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $01d146888511578c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $01d146888511578c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $01d146888511578c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $01d146888511578c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $01d146888511578c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($01d146888511578c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$01d146888511578c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $01d146888511578c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($01d146888511578c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $01d146888511578c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $01d146888511578c$var$isResponse(result) ? result : $01d146888511578c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($01d146888511578c$var$isDataStrategyResult(e) && $01d146888511578c$var$isResponse(e.result)) {
                if (e.type === $01d146888511578c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($01d146888511578c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $01d146888511578c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $01d146888511578c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($01d146888511578c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($01d146888511578c$var$isDeferredResult(result)) {
            let error = $01d146888511578c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $01d146888511578c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($01d146888511578c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($01d146888511578c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $01d146888511578c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $01d146888511578c$var$_extends({}, context, {
                statusCode: $01d146888511578c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $01d146888511578c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $01d146888511578c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $01d146888511578c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $01d146888511578c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $01d146888511578c$var$callDataStrategyImpl(dataStrategy || $01d146888511578c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($01d146888511578c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($01d146888511578c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $01d146888511578c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $01d146888511578c$export$fec11da027c70692(routes, context, error) {
    let newContext = $01d146888511578c$var$_extends({}, context, {
        statusCode: $01d146888511578c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $01d146888511578c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $01d146888511578c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $01d146888511578c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $01d146888511578c$export$cae722b0cc860f13(to ? to : ".", $01d146888511578c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $01d146888511578c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $01d146888511578c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $01d146888511578c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $01d146888511578c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $01d146888511578c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$01d146888511578c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$01d146888511578c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $01d146888511578c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $01d146888511578c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $01d146888511578c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$01d146888511578c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$01d146888511578c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $01d146888511578c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $01d146888511578c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $01d146888511578c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $01d146888511578c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $01d146888511578c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($01d146888511578c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $01d146888511578c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $01d146888511578c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $01d146888511578c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $01d146888511578c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $01d146888511578c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $01d146888511578c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($01d146888511578c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $01d146888511578c$var$shouldRevalidateLoader(match, $01d146888511578c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $01d146888511578c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $01d146888511578c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $01d146888511578c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $01d146888511578c$var$shouldRevalidateLoader(fetcherMatch, $01d146888511578c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $01d146888511578c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $01d146888511578c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $01d146888511578c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $01d146888511578c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $01d146888511578c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $01d146888511578c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$01d146888511578c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $01d146888511578c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $01d146888511578c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$01d146888511578c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $01d146888511578c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $01d146888511578c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $01d146888511578c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$01d146888511578c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $01d146888511578c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $01d146888511578c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $01d146888511578c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $01d146888511578c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $01d146888511578c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $01d146888511578c$var$ResultType.data,
                result: undefined
            });
        };
        return $01d146888511578c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $01d146888511578c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $01d146888511578c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $01d146888511578c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $01d146888511578c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $01d146888511578c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $01d146888511578c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $01d146888511578c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($01d146888511578c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $01d146888511578c$var$ResultType.error,
                error: e
            };
        }
        if (type === $01d146888511578c$var$ResultType.error) return {
            type: $01d146888511578c$var$ResultType.error,
            error: new $01d146888511578c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $01d146888511578c$var$ResultType.error) {
        if ($01d146888511578c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $01d146888511578c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $01d146888511578c$var$ResultType.error,
                error: new $01d146888511578c$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $01d146888511578c$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $01d146888511578c$var$ResultType.error,
            error: result,
            statusCode: $01d146888511578c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($01d146888511578c$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $01d146888511578c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($01d146888511578c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $01d146888511578c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $01d146888511578c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $01d146888511578c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $01d146888511578c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $01d146888511578c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($01d146888511578c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $01d146888511578c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $01d146888511578c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($01d146888511578c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $01d146888511578c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $01d146888511578c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $01d146888511578c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $01d146888511578c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $01d146888511578c$export$3e9cee6b33872309(!$01d146888511578c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($01d146888511578c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $01d146888511578c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $01d146888511578c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($01d146888511578c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $01d146888511578c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $01d146888511578c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $01d146888511578c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($01d146888511578c$var$isErrorResult(result)) {
            let boundaryMatch = $01d146888511578c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $01d146888511578c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($01d146888511578c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $01d146888511578c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($01d146888511578c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $01d146888511578c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $01d146888511578c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $01d146888511578c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $01d146888511578c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $01d146888511578c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $01d146888511578c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $01d146888511578c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $01d146888511578c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $01d146888511578c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $01d146888511578c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $01d146888511578c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($01d146888511578c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $01d146888511578c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(path) : path;
    return $01d146888511578c$export$fe53371bee54353d($01d146888511578c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $01d146888511578c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $01d146888511578c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $01d146888511578c$var$ResultType.data || result.type === $01d146888511578c$var$ResultType.error);
}
function $01d146888511578c$var$isRedirectDataStrategyResultResult(result) {
    return $01d146888511578c$var$isResponse(result.result) && $01d146888511578c$var$redirectStatusCodes.has(result.result.status);
}
function $01d146888511578c$var$isDeferredResult(result) {
    return result.type === $01d146888511578c$var$ResultType.deferred;
}
function $01d146888511578c$var$isErrorResult(result) {
    return result.type === $01d146888511578c$var$ResultType.error;
}
function $01d146888511578c$var$isRedirectResult(result) {
    return (result && result.type) === $01d146888511578c$var$ResultType.redirect;
}
function $01d146888511578c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $01d146888511578c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $01d146888511578c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $01d146888511578c$var$isRedirectResponse(result) {
    if (!$01d146888511578c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $01d146888511578c$var$isValidMethod(method) {
    return $01d146888511578c$var$validRequestMethods.has(method.toLowerCase());
}
function $01d146888511578c$var$isMutationMethod(method) {
    return $01d146888511578c$var$validMutationMethods.has(method.toLowerCase());
}
async function $01d146888511578c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$01d146888511578c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($01d146888511578c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $01d146888511578c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $01d146888511578c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($01d146888511578c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $01d146888511578c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $01d146888511578c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $01d146888511578c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $01d146888511578c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $01d146888511578c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $01d146888511578c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $01d146888511578c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $01d146888511578c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $01d146888511578c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $01d146888511578c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $01d146888511578c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $01d146888511578c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $01d146888511578c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $01d146888511578c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $01d146888511578c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $01d146888511578c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $01d146888511578c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $01d146888511578c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($01d146888511578c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $01d146888511578c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($01d146888511578c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $01d146888511578c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("aIP8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ce5ad34b7ef970a$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $fa7bF = parcelRequire("fa7bF");

var $gL7Ec = parcelRequire("gL7Ec");
var $7ce5ad34b7ef970a$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $fa7bF.default)
    }));
};
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ var $7ce5ad34b7ef970a$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($7ce5ad34b7ef970a$var$DownOutlined);
var $7ce5ad34b7ef970a$export$2e2bcd8739ae039 = $7ce5ad34b7ef970a$var$RefIcon;

});
parcelRegister("fa7bF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09d5d6a354f9ab8$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $b09d5d6a354f9ab8$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $b09d5d6a354f9ab8$export$2e2bcd8739ae039 = $b09d5d6a354f9ab8$var$DownOutlined;

});


parcelRegister("dU9d6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f7a64a84dc4d49$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $kft9J = parcelRequire("kft9J");

var $k3pyC = parcelRequire("k3pyC");

var $bqPQ9 = parcelRequire("bqPQ9");

var $fwjTv = parcelRequire("fwjTv");

var $k91S5 = parcelRequire("k91S5");

var $eAKDF = parcelRequire("eAKDF");

var $1iwLi = parcelRequire("1iwLi");

var $jHeh6 = parcelRequire("jHeh6");

var $3qwE5 = parcelRequire("3qwE5");

var $i22RA = parcelRequire("i22RA");

var $iJhZR = parcelRequire("iJhZR");

var $iOHOh = parcelRequire("iOHOh");

var $dkjPS = parcelRequire("dkjPS");

var $jaW1p = parcelRequire("jaW1p");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $f6jN2 = parcelRequire("f6jN2");

var $kkbgX = parcelRequire("kkbgX");

var $jygCN = parcelRequire("jygCN");

var $cbZ8R = parcelRequire("cbZ8R");
"use client";
const $a1f7a64a84dc4d49$var$_Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const $a1f7a64a84dc4d49$var$Dropdown = (props)=>{
    var _a;
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, visible: // Deprecated
    visible, onVisibleChange: onVisibleChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = '', overlay: overlay, transitionName: transitionName, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, dropdown: dropdown } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const mergedPopupRender = popupRender || dropdownRender;
    // Warning for deprecated usage
    const warning = (0, $dkjPS.devUseWarning)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = $aqdBs.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $aqdBs.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $cbZ8R.default)(prefixCls, rootCls);
    const [, token] = (0, $jygCN.default)();
    const child = $aqdBs.Children.only((0, $3qwE5.default)(children) ? /*#__PURE__*/ $aqdBs.createElement("span", null, children) : children);
    const popupTrigger = (0, $iOHOh.cloneElement)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!(triggerActions === null || triggerActions === void 0 ? void 0 : triggerActions.includes('contextMenu'));
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $eAKDF.default)(false, {
        value: open !== null && open !== void 0 ? open : visible
    });
    const onInnerOpenChange = (0, $k91S5.default)((nextOpen)=>{
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen, {
            source: 'trigger'
        });
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, $i22RA.default)({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = $aqdBs.useCallback(()=>{
        if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) return;
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(false, {
            source: 'menu'
        });
        setOpen(false);
    }, [
        menu === null || menu === void 0 ? void 0 : menu.selectable,
        menu === null || menu === void 0 ? void 0 : menu.multiple
    ]);
    const renderOverlay = ()=>{
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        let overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $aqdBs.createElement((0, $f6jN2.default), Object.assign({}, menu));
        else if (typeof overlay === 'function') overlayNode = overlay();
        else overlayNode = overlay;
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = $aqdBs.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ $aqdBs.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $aqdBs.createElement((0, $kkbgX.OverrideProvider), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $aqdBs.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ $aqdBs.createElement((0, $kft9J.default), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $aqdBs.createElement((0, $k3pyC.default), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $jHeh6.useZIndex)('Dropdown', overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $aqdBs.createElement((0, $fwjTv.default), Object.assign({
        alignPoint: alignPoint
    }, (0, $1iwLi.default)(props, [
        'rootClassName'
    ]), {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
            zIndex: zIndex
        }),
        autoDestroy: destroyOnHidden !== null && destroyOnHidden !== void 0 ? destroyOnHidden : destroyPopupOnHide
    }), popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $aqdBs.createElement((0, $jaW1p.default).Provider, {
        value: contextZIndex
    }, renderNode);
    return wrapCSSVar(renderNode);
};
// We don't care debug panel
const $a1f7a64a84dc4d49$var$PurePanel = (0, $iJhZR.default)($a1f7a64a84dc4d49$var$Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $a1f7a64a84dc4d49$var$WrapPurePanel = (props)=>/*#__PURE__*/ $aqdBs.createElement($a1f7a64a84dc4d49$var$PurePanel, Object.assign({}, props), /*#__PURE__*/ $aqdBs.createElement("span", null));
$a1f7a64a84dc4d49$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $a1f7a64a84dc4d49$var$WrapPurePanel;
var $a1f7a64a84dc4d49$export$2e2bcd8739ae039 = $a1f7a64a84dc4d49$var$Dropdown;

});
parcelRegister("fwjTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4c946c2715ca5f2$export$2e2bcd8739ae039);

var $7OjH4 = parcelRequire("7OjH4");
var $b4c946c2715ca5f2$export$2e2bcd8739ae039 = (0, $7OjH4.default);

});
parcelRegister("7OjH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5afc7aaedea33383$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $br1G4 = parcelRequire("br1G4");

var $kelIR = parcelRequire("kelIR");

var $aX4Fp = parcelRequire("aX4Fp");

var $iSQdk = parcelRequire("iSQdk");

var $bqPQ9 = parcelRequire("bqPQ9");

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");

var $gddnq = parcelRequire("gddnq");

var $6Dbvl = parcelRequire("6Dbvl");

var $bXZqR = parcelRequire("bXZqR");
var $5afc7aaedea33383$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $5afc7aaedea33383$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-dropdown' : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottomLeft' : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $bXZqR.default) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $aX4Fp.default)(props, $5afc7aaedea33383$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useState(), _React$useState2 = (0, $kelIR.default)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = 'visible' in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $gddnq.default)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $6Dbvl.default), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $kBwE8.supportRef)(children) ? (0, $kBwE8.composeRef)(childRef, (0, $kBwE8.getNodeRef)(children)) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $iSQdk.default), (0, $13KW1.default)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(overlayClassName, (0, $br1G4.default)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $5afc7aaedea33383$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).forwardRef($5afc7aaedea33383$var$Dropdown);

});
parcelRegister("gddnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd83c93cc6be469$export$2e2bcd8739ae039);

var $dHI2t = parcelRequire("dHI2t");

var $ebavw = parcelRequire("ebavw");

var $aqdBs = parcelRequire("aqdBs");
var $bcd83c93cc6be469$var$ESC = (0, $dHI2t.default).ESC, $bcd83c93cc6be469$var$TAB = (0, $dHI2t.default).TAB;
function $bcd83c93cc6be469$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $aqdBs.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $bcd83c93cc6be469$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $bcd83c93cc6be469$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $aqdBs.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $ebavw.default)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}

});

parcelRegister("6Dbvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3f4f2331cbd342$export$2e2bcd8739ae039);

var $kBwE8 = parcelRequire("kBwE8");

var $aqdBs = parcelRequire("aqdBs");
var $4d3f4f2331cbd342$var$Overlay = /*#__PURE__*/ (0, $aqdBs.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $aqdBs.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $kBwE8.composeRef)(ref, (0, $kBwE8.getNodeRef)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).cloneElement(overlayNode, {
        ref: (0, $kBwE8.supportRef)(overlayNode) ? composedRef : undefined
    }));
});
var $4d3f4f2331cbd342$export$2e2bcd8739ae039 = $4d3f4f2331cbd342$var$Overlay;

});

parcelRegister("bXZqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b64db89da66941d$export$2e2bcd8739ae039);
var $8b64db89da66941d$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $8b64db89da66941d$var$targetOffset = [
    0,
    0
];
var $8b64db89da66941d$var$placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $8b64db89da66941d$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $8b64db89da66941d$var$targetOffset
    }
};
var $8b64db89da66941d$export$2e2bcd8739ae039 = $8b64db89da66941d$var$placements;

});



parcelRegister("3qwE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $27ed1f8a86c6b312$export$2e2bcd8739ae039);
const $27ed1f8a86c6b312$var$isPrimitive = (value)=>typeof value !== 'object' && typeof value !== 'function' || value === null;
var $27ed1f8a86c6b312$export$2e2bcd8739ae039 = $27ed1f8a86c6b312$var$isPrimitive;

});

parcelRegister("f6jN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe6c46baefb468a$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("1FrlO");
var $7YcE0 = parcelRequire("7YcE0");

var $2Kije = parcelRequire("2Kije");

var $9Lenh = parcelRequire("9Lenh");

var $eE4hS = parcelRequire("eE4hS");

var $6LyRL = parcelRequire("6LyRL");

var $byoLW = parcelRequire("byoLW");
"use client";
const $afe6c46baefb468a$var$Menu = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    const menuRef = (0, $aqdBs.useRef)(null);
    const context = $aqdBs.useContext((0, $2Kije.SiderContext));
    (0, $aqdBs.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                var _a;
                (_a = menuRef.current) === null || _a === void 0 || _a.focus(options);
            }
        }));
    return /*#__PURE__*/ $aqdBs.createElement((0, $9Lenh.default), Object.assign({
        ref: menuRef
    }, props, context));
});
$afe6c46baefb468a$var$Menu.Item = (0, $6LyRL.default);
$afe6c46baefb468a$var$Menu.SubMenu = (0, $byoLW.default);
$afe6c46baefb468a$var$Menu.Divider = (0, $eE4hS.default);
$afe6c46baefb468a$var$Menu.ItemGroup = (0, $7YcE0.default);
var $afe6c46baefb468a$export$2e2bcd8739ae039 = $afe6c46baefb468a$var$Menu;

});
parcelRegister("2Kije", function(module, exports) {

$parcel$export(module.exports, "SiderContext", () => $1ffe1475b5945038$export$63554aebd2a6d54c);
$parcel$export(module.exports, "default", () => $1ffe1475b5945038$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $lK6E1 = parcelRequire("lK6E1");

var $kft9J = parcelRequire("kft9J");

var $k3pyC = parcelRequire("k3pyC");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");

var $9WypM = parcelRequire("9WypM");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $hMq36 = parcelRequire("hMq36");

var $g3fxu = parcelRequire("g3fxu");
"use client";
var $1ffe1475b5945038$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1ffe1475b5945038$var$dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
const $1ffe1475b5945038$var$isNumeric = (value)=>!Number.isNaN(Number.parseFloat(value)) && isFinite(value);
const $1ffe1475b5945038$export$63554aebd2a6d54c = /*#__PURE__*/ $aqdBs.createContext({});
const $1ffe1475b5945038$var$generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $1ffe1475b5945038$var$Sider = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = 'dark', style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint } = props, otherProps = $1ffe1475b5945038$var$__rest(props, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    const { siderHook: siderHook } = (0, $aqdBs.useContext)((0, $hMq36.LayoutContext));
    const [collapsed, setCollapsed] = (0, $aqdBs.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $aqdBs.useState)(false);
    (0, $aqdBs.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $aqdBs.useContext)((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $g3fxu.default)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $aqdBs.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, $aqdBs.useEffect)(()=>{
        function responsiveHandler(mql) {
            var _a;
            return (_a = responsiveHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(responsiveHandlerRef, mql);
        }
        let mql;
        if (typeof (window === null || window === void 0 ? void 0 : window.matchMedia) !== 'undefined' && breakpoint && breakpoint in $1ffe1475b5945038$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$1ffe1475b5945038$var$dimensionMaxMap[breakpoint]})`);
            (0, $9WypM.addMediaQueryListener)(mql, responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            (0, $9WypM.removeMediaQueryListener)(mql, responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $aqdBs.useEffect)(()=>{
        const uniqueId = $1ffe1475b5945038$var$generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, $1iwLi.default)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $1ffe1475b5945038$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $aqdBs.createElement("span", {
        onClick: toggle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $aqdBs.createElement((0, $lK6E1.default), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $aqdBs.createElement((0, $k3pyC.default), null) : /*#__PURE__*/ $aqdBs.createElement((0, $kft9J.default), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $aqdBs.createElement((0, $kft9J.default), null) : /*#__PURE__*/ $aqdBs.createElement((0, $k3pyC.default), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = Object.assign(Object.assign({}, style), {
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        minWidth: siderWidth,
        width: siderWidth
    });
    const siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = $aqdBs.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement($1ffe1475b5945038$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $aqdBs.createElement("aside", Object.assign({
        className: siderCls
    }, divProps, {
        style: divStyle,
        ref: ref
    }), /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null)));
});
var $1ffe1475b5945038$export$2e2bcd8739ae039 = $1ffe1475b5945038$var$Sider;

});
parcelRegister("lK6E1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd430c52ec084afd$export$2e2bcd8739ae039);

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");

var $2e0Wh = parcelRequire("2e0Wh");

var $gL7Ec = parcelRequire("gL7Ec");
var $fd430c52ec084afd$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $2e0Wh.default)
    }));
};
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ var $fd430c52ec084afd$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($fd430c52ec084afd$var$BarsOutlined);
var $fd430c52ec084afd$export$2e2bcd8739ae039 = $fd430c52ec084afd$var$RefIcon;

});
parcelRegister("2e0Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ed9e0cee9261e9$export$2e2bcd8739ae039);
// This icon file is generated automatically.
var $19ed9e0cee9261e9$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $19ed9e0cee9261e9$export$2e2bcd8739ae039 = $19ed9e0cee9261e9$var$BarsOutlined;

});


parcelRegister("hMq36", function(module, exports) {

$parcel$export(module.exports, "LayoutContext", () => $cf1b2023a579dabc$export$964282a2c3979546);

var $aqdBs = parcelRequire("aqdBs");
const $cf1b2023a579dabc$export$964282a2c3979546 = /*#__PURE__*/ $aqdBs.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});

});

parcelRegister("g3fxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $baf8fae69d782c94$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $lnWpy = parcelRequire("lnWpy");

var $4wPvn = parcelRequire("4wPvn");
const $baf8fae69d782c94$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $aWTY1.unit)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, $aWTY1.unit)(borderRadiusLG)} ${(0, $aWTY1.unit)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $aWTY1.unit)(borderRadiusLG)} 0 0 ${(0, $aWTY1.unit)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $baf8fae69d782c94$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)([
    'Layout',
    'Sider'
], (token)=>[
        $baf8fae69d782c94$var$genSiderStyle(token)
    ], (0, $lnWpy.prepareComponentToken), {
    deprecatedTokens: (0, $lnWpy.DEPRECATED_TOKENS)
});

});
parcelRegister("lnWpy", function(module, exports) {

$parcel$export(module.exports, "prepareComponentToken", () => $f9190e38999c4c6c$export$9ca1be8807fe0675);
$parcel$export(module.exports, "DEPRECATED_TOKENS", () => $f9190e38999c4c6c$export$da0be9ab56e785fc);
$parcel$export(module.exports, "default", () => $f9190e38999c4c6c$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $4wPvn = parcelRequire("4wPvn");
const $f9190e38999c4c6c$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $aWTY1.unit)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $f9190e38999c4c6c$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $f9190e38999c4c6c$export$da0be9ab56e785fc = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
var $f9190e38999c4c6c$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Layout', (token)=>[
        $f9190e38999c4c6c$var$genLayoutStyle(token)
    ], $f9190e38999c4c6c$export$9ca1be8807fe0675, {
    deprecatedTokens: $f9190e38999c4c6c$export$da0be9ab56e785fc
});

});



parcelRegister("9Lenh", function(module, exports) {

$parcel$export(module.exports, "default", () => $71b3a752914d185e$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $7uUoR = parcelRequire("7uUoR");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1FrlO = parcelRequire("1FrlO");

var $k91S5 = parcelRequire("k91S5");

var $1iwLi = parcelRequire("1iwLi");

var $dLmcO = parcelRequire("dLmcO");

var $iOHOh = parcelRequire("iOHOh");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aogQV = parcelRequire("aogQV");

var $1vFUO = parcelRequire("1vFUO");

var $eE4hS = parcelRequire("eE4hS");

var $6LyRL = parcelRequire("6LyRL");

var $kkbgX = parcelRequire("kkbgX");

var $56hza = parcelRequire("56hza");

var $byoLW = parcelRequire("byoLW");
"use client";
var $71b3a752914d185e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $71b3a752914d185e$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $71b3a752914d185e$var$MENU_COMPONENTS = {
    item: (0, $6LyRL.default),
    submenu: (0, $byoLW.default),
    divider: (0, $eE4hS.default)
};
const $71b3a752914d185e$var$InternalMenu = /*#__PURE__*/ (0, $aqdBs.forwardRef)((props, ref)=>{
    var _a;
    const override = $aqdBs.useContext((0, $kkbgX.default));
    const overrideObj = override || {};
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, menu: menu } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const rootPrefixCls = getPrefixCls();
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = 'light', expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName } = props, restProps = $71b3a752914d185e$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "rootClassName",
        "mode",
        "selectable",
        "onClick",
        "overflowedIndicatorPopupClassName"
    ]);
    const passedProps = (0, $1iwLi.default)(restProps, [
        'collapsedWidth'
    ]);
    (_a = overrideObj.validator) === null || _a === void 0 || _a.call(overrideObj, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $k91S5.default)((...args)=>{
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, args);
        (_a = overrideObj.onClick) === null || _a === void 0 || _a.call(overrideObj);
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed !== null && inlineCollapsed !== void 0 ? inlineCollapsed : siderCollapsed;
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $dLmcO.default)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $aogQV.default)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $56hza.default)(prefixCls, rootCls, !override);
    const menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-${theme}`, menu === null || menu === void 0 ? void 0 : menu.className, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $aqdBs.useMemo(()=>{
        var _a, _b;
        if (typeof expandIcon === 'function' || $71b3a752914d185e$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || $71b3a752914d185e$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof (menu === null || menu === void 0 ? void 0 : menu.expandIcon) === 'function' || $71b3a752914d185e$var$isEmptyIcon(menu === null || menu === void 0 ? void 0 : menu.expandIcon)) return (menu === null || menu === void 0 ? void 0 : menu.expandIcon) || null;
        const mergedIcon = (_a = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon) !== null && _a !== void 0 ? _a : menu === null || menu === void 0 ? void 0 : menu.expandIcon;
        return (0, $iOHOh.cloneElement)(mergedIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $aqdBs.isValidElement(mergedIcon) ? (_b = mergedIcon.props) === null || _b === void 0 ? void 0 : _b.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon,
        menu === null || menu === void 0 ? void 0 : menu.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $aqdBs.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme
    ]);
    // ========================= Render ==========================
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $kkbgX.default).Provider, {
        value: null
    }, /*#__PURE__*/ $aqdBs.createElement((0, $1vFUO.default).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $aqdBs.createElement((0, $1FrlO.default), Object.assign({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $aqdBs.createElement((0, $7uUoR.default), null),
        overflowedIndicatorPopupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style),
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls),
        _internalComponents: $71b3a752914d185e$var$MENU_COMPONENTS
    })))));
});
var $71b3a752914d185e$export$2e2bcd8739ae039 = $71b3a752914d185e$var$InternalMenu;

});
parcelRegister("1vFUO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1199332f4e990e71$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");
"use client";
const $1199332f4e990e71$var$MenuContext = /*#__PURE__*/ (0, $aqdBs.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false
});
var $1199332f4e990e71$export$2e2bcd8739ae039 = $1199332f4e990e71$var$MenuContext;

});

parcelRegister("eE4hS", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa98208261c45026$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("1FrlO");
var $aqdcb = parcelRequire("aqdcb");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
"use client";
var $aa98208261c45026$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $aa98208261c45026$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed } = props, restProps = $aa98208261c45026$var$__rest(props, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $aqdBs.createElement((0, $aqdcb.default), Object.assign({
        className: classString
    }, restProps));
};
var $aa98208261c45026$export$2e2bcd8739ae039 = $aa98208261c45026$var$MenuDivider;

});

parcelRegister("6LyRL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed22d91e189cee5$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("1FrlO");
var $8azox = parcelRequire("8azox");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $1iwLi = parcelRequire("1iwLi");

var $iOHOh = parcelRequire("iOHOh");

var $2Kije = parcelRequire("2Kije");

var $LGNg6 = parcelRequire("LGNg6");

var $1vFUO = parcelRequire("1vFUO");
"use client";
const $4ed22d91e189cee5$var$MenuItem = (props)=>{
    var _a;
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed } = $aqdBs.useContext((0, $1vFUO.default));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children === null || children === void 0 ? void 0 : children[0];
        const wrapNode = /*#__PURE__*/ $aqdBs.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-title-content`, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            })
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $aqdBs.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ $aqdBs.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $aqdBs.useContext((0, $2Kije.SiderContext));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $bZ6Ai.default)(children).length;
    let returnNode = /*#__PURE__*/ $aqdBs.createElement((0, $8azox.default), Object.assign({}, (0, $1iwLi.default)(props, [
        'title',
        'icon',
        'danger'
    ]), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))({
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        title: typeof title === 'string' ? title : undefined
    }), (0, $iOHOh.cloneElement)(icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(/*#__PURE__*/ $aqdBs.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
    }), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $aqdBs.createElement((0, $LGNg6.default), Object.assign({}, tooltipProps, {
        placement: direction === 'rtl' ? 'left' : 'right',
        classNames: {
            root: `${prefixCls}-inline-collapsed-tooltip`
        }
    }), returnNode);
    return returnNode;
};
var $4ed22d91e189cee5$export$2e2bcd8739ae039 = $4ed22d91e189cee5$var$MenuItem;

});

parcelRegister("kkbgX", function(module, exports) {

$parcel$export(module.exports, "OverrideProvider", () => $ecbe6b62c3ed91a6$export$9bd434816b0530d0);
$parcel$export(module.exports, "default", () => $ecbe6b62c3ed91a6$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $kBwE8 = parcelRequire("kBwE8");

var $cQKK1 = parcelRequire("cQKK1");
"use client";
var $ecbe6b62c3ed91a6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ecbe6b62c3ed91a6$var$OverrideContext = /*#__PURE__*/ $aqdBs.createContext(null);
const $ecbe6b62c3ed91a6$export$9bd434816b0530d0 = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { children: children } = props, restProps = $ecbe6b62c3ed91a6$var$__rest(props, [
        "children"
    ]);
    const override = $aqdBs.useContext($ecbe6b62c3ed91a6$var$OverrideContext);
    const context = $aqdBs.useMemo(()=>Object.assign(Object.assign({}, override), restProps), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $kBwE8.supportNodeRef)(children);
    const mergedRef = (0, $kBwE8.useComposeRef)(ref, canRef ? (0, $kBwE8.getNodeRef)(children) : null);
    return /*#__PURE__*/ $aqdBs.createElement($ecbe6b62c3ed91a6$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $aqdBs.createElement((0, $cQKK1.default), {
        space: true
    }, canRef ? /*#__PURE__*/ $aqdBs.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $ecbe6b62c3ed91a6$export$2e2bcd8739ae039 = $ecbe6b62c3ed91a6$var$OverrideContext;

});

parcelRegister("56hza", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6b2397ccae897f$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");

var $5kUb2 = parcelRequire("5kUb2");

var $ZA9h0 = parcelRequire("ZA9h0");
var $8ccL3 = parcelRequire("8ccL3");
var $d9Xyr = parcelRequire("d9Xyr");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $8kSOt = parcelRequire("8kSOt");

var $ieSVG = parcelRequire("ieSVG");

var $8S1DE = parcelRequire("8S1DE");

var $37NzT = parcelRequire("37NzT");
const $3b6b2397ccae897f$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: Object.assign({}, (0, $5kUb2.resetIcon)()),
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const $3b6b2397ccae897f$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius: borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, $aWTY1.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, $aWTY1.unit)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $3b6b2397ccae897f$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.clearFix)()), {
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                })
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), (0, $5kUb2.clearFix)()), {
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $aWTY1.unit)(paddingXS)} ${(0, $aWTY1.unit)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                }
            }), $3b6b2397ccae897f$var$genMenuItemStyle(token)), {
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $aWTY1.unit)(token.calc(fontSize).mul(2).equal())} ${(0, $aWTY1.unit)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: Object.assign(Object.assign(Object.assign({
                            borderRadius: borderRadiusLG
                        }, $3b6b2397ccae897f$var$genMenuItemStyle(token)), $3b6b2397ccae897f$var$genSubMenuArrowStyle(token)), {
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        })
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: '100% 0'
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: '100% 100%'
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: '0 100%'
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: '0 0'
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                }
            }), $3b6b2397ccae897f$var$genSubMenuArrowStyle(token)), {
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, $aWTY1.unit)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, $aWTY1.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $aWTY1.unit)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, $aWTY1.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, $aWTY1.unit)(menuArrowOffset)})`
                    }
                }
            })
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const $3b6b2397ccae897f$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c;
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = (_a = token.activeBarWidth) !== null && _a !== void 0 ? _a : 0;
    const activeBarBorderWidth = (_b = token.activeBarBorderWidth) !== null && _b !== void 0 ? _b : lineWidth;
    const itemMarginInline = (_c = token.itemMarginInline) !== null && _c !== void 0 ? _c : token.marginXXS;
    const colorTextDark = new (0, $bkcIW.FastColor)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $bkcIW.FastColor)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$3b6b2397ccae897f$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $4wPvn.genStyleHooks)('Menu', (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $8Olk9.merge)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $8Olk9.merge)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $3b6b2397ccae897f$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $8kSOt.default)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $37NzT.default)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $8S1DE.default)(menuToken, 'light'),
            (0, $8S1DE.default)(menuDarkToken, 'dark'),
            // RTL
            (0, $ieSVG.default)(menuToken),
            // Motion
            (0, $ZA9h0.default)(menuToken),
            (0, $8ccL3.initSlideMotion)(menuToken, 'slide-up'),
            (0, $8ccL3.initSlideMotion)(menuToken, 'slide-down'),
            (0, $d9Xyr.initZoomMotion)(menuToken, 'zoom-big')
        ];
    }, $3b6b2397ccae897f$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};

});
parcelRegister("8kSOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $611ab5b992e7c18c$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
const $611ab5b992e7c18c$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $aWTY1.unit)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
var $611ab5b992e7c18c$export$2e2bcd8739ae039 = $611ab5b992e7c18c$var$getHorizontalStyle;

});

parcelRegister("ieSVG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47424a4762f6062$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");
const $d47424a4762f6062$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, $aWTY1.unit)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, $aWTY1.unit)(menuArrowOffset)})`
                }
            }
        }
    });
var $d47424a4762f6062$export$2e2bcd8739ae039 = $d47424a4762f6062$var$getRTLStyle;

});

parcelRegister("8S1DE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6754a3449a92b814$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");
const $6754a3449a92b814$var$accessibilityFocus = (token)=>Object.assign({}, (0, $5kUb2.genFocusOutline)(token));
const $6754a3449a92b814$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: Object.assign({}, $6754a3449a92b814$var$accessibilityFocus(token)),
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: Object.assign({}, $6754a3449a92b814$var$accessibilityFocus(token))
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: Object.assign(Object.assign({}, themeSuffix === 'dark' ? {
                borderBottom: 0
            } : {}), {
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $aWTY1.unit)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            }),
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $aWTY1.unit)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $aWTY1.unit)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(',')
                    }
                }
            }
        }
    };
};
var $6754a3449a92b814$export$2e2bcd8739ae039 = $6754a3449a92b814$var$getThemeStyle;

});

parcelRegister("37NzT", function(module, exports) {

$parcel$export(module.exports, "default", () => $24687bb4413bfc45$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");
const $24687bb4413bfc45$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $aWTY1.unit)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $aWTY1.unit)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $24687bb4413bfc45$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $aWTY1.unit)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': Object.assign({
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    }
                }, $24687bb4413bfc45$var$getVerticalInlineStyle(token))
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: Object.assign(Object.assign({}, $24687bb4413bfc45$var$getVerticalInlineStyle(token)), {
                    boxShadow: boxShadowSecondary
                })
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $aWTY1.unit)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $aWTY1.unit)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $aWTY1.unit)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $aWTY1.unit)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: Object.assign(Object.assign({}, (0, $5kUb2.textEllipsis)), {
                    paddingInline: paddingXS
                })
            }
        }
    ];
};
var $24687bb4413bfc45$export$2e2bcd8739ae039 = $24687bb4413bfc45$var$getVerticalStyle;

});


parcelRegister("byoLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $869615f11039a908$export$2e2bcd8739ae039);

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");
parcelRequire("1FrlO");
var $aXEQC = parcelRequire("aXEQC");
var $irLxp = parcelRequire("irLxp");

var $1iwLi = parcelRequire("1iwLi");

var $jHeh6 = parcelRequire("jHeh6");

var $iOHOh = parcelRequire("iOHOh");

var $1vFUO = parcelRequire("1vFUO");
"use client";
const $869615f11039a908$var$SubMenu = (props)=>{
    var _a;
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $aqdBs.useContext((0, $1vFUO.default));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme } = context;
    const parentPath = (0, $irLxp.useFullPath)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ $aqdBs.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $aqdBs.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $aqdBs.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, (0, $iOHOh.cloneElement)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(/*#__PURE__*/ $aqdBs.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
        }), titleIsSpan ? title : /*#__PURE__*/ $aqdBs.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $aqdBs.useMemo(()=>Object.assign(Object.assign({}, context), {
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $jHeh6.useZIndex)('Menu');
    return /*#__PURE__*/ $aqdBs.createElement((0, $1vFUO.default).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $aqdBs.createElement((0, $aXEQC.default), Object.assign({}, (0, $1iwLi.default)(props, [
        'icon'
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, popupClassName, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: Object.assign({
            zIndex: zIndex
        }, props.popupStyle)
    })));
};
var $869615f11039a908$export$2e2bcd8739ae039 = $869615f11039a908$var$SubMenu;

});



parcelRegister("cbZ8R", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e05f0a1c2f21338$export$2e2bcd8739ae039);
parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $fn8IA = parcelRequire("fn8IA");
var $8ccL3 = parcelRequire("8ccL3");
var $d9Xyr = parcelRequire("d9Xyr");

var $kpffc = parcelRequire("kpffc");

var $l2rZk = parcelRequire("l2rZk");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");

var $1mopD = parcelRequire("1mopD");
// =============================== Base ===============================
const $8e05f0a1c2f21338$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $8ccL3.slideUpIn)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $8ccL3.slideDownIn)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $8ccL3.slideUpOut)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $8ccL3.slideDownOut)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $kpffc.default)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
                [menuCls]: Object.assign(Object.assign({
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary
                }, (0, $5kUb2.genFocusStyle)(token)), {
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $aWTY1.unit)(paddingBlock)} ${(0, $aWTY1.unit)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: Object.assign(Object.assign({
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, $aWTY1.unit)(paddingBlock)} ${(0, $aWTY1.unit)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        }
                    }, (0, $5kUb2.genFocusStyle)(token)), {
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, $aWTY1.unit)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    }),
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $aWTY1.unit)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                })
            })
        },
        // Follow code may reuse in other components
        [
            (0, $8ccL3.initSlideMotion)(token, 'slide-up'),
            (0, $8ccL3.initSlideMotion)(token, 'slide-down'),
            (0, $fn8IA.initMoveMotion)(token, 'move-up'),
            (0, $fn8IA.initMoveMotion)(token, 'move-down'),
            (0, $d9Xyr.initZoomMotion)(token, 'zoom-big')
        ]
    ];
};
const $8e05f0a1c2f21338$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2
    }, (0, $kpffc.getArrowOffsetToken)({
        contentRadius: token.borderRadiusLG,
        limitVerticalRadius: true
    })), (0, $l2rZk.getArrowToken)(token));
var $8e05f0a1c2f21338$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Dropdown', (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $8Olk9.merge)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $8e05f0a1c2f21338$var$genBaseStyle(dropdownToken),
        (0, $1mopD.default)(dropdownToken)
    ];
}, $8e05f0a1c2f21338$export$9ca1be8807fe0675, {
    resetStyle: false
});

});
parcelRegister("fn8IA", function(module, exports) {

$parcel$export(module.exports, "initMoveMotion", () => $b30fc4398a341f8b$export$913b1b7e3288c319);
parcelRequire("g14b3");
var $Zo2YC = parcelRequire("Zo2YC");

var $9V6Az = parcelRequire("9V6Az");
const $b30fc4398a341f8b$export$c81b62e088da1305 = new (0, $Zo2YC.default)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $b30fc4398a341f8b$export$6c1eca72ac4f6672 = new (0, $Zo2YC.default)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $b30fc4398a341f8b$export$8dd54688d033571 = new (0, $Zo2YC.default)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $b30fc4398a341f8b$export$be161c4e647bea9b = new (0, $Zo2YC.default)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $b30fc4398a341f8b$export$a984c43131c7d145 = new (0, $Zo2YC.default)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $b30fc4398a341f8b$export$e141ac6798b476df = new (0, $Zo2YC.default)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $b30fc4398a341f8b$export$ab676201eaaca05 = new (0, $Zo2YC.default)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const $b30fc4398a341f8b$export$ec1b91b8ec2f6331 = new (0, $Zo2YC.default)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const $b30fc4398a341f8b$var$moveMotion = {
    'move-up': {
        inKeyframes: $b30fc4398a341f8b$export$ab676201eaaca05,
        outKeyframes: $b30fc4398a341f8b$export$ec1b91b8ec2f6331
    },
    'move-down': {
        inKeyframes: $b30fc4398a341f8b$export$c81b62e088da1305,
        outKeyframes: $b30fc4398a341f8b$export$6c1eca72ac4f6672
    },
    'move-left': {
        inKeyframes: $b30fc4398a341f8b$export$8dd54688d033571,
        outKeyframes: $b30fc4398a341f8b$export$be161c4e647bea9b
    },
    'move-right': {
        inKeyframes: $b30fc4398a341f8b$export$a984c43131c7d145,
        outKeyframes: $b30fc4398a341f8b$export$e141ac6798b476df
    }
};
const $b30fc4398a341f8b$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $b30fc4398a341f8b$var$moveMotion[motionName];
    return [
        (0, $9V6Az.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};

});

parcelRegister("1mopD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fdac84f97a5259c$export$2e2bcd8739ae039);
const $0fdac84f97a5259c$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $0fdac84f97a5259c$export$2e2bcd8739ae039 = $0fdac84f97a5259c$var$genStatusStyle;

});



parcelRegister("bi4ZQ", function(module, exports) {
module.exports = Promise.all([
    import("kiX7z"),
    import("bNCY4"),
    import("1cyBw"),
    import("97qiv"),
    import("Litpo"),
    import("ftVGF")
]).then(()=>parcelRequire('d7UxB'));

});

parcelRegister("a0I4U", function(module, exports) {
module.exports = Promise.all([
    import("1cyBw"),
    import("g8I1x")
]).then(()=>parcelRequire('evUGJ'));

});

parcelRegister("lvEPJ", function(module, exports) {
module.exports = Promise.all([
    import("1qhCm"),
    import("76K7h"),
    import("1cyBw"),
    import("97qiv"),
    import("iG9qQ")
]).then(()=>parcelRequire('hkIWJ'));

});

parcelRegister("4yOAB", function(module, exports) {
module.exports = Promise.all([
    import("1qhCm"),
    import("76K7h"),
    import("1cyBw"),
    import("97qiv"),
    import("dLkev")
]).then(()=>parcelRequire('fZ7PI'));

});

parcelRegister("dy9LN", function(module, exports) {
module.exports = Promise.all([
    import("23Oo9"),
    import("1qhCm"),
    import("kiX7z"),
    import("1cyBw"),
    import("2iQMA")
]).then(()=>parcelRequire('9VL5o'));

});

parcelRegister("cK2Pb", function(module, exports) {
module.exports = Promise.all([
    import("7iXs3"),
    import("23Oo9"),
    import("1qhCm"),
    import("1cyBw"),
    import("97qiv"),
    import("Litpo"),
    import("ldKv3")
]).then(()=>parcelRequire('bAE7s'));

});

parcelRegister("1M7IH", function(module, exports) {
module.exports = Promise.all([
    import("7iXs3"),
    import("23Oo9"),
    import("1qhCm"),
    import("1cyBw"),
    import("97qiv"),
    import("Litpo"),
    import("f5IsU")
]).then(()=>parcelRequire('gJs7p'));

});


var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");
var $c920eedc27eaef64$export$882461b6382ed46c;
var $c920eedc27eaef64$export$757ceba2d55c277e;
'use strict';

var $jVlfX = parcelRequire("jVlfX");
var $c920eedc27eaef64$var$i;
$c920eedc27eaef64$export$882461b6382ed46c = $jVlfX.createRoot;
$c920eedc27eaef64$export$757ceba2d55c277e = $jVlfX.hydrateRoot;



var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");

var $28b3p = parcelRequire("28b3p");
var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");
// This icon file is generated automatically.
var $882332178f34f1b0$var$DatabaseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0zm0 272a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "database",
    "theme": "outlined"
};
var $882332178f34f1b0$export$2e2bcd8739ae039 = $882332178f34f1b0$var$DatabaseOutlined;



var $gL7Ec = parcelRequire("gL7Ec");
var $da86e2de4939fd68$var$DatabaseOutlined = function DatabaseOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $882332178f34f1b0$export$2e2bcd8739ae039)
    }));
};
/**![database](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWOTZjMC0xNy43LTE0LjMtMzItMzItMzJ6bS02MDAgNzJoNTYwdjIwOEgyMzJWMTM2em01NjAgNDgwSDIzMlY0MDhoNTYwdjIwOHptMCAyNzJIMjMyVjY4MGg1NjB2MjA4ek0zMDQgMjQwYTQwIDQwIDAgMTA4MCAwIDQwIDQwIDAgMTAtODAgMHptMCAyNzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAwem0wIDI3MmE0MCA0MCAwIDEwODAgMCA0MCA0MCAwIDEwLTgwIDB6IiAvPjwvc3ZnPg==) */ var $da86e2de4939fd68$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($da86e2de4939fd68$var$DatabaseOutlined);
var $da86e2de4939fd68$export$2e2bcd8739ae039 = $da86e2de4939fd68$var$RefIcon;


var $gtz9i = parcelRequire("gtz9i");
var $5BZxE = parcelRequire("5BZxE");
var $71P5e = parcelRequire("71P5e");
var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");
// This icon file is generated automatically.
var $5ab8a8a78e584740$var$ScheduleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    },
    "name": "schedule",
    "theme": "outlined"
};
var $5ab8a8a78e584740$export$2e2bcd8739ae039 = $5ab8a8a78e584740$var$ScheduleOutlined;



var $gL7Ec = parcelRequire("gL7Ec");
var $2d99f5b60b33edee$var$ScheduleOutlined = function ScheduleOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $5ab8a8a78e584740$export$2e2bcd8739ae039)
    }));
};
/**![schedule](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAyMjRINzY4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZINTQ4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZIMzI4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU3NmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMjU2YzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNTY4SDEzNlYyOTZoMTIwdjU2YzAgNC40IDMuNiA4IDggOGg1NmM0LjQgMCA4LTMuNiA4LTh2LTU2aDE0OHY1NmMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di01NmgxNDh2NTZjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNTZoMTIwdjQ5NnpNNDE2IDQ5NkgyMzJjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0wIDEzNkgyMzJjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0zMDguMi0xNzcuNEw2MjAuNiA1OTguM2wtNTIuOC03My4xYy0zLTQuMi03LjgtNi42LTEyLjktNi42SDUwMGMtNi41IDAtMTAuMyA3LjQtNi41IDEyLjdsMTE0LjEgMTU4LjJhMTUuOSAxNS45IDAgMDAyNS44IDBsMTY1LTIyOC43YzMuOC01LjMgMC0xMi43LTYuNS0xMi43SDczN2MtNS0uMS05LjggMi40LTEyLjggNi41eiIgLz48L3N2Zz4=) */ var $2d99f5b60b33edee$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($2d99f5b60b33edee$var$ScheduleOutlined);
var $2d99f5b60b33edee$export$2e2bcd8739ae039 = $2d99f5b60b33edee$var$RefIcon;


var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");
// This icon file is generated automatically.
var $9094fabec1cf2980$var$SettingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "setting",
    "theme": "outlined"
};
var $9094fabec1cf2980$export$2e2bcd8739ae039 = $9094fabec1cf2980$var$SettingOutlined;



var $gL7Ec = parcelRequire("gL7Ec");
var $5506d63922cc2448$var$SettingOutlined = function SettingOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $9094fabec1cf2980$export$2e2bcd8739ae039)
    }));
};
/**![setting](data:image/svg+xml;base64,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) */ var $5506d63922cc2448$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($5506d63922cc2448$var$SettingOutlined);
var $5506d63922cc2448$export$2e2bcd8739ae039 = $5506d63922cc2448$var$RefIcon;



var $ffbQF = parcelRequire("ffbQF");
var $k643f = parcelRequire("k643f");
var $dMbbs = parcelRequire("dMbbs");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $1iwLi = parcelRequire("1iwLi");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $kjlvF = parcelRequire("kjlvF");

var $hMq36 = parcelRequire("hMq36");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $2Kije = parcelRequire("2Kije");
function $46ff63c58a4e976c$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === 'boolean') return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $bZ6Ai.default)(children);
    return childNodes.some((node)=>node.type === (0, $2Kije.default));
}



var $lnWpy = parcelRequire("lnWpy");
"use client";
var $3b4f0ff22c7a8add$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $3b4f0ff22c7a8add$var$generator({ suffixCls: suffixCls, tagName: tagName, displayName: displayName }) {
    return (BasicComponent)=>{
        const Adapter = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>/*#__PURE__*/ $aqdBs.createElement(BasicComponent, Object.assign({
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName
            }, props)));
        return Adapter;
    };
}
const $3b4f0ff22c7a8add$var$Basic = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName } = props, others = $3b4f0ff22c7a8add$var$__rest(props, [
        "prefixCls",
        "suffixCls",
        "className",
        "tagName"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const [wrapSSR, hashId, cssVarCls] = (0, $lnWpy.default)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return wrapSSR(/*#__PURE__*/ $aqdBs.createElement(TagName, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(customizePrefixCls || prefixWithSuffixCls, className, hashId, cssVarCls),
        ref: ref
    }, others)));
});
const $3b4f0ff22c7a8add$var$BasicLayout = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
    const { direction: direction } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const [siders, setSiders] = $aqdBs.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style } = props, others = $3b4f0ff22c7a8add$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "hasSider",
        "tagName",
        "style"
    ]);
    const passedProps = (0, $1iwLi.default)(others, [
        'suffixCls'
    ]);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $kjlvF.useComponentConfig)('layout');
    const prefixCls = getPrefixCls('layout', customizePrefixCls);
    const mergedHasSider = (0, $46ff63c58a4e976c$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $lnWpy.default)(prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, contextClassName, className, rootClassName, hashId, cssVarCls);
    const contextValue = $aqdBs.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $dMbbs.default)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement((0, $hMq36.LayoutContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $aqdBs.createElement(Tag, Object.assign({
        ref: ref,
        className: classString,
        style: Object.assign(Object.assign({}, contextStyle), style)
    }, passedProps), children)));
});
const $3b4f0ff22c7a8add$var$Layout = $3b4f0ff22c7a8add$var$generator({
    tagName: 'div',
    displayName: 'Layout'
})($3b4f0ff22c7a8add$var$BasicLayout);
const $3b4f0ff22c7a8add$export$8b251419efc915eb = $3b4f0ff22c7a8add$var$generator({
    suffixCls: 'header',
    tagName: 'header',
    displayName: 'Header'
})($3b4f0ff22c7a8add$var$Basic);
const $3b4f0ff22c7a8add$export$a06f1c675e846f6f = $3b4f0ff22c7a8add$var$generator({
    suffixCls: 'footer',
    tagName: 'footer',
    displayName: 'Footer'
})($3b4f0ff22c7a8add$var$Basic);
const $3b4f0ff22c7a8add$export$7c6e2c02157bb7d2 = $3b4f0ff22c7a8add$var$generator({
    suffixCls: 'content',
    tagName: 'main',
    displayName: 'Content'
})($3b4f0ff22c7a8add$var$Basic);
var $3b4f0ff22c7a8add$export$2e2bcd8739ae039 = $3b4f0ff22c7a8add$var$Layout;



var $2Kije = parcelRequire("2Kije");
"use client";
const $ecb9175edbe34b60$var$Layout = (0, $3b4f0ff22c7a8add$export$2e2bcd8739ae039);
$ecb9175edbe34b60$var$Layout.Header = (0, $3b4f0ff22c7a8add$export$8b251419efc915eb);
$ecb9175edbe34b60$var$Layout.Footer = (0, $3b4f0ff22c7a8add$export$a06f1c675e846f6f);
$ecb9175edbe34b60$var$Layout.Content = (0, $3b4f0ff22c7a8add$export$7c6e2c02157bb7d2);
$ecb9175edbe34b60$var$Layout.Sider = (0, $2Kije.default);
$ecb9175edbe34b60$var$Layout._InternalSiderContext = (0, $2Kije.SiderContext);
var $ecb9175edbe34b60$export$2e2bcd8739ae039 = $ecb9175edbe34b60$var$Layout;


var $f6jN2 = parcelRequire("f6jN2");
var $1Estt = parcelRequire("1Estt");parcelRequire("g14b3");
var $4wnj3 = parcelRequire("4wnj3");
var $5tHf5 = parcelRequire("5tHf5");

var $dWyN5 = parcelRequire("dWyN5");

var $l15Kx = parcelRequire("l15Kx");

var $emEBF = parcelRequire("emEBF");
const $541830db057c53b5$var$getDesignToken = (config)=>{
    const theme = (config === null || config === void 0 ? void 0 : config.algorithm) ? (0, $4wnj3.default)(config.algorithm) : (0, $dWyN5.default);
    const mergedToken = Object.assign(Object.assign({}, (0, $l15Kx.default)), config === null || config === void 0 ? void 0 : config.token);
    return (0, $5tHf5.getComputedToken)(mergedToken, {
        override: config === null || config === void 0 ? void 0 : config.token
    }, theme, (0, $emEBF.default));
};
var $541830db057c53b5$export$2e2bcd8739ae039 = $541830db057c53b5$var$getDesignToken;



var $j22ew = parcelRequire("j22ew");
var $jygCN = parcelRequire("jygCN");

var $j3WK9 = parcelRequire("j3WK9");

var $DeCMq = parcelRequire("DeCMq");

var $hNSjw = parcelRequire("hNSjw");
function $97ebb625f9e086ae$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    const compactSizeStep = sizeStep - 2;
    return {
        sizeXXL: sizeUnit * (compactSizeStep + 10),
        sizeXL: sizeUnit * (compactSizeStep + 6),
        sizeLG: sizeUnit * (compactSizeStep + 2),
        sizeMD: sizeUnit * (compactSizeStep + 2),
        sizeMS: sizeUnit * (compactSizeStep + 1),
        size: sizeUnit * compactSizeStep,
        sizeSM: sizeUnit * compactSizeStep,
        sizeXS: sizeUnit * (compactSizeStep - 1),
        sizeXXS: sizeUnit * (compactSizeStep - 1)
    };
}


const $557beeeb7b139bb8$var$derivative = (token, mapToken)=>{
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $j3WK9.default)(token);
    const fontSize = mergedMapToken.fontSizeSM; // Smaller size font-size as base
    const controlHeight = mergedMapToken.controlHeight - 4;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), (0, $97ebb625f9e086ae$export$2e2bcd8739ae039)(mapToken !== null && mapToken !== void 0 ? mapToken : token)), (0, $hNSjw.default)(fontSize)), {
        controlHeight: // controlHeight
        controlHeight
    }), (0, $DeCMq.default)(Object.assign(Object.assign({}, mergedMapToken), {
        controlHeight: controlHeight
    })));
};
var $557beeeb7b139bb8$export$2e2bcd8739ae039 = $557beeeb7b139bb8$var$derivative;


parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");

var $j3WK9 = parcelRequire("j3WK9");

var $l15Kx = parcelRequire("l15Kx");

var $inLzo = parcelRequire("inLzo");
parcelRequire("epPW7");
var $7oyKr = parcelRequire("7oyKr");
parcelRequire("jtvBX");
var $bkcIW = parcelRequire("bkcIW");
const $2490d772a03424d3$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $bkcIW.FastColor)(baseColor).setA(alpha).toRgbString();
const $2490d772a03424d3$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $bkcIW.FastColor)(baseColor);
    return instance.lighten(brightness).toHexString();
};


const $330ac1b477e23927$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $7oyKr.default)(baseColor, {
        theme: 'dark'
    });
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[6],
        6: colors[5],
        7: colors[4],
        8: colors[6],
        9: colors[5],
        10: colors[4]
    };
};
const $330ac1b477e23927$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#000';
    const colorTextBase = textBaseColor || '#fff';
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorTextSecondary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.18),
        colorFillSecondary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.12),
        colorFillTertiary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.08),
        colorFillQuaternary: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBgSolid: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgSolidHover: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidActive: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.9),
        colorBgElevated: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 12),
        colorBgContainer: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 8),
        colorBgLayout: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 26),
        colorBgBlur: (0, $2490d772a03424d3$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBorder: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 26),
        colorBorderSecondary: (0, $2490d772a03424d3$export$7003a8a990e79359)(colorBgBase, 19)
    };
};


const $01660109cebffb38$var$derivative = (token, mapToken)=>{
    const colorPalettes = Object.keys((0, $l15Kx.defaultPresetColors)).map((colorKey)=>{
        const colors = (0, $7oyKr.default)(token[colorKey], {
            theme: 'dark'
        });
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $j3WK9.default)(token);
    const colorMapToken = (0, $inLzo.default)(token, {
        generateColorPalettes: $330ac1b477e23927$export$da275153033f4ec1,
        generateNeutralColorPalettes: $330ac1b477e23927$export$3e0cb0c1d9c1b691
    });
    return Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), colorPalettes), colorMapToken), {
        // Customize selected item background color
        // https://github.com/ant-design/ant-design/issues/30524#issuecomment-871961867
        colorPrimaryBg: colorMapToken.colorPrimaryBorder,
        colorPrimaryBgHover: colorMapToken.colorPrimaryBorderHover
    });
};
var $01660109cebffb38$export$2e2bcd8739ae039 = $01660109cebffb38$var$derivative;



var $j3WK9 = parcelRequire("j3WK9");
"use client";
// ZombieJ: We export as object to user but array in internal.
// This is used to minimize the bundle size for antd package but safe to refactor as object also.
// Please do not export internal `useToken` directly to avoid something export unexpected.
/** Get current context Design Token. Will be different if you are using nest theme config. */ function $ec325b47db174b3f$var$useToken() {
    const [theme, token, hashId] = (0, $jygCN.default)();
    return {
        theme: theme,
        token: token,
        hashId: hashId
    };
}
var $ec325b47db174b3f$export$2e2bcd8739ae039 = {
    /** Default seedToken */ defaultSeed: (0, $j22ew.defaultConfig).token,
    useToken: $ec325b47db174b3f$var$useToken,
    defaultAlgorithm: $j3WK9.default,
    darkAlgorithm: $01660109cebffb38$export$2e2bcd8739ae039,
    compactAlgorithm: $557beeeb7b139bb8$export$2e2bcd8739ae039,
    getDesignToken: $541830db057c53b5$export$2e2bcd8739ae039,
    defaultConfig: /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */ $j22ew.defaultConfig,
    /**
   * @private Private variable
   * @warring 🔥 Do not use in production. 🔥
   */ _internalContext: (0, $j22ew.DesignTokenContext)
};



var $3JMMO = parcelRequire("3JMMO");

var $dkYnv = parcelRequire("dkYnv");

var $3xSyo = parcelRequire("3xSyo");

var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");

var $c9ked = parcelRequire("c9ked");

var $9oUau = parcelRequire("9oUau");

var $81vtw = parcelRequire("81vtw");

var $aDcZc = parcelRequire("aDcZc");
const $6ac41049c7ab9f96$export$67549794012d4f27 = ()=>{
    const [activeOperations, setActiveOperations] = (0, $aqdBs.useState)([]);
    const setRefresh = (0, $aqdBs.useState)(0)[1];
    (0, $aqdBs.useEffect)(()=>{
        const callback = (event, err)=>{
            if (!event || !event.event) return;
            switch(event.event.case){
                case "createdOperations":
                case "updatedOperations":
                    const ops = event.event.value.operations;
                    setActiveOperations((oldOps)=>{
                        oldOps = oldOps.filter((op)=>!ops.find((newOp)=>newOp.id === op.id));
                        const newOps = ops.filter((newOp)=>newOp.status === (0, $81vtw.OperationStatus).STATUS_INPROGRESS);
                        return [
                            ...oldOps,
                            ...newOps
                        ];
                    });
                    break;
                case "deletedOperations":
                    const opIDs = event.event.value.values;
                    setActiveOperations((ops)=>ops.filter((op)=>!opIDs.includes(op.id)));
                    break;
            }
        };
        (0, $c9ked.subscribeToOperations)(callback);
        setInterval(()=>{
            setRefresh((r)=>r + 1);
        }, 500);
        return ()=>{
            (0, $c9ked.unsubscribeFromOperations)(callback);
        };
    }, []);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)("span", {
        style: {
            color: "white"
        },
        children: activeOperations.map((op, idx)=>{
            const displayName = (0, $aDcZc.displayTypeToString)((0, $aDcZc.getTypeForDisplay)(op));
            return /*#__PURE__*/ (0, $1Ivrw.jsxs)("span", {
                style: {
                    marginRight: "2em"
                },
                children: [
                    displayName,
                    " in progress for plan ",
                    op.planId,
                    " to ",
                    op.repoId,
                    " for",
                    " ",
                    (0, $9oUau.formatDuration)(Date.now() - Number(op.unixTimeStartMs))
                ]
            }, idx);
        })
    });
};



var $81vtw = parcelRequire("81vtw");

var $c9ked = parcelRequire("c9ked");
var $34c8abdd10f319ed$exports = {};
$34c8abdd10f319ed$exports = import.meta.resolve("9Zsv5");



var $aMH3h = parcelRequire("aMH3h");

var $lBjkW = parcelRequire("lBjkW");

var $1Ivrw = parcelRequire("1Ivrw");

var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");
// This icon file is generated automatically.
var $f8df41bb2af73555$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
var $f8df41bb2af73555$export$2e2bcd8739ae039 = $f8df41bb2af73555$var$LockOutlined;



var $gL7Ec = parcelRequire("gL7Ec");
var $d06a35a3d52d43bc$var$LockOutlined = function LockOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $f8df41bb2af73555$export$2e2bcd8739ae039)
    }));
};
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ var $d06a35a3d52d43bc$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($d06a35a3d52d43bc$var$LockOutlined);
var $d06a35a3d52d43bc$export$2e2bcd8739ae039 = $d06a35a3d52d43bc$var$RefIcon;


var $13KW1 = parcelRequire("13KW1");

var $aqdBs = parcelRequire("aqdBs");
// This icon file is generated automatically.
var $f031dcd86dab2817$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
var $f031dcd86dab2817$export$2e2bcd8739ae039 = $f031dcd86dab2817$var$UserOutlined;



var $gL7Ec = parcelRequire("gL7Ec");
var $af038261afdd4682$var$UserOutlined = function UserOutlined(props, ref) {
    return /*#__PURE__*/ $aqdBs.createElement((0, $gL7Ec.default), (0, $13KW1.default)({}, props, {
        ref: ref,
        icon: (0, $f031dcd86dab2817$export$2e2bcd8739ae039)
    }));
};
/**![user](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC41IDc2My42YTM3NCAzNzQgMCAwMC04MC42LTExOS41IDM3NS42MyAzNzUuNjMgMCAwMC0xMTkuNS04MC42Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjUgNTE4IDc2MCA0NDQuNyA3NjAgMzYyYzAtMTM3LTExMS0yNDgtMjQ4LTI0OFMyNjQgMjI1IDI2NCAzNjJjMCA4Mi43IDQwLjUgMTU2IDEwMi44IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC44IDE4LjktODUgNDYtMTE5LjUgODAuNmEzNzUuNjMgMzc1LjYzIDAgMDAtODAuNiAxMTkuNUEzNzEuNyAzNzEuNyAwIDAwMTM2IDkwMS44YTggOCAwIDAwOCA4LjJoNjBjNC40IDAgNy45LTMuNSA4LTcuOCAyLTc3LjIgMzMtMTQ5LjUgODcuOC0yMDQuMyA1Ni43LTU2LjcgMTMyLTg3LjkgMjEyLjItODcuOXMxNTUuNSAzMS4yIDIxMi4yIDg3LjlDNzc5IDc1Mi43IDgxMCA4MjUgODEyIDkwMi4yYy4xIDQuNCAzLjYgNy44IDggNy44aDYwYTggOCAwIDAwOC04LjJjLTEtNDcuOC0xMC45LTk0LjMtMjkuNS0xMzguMnpNNTEyIDUzNGMtNDUuOSAwLTg5LjEtMTcuOS0xMjEuNi01MC40UzM0MCA0MDcuOSAzNDAgMzYyYzAtNDUuOSAxNy45LTg5LjEgNTAuNC0xMjEuNlM0NjYuMSAxOTAgNTEyIDE5MHM4OS4xIDE3LjkgMTIxLjYgNTAuNFM2ODQgMzE2LjEgNjg0IDM2MmMwIDQ1LjktMTcuOSA4OS4xLTUwLjQgMTIxLjZTNTU3LjkgNTM0IDUxMiA1MzR6IiAvPjwvc3ZnPg==) */ var $af038261afdd4682$var$RefIcon = /*#__PURE__*/ $aqdBs.forwardRef($af038261afdd4682$var$UserOutlined);
var $af038261afdd4682$export$2e2bcd8739ae039 = $af038261afdd4682$var$RefIcon;



var $ffbQF = parcelRequire("ffbQF");
var $4mi0X = parcelRequire("4mi0X");
var $1TmFS = parcelRequire("1TmFS");
var $172oi = parcelRequire("172oi");
var $RqC3z = parcelRequire("RqC3z");
var $fcEEk = parcelRequire("fcEEk");
parcelRequire("aqdBs");

var $1Yxub = parcelRequire("1Yxub");

var $h3scz = parcelRequire("h3scz");

var $3JMMO = parcelRequire("3JMMO");

var $1jDsz = parcelRequire("1jDsz");
const $a311867e06ee0ace$export$b4d7a44be6f5e733 = ()=>{
    let defaultCreds = (0, $1jDsz.create)((0, $h3scz.LoginRequestSchema), {});
    const [form] = (0, $1TmFS.default).useForm();
    const alertApi = (0, $3JMMO.useAlertApi)();
    const onFinish = async (values)=>{
        const loginReq = (0, $1jDsz.create)((0, $h3scz.LoginRequestSchema), {
            username: values.username,
            password: values.password
        });
        try {
            const loginResponse = await (0, $1Yxub.authenticationService).login(loginReq);
            (0, $1Yxub.setAuthToken)(loginResponse.token);
            alertApi.success("Logged in", 5);
            setTimeout(()=>{
                window.location.reload();
            }, 500);
        } catch (e) {
            alertApi.error("Login failed: " + (e.message ? e.message : "" + e), 10);
        }
    };
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $RqC3z.default), {
        open: true,
        width: "40vw",
        title: "Login",
        footer: null,
        closable: false,
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1TmFS.default), {
            form: form,
            name: "horizontal_login",
            layout: "inline",
            onFinish: onFinish,
            style: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $fcEEk.default), {
                justify: "center",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4mi0X.default), {
                        span: 10,
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1TmFS.default).Item, {
                            name: "username",
                            rules: [
                                {
                                    required: true,
                                    message: "Please input your username"
                                }
                            ],
                            style: {
                                width: "100%",
                                paddingRight: "10px"
                            },
                            initialValue: defaultCreds.username,
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $172oi.default), {
                                prefix: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $af038261afdd4682$export$2e2bcd8739ae039), {
                                    className: "site-form-item-icon"
                                }),
                                placeholder: "Username"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4mi0X.default), {
                        span: 10,
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1TmFS.default).Item, {
                            name: "password",
                            rules: [
                                {
                                    required: true,
                                    message: "Please input your password!"
                                }
                            ],
                            style: {
                                width: "100%",
                                paddingRight: "10px"
                            },
                            initialValue: defaultCreds.password,
                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $172oi.default), {
                                prefix: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $d06a35a3d52d43bc$export$2e2bcd8739ae039), {
                                    className: "site-form-item-icon"
                                }),
                                type: "password",
                                placeholder: "Password"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $4mi0X.default), {
                        span: 4,
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ffbQF.default), {
                            type: "primary",
                            htmlType: "submit",
                            style: {
                                width: "100%"
                            },
                            children: "Log in"
                        })
                    })
                ]
            })
        })
    });
};



var $1Yxub = parcelRequire("1Yxub");

var $1VQWV = parcelRequire("1VQWV");
const $11c18db41d7a26e7$export$8eab9ef84668a092 = (config)=>{
    return !config.instance || !config.auth || !config.auth.disabled && config.auth.users.length === 0;
};



var $cT7kT = parcelRequire("cT7kT");

var $aDcZc = parcelRequire("aDcZc");

var $b0VD2 = parcelRequire("b0VD2");

var $ebiy2 = parcelRequire("ebiy2");/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aqdBs = parcelRequire("aqdBs");

var $jVlfX = parcelRequire("jVlfX");

var $9FOsn = parcelRequire("9FOsn");
var $ebiy2 = parcelRequire("ebiy2");

var $9FOsn = parcelRequire("9FOsn");
function $092d4ddd3ad595b9$var$_extends() {
    $092d4ddd3ad595b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $092d4ddd3ad595b9$var$_extends.apply(this, arguments);
}
function $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $092d4ddd3ad595b9$var$defaultMethod = "get";
const $092d4ddd3ad595b9$var$defaultEncType = "application/x-www-form-urlencoded";
function $092d4ddd3ad595b9$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $092d4ddd3ad595b9$var$isButtonElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $092d4ddd3ad595b9$var$isFormElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $092d4ddd3ad595b9$var$isInputElement(object) {
    return $092d4ddd3ad595b9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $092d4ddd3ad595b9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $092d4ddd3ad595b9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$092d4ddd3ad595b9$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $092d4ddd3ad595b9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = null;
function $092d4ddd3ad595b9$var$isFormDataSubmitterSupported() {
    if ($092d4ddd3ad595b9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $092d4ddd3ad595b9$var$_formDataSupportsSubmitter = true;
    }
    return $092d4ddd3ad595b9$var$_formDataSupportsSubmitter;
}
const $092d4ddd3ad595b9$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $092d4ddd3ad595b9$var$getFormEncType(encType) {
    if (encType != null && !$092d4ddd3ad595b9$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $092d4ddd3ad595b9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($092d4ddd3ad595b9$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9FOsn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $092d4ddd3ad595b9$var$defaultMethod;
        encType = $092d4ddd3ad595b9$var$getFormEncType(target.getAttribute("enctype")) || $092d4ddd3ad595b9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($092d4ddd3ad595b9$var$isButtonElement(target) || $092d4ddd3ad595b9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9FOsn.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $092d4ddd3ad595b9$var$defaultMethod;
        encType = $092d4ddd3ad595b9$var$getFormEncType(target.getAttribute("formenctype")) || $092d4ddd3ad595b9$var$getFormEncType(form.getAttribute("enctype")) || $092d4ddd3ad595b9$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$092d4ddd3ad595b9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($092d4ddd3ad595b9$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $092d4ddd3ad595b9$var$defaultMethod;
        action = null;
        encType = $092d4ddd3ad595b9$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $092d4ddd3ad595b9$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $092d4ddd3ad595b9$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $092d4ddd3ad595b9$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $092d4ddd3ad595b9$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $092d4ddd3ad595b9$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $092d4ddd3ad595b9$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $092d4ddd3ad595b9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $092d4ddd3ad595b9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebiy2.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $092d4ddd3ad595b9$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9FOsn.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $092d4ddd3ad595b9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9FOsn.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $092d4ddd3ad595b9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $ebiy2.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $092d4ddd3ad595b9$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $092d4ddd3ad595b9$var$_extends({}, state, {
        errors: $092d4ddd3ad595b9$var$deserializeErrors(state.errors)
    });
    return state;
}
function $092d4ddd3ad595b9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9FOsn.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $092d4ddd3ad595b9$export$7ad602f0e94e62d1 = /*#__PURE__*/ $aqdBs.createContext({
    isTransitioning: false
});
const $092d4ddd3ad595b9$export$148fd98d095596d4 = /*#__PURE__*/ $aqdBs.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $092d4ddd3ad595b9$var$START_TRANSITION = "startTransition";
const $092d4ddd3ad595b9$var$startTransitionImpl = $aqdBs[$092d4ddd3ad595b9$var$START_TRANSITION];
const $092d4ddd3ad595b9$var$FLUSH_SYNC = "flushSync";
const $092d4ddd3ad595b9$var$flushSyncImpl = $jVlfX[$092d4ddd3ad595b9$var$FLUSH_SYNC];
const $092d4ddd3ad595b9$var$USE_ID = "useId";
const $092d4ddd3ad595b9$var$useIdImpl = $aqdBs[$092d4ddd3ad595b9$var$USE_ID];
function $092d4ddd3ad595b9$var$startTransitionSafe(cb) {
    if ($092d4ddd3ad595b9$var$startTransitionImpl) $092d4ddd3ad595b9$var$startTransitionImpl(cb);
    else cb();
}
function $092d4ddd3ad595b9$var$flushSyncSafe(cb) {
    if ($092d4ddd3ad595b9$var$flushSyncImpl) $092d4ddd3ad595b9$var$flushSyncImpl(cb);
    else cb();
}
class $092d4ddd3ad595b9$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $092d4ddd3ad595b9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aqdBs.useState(router.state);
    let [pendingState, setPendingState] = $aqdBs.useState();
    let [vtContext, setVtContext] = $aqdBs.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aqdBs.useState();
    let [transition, setTransition] = $aqdBs.useState();
    let [interruption, setInterruption] = $aqdBs.useState();
    let fetcherData = $aqdBs.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $aqdBs.useCallback((cb)=>{
        if (v7_startTransition) $092d4ddd3ad595b9$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $aqdBs.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $092d4ddd3ad595b9$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $092d4ddd3ad595b9$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $092d4ddd3ad595b9$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $092d4ddd3ad595b9$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $092d4ddd3ad595b9$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aqdBs.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $aqdBs.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $092d4ddd3ad595b9$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $aqdBs.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $aqdBs.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $aqdBs.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aqdBs.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aqdBs.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $aqdBs.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $092d4ddd3ad595b9$var$MemoizedDataRoutes = /*#__PURE__*/ $aqdBs.memo($092d4ddd3ad595b9$var$DataRoutes);
function $092d4ddd3ad595b9$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $ebiy2.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $092d4ddd3ad595b9$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $092d4ddd3ad595b9$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $aqdBs.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9FOsn.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $092d4ddd3ad595b9$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $aqdBs.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aqdBs.useCallback((newState)=>{
        v7_startTransition && $092d4ddd3ad595b9$var$startTransitionImpl ? $092d4ddd3ad595b9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aqdBs.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $aqdBs.useEffect(()=>(0, $ebiy2.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $aqdBs.createElement((0, $ebiy2.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $092d4ddd3ad595b9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $092d4ddd3ad595b9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $092d4ddd3ad595b9$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aqdBs.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref7, $092d4ddd3ad595b9$var$_excluded);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $092d4ddd3ad595b9$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($092d4ddd3ad595b9$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9FOsn.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $ebiy2.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $092d4ddd3ad595b9$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aqdBs.createElement("a", $092d4ddd3ad595b9$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $092d4ddd3ad595b9$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aqdBs.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref8, $092d4ddd3ad595b9$var$_excluded2);
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $ebiy2.useLocation)();
    let routerState = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $092d4ddd3ad595b9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9FOsn.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$a6c7ac8248d6e38a, $092d4ddd3ad595b9$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $092d4ddd3ad595b9$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aqdBs.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $092d4ddd3ad595b9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $092d4ddd3ad595b9$var$_objectWithoutPropertiesLoose(_ref9, $092d4ddd3ad595b9$var$_excluded3);
    let submit = $092d4ddd3ad595b9$export$47c85c6e3a081d3();
    let formAction = $092d4ddd3ad595b9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $aqdBs.createElement("form", $092d4ddd3ad595b9$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $092d4ddd3ad595b9$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $092d4ddd3ad595b9$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $092d4ddd3ad595b9$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($092d4ddd3ad595b9$var$DataRouterHook || ($092d4ddd3ad595b9$var$DataRouterHook = {}));
var $092d4ddd3ad595b9$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($092d4ddd3ad595b9$var$DataRouterStateHook || ($092d4ddd3ad595b9$var$DataRouterStateHook = {}));
// Internal hooks
function $092d4ddd3ad595b9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $092d4ddd3ad595b9$var$useDataRouterContext(hookName) {
    let ctx = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterContext));
    !ctx && (0, $9FOsn.UNSAFE_invariant)(false);
    return ctx;
}
function $092d4ddd3ad595b9$var$useDataRouterState(hookName) {
    let state = $aqdBs.useContext((0, $ebiy2.UNSAFE_DataRouterStateContext));
    !state && (0, $9FOsn.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $092d4ddd3ad595b9$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $ebiy2.useNavigate)();
    let location = (0, $ebiy2.useLocation)();
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: relative
    });
    return $aqdBs.useCallback((event)=>{
        if ($092d4ddd3ad595b9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $9FOsn.createPath)(location) === (0, $9FOsn.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $092d4ddd3ad595b9$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aqdBs.useRef($092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aqdBs.useRef(false);
    let location = (0, $ebiy2.useLocation)();
    let searchParams = $aqdBs.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $092d4ddd3ad595b9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $ebiy2.useNavigate)();
    let setSearchParams = $aqdBs.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $092d4ddd3ad595b9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $092d4ddd3ad595b9$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $092d4ddd3ad595b9$var$fetcherId = 0;
let $092d4ddd3ad595b9$var$getUniqueFetcherId = ()=>"__" + String(++$092d4ddd3ad595b9$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $092d4ddd3ad595b9$export$47c85c6e3a081d3() {
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let currentRouteId = (0, $ebiy2.UNSAFE_useRouteId)();
    return $aqdBs.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $092d4ddd3ad595b9$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $092d4ddd3ad595b9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $092d4ddd3ad595b9$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $092d4ddd3ad595b9$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let routeContext = $aqdBs.useContext((0, $ebiy2.UNSAFE_RouteContext));
    !routeContext && (0, $9FOsn.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $092d4ddd3ad595b9$var$_extends({}, (0, $ebiy2.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $ebiy2.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9FOsn.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $9FOsn.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $092d4ddd3ad595b9$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseFetcher);
    let state = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $aqdBs.useContext($092d4ddd3ad595b9$export$148fd98d095596d4);
    let route = $aqdBs.useContext((0, $ebiy2.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9FOsn.UNSAFE_invariant)(false);
    !route && (0, $9FOsn.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $9FOsn.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $092d4ddd3ad595b9$var$useIdImpl ? $092d4ddd3ad595b9$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $aqdBs.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($092d4ddd3ad595b9$var$getUniqueFetcherId());
    // Registration/cleanup
    $aqdBs.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $aqdBs.useCallback((href, opts)=>{
        !routeId && (0, $9FOsn.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $092d4ddd3ad595b9$export$47c85c6e3a081d3();
    let submit = $aqdBs.useCallback((target, opts)=>{
        submitImpl(target, $092d4ddd3ad595b9$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $aqdBs.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $aqdBs.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $aqdBs.createElement($092d4ddd3ad595b9$export$a7fed597f4b8afd8, $092d4ddd3ad595b9$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9FOsn.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aqdBs.useMemo(()=>$092d4ddd3ad595b9$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $092d4ddd3ad595b9$export$fa996778a3a31087() {
    let state = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $092d4ddd3ad595b9$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $092d4ddd3ad595b9$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $092d4ddd3ad595b9$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $092d4ddd3ad595b9$var$useDataRouterState($092d4ddd3ad595b9$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aqdBs.useContext((0, $ebiy2.UNSAFE_NavigationContext));
    let location = (0, $ebiy2.useLocation)();
    let matches = (0, $ebiy2.useMatches)();
    let navigation = (0, $ebiy2.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $aqdBs.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $092d4ddd3ad595b9$var$usePageHide($aqdBs.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $092d4ddd3ad595b9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($092d4ddd3ad595b9$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $092d4ddd3ad595b9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $092d4ddd3ad595b9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($092d4ddd3ad595b9$var$_extends({}, location, {
                    pathname: (0, $9FOsn.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($092d4ddd3ad595b9$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aqdBs.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $092d4ddd3ad595b9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $092d4ddd3ad595b9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aqdBs.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $092d4ddd3ad595b9$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $ebiy2.useBlocker)(when);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aqdBs.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $092d4ddd3ad595b9$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $aqdBs.useContext($092d4ddd3ad595b9$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9FOsn.UNSAFE_invariant)(false);
    let { basename: basename } = $092d4ddd3ad595b9$var$useDataRouterContext($092d4ddd3ad595b9$var$DataRouterHook.useViewTransitionState);
    let path = (0, $ebiy2.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9FOsn.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9FOsn.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9FOsn.matchPath)(path.pathname, nextPath) != null || (0, $9FOsn.matchPath)(path.pathname, currentPath) != null;
}


var $ebiy2 = parcelRequire("ebiy2");

var $1Ivrw = parcelRequire("1Ivrw");

var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $bZ6Ai = parcelRequire("bZ6Ai");

var $bWa8g = parcelRequire("bWa8g");

var $iOHOh = parcelRequire("iOHOh");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $aqdBs = parcelRequire("aqdBs");

var $aIP8f = parcelRequire("aIP8f");

parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");

var $dU9d6 = parcelRequire("dU9d6");

var $aqdBs = parcelRequire("aqdBs");
parcelRequire("ky6DR");
var $kjlvF = parcelRequire("kjlvF");
"use client";
const $3d2bbff14d89aa40$var$BreadcrumbSeparator = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('breadcrumb');
    return /*#__PURE__*/ $aqdBs.createElement("li", {
        className: `${prefixCls}-separator`,
        "aria-hidden": "true"
    }, children === '' ? children : children || '/');
};
$3d2bbff14d89aa40$var$BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
var $3d2bbff14d89aa40$export$2e2bcd8739ae039 = $3d2bbff14d89aa40$var$BreadcrumbSeparator;



var $aqdBs = parcelRequire("aqdBs");

var $bqPQ9 = parcelRequire("bqPQ9");

var $bWa8g = parcelRequire("bWa8g");
"use client";
var $1bf50b227a5b2f2d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $1bf50b227a5b2f2d$var$getBreadcrumbName(route, params) {
    if (route.title === undefined || route.title === null) return null;
    const paramsKeys = Object.keys(params).join('|');
    return typeof route.title === 'object' ? route.title : String(route.title).replace(new RegExp(`:(${paramsKeys})`, 'g'), (replacement, key)=>params[key] || replacement);
}
function $1bf50b227a5b2f2d$export$7178ad99788f9ddc(prefixCls, item, children, href) {
    if (children === null || children === undefined) return null;
    const { className: className, onClick: onClick } = item, restItem = $1bf50b227a5b2f2d$var$__rest(item, [
        "className",
        "onClick"
    ]);
    const passedProps = Object.assign(Object.assign({}, (0, $bWa8g.default)(restItem, {
        data: true,
        aria: true
    })), {
        onClick: onClick
    });
    if (href !== undefined) return /*#__PURE__*/ $aqdBs.createElement("a", Object.assign({}, passedProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-link`, className),
        href: href
    }), children);
    return /*#__PURE__*/ $aqdBs.createElement("span", Object.assign({}, passedProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(`${prefixCls}-link`, className)
    }), children);
}
function $1bf50b227a5b2f2d$export$2e2bcd8739ae039(prefixCls, itemRender) {
    const mergedItemRender = (item, params, routes, path, href)=>{
        if (itemRender) return itemRender(item, params, routes, path);
        const name = $1bf50b227a5b2f2d$var$getBreadcrumbName(item, params);
        return $1bf50b227a5b2f2d$export$7178ad99788f9ddc(prefixCls, item, name, href);
    };
    return mergedItemRender;
}


"use client";
var $6b2abe3762bf66f2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $6b2abe3762bf66f2$export$ac5486a97fd4c014 = (props)=>{
    const { prefixCls: prefixCls, separator: separator = '/', children: children, menu: menu, overlay: overlay, dropdownProps: dropdownProps, href: href } = props;
    /** If overlay is have Wrap a Dropdown */ const renderBreadcrumbNode = (breadcrumbItem)=>{
        if (menu || overlay) {
            const mergeDropDownProps = Object.assign({}, dropdownProps);
            if (menu) {
                const _a = menu || {}, { items: items } = _a, menuProps = $6b2abe3762bf66f2$var$__rest(_a, [
                    "items"
                ]);
                mergeDropDownProps.menu = Object.assign(Object.assign({}, menuProps), {
                    items: items === null || items === void 0 ? void 0 : items.map((_a, index)=>{
                        var { key: key, title: title, label: label, path: path } = _a, itemProps = $6b2abe3762bf66f2$var$__rest(_a, [
                            "key",
                            "title",
                            "label",
                            "path"
                        ]);
                        let mergedLabel = label !== null && label !== void 0 ? label : title;
                        if (path) mergedLabel = /*#__PURE__*/ $aqdBs.createElement("a", {
                            href: `${href}${path}`
                        }, mergedLabel);
                        return Object.assign(Object.assign({}, itemProps), {
                            key: key !== null && key !== void 0 ? key : index,
                            label: mergedLabel
                        });
                    })
                });
            } else if (overlay) mergeDropDownProps.overlay = overlay;
            return /*#__PURE__*/ $aqdBs.createElement((0, $dU9d6.default), Object.assign({
                placement: "bottom"
            }, mergeDropDownProps), /*#__PURE__*/ $aqdBs.createElement("span", {
                className: `${prefixCls}-overlay-link`
            }, breadcrumbItem, /*#__PURE__*/ $aqdBs.createElement((0, $aIP8f.default), null)));
        }
        return breadcrumbItem;
    };
    // wrap to dropDown
    const link = renderBreadcrumbNode(children);
    if (link !== undefined && link !== null) return /*#__PURE__*/ $aqdBs.createElement($aqdBs.Fragment, null, /*#__PURE__*/ $aqdBs.createElement("li", null, link), separator && /*#__PURE__*/ $aqdBs.createElement((0, $3d2bbff14d89aa40$export$2e2bcd8739ae039), null, separator));
    return null;
};
const $6b2abe3762bf66f2$var$BreadcrumbItem = (props)=>{
    const { prefixCls: customizePrefixCls, children: children, href: href } = props, restProps = $6b2abe3762bf66f2$var$__rest(props, [
        "prefixCls",
        "children",
        "href"
    ]);
    const { getPrefixCls: getPrefixCls } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    return /*#__PURE__*/ $aqdBs.createElement($6b2abe3762bf66f2$export$ac5486a97fd4c014, Object.assign({}, restProps, {
        prefixCls: prefixCls
    }), (0, $1bf50b227a5b2f2d$export$7178ad99788f9ddc)(prefixCls, restProps, children, href));
};
$6b2abe3762bf66f2$var$BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
var $6b2abe3762bf66f2$export$2e2bcd8739ae039 = $6b2abe3762bf66f2$var$BreadcrumbItem;



parcelRequire("g14b3");
var $aWTY1 = parcelRequire("aWTY1");

var $5kUb2 = parcelRequire("5kUb2");

var $4wPvn = parcelRequire("4wPvn");parcelRequire("gS2oY");
var $8Olk9 = parcelRequire("8Olk9");
const $e981d35344f41347$var$genBreadcrumbStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, calc: calc } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $5kUb2.resetComponent)(token)), {
            color: token.itemColor,
            fontSize: token.fontSize,
            [iconCls]: {
                fontSize: token.iconFontSize
            },
            ol: {
                display: 'flex',
                flexWrap: 'wrap',
                margin: 0,
                padding: 0,
                listStyle: 'none'
            },
            a: Object.assign({
                color: token.linkColor,
                transition: `color ${token.motionDurationMid}`,
                padding: `0 ${(0, $aWTY1.unit)(token.paddingXXS)}`,
                borderRadius: token.borderRadiusSM,
                height: token.fontHeight,
                display: 'inline-block',
                marginInline: calc(token.marginXXS).mul(-1).equal(),
                '&:hover': {
                    color: token.linkHoverColor,
                    backgroundColor: token.colorBgTextHover
                }
            }, (0, $5kUb2.genFocusStyle)(token)),
            'li:last-child': {
                color: token.lastItemColor
            },
            [`${componentCls}-separator`]: {
                marginInline: token.separatorMargin,
                color: token.separatorColor
            },
            [`${componentCls}-link`]: {
                [`
          > ${iconCls} + span,
          > ${iconCls} + a
        `]: {
                    marginInlineStart: token.marginXXS
                }
            },
            [`${componentCls}-overlay-link`]: {
                borderRadius: token.borderRadiusSM,
                height: token.fontHeight,
                display: 'inline-block',
                padding: `0 ${(0, $aWTY1.unit)(token.paddingXXS)}`,
                marginInline: calc(token.marginXXS).mul(-1).equal(),
                [`> ${iconCls}`]: {
                    marginInlineStart: token.marginXXS,
                    fontSize: token.fontSizeIcon
                },
                '&:hover': {
                    color: token.linkHoverColor,
                    backgroundColor: token.colorBgTextHover,
                    a: {
                        color: token.linkHoverColor
                    }
                },
                a: {
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            // rtl style
            [`&${token.componentCls}-rtl`]: {
                direction: 'rtl'
            }
        })
    };
};
const $e981d35344f41347$export$9ca1be8807fe0675 = (token)=>({
        itemColor: token.colorTextDescription,
        lastItemColor: token.colorText,
        iconFontSize: token.fontSize,
        linkColor: token.colorTextDescription,
        linkHoverColor: token.colorText,
        separatorColor: token.colorTextDescription,
        separatorMargin: token.marginXS
    });
var // ============================== Export ==============================
$e981d35344f41347$export$2e2bcd8739ae039 = (0, $4wPvn.genStyleHooks)('Breadcrumb', (token)=>{
    const breadcrumbToken = (0, $8Olk9.merge)(token, {});
    return $e981d35344f41347$var$genBreadcrumbStyle(breadcrumbToken);
}, $e981d35344f41347$export$9ca1be8807fe0675);




var $aqdBs = parcelRequire("aqdBs");
var $a53015ccc8a19077$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a53015ccc8a19077$var$route2item(route) {
    const { breadcrumbName: breadcrumbName, children: children } = route, rest = $a53015ccc8a19077$var$__rest(route, [
        "breadcrumbName",
        "children"
    ]);
    const clone = Object.assign({
        title: breadcrumbName
    }, rest);
    if (children) clone.menu = {
        items: children.map((_a)=>{
            var { breadcrumbName: itemBreadcrumbName } = _a, itemProps = $a53015ccc8a19077$var$__rest(_a, [
                "breadcrumbName"
            ]);
            return Object.assign(Object.assign({}, itemProps), {
                title: itemBreadcrumbName
            });
        })
    };
    return clone;
}
function $a53015ccc8a19077$export$2e2bcd8739ae039(items, routes) {
    return (0, $aqdBs.useMemo)(()=>{
        if (items) return items;
        if (routes) return routes.map($a53015ccc8a19077$var$route2item);
        return null;
    }, [
        items,
        routes
    ]);
}


"use client";
var $d53a0167f9f51f6f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d53a0167f9f51f6f$var$getPath = (params, path)=>{
    if (path === undefined) return path;
    let mergedPath = (path || '').replace(/^\//, '');
    Object.keys(params).forEach((key)=>{
        mergedPath = mergedPath.replace(`:${key}`, params[key]);
    });
    return mergedPath;
};
const $d53a0167f9f51f6f$var$Breadcrumb = (props)=>{
    const { prefixCls: customizePrefixCls, separator: separator = '/', style: style, className: className, rootClassName: rootClassName, routes: legacyRoutes, items: items, children: children, itemRender: itemRender, params: params = {} } = props, restProps = $d53a0167f9f51f6f$var$__rest(props, [
        "prefixCls",
        "separator",
        "style",
        "className",
        "rootClassName",
        "routes",
        "items",
        "children",
        "itemRender",
        "params"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, breadcrumb: breadcrumb } = $aqdBs.useContext((0, $kjlvF.ConfigContext));
    let crumbs;
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $e981d35344f41347$export$2e2bcd8739ae039)(prefixCls);
    const mergedItems = (0, $a53015ccc8a19077$export$2e2bcd8739ae039)(items, legacyRoutes);
    var element;
    const mergedItemRender = (0, $1bf50b227a5b2f2d$export$2e2bcd8739ae039)(prefixCls, itemRender);
    if (mergedItems && mergedItems.length > 0) {
        // generated by route
        const paths = [];
        const itemRenderRoutes = items || legacyRoutes;
        crumbs = mergedItems.map((item, index)=>{
            const { path: path, key: key, type: type, menu: menu, overlay: overlay, onClick: onClick, className: itemClassName, separator: itemSeparator, dropdownProps: dropdownProps } = item;
            const mergedPath = $d53a0167f9f51f6f$var$getPath(params, path);
            if (mergedPath !== undefined) paths.push(mergedPath);
            const mergedKey = key !== null && key !== void 0 ? key : index;
            if (type === 'separator') return /*#__PURE__*/ $aqdBs.createElement((0, $3d2bbff14d89aa40$export$2e2bcd8739ae039), {
                key: mergedKey
            }, itemSeparator);
            const itemProps = {};
            const isLastItem = index === mergedItems.length - 1;
            if (menu) itemProps.menu = menu;
            else if (overlay) itemProps.overlay = overlay;
            let { href: href } = item;
            if (paths.length && mergedPath !== undefined) href = `#/${paths.join('/')}`;
            return /*#__PURE__*/ $aqdBs.createElement((0, $6b2abe3762bf66f2$export$ac5486a97fd4c014), Object.assign({
                key: mergedKey
            }, itemProps, (0, $bWa8g.default)(item, {
                data: true,
                aria: true
            }), {
                className: itemClassName,
                dropdownProps: dropdownProps,
                href: href,
                separator: isLastItem ? '' : separator,
                onClick: onClick,
                prefixCls: prefixCls
            }), mergedItemRender(item, params, itemRenderRoutes, paths, href));
        });
    } else if (children) {
        const childrenLength = (0, $bZ6Ai.default)(children).length;
        crumbs = (0, $bZ6Ai.default)(children).map((element, index)=>{
            if (!element) return element;
            const isLastItem = index === childrenLength - 1;
            return (0, $iOHOh.cloneElement)(element, {
                separator: isLastItem ? '' : separator,
                // eslint-disable-next-line react/no-array-index-key
                key: index
            });
        });
    }
    const breadcrumbClassName = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(prefixCls, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.className, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.style), style);
    return wrapCSSVar(/*#__PURE__*/ $aqdBs.createElement("nav", Object.assign({
        className: breadcrumbClassName,
        style: mergedStyle
    }, restProps), /*#__PURE__*/ $aqdBs.createElement("ol", null, crumbs)));
};
$d53a0167f9f51f6f$var$Breadcrumb.Item = (0, $6b2abe3762bf66f2$export$2e2bcd8739ae039);
$d53a0167f9f51f6f$var$Breadcrumb.Separator = (0, $3d2bbff14d89aa40$export$2e2bcd8739ae039);
var $d53a0167f9f51f6f$export$2e2bcd8739ae039 = $d53a0167f9f51f6f$var$Breadcrumb;


"use client";
var $471a29646f748bd2$export$2e2bcd8739ae039 = (0, $d53a0167f9f51f6f$export$2e2bcd8739ae039);



parcelRequire("aqdBs");
const $3cfb31961d3bcc4a$export$5d7600abb6392766 = ({ breadcrumbs: breadcrumbs, children: children })=>{
    const { token: { colorBgContainer: colorBgContainer } } = (0, $ec325b47db174b3f$export$2e2bcd8739ae039).useToken();
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $ecb9175edbe34b60$export$2e2bcd8739ae039), {
        style: {
            padding: "0 24px 24px"
        },
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $471a29646f748bd2$export$2e2bcd8739ae039), {
                style: {
                    margin: "16px 0"
                },
                items: breadcrumbs.map((b)=>({
                        title: b.title,
                        onClick: b.onClick
                    }))
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3b4f0ff22c7a8add$export$7c6e2c02157bb7d2), {
                style: {
                    padding: 24,
                    margin: 0,
                    minHeight: 280,
                    background: colorBgContainer
                },
                children: children
            })
        ]
    });
};



var $1jDsz = parcelRequire("1jDsz");
const { Header: $e7e8dd084d943877$var$Header, Sider: $e7e8dd084d943877$var$Sider } = (0, $ecb9175edbe34b60$export$2e2bcd8739ae039);

const $e7e8dd084d943877$var$SummaryDashboard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).lazy(()=>(parcelRequire("bi4ZQ")).then((m)=>({
            default: m.SummaryDashboard
        })));

const $e7e8dd084d943877$var$GettingStartedGuide = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).lazy(()=>(parcelRequire("a0I4U")).then((m)=>({
            default: m.GettingStartedGuide
        })));

const $e7e8dd084d943877$var$PlanView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).lazy(()=>(parcelRequire("lvEPJ")).then((m)=>({
            default: m.PlanView
        })));

const $e7e8dd084d943877$var$RepoView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).lazy(()=>(parcelRequire("4yOAB")).then((m)=>({
            default: m.RepoView
        })));
const $e7e8dd084d943877$var$RepoViewContainer = ()=>{
    const { repoId: repoId } = (0, $ebiy2.useParams)();
    const [config, setConfig] = (0, $1VQWV.useConfig)();
    if (!config) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Estt.default), {});
    const repo = config.repos.find((r)=>r.id === repoId);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3cfb31961d3bcc4a$export$5d7600abb6392766), {
        breadcrumbs: [
            {
                title: "Repo"
            },
            {
                title: repoId
            }
        ],
        children: repo ? /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$RepoView, {
            repo: repo
        }) : /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $k643f.default), {
            description: `Repo ${repoId} not found`
        })
    }, repoId);
};
const $e7e8dd084d943877$var$PlanViewContainer = ()=>{
    const { planId: planId } = (0, $ebiy2.useParams)();
    const [config, setConfig] = (0, $1VQWV.useConfig)();
    if (!config) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Estt.default), {});
    const plan = config.plans.find((p)=>p.id === planId);
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3cfb31961d3bcc4a$export$5d7600abb6392766), {
        breadcrumbs: [
            {
                title: "Plan"
            },
            {
                title: planId
            }
        ],
        children: plan ? /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$PlanView, {
            plan: plan
        }) : /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $k643f.default), {
            description: `Plan ${planId} not found`
        })
    }, planId);
};
const $e7e8dd084d943877$export$86fbec116b87613f = ()=>{
    const { token: { colorBgContainer: colorBgContainer, colorTextLightSolid: colorTextLightSolid } } = (0, $ec325b47db174b3f$export$2e2bcd8739ae039).useToken();
    const navigate = (0, $ebiy2.useNavigate)();
    const [config, setConfig] = (0, $1VQWV.useConfig)();
    const items = $e7e8dd084d943877$var$getSidenavItems(config);
    return /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $ecb9175edbe34b60$export$2e2bcd8739ae039), {
        style: {
            height: "auto",
            minHeight: "100vh"
        },
        children: [
            /*#__PURE__*/ (0, $1Ivrw.jsxs)($e7e8dd084d943877$var$Header, {
                style: {
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "60px",
                    backgroundColor: "#1b232c"
                },
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)("a", {
                        style: {
                            color: colorTextLightSolid
                        },
                        onClick: ()=>{
                            navigate("/");
                        },
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($34c8abdd10f319ed$exports))),
                            style: {
                                height: "30px",
                                color: "white",
                                marginBottom: "-8px",
                                paddingRight: "10px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsxs)("h1", {
                        children: [
                            /*#__PURE__*/ (0, $1Ivrw.jsx)("a", {
                                href: "https://github.com/garethgeorge/backrest",
                                target: "_blank",
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)("small", {
                                    style: {
                                        color: "rgba(255,255,255,0.3)",
                                        fontSize: "0.6em"
                                    },
                                    children: (0, $3xSyo.uiBuildVersion)
                                })
                            }),
                            /*#__PURE__*/ (0, $1Ivrw.jsx)("small", {
                                style: {
                                    fontSize: "0.6em",
                                    marginLeft: "30px"
                                },
                                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $6ac41049c7ab9f96$export$67549794012d4f27), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsxs)("h1", {
                        style: {
                            position: "absolute",
                            right: "20px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $1Ivrw.jsx)("small", {
                                style: {
                                    color: "rgba(255,255,255,0.3)",
                                    fontSize: "0.6em"
                                },
                                children: config && config.instance ? config.instance : undefined
                            }),
                            /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ffbQF.default), {
                                type: "text",
                                style: {
                                    marginLeft: "10px",
                                    color: "white",
                                    visibility: config?.auth?.disabled ? "hidden" : "visible"
                                },
                                onClick: ()=>{
                                    (0, $1Yxub.setAuthToken)("");
                                    window.location.reload();
                                },
                                children: "Logout"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $ecb9175edbe34b60$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$Sider, {
                        width: 300,
                        style: {
                            background: colorBgContainer
                        },
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $f6jN2.default), {
                            mode: "inline",
                            defaultSelectedKeys: [
                                "1"
                            ],
                            defaultOpenKeys: [
                                "plans",
                                "repos"
                            ],
                            style: {
                                height: "100%",
                                borderRight: 0
                            },
                            items: items
                        })
                    }),
                    /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$AuthenticationBoundary, {
                        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $aqdBs.Suspense), {
                            fallback: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Estt.default), {}),
                            children: /*#__PURE__*/ (0, $1Ivrw.jsxs)((0, $ebiy2.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ebiy2.Route), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3cfb31961d3bcc4a$export$5d7600abb6392766), {
                                            breadcrumbs: [
                                                {
                                                    title: "Summary"
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$SummaryDashboard, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ebiy2.Route), {
                                        path: "/getting-started",
                                        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3cfb31961d3bcc4a$export$5d7600abb6392766), {
                                            breadcrumbs: [
                                                {
                                                    title: "Getting Started"
                                                }
                                            ],
                                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$GettingStartedGuide, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ebiy2.Route), {
                                        path: "/plan/:planId",
                                        element: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$PlanViewContainer, {})
                                    }),
                                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ebiy2.Route), {
                                        path: "/repo/:repoId",
                                        element: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$RepoViewContainer, {})
                                    }),
                                    /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ebiy2.Route), {
                                        path: "/*",
                                        element: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3cfb31961d3bcc4a$export$5d7600abb6392766), {
                                            breadcrumbs: [],
                                            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $k643f.default), {
                                                description: "Page not found"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};

const $e7e8dd084d943877$var$AuthenticationBoundary = ({ children: children })=>{
    const [config, setConfig] = (0, $1VQWV.useConfig)();
    const alertApi = (0, $3JMMO.useAlertApi)();
    const showModal = (0, $dkYnv.useShowModal)();
    (0, $aqdBs.useEffect)(()=>{
        (0, $1Yxub.backrestService).getConfig({}).then((config)=>{
            setConfig(config);
            if ((0, $11c18db41d7a26e7$export$8eab9ef84668a092)(config)) (parcelRequire("dy9LN")).then(({ SettingsModal: SettingsModal })=>{
                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(SettingsModal, {}));
            });
            else showModal(null);
        }).catch((err)=>{
            const code = err.code;
            if (err.code === (0, $lBjkW.Code).Unauthenticated) {
                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $a311867e06ee0ace$export$b4d7a44be6f5e733), {}));
                return;
            } else if (err.code !== (0, $lBjkW.Code).Unavailable && err.code !== (0, $lBjkW.Code).DeadlineExceeded) {
                alertApi.error(err.message, 0);
                return;
            }
            alertApi.error("Failed to fetch initial config, typically this means the UI could not connect to the backend", 0);
        });
    }, []);
    if (!config) return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {});
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1Ivrw.Fragment), {
        children: children
    });
};





const $e7e8dd084d943877$var$getSidenavItems = (config)=>{
    const showModal = (0, $dkYnv.useShowModal)();
    const navigate = (0, $ebiy2.useNavigate)();
    if (!config) return;
    const reposById = (0, (/*@__PURE__*/$parcel$interopDefault($aMH3h))).keyBy(config.repos, (r)=>r.id);
    const configPlans = config.plans || [];
    const configRepos = config.repos || [];
    const plans = [
        {
            key: "add-plan",
            icon: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $71P5e.default), {}),
            label: "Add Plan",
            onClick: async ()=>{
                const { AddPlanModal: AddPlanModal } = await (parcelRequire("cK2Pb"));
                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(AddPlanModal, {
                    template: null
                }));
            }
        },
        ...configPlans.map((plan)=>{
            const sel = (0, $1jDsz.create)((0, $cT7kT.OpSelectorSchema), {
                instanceId: config.instance,
                planId: plan.id,
                repoGuid: reposById[plan.repo]?.guid
            });
            return {
                key: "p-" + plan.id,
                icon: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$IconForResource, {
                    selector: sel
                }),
                label: /*#__PURE__*/ (0, $1Ivrw.jsxs)("div", {
                    className: "backrest visible-on-hover",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    children: [
                        plan.id,
                        " ",
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ffbQF.default), {
                            className: "hidden-child float-center-right",
                            type: "text",
                            size: "small",
                            shape: "circle",
                            style: {
                                width: "30px",
                                height: "30px"
                            },
                            icon: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5506d63922cc2448$export$2e2bcd8739ae039), {}),
                            onClick: async ()=>{
                                const { AddPlanModal: AddPlanModal } = await (parcelRequire("cK2Pb"));
                                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(AddPlanModal, {
                                    template: plan
                                }));
                            }
                        })
                    ]
                }),
                onClick: async ()=>{
                    navigate(`/plan/${plan.id}`);
                }
            };
        })
    ];
    const repos = [
        {
            key: "add-repo",
            icon: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $71P5e.default), {}),
            label: "Add Repo",
            onClick: async ()=>{
                const { AddRepoModal: AddRepoModal } = await (parcelRequire("1M7IH"));
                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(AddRepoModal, {
                    template: null
                }));
            }
        },
        ...configRepos.map((repo)=>{
            return {
                key: "r-" + repo.id,
                icon: /*#__PURE__*/ (0, $1Ivrw.jsx)($e7e8dd084d943877$var$IconForResource, {
                    selector: (0, $1jDsz.create)((0, $cT7kT.OpSelectorSchema), {
                        instanceId: config.instance,
                        repoGuid: repo.guid
                    })
                }),
                label: /*#__PURE__*/ (0, $1Ivrw.jsxs)("div", {
                    className: "backrest visible-on-hover",
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    children: [
                        repo.id,
                        " ",
                        /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ffbQF.default), {
                            type: "text",
                            size: "small",
                            shape: "circle",
                            className: "hidden-child float-center-right",
                            style: {
                                width: "30px",
                                height: "30px"
                            },
                            icon: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5506d63922cc2448$export$2e2bcd8739ae039), {}),
                            onClick: async ()=>{
                                const { AddRepoModal: AddRepoModal } = await (parcelRequire("1M7IH"));
                                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(AddRepoModal, {
                                    template: repo
                                }));
                            }
                        })
                    ]
                }),
                onClick: async ()=>{
                    navigate(`/repo/${repo.id}`);
                }
            };
        })
    ];
    const authorizedClientRepos = [];
    if (config.multihost?.authorizedClients?.length) {
        const authorizedClients = config.multihost.authorizedClients;
    // Display authorized client peer statuses
    }
    return [
        {
            key: "plans",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $2d99f5b60b33edee$export$2e2bcd8739ae039)),
            label: "Plans",
            children: plans
        },
        {
            key: "repos",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $da86e2de4939fd68$export$2e2bcd8739ae039)),
            label: "Repositories",
            children: repos
        },
        {
            key: "settings",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aqdBs))).createElement((0, $5506d63922cc2448$export$2e2bcd8739ae039)),
            label: "Settings",
            onClick: async ()=>{
                const { SettingsModal: SettingsModal } = await (parcelRequire("dy9LN"));
                showModal(/*#__PURE__*/ (0, $1Ivrw.jsx)(SettingsModal, {}));
            }
        }
    ];
};
const $e7e8dd084d943877$var$IconForResource = ({ selector: selector })=>{
    const [status, setStatus] = (0, $aqdBs.useState)((0, $81vtw.OperationStatus).STATUS_UNKNOWN);
    (0, $aqdBs.useEffect)(()=>{
        if (!selector || !selector.instanceId || !selector.repoGuid) return;
        const load = async ()=>{
            setStatus(await (0, $b0VD2.getStatusForSelector)(selector));
        };
        load();
        const refresh = (0, (/*@__PURE__*/$parcel$interopDefault($aMH3h))).debounce(load, 1000, {
            maxWait: 10000,
            trailing: true
        });
        const callback = (event, err)=>{
            if (!event || !event.event) return;
            switch(event.event.case){
                case "createdOperations":
                case "updatedOperations":
                    const ops = event.event.value.operations;
                    if (ops.find((op)=>(0, $b0VD2.matchSelector)(selector, op))) refresh();
                    break;
                case "deletedOperations":
                    refresh();
                    break;
            }
        };
        (0, $c9ked.subscribeToOperations)(callback);
        return ()=>{
            (0, $c9ked.unsubscribeFromOperations)(callback);
        };
    }, [
        JSON.stringify(selector)
    ]);
    return $e7e8dd084d943877$var$iconForStatus(status);
};
const $e7e8dd084d943877$var$iconForStatus = (status)=>{
    const color = (0, $aDcZc.colorForStatus)(status);
    switch(status){
        case (0, $81vtw.OperationStatus).STATUS_ERROR:
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $gtz9i.default), {
                style: {
                    color: color
                }
            });
        case (0, $81vtw.OperationStatus).STATUS_WARNING:
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $gtz9i.default), {
                style: {
                    color: color
                }
            });
        case (0, $81vtw.OperationStatus).STATUS_INPROGRESS:
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5BZxE.default), {
                style: {
                    color: color
                }
            });
        case (0, $81vtw.OperationStatus).STATUS_UNKNOWN:
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $5BZxE.default), {
                style: {
                    color: color
                }
            });
        default:
            return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $28b3p.default), {
                style: {
                    color: color
                }
            });
    }
};



var $3JMMO = parcelRequire("3JMMO");

var $dkYnv = parcelRequire("dkYnv");


var $ky6DR = parcelRequire("ky6DR");

var $1VQWV = parcelRequire("1VQWV");

const $70fc9a727fa662ae$var$Root = ({ children: children })=>{
    return /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $1VQWV.ConfigContextProvider), {
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $3JMMO.AlertContextProvider), {
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $dkYnv.ModalContextProvider), {
                children: children
            })
        })
    });
};
const $70fc9a727fa662ae$var$darkTheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
const $70fc9a727fa662ae$var$el = document.querySelector("#app");
$70fc9a727fa662ae$var$el && (0, $c920eedc27eaef64$export$882461b6382ed46c)($70fc9a727fa662ae$var$el).render(/*#__PURE__*/ (0, $1Ivrw.jsx)((0, $ky6DR.default), {
    theme: {
        algorithm: [
            $70fc9a727fa662ae$var$darkTheme ? (0, $ec325b47db174b3f$export$2e2bcd8739ae039).darkAlgorithm : (0, $ec325b47db174b3f$export$2e2bcd8739ae039).defaultAlgorithm,
            (0, $ec325b47db174b3f$export$2e2bcd8739ae039).compactAlgorithm
        ]
    },
    children: /*#__PURE__*/ (0, $1Ivrw.jsx)($aqdBs.StrictMode, {
        children: /*#__PURE__*/ (0, $1Ivrw.jsx)($70fc9a727fa662ae$var$Root, {
            children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $092d4ddd3ad595b9$export$7221d69dcfc8e36b), {
                children: /*#__PURE__*/ (0, $1Ivrw.jsx)((0, $e7e8dd084d943877$export$86fbec116b87613f), {})
            })
        })
    })
}));


//# sourceMappingURL=webui.aea23185.js.map
